import Vue$2 from 'vue';
import crypto$1 from 'crypto';
import tty from 'tty';
import util from 'util';
import os from 'os';
import Element$1 from 'element-ui';
import axios from 'axios';

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof commonjsGlobal !== 'undefined'
    ? commonjsGlobal
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index_cjs = {
  Store: Store,
  install: install,
  version: '3.6.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

var vuex_common = index_cjs;

const {
  Store: Store$1,
  install: install$1,
  version,
  mapState: mapState$1,
  mapMutations: mapMutations$1,
  mapGetters: mapGetters$1,
  mapActions: mapActions$1,
  createNamespacedHelpers: createNamespacedHelpers$1,
  createLogger: createLogger$1
} = vuex_common;

var actions = {
  addMessage: function addMessage(_ref, msg) {
    var commit = _ref.commit;
    var message = msg.payload || msg;
    if (msg.stanza) {
      message.stanza = msg.stanza;
    }
    commit("add", message);
  },
  setResource: function setResource(_ref2, res) {
    var commit = _ref2.commit;
    commit("_setResource", res);
  },
  setMessages: function setMessages(_ref3, messages) {
    var commit = _ref3.commit;
    commit("_setAllMessages", messages);
  },
  setTimestampMap: function setTimestampMap(_ref4, args) {
    var commit = _ref4.commit;
    commit("_setTimestampMap", args);
  },
  setHistory: function setHistory(_ref5, history) {
    var commit = _ref5.commit;
    commit("_setHistory", history);
  },
  toggleUserInputArea: function toggleUserInputArea(_ref6, status) {
    var commit = _ref6.commit;
    commit("_toggleUserInputArea", status);
  },
  toggleLoginProxyView: function toggleLoginProxyView(_ref7, status) {
    var commit = _ref7.commit;
    commit("_toggleLoginProxyView", status);
  },
  addMessageToHistory: function addMessageToHistory(_ref8, message) {
    var commit = _ref8.commit;
    commit("_addToHistory", message);
  },
  prependMessageInCurrentConversation: function prependMessageInCurrentConversation(_ref9, message) {
    var commit = _ref9.commit;
    commit("_prependMessageInCurrentConversation", message);
  },
  pushMessageInCurrentConversation: function pushMessageInCurrentConversation(_ref0, message) {
    var commit = _ref0.commit;
    commit("_pushMessageInCurrentConversation", message);
  },
  pushMessageInCurrentConversationPagination: function pushMessageInCurrentConversationPagination(_ref1, message) {
    var commit = _ref1.commit;
    commit("_pushMessageInCurrentConversationPagination", message);
  },
  pushMessageInCurrentConversationSupportPagination: function pushMessageInCurrentConversationSupportPagination(_ref10, payload) {
    var commit = _ref10.commit;
    commit("_pushMessageInCurrentConversationSupportPagination", payload);
  },
  setCurrentConversationPreviousMessages: function setCurrentConversationPreviousMessages(_ref11, messages) {
    var commit = _ref11.commit;
    commit("_setCurrentConversationPreviousMessages", messages);
  },
  setCurrentConversationNextMessages: function setCurrentConversationNextMessages(_ref12, messages) {
    var commit = _ref12.commit;
    commit("_setCurrentConversationNextMessages", messages);
  },
  setCurrentConversationMessages: function setCurrentConversationMessages(_ref13, messages) {
    var commit = _ref13.commit;
    commit("_setCurrentConversationMessages", messages);
  },
  setCurrentConversationMessagesPagination: function setCurrentConversationMessagesPagination(_ref14, messages) {
    var commit = _ref14.commit;
    commit("_setCurrentConversationMessagesPagination", messages);
  },
  setCurrentConversationSupportMessagesPagination: function setCurrentConversationSupportMessagesPagination(_ref15, conversations) {
    var commit = _ref15.commit;
    commit("_setCurrentConversationSupportMessagesPagination", conversations);
  },
  setCurrentConversationPaginationMode: function setCurrentConversationPaginationMode(_ref16, mode) {
    var commit = _ref16.commit;
    commit("_setCurrentConversationPaginationMode", mode);
  },
  toggleActionsMenu: function toggleActionsMenu(_ref17, params) {
    var commit = _ref17.commit;
    commit("_toggleActionsMenu", params);
  },
  setBackButtonLabel: function setBackButtonLabel(_ref18, label) {
    var commit = _ref18.commit;
    commit("_setBackButtonLabel", label);
  },
  setConversationsTitle: function setConversationsTitle(_ref19, title) {
    var commit = _ref19.commit;
    commit("_setConversationsTitle", title);
  },
  setConversationsArray: function setConversationsArray(_ref20, conversations) {
    var commit = _ref20.commit;
    commit("_setConversations", conversations);
  },
  updateConversation: function updateConversation(_ref21, args) {
    var commit = _ref21.commit;
    commit("_updateConversation", args);
  },
  updateConversationClass: function updateConversationClass(_ref22, args) {
    var commit = _ref22.commit;
    commit("_updateConversationClass", args);
  },
  pushConversation: function pushConversation(_ref23, conversation) {
    var commit = _ref23.commit;
    commit("_pushConversation", conversation);
  },
  popConversation: function popConversation(_ref24, conversation) {
    var commit = _ref24.commit;
    commit("_popConversation", conversation);
  },
  setConversationsCounter: function setConversationsCounter(_ref25, conversationsCounter) {
    var commit = _ref25.commit;
    commit("_setConversationsCounter", conversationsCounter);
  },
  setCurrentChat: function setCurrentChat(_ref26, chat) {
    var commit = _ref26.commit;
    commit("_setCurrentChat", chat);
  },
  setChatHeaderTitle: function setChatHeaderTitle(_ref27, title) {
    var commit = _ref27.commit;
    commit("_setChatHeaderTitle", title);
  },
  setChatHeaderIcon: function setChatHeaderIcon(_ref28, resource) {
    var commit = _ref28.commit;
    commit("_setChatHeaderIcon", resource);
  },
  setIsConversationHeaderRawHtml: function setIsConversationHeaderRawHtml(_ref29, toggle) {
    var commit = _ref29.commit;
    commit("_setIsConversationHeaderRawHtml", toggle);
  },
  setChatAvatarIcon: function setChatAvatarIcon(_ref30, resource) {
    var commit = _ref30.commit;
    commit("_setChatAvatarIcon", resource);
  },
  setLoggedInStatus: function setLoggedInStatus(_ref31, status) {
    var commit = _ref31.commit;
    commit("loggedIn", status);
  },
  setAttachmentsUploaderConfig: function setAttachmentsUploaderConfig(_ref32, config) {
    var commit = _ref32.commit;
    commit("_setAttachmentsUploaderConfig", config);
  },
  setToggleMetas: function setToggleMetas(_ref33, conf) {
    var commit = _ref33.commit;
    commit("_setToggleMetas", conf);
  },
  setIsInteractionInsertLocation: function setIsInteractionInsertLocation(_ref34, toggle) {
    var commit = _ref34.commit;
    commit("_setIsInteractionInsertLocation", toggle);
  },
  setIsLocationModalEnable: function setIsLocationModalEnable(_ref35, toggle) {
    var commit = _ref35.commit;
    commit("_setIsLocationModalEnable", toggle);
  },
  setIsInteractionInsertDate: function setIsInteractionInsertDate(_ref36, toggle) {
    var commit = _ref36.commit;
    commit("_setIsInteractionInsertDate", toggle);
  },
  setCurrentDatePickerInfo: function setCurrentDatePickerInfo(_ref37, payload) {
    var commit = _ref37.commit;
    commit("_setCurrentDatePickerInfo", payload);
  },
  setIsInteractionSingleAutocomplete: function setIsInteractionSingleAutocomplete(_ref38, toggle) {
    var commit = _ref38.commit;
    commit("_setIsInteractionSingleAutocomplete", toggle);
  },
  setIsInteractionMultipleAutocomplete: function setIsInteractionMultipleAutocomplete(_ref39, toggle) {
    var commit = _ref39.commit;
    commit("_setIsInteractionMultipleAutocomplete", toggle);
  },
  setCurrentAutocompleteInfo: function setCurrentAutocompleteInfo(_ref40, payload) {
    var commit = _ref40.commit;
    commit("_setCurrentAutocompleteInfo", payload);
  },
  setCurrentAutocompleteList: function setCurrentAutocompleteList(_ref41, payload) {
    var commit = _ref41.commit;
    commit("_setCurrentAutocompleteList", payload);
  },
  setShowRestartChatButton: function setShowRestartChatButton(_ref42, toggle) {
    var commit = _ref42.commit;
    commit("_setShowRestartChatButton", toggle);
  },
  setModeBeforeSubmit: function setModeBeforeSubmit(_ref43, payload) {
    var commit = _ref43.commit;
    var modeBeforeSubmit = payload || "";
    commit("_setModeBeforeSubmit", modeBeforeSubmit);
  },
  setVisibilityAfterSubmit: function setVisibilityAfterSubmit(_ref44, payload) {
    var commit = _ref44.commit;
    var visibilityAfterSubmit = payload || "";
    commit("_setVisibilityAfterSubmit", visibilityAfterSubmit);
  },
  setBotConfigSettings: function setBotConfigSettings(_ref45, payload) {
    var commit = _ref45.commit;
    var botConfigSettings = payload || {};
    commit("_setBotConfigSettings", botConfigSettings);
  }
};

var dist = createCommonjsModule(function (module, exports) {
/*! For license information please see index.js.LICENSE.txt */
!function(t,e){module.exports=e(function(){try{return crypto$1}catch(t){}}());}(self,(function(t){return (()=>{var e={452:function(t,e,r){var i;t.exports=(i=r(249),r(269),r(214),r(888),r(109),function(){var t=i,e=t.lib.BlockCipher,r=t.algo,n=[],o=[],s=[],c=[],a=[],h=[],f=[],l=[],u=[],d=[];!function(){for(var t=[],e=0;e<256;e++)t[e]=e<128?e<<1:e<<1^283;var r=0,i=0;for(e=0;e<256;e++){var p=i^i<<1^i<<2^i<<3^i<<4;p=p>>>8^255&p^99,n[r]=p,o[p]=r;var v=t[r],_=t[v],y=t[_],g=257*t[p]^16843008*p;s[r]=g<<24|g>>>8,c[r]=g<<16|g>>>16,a[r]=g<<8|g>>>24,h[r]=g,g=16843009*y^65537*_^257*v^16843008*r,f[p]=g<<24|g>>>8,l[p]=g<<16|g>>>16,u[p]=g<<8|g>>>24,d[p]=g,r?(r=v^t[t[t[y^v]]],i^=t[t[i]]):r=i=1;}}();var p=[0,1,2,4,8,16,32,64,128,27,54],v=r.AES=e.extend({_doReset:function(){if(!this._nRounds||this._keyPriorReset!==this._key){for(var t=this._keyPriorReset=this._key,e=t.words,r=t.sigBytes/4,i=4*((this._nRounds=r+6)+1),o=this._keySchedule=[],s=0;s<i;s++)s<r?o[s]=e[s]:(h=o[s-1],s%r?r>6&&s%r==4&&(h=n[h>>>24]<<24|n[h>>>16&255]<<16|n[h>>>8&255]<<8|n[255&h]):(h=n[(h=h<<8|h>>>24)>>>24]<<24|n[h>>>16&255]<<16|n[h>>>8&255]<<8|n[255&h],h^=p[s/r|0]<<24),o[s]=o[s-r]^h);for(var c=this._invKeySchedule=[],a=0;a<i;a++){if(s=i-a,a%4)var h=o[s];else h=o[s-4];c[a]=a<4||s<=4?h:f[n[h>>>24]]^l[n[h>>>16&255]]^u[n[h>>>8&255]]^d[n[255&h]];}}},encryptBlock:function(t,e){this._doCryptBlock(t,e,this._keySchedule,s,c,a,h,n);},decryptBlock:function(t,e){var r=t[e+1];t[e+1]=t[e+3],t[e+3]=r,this._doCryptBlock(t,e,this._invKeySchedule,f,l,u,d,o),r=t[e+1],t[e+1]=t[e+3],t[e+3]=r;},_doCryptBlock:function(t,e,r,i,n,o,s,c){for(var a=this._nRounds,h=t[e]^r[0],f=t[e+1]^r[1],l=t[e+2]^r[2],u=t[e+3]^r[3],d=4,p=1;p<a;p++){var v=i[h>>>24]^n[f>>>16&255]^o[l>>>8&255]^s[255&u]^r[d++],_=i[f>>>24]^n[l>>>16&255]^o[u>>>8&255]^s[255&h]^r[d++],y=i[l>>>24]^n[u>>>16&255]^o[h>>>8&255]^s[255&f]^r[d++],g=i[u>>>24]^n[h>>>16&255]^o[f>>>8&255]^s[255&l]^r[d++];h=v,f=_,l=y,u=g;}v=(c[h>>>24]<<24|c[f>>>16&255]<<16|c[l>>>8&255]<<8|c[255&u])^r[d++],_=(c[f>>>24]<<24|c[l>>>16&255]<<16|c[u>>>8&255]<<8|c[255&h])^r[d++],y=(c[l>>>24]<<24|c[u>>>16&255]<<16|c[h>>>8&255]<<8|c[255&f])^r[d++],g=(c[u>>>24]<<24|c[h>>>16&255]<<16|c[f>>>8&255]<<8|c[255&l])^r[d++],t[e]=v,t[e+1]=_,t[e+2]=y,t[e+3]=g;},keySize:8});t.AES=e._createHelper(v);}(),i.AES);},109:function(t,e,r){var i,n,o,s,c,a,h,f,l,u,d,p,v,_,y,g,B,w,k;t.exports=(i=r(249),r(888),void(i.lib.Cipher||(n=i,o=n.lib,s=o.Base,c=o.WordArray,a=o.BufferedBlockAlgorithm,h=n.enc,h.Utf8,f=h.Base64,l=n.algo.EvpKDF,u=o.Cipher=a.extend({cfg:s.extend(),createEncryptor:function(t,e){return this.create(this._ENC_XFORM_MODE,t,e)},createDecryptor:function(t,e){return this.create(this._DEC_XFORM_MODE,t,e)},init:function(t,e,r){this.cfg=this.cfg.extend(r),this._xformMode=t,this._key=e,this.reset();},reset:function(){a.reset.call(this),this._doReset();},process:function(t){return this._append(t),this._process()},finalize:function(t){return t&&this._append(t),this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(){function t(t){return "string"==typeof t?k:B}return function(e){return {encrypt:function(r,i,n){return t(i).encrypt(e,r,i,n)},decrypt:function(r,i,n){return t(i).decrypt(e,r,i,n)}}}}()}),o.StreamCipher=u.extend({_doFinalize:function(){return this._process(!0)},blockSize:1}),d=n.mode={},p=o.BlockCipherMode=s.extend({createEncryptor:function(t,e){return this.Encryptor.create(t,e)},createDecryptor:function(t,e){return this.Decryptor.create(t,e)},init:function(t,e){this._cipher=t,this._iv=e;}}),v=d.CBC=function(){var t=p.extend();function e(t,e,r){var i,n=this._iv;n?(i=n,this._iv=void 0):i=this._prevBlock;for(var o=0;o<r;o++)t[e+o]^=i[o];}return t.Encryptor=t.extend({processBlock:function(t,r){var i=this._cipher,n=i.blockSize;e.call(this,t,r,n),i.encryptBlock(t,r),this._prevBlock=t.slice(r,r+n);}}),t.Decryptor=t.extend({processBlock:function(t,r){var i=this._cipher,n=i.blockSize,o=t.slice(r,r+n);i.decryptBlock(t,r),e.call(this,t,r,n),this._prevBlock=o;}}),t}(),_=(n.pad={}).Pkcs7={pad:function(t,e){for(var r=4*e,i=r-t.sigBytes%r,n=i<<24|i<<16|i<<8|i,o=[],s=0;s<i;s+=4)o.push(n);var a=c.create(o,i);t.concat(a);},unpad:function(t){var e=255&t.words[t.sigBytes-1>>>2];t.sigBytes-=e;}},o.BlockCipher=u.extend({cfg:u.cfg.extend({mode:v,padding:_}),reset:function(){var t;u.reset.call(this);var e=this.cfg,r=e.iv,i=e.mode;this._xformMode==this._ENC_XFORM_MODE?t=i.createEncryptor:(t=i.createDecryptor,this._minBufferSize=1),this._mode&&this._mode.__creator==t?this._mode.init(this,r&&r.words):(this._mode=t.call(i,this,r&&r.words),this._mode.__creator=t);},_doProcessBlock:function(t,e){this._mode.processBlock(t,e);},_doFinalize:function(){var t,e=this.cfg.padding;return this._xformMode==this._ENC_XFORM_MODE?(e.pad(this._data,this.blockSize),t=this._process(!0)):(t=this._process(!0),e.unpad(t)),t},blockSize:4}),y=o.CipherParams=s.extend({init:function(t){this.mixIn(t);},toString:function(t){return (t||this.formatter).stringify(this)}}),g=(n.format={}).OpenSSL={stringify:function(t){var e=t.ciphertext,r=t.salt;return (r?c.create([1398893684,1701076831]).concat(r).concat(e):e).toString(f)},parse:function(t){var e,r=f.parse(t),i=r.words;return 1398893684==i[0]&&1701076831==i[1]&&(e=c.create(i.slice(2,4)),i.splice(0,4),r.sigBytes-=16),y.create({ciphertext:r,salt:e})}},B=o.SerializableCipher=s.extend({cfg:s.extend({format:g}),encrypt:function(t,e,r,i){i=this.cfg.extend(i);var n=t.createEncryptor(r,i),o=n.finalize(e),s=n.cfg;return y.create({ciphertext:o,key:r,iv:s.iv,algorithm:t,mode:s.mode,padding:s.padding,blockSize:t.blockSize,formatter:i.format})},decrypt:function(t,e,r,i){return i=this.cfg.extend(i),e=this._parse(e,i.format),t.createDecryptor(r,i).finalize(e.ciphertext)},_parse:function(t,e){return "string"==typeof t?e.parse(t,this):t}}),w=(n.kdf={}).OpenSSL={execute:function(t,e,r,i){i||(i=c.random(8));var n=l.create({keySize:e+r}).compute(t,i),o=c.create(n.words.slice(e),4*r);return n.sigBytes=4*e,y.create({key:n,iv:o,salt:i})}},k=o.PasswordBasedCipher=B.extend({cfg:B.cfg.extend({kdf:w}),encrypt:function(t,e,r,i){var n=(i=this.cfg.extend(i)).kdf.execute(r,t.keySize,t.ivSize);i.iv=n.iv;var o=B.encrypt.call(this,t,e,n.key,i);return o.mixIn(n),o},decrypt:function(t,e,r,i){i=this.cfg.extend(i),e=this._parse(e,i.format);var n=i.kdf.execute(r,t.keySize,t.ivSize,e.salt);return i.iv=n.iv,B.decrypt.call(this,t,e,n.key,i)}}))));},249:function(t,e,r){var i;t.exports=i=i||function(t,e){var i;if("undefined"!=typeof window&&window.crypto&&(i=window.crypto),!i&&"undefined"!=typeof window&&window.msCrypto&&(i=window.msCrypto),!i&&void 0!==r.g&&r.g.crypto&&(i=r.g.crypto),!i)try{i=r(417);}catch(t){}var n=function(){if(i){if("function"==typeof i.getRandomValues)try{return i.getRandomValues(new Uint32Array(1))[0]}catch(t){}if("function"==typeof i.randomBytes)try{return i.randomBytes(4).readInt32LE()}catch(t){}}throw new Error("Native crypto module could not be used to get secure random number.")},o=Object.create||function(){function t(){}return function(e){var r;return t.prototype=e,r=new t,t.prototype=null,r}}(),s={},c=s.lib={},a=c.Base={extend:function(t){var e=o(this);return t&&e.mixIn(t),e.hasOwnProperty("init")&&this.init!==e.init||(e.init=function(){e.$super.init.apply(this,arguments);}),e.init.prototype=e,e.$super=this,e},create:function(){var t=this.extend();return t.init.apply(t,arguments),t},init:function(){},mixIn:function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e]);t.hasOwnProperty("toString")&&(this.toString=t.toString);},clone:function(){return this.init.prototype.extend(this)}},h=c.WordArray=a.extend({init:function(t,e){t=this.words=t||[],this.sigBytes=null!=e?e:4*t.length;},toString:function(t){return (t||l).stringify(this)},concat:function(t){var e=this.words,r=t.words,i=this.sigBytes,n=t.sigBytes;if(this.clamp(),i%4)for(var o=0;o<n;o++){var s=r[o>>>2]>>>24-o%4*8&255;e[i+o>>>2]|=s<<24-(i+o)%4*8;}else for(o=0;o<n;o+=4)e[i+o>>>2]=r[o>>>2];return this.sigBytes+=n,this},clamp:function(){var e=this.words,r=this.sigBytes;e[r>>>2]&=4294967295<<32-r%4*8,e.length=t.ceil(r/4);},clone:function(){var t=a.clone.call(this);return t.words=this.words.slice(0),t},random:function(t){for(var e=[],r=0;r<t;r+=4)e.push(n());return new h.init(e,t)}}),f=s.enc={},l=f.Hex={stringify:function(t){for(var e=t.words,r=t.sigBytes,i=[],n=0;n<r;n++){var o=e[n>>>2]>>>24-n%4*8&255;i.push((o>>>4).toString(16)),i.push((15&o).toString(16));}return i.join("")},parse:function(t){for(var e=t.length,r=[],i=0;i<e;i+=2)r[i>>>3]|=parseInt(t.substr(i,2),16)<<24-i%8*4;return new h.init(r,e/2)}},u=f.Latin1={stringify:function(t){for(var e=t.words,r=t.sigBytes,i=[],n=0;n<r;n++){var o=e[n>>>2]>>>24-n%4*8&255;i.push(String.fromCharCode(o));}return i.join("")},parse:function(t){for(var e=t.length,r=[],i=0;i<e;i++)r[i>>>2]|=(255&t.charCodeAt(i))<<24-i%4*8;return new h.init(r,e)}},d=f.Utf8={stringify:function(t){try{return decodeURIComponent(escape(u.stringify(t)))}catch(t){throw new Error("Malformed UTF-8 data")}},parse:function(t){return u.parse(unescape(encodeURIComponent(t)))}},p=c.BufferedBlockAlgorithm=a.extend({reset:function(){this._data=new h.init,this._nDataBytes=0;},_append:function(t){"string"==typeof t&&(t=d.parse(t)),this._data.concat(t),this._nDataBytes+=t.sigBytes;},_process:function(e){var r,i=this._data,n=i.words,o=i.sigBytes,s=this.blockSize,c=o/(4*s),a=(c=e?t.ceil(c):t.max((0|c)-this._minBufferSize,0))*s,f=t.min(4*a,o);if(a){for(var l=0;l<a;l+=s)this._doProcessBlock(n,l);r=n.splice(0,a),i.sigBytes-=f;}return new h.init(r,f)},clone:function(){var t=a.clone.call(this);return t._data=this._data.clone(),t},_minBufferSize:0}),v=(c.Hasher=p.extend({cfg:a.extend(),init:function(t){this.cfg=this.cfg.extend(t),this.reset();},reset:function(){p.reset.call(this),this._doReset();},update:function(t){return this._append(t),this._process(),this},finalize:function(t){return t&&this._append(t),this._doFinalize()},blockSize:16,_createHelper:function(t){return function(e,r){return new t.init(r).finalize(e)}},_createHmacHelper:function(t){return function(e,r){return new v.HMAC.init(t,r).finalize(e)}}}),s.algo={});return s}(Math);},269:function(t,e,r){var i,n,o;t.exports=(i=r(249),o=(n=i).lib.WordArray,n.enc.Base64={stringify:function(t){var e=t.words,r=t.sigBytes,i=this._map;t.clamp();for(var n=[],o=0;o<r;o+=3)for(var s=(e[o>>>2]>>>24-o%4*8&255)<<16|(e[o+1>>>2]>>>24-(o+1)%4*8&255)<<8|e[o+2>>>2]>>>24-(o+2)%4*8&255,c=0;c<4&&o+.75*c<r;c++)n.push(i.charAt(s>>>6*(3-c)&63));var a=i.charAt(64);if(a)for(;n.length%4;)n.push(a);return n.join("")},parse:function(t){var e=t.length,r=this._map,i=this._reverseMap;if(!i){i=this._reverseMap=[];for(var n=0;n<r.length;n++)i[r.charCodeAt(n)]=n;}var s=r.charAt(64);if(s){var c=t.indexOf(s);-1!==c&&(e=c);}return function(t,e,r){for(var i=[],n=0,s=0;s<e;s++)if(s%4){var c=r[t.charCodeAt(s-1)]<<s%4*2|r[t.charCodeAt(s)]>>>6-s%4*2;i[n>>>2]|=c<<24-n%4*8,n++;}return o.create(i,n)}(t,e,i)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="},i.enc.Base64);},298:function(t,e,r){var i;t.exports=(i=r(249),function(){var t=i,e=t.lib.WordArray,r=t.enc;function n(t){return t<<8&4278255360|t>>>8&16711935}r.Utf16=r.Utf16BE={stringify:function(t){for(var e=t.words,r=t.sigBytes,i=[],n=0;n<r;n+=2){var o=e[n>>>2]>>>16-n%4*8&65535;i.push(String.fromCharCode(o));}return i.join("")},parse:function(t){for(var r=t.length,i=[],n=0;n<r;n++)i[n>>>1]|=t.charCodeAt(n)<<16-n%2*16;return e.create(i,2*r)}},r.Utf16LE={stringify:function(t){for(var e=t.words,r=t.sigBytes,i=[],o=0;o<r;o+=2){var s=n(e[o>>>2]>>>16-o%4*8&65535);i.push(String.fromCharCode(s));}return i.join("")},parse:function(t){for(var r=t.length,i=[],o=0;o<r;o++)i[o>>>1]|=n(t.charCodeAt(o)<<16-o%2*16);return e.create(i,2*r)}};}(),i.enc.Utf16);},888:function(t,e,r){var i,n,o,s,c,a,h,f;t.exports=(f=r(249),r(783),r(824),o=(n=(i=f).lib).Base,s=n.WordArray,a=(c=i.algo).MD5,h=c.EvpKDF=o.extend({cfg:o.extend({keySize:4,hasher:a,iterations:1}),init:function(t){this.cfg=this.cfg.extend(t);},compute:function(t,e){for(var r,i=this.cfg,n=i.hasher.create(),o=s.create(),c=o.words,a=i.keySize,h=i.iterations;c.length<a;){r&&n.update(r),r=n.update(t).finalize(e),n.reset();for(var f=1;f<h;f++)r=n.finalize(r),n.reset();o.concat(r);}return o.sigBytes=4*a,o}}),i.EvpKDF=function(t,e,r){return h.create(r).compute(t,e)},f.EvpKDF);},209:function(t,e,r){var i,n,o,s;t.exports=(s=r(249),r(109),n=(i=s).lib.CipherParams,o=i.enc.Hex,i.format.Hex={stringify:function(t){return t.ciphertext.toString(o)},parse:function(t){var e=o.parse(t);return n.create({ciphertext:e})}},s.format.Hex);},824:function(t,e,r){var i,n,o;t.exports=(n=(i=r(249)).lib.Base,o=i.enc.Utf8,void(i.algo.HMAC=n.extend({init:function(t,e){t=this._hasher=new t.init,"string"==typeof e&&(e=o.parse(e));var r=t.blockSize,i=4*r;e.sigBytes>i&&(e=t.finalize(e)),e.clamp();for(var n=this._oKey=e.clone(),s=this._iKey=e.clone(),c=n.words,a=s.words,h=0;h<r;h++)c[h]^=1549556828,a[h]^=909522486;n.sigBytes=s.sigBytes=i,this.reset();},reset:function(){var t=this._hasher;t.reset(),t.update(this._iKey);},update:function(t){return this._hasher.update(t),this},finalize:function(t){var e=this._hasher,r=e.finalize(t);return e.reset(),e.finalize(this._oKey.clone().concat(r))}})));},354:function(t,e,r){var i;t.exports=(i=r(249),r(938),r(433),r(298),r(269),r(214),r(783),r(153),r(792),r(34),r(460),r(327),r(706),r(824),r(112),r(888),r(109),r(568),r(242),r(968),r(660),r(148),r(615),r(807),r(77),r(475),r(991),r(209),r(452),r(253),r(857),r(454),r(974),i);},433:function(t,e,r){var i;t.exports=(i=r(249),function(){if("function"==typeof ArrayBuffer){var t=i.lib.WordArray,e=t.init;(t.init=function(t){if(t instanceof ArrayBuffer&&(t=new Uint8Array(t)),(t instanceof Int8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array)&&(t=new Uint8Array(t.buffer,t.byteOffset,t.byteLength)),t instanceof Uint8Array){for(var r=t.byteLength,i=[],n=0;n<r;n++)i[n>>>2]|=t[n]<<24-n%4*8;e.call(this,i,r);}else e.apply(this,arguments);}).prototype=t;}}(),i.lib.WordArray);},214:function(t,e,r){var i;t.exports=(i=r(249),function(t){var e=i,r=e.lib,n=r.WordArray,o=r.Hasher,s=e.algo,c=[];!function(){for(var e=0;e<64;e++)c[e]=4294967296*t.abs(t.sin(e+1))|0;}();var a=s.MD5=o.extend({_doReset:function(){this._hash=new n.init([1732584193,4023233417,2562383102,271733878]);},_doProcessBlock:function(t,e){for(var r=0;r<16;r++){var i=e+r,n=t[i];t[i]=16711935&(n<<8|n>>>24)|4278255360&(n<<24|n>>>8);}var o=this._hash.words,s=t[e+0],a=t[e+1],d=t[e+2],p=t[e+3],v=t[e+4],_=t[e+5],y=t[e+6],g=t[e+7],B=t[e+8],w=t[e+9],k=t[e+10],x=t[e+11],S=t[e+12],m=t[e+13],b=t[e+14],A=t[e+15],H=o[0],z=o[1],C=o[2],E=o[3];H=h(H,z,C,E,s,7,c[0]),E=h(E,H,z,C,a,12,c[1]),C=h(C,E,H,z,d,17,c[2]),z=h(z,C,E,H,p,22,c[3]),H=h(H,z,C,E,v,7,c[4]),E=h(E,H,z,C,_,12,c[5]),C=h(C,E,H,z,y,17,c[6]),z=h(z,C,E,H,g,22,c[7]),H=h(H,z,C,E,B,7,c[8]),E=h(E,H,z,C,w,12,c[9]),C=h(C,E,H,z,k,17,c[10]),z=h(z,C,E,H,x,22,c[11]),H=h(H,z,C,E,S,7,c[12]),E=h(E,H,z,C,m,12,c[13]),C=h(C,E,H,z,b,17,c[14]),H=f(H,z=h(z,C,E,H,A,22,c[15]),C,E,a,5,c[16]),E=f(E,H,z,C,y,9,c[17]),C=f(C,E,H,z,x,14,c[18]),z=f(z,C,E,H,s,20,c[19]),H=f(H,z,C,E,_,5,c[20]),E=f(E,H,z,C,k,9,c[21]),C=f(C,E,H,z,A,14,c[22]),z=f(z,C,E,H,v,20,c[23]),H=f(H,z,C,E,w,5,c[24]),E=f(E,H,z,C,b,9,c[25]),C=f(C,E,H,z,p,14,c[26]),z=f(z,C,E,H,B,20,c[27]),H=f(H,z,C,E,m,5,c[28]),E=f(E,H,z,C,d,9,c[29]),C=f(C,E,H,z,g,14,c[30]),H=l(H,z=f(z,C,E,H,S,20,c[31]),C,E,_,4,c[32]),E=l(E,H,z,C,B,11,c[33]),C=l(C,E,H,z,x,16,c[34]),z=l(z,C,E,H,b,23,c[35]),H=l(H,z,C,E,a,4,c[36]),E=l(E,H,z,C,v,11,c[37]),C=l(C,E,H,z,g,16,c[38]),z=l(z,C,E,H,k,23,c[39]),H=l(H,z,C,E,m,4,c[40]),E=l(E,H,z,C,s,11,c[41]),C=l(C,E,H,z,p,16,c[42]),z=l(z,C,E,H,y,23,c[43]),H=l(H,z,C,E,w,4,c[44]),E=l(E,H,z,C,S,11,c[45]),C=l(C,E,H,z,A,16,c[46]),H=u(H,z=l(z,C,E,H,d,23,c[47]),C,E,s,6,c[48]),E=u(E,H,z,C,g,10,c[49]),C=u(C,E,H,z,b,15,c[50]),z=u(z,C,E,H,_,21,c[51]),H=u(H,z,C,E,S,6,c[52]),E=u(E,H,z,C,p,10,c[53]),C=u(C,E,H,z,k,15,c[54]),z=u(z,C,E,H,a,21,c[55]),H=u(H,z,C,E,B,6,c[56]),E=u(E,H,z,C,A,10,c[57]),C=u(C,E,H,z,y,15,c[58]),z=u(z,C,E,H,m,21,c[59]),H=u(H,z,C,E,v,6,c[60]),E=u(E,H,z,C,x,10,c[61]),C=u(C,E,H,z,d,15,c[62]),z=u(z,C,E,H,w,21,c[63]),o[0]=o[0]+H|0,o[1]=o[1]+z|0,o[2]=o[2]+C|0,o[3]=o[3]+E|0;},_doFinalize:function(){var e=this._data,r=e.words,i=8*this._nDataBytes,n=8*e.sigBytes;r[n>>>5]|=128<<24-n%32;var o=t.floor(i/4294967296),s=i;r[15+(n+64>>>9<<4)]=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),r[14+(n+64>>>9<<4)]=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),e.sigBytes=4*(r.length+1),this._process();for(var c=this._hash,a=c.words,h=0;h<4;h++){var f=a[h];a[h]=16711935&(f<<8|f>>>24)|4278255360&(f<<24|f>>>8);}return c},clone:function(){var t=o.clone.call(this);return t._hash=this._hash.clone(),t}});function h(t,e,r,i,n,o,s){var c=t+(e&r|~e&i)+n+s;return (c<<o|c>>>32-o)+e}function f(t,e,r,i,n,o,s){var c=t+(e&i|r&~i)+n+s;return (c<<o|c>>>32-o)+e}function l(t,e,r,i,n,o,s){var c=t+(e^r^i)+n+s;return (c<<o|c>>>32-o)+e}function u(t,e,r,i,n,o,s){var c=t+(r^(e|~i))+n+s;return (c<<o|c>>>32-o)+e}e.MD5=o._createHelper(a),e.HmacMD5=o._createHmacHelper(a);}(Math),i.MD5);},568:function(t,e,r){var i;t.exports=(i=r(249),r(109),i.mode.CFB=function(){var t=i.lib.BlockCipherMode.extend();function e(t,e,r,i){var n,o=this._iv;o?(n=o.slice(0),this._iv=void 0):n=this._prevBlock,i.encryptBlock(n,0);for(var s=0;s<r;s++)t[e+s]^=n[s];}return t.Encryptor=t.extend({processBlock:function(t,r){var i=this._cipher,n=i.blockSize;e.call(this,t,r,n,i),this._prevBlock=t.slice(r,r+n);}}),t.Decryptor=t.extend({processBlock:function(t,r){var i=this._cipher,n=i.blockSize,o=t.slice(r,r+n);e.call(this,t,r,n,i),this._prevBlock=o;}}),t}(),i.mode.CFB);},968:function(t,e,r){var i;t.exports=(i=r(249),r(109),i.mode.CTRGladman=function(){var t=i.lib.BlockCipherMode.extend();function e(t){if(255==(t>>24&255)){var e=t>>16&255,r=t>>8&255,i=255&t;255===e?(e=0,255===r?(r=0,255===i?i=0:++i):++r):++e,t=0,t+=e<<16,t+=r<<8,t+=i;}else t+=1<<24;return t}var r=t.Encryptor=t.extend({processBlock:function(t,r){var i=this._cipher,n=i.blockSize,o=this._iv,s=this._counter;o&&(s=this._counter=o.slice(0),this._iv=void 0),function(t){0===(t[0]=e(t[0]))&&(t[1]=e(t[1]));}(s);var c=s.slice(0);i.encryptBlock(c,0);for(var a=0;a<n;a++)t[r+a]^=c[a];}});return t.Decryptor=r,t}(),i.mode.CTRGladman);},242:function(t,e,r){var i,n,o;t.exports=(o=r(249),r(109),o.mode.CTR=(n=(i=o.lib.BlockCipherMode.extend()).Encryptor=i.extend({processBlock:function(t,e){var r=this._cipher,i=r.blockSize,n=this._iv,o=this._counter;n&&(o=this._counter=n.slice(0),this._iv=void 0);var s=o.slice(0);r.encryptBlock(s,0),o[i-1]=o[i-1]+1|0;for(var c=0;c<i;c++)t[e+c]^=s[c];}}),i.Decryptor=n,i),o.mode.CTR);},148:function(t,e,r){var i,n;t.exports=(n=r(249),r(109),n.mode.ECB=((i=n.lib.BlockCipherMode.extend()).Encryptor=i.extend({processBlock:function(t,e){this._cipher.encryptBlock(t,e);}}),i.Decryptor=i.extend({processBlock:function(t,e){this._cipher.decryptBlock(t,e);}}),i),n.mode.ECB);},660:function(t,e,r){var i,n,o;t.exports=(o=r(249),r(109),o.mode.OFB=(n=(i=o.lib.BlockCipherMode.extend()).Encryptor=i.extend({processBlock:function(t,e){var r=this._cipher,i=r.blockSize,n=this._iv,o=this._keystream;n&&(o=this._keystream=n.slice(0),this._iv=void 0),r.encryptBlock(o,0);for(var s=0;s<i;s++)t[e+s]^=o[s];}}),i.Decryptor=n,i),o.mode.OFB);},615:function(t,e,r){var i;t.exports=(i=r(249),r(109),i.pad.AnsiX923={pad:function(t,e){var r=t.sigBytes,i=4*e,n=i-r%i,o=r+n-1;t.clamp(),t.words[o>>>2]|=n<<24-o%4*8,t.sigBytes+=n;},unpad:function(t){var e=255&t.words[t.sigBytes-1>>>2];t.sigBytes-=e;}},i.pad.Ansix923);},807:function(t,e,r){var i;t.exports=(i=r(249),r(109),i.pad.Iso10126={pad:function(t,e){var r=4*e,n=r-t.sigBytes%r;t.concat(i.lib.WordArray.random(n-1)).concat(i.lib.WordArray.create([n<<24],1));},unpad:function(t){var e=255&t.words[t.sigBytes-1>>>2];t.sigBytes-=e;}},i.pad.Iso10126);},77:function(t,e,r){var i;t.exports=(i=r(249),r(109),i.pad.Iso97971={pad:function(t,e){t.concat(i.lib.WordArray.create([2147483648],1)),i.pad.ZeroPadding.pad(t,e);},unpad:function(t){i.pad.ZeroPadding.unpad(t),t.sigBytes--;}},i.pad.Iso97971);},991:function(t,e,r){var i;t.exports=(i=r(249),r(109),i.pad.NoPadding={pad:function(){},unpad:function(){}},i.pad.NoPadding);},475:function(t,e,r){var i;t.exports=(i=r(249),r(109),i.pad.ZeroPadding={pad:function(t,e){var r=4*e;t.clamp(),t.sigBytes+=r-(t.sigBytes%r||r);},unpad:function(t){var e=t.words,r=t.sigBytes-1;for(r=t.sigBytes-1;r>=0;r--)if(e[r>>>2]>>>24-r%4*8&255){t.sigBytes=r+1;break}}},i.pad.ZeroPadding);},112:function(t,e,r){var i,n,o,s,c,a,h,f,l;t.exports=(l=r(249),r(783),r(824),o=(n=(i=l).lib).Base,s=n.WordArray,a=(c=i.algo).SHA1,h=c.HMAC,f=c.PBKDF2=o.extend({cfg:o.extend({keySize:4,hasher:a,iterations:1}),init:function(t){this.cfg=this.cfg.extend(t);},compute:function(t,e){for(var r=this.cfg,i=h.create(r.hasher,t),n=s.create(),o=s.create([1]),c=n.words,a=o.words,f=r.keySize,l=r.iterations;c.length<f;){var u=i.update(e).finalize(o);i.reset();for(var d=u.words,p=d.length,v=u,_=1;_<l;_++){v=i.finalize(v),i.reset();for(var y=v.words,g=0;g<p;g++)d[g]^=y[g];}n.concat(u),a[0]++;}return n.sigBytes=4*f,n}}),i.PBKDF2=function(t,e,r){return f.create(r).compute(t,e)},l.PBKDF2);},974:function(t,e,r){var i;t.exports=(i=r(249),r(269),r(214),r(888),r(109),function(){var t=i,e=t.lib.StreamCipher,r=t.algo,n=[],o=[],s=[],c=r.RabbitLegacy=e.extend({_doReset:function(){var t=this._key.words,e=this.cfg.iv,r=this._X=[t[0],t[3]<<16|t[2]>>>16,t[1],t[0]<<16|t[3]>>>16,t[2],t[1]<<16|t[0]>>>16,t[3],t[2]<<16|t[1]>>>16],i=this._C=[t[2]<<16|t[2]>>>16,4294901760&t[0]|65535&t[1],t[3]<<16|t[3]>>>16,4294901760&t[1]|65535&t[2],t[0]<<16|t[0]>>>16,4294901760&t[2]|65535&t[3],t[1]<<16|t[1]>>>16,4294901760&t[3]|65535&t[0]];this._b=0;for(var n=0;n<4;n++)a.call(this);for(n=0;n<8;n++)i[n]^=r[n+4&7];if(e){var o=e.words,s=o[0],c=o[1],h=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),f=16711935&(c<<8|c>>>24)|4278255360&(c<<24|c>>>8),l=h>>>16|4294901760&f,u=f<<16|65535&h;for(i[0]^=h,i[1]^=l,i[2]^=f,i[3]^=u,i[4]^=h,i[5]^=l,i[6]^=f,i[7]^=u,n=0;n<4;n++)a.call(this);}},_doProcessBlock:function(t,e){var r=this._X;a.call(this),n[0]=r[0]^r[5]>>>16^r[3]<<16,n[1]=r[2]^r[7]>>>16^r[5]<<16,n[2]=r[4]^r[1]>>>16^r[7]<<16,n[3]=r[6]^r[3]>>>16^r[1]<<16;for(var i=0;i<4;i++)n[i]=16711935&(n[i]<<8|n[i]>>>24)|4278255360&(n[i]<<24|n[i]>>>8),t[e+i]^=n[i];},blockSize:4,ivSize:2});function a(){for(var t=this._X,e=this._C,r=0;r<8;r++)o[r]=e[r];for(e[0]=e[0]+1295307597+this._b|0,e[1]=e[1]+3545052371+(e[0]>>>0<o[0]>>>0?1:0)|0,e[2]=e[2]+886263092+(e[1]>>>0<o[1]>>>0?1:0)|0,e[3]=e[3]+1295307597+(e[2]>>>0<o[2]>>>0?1:0)|0,e[4]=e[4]+3545052371+(e[3]>>>0<o[3]>>>0?1:0)|0,e[5]=e[5]+886263092+(e[4]>>>0<o[4]>>>0?1:0)|0,e[6]=e[6]+1295307597+(e[5]>>>0<o[5]>>>0?1:0)|0,e[7]=e[7]+3545052371+(e[6]>>>0<o[6]>>>0?1:0)|0,this._b=e[7]>>>0<o[7]>>>0?1:0,r=0;r<8;r++){var i=t[r]+e[r],n=65535&i,c=i>>>16,a=((n*n>>>17)+n*c>>>15)+c*c,h=((4294901760&i)*i|0)+((65535&i)*i|0);s[r]=a^h;}t[0]=s[0]+(s[7]<<16|s[7]>>>16)+(s[6]<<16|s[6]>>>16)|0,t[1]=s[1]+(s[0]<<8|s[0]>>>24)+s[7]|0,t[2]=s[2]+(s[1]<<16|s[1]>>>16)+(s[0]<<16|s[0]>>>16)|0,t[3]=s[3]+(s[2]<<8|s[2]>>>24)+s[1]|0,t[4]=s[4]+(s[3]<<16|s[3]>>>16)+(s[2]<<16|s[2]>>>16)|0,t[5]=s[5]+(s[4]<<8|s[4]>>>24)+s[3]|0,t[6]=s[6]+(s[5]<<16|s[5]>>>16)+(s[4]<<16|s[4]>>>16)|0,t[7]=s[7]+(s[6]<<8|s[6]>>>24)+s[5]|0;}t.RabbitLegacy=e._createHelper(c);}(),i.RabbitLegacy);},454:function(t,e,r){var i;t.exports=(i=r(249),r(269),r(214),r(888),r(109),function(){var t=i,e=t.lib.StreamCipher,r=t.algo,n=[],o=[],s=[],c=r.Rabbit=e.extend({_doReset:function(){for(var t=this._key.words,e=this.cfg.iv,r=0;r<4;r++)t[r]=16711935&(t[r]<<8|t[r]>>>24)|4278255360&(t[r]<<24|t[r]>>>8);var i=this._X=[t[0],t[3]<<16|t[2]>>>16,t[1],t[0]<<16|t[3]>>>16,t[2],t[1]<<16|t[0]>>>16,t[3],t[2]<<16|t[1]>>>16],n=this._C=[t[2]<<16|t[2]>>>16,4294901760&t[0]|65535&t[1],t[3]<<16|t[3]>>>16,4294901760&t[1]|65535&t[2],t[0]<<16|t[0]>>>16,4294901760&t[2]|65535&t[3],t[1]<<16|t[1]>>>16,4294901760&t[3]|65535&t[0]];for(this._b=0,r=0;r<4;r++)a.call(this);for(r=0;r<8;r++)n[r]^=i[r+4&7];if(e){var o=e.words,s=o[0],c=o[1],h=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),f=16711935&(c<<8|c>>>24)|4278255360&(c<<24|c>>>8),l=h>>>16|4294901760&f,u=f<<16|65535&h;for(n[0]^=h,n[1]^=l,n[2]^=f,n[3]^=u,n[4]^=h,n[5]^=l,n[6]^=f,n[7]^=u,r=0;r<4;r++)a.call(this);}},_doProcessBlock:function(t,e){var r=this._X;a.call(this),n[0]=r[0]^r[5]>>>16^r[3]<<16,n[1]=r[2]^r[7]>>>16^r[5]<<16,n[2]=r[4]^r[1]>>>16^r[7]<<16,n[3]=r[6]^r[3]>>>16^r[1]<<16;for(var i=0;i<4;i++)n[i]=16711935&(n[i]<<8|n[i]>>>24)|4278255360&(n[i]<<24|n[i]>>>8),t[e+i]^=n[i];},blockSize:4,ivSize:2});function a(){for(var t=this._X,e=this._C,r=0;r<8;r++)o[r]=e[r];for(e[0]=e[0]+1295307597+this._b|0,e[1]=e[1]+3545052371+(e[0]>>>0<o[0]>>>0?1:0)|0,e[2]=e[2]+886263092+(e[1]>>>0<o[1]>>>0?1:0)|0,e[3]=e[3]+1295307597+(e[2]>>>0<o[2]>>>0?1:0)|0,e[4]=e[4]+3545052371+(e[3]>>>0<o[3]>>>0?1:0)|0,e[5]=e[5]+886263092+(e[4]>>>0<o[4]>>>0?1:0)|0,e[6]=e[6]+1295307597+(e[5]>>>0<o[5]>>>0?1:0)|0,e[7]=e[7]+3545052371+(e[6]>>>0<o[6]>>>0?1:0)|0,this._b=e[7]>>>0<o[7]>>>0?1:0,r=0;r<8;r++){var i=t[r]+e[r],n=65535&i,c=i>>>16,a=((n*n>>>17)+n*c>>>15)+c*c,h=((4294901760&i)*i|0)+((65535&i)*i|0);s[r]=a^h;}t[0]=s[0]+(s[7]<<16|s[7]>>>16)+(s[6]<<16|s[6]>>>16)|0,t[1]=s[1]+(s[0]<<8|s[0]>>>24)+s[7]|0,t[2]=s[2]+(s[1]<<16|s[1]>>>16)+(s[0]<<16|s[0]>>>16)|0,t[3]=s[3]+(s[2]<<8|s[2]>>>24)+s[1]|0,t[4]=s[4]+(s[3]<<16|s[3]>>>16)+(s[2]<<16|s[2]>>>16)|0,t[5]=s[5]+(s[4]<<8|s[4]>>>24)+s[3]|0,t[6]=s[6]+(s[5]<<16|s[5]>>>16)+(s[4]<<16|s[4]>>>16)|0,t[7]=s[7]+(s[6]<<8|s[6]>>>24)+s[5]|0;}t.Rabbit=e._createHelper(c);}(),i.Rabbit);},857:function(t,e,r){var i;t.exports=(i=r(249),r(269),r(214),r(888),r(109),function(){var t=i,e=t.lib.StreamCipher,r=t.algo,n=r.RC4=e.extend({_doReset:function(){for(var t=this._key,e=t.words,r=t.sigBytes,i=this._S=[],n=0;n<256;n++)i[n]=n;n=0;for(var o=0;n<256;n++){var s=n%r,c=e[s>>>2]>>>24-s%4*8&255;o=(o+i[n]+c)%256;var a=i[n];i[n]=i[o],i[o]=a;}this._i=this._j=0;},_doProcessBlock:function(t,e){t[e]^=o.call(this);},keySize:8,ivSize:0});function o(){for(var t=this._S,e=this._i,r=this._j,i=0,n=0;n<4;n++){r=(r+t[e=(e+1)%256])%256;var o=t[e];t[e]=t[r],t[r]=o,i|=t[(t[e]+t[r])%256]<<24-8*n;}return this._i=e,this._j=r,i}t.RC4=e._createHelper(n);var s=r.RC4Drop=n.extend({cfg:n.cfg.extend({drop:192}),_doReset:function(){n._doReset.call(this);for(var t=this.cfg.drop;t>0;t--)o.call(this);}});t.RC4Drop=e._createHelper(s);}(),i.RC4);},706:function(t,e,r){var i;t.exports=(i=r(249),function(t){var e=i,r=e.lib,n=r.WordArray,o=r.Hasher,s=e.algo,c=n.create([0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13]),a=n.create([5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11]),h=n.create([11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6]),f=n.create([8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]),l=n.create([0,1518500249,1859775393,2400959708,2840853838]),u=n.create([1352829926,1548603684,1836072691,2053994217,0]),d=s.RIPEMD160=o.extend({_doReset:function(){this._hash=n.create([1732584193,4023233417,2562383102,271733878,3285377520]);},_doProcessBlock:function(t,e){for(var r=0;r<16;r++){var i=e+r,n=t[i];t[i]=16711935&(n<<8|n>>>24)|4278255360&(n<<24|n>>>8);}var o,s,d,w,k,x,S,m,b,A,H,z=this._hash.words,C=l.words,E=u.words,D=c.words,R=a.words,M=h.words,P=f.words;for(x=o=z[0],S=s=z[1],m=d=z[2],b=w=z[3],A=k=z[4],r=0;r<80;r+=1)H=o+t[e+D[r]]|0,H+=r<16?p(s,d,w)+C[0]:r<32?v(s,d,w)+C[1]:r<48?_(s,d,w)+C[2]:r<64?y(s,d,w)+C[3]:g(s,d,w)+C[4],H=(H=B(H|=0,M[r]))+k|0,o=k,k=w,w=B(d,10),d=s,s=H,H=x+t[e+R[r]]|0,H+=r<16?g(S,m,b)+E[0]:r<32?y(S,m,b)+E[1]:r<48?_(S,m,b)+E[2]:r<64?v(S,m,b)+E[3]:p(S,m,b)+E[4],H=(H=B(H|=0,P[r]))+A|0,x=A,A=b,b=B(m,10),m=S,S=H;H=z[1]+d+b|0,z[1]=z[2]+w+A|0,z[2]=z[3]+k+x|0,z[3]=z[4]+o+S|0,z[4]=z[0]+s+m|0,z[0]=H;},_doFinalize:function(){var t=this._data,e=t.words,r=8*this._nDataBytes,i=8*t.sigBytes;e[i>>>5]|=128<<24-i%32,e[14+(i+64>>>9<<4)]=16711935&(r<<8|r>>>24)|4278255360&(r<<24|r>>>8),t.sigBytes=4*(e.length+1),this._process();for(var n=this._hash,o=n.words,s=0;s<5;s++){var c=o[s];o[s]=16711935&(c<<8|c>>>24)|4278255360&(c<<24|c>>>8);}return n},clone:function(){var t=o.clone.call(this);return t._hash=this._hash.clone(),t}});function p(t,e,r){return t^e^r}function v(t,e,r){return t&e|~t&r}function _(t,e,r){return (t|~e)^r}function y(t,e,r){return t&r|e&~r}function g(t,e,r){return t^(e|~r)}function B(t,e){return t<<e|t>>>32-e}e.RIPEMD160=o._createHelper(d),e.HmacRIPEMD160=o._createHmacHelper(d);}(),i.RIPEMD160);},783:function(t,e,r){var i,n,o,s,c,a,h,f;t.exports=(n=(i=f=r(249)).lib,o=n.WordArray,s=n.Hasher,c=i.algo,a=[],h=c.SHA1=s.extend({_doReset:function(){this._hash=new o.init([1732584193,4023233417,2562383102,271733878,3285377520]);},_doProcessBlock:function(t,e){for(var r=this._hash.words,i=r[0],n=r[1],o=r[2],s=r[3],c=r[4],h=0;h<80;h++){if(h<16)a[h]=0|t[e+h];else {var f=a[h-3]^a[h-8]^a[h-14]^a[h-16];a[h]=f<<1|f>>>31;}var l=(i<<5|i>>>27)+c+a[h];l+=h<20?1518500249+(n&o|~n&s):h<40?1859775393+(n^o^s):h<60?(n&o|n&s|o&s)-1894007588:(n^o^s)-899497514,c=s,s=o,o=n<<30|n>>>2,n=i,i=l;}r[0]=r[0]+i|0,r[1]=r[1]+n|0,r[2]=r[2]+o|0,r[3]=r[3]+s|0,r[4]=r[4]+c|0;},_doFinalize:function(){var t=this._data,e=t.words,r=8*this._nDataBytes,i=8*t.sigBytes;return e[i>>>5]|=128<<24-i%32,e[14+(i+64>>>9<<4)]=Math.floor(r/4294967296),e[15+(i+64>>>9<<4)]=r,t.sigBytes=4*e.length,this._process(),this._hash},clone:function(){var t=s.clone.call(this);return t._hash=this._hash.clone(),t}}),i.SHA1=s._createHelper(h),i.HmacSHA1=s._createHmacHelper(h),f.SHA1);},792:function(t,e,r){var i,n,o,s,c,a;t.exports=(a=r(249),r(153),n=(i=a).lib.WordArray,o=i.algo,s=o.SHA256,c=o.SHA224=s.extend({_doReset:function(){this._hash=new n.init([3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428]);},_doFinalize:function(){var t=s._doFinalize.call(this);return t.sigBytes-=4,t}}),i.SHA224=s._createHelper(c),i.HmacSHA224=s._createHmacHelper(c),a.SHA224);},153:function(t,e,r){var i;t.exports=(i=r(249),function(t){var e=i,r=e.lib,n=r.WordArray,o=r.Hasher,s=e.algo,c=[],a=[];!function(){function e(e){for(var r=t.sqrt(e),i=2;i<=r;i++)if(!(e%i))return !1;return !0}function r(t){return 4294967296*(t-(0|t))|0}for(var i=2,n=0;n<64;)e(i)&&(n<8&&(c[n]=r(t.pow(i,.5))),a[n]=r(t.pow(i,1/3)),n++),i++;}();var h=[],f=s.SHA256=o.extend({_doReset:function(){this._hash=new n.init(c.slice(0));},_doProcessBlock:function(t,e){for(var r=this._hash.words,i=r[0],n=r[1],o=r[2],s=r[3],c=r[4],f=r[5],l=r[6],u=r[7],d=0;d<64;d++){if(d<16)h[d]=0|t[e+d];else {var p=h[d-15],v=(p<<25|p>>>7)^(p<<14|p>>>18)^p>>>3,_=h[d-2],y=(_<<15|_>>>17)^(_<<13|_>>>19)^_>>>10;h[d]=v+h[d-7]+y+h[d-16];}var g=i&n^i&o^n&o,B=(i<<30|i>>>2)^(i<<19|i>>>13)^(i<<10|i>>>22),w=u+((c<<26|c>>>6)^(c<<21|c>>>11)^(c<<7|c>>>25))+(c&f^~c&l)+a[d]+h[d];u=l,l=f,f=c,c=s+w|0,s=o,o=n,n=i,i=w+(B+g)|0;}r[0]=r[0]+i|0,r[1]=r[1]+n|0,r[2]=r[2]+o|0,r[3]=r[3]+s|0,r[4]=r[4]+c|0,r[5]=r[5]+f|0,r[6]=r[6]+l|0,r[7]=r[7]+u|0;},_doFinalize:function(){var e=this._data,r=e.words,i=8*this._nDataBytes,n=8*e.sigBytes;return r[n>>>5]|=128<<24-n%32,r[14+(n+64>>>9<<4)]=t.floor(i/4294967296),r[15+(n+64>>>9<<4)]=i,e.sigBytes=4*r.length,this._process(),this._hash},clone:function(){var t=o.clone.call(this);return t._hash=this._hash.clone(),t}});e.SHA256=o._createHelper(f),e.HmacSHA256=o._createHmacHelper(f);}(Math),i.SHA256);},327:function(t,e,r){var i;t.exports=(i=r(249),r(938),function(t){var e=i,r=e.lib,n=r.WordArray,o=r.Hasher,s=e.x64.Word,c=e.algo,a=[],h=[],f=[];!function(){for(var t=1,e=0,r=0;r<24;r++){a[t+5*e]=(r+1)*(r+2)/2%64;var i=(2*t+3*e)%5;t=e%5,e=i;}for(t=0;t<5;t++)for(e=0;e<5;e++)h[t+5*e]=e+(2*t+3*e)%5*5;for(var n=1,o=0;o<24;o++){for(var c=0,l=0,u=0;u<7;u++){if(1&n){var d=(1<<u)-1;d<32?l^=1<<d:c^=1<<d-32;}128&n?n=n<<1^113:n<<=1;}f[o]=s.create(c,l);}}();var l=[];!function(){for(var t=0;t<25;t++)l[t]=s.create();}();var u=c.SHA3=o.extend({cfg:o.cfg.extend({outputLength:512}),_doReset:function(){for(var t=this._state=[],e=0;e<25;e++)t[e]=new s.init;this.blockSize=(1600-2*this.cfg.outputLength)/32;},_doProcessBlock:function(t,e){for(var r=this._state,i=this.blockSize/2,n=0;n<i;n++){var o=t[e+2*n],s=t[e+2*n+1];o=16711935&(o<<8|o>>>24)|4278255360&(o<<24|o>>>8),s=16711935&(s<<8|s>>>24)|4278255360&(s<<24|s>>>8),(z=r[n]).high^=s,z.low^=o;}for(var c=0;c<24;c++){for(var u=0;u<5;u++){for(var d=0,p=0,v=0;v<5;v++)d^=(z=r[u+5*v]).high,p^=z.low;var _=l[u];_.high=d,_.low=p;}for(u=0;u<5;u++){var y=l[(u+4)%5],g=l[(u+1)%5],B=g.high,w=g.low;for(d=y.high^(B<<1|w>>>31),p=y.low^(w<<1|B>>>31),v=0;v<5;v++)(z=r[u+5*v]).high^=d,z.low^=p;}for(var k=1;k<25;k++){var x=(z=r[k]).high,S=z.low,m=a[k];m<32?(d=x<<m|S>>>32-m,p=S<<m|x>>>32-m):(d=S<<m-32|x>>>64-m,p=x<<m-32|S>>>64-m);var b=l[h[k]];b.high=d,b.low=p;}var A=l[0],H=r[0];for(A.high=H.high,A.low=H.low,u=0;u<5;u++)for(v=0;v<5;v++){var z=r[k=u+5*v],C=l[k],E=l[(u+1)%5+5*v],D=l[(u+2)%5+5*v];z.high=C.high^~E.high&D.high,z.low=C.low^~E.low&D.low;}z=r[0];var R=f[c];z.high^=R.high,z.low^=R.low;}},_doFinalize:function(){var e=this._data,r=e.words,i=(this._nDataBytes,8*e.sigBytes),o=32*this.blockSize;r[i>>>5]|=1<<24-i%32,r[(t.ceil((i+1)/o)*o>>>5)-1]|=128,e.sigBytes=4*r.length,this._process();for(var s=this._state,c=this.cfg.outputLength/8,a=c/8,h=[],f=0;f<a;f++){var l=s[f],u=l.high,d=l.low;u=16711935&(u<<8|u>>>24)|4278255360&(u<<24|u>>>8),d=16711935&(d<<8|d>>>24)|4278255360&(d<<24|d>>>8),h.push(d),h.push(u);}return new n.init(h,c)},clone:function(){for(var t=o.clone.call(this),e=t._state=this._state.slice(0),r=0;r<25;r++)e[r]=e[r].clone();return t}});e.SHA3=o._createHelper(u),e.HmacSHA3=o._createHmacHelper(u);}(Math),i.SHA3);},460:function(t,e,r){var i,n,o,s,c,a,h,f;t.exports=(f=r(249),r(938),r(34),n=(i=f).x64,o=n.Word,s=n.WordArray,c=i.algo,a=c.SHA512,h=c.SHA384=a.extend({_doReset:function(){this._hash=new s.init([new o.init(3418070365,3238371032),new o.init(1654270250,914150663),new o.init(2438529370,812702999),new o.init(355462360,4144912697),new o.init(1731405415,4290775857),new o.init(2394180231,1750603025),new o.init(3675008525,1694076839),new o.init(1203062813,3204075428)]);},_doFinalize:function(){var t=a._doFinalize.call(this);return t.sigBytes-=16,t}}),i.SHA384=a._createHelper(h),i.HmacSHA384=a._createHmacHelper(h),f.SHA384);},34:function(t,e,r){var i;t.exports=(i=r(249),r(938),function(){var t=i,e=t.lib.Hasher,r=t.x64,n=r.Word,o=r.WordArray,s=t.algo;function c(){return n.create.apply(n,arguments)}var a=[c(1116352408,3609767458),c(1899447441,602891725),c(3049323471,3964484399),c(3921009573,2173295548),c(961987163,4081628472),c(1508970993,3053834265),c(2453635748,2937671579),c(2870763221,3664609560),c(3624381080,2734883394),c(310598401,1164996542),c(607225278,1323610764),c(1426881987,3590304994),c(1925078388,4068182383),c(2162078206,991336113),c(2614888103,633803317),c(3248222580,3479774868),c(3835390401,2666613458),c(4022224774,944711139),c(264347078,2341262773),c(604807628,2007800933),c(770255983,1495990901),c(1249150122,1856431235),c(1555081692,3175218132),c(1996064986,2198950837),c(2554220882,3999719339),c(2821834349,766784016),c(2952996808,2566594879),c(3210313671,3203337956),c(3336571891,1034457026),c(3584528711,2466948901),c(113926993,3758326383),c(338241895,168717936),c(666307205,1188179964),c(773529912,1546045734),c(1294757372,1522805485),c(1396182291,2643833823),c(1695183700,2343527390),c(1986661051,1014477480),c(2177026350,1206759142),c(2456956037,344077627),c(2730485921,1290863460),c(2820302411,3158454273),c(3259730800,3505952657),c(3345764771,106217008),c(3516065817,3606008344),c(3600352804,1432725776),c(4094571909,1467031594),c(275423344,851169720),c(430227734,3100823752),c(506948616,1363258195),c(659060556,3750685593),c(883997877,3785050280),c(958139571,3318307427),c(1322822218,3812723403),c(1537002063,2003034995),c(1747873779,3602036899),c(1955562222,1575990012),c(2024104815,1125592928),c(2227730452,2716904306),c(2361852424,442776044),c(2428436474,593698344),c(2756734187,3733110249),c(3204031479,2999351573),c(3329325298,3815920427),c(3391569614,3928383900),c(3515267271,566280711),c(3940187606,3454069534),c(4118630271,4000239992),c(116418474,1914138554),c(174292421,2731055270),c(289380356,3203993006),c(460393269,320620315),c(685471733,587496836),c(852142971,1086792851),c(1017036298,365543100),c(1126000580,2618297676),c(1288033470,3409855158),c(1501505948,4234509866),c(1607167915,987167468),c(1816402316,1246189591)],h=[];!function(){for(var t=0;t<80;t++)h[t]=c();}();var f=s.SHA512=e.extend({_doReset:function(){this._hash=new o.init([new n.init(1779033703,4089235720),new n.init(3144134277,2227873595),new n.init(1013904242,4271175723),new n.init(2773480762,1595750129),new n.init(1359893119,2917565137),new n.init(2600822924,725511199),new n.init(528734635,4215389547),new n.init(1541459225,327033209)]);},_doProcessBlock:function(t,e){for(var r=this._hash.words,i=r[0],n=r[1],o=r[2],s=r[3],c=r[4],f=r[5],l=r[6],u=r[7],d=i.high,p=i.low,v=n.high,_=n.low,y=o.high,g=o.low,B=s.high,w=s.low,k=c.high,x=c.low,S=f.high,m=f.low,b=l.high,A=l.low,H=u.high,z=u.low,C=d,E=p,D=v,R=_,M=y,P=g,F=B,O=w,I=k,W=x,K=S,U=m,j=b,X=A,L=H,T=z,N=0;N<80;N++){var $,q,Z=h[N];if(N<16)q=Z.high=0|t[e+2*N],$=Z.low=0|t[e+2*N+1];else {var G=h[N-15],J=G.high,V=G.low,Q=(J>>>1|V<<31)^(J>>>8|V<<24)^J>>>7,Y=(V>>>1|J<<31)^(V>>>8|J<<24)^(V>>>7|J<<25),tt=h[N-2],et=tt.high,rt=tt.low,it=(et>>>19|rt<<13)^(et<<3|rt>>>29)^et>>>6,nt=(rt>>>19|et<<13)^(rt<<3|et>>>29)^(rt>>>6|et<<26),ot=h[N-7],st=ot.high,ct=ot.low,at=h[N-16],ht=at.high,ft=at.low;q=(q=(q=Q+st+(($=Y+ct)>>>0<Y>>>0?1:0))+it+(($+=nt)>>>0<nt>>>0?1:0))+ht+(($+=ft)>>>0<ft>>>0?1:0),Z.high=q,Z.low=$;}var lt,ut=I&K^~I&j,dt=W&U^~W&X,pt=C&D^C&M^D&M,vt=E&R^E&P^R&P,_t=(C>>>28|E<<4)^(C<<30|E>>>2)^(C<<25|E>>>7),yt=(E>>>28|C<<4)^(E<<30|C>>>2)^(E<<25|C>>>7),gt=(I>>>14|W<<18)^(I>>>18|W<<14)^(I<<23|W>>>9),Bt=(W>>>14|I<<18)^(W>>>18|I<<14)^(W<<23|I>>>9),wt=a[N],kt=wt.high,xt=wt.low,St=L+gt+((lt=T+Bt)>>>0<T>>>0?1:0),mt=yt+vt;L=j,T=X,j=K,X=U,K=I,U=W,I=F+(St=(St=(St=St+ut+((lt+=dt)>>>0<dt>>>0?1:0))+kt+((lt+=xt)>>>0<xt>>>0?1:0))+q+((lt+=$)>>>0<$>>>0?1:0))+((W=O+lt|0)>>>0<O>>>0?1:0)|0,F=M,O=P,M=D,P=R,D=C,R=E,C=St+(_t+pt+(mt>>>0<yt>>>0?1:0))+((E=lt+mt|0)>>>0<lt>>>0?1:0)|0;}p=i.low=p+E,i.high=d+C+(p>>>0<E>>>0?1:0),_=n.low=_+R,n.high=v+D+(_>>>0<R>>>0?1:0),g=o.low=g+P,o.high=y+M+(g>>>0<P>>>0?1:0),w=s.low=w+O,s.high=B+F+(w>>>0<O>>>0?1:0),x=c.low=x+W,c.high=k+I+(x>>>0<W>>>0?1:0),m=f.low=m+U,f.high=S+K+(m>>>0<U>>>0?1:0),A=l.low=A+X,l.high=b+j+(A>>>0<X>>>0?1:0),z=u.low=z+T,u.high=H+L+(z>>>0<T>>>0?1:0);},_doFinalize:function(){var t=this._data,e=t.words,r=8*this._nDataBytes,i=8*t.sigBytes;return e[i>>>5]|=128<<24-i%32,e[30+(i+128>>>10<<5)]=Math.floor(r/4294967296),e[31+(i+128>>>10<<5)]=r,t.sigBytes=4*e.length,this._process(),this._hash.toX32()},clone:function(){var t=e.clone.call(this);return t._hash=this._hash.clone(),t},blockSize:32});t.SHA512=e._createHelper(f),t.HmacSHA512=e._createHmacHelper(f);}(),i.SHA512);},253:function(t,e,r){var i;t.exports=(i=r(249),r(269),r(214),r(888),r(109),function(){var t=i,e=t.lib,r=e.WordArray,n=e.BlockCipher,o=t.algo,s=[57,49,41,33,25,17,9,1,58,50,42,34,26,18,10,2,59,51,43,35,27,19,11,3,60,52,44,36,63,55,47,39,31,23,15,7,62,54,46,38,30,22,14,6,61,53,45,37,29,21,13,5,28,20,12,4],c=[14,17,11,24,1,5,3,28,15,6,21,10,23,19,12,4,26,8,16,7,27,20,13,2,41,52,31,37,47,55,30,40,51,45,33,48,44,49,39,56,34,53,46,42,50,36,29,32],a=[1,2,4,6,8,10,12,14,15,17,19,21,23,25,27,28],h=[{0:8421888,268435456:32768,536870912:8421378,805306368:2,1073741824:512,1342177280:8421890,1610612736:8389122,1879048192:8388608,2147483648:514,2415919104:8389120,2684354560:33280,2952790016:8421376,3221225472:32770,3489660928:8388610,3758096384:0,4026531840:33282,134217728:0,402653184:8421890,671088640:33282,939524096:32768,1207959552:8421888,1476395008:512,1744830464:8421378,2013265920:2,2281701376:8389120,2550136832:33280,2818572288:8421376,3087007744:8389122,3355443200:8388610,3623878656:32770,3892314112:514,4160749568:8388608,1:32768,268435457:2,536870913:8421888,805306369:8388608,1073741825:8421378,1342177281:33280,1610612737:512,1879048193:8389122,2147483649:8421890,2415919105:8421376,2684354561:8388610,2952790017:33282,3221225473:514,3489660929:8389120,3758096385:32770,4026531841:0,134217729:8421890,402653185:8421376,671088641:8388608,939524097:512,1207959553:32768,1476395009:8388610,1744830465:2,2013265921:33282,2281701377:32770,2550136833:8389122,2818572289:514,3087007745:8421888,3355443201:8389120,3623878657:0,3892314113:33280,4160749569:8421378},{0:1074282512,16777216:16384,33554432:524288,50331648:1074266128,67108864:1073741840,83886080:1074282496,100663296:1073758208,117440512:16,134217728:540672,150994944:1073758224,167772160:1073741824,184549376:540688,201326592:524304,218103808:0,234881024:16400,251658240:1074266112,8388608:1073758208,25165824:540688,41943040:16,58720256:1073758224,75497472:1074282512,92274688:1073741824,109051904:524288,125829120:1074266128,142606336:524304,159383552:0,176160768:16384,192937984:1074266112,209715200:1073741840,226492416:540672,243269632:1074282496,260046848:16400,268435456:0,285212672:1074266128,301989888:1073758224,318767104:1074282496,335544320:1074266112,352321536:16,369098752:540688,385875968:16384,402653184:16400,419430400:524288,436207616:524304,452984832:1073741840,469762048:540672,486539264:1073758208,503316480:1073741824,520093696:1074282512,276824064:540688,293601280:524288,310378496:1074266112,327155712:16384,343932928:1073758208,360710144:1074282512,377487360:16,394264576:1073741824,411041792:1074282496,427819008:1073741840,444596224:1073758224,461373440:524304,478150656:0,494927872:16400,511705088:1074266128,528482304:540672},{0:260,1048576:0,2097152:67109120,3145728:65796,4194304:65540,5242880:67108868,6291456:67174660,7340032:67174400,8388608:67108864,9437184:67174656,10485760:65792,11534336:67174404,12582912:67109124,13631488:65536,14680064:4,15728640:256,524288:67174656,1572864:67174404,2621440:0,3670016:67109120,4718592:67108868,5767168:65536,6815744:65540,7864320:260,8912896:4,9961472:256,11010048:67174400,12058624:65796,13107200:65792,14155776:67109124,15204352:67174660,16252928:67108864,16777216:67174656,17825792:65540,18874368:65536,19922944:67109120,20971520:256,22020096:67174660,23068672:67108868,24117248:0,25165824:67109124,26214400:67108864,27262976:4,28311552:65792,29360128:67174400,30408704:260,31457280:65796,32505856:67174404,17301504:67108864,18350080:260,19398656:67174656,20447232:0,21495808:65540,22544384:67109120,23592960:256,24641536:67174404,25690112:65536,26738688:67174660,27787264:65796,28835840:67108868,29884416:67109124,30932992:67174400,31981568:4,33030144:65792},{0:2151682048,65536:2147487808,131072:4198464,196608:2151677952,262144:0,327680:4198400,393216:2147483712,458752:4194368,524288:2147483648,589824:4194304,655360:64,720896:2147487744,786432:2151678016,851968:4160,917504:4096,983040:2151682112,32768:2147487808,98304:64,163840:2151678016,229376:2147487744,294912:4198400,360448:2151682112,425984:0,491520:2151677952,557056:4096,622592:2151682048,688128:4194304,753664:4160,819200:2147483648,884736:4194368,950272:4198464,1015808:2147483712,1048576:4194368,1114112:4198400,1179648:2147483712,1245184:0,1310720:4160,1376256:2151678016,1441792:2151682048,1507328:2147487808,1572864:2151682112,1638400:2147483648,1703936:2151677952,1769472:4198464,1835008:2147487744,1900544:4194304,1966080:64,2031616:4096,1081344:2151677952,1146880:2151682112,1212416:0,1277952:4198400,1343488:4194368,1409024:2147483648,1474560:2147487808,1540096:64,1605632:2147483712,1671168:4096,1736704:2147487744,1802240:2151678016,1867776:4160,1933312:2151682048,1998848:4194304,2064384:4198464},{0:128,4096:17039360,8192:262144,12288:536870912,16384:537133184,20480:16777344,24576:553648256,28672:262272,32768:16777216,36864:537133056,40960:536871040,45056:553910400,49152:553910272,53248:0,57344:17039488,61440:553648128,2048:17039488,6144:553648256,10240:128,14336:17039360,18432:262144,22528:537133184,26624:553910272,30720:536870912,34816:537133056,38912:0,43008:553910400,47104:16777344,51200:536871040,55296:553648128,59392:16777216,63488:262272,65536:262144,69632:128,73728:536870912,77824:553648256,81920:16777344,86016:553910272,90112:537133184,94208:16777216,98304:553910400,102400:553648128,106496:17039360,110592:537133056,114688:262272,118784:536871040,122880:0,126976:17039488,67584:553648256,71680:16777216,75776:17039360,79872:537133184,83968:536870912,88064:17039488,92160:128,96256:553910272,100352:262272,104448:553910400,108544:0,112640:553648128,116736:16777344,120832:262144,124928:537133056,129024:536871040},{0:268435464,256:8192,512:270532608,768:270540808,1024:268443648,1280:2097152,1536:2097160,1792:268435456,2048:0,2304:268443656,2560:2105344,2816:8,3072:270532616,3328:2105352,3584:8200,3840:270540800,128:270532608,384:270540808,640:8,896:2097152,1152:2105352,1408:268435464,1664:268443648,1920:8200,2176:2097160,2432:8192,2688:268443656,2944:270532616,3200:0,3456:270540800,3712:2105344,3968:268435456,4096:268443648,4352:270532616,4608:270540808,4864:8200,5120:2097152,5376:268435456,5632:268435464,5888:2105344,6144:2105352,6400:0,6656:8,6912:270532608,7168:8192,7424:268443656,7680:270540800,7936:2097160,4224:8,4480:2105344,4736:2097152,4992:268435464,5248:268443648,5504:8200,5760:270540808,6016:270532608,6272:270540800,6528:270532616,6784:8192,7040:2105352,7296:2097160,7552:0,7808:268435456,8064:268443656},{0:1048576,16:33555457,32:1024,48:1049601,64:34604033,80:0,96:1,112:34603009,128:33555456,144:1048577,160:33554433,176:34604032,192:34603008,208:1025,224:1049600,240:33554432,8:34603009,24:0,40:33555457,56:34604032,72:1048576,88:33554433,104:33554432,120:1025,136:1049601,152:33555456,168:34603008,184:1048577,200:1024,216:34604033,232:1,248:1049600,256:33554432,272:1048576,288:33555457,304:34603009,320:1048577,336:33555456,352:34604032,368:1049601,384:1025,400:34604033,416:1049600,432:1,448:0,464:34603008,480:33554433,496:1024,264:1049600,280:33555457,296:34603009,312:1,328:33554432,344:1048576,360:1025,376:34604032,392:33554433,408:34603008,424:0,440:34604033,456:1049601,472:1024,488:33555456,504:1048577},{0:134219808,1:131072,2:134217728,3:32,4:131104,5:134350880,6:134350848,7:2048,8:134348800,9:134219776,10:133120,11:134348832,12:2080,13:0,14:134217760,15:133152,2147483648:2048,2147483649:134350880,2147483650:134219808,2147483651:134217728,2147483652:134348800,2147483653:133120,2147483654:133152,2147483655:32,2147483656:134217760,2147483657:2080,2147483658:131104,2147483659:134350848,2147483660:0,2147483661:134348832,2147483662:134219776,2147483663:131072,16:133152,17:134350848,18:32,19:2048,20:134219776,21:134217760,22:134348832,23:131072,24:0,25:131104,26:134348800,27:134219808,28:134350880,29:133120,30:2080,31:134217728,2147483664:131072,2147483665:2048,2147483666:134348832,2147483667:133152,2147483668:32,2147483669:134348800,2147483670:134217728,2147483671:134219808,2147483672:134350880,2147483673:134217760,2147483674:134219776,2147483675:0,2147483676:133120,2147483677:2080,2147483678:131104,2147483679:134350848}],f=[4160749569,528482304,33030144,2064384,129024,8064,504,2147483679],l=o.DES=n.extend({_doReset:function(){for(var t=this._key.words,e=[],r=0;r<56;r++){var i=s[r]-1;e[r]=t[i>>>5]>>>31-i%32&1;}for(var n=this._subKeys=[],o=0;o<16;o++){var h=n[o]=[],f=a[o];for(r=0;r<24;r++)h[r/6|0]|=e[(c[r]-1+f)%28]<<31-r%6,h[4+(r/6|0)]|=e[28+(c[r+24]-1+f)%28]<<31-r%6;for(h[0]=h[0]<<1|h[0]>>>31,r=1;r<7;r++)h[r]=h[r]>>>4*(r-1)+3;h[7]=h[7]<<5|h[7]>>>27;}var l=this._invSubKeys=[];for(r=0;r<16;r++)l[r]=n[15-r];},encryptBlock:function(t,e){this._doCryptBlock(t,e,this._subKeys);},decryptBlock:function(t,e){this._doCryptBlock(t,e,this._invSubKeys);},_doCryptBlock:function(t,e,r){this._lBlock=t[e],this._rBlock=t[e+1],u.call(this,4,252645135),u.call(this,16,65535),d.call(this,2,858993459),d.call(this,8,16711935),u.call(this,1,1431655765);for(var i=0;i<16;i++){for(var n=r[i],o=this._lBlock,s=this._rBlock,c=0,a=0;a<8;a++)c|=h[a][((s^n[a])&f[a])>>>0];this._lBlock=s,this._rBlock=o^c;}var l=this._lBlock;this._lBlock=this._rBlock,this._rBlock=l,u.call(this,1,1431655765),d.call(this,8,16711935),d.call(this,2,858993459),u.call(this,16,65535),u.call(this,4,252645135),t[e]=this._lBlock,t[e+1]=this._rBlock;},keySize:2,ivSize:2,blockSize:2});function u(t,e){var r=(this._lBlock>>>t^this._rBlock)&e;this._rBlock^=r,this._lBlock^=r<<t;}function d(t,e){var r=(this._rBlock>>>t^this._lBlock)&e;this._lBlock^=r,this._rBlock^=r<<t;}t.DES=n._createHelper(l);var p=o.TripleDES=n.extend({_doReset:function(){var t=this._key.words;if(2!==t.length&&4!==t.length&&t.length<6)throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");var e=t.slice(0,2),i=t.length<4?t.slice(0,2):t.slice(2,4),n=t.length<6?t.slice(0,2):t.slice(4,6);this._des1=l.createEncryptor(r.create(e)),this._des2=l.createEncryptor(r.create(i)),this._des3=l.createEncryptor(r.create(n));},encryptBlock:function(t,e){this._des1.encryptBlock(t,e),this._des2.decryptBlock(t,e),this._des3.encryptBlock(t,e);},decryptBlock:function(t,e){this._des3.decryptBlock(t,e),this._des2.encryptBlock(t,e),this._des1.decryptBlock(t,e);},keySize:6,ivSize:2,blockSize:2});t.TripleDES=n._createHelper(p);}(),i.TripleDES);},938:function(t,e,r){var i,n,o,s,c,a;t.exports=(i=r(249),o=(n=i).lib,s=o.Base,c=o.WordArray,(a=n.x64={}).Word=s.extend({init:function(t,e){this.high=t,this.low=e;}}),a.WordArray=s.extend({init:function(t,e){t=this.words=t||[],this.sigBytes=null!=e?e:8*t.length;},toX32:function(){for(var t=this.words,e=t.length,r=[],i=0;i<e;i++){var n=t[i];r.push(n.high),r.push(n.low);}return c.create(r,this.sigBytes)},clone:function(){for(var t=s.clone.call(this),e=t.words=this.words.slice(0),r=e.length,i=0;i<r;i++)e[i]=e[i].clone();return t}}),i);},37:function(t,e,r){var i=this&&this.__createBinding||(Object.create?function(t,e,r,i){void 0===i&&(i=r),Object.defineProperty(t,i,{enumerable:!0,get:function(){return e[r]}});}:function(t,e,r,i){void 0===i&&(i=r),t[i]=e[r];}),n=this&&this.__exportStar||function(t,e){for(var r in t)"default"===r||Object.prototype.hasOwnProperty.call(e,r)||i(e,t,r);};Object.defineProperty(e,"__esModule",{value:!0}),n(r(911),e);},911:(t,e)=>{Object.defineProperty(e,"__esModule",{value:!0}),e.InvalidSecretKeyError=void 0;class r extends Error{constructor(){super("The secretKey parameter must bne contains min 10 characters. Please provide a valid secretKey"),this.name="InvalidSecretKey";}}e.InvalidSecretKeyError=r;},417:e=>{if(void 0===t){var r=new Error("Cannot find module 'crypto'");throw r.code="MODULE_NOT_FOUND",r}e.exports=t;}},r={};function i(t){var n=r[t];if(void 0!==n)return n.exports;var o=r[t]={exports:{}};return e[t].call(o.exports,o,o.exports,i),o.exports}i.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(t){if("object"==typeof window)return window}}();var n={};return (()=>{var t=n;Object.defineProperty(t,"__esModule",{value:!0}),t.EncryptStorage=void 0;const e=i(354),r=i(37);function o(t,i={}){if(t.length<10)throw new r.InvalidSecretKeyError;const n=window[i.storageType||"localStorage"],o=i.prefix||"",s=i.stateManagementUse||!1;return {length:n.length,setItem(r,i){const s=o?`${o}:${r}`:r,c="object"==typeof i?JSON.stringify(i):String(i),a=e.AES.encrypt(c,t).toString();n.setItem(s,a);},getItem(r){const i=o?`${o}:${r}`:r,c=n.getItem(i);if(c){const r=e.AES.decrypt(c,t).toString(e.enc.Utf8);if(s)return r;try{return JSON.parse(r)}catch(t){return r}}},removeItem(t){n.removeItem(t);},removeItemFromPattern(t){Object.keys(n).filter((e=>e.includes(t))).forEach((t=>{this.removeItem(t);}));},clear(){n.clear();},key:t=>n.key(t),encryptString:r=>e.AES.encrypt(r,t).toString(),decryptString:r=>e.AES.decrypt(r,t).toString(e.enc.Utf8)}}t.EncryptStorage=o,t.default=o;})(),n})()}));
});

var EncryptStorage = unwrapExports(dist);

var secret = "M0NK_W3bCh4t:$42.!";
var encryptedLS = EncryptStorage(secret);
var encryptedSS = EncryptStorage(secret, {
  storageType: "sessionStorage"
});

function lsSet(key, value) {
  encryptedLS.setItem(key, value);
}
function ssSet(key, value) {
  encryptedSS.setItem(key, value);
}
function lsGet(key) {
  try {
    return encryptedLS.getItem(key);
  } catch (err) {
    lsRemove(key);
    return "";
  }
}
function ssGet(key) {
  try {
    return encryptedSS.getItem(key);
  } catch (err) {
    ssRemove(key);
    return "";
  }
}
function lsRemove(key) {
  encryptedLS.removeItem(key);
}
function ssRemove(key) {
  encryptedSS.removeItem(key);
}

var getters = {
  messages: function messages(state) {
    return state.messages;
  },
  history: function history(state) {
    return state.history;
  },
  stampsMap: function stampsMap(state) {
    return state.timestampMap;
  },
  isLoggedIn: function isLoggedIn(state) {
    return state.isLogged;
  },
  getActionsMenu: function getActionsMenu(state) {
    return state.actionsMenu;
  },
  resource: function resource() {
    return lsGet("resource");
  },
  loggedCreds: function loggedCreds(state) {
    return state.loginCreds;
  },
  getConversationAreaTitle: function getConversationAreaTitle(state) {
    return state.conversationAreaTitle;
  },
  getConversations: function getConversations(state) {
    return state.conversations;
  },
  getConversationsCounter: function getConversationsCounter(state) {
    return state.conversationsCounter;
  },
  getCurrentChat: function getCurrentChat(state) {
    return state.currentUIChat;
  },
  showUserInputArea: function showUserInputArea(state) {
    return state.showUserInputArea;
  },
  showProxyView: function showProxyView(state) {
    return state.showProxyView;
  },
  getCurrentChatMessages: function getCurrentChatMessages(state) {
    return state.currentConversationMessages;
  },
  getCurrentChatMessagesPagination: function getCurrentChatMessagesPagination(state) {
    return state.currentConversationMessagesPagination;
  },
  getCurrentChatSupportMessagesPagination: function getCurrentChatSupportMessagesPagination(state) {
    return state.currentConversationSupportMessagesPagination;
  },
  getCurrentConversationPaginationMode: function getCurrentConversationPaginationMode(state) {
    return state.currentConversationPaginationMode;
  },
  getBackButtonLabel: function getBackButtonLabel(state) {
    return state.conversationsBackButtonLabel;
  },
  getChatHeaderTitle: function getChatHeaderTitle(state) {
    return state.currentChatHeaderTitle;
  },
  getChatHeaderIcon: function getChatHeaderIcon(state) {
    return state.currentChatHeaderIcon;
  },
  getIsConversationHeaderRawHtml: function getIsConversationHeaderRawHtml(state) {
    return state.isConversationHeaderRawHtml;
  },
  getChatAvatarIcon: function getChatAvatarIcon(state) {
    return state.currentAvatarIcon;
  },
  fetchAttachmentsUploaderConfig: function fetchAttachmentsUploaderConfig(state) {
    return state.attachmentsUploaderConfig;
  },
  getToggleMetas: function getToggleMetas(state) {
    return state.toggleMeta;
  },
  isInteractionInsertLocation: function isInteractionInsertLocation(state) {
    return state.isInteractionInsertLocation;
  },
  isLocationModalEnable: function isLocationModalEnable(state) {
    return state.isLocationModalEnable;
  },
  isInteractionInsertDate: function isInteractionInsertDate(state) {
    return state.isInteractionInsertDate;
  },
  currentDatePickerInfo: function currentDatePickerInfo(state) {
    return state.currentDatePickerInfo;
  },
  isInteractionSingleAutocomplete: function isInteractionSingleAutocomplete(state) {
    return state.isInteractionSingleAutocomplete;
  },
  isInteractionMultipleAutocomplete: function isInteractionMultipleAutocomplete(state) {
    return state.isInteractionMultipleAutocomplete;
  },
  currentAutocompleteInfo: function currentAutocompleteInfo(state) {
    return state.currentAutocompleteInfo;
  },
  currentAutocompleteList: function currentAutocompleteList(state) {
    return state.currentAutocompleteList;
  },
  showRestartChatButton: function showRestartChatButton(state) {
    return state.showRestartChatButton;
  },
  modeBeforeSubmit: function modeBeforeSubmit(state) {
    return state.modeBeforeSubmit;
  },
  visibilityAfterSubmit: function visibilityAfterSubmit(state) {
    return state.visibilityAfterSubmit;
  },
  getBotConfigSettings: function getBotConfigSettings(state) {
    return state.botConfigSettings;
  }
};

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

function _newArrowCheck(n, r) {
  if (n !== r) throw new TypeError("Cannot instantiate an arrow function");
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var call = Function.prototype.call;

var functionCall = functionBindNative ? call.bind(call) : function () {
  return call.apply(call, arguments);
};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var FunctionPrototype = Function.prototype;
var call$1 = FunctionPrototype.call;
var uncurryThisWithBind = functionBindNative && FunctionPrototype.bind.bind(call$1, call$1);

var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$1.apply(fn, arguments);
  };
};

var toString = functionUncurryThis({}.toString);
var stringSlice = functionUncurryThis(''.slice);

var classofRaw = function (it) {
  return stringSlice(toString(it), 8, -1);
};

var $Object = Object;
var split = functionUncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function (it) {
  return it === null || it === undefined;
};

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isObject$1 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis_1[namespace]) : globalThis_1[namespace] && globalThis_1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var navigator$1 = globalThis_1.navigator;
var userAgent = navigator$1 && navigator$1.userAgent;

var environmentUserAgent = userAgent ? String(userAgent) : '';

var process$1 = globalThis_1.process;
var Deno = globalThis_1.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version$1;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version$1 = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version$1 && environmentUserAgent) {
  match = environmentUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = environmentUserAgent.match(/Chrome\/(\d+)/);
    if (match) version$1 = +match[1];
  }
}

var environmentV8Version = version$1;

/* eslint-disable es/no-symbol -- required for testing */




var $String = globalThis_1.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && environmentV8Version && environmentV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = symbolConstructorDetection
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var $Object$1 = Object;

var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$1(it));
};

var $String$1 = String;

var tryToString = function (argument) {
  try {
    return $String$1(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$1 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError$1(tryToString(argument) + ' is not a function');
};

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$2 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject$1(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject$1(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject$1(val = functionCall(fn, input))) return val;
  throw new $TypeError$2("Can't convert object to primitive value");
};

var isPure = false;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var defineGlobalProperty = function (key, value) {
  try {
    defineProperty(globalThis_1, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis_1[key] = value;
  } return value;
};

var sharedStore = createCommonjsModule(function (module) {




var SHARED = '__core-js_shared__';
var store = module.exports = globalThis_1[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.38.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});
});

var shared = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value || {});
};

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return $Object$2(requireObjectCoercible(argument));
};

var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var id = 0;
var postfix = Math.random();
var toString$1 = functionUncurryThis(1.0.toString);

var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1(++id + postfix, 36);
};

var Symbol$1 = globalThis_1.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var $TypeError$3 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$1(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject$1(result) || isSymbol(result)) return result;
    throw new $TypeError$3("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$1 = function (argument) {
  var key = toPrimitive$1(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var document$1 = globalThis_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$1(document$1) && isObject$1(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey$1(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$1
};

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var $String$2 = String;
var $TypeError$4 = TypeError;

// `Assert: Type(argument) is Object`
var anObject = function (argument) {
  if (isObject$1(argument)) return argument;
  throw new $TypeError$4($String$2(argument) + ' is not an object');
};

var $TypeError$5 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$2 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey$1(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey$1(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$5('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;

var EXISTS$1 = hasOwnProperty_1(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS$1 && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE$1 = EXISTS$1 && (!descriptors || (descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS$1,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE$1
};

var functionToString = functionUncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = globalThis_1.WeakMap;

var weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = globalThis_1.TypeError;
var WeakMap$1 = globalThis_1.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (weakMapBasicDetection || sharedStore.state) {
  var store = sharedStore.state || (sharedStore.state = new WeakMap$1());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var makeBuiltIn_1 = createCommonjsModule(function (module) {





var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;



var enforceInternalState = internalState.enforce;
var getInternalState = internalState.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = functionUncurryThis(''.slice);
var replace = functionUncurryThis(''.replace);
var join = functionUncurryThis([].join);

var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwnProperty_1(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (descriptors) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
      if (descriptors) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwnProperty_1(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');
});

var defineBuiltIn = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min$1(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var push = functionUncurryThis([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwnProperty_1(hiddenKeys, key) && hasOwnProperty_1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

var concat = functionUncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source, exceptions) {
  var keys = ownKeys$1(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis_1;
  } else if (STATIC) {
    target = globalThis_1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis_1[TARGET] && globalThis_1[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(argument) {
  return classofRaw(argument) === 'Array';
};

var $TypeError$6 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$6('Maximum allowed index exceeded');
  return it;
};

var createProperty = function (object, key, value) {
  if (descriptors) objectDefineProperty.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var $Object$3 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$3(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var noop = function () { /* empty */ };
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = functionUncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject$1(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return environmentV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = environmentV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject$1(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
};

var bind = functionUncurryThisClause(functionUncurryThisClause.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var push$1 = functionUncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var length = lengthOfArrayLike(self);
    var boundFunction = functionBindContext(callbackfn, that);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$1(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push$1(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$1(7)
};

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var f$5 = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
  return O;
};

var objectDefineProperties = {
	f: f$5
};

var html = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */








var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

var defineProperty$1 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$1(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $findIndex = arrayIteration.findIndex;


var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);

var $map = arrayIteration.map;


var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var $TypeError$7 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor$2(O, 'length').writable) {
    throw new $TypeError$7('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$8 = TypeError;

var deletePropertyOrThrow = function (O, P) {
  if (!delete O[P]) throw new $TypeError$8('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('splice');

var max$1 = Math.max;
var min$2 = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$2(max$1(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    arraySetLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});

var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!toStringTagSupport) {
  defineBuiltIn(Object.prototype, 'toString', objectToString, { unsafe: true });
}

var mutations = {
  add: function add(state, message) {
    var messages = _toConsumableArray(state.messages);
    messages.push(message);
    Vue$2.set(state, "messages", messages);
  },
  _setAllMessages: function _setAllMessages(state, messages) {
    Vue$2.set(state, "messages", messages);
  },
  _setHistory: function _setHistory(state, history) {
    Vue$2.set(state, "history", history);
  },
  _setResource: function _setResource(state, res) {
    Vue$2.set(state, "resource", res);
  },
  _addToHistory: function _addToHistory(state, message) {
    if (message) {
      var payload = message.payload,
        keyThread = message.key;
      if (payload && keyThread) {
        var history = _objectSpread2(_objectSpread2({}, state.history), {}, _defineProperty({}, keyThread, _objectSpread2({}, message)));
        Vue$2.set(state, "history", history);
      }
    }
  },
  _toggleUserInputArea: function _toggleUserInputArea(state, status) {
    Vue$2.set(state, "showUserInputArea", status);
  },
  _toggleLoginProxyView: function _toggleLoginProxyView(state, status) {
    Vue$2.set(state, "showProxyView", status);
  },
  _prependMessageInCurrentConversation: function _prependMessageInCurrentConversation(state) {
    var previousMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var currentConversationMessages = [previousMessage].concat(_toConsumableArray(state.currentConversationMessages));
    Vue$2.set(state, "currentConversationMessages", currentConversationMessages);
  },
  _pushMessageInCurrentConversation: function _pushMessageInCurrentConversation(state, message) {
    var currentConversationMessages = _toConsumableArray(state.currentConversationMessages);
    // TODO: commented, check why its like this
    /* if (!state.currentConversationMessages) {
      currentConversationMessages = [];
    } */
    currentConversationMessages.push(message);
    Vue$2.set(state, "currentConversationMessages", currentConversationMessages);
  },
  _pushMessageInCurrentConversationPagination: function _pushMessageInCurrentConversationPagination(state, message) {
    var currentConversationMessagesPagination = _toConsumableArray(state.currentConversationMessagesPagination);
    currentConversationMessagesPagination.push(message);
    Vue$2.set(state, "currentConversationMessagesPagination", currentConversationMessagesPagination);
  },
  _pushMessageInCurrentConversationSupportPagination: function _pushMessageInCurrentConversationSupportPagination(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var thread = payload.thread,
      message = payload.message;
    if (thread && message) {
      var currentConversationSupportMessagesPagination = _objectSpread2({}, state.currentConversationSupportMessagesPagination);
      // create if thread do not exist
      if (!currentConversationSupportMessagesPagination.hasOwnProperty(thread)) {
        currentConversationSupportMessagesPagination[thread] = [];
      }
      currentConversationSupportMessagesPagination[thread].push(message);
      Vue$2.set(state, "currentConversationSupportMessagesPagination", currentConversationSupportMessagesPagination);
    }
  },
  _setTimestampMap: function _setTimestampMap(state, args) {
    var map = state.timestampMap;
    var chatKey = Object.keys(args)[0];
    if (!map.hasOwnProperty(chatKey)) {
      Object.assign(map, _objectSpread2(_objectSpread2({}, map), {}, _defineProperty({}, chatKey, args[chatKey])));
    } else {
      map[chatKey] = args[chatKey];
    }
    Vue$2.set(state, "timestampMap", map);
  },
  _setCurrentConversationPreviousMessages: function _setCurrentConversationPreviousMessages(state) {
    var previousMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var currentConversationMessages = [].concat(_toConsumableArray(previousMessages), _toConsumableArray(state.currentConversationMessages));
    Vue$2.set(state, "currentConversationMessages", currentConversationMessages);
  },
  _setCurrentConversationNextMessages: function _setCurrentConversationNextMessages(state) {
    var nextMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var currentConversationMessages = [].concat(_toConsumableArray(state.currentConversationMessages), _toConsumableArray(nextMessages));
    Vue$2.set(state, "currentConversationMessages", currentConversationMessages);
  },
  _setCurrentConversationMessages: function _setCurrentConversationMessages(state) {
    var messages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    Vue$2.set(state, "currentConversationMessages", messages);
  },
  _setCurrentConversationMessagesPagination: function _setCurrentConversationMessagesPagination(state) {
    var messages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    Vue$2.set(state, "currentConversationMessagesPagination", messages);
  },
  _setCurrentConversationSupportMessagesPagination: function _setCurrentConversationSupportMessagesPagination(state) {
    var conversations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Vue$2.set(state, "currentConversationSupportMessagesPagination", conversations);
  },
  _setCurrentConversationPaginationMode: function _setCurrentConversationPaginationMode(state) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    Vue$2.set(state, "currentConversationPaginationMode", mode);
  },
  loggedIn: function loggedIn(state, loginStatus) {
    Vue$2.set(state, "isLogged", loginStatus);
  },
  _toggleActionsMenu: function _toggleActionsMenu(state, params) {
    var args = {
      enabled: params.enabled !== undefined ? params.enabled : true,
      active: params.active !== undefined ? params.active : false
    };
    var actionsMenu = _objectSpread2(_objectSpread2({}, state.actionsMenu), {}, _defineProperty({}, params.index, args));
    Vue$2.set(state, "actionsMenu", actionsMenu);
  },
  _setBackButtonLabel: function _setBackButtonLabel(state, label) {
    Vue$2.set(state, "conversationsBackButtonLabel", label);
  },
  _setConversationsTitle: function _setConversationsTitle(state, title) {
    Vue$2.set(state, "conversationAreaTitle", title);
  },
  _setConversations: function _setConversations(state, conversationsArr) {
    Vue$2.set(state, "conversations", _toConsumableArray(conversationsArr));
  },
  _updateConversation: function _updateConversation(state, args) {
    var _this = this;
    if (!args.old || !args["new"]) return false;
    var matchIndex = state.conversations.findIndex(function (c) {
      _newArrowCheck(this, _this);
      return args.thread && args.thread !== btoa("Will") ? c.thread === args.thread : !c.thread || c.thread === btoa("Will");
    }.bind(this));
    if (matchIndex !== -1) {
      var conversations = _toConsumableArray(state.conversations);
      conversations[matchIndex] = args["new"];
      Vue$2.set(state, "conversations", conversations);
      // console.log(state.conversations);
    }
  },
  _updateConversationClass: function _updateConversationClass(state, args) {
    var _this2 = this;
    var matchIndex = state.conversations.findIndex(function (c) {
      _newArrowCheck(this, _this2);
      return args.thread && args.thread !== btoa("Will") ? c.thread === args.thread : !c.thread || c.thread === btoa("Will");
    }.bind(this));
    var conversations = _toConsumableArray(state.conversations);
    if (matchIndex !== -1) {
      conversations[matchIndex]["class"] = args.newClass;
      conversations[matchIndex].pin_date = Date.now();
      Vue$2.set(state, "conversations", conversations);
    }
  },
  _pushConversation: function _pushConversation(state, conversation) {
    var conversations = _toConsumableArray(state.conversations);
    conversations.push(conversation);
    Vue$2.set(state, "conversations", conversations);
  },
  _popConversation: function _popConversation(state, conversation) {
    var _this3 = this;
    var matchIndex = state.conversations.findIndex(function (c) {
      _newArrowCheck(this, _this3);
      return c.thread === conversation.thread;
    }.bind(this));
    var conversations = _toConsumableArray(state.conversations);
    conversations.splice(matchIndex, 1);
    Vue$2.set(state, "conversations", conversations);
  },
  _setConversationsCounter: function _setConversationsCounter(state) {
    var conversationsCounter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Vue$2.set(state, "conversationsCounter", conversationsCounter);
  },
  _setCurrentChat: function _setCurrentChat(state, chat) {
    Vue$2.set(state, "currentUIChat", chat);
  },
  _setChatHeaderTitle: function _setChatHeaderTitle(state, title) {
    Vue$2.set(state, "currentChatHeaderTitle", title);
  },
  _setChatHeaderIcon: function _setChatHeaderIcon(state, resource) {
    Vue$2.set(state, "currentChatHeaderIcon", resource);
  },
  _setIsConversationHeaderRawHtml: function _setIsConversationHeaderRawHtml(state, toggle) {
    Vue$2.set(state, "isConversationHeaderRawHtml", toggle);
  },
  _setChatAvatarIcon: function _setChatAvatarIcon(state, resource) {
    Vue$2.set(state, "currentAvatarIcon", resource);
  },
  _setAttachmentsUploaderConfig: function _setAttachmentsUploaderConfig(state, config) {
    Vue$2.set(state, "attachmentsUploaderConfig", config);
  },
  _setToggleMetas: function _setToggleMetas(state, conf) {
    Vue$2.set(state, "toggleMeta", conf);
  },
  _setIsInteractionInsertLocation: function _setIsInteractionInsertLocation(state, toggle) {
    Vue$2.set(state, "isInteractionInsertLocation", toggle);
  },
  _setIsLocationModalEnable: function _setIsLocationModalEnable(state, toggle) {
    Vue$2.set(state, "isLocationModalEnable", toggle);
  },
  _setIsInteractionInsertDate: function _setIsInteractionInsertDate(state, toggle) {
    Vue$2.set(state, "isInteractionInsertDate", toggle);
  },
  _setCurrentDatePickerInfo: function _setCurrentDatePickerInfo(state, payload) {
    Vue$2.set(state, "currentDatePickerInfo", payload);
  },
  _setIsInteractionSingleAutocomplete: function _setIsInteractionSingleAutocomplete(state, toggle) {
    Vue$2.set(state, "isInteractionSingleAutocomplete", toggle);
  },
  _setIsInteractionMultipleAutocomplete: function _setIsInteractionMultipleAutocomplete(state, toggle) {
    Vue$2.set(state, "isInteractionMultipleAutocomplete", toggle);
  },
  _setCurrentAutocompleteInfo: function _setCurrentAutocompleteInfo(state, payload) {
    Vue$2.set(state, "currentAutocompleteInfo", payload);
  },
  _setCurrentAutocompleteList: function _setCurrentAutocompleteList(state) {
    var _this4 = this;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    // re-structure choices data for autocomplete
    var choicesData = payload.map(function (item) {
      _newArrowCheck(this, _this4);
      var command = item.command,
        content = item.content;
      var _content = _slicedToArray(content, 1),
        itemContent = _content[0];
      return {
        item: item,
        text: itemContent.text,
        value: command
      };
    }.bind(this));
    Vue$2.set(state, "currentAutocompleteList", choicesData);
  },
  _setShowRestartChatButton: function _setShowRestartChatButton(state, toggle) {
    Vue$2.set(state, "showRestartChatButton", toggle);
  },
  _setModeBeforeSubmit: function _setModeBeforeSubmit(state, payload) {
    Vue$2.set(state, "modeBeforeSubmit", payload);
  },
  _setVisibilityAfterSubmit: function _setVisibilityAfterSubmit(state, payload) {
    Vue$2.set(state, "visibilityAfterSubmit", payload);
  },
  _setBotConfigSettings: function _setBotConfigSettings(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Vue$2.set(state, "botConfigSettings", payload);
  }
};

var ConversationType;
(function (ConversationType) {
  ConversationType["Wfp"] = "wfp";
  ConversationType["Active"] = "active";
  ConversationType["RemoteClosed"] = "remote_closed";
  ConversationType["LocalClosed"] = "local_closed";
  ConversationType["Deleted"] = "deleted";
  ConversationType["Archived"] = "archived";
})(ConversationType || (ConversationType = {}));

var state = {
  messages: [],
  // holds the last message history
  // for each conversation
  // i.e { "spocThread": { stanza, payload, ...}, "supportThread": { stanza, payload, ...} }
  history: {},
  showUserInputArea: true,
  showProxyView: false,
  // holds the actual conversation visible on the user
  // and is mutated with client-side pagination
  currentConversationMessages: [],
  // staging state for the results of the current pagination
  currentConversationMessagesPagination: [],
  // staging state for the results of the current pagination for support
  currentConversationSupportMessagesPagination: {},
  currentConversationPaginationMode: "forward",
  // holds the list of conversation archives
  // i.e. [{ id, title, class, avatar, thread, is_archived}]
  // suprisingly, for spoc conversation, doesnt have id, thread 
  conversations: [],
  // holds the unread count for each thread
  // i.e. { "spocThread": { unread_msg_count }, "supportThread": { unread_msg_count }... }
  conversationsCounter: {},
  timestampMap: {},
  currentUIChat: {
    title: "",
    thread: "",
    "class": ConversationType.LocalClosed
  },
  currentChatHeaderTitle: "",
  currentChatHeaderIcon: "",
  isConversationHeaderRawHtml: false,
  actionsMenu: [],
  isLogged: false,
  loginCreds: {
    user: "",
    password: "",
    host: ""
  },
  proactisvityMap: [],
  currentProactivityContext: "",
  toggleMeta: {},
  conversationAreaTitle: "",
  conversationsBackButtonLabel: "",
  currentAvatarIcon: "",
  isInteractionInsertLocation: false,
  isLocationModalEnable: false,
  // flag that tells if a node is a date node
  isInteractionInsertDate: false,
  // flag that tells if a node is single autocomplete
  isInteractionSingleAutocomplete: false,
  // flag that tells if a node is a multiple autocomplete
  isInteractionMultipleAutocomplete: false,
  // holds the current autocomplete node info
  currentAutocompleteInfo: {},
  // holds the current choices list
  currentAutocompleteList: [],
  // holds the current info about the date node
  currentDatePickerInfo: {},
  showRestartChatButton: true,
  modeBeforeSubmit: "",
  visibilityAfterSubmit: "",
  // holds other specific configs
  // from the wrapper client
  // i.e. labels, etc
  botConfigSettings: {}
};
var namespaced = true;
var chat = {
  namespaced: namespaced,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
};

var getters$1 = {
  instance: function instance(state) {
    return state.xmppInstance;
  },
  messages: function messages(state) {
    return state.messages;
  },
  vcard: function vcard(state) {
    return state.vcard;
  },
  clientOptions: function clientOptions(state) {
    return state.clientOptions;
  },
  genesysErrorsMap: function genesysErrorsMap(state) {
    return state.genesysErrorsMap;
  },
  isXmppQueryArchivePagination: function isXmppQueryArchivePagination(state) {
    return state.isXmppQueryArchivePagination;
  },
  shouldForceQueryArchivePagination: function shouldForceQueryArchivePagination(state) {
    return state.shouldForceQueryArchivePagination;
  },
  isXmppQueryArchive: function isXmppQueryArchive(state) {
    return state.isXmppQueryArchive;
  },
  isXmppQueryArchiveAfter: function isXmppQueryArchiveAfter(state) {
    return state.isXmppQueryArchiveAfter;
  },
  xmppMamPagination: function xmppMamPagination(state) {
    return state.xmppMamPagination;
  }
};

function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}

function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine(u), _regeneratorDefine(u, o, "Generator"), _regeneratorDefine(u, n, function () {
    return this;
  }), _regeneratorDefine(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}

var $String$3 = String;

var toString_1 = function (argument) {
  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$3(argument);
};

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = globalThis_1.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = globalThis_1.RegExp;

var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp$2 = globalThis_1.RegExp;

var regexpUnsupportedNcg = fails(function () {
  var re = $RegExp$2('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */







var getInternalState = internalState.get;



var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = functionUncurryThis(''.charAt);
var indexOf$1 = functionUncurryThis(''.indexOf);
var replace = functionUncurryThis(''.replace);
var stringSlice$1 = functionUncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall(nativeExec, re1, 'a');
  functionCall(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString_1(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = functionCall(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf$1(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$1(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$1(match.input, charsAdded);
        match[0] = stringSlice$1(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

var FunctionPrototype$2 = Function.prototype;
var apply = FunctionPrototype$2.apply;
var call$2 = FunctionPrototype$2.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call$2.bind(apply) : function () {
  return call$2.apply(apply, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points








var SPECIES$2 = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$2] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: functionCall(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: functionCall(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var charAt$1 = functionUncurryThis(''.charAt);
var charCodeAt = functionUncurryThis(''.charCodeAt);
var stringSlice$2 = functionUncurryThis(''.slice);

var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$1(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt$2 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$2(S, index).length : 1);
};

var floor$1 = Math.floor;
var charAt$3 = functionUncurryThis(''.charAt);
var replace$1 = functionUncurryThis(''.replace);
var stringSlice$3 = functionUncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$3(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$3(str, 0, position);
      case "'": return stringSlice$3(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$3(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$1(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$3(ch, 1) : captures[f - 1] + charAt$3(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var $TypeError$9 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = functionCall(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
  throw new $TypeError$9('RegExp#exec called on incompatible receiver');
};

var REPLACE = wellKnownSymbol('replace');
var max$2 = Math.max;
var min$3 = Math.min;
var concat$1 = functionUncurryThis([].concat);
var push$2 = functionUncurryThis([].push);
var stringIndexOf = functionUncurryThis(''.indexOf);
var stringSlice$4 = functionUncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? functionCall(replacer, searchValue, O, replaceValue)
        : functionCall(nativeReplace, toString_1(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString_1(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString_1(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regexpExecAbstract(rx, S);
        if (result === null) break;

        push$2(results, result);
        if (!global) break;

        var matchStr = toString_1(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString_1(result[0]);
        var position = max$2(min$3(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$2(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat$1([matched], captures, position, S);
          if (namedCaptures !== undefined) push$2(replacerArgs, namedCaptures);
          replacement = toString_1(functionApply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$4(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$4(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

var ms = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = ms;
	createDebug.destroy = destroy;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;
		let enableOverride = null;
		let namespacesCache;
		let enabledCache;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: () => {
				if (enableOverride !== null) {
					return enableOverride;
				}
				if (namespacesCache !== createDebug.namespaces) {
					namespacesCache = createDebug.namespaces;
					enabledCache = createDebug.enabled(namespace);
				}

				return enabledCache;
			},
			set: v => {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);
		createDebug.namespaces = namespaces;

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

var common = setup;

var browser = createCommonjsModule(function (module, exports) {
/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (() => {
	let warned = false;

	return () => {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
})();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || (() => {});

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = common(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};
});
browser.formatArgs;
browser.save;
browser.load;
browser.useColors;
browser.storage;
browser.destroy;
browser.colors;
browser.log;

var hasFlag = (flag, argv) => {
	argv = argv || process.argv;
	const prefix = flag.startsWith('-') ? '' : (flag.length === 1 ? '-' : '--');
	const pos = argv.indexOf(prefix + flag);
	const terminatorPos = argv.indexOf('--');
	return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};

const env = process.env;

let forceColor;
if (hasFlag('no-color') ||
	hasFlag('no-colors') ||
	hasFlag('color=false')) {
	forceColor = false;
} else if (hasFlag('color') ||
	hasFlag('colors') ||
	hasFlag('color=true') ||
	hasFlag('color=always')) {
	forceColor = true;
}
if ('FORCE_COLOR' in env) {
	forceColor = env.FORCE_COLOR.length === 0 || parseInt(env.FORCE_COLOR, 10) !== 0;
}

function translateLevel(level) {
	if (level === 0) {
		return false;
	}

	return {
		level,
		hasBasic: true,
		has256: level >= 2,
		has16m: level >= 3
	};
}

function supportsColor(stream) {
	if (forceColor === false) {
		return 0;
	}

	if (hasFlag('color=16m') ||
		hasFlag('color=full') ||
		hasFlag('color=truecolor')) {
		return 3;
	}

	if (hasFlag('color=256')) {
		return 2;
	}

	if (stream && !stream.isTTY && forceColor !== true) {
		return 0;
	}

	const min = forceColor ? 1 : 0;

	if (process.platform === 'win32') {
		// Node.js 7.5.0 is the first version of Node.js to include a patch to
		// libuv that enables 256 color output on Windows. Anything earlier and it
		// won't work. However, here we target Node.js 8 at minimum as it is an LTS
		// release, and Node.js 7 is not. Windows 10 build 10586 is the first Windows
		// release that supports 256 colors. Windows 10 build 14931 is the first release
		// that supports 16m/TrueColor.
		const osRelease = os.release().split('.');
		if (
			Number(process.versions.node.split('.')[0]) >= 8 &&
			Number(osRelease[0]) >= 10 &&
			Number(osRelease[2]) >= 10586
		) {
			return Number(osRelease[2]) >= 14931 ? 3 : 2;
		}

		return 1;
	}

	if ('CI' in env) {
		if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(sign => sign in env) || env.CI_NAME === 'codeship') {
			return 1;
		}

		return min;
	}

	if ('TEAMCITY_VERSION' in env) {
		return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
	}

	if (env.COLORTERM === 'truecolor') {
		return 3;
	}

	if ('TERM_PROGRAM' in env) {
		const version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

		switch (env.TERM_PROGRAM) {
			case 'iTerm.app':
				return version >= 3 ? 3 : 2;
			case 'Apple_Terminal':
				return 2;
			// No default
		}
	}

	if (/-256(color)?$/i.test(env.TERM)) {
		return 2;
	}

	if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
		return 1;
	}

	if ('COLORTERM' in env) {
		return 1;
	}

	if (env.TERM === 'dumb') {
		return min;
	}

	return min;
}

function getSupportLevel(stream) {
	const level = supportsColor(stream);
	return translateLevel(level);
}

var supportsColor_1 = {
	supportsColor: getSupportLevel,
	stdout: getSupportLevel(process.stdout),
	stderr: getSupportLevel(process.stderr)
};

var node = createCommonjsModule(function (module, exports) {
/**
 * Module dependencies.
 */




/**
 * This is the Node.js implementation of `debug()`.
 */

exports.init = init;
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.destroy = util.deprecate(
	() => {},
	'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.'
);

/**
 * Colors.
 */

exports.colors = [6, 2, 3, 4, 5, 1];

try {
	// Optional dependency (as in, doesn't need to be installed, NOT like optionalDependencies in package.json)
	// eslint-disable-next-line import/no-extraneous-dependencies
	const supportsColor = supportsColor_1;

	if (supportsColor && (supportsColor.stderr || supportsColor).level >= 2) {
		exports.colors = [
			20,
			21,
			26,
			27,
			32,
			33,
			38,
			39,
			40,
			41,
			42,
			43,
			44,
			45,
			56,
			57,
			62,
			63,
			68,
			69,
			74,
			75,
			76,
			77,
			78,
			79,
			80,
			81,
			92,
			93,
			98,
			99,
			112,
			113,
			128,
			129,
			134,
			135,
			148,
			149,
			160,
			161,
			162,
			163,
			164,
			165,
			166,
			167,
			168,
			169,
			170,
			171,
			172,
			173,
			178,
			179,
			184,
			185,
			196,
			197,
			198,
			199,
			200,
			201,
			202,
			203,
			204,
			205,
			206,
			207,
			208,
			209,
			214,
			215,
			220,
			221
		];
	}
} catch (error) {
	// Swallow - we only care if `supports-color` is available; it doesn't have to be.
}

/**
 * Build up the default `inspectOpts` object from the environment variables.
 *
 *   $ DEBUG_COLORS=no DEBUG_DEPTH=10 DEBUG_SHOW_HIDDEN=enabled node script.js
 */

exports.inspectOpts = Object.keys(process.env).filter(key => {
	return /^debug_/i.test(key);
}).reduce((obj, key) => {
	// Camel-case
	const prop = key
		.substring(6)
		.toLowerCase()
		.replace(/_([a-z])/g, (_, k) => {
			return k.toUpperCase();
		});

	// Coerce string value into JS value
	let val = process.env[key];
	if (/^(yes|on|true|enabled)$/i.test(val)) {
		val = true;
	} else if (/^(no|off|false|disabled)$/i.test(val)) {
		val = false;
	} else if (val === 'null') {
		val = null;
	} else {
		val = Number(val);
	}

	obj[prop] = val;
	return obj;
}, {});

/**
 * Is stdout a TTY? Colored output is enabled when `true`.
 */

function useColors() {
	return 'colors' in exports.inspectOpts ?
		Boolean(exports.inspectOpts.colors) :
		tty.isatty(process.stderr.fd);
}

/**
 * Adds ANSI color escape codes if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	const {namespace: name, useColors} = this;

	if (useColors) {
		const c = this.color;
		const colorCode = '\u001B[3' + (c < 8 ? c : '8;5;' + c);
		const prefix = `  ${colorCode};1m${name} \u001B[0m`;

		args[0] = prefix + args[0].split('\n').join('\n' + prefix);
		args.push(colorCode + 'm+' + module.exports.humanize(this.diff) + '\u001B[0m');
	} else {
		args[0] = getDate() + name + ' ' + args[0];
	}
}

function getDate() {
	if (exports.inspectOpts.hideDate) {
		return '';
	}
	return new Date().toISOString() + ' ';
}

/**
 * Invokes `util.format()` with the specified arguments and writes to stderr.
 */

function log(...args) {
	return process.stderr.write(util.format(...args) + '\n');
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	if (namespaces) {
		process.env.DEBUG = namespaces;
	} else {
		// If you set a process.env field to null or undefined, it gets cast to the
		// string 'null' or 'undefined'. Just delete instead.
		delete process.env.DEBUG;
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
	return process.env.DEBUG;
}

/**
 * Init logic for `debug` instances.
 *
 * Create a new `inspectOpts` object in case `useColors` is set
 * differently for a particular `debug` instance.
 */

function init(debug) {
	debug.inspectOpts = {};

	const keys = Object.keys(exports.inspectOpts);
	for (let i = 0; i < keys.length; i++) {
		debug.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
	}
}

module.exports = common(exports);

const {formatters} = module.exports;

/**
 * Map %o to `util.inspect()`, all on a single line.
 */

formatters.o = function (v) {
	this.inspectOpts.colors = this.useColors;
	return util.inspect(v, this.inspectOpts)
		.split('\n')
		.map(str => str.trim())
		.join(' ');
};

/**
 * Map %O to `util.inspect()`, allowing multiple lines if needed.
 */

formatters.O = function (v) {
	this.inspectOpts.colors = this.useColors;
	return util.inspect(v, this.inspectOpts);
};
});
node.init;
node.log;
node.formatArgs;
node.save;
node.load;
node.useColors;
node.destroy;
node.colors;
node.inspectOpts;

var src = createCommonjsModule(function (module) {
/**
 * Detect Electron renderer / nwjs process, which is node, but we should
 * treat as a browser.
 */

if (typeof process === 'undefined' || process.type === 'renderer' || process.browser === true || process.__nwjs) {
	module.exports = browser;
} else {
	module.exports = node;
}
});

/**
 * This module provides uniform
 * Shims APIs and globals that are not present in all JS environments,
 * the most common example for Strophe being browser APIs like WebSocket
 * and DOM that don't exist under nodejs.
 *
 * Usually these will be supplied in nodejs by conditionally requiring a
 * NPM module that provides a compatible implementation.
 */

/* global globalThis */

/**
 * WHATWG WebSockets API
 * https://www.w3.org/TR/websockets/
 *
 * Interface to use the web socket protocol
 *
 * Used implementations:
 * - supported browsers: built-in in WebSocket global
 *   https://developer.mozilla.org/en-US/docs/Web/API/WebSocket#Browser_compatibility
 * - nodejs: use standard-compliant 'ws' module
 *   https://www.npmjs.com/package/ws
 */
function getWebSocketImplementation() {
    if (typeof globalThis.WebSocket === 'undefined') {
        try {
            return require('ws');
            // eslint-disable-next-line no-unused-vars
        } catch (e) {
            throw new Error('You must install the "ws" package to use Strophe in nodejs.');
        }
    }
    return globalThis.WebSocket;
}
const WebSocket = getWebSocketImplementation();

/**
 * Retrieves the XMLSerializer implementation for the current environment.
 *
 * In browser environments, it uses the built-in XMLSerializer.
 * In Node.js environments, it attempts to load the 'jsdom' package
 * to create a compatible XMLSerializer.
 */
function getXMLSerializerImplementation() {
    if (typeof globalThis.XMLSerializer === 'undefined') {
        let JSDOM;
        try {
            JSDOM = require('jsdom').JSDOM;
            // eslint-disable-next-line no-unused-vars
        } catch (e) {
            throw new Error('You must install the "ws" package to use Strophe in nodejs.');
        }
        const dom = new JSDOM('');
        return dom.window.XMLSerializer;
    }
    return globalThis.XMLSerializer;
}
const XMLSerializer = getXMLSerializerImplementation();

/**
 * DOMParser
 * https://w3c.github.io/DOM-Parsing/#the-domparser-interface
 *
 * Interface to parse XML strings into Document objects
 *
 * Used implementations:
 * - supported browsers: built-in in DOMParser global
 *   https://developer.mozilla.org/en-US/docs/Web/API/DOMParser#Browser_compatibility
 * - nodejs: use 'jsdom' https://www.npmjs.com/package/jsdom
 */
function getDOMParserImplementation() {
    const DOMParserImplementation = globalThis.DOMParser;
    if (typeof DOMParserImplementation === 'undefined') {
        // NodeJS
        let JSDOM;
        try {
            JSDOM = require('jsdom').JSDOM;
            // eslint-disable-next-line no-unused-vars
        } catch (e) {
            throw new Error('You must install the "jsdom" package to use Strophe in nodejs.');
        }
        const dom = new JSDOM('');
        return dom.window.DOMParser;
    }
    return DOMParserImplementation;
}
const DOMParser$1 = getDOMParserImplementation();

/**
 * Creates a dummy XML DOM document to serve as an element and text node generator.
 *
 * Used implementations:
 *  - browser: use document's createDocument
 * - nodejs: use 'jsdom' https://www.npmjs.com/package/jsdom
 */
function getDummyXMLDOMDocument() {
    if (typeof document === 'undefined') {
        // NodeJS
        let JSDOM;
        try {
            JSDOM = require('jsdom').JSDOM;
            // eslint-disable-next-line no-unused-vars
        } catch (e) {
            throw new Error('You must install the "jsdom" package to use Strophe in nodejs.');
        }
        const dom = new JSDOM('');
        return dom.window.document.implementation.createDocument('jabber:client', 'strophe', null);
    }
    return document.implementation.createDocument('jabber:client', 'strophe', null);
}

var shims = /*#__PURE__*/Object.freeze({
  __proto__: null,
  WebSocket: WebSocket,
  XMLSerializer: XMLSerializer,
  DOMParser: DOMParser$1,
  getDummyXMLDOMDocument: getDummyXMLDOMDocument
});

/**
 * Common namespace constants from the XMPP RFCs and XEPs.
 *
 * @typedef { Object } NS
 * @property {string} NS.HTTPBIND - HTTP BIND namespace from XEP 124.
 * @property {string} NS.BOSH - BOSH namespace from XEP 206.
 * @property {string} NS.CLIENT - Main XMPP client namespace.
 * @property {string} NS.AUTH - Legacy authentication namespace.
 * @property {string} NS.ROSTER - Roster operations namespace.
 * @property {string} NS.PROFILE - Profile namespace.
 * @property {string} NS.DISCO_INFO - Service discovery info namespace from XEP 30.
 * @property {string} NS.DISCO_ITEMS - Service discovery items namespace from XEP 30.
 * @property {string} NS.MUC - Multi-User Chat namespace from XEP 45.
 * @property {string} NS.SASL - XMPP SASL namespace from RFC 3920.
 * @property {string} NS.STREAM - XMPP Streams namespace from RFC 3920.
 * @property {string} NS.BIND - XMPP Binding namespace from RFC 3920 and RFC 6120.
 * @property {string} NS.SESSION - XMPP Session namespace from RFC 3920.
 * @property {string} NS.XHTML_IM - XHTML-IM namespace from XEP 71.
 * @property {string} NS.XHTML - XHTML body namespace from XEP 71.
 * @property {string} NS.STANZAS
 * @property {string} NS.FRAMING
 */
const NS = {
    HTTPBIND: 'http://jabber.org/protocol/httpbind',
    BOSH: 'urn:xmpp:xbosh',
    CLIENT: 'jabber:client',
    SERVER: 'jabber:server',
    AUTH: 'jabber:iq:auth',
    ROSTER: 'jabber:iq:roster',
    PROFILE: 'jabber:iq:profile',
    DISCO_INFO: 'http://jabber.org/protocol/disco#info',
    DISCO_ITEMS: 'http://jabber.org/protocol/disco#items',
    MUC: 'http://jabber.org/protocol/muc',
    SASL: 'urn:ietf:params:xml:ns:xmpp-sasl',
    STREAM: 'http://etherx.jabber.org/streams',
    FRAMING: 'urn:ietf:params:xml:ns:xmpp-framing',
    BIND: 'urn:ietf:params:xml:ns:xmpp-bind',
    SESSION: 'urn:ietf:params:xml:ns:xmpp-session',
    VERSION: 'jabber:iq:version',
    STANZAS: 'urn:ietf:params:xml:ns:xmpp-stanzas',
    XHTML_IM: 'http://jabber.org/protocol/xhtml-im',
    XHTML: 'http://www.w3.org/1999/xhtml',
};

const PARSE_ERROR_NS = 'http://www.w3.org/1999/xhtml';

/**
 * Contains allowed tags, tag attributes, and css properties.
 * Used in the {@link Strophe.createHtml} function to filter incoming html into the allowed XHTML-IM subset.
 * See [XEP-0071](http://xmpp.org/extensions/xep-0071.html#profile-summary) for the list of recommended
 * allowed tags and their attributes.
 */
const XHTML = {
    tags: ['a', 'blockquote', 'br', 'cite', 'em', 'img', 'li', 'ol', 'p', 'span', 'strong', 'ul', 'body'],
    attributes: {
        'a': ['href'],
        'blockquote': ['style'],
        /** @type {never[]} */
        'br': [],
        'cite': ['style'],
        /** @type {never[]} */
        'em': [],
        'img': ['src', 'alt', 'style', 'height', 'width'],
        'li': ['style'],
        'ol': ['style'],
        'p': ['style'],
        'span': ['style'],
        /** @type {never[]} */
        'strong': [],
        'ul': ['style'],
        /** @type {never[]} */
        'body': [],
    },
    css: [
        'background-color',
        'color',
        'font-family',
        'font-size',
        'font-style',
        'font-weight',
        'margin-left',
        'margin-right',
        'text-align',
        'text-decoration',
    ],
};

/** @typedef {number} connstatus */

/**
 * Connection status constants for use by the connection handler
 * callback.
 *
 * @typedef {Object} Status
 * @property {connstatus} Status.ERROR - An error has occurred
 * @property {connstatus} Status.CONNECTING - The connection is currently being made
 * @property {connstatus} Status.CONNFAIL - The connection attempt failed
 * @property {connstatus} Status.AUTHENTICATING - The connection is authenticating
 * @property {connstatus} Status.AUTHFAIL - The authentication attempt failed
 * @property {connstatus} Status.CONNECTED - The connection has succeeded
 * @property {connstatus} Status.DISCONNECTED - The connection has been terminated
 * @property {connstatus} Status.DISCONNECTING - The connection is currently being terminated
 * @property {connstatus} Status.ATTACHED - The connection has been attached
 * @property {connstatus} Status.REDIRECT - The connection has been redirected
 * @property {connstatus} Status.CONNTIMEOUT - The connection has timed out
 * @property {connstatus} Status.BINDREQUIRED - The JID resource needs to be bound for this session
 * @property {connstatus} Status.ATTACHFAIL - Failed to attach to a pre-existing session
 * @property {connstatus} Status.RECONNECTING - Not used by Strophe, but added for integrators
 */
const Status = {
    ERROR: 0,
    CONNECTING: 1,
    CONNFAIL: 2,
    AUTHENTICATING: 3,
    AUTHFAIL: 4,
    CONNECTED: 5,
    DISCONNECTED: 6,
    DISCONNECTING: 7,
    ATTACHED: 8,
    REDIRECT: 9,
    CONNTIMEOUT: 10,
    BINDREQUIRED: 11,
    ATTACHFAIL: 12,
    RECONNECTING: 13,
};

const ErrorCondition = {
    BAD_FORMAT: 'bad-format',
    CONFLICT: 'conflict',
    MISSING_JID_NODE: 'x-strophe-bad-non-anon-jid',
    NO_AUTH_MECH: 'no-auth-mech',
    UNKNOWN_REASON: 'unknown',
};

/**
 * Logging level indicators.
 * @typedef {0|1|2|3|4} LogLevel
 * @typedef {'DEBUG'|'INFO'|'WARN'|'ERROR'|'FATAL'} LogLevelName
 * @typedef {Record<LogLevelName, LogLevel>} LogLevels
 */
const LOG_LEVELS = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    FATAL: 4,
};

/**
 * DOM element types.
 *
 * - ElementType.NORMAL - Normal element.
 * - ElementType.TEXT - Text data element.
 * - ElementType.FRAGMENT - XHTML fragment element.
 */
const ElementType = {
    NORMAL: 1,
    TEXT: 3,
    CDATA: 4,
    FRAGMENT: 11,
};

/**
 * @typedef {import('./constants').LogLevel} LogLevel
 */

let logLevel = LOG_LEVELS.DEBUG;

const log = {
    /**
     * Library consumers can use this function to set the log level of Strophe.
     * The default log level is Strophe.LogLevel.INFO.
     * @param {LogLevel} level
     * @example Strophe.setLogLevel(Strophe.LogLevel.DEBUG);
     */
    setLogLevel(level) {
        if (level < LOG_LEVELS.DEBUG || level > LOG_LEVELS.FATAL) {
            throw new Error("Invalid log level supplied to setLogLevel");
        }
        logLevel = level;
    },

    /**
     *
     * Please note that data sent and received over the wire is logged
     * via {@link Strophe.Connection#rawInput|Strophe.Connection.rawInput()}
     * and {@link Strophe.Connection#rawOutput|Strophe.Connection.rawOutput()}.
     *
     * The different levels and their meanings are
     *
     *   DEBUG - Messages useful for debugging purposes.
     *   INFO - Informational messages.  This is mostly information like
     *     'disconnect was called' or 'SASL auth succeeded'.
     *   WARN - Warnings about potential problems.  This is mostly used
     *     to report transient connection errors like request timeouts.
     *   ERROR - Some error occurred.
     *   FATAL - A non-recoverable fatal error occurred.
     *
     * @param {number} level - The log level of the log message.
     *     This will be one of the values in Strophe.LOG_LEVELS.
     * @param {string} msg - The log message.
     */
    log(level, msg) {
        if (level < logLevel) {
            return;
        }

        if (level >= LOG_LEVELS.ERROR) {
            console?.error(msg);
        } else if (level === LOG_LEVELS.INFO) {
            console?.info(msg);
        } else if (level === LOG_LEVELS.WARN) {
            console?.warn(msg);
        } else if (level === LOG_LEVELS.DEBUG) {
            console?.debug(msg);
        }
    },

    /**
     * Log a message at the Strophe.LOG_LEVELS.DEBUG level.
     * @param {string} msg - The log message.
     */
    debug(msg) {
        this.log(LOG_LEVELS.DEBUG, msg);
    },

    /**
     * Log a message at the Strophe.LOG_LEVELS.INFO level.
     * @param {string} msg - The log message.
     */
    info(msg) {
        this.log(LOG_LEVELS.INFO, msg);
    },

    /**
     * Log a message at the Strophe.LOG_LEVELS.WARN level.
     * @param {string} msg - The log message.
     */
    warn(msg) {
        this.log(LOG_LEVELS.WARN, msg);
    },

    /**
     * Log a message at the Strophe.LOG_LEVELS.ERROR level.
     * @param {string} msg - The log message.
     */
    error(msg) {
        this.log(LOG_LEVELS.ERROR, msg);
    },

    /**
     * Log a message at the Strophe.LOG_LEVELS.FATAL level.
     * @param {string} msg - The log message.
     */
    fatal(msg) {
        this.log(LOG_LEVELS.FATAL, msg);
    },
};

/* global btoa */

/**
 * Takes a string and turns it into an XML Element.
 * @param {string} string
 * @param {boolean} [throwErrorIfInvalidNS]
 * @returns {Element}
 */
function toElement(string, throwErrorIfInvalidNS) {
    const doc = xmlHtmlNode(string);
    const parserError = getParserError(doc);
    if (parserError) {
        throw new Error(`Parser Error: ${parserError}`);
    }

    const node = getFirstElementChild(doc);
    if (
        ['message', 'iq', 'presence'].includes(node.nodeName.toLowerCase()) &&
        node.namespaceURI !== 'jabber:client' &&
        node.namespaceURI !== 'jabber:server'
    ) {
        const err_msg = `Invalid namespaceURI ${node.namespaceURI}`;
        if (throwErrorIfInvalidNS) {
            throw new Error(err_msg);
        } else {
            log.error(err_msg);
        }
    }
    return node;
}

/**
 * Properly logs an error to the console
 * @param {Error} e
 */
function handleError(e) {
    if (typeof e.stack !== 'undefined') {
        log.fatal(e.stack);
    }
    log.fatal('error: ' + e.message);
}

/**
 * @param {string} str
 * @return {string}
 */
function utf16to8(str) {
    let out = '';
    const len = str.length;
    for (let i = 0; i < len; i++) {
        const c = str.charCodeAt(i);
        if (c >= 0x0000 && c <= 0x007f) {
            out += str.charAt(i);
        } else if (c > 0x07ff) {
            out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        } else {
            out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        }
    }
    return out;
}

/**
 * @param {ArrayBufferLike} x
 * @param {ArrayBufferLike} y
 */
function xorArrayBuffers(x, y) {
    const xIntArray = new Uint8Array(x);
    const yIntArray = new Uint8Array(y);
    const zIntArray = new Uint8Array(x.byteLength);
    for (let i = 0; i < x.byteLength; i++) {
        zIntArray[i] = xIntArray[i] ^ yIntArray[i];
    }
    return zIntArray.buffer;
}

/**
 * @param {ArrayBufferLike} buffer
 * @return {string}
 */
function arrayBufToBase64(buffer) {
    // This function is due to mobz (https://stackoverflow.com/users/1234628/mobz)
    // and Emmanuel (https://stackoverflow.com/users/288564/emmanuel)
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}

/**
 * @param {string} str
 * @return {ArrayBufferLike}
 */
function base64ToArrayBuf(str) {
    return Uint8Array.from(atob(str), (c) => c.charCodeAt(0))?.buffer;
}

/**
 * @param {string} str
 * @return {ArrayBufferLike}
 */
function stringToArrayBuf(str) {
    const bytes = new TextEncoder().encode(str);
    return bytes.buffer;
}

/**
 * @param {Cookies} cookies
 */
function addCookies(cookies) {
    if (typeof document === 'undefined') {
        log.error(`addCookies: not adding any cookies, since there's no document object`);
    }

    /**
     * @typedef {Object.<string, string>} Cookie
     *
     * A map of cookie names to string values or to maps of cookie values.
     * @typedef {Cookie|Object.<string, Cookie>} Cookies
     *
     * For example:
     * { "myCookie": "1234" }
     *
     * or:
     * { "myCookie": {
     *    "value": "1234",
     *    "domain": ".example.org",
     *    "path": "/",
     *    "expires": expirationDate
     *    }
     * }
     *
     * These values get passed to {@link Strophe.Connection} via options.cookies
     */
    cookies = cookies || {};
    for (const cookieName in cookies) {
        if (Object.prototype.hasOwnProperty.call(cookies, cookieName)) {
            let expires = '';
            let domain = '';
            let path = '';
            const cookieObj = cookies[cookieName];
            const isObj = typeof cookieObj === 'object';
            const cookieValue = escape(unescape(isObj ? cookieObj.value : cookieObj));
            if (isObj) {
                expires = cookieObj.expires ? ';expires=' + cookieObj.expires : '';
                domain = cookieObj.domain ? ';domain=' + cookieObj.domain : '';
                path = cookieObj.path ? ';path=' + cookieObj.path : '';
            }
            document.cookie = cookieName + '=' + cookieValue + expires + domain + path;
        }
    }
}

/** @type {Document} */
let _xmlGenerator = null;

/**
 * Get the DOM document to generate elements.
 * @return {Document} - The currently used DOM document.
 */
function xmlGenerator() {
    if (!_xmlGenerator) {
        _xmlGenerator = getDummyXMLDOMDocument();
    }
    return _xmlGenerator;
}

/**
 * Creates an XML DOM text node.
 * Provides a cross implementation version of document.createTextNode.
 * @param {string} text - The content of the text node.
 * @return {Text} - A new XML DOM text node.
 */
function xmlTextNode(text) {
    return xmlGenerator().createTextNode(text);
}

/**
 * @param {Element} stanza
 * @return {Element}
 */
function stripWhitespace(stanza) {
    const childNodes = Array.from(stanza.childNodes);
    if (childNodes.length === 1 && childNodes[0].nodeType === ElementType.TEXT) {
        // If the element has only one child and it's a text node, we assume
        // it's significant and don't remove it, even if it's only whitespace.
        return stanza;
    }
    childNodes.forEach((node) => {
        if (node.nodeName.toLowerCase() === 'body') {
            // We don't remove anything inside <body> elements
            return;
        }
        if (node.nodeType === ElementType.TEXT && !(/\S/).test(node.nodeValue)) {
            stanza.removeChild(node);
        } else if (node.nodeType === ElementType.NORMAL) {
            stripWhitespace(/** @type {Element} */ (node));
        }
    });
    return stanza;
}

/**
 * Creates an XML DOM node.
 * @param {string} text - The contents of the XML element.
 * @return {XMLDocument}
 */
function xmlHtmlNode(text) {
    const parser = new DOMParser$1();
    return parser.parseFromString(text, 'text/xml');
}

/**
 * @param {XMLDocument} doc
 * @returns {string|null}
 */
function getParserError(doc) {
    const el =
        doc.firstElementChild?.nodeName === 'parsererror'
            ? doc.firstElementChild
            : doc.getElementsByTagNameNS(PARSE_ERROR_NS, 'parsererror')[0];

    return el?.nodeName === 'parsererror' ? el?.textContent : null;
}

/**
 * @param {XMLDocument} el
 * @returns {Element}
 */
function getFirstElementChild(el) {
    if (el.firstElementChild) return el.firstElementChild;
    let node,
        i = 0;
    const nodes = el.childNodes;

    while ((node = nodes[i++])) {
        if (node.nodeType === 1) return /** @type {Element} */ (node);
    }
    return null;
}

/**
 * Create an XML DOM element.
 *
 * This function creates an XML DOM element correctly across all
 * implementations. Note that these are not HTML DOM elements, which
 * aren't appropriate for XMPP stanzas.
 *
 * @param {string} name - The name for the element.
 * @param {Array<Array<string>>|Object.<string,string|number>|string|number} [attrs]
 *    An optional array or object containing
 *    key/value pairs to use as element attributes.
 *    The object should be in the format `{'key': 'value'}`.
 *    The array should have the format `[['key1', 'value1'], ['key2', 'value2']]`.
 * @param {string|number} [text] - The text child data for the element.
 *
 * @return {Element} A new XML DOM element.
 */
function xmlElement(name, attrs, text) {
    if (!name) return null;

    const node = xmlGenerator().createElement(name);

    if (text && (typeof text === 'string' || typeof text === 'number')) {
        node.appendChild(xmlTextNode(text.toString()));
    } else if (typeof attrs === 'string' || typeof attrs === 'number') {
        node.appendChild(xmlTextNode(/** @type {number|string} */ (attrs).toString()));
        return node;
    }

    if (!attrs) {
        return node;
    } else if (Array.isArray(attrs)) {
        for (const attr of attrs) {
            if (Array.isArray(attr)) {
                // eslint-disable-next-line no-eq-null
                if (attr[0] != null && attr[1] != null) {
                    node.setAttribute(attr[0], attr[1]);
                }
            }
        }
    } else if (typeof attrs === 'object') {
        for (const k of Object.keys(attrs)) {
            // eslint-disable-next-line no-eq-null
            if (k && attrs[k] != null) {
                node.setAttribute(k, attrs[k].toString());
            }
        }
    }

    return node;
}

/**
 * Utility method to determine whether a tag is allowed
 * in the XHTML_IM namespace.
 *
 * XHTML tag names are case sensitive and must be lower case.
 * @method Strophe.XHTML.validTag
 * @param {string} tag
 */
function validTag(tag) {
    for (let i = 0; i < XHTML.tags.length; i++) {
        if (tag === XHTML.tags[i]) {
            return true;
        }
    }
    return false;
}

/**
 * @typedef {'a'|'blockquote'|'br'|'cite'|'em'|'img'|'li'|'ol'|'p'|'span'|'strong'|'ul'|'body'} XHTMLAttrs
 */

/**
 * Utility method to determine whether an attribute is allowed
 * as recommended per XEP-0071
 *
 * XHTML attribute names are case sensitive and must be lower case.
 * @method Strophe.XHTML.validAttribute
 * @param {string} tag
 * @param {string} attribute
 */
function validAttribute(tag, attribute) {
    const attrs = XHTML.attributes[/** @type {XHTMLAttrs} */ (tag)];

    if (attrs?.length > 0) {
        for (let i = 0; i < attrs.length; i++) {
            if (attribute === attrs[i]) {
                return true;
            }
        }
    }
    return false;
}

/**
 * @method Strophe.XHTML.validCSS
 * @param {string} style
 */
function validCSS(style) {
    for (let i = 0; i < XHTML.css.length; i++) {
        if (style === XHTML.css[i]) {
            return true;
        }
    }
    return false;
}

/**
 * Copy an HTML DOM Element into an XML DOM.
 * This function copies a DOM element and all its descendants and returns
 * the new copy.
 * @param {HTMLElement} elem - A DOM element.
 * @return {Node} - A new, copied DOM element tree.
 */
function createFromHtmlElement(elem) {
    let el;
    const tag = elem.nodeName.toLowerCase(); // XHTML tags must be lower case.
    if (validTag(tag)) {
        try {
            el = xmlElement(tag);

            if (tag in XHTML.attributes) {
                const attrs = XHTML.attributes[/** @type {XHTMLAttrs} */ (tag)];

                for (let i = 0; i < attrs.length; i++) {
                    const attribute = attrs[i];
                    let value = elem.getAttribute(attribute);

                    if (typeof value === 'undefined' || value === null || value === '') {
                        continue;
                    }

                    if (attribute === 'style' && typeof value === 'object') {
                        value = /** @type {Object.<'csstext',string>} */ (value).cssText ?? value; // we're dealing with IE, need to get CSS out
                    }

                    // filter out invalid css styles
                    if (attribute === 'style') {
                        const css = [];
                        const cssAttrs = value.split(';');
                        for (let j = 0; j < cssAttrs.length; j++) {
                            const attr = cssAttrs[j].split(':');
                            const cssName = attr[0].replace(/^\s*/, '').replace(/\s*$/, '').toLowerCase();
                            if (validCSS(cssName)) {
                                const cssValue = attr[1].replace(/^\s*/, '').replace(/\s*$/, '');
                                css.push(cssName + ': ' + cssValue);
                            }
                        }
                        if (css.length > 0) {
                            value = css.join('; ');
                            el.setAttribute(attribute, value);
                        }
                    } else {
                        el.setAttribute(attribute, value);
                    }
                }
                for (let i = 0; i < elem.childNodes.length; i++) {
                    el.appendChild(createHtml(elem.childNodes[i]));
                }
            }
        } catch (e) { // eslint-disable-line no-unused-vars
            // invalid elements
            el = xmlTextNode('');
        }
    } else {
        el = xmlGenerator().createDocumentFragment();
        for (let i = 0; i < elem.childNodes.length; i++) {
            el.appendChild(createHtml(elem.childNodes[i]));
        }
    }
    return el;
}

/**
 * Copy an HTML DOM Node into an XML DOM.
 * This function copies a DOM element and all its descendants and returns
 * the new copy.
 * @method Strophe.createHtml
 * @param {Node} node - A DOM element.
 * @return {Node} - A new, copied DOM element tree.
 */
function createHtml(node) {
    if (node.nodeType === ElementType.NORMAL) {
        return createFromHtmlElement(/** @type {HTMLElement} */ (node));
    } else if (node.nodeType === ElementType.FRAGMENT) {
        const el = xmlGenerator().createDocumentFragment();
        for (let i = 0; i < node.childNodes.length; i++) {
            el.appendChild(createHtml(node.childNodes[i]));
        }
        return el;
    } else if (node.nodeType === ElementType.TEXT) {
        return xmlTextNode(node.nodeValue);
    }
}

/**
 * Copy an XML DOM element.
 *
 * This function copies a DOM element and all its descendants and returns
 * the new copy.
 * @method Strophe.copyElement
 * @param {Node} node - A DOM element.
 * @return {Element|Text} - A new, copied DOM element tree.
 */
function copyElement(node) {
    let out;

    if (node.nodeType === ElementType.NORMAL) {
        const el = /** @type {Element} */ (node);
        out = xmlElement(el.tagName);

        for (let i = 0; i < el.attributes.length; i++) {
            out.setAttribute(el.attributes[i].nodeName, el.attributes[i].value);
        }
        for (let i = 0; i < el.childNodes.length; i++) {
            out.appendChild(copyElement(el.childNodes[i]));
        }
    } else if (node.nodeType === ElementType.TEXT) {
        out = xmlGenerator().createTextNode(node.nodeValue);
    }
    return out;
}

/**
 * Excapes invalid xml characters.
 * @method Strophe.xmlescape
 * @param {string} text - text to escape.
 * @return {string} - Escaped text.
 */
function xmlescape(text) {
    text = text.replace(/\&/g, '&amp;');
    text = text.replace(/</g, '&lt;');
    text = text.replace(/>/g, '&gt;');
    text = text.replace(/'/g, '&apos;');
    text = text.replace(/"/g, '&quot;');
    return text;
}

/**
 * Unexcapes invalid xml characters.
 * @method Strophe.xmlunescape
 * @param {string} text - text to unescape.
 * @return {string} - Unescaped text.
 */
function xmlunescape(text) {
    text = text.replace(/\&amp;/g, '&');
    text = text.replace(/&lt;/g, '<');
    text = text.replace(/&gt;/g, '>');
    text = text.replace(/&apos;/g, "'");
    text = text.replace(/&quot;/g, '"');
    return text;
}

/**
 * Map a function over some or all child elements of a given element.
 *
 * This is a small convenience function for mapping a function over
 * some or all of the children of an element.  If elemName is null, all
 * children will be passed to the function, otherwise only children
 * whose tag names match elemName will be passed.
 *
 * @method Strophe.forEachChild
 * @param {Element} elem - The element to operate on.
 * @param {string} elemName - The child element tag name filter.
 * @param {Function} func - The function to apply to each child.  This
 *    function should take a single argument, a DOM element.
 */
function forEachChild(elem, elemName, func) {
    for (let i = 0; i < elem.childNodes.length; i++) {
        const childNode = elem.childNodes[i];
        if (childNode.nodeType === ElementType.NORMAL && (!elemName || this.isTagEqual(childNode, elemName))) {
            func(childNode);
        }
    }
}

/**
 * Compare an element's tag name with a string.
 * This function is case sensitive.
 * @method Strophe.isTagEqual
 * @param {Element} el - A DOM element.
 * @param {string} name - The element name.
 * @return {boolean}
 *  true if the element's tag name matches _el_, and false
 *  otherwise.
 */
function isTagEqual(el, name) {
    return el.tagName === name;
}

/**
 * Get the concatenation of all text children of an element.
 * @method Strophe.getText
 * @param {Element} elem - A DOM element.
 * @return {string} - A String with the concatenated text of all text element children.
 */
function getText(elem) {
    if (!elem) return null;

    let str = '';
    if (!elem.childNodes.length && elem.nodeType === ElementType.TEXT) {
        str += elem.nodeValue;
    }

    for (const child of elem.childNodes) {
        if (child.nodeType === ElementType.TEXT) {
            str += child.nodeValue;
        }
    }
    return xmlescape(str);
}

/**
 * Escape the node part (also called local part) of a JID.
 * @method Strophe.escapeNode
 * @param {string} node - A node (or local part).
 * @return {string} An escaped node (or local part).
 */
function escapeNode(node) {
    if (typeof node !== 'string') {
        return node;
    }
    return node
        .replace(/^\s+|\s+$/g, '')
        .replace(/\\/g, '\\5c')
        .replace(/ /g, '\\20')
        .replace(/\"/g, '\\22')
        .replace(/\&/g, '\\26')
        .replace(/\'/g, '\\27')
        .replace(/\//g, '\\2f')
        .replace(/:/g, '\\3a')
        .replace(/</g, '\\3c')
        .replace(/>/g, '\\3e')
        .replace(/@/g, '\\40');
}

/**
 * Unescape a node part (also called local part) of a JID.
 * @method Strophe.unescapeNode
 * @param {string} node - A node (or local part).
 * @return {string} An unescaped node (or local part).
 */
function unescapeNode(node) {
    if (typeof node !== 'string') {
        return node;
    }
    return node
        .replace(/\\20/g, ' ')
        .replace(/\\22/g, '"')
        .replace(/\\26/g, '&')
        .replace(/\\27/g, "'")
        .replace(/\\2f/g, '/')
        .replace(/\\3a/g, ':')
        .replace(/\\3c/g, '<')
        .replace(/\\3e/g, '>')
        .replace(/\\40/g, '@')
        .replace(/\\5c/g, '\\');
}

/**
 * Get the node portion of a JID String.
 * @method Strophe.getNodeFromJid
 * @param {string} jid - A JID.
 * @return {string} - A String containing the node.
 */
function getNodeFromJid(jid) {
    if (jid.indexOf('@') < 0) {
        return null;
    }
    return jid.split('@')[0];
}

/**
 * Get the domain portion of a JID String.
 * @method Strophe.getDomainFromJid
 * @param {string} jid - A JID.
 * @return {string} - A String containing the domain.
 */
function getDomainFromJid(jid) {
    const bare = getBareJidFromJid(jid);
    if (bare.indexOf('@') < 0) {
        return bare;
    } else {
        const parts = bare.split('@');
        parts.splice(0, 1);
        return parts.join('@');
    }
}

/**
 * Get the resource portion of a JID String.
 * @method Strophe.getResourceFromJid
 * @param {string} jid - A JID.
 * @return {string} - A String containing the resource.
 */
function getResourceFromJid(jid) {
    if (!jid) {
        return null;
    }
    const s = jid.split('/');
    if (s.length < 2) {
        return null;
    }
    s.splice(0, 1);
    return s.join('/');
}

/**
 * Get the bare JID from a JID String.
 * @method Strophe.getBareJidFromJid
 * @param {string} jid - A JID.
 * @return {string} - A String containing the bare JID.
 */
function getBareJidFromJid(jid) {
    return jid ? jid.split('/')[0] : null;
}

const utils = {
    utf16to8,
    xorArrayBuffers,
    arrayBufToBase64,
    base64ToArrayBuf,
    stringToArrayBuf,
    addCookies,
};

var utils$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  toElement: toElement,
  handleError: handleError,
  utf16to8: utf16to8,
  xorArrayBuffers: xorArrayBuffers,
  arrayBufToBase64: arrayBufToBase64,
  base64ToArrayBuf: base64ToArrayBuf,
  stringToArrayBuf: stringToArrayBuf,
  addCookies: addCookies,
  xmlGenerator: xmlGenerator,
  xmlTextNode: xmlTextNode,
  stripWhitespace: stripWhitespace,
  xmlHtmlNode: xmlHtmlNode,
  getParserError: getParserError,
  getFirstElementChild: getFirstElementChild,
  xmlElement: xmlElement,
  validTag: validTag,
  validAttribute: validAttribute,
  validCSS: validCSS,
  createHtml: createHtml,
  copyElement: copyElement,
  xmlescape: xmlescape,
  xmlunescape: xmlunescape,
  forEachChild: forEachChild,
  isTagEqual: isTagEqual,
  getText: getText,
  escapeNode: escapeNode,
  unescapeNode: unescapeNode,
  getNodeFromJid: getNodeFromJid,
  getDomainFromJid: getDomainFromJid,
  getResourceFromJid: getResourceFromJid,
  getBareJidFromJid: getBareJidFromJid,
  'default': utils
});

/**
 * Create a {@link Strophe.Builder}
 * This is an alias for `new Strophe.Builder(name, attrs)`.
 * @param {string} name - The root element name.
 * @param {Object.<string,string|number>} [attrs] - The attributes for the root element in object notation.
 * @return {Builder} A new Strophe.Builder object.
 */
function $build(name, attrs) {
    return new Builder(name, attrs);
}

/**
 * Create a {@link Strophe.Builder} with a `<message/>` element as the root.
 * @param {Object.<string,string>} [attrs] - The <message/> element attributes in object notation.
 * @return {Builder} A new Strophe.Builder object.
 */
function $msg(attrs) {
    return new Builder('message', attrs);
}

/**
 * Create a {@link Strophe.Builder} with an `<iq/>` element as the root.
 * @param {Object.<string,string>} [attrs] - The <iq/> element attributes in object notation.
 * @return {Builder} A new Strophe.Builder object.
 */
function $iq(attrs) {
    return new Builder('iq', attrs);
}

/**
 * Create a {@link Strophe.Builder} with a `<presence/>` element as the root.
 * @param {Object.<string,string>} [attrs] - The <presence/> element attributes in object notation.
 * @return {Builder} A new Strophe.Builder object.
 */
function $pres(attrs) {
    return new Builder('presence', attrs);
}

/**
 * This class provides an interface similar to JQuery but for building
 * DOM elements easily and rapidly.  All the functions except for `toString()`
 * and tree() return the object, so calls can be chained.
 *
 * The corresponding DOM manipulations to get a similar fragment would be
 * a lot more tedious and probably involve several helper variables.
 *
 * Since adding children makes new operations operate on the child, up()
 * is provided to traverse up the tree.  To add two children, do
 * > builder.c('child1', ...).up().c('child2', ...)
 *
 * The next operation on the Builder will be relative to the second child.
 *
 * @example
 *  // Here's an example using the $iq() builder helper.
 *  $iq({to: 'you', from: 'me', type: 'get', id: '1'})
 *      .c('query', {xmlns: 'strophe:example'})
 *      .c('example')
 *      .toString()
 *
 *  // The above generates this XML fragment
 *  //  <iq to='you' from='me' type='get' id='1'>
 *  //    <query xmlns='strophe:example'>
 *  //      <example/>
 *  //    </query>
 *  //  </iq>
 */
class Builder {
    /**
     * @typedef {Object.<string, string|number>} StanzaAttrs
     * @property {string} [StanzaAttrs.xmlns]
     */

    /** @type {Element} */
    #nodeTree;
    /** @type {Element} */
    #node;
    /** @type {string} */
    #name;
    /** @type {StanzaAttrs} */
    #attrs;

    /**
     * The attributes should be passed in object notation.
     * @param {string} name - The name of the root element.
     * @param {StanzaAttrs} [attrs] - The attributes for the root element in object notation.
     * @example const b = new Builder('message', {to: 'you', from: 'me'});
     * @example const b = new Builder('messsage', {'xml:lang': 'en'});
     */
    constructor(name, attrs) {
        // Set correct namespace for jabber:client elements
        if (name === 'presence' || name === 'message' || name === 'iq') {
            if (attrs && !attrs.xmlns) {
                attrs.xmlns = NS.CLIENT;
            } else if (!attrs) {
                attrs = { xmlns: NS.CLIENT };
            }
        }

        this.#name = name;
        this.#attrs = attrs;
    }

    /**
     * Creates a new Builder object from an XML string.
     * @param {string} str
     * @returns {Builder}
     * @example const stanza = Builder.fromString('<presence from="juliet@example.com/chamber"></presence>');
     */
    static fromString(str) {
        const el = toElement(str, true);
        const b = new Builder('');
        b.#nodeTree = el;
        return b;
    }

    buildTree() {
        return xmlElement(this.#name, this.#attrs);
    }

    /** @return {Element} */
    get nodeTree() {
        if (!this.#nodeTree) {
            // Holds the tree being built.
            this.#nodeTree = this.buildTree();
        }
        return this.#nodeTree;
    }

    /** @return {Element} */
    get node() {
        if (!this.#node) {
            this.#node = this.tree();
        }
        return this.#node;
    }

    /** @param {Element} el */
    set node(el) {
        this.#node = el;
    }

    /**
     * Render a DOM element and all descendants to a String.
     * @param {Element|Builder} elem - A DOM element.
     * @return {string} - The serialized element tree as a String.
     */
    static serialize(elem) {
        if (!elem) return null;

        const el = elem instanceof Builder ? elem.tree() : elem;

        const names = [...Array(el.attributes.length).keys()].map((i) => el.attributes[i].nodeName);
        names.sort();
        let result = names.reduce(
            (a, n) => `${a} ${n}="${xmlescape(el.attributes.getNamedItem(n).value)}"`,
            `<${el.nodeName}`
        );

        if (el.childNodes.length > 0) {
            result += '>';
            for (let i = 0; i < el.childNodes.length; i++) {
                const child = el.childNodes[i];
                switch (child.nodeType) {
                    case ElementType.NORMAL:
                        // normal element, so recurse
                        result += Builder.serialize(/** @type {Element} */ (child));
                        break;
                    case ElementType.TEXT:
                        // text element to escape values
                        result += xmlescape(child.nodeValue);
                        break;
                    case ElementType.CDATA:
                        // cdata section so don't escape values
                        result += '<![CDATA[' + child.nodeValue + ']]>';
                }
            }
            result += '</' + el.nodeName + '>';
        } else {
            result += '/>';
        }
        return result;
    }

    /**
     * Return the DOM tree.
     *
     * This function returns the current DOM tree as an element object.  This
     * is suitable for passing to functions like Strophe.Connection.send().
     *
     * @return {Element} The DOM tree as a element object.
     */
    tree() {
        return this.nodeTree;
    }

    /**
     * Serialize the DOM tree to a String.
     *
     * This function returns a string serialization of the current DOM
     * tree.  It is often used internally to pass data to a
     * Strophe.Request object.
     *
     * @return {string} The serialized DOM tree in a String.
     */
    toString() {
        return Builder.serialize(this.tree());
    }

    /**
     * Make the current parent element the new current element.
     * This function is often used after c() to traverse back up the tree.
     *
     * @example
     *  // For example, to add two children to the same element
     *  builder.c('child1', {}).up().c('child2', {});
     *
     * @return {Builder} The Strophe.Builder object.
     */
    up() {
        // Depending on context, parentElement is not always available
        this.node = this.node.parentElement ? this.node.parentElement : /** @type {Element} */ (this.node.parentNode);
        return this;
    }

    /**
     * Make the root element the new current element.
     *
     * When at a deeply nested element in the tree, this function can be used
     * to jump back to the root of the tree, instead of having to repeatedly
     * call up().
     *
     * @return {Builder} The Strophe.Builder object.
     */
    root() {
        this.node = this.tree();
        return this;
    }

    /**
     * Add or modify attributes of the current element.
     *
     * The attributes should be passed in object notation.
     * This function does not move the current element pointer.
     * @param {Object.<string, string|number|null>} moreattrs - The attributes to add/modify in object notation.
     *  If an attribute is set to `null` or `undefined`, it will be removed.
     * @return {Builder} The Strophe.Builder object.
     */
    attrs(moreattrs) {
        for (const k in moreattrs) {
            if (Object.prototype.hasOwnProperty.call(moreattrs, k)) {
                // eslint-disable-next-line no-eq-null
                if (moreattrs[k] != null) {
                    this.node.setAttribute(k, moreattrs[k].toString());
                } else {
                    this.node.removeAttribute(k);
                }
            }
        }
        return this;
    }

    /**
     * Add a child to the current element and make it the new current
     * element.
     *
     * This function moves the current element pointer to the child,
     * unless text is provided.  If you need to add another child, it
     * is necessary to use up() to go back to the parent in the tree.
     *
     * @param {string} name - The name of the child.
     * @param {Object.<string, string>|string} [attrs] - The attributes of the child in object notation.
     * @param {string} [text] - The text to add to the child.
     *
     * @return {Builder} The Strophe.Builder object.
     */
    c(name, attrs, text) {
        const child = xmlElement(name, attrs, text);
        this.node.appendChild(child);
        if (typeof text !== 'string' && typeof text !== 'number') {
            this.node = child;
        }
        return this;
    }

    /**
     * Add a child to the current element and make it the new current
     * element.
     *
     * This function is the same as c() except that instead of using a
     * name and an attributes object to create the child it uses an
     * existing DOM element object.
     *
     * @param {Element|Builder} elem - A DOM element.
     * @return {Builder} The Strophe.Builder object.
     */
    cnode(elem) {
        if (elem instanceof Builder) {
            elem = elem.tree();
        }
        let impNode;
        const xmlGen = xmlGenerator();
        try {
            impNode = xmlGen.importNode !== undefined;
            // eslint-disable-next-line no-unused-vars
        } catch (e) {
            impNode = false;
        }

        const newElem = impNode ? xmlGen.importNode(elem, true) : copyElement(elem);
        this.node.appendChild(newElem);
        this.node = /** @type {Element} */ (newElem);
        return this;
    }

    /**
     * Add a child text element.
     *
     * This *does not* make the child the new current element since there
     * are no children of text elements.
     *
     * @param {string} text - The text data to append to the current element.
     * @return {Builder} The Strophe.Builder object.
     */
    t(text) {
        const child = xmlTextNode(text);
        this.node.appendChild(child);
        return this;
    }

    /**
     * Replace current element contents with the HTML passed in.
     *
     * This *does not* make the child the new current element
     *
     * @param {string} html - The html to insert as contents of current element.
     * @return {Builder} The Strophe.Builder object.
     */
    h(html) {
        const fragment = xmlGenerator().createElement('body');
        // force the browser to try and fix any invalid HTML tags
        fragment.innerHTML = html;
        // copy cleaned html into an xml dom
        const xhtml = createHtml(fragment);
        while (xhtml.childNodes.length > 0) {
            this.node.appendChild(xhtml.childNodes[0]);
        }
        return this;
    }
}

/**
 * _Private_ variable that keeps track of the request ids for connections.
 */
let _requestId = 0;

/**
 * Helper class that provides a cross implementation abstraction
 * for a BOSH related XMLHttpRequest.
 *
 * The Request class is used internally to encapsulate BOSH request
 * information.  It is not meant to be used from user's code.
 *
 * @property {number} id
 * @property {number} sends
 * @property {XMLHttpRequest} xhr
 */
class Request {
    /**
     * Create and initialize a new Request object.
     *
     * @param {Element} elem - The XML data to be sent in the request.
     * @param {Function} func - The function that will be called when the
     *     XMLHttpRequest readyState changes.
     * @param {number} rid - The BOSH rid attribute associated with this request.
     * @param {number} [sends=0] - The number of times this same request has been sent.
     */
    constructor(elem, func, rid, sends = 0) {
        this.id = ++_requestId;
        this.xmlData = elem;
        this.data = Builder.serialize(elem);
        // save original function in case we need to make a new request
        // from this one.
        this.origFunc = func;
        this.func = func;
        this.rid = rid;
        this.date = NaN;
        this.sends = sends;
        this.abort = false;
        this.dead = null;

        this.age = () => (this.date ? (new Date().valueOf() - this.date.valueOf()) / 1000 : 0);
        this.timeDead = () => (this.dead ? (new Date().valueOf() - this.dead.valueOf()) / 1000 : 0);
        this.xhr = this._newXHR();
    }

    /**
     * Get a response from the underlying XMLHttpRequest.
     * This function attempts to get a response from the request and checks
     * for errors.
     * @throws "parsererror" - A parser error occured.
     * @throws "bad-format" - The entity has sent XML that cannot be processed.
     * @return {Element} - The DOM element tree of the response.
     */
    getResponse() {
        const node = this.xhr.responseXML?.documentElement;
        if (node) {
            if (node.tagName === 'parsererror') {
                log.error('invalid response received');
                log.error('responseText: ' + this.xhr.responseText);
                log.error('responseXML: ' + Builder.serialize(node));
                throw new Error('parsererror');
            }
        } else if (this.xhr.responseText) {
            // In Node (with xhr2) or React Native, we may get responseText but no responseXML.
            // We can try to parse it manually.
            log.debug('Got responseText but no responseXML; attempting to parse it with DOMParser...');

            const doc = xmlHtmlNode(this.xhr.responseText);
            const parserError = getParserError(doc);

            if (!doc || parserError) {
                if (parserError) {
                    log.error('invalid response received: ' + parserError);
                    log.error('responseText: ' + this.xhr.responseText);
                }
                const error = new Error();
                error.name = ErrorCondition.BAD_FORMAT;
                throw error;
            }
        }
        return node;
    }

    /**
     * _Private_ helper function to create XMLHttpRequests.
     * This function creates XMLHttpRequests across all implementations.
     * @private
     * @return {XMLHttpRequest}
     */
    _newXHR() {
        const xhr = new XMLHttpRequest();
        if (xhr.overrideMimeType) {
            xhr.overrideMimeType('text/xml; charset=utf-8');
        }
        // use Function.bind() to prepend ourselves as an argument
        xhr.onreadystatechange = this.func.bind(null, this);
        return xhr;
    }
}

/**
 * A JavaScript library to enable BOSH in Strophejs.
 *
 * this library uses Bidirectional-streams Over Synchronous HTTP (BOSH)
 * to emulate a persistent, stateful, two-way connection to an XMPP server.
 * More information on BOSH can be found in XEP 124.
 */

let timeoutMultiplier = 1.1;
let secondaryTimeoutMultiplier = 0.1;

/**
 * _Private_ helper class that handles BOSH Connections
 * The Bosh class is used internally by Connection
 * to encapsulate BOSH sessions. It is not meant to be used from user's code.
 */
class Bosh {
    /**
     * @param {Connection} connection - The Connection that will use BOSH.
     */
    constructor(connection) {
        this._conn = connection;
        /* request id for body tags */
        this.rid = Math.floor(Math.random() * 4294967295);
        /* The current session ID. */
        this.sid = null;

        // default BOSH values
        this.hold = 1;
        this.wait = 60;
        this.window = 5;
        this.errors = 0;
        this.inactivity = null;

        /**
         * BOSH-Connections will have all stanzas wrapped in a <body> tag when
         * passed to {@link Connection#xmlInput|xmlInput()} or {@link Connection#xmlOutput|xmlOutput()}.
         * To strip this tag, User code can set {@link Bosh#strip|strip} to `true`:
         *
         * > // You can set `strip` on the prototype
         * > Bosh.prototype.strip = true;
         *
         * > // Or you can set it on the Bosh instance (which is `._proto` on the connection instance.
         * > const conn = new Connection();
         * > conn._proto.strip = true;
         *
         * This will enable stripping of the body tag in both
         * {@link Connection#xmlInput|xmlInput} and {@link Connection#xmlOutput|xmlOutput}.
         *
         * @property {boolean} [strip=false]
         */
        this.strip = Bosh.prototype.strip ?? false;

        this.lastResponseHeaders = null;
        /** @type {Request[]} */
        this._requests = [];
    }

    /**
     * @param {number} m
     */
    static setTimeoutMultiplier(m) {
        timeoutMultiplier = m;
    }

    /**
     * @returns {number}
     */
    static getTimeoutMultplier() {
        return timeoutMultiplier;
    }

    /**
     * @param {number} m
     */
    static setSecondaryTimeoutMultiplier(m) {
        secondaryTimeoutMultiplier = m;
    }

    /**
     * @returns {number}
     */
    static getSecondaryTimeoutMultplier() {
        return secondaryTimeoutMultiplier;
    }

    /**
     * _Private_ helper function to generate the <body/> wrapper for BOSH.
     * @private
     * @return {Builder} - A Builder with a <body/> element.
     */
    _buildBody() {
        const bodyWrap = $build('body', {
            'rid': this.rid++,
            'xmlns': NS.HTTPBIND,
        });
        if (this.sid !== null) {
            bodyWrap.attrs({ 'sid': this.sid });
        }
        if (this._conn.options.keepalive && this._conn._sessionCachingSupported()) {
            this._cacheSession();
        }
        return bodyWrap;
    }

    /**
     * Reset the connection.
     * This function is called by the reset function of the Connection
     */
    _reset() {
        this.rid = Math.floor(Math.random() * 4294967295);
        this.sid = null;
        this.errors = 0;
        if (this._conn._sessionCachingSupported()) {
            sessionStorage.removeItem('strophe-bosh-session');
        }

        this._conn.nextValidRid(this.rid);
    }

    /**
     * _Private_ function that initializes the BOSH connection.
     * Creates and sends the Request that initializes the BOSH connection.
     * @param {number} wait - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     *     Other settings will require tweaks to the Strophe.TIMEOUT value.
     * @param {number} hold - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param {string} route
     */
    _connect(wait, hold, route) {
        this.wait = wait || this.wait;
        this.hold = hold || this.hold;
        this.errors = 0;

        const body = this._buildBody().attrs({
            'to': this._conn.domain,
            'xml:lang': 'en',
            'wait': this.wait,
            'hold': this.hold,
            'content': 'text/xml; charset=utf-8',
            'ver': '1.6',
            'xmpp:version': '1.0',
            'xmlns:xmpp': NS.BOSH,
        });
        if (route) {
            body.attrs({ route });
        }

        const _connect_cb = this._conn._connect_cb;
        this._requests.push(
            new Request(
                body.tree(),
                this._onRequestStateChange.bind(this, _connect_cb.bind(this._conn)),
                Number(body.tree().getAttribute('rid'))
            )
        );
        this._throttledRequestHandler();
    }

    /**
     * Attach to an already created and authenticated BOSH session.
     *
     * This function is provided to allow Strophe to attach to BOSH
     * sessions which have been created externally, perhaps by a Web
     * application.  This is often used to support auto-login type features
     * without putting user credentials into the page.
     *
     * @param {string} jid - The full JID that is bound by the session.
     * @param {string} sid - The SID of the BOSH session.
     * @param {number} rid - The current RID of the BOSH session.  This RID
     *     will be used by the next request.
     * @param {Function} callback The connect callback function.
     * @param {number} wait - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     *     Other settings will require tweaks to the Strophe.TIMEOUT value.
     * @param {number} hold - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param {number} wind - The optional HTTBIND window value.  This is the
     *     allowed range of request ids that are valid.  The default is 5.
     */
    _attach(jid, sid, rid, callback, wait, hold, wind) {
        this._conn.jid = jid;
        this.sid = sid;
        this.rid = rid;

        this._conn.connect_callback = callback;
        this._conn.domain = getDomainFromJid(this._conn.jid);
        this._conn.authenticated = true;
        this._conn.connected = true;

        this.wait = wait || this.wait;
        this.hold = hold || this.hold;
        this.window = wind || this.window;

        this._conn._changeConnectStatus(Status.ATTACHED, null);
    }

    /**
     * Attempt to restore a cached BOSH session
     *
     * @param {string} jid - The full JID that is bound by the session.
     *     This parameter is optional but recommended, specifically in cases
     *     where prebinded BOSH sessions are used where it's important to know
     *     that the right session is being restored.
     * @param {Function} callback The connect callback function.
     * @param {number} wait - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     *     Other settings will require tweaks to the Strophe.TIMEOUT value.
     * @param {number} hold - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param {number} wind - The optional HTTBIND window value.  This is the
     *     allowed range of request ids that are valid.  The default is 5.
     */
    _restore(jid, callback, wait, hold, wind) {
        const session = JSON.parse(sessionStorage.getItem('strophe-bosh-session'));
        if (
            typeof session !== 'undefined' &&
            session !== null &&
            session.rid &&
            session.sid &&
            session.jid &&
            (typeof jid === 'undefined' ||
                jid === null ||
                getBareJidFromJid(session.jid) === getBareJidFromJid(jid) ||
                // If authcid is null, then it's an anonymous login, so
                // we compare only the domains:
                (getNodeFromJid(jid) === null && getDomainFromJid(session.jid) === jid))
        ) {
            this._conn.restored = true;
            this._attach(session.jid, session.sid, session.rid, callback, wait, hold, wind);
        } else {
            const error = new Error('_restore: no restoreable session.');
            error.name = 'StropheSessionError';
            throw error;
        }
    }

    /**
     * _Private_ handler for the beforeunload event.
     * This handler is used to process the Bosh-part of the initial request.
     * @private
     */
    _cacheSession() {
        if (this._conn.authenticated) {
            if (this._conn.jid && this.rid && this.sid) {
                sessionStorage.setItem(
                    'strophe-bosh-session',
                    JSON.stringify({
                        'jid': this._conn.jid,
                        'rid': this.rid,
                        'sid': this.sid,
                    })
                );
            }
        } else {
            sessionStorage.removeItem('strophe-bosh-session');
        }
    }

    /**
     * _Private_ handler for initial connection request.
     * This handler is used to process the Bosh-part of the initial request.
     * @param {Element} bodyWrap - The received stanza.
     */
    _connect_cb(bodyWrap) {
        const typ = bodyWrap.getAttribute('type');
        if (typ !== null && typ === 'terminate') {
            // an error occurred
            let cond = bodyWrap.getAttribute('condition');
            log.error('BOSH-Connection failed: ' + cond);
            const conflict = bodyWrap.getElementsByTagName('conflict');
            if (cond !== null) {
                if (cond === 'remote-stream-error' && conflict.length > 0) {
                    cond = 'conflict';
                }
                this._conn._changeConnectStatus(Status.CONNFAIL, cond);
            } else {
                this._conn._changeConnectStatus(Status.CONNFAIL, 'unknown');
            }
            this._conn._doDisconnect(cond);
            return Status.CONNFAIL;
        }

        // check to make sure we don't overwrite these if _connect_cb is
        // called multiple times in the case of missing stream:features
        if (!this.sid) {
            this.sid = bodyWrap.getAttribute('sid');
        }
        const wind = bodyWrap.getAttribute('requests');
        if (wind) {
            this.window = parseInt(wind, 10);
        }
        const hold = bodyWrap.getAttribute('hold');
        if (hold) {
            this.hold = parseInt(hold, 10);
        }
        const wait = bodyWrap.getAttribute('wait');
        if (wait) {
            this.wait = parseInt(wait, 10);
        }
        const inactivity = bodyWrap.getAttribute('inactivity');
        if (inactivity) {
            this.inactivity = parseInt(inactivity, 10);
        }
    }

    /**
     * _Private_ part of Connection.disconnect for Bosh
     * @param {Element|Builder} pres - This stanza will be sent before disconnecting.
     */
    _disconnect(pres) {
        this._sendTerminate(pres);
    }

    /**
     * _Private_ function to disconnect.
     * Resets the SID and RID.
     */
    _doDisconnect() {
        this.sid = null;
        this.rid = Math.floor(Math.random() * 4294967295);
        if (this._conn._sessionCachingSupported()) {
            sessionStorage.removeItem('strophe-bosh-session');
        }

        this._conn.nextValidRid(this.rid);
    }

    /**
     * _Private_ function to check if the Request queue is empty.
     * @return {boolean} - True, if there are no Requests queued, False otherwise.
     */
    _emptyQueue() {
        return this._requests.length === 0;
    }

    /**
     * _Private_ function to call error handlers registered for HTTP errors.
     * @private
     * @param {Request} req - The request that is changing readyState.
     */
    _callProtocolErrorHandlers(req) {
        const reqStatus = Bosh._getRequestStatus(req);
        const err_callback = this._conn.protocolErrorHandlers.HTTP[reqStatus];
        if (err_callback) {
            err_callback.call(this, reqStatus);
        }
    }

    /**
     * _Private_ function to handle the error count.
     *
     * Requests are resent automatically until their error count reaches
     * 5.  Each time an error is encountered, this function is called to
     * increment the count and disconnect if the count is too high.
     * @private
     * @param {number} reqStatus - The request status.
     */
    _hitError(reqStatus) {
        this.errors++;
        log.warn('request errored, status: ' + reqStatus + ', number of errors: ' + this.errors);
        if (this.errors > 4) {
            this._conn._onDisconnectTimeout();
        }
    }

    /**
     * @callback connectionCallback
     * @param {Connection} connection
     */

    /**
     * Called on stream start/restart when no stream:features
     * has been received and sends a blank poll request.
     * @param {connectionCallback} callback
     */
    _no_auth_received(callback) {
        log.warn('Server did not yet offer a supported authentication ' + 'mechanism. Sending a blank poll request.');
        if (callback) {
            callback = callback.bind(this._conn);
        } else {
            callback = this._conn._connect_cb.bind(this._conn);
        }
        const body = this._buildBody();
        this._requests.push(
            new Request(
                body.tree(),
                this._onRequestStateChange.bind(this, callback),
                Number(body.tree().getAttribute('rid'))
            )
        );
        this._throttledRequestHandler();
    }

    /**
     * _Private_ timeout handler for handling non-graceful disconnection.
     * Cancels all remaining Requests and clears the queue.
     */
    _onDisconnectTimeout() {
        this._abortAllRequests();
    }

    /**
     * _Private_ helper function that makes sure all pending requests are aborted.
     */
    _abortAllRequests() {
        while (this._requests.length > 0) {
            const req = this._requests.pop();
            req.abort = true;
            req.xhr.abort();
            req.xhr.onreadystatechange = function () {};
        }
    }

    /**
     * _Private_ handler called by {@link Connection#_onIdle|Connection._onIdle()}.
     * Sends all queued Requests or polls with empty Request if there are none.
     */
    _onIdle() {
        const data = this._conn._data;
        // if no requests are in progress, poll
        if (this._conn.authenticated && this._requests.length === 0 && data.length === 0 && !this._conn.disconnecting) {
            log.debug('no requests during idle cycle, sending blank request');
            data.push(null);
        }

        if (this._conn.paused) {
            return;
        }

        if (this._requests.length < 2 && data.length > 0) {
            const body = this._buildBody();
            for (let i = 0; i < data.length; i++) {
                if (data[i] !== null) {
                    if (data[i] === 'restart') {
                        body.attrs({
                            'to': this._conn.domain,
                            'xml:lang': 'en',
                            'xmpp:restart': 'true',
                            'xmlns:xmpp': NS.BOSH,
                        });
                    } else {
                        body.cnode(/** @type {Element} */ (data[i])).up();
                    }
                }
            }
            delete this._conn._data;
            this._conn._data = [];
            this._requests.push(
                new Request(
                    body.tree(),
                    this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)),
                    Number(body.tree().getAttribute('rid'))
                )
            );
            this._throttledRequestHandler();
        }

        if (this._requests.length > 0) {
            const time_elapsed = this._requests[0].age();
            if (this._requests[0].dead !== null) {
                if (this._requests[0].timeDead() > Math.floor(timeoutMultiplier * this.wait)) {
                    this._throttledRequestHandler();
                }
            }
            if (time_elapsed > Math.floor(timeoutMultiplier * this.wait)) {
                log.warn(
                    'Request ' +
                        this._requests[0].id +
                        ' timed out, over ' +
                        Math.floor(timeoutMultiplier * this.wait) +
                        ' seconds since last activity'
                );
                this._throttledRequestHandler();
            }
        }
    }

    /**
     * Returns the HTTP status code from a {@link Request}
     * @private
     * @param {Request} req - The {@link Request} instance.
     * @param {number} [def] - The default value that should be returned if no status value was found.
     */
    static _getRequestStatus(req, def) {
        let reqStatus;
        if (req.xhr.readyState === 4) {
            try {
                reqStatus = req.xhr.status;
            } catch (e) {
                // ignore errors from undefined status attribute. Works
                // around a browser bug
                log.error(
                    `Caught an error while retrieving a request's status, reqStatus: ${reqStatus}, message: ${e.message}`
                );
            }
        }
        if (typeof reqStatus === 'undefined') {
            reqStatus = typeof def === 'number' ? def : 0;
        }
        return reqStatus;
    }

    /**
     * _Private_ handler for {@link Request} state changes.
     *
     * This function is called when the XMLHttpRequest readyState changes.
     * It contains a lot of error handling logic for the many ways that
     * requests can fail, and calls the request callback when requests
     * succeed.
     * @private
     *
     * @param {Function} func - The handler for the request.
     * @param {Request} req - The request that is changing readyState.
     */
    _onRequestStateChange(func, req) {
        log.debug('request id ' + req.id + '.' + req.sends + ' state changed to ' + req.xhr.readyState);
        if (req.abort) {
            req.abort = false;
            return;
        }
        if (req.xhr.readyState !== 4) {
            // The request is not yet complete
            return;
        }
        const reqStatus = Bosh._getRequestStatus(req);
        this.lastResponseHeaders = req.xhr.getAllResponseHeaders();
        if (this._conn.disconnecting && reqStatus >= 400) {
            this._hitError(reqStatus);
            this._callProtocolErrorHandlers(req);
            return;
        }

        const reqIs0 = this._requests[0] === req;
        const reqIs1 = this._requests[1] === req;

        const valid_request = reqStatus > 0 && reqStatus < 500;
        const too_many_retries = req.sends > this._conn.maxRetries;
        if (valid_request || too_many_retries) {
            // remove from internal queue
            this._removeRequest(req);
            log.debug('request id ' + req.id + ' should now be removed');
        }

        if (reqStatus === 200) {
            // request succeeded
            // if request 1 finished, or request 0 finished and request
            // 1 is over _TIMEOUT seconds old, we need to
            // restart the other - both will be in the first spot, as the
            // completed request has been removed from the queue already
            if (
                reqIs1 ||
                (reqIs0 &&
                    this._requests.length > 0 &&
                    this._requests[0].age() > Math.floor(timeoutMultiplier * this.wait))
            ) {
                this._restartRequest(0);
            }
            this._conn.nextValidRid(req.rid + 1);
            log.debug('request id ' + req.id + '.' + req.sends + ' got 200');
            func(req); // call handler
            this.errors = 0;
        } else if (reqStatus === 0 || (reqStatus >= 400 && reqStatus < 600) || reqStatus >= 12000) {
            // request failed
            log.error('request id ' + req.id + '.' + req.sends + ' error ' + reqStatus + ' happened');
            this._hitError(reqStatus);
            this._callProtocolErrorHandlers(req);
            if (reqStatus >= 400 && reqStatus < 500) {
                this._conn._changeConnectStatus(Status.DISCONNECTING, null);
                this._conn._doDisconnect();
            }
        } else {
            log.error('request id ' + req.id + '.' + req.sends + ' error ' + reqStatus + ' happened');
        }

        if (!valid_request && !too_many_retries) {
            this._throttledRequestHandler();
        } else if (too_many_retries && !this._conn.connected) {
            this._conn._changeConnectStatus(Status.CONNFAIL, 'giving-up');
        }
    }

    /**
     * _Private_ function to process a request in the queue.
     *
     * This function takes requests off the queue and sends them and
     * restarts dead requests.
     * @private
     *
     * @param {number} i - The index of the request in the queue.
     */
    _processRequest(i) {
        let req = this._requests[i];
        const reqStatus = Bosh._getRequestStatus(req, -1);

        // make sure we limit the number of retries
        if (req.sends > this._conn.maxRetries) {
            this._conn._onDisconnectTimeout();
            return;
        }
        const time_elapsed = req.age();
        const primary_timeout = !isNaN(time_elapsed) && time_elapsed > Math.floor(timeoutMultiplier * this.wait);
        const secondary_timeout =
            req.dead !== null && req.timeDead() > Math.floor(secondaryTimeoutMultiplier * this.wait);
        const server_error = req.xhr.readyState === 4 && (reqStatus < 1 || reqStatus >= 500);

        if (primary_timeout || secondary_timeout || server_error) {
            if (secondary_timeout) {
                log.error(`Request ${this._requests[i].id} timed out (secondary), restarting`);
            }
            req.abort = true;
            req.xhr.abort();
            // setting to null fails on IE6, so set to empty function
            req.xhr.onreadystatechange = function () {};
            this._requests[i] = new Request(req.xmlData, req.origFunc, req.rid, req.sends);
            req = this._requests[i];
        }

        if (req.xhr.readyState === 0) {
            log.debug('request id ' + req.id + '.' + req.sends + ' posting');

            try {
                const content_type = this._conn.options.contentType || 'text/xml; charset=utf-8';
                req.xhr.open('POST', this._conn.service, this._conn.options.sync ? false : true);
                if (typeof req.xhr.setRequestHeader !== 'undefined') {
                    // IE9 doesn't have setRequestHeader
                    req.xhr.setRequestHeader('Content-Type', content_type);
                }
                if (this._conn.options.withCredentials) {
                    req.xhr.withCredentials = true;
                }
            } catch (e2) {
                log.error('XHR open failed: ' + e2.toString());
                if (!this._conn.connected) {
                    this._conn._changeConnectStatus(Status.CONNFAIL, 'bad-service');
                }
                this._conn.disconnect();
                return;
            }

            // Fires the XHR request -- may be invoked immediately
            // or on a gradually expanding retry window for reconnects
            const sendFunc = () => {
                req.date = new Date().valueOf();
                if (this._conn.options.customHeaders) {
                    const headers = this._conn.options.customHeaders;
                    for (const header in headers) {
                        if (Object.prototype.hasOwnProperty.call(headers, header)) {
                            req.xhr.setRequestHeader(header, headers[header]);
                        }
                    }
                }
                req.xhr.send(req.data);
            };

            // Implement progressive backoff for reconnects --
            // First retry (send === 1) should also be instantaneous
            if (req.sends > 1) {
                // Using a cube of the retry number creates a nicely
                // expanding retry window
                const backoff = Math.min(Math.floor(timeoutMultiplier * this.wait), Math.pow(req.sends, 3)) * 1000;
                setTimeout(function () {
                    // XXX: setTimeout should be called only with function expressions (23974bc1)
                    sendFunc();
                }, backoff);
            } else {
                sendFunc();
            }

            req.sends++;

            if (this.strip && req.xmlData.nodeName === 'body' && req.xmlData.childNodes.length) {
                this._conn.xmlOutput?.(req.xmlData.children[0]);
            } else {
                this._conn.xmlOutput?.(req.xmlData);
            }
            this._conn.rawOutput?.(req.data);
        } else {
            log.debug(
                '_processRequest: ' +
                    (i === 0 ? 'first' : 'second') +
                    ' request has readyState of ' +
                    req.xhr.readyState
            );
        }
    }

    /**
     * _Private_ function to remove a request from the queue.
     * @private
     * @param {Request} req - The request to remove.
     */
    _removeRequest(req) {
        log.debug('removing request');
        for (let i = this._requests.length - 1; i >= 0; i--) {
            if (req === this._requests[i]) {
                this._requests.splice(i, 1);
            }
        }
        // IE6 fails on setting to null, so set to empty function
        req.xhr.onreadystatechange = function () {};
        this._throttledRequestHandler();
    }

    /**
     * _Private_ function to restart a request that is presumed dead.
     * @private
     *
     * @param {number} i - The index of the request in the queue.
     */
    _restartRequest(i) {
        const req = this._requests[i];
        if (req.dead === null) {
            req.dead = new Date();
        }
        this._processRequest(i);
    }

    /**
     * _Private_ function to get a stanza out of a request.
     * Tries to extract a stanza out of a Request Object.
     * When this fails the current connection will be disconnected.
     *
     * @param {Request} req - The Request.
     * @return {Element} - The stanza that was passed.
     */
    _reqToData(req) {
        try {
            return req.getResponse();
        } catch (e) {
            if (e.message !== 'parsererror') {
                throw e;
            }
            this._conn.disconnect('strophe-parsererror');
        }
    }

    /**
     * _Private_ function to send initial disconnect sequence.
     *
     * This is the first step in a graceful disconnect.  It sends
     * the BOSH server a terminate body and includes an unavailable
     * presence if authentication has completed.
     * @private
     * @param {Element|Builder} [pres]
     */
    _sendTerminate(pres) {
        log.debug('_sendTerminate was called');
        const body = this._buildBody().attrs({ type: 'terminate' });

        const el = pres instanceof Builder ? pres.tree() : pres;

        if (pres) {
            body.cnode(el);
        }
        const req = new Request(
            body.tree(),
            this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)),
            Number(body.tree().getAttribute('rid'))
        );
        this._requests.push(req);
        this._throttledRequestHandler();
    }

    /**
     * _Private_ part of the Connection.send function for BOSH
     * Just triggers the RequestHandler to send the messages that are in the queue
     */
    _send() {
        clearTimeout(this._conn._idleTimeout);
        this._throttledRequestHandler();
        this._conn._idleTimeout = setTimeout(() => this._conn._onIdle(), 100);
    }

    /**
     * Send an xmpp:restart stanza.
     */
    _sendRestart() {
        this._throttledRequestHandler();
        clearTimeout(this._conn._idleTimeout);
    }

    /**
     * _Private_ function to throttle requests to the connection window.
     *
     * This function makes sure we don't send requests so fast that the
     * request ids overflow the connection window in the case that one
     * request died.
     * @private
     */
    _throttledRequestHandler() {
        if (!this._requests) {
            log.debug('_throttledRequestHandler called with ' + 'undefined requests');
        } else {
            log.debug('_throttledRequestHandler called with ' + this._requests.length + ' requests');
        }

        if (!this._requests || this._requests.length === 0) {
            return;
        }

        if (this._requests.length > 0) {
            this._processRequest(0);
        }

        if (this._requests.length > 1 && Math.abs(this._requests[0].rid - this._requests[1].rid) < this.window) {
            this._processRequest(1);
        }
    }
}

/**
 * _Private_ helper class for managing stanza handlers.
 *
 * A Handler encapsulates a user provided callback function to be
 * executed when matching stanzas are received by the connection.
 * Handlers can be either one-off or persistant depending on their
 * return value. Returning true will cause a Handler to remain active, and
 * returning false will remove the Handler.
 *
 * Users will not use Handler objects directly, but instead they
 * will use {@link Connection.addHandler} and
 * {@link Connection.deleteHandler}.
 */
class Handler {
    /**
     * @typedef {Object} HandlerOptions
     * @property {boolean} [HandlerOptions.matchBareFromJid]
     * @property {boolean} [HandlerOptions.ignoreNamespaceFragment]
     */

    /**
     * Create and initialize a new Handler.
     *
     * @param {Function} handler - A function to be executed when the handler is run.
     * @param {string} ns - The namespace to match.
     * @param {string} name - The element name to match.
     * @param {string|string[]} type - The stanza type (or types if an array) to match.
     * @param {string} [id] - The element id attribute to match.
     * @param {string} [from] - The element from attribute to match.
     * @param {HandlerOptions} [options] - Handler options
     */
    constructor(handler, ns, name, type, id, from, options) {
        this.handler = handler;
        this.ns = ns;
        this.name = name;
        this.type = type;
        this.id = id;
        this.options = options || { 'matchBareFromJid': false, 'ignoreNamespaceFragment': false };
        if (this.options.matchBareFromJid) {
            this.from = from ? getBareJidFromJid(from) : null;
        } else {
            this.from = from;
        }
        // whether the handler is a user handler or a system handler
        this.user = true;
    }

    /**
     * Returns the XML namespace attribute on an element.
     * If `ignoreNamespaceFragment` was passed in for this handler, then the
     * URL fragment will be stripped.
     * @param {Element} elem - The XML element with the namespace.
     * @return {string} - The namespace, with optionally the fragment stripped.
     */
    getNamespace(elem) {
        let elNamespace = elem.getAttribute('xmlns');
        if (elNamespace && this.options.ignoreNamespaceFragment) {
            elNamespace = elNamespace.split('#')[0];
        }
        return elNamespace;
    }

    /**
     * Tests if a stanza element (or any of its children) matches the
     * namespace set for this Handler.
     * @param {Element} elem - The XML element to test.
     * @return {boolean} - true if the stanza matches and false otherwise.
     */
    namespaceMatch(elem) {
        if (!this.ns || this.getNamespace(elem) === this.ns) {
            return true;
        }
        for (const child of elem.children ?? []) {
            if (this.getNamespace(child) === this.ns) {
                return true;
            } else if (this.namespaceMatch(child)) {
                return true;
            }
        }
        return false;
    }

    /**
     * Tests if a stanza matches the Handler.
     * @param {Element} elem - The XML element to test.
     * @return {boolean} - true if the stanza matches and false otherwise.
     */
    isMatch(elem) {
        let from = elem.getAttribute('from');
        if (this.options.matchBareFromJid) {
            from = getBareJidFromJid(from);
        }
        const elem_type = elem.getAttribute('type');
        if (
            this.namespaceMatch(elem) &&
            (!this.name || isTagEqual(elem, this.name)) &&
            (!this.type ||
                (Array.isArray(this.type) ? this.type.indexOf(elem_type) !== -1 : elem_type === this.type)) &&
            (!this.id || elem.getAttribute('id') === this.id) &&
            (!this.from || from === this.from)
        ) {
            return true;
        }
        return false;
    }

    /**
     * Run the callback on a matching stanza.
     * @param {Element} elem - The DOM element that triggered the Handler.
     * @return {boolean} - A boolean indicating if the handler should remain active.
     */
    run(elem) {
        let result = null;
        try {
            result = this.handler(elem);
        } catch (e) {
            handleError(e);
            throw e;
        }
        return result;
    }

    /**
     * Get a String representation of the Handler object.
     * @return {string}
     */
    toString() {
        return '{Handler: ' + this.handler + '(' + this.name + ',' + this.id + ',' + this.ns + ')}';
    }
}

/**
 * _Private_ helper class for managing timed handlers.
 *
 * A Strophe.TimedHandler encapsulates a user provided callback that
 * should be called after a certain period of time or at regular
 * intervals.  The return value of the callback determines whether the
 * Strophe.TimedHandler will continue to fire.
 *
 * Users will not use Strophe.TimedHandler objects directly, but instead
 * they will use {@link Strophe.Connection#addTimedHandler|addTimedHandler()} and
 * {@link Strophe.Connection#deleteTimedHandler|deleteTimedHandler()}.
 *
 * @memberof Strophe
 */
class TimedHandler {
    /**
     * Create and initialize a new Strophe.TimedHandler object.
     * @param {number} period - The number of milliseconds to wait before the
     *     handler is called.
     * @param {Function} handler - The callback to run when the handler fires.  This
     *     function should take no arguments.
     */
    constructor(period, handler) {
        this.period = period;
        this.handler = handler;
        this.lastCalled = new Date().getTime();
        this.user = true;
    }

    /**
     * Run the callback for the Strophe.TimedHandler.
     *
     * @return {boolean} Returns the result of running the handler,
     *  which is `true` if the Strophe.TimedHandler should be called again,
     *  and `false` otherwise.
     */
    run() {
        this.lastCalled = new Date().getTime();
        return this.handler();
    }

    /**
     * Reset the last called time for the Strophe.TimedHandler.
     */
    reset() {
        this.lastCalled = new Date().getTime();
    }

    /**
     * Get a string representation of the Strophe.TimedHandler object.
     * @return {string}
     */
    toString() {
        return '{TimedHandler: ' + this.handler + '(' + this.period + ')}';
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

/**
 * Encapsulates an SASL authentication mechanism.
 *
 * User code may override the priority for each mechanism or disable it completely.
 * See <priority> for information about changing priority and <test> for informatian on
 * how to disable a mechanism.
 *
 * By default, all mechanisms are enabled and t_he priorities are
 *
 *     SCRAM-SHA-512 - 72
 *     SCRAM-SHA-384 - 71
 *     SCRAM-SHA-256 - 70
 *     SCRAM-SHA-1   - 60
 *     PLAIN         - 50
 *     OAUTHBEARER   - 40
 *     X-OAUTH2      - 30
 *     ANONYMOUS     - 20
 *     EXTERNAL      - 10
 *
 * See: {@link Strophe.Connection#registerSASLMechanisms}
 */
class SASLMechanism {
    /**
     * PrivateConstructor: Strophe.SASLMechanism
     * SASL auth mechanism abstraction.
     * @param {String} [name] - SASL Mechanism name.
     * @param {Boolean} [isClientFirst] - If client should send response first without challenge.
     * @param {Number} [priority] - Priority.
     */
    constructor(name, isClientFirst, priority) {
        /** Mechanism name. */
        this.mechname = name;

        /**
         * If client sends response without initial server challenge.
         */
        this.isClientFirst = isClientFirst;

        /**
         * Determines which {@link SASLMechanism} is chosen for authentication (Higher is better).
         * Users may override this to prioritize mechanisms differently.
         *
         * Example: (This will cause Strophe to choose the mechanism that the server sent first)
         *
         * > Strophe.SASLPlain.priority = Strophe.SASLSHA1.priority;
         *
         * See <SASL mechanisms> for a list of available mechanisms.
         */
        this.priority = priority;
    }

    /**
     * Checks if mechanism able to run.
     * To disable a mechanism, make this return false;
     *
     * To disable plain authentication run
     * > Strophe.SASLPlain.test = function() {
     * >   return false;
     * > }
     *
     * See <SASL mechanisms> for a list of available mechanisms.
     * @param {Connection} connection - Target Connection.
     * @return {boolean} If mechanism was able to run.
     */
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    test(connection) {
        return true;
    }

    /**
     * Called before starting mechanism on some connection.
     * @param {Connection} connection - Target Connection.
     */
    onStart(connection) {
        this._connection = connection;
    }

    /**
     * Called by protocol implementation on incoming challenge.
     *
     * By deafult, if the client is expected to send data first (isClientFirst === true),
     * this method is called with `challenge` as null on the first call,
     * unless `clientChallenge` is overridden in the relevant subclass.
     * @param {Connection} connection - Target Connection.
     * @param {string} [challenge] - current challenge to handle.
     * @return {string|Promise<string|false>} Mechanism response.
     */
    // eslint-disable-next-line no-unused-vars, class-methods-use-this
    onChallenge(connection, challenge) {
        throw new Error('You should implement challenge handling!');
    }

    /**
     * Called by the protocol implementation if the client is expected to send
     * data first in the authentication exchange (i.e. isClientFirst === true).
     * @param {Connection} connection - Target Connection.
     * @return {string|Promise<string|false>} Mechanism response.
     */
    clientChallenge(connection) {
        if (!this.isClientFirst) {
            throw new Error('clientChallenge should not be called if isClientFirst is false!');
        }
        return this.onChallenge(connection);
    }

    /**
     * Protocol informs mechanism implementation about SASL failure.
     */
    onFailure() {
        this._connection = null;
    }

    /**
     * Protocol informs mechanism implementation about SASL success.
     */
    onSuccess() {
        this._connection = null;
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLAnonymous extends SASLMechanism {
    /**
     * SASL ANONYMOUS authentication.
     */
    constructor(mechname = 'ANONYMOUS', isClientFirst = false, priority = 20) {
        super(mechname, isClientFirst, priority);
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    test(connection) {
        return connection.authcid === null;
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLExternal extends SASLMechanism {
    /**
     * SASL EXTERNAL authentication.
     *
     * The EXTERNAL mechanism allows a client to request the server to use
     * credentials established by means external to the mechanism to
     * authenticate the client. The external means may be, for instance,
     * TLS services.
     */
    constructor(mechname = 'EXTERNAL', isClientFirst = true, priority = 10) {
        super(mechname, isClientFirst, priority);
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    onChallenge(connection) {
        /* According to XEP-178, an authzid SHOULD NOT be presented when the
         * authcid contained or implied in the client certificate is the JID (i.e.
         * authzid) with which the user wants to log in as.
         *
         * To NOT send the authzid, the user should therefore set the authcid equal
         * to the JID when instantiating a new Strophe.Connection object.
         */
        return connection.authcid === connection.authzid ? '' : connection.authzid;
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLOAuthBearer extends SASLMechanism {
    /**
     * SASL OAuth Bearer authentication.
     */
    constructor(mechname = 'OAUTHBEARER', isClientFirst = true, priority = 40) {
        super(mechname, isClientFirst, priority);
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    test(connection) {
        return connection.pass !== null;
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    onChallenge(connection) {
        let auth_str = 'n,';
        if (connection.authcid !== null) {
            auth_str = auth_str + 'a=' + connection.authzid;
        }
        auth_str = auth_str + ',';
        auth_str = auth_str + '\u0001';
        auth_str = auth_str + 'auth=Bearer ';
        auth_str = auth_str + connection.pass;
        auth_str = auth_str + '\u0001';
        auth_str = auth_str + '\u0001';
        return utils.utf16to8(auth_str);
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLPlain extends SASLMechanism {
    /**
     * SASL PLAIN authentication.
     */
    constructor(mechname = 'PLAIN', isClientFirst = true, priority = 50) {
        super(mechname, isClientFirst, priority);
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    test(connection) {
        return connection.authcid !== null;
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    onChallenge(connection) {
        const { authcid, authzid, domain, pass } = connection;
        if (!domain) {
            throw new Error('SASLPlain onChallenge: domain is not defined!');
        }
        // Only include authzid if it differs from authcid.
        // See: https://tools.ietf.org/html/rfc6120#section-6.3.8
        let auth_str = authzid !== `${authcid}@${domain}` ? authzid : '';
        auth_str = auth_str + '\u0000';
        auth_str = auth_str + authcid;
        auth_str = auth_str + '\u0000';
        auth_str = auth_str + pass;
        return utils.utf16to8(auth_str);
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

/**
 * @param {string} authMessage
 * @param {ArrayBufferLike} clientKey
 * @param {string} hashName
 */
async function scramClientProof(authMessage, clientKey, hashName) {
    const storedKey = await crypto.subtle.importKey(
        'raw',
        await crypto.subtle.digest(hashName, clientKey),
        { 'name': 'HMAC', 'hash': hashName },
        false,
        ['sign']
    );
    const clientSignature = await crypto.subtle.sign('HMAC', storedKey, utils.stringToArrayBuf(authMessage));

    return utils.xorArrayBuffers(clientKey, clientSignature);
}

/**
 * This function parses the information in a SASL SCRAM challenge response,
 * into an object of the form
 * { nonce: String,
 *   salt:  ArrayBuffer,
 *   iter:  Int
 * }
 * Returns undefined on failure.
 * @param {string} challenge
 */
function scramParseChallenge(challenge) {
    let nonce, salt, iter;
    const attribMatch = /([a-z]+)=([^,]+)(,|$)/;
    while (challenge.match(attribMatch)) {
        const matches = challenge.match(attribMatch);
        challenge = challenge.replace(matches[0], '');
        switch (matches[1]) {
            case 'r':
                nonce = matches[2];
                break;
            case 's':
                salt = utils.base64ToArrayBuf(matches[2]);
                break;
            case 'i':
                iter = parseInt(matches[2], 10);
                break;
            case 'm':
                // Mandatory but unknown extension, per RFC 5802 we should abort
                return undefined;
        }
    }

    // Consider iteration counts less than 4096 insecure, as reccommended by
    // RFC 5802
    if (isNaN(iter) || iter < 4096) {
        log.warn('Failing SCRAM authentication because server supplied iteration count < 4096.');
        return undefined;
    }

    if (!salt) {
        log.warn('Failing SCRAM authentication because server supplied incorrect salt.');
        return undefined;
    }

    return { 'nonce': nonce, 'salt': salt, 'iter': iter };
}

/**
 * Derive the client and server keys given a string password,
 * a hash name, and a bit length.
 * Returns an object of the following form:
 * { ck: ArrayBuffer, the client key
 *   sk: ArrayBuffer, the server key
 * }
 * @param {string} password
 * @param {BufferSource} salt
 * @param {number} iter
 * @param {string} hashName
 * @param {number} hashBits
 */
async function scramDeriveKeys(password, salt, iter, hashName, hashBits) {
    const saltedPasswordBits = await crypto.subtle.deriveBits(
        { 'name': 'PBKDF2', 'salt': salt, 'iterations': iter, 'hash': { 'name': hashName } },
        await crypto.subtle.importKey('raw', utils.stringToArrayBuf(password), 'PBKDF2', false, ['deriveBits']),
        hashBits
    );
    const saltedPassword = await crypto.subtle.importKey(
        'raw',
        saltedPasswordBits,
        { 'name': 'HMAC', 'hash': hashName },
        false,
        ['sign']
    );

    return {
        'ck': await crypto.subtle.sign('HMAC', saltedPassword, utils.stringToArrayBuf('Client Key')),
        'sk': await crypto.subtle.sign('HMAC', saltedPassword, utils.stringToArrayBuf('Server Key')),
    };
}

/**
 * @param {string} authMessage
 * @param {BufferSource} sk
 * @param {string} hashName
 */
async function scramServerSign(authMessage, sk, hashName) {
    const serverKey = await crypto.subtle.importKey('raw', sk, { 'name': 'HMAC', 'hash': hashName }, false, ['sign']);

    return crypto.subtle.sign('HMAC', serverKey, utils.stringToArrayBuf(authMessage));
}

/**
 * Generate an ASCII nonce (not containing the ',' character)
 * @return {string}
 */
function generate_cnonce() {
    // generate 16 random bytes of nonce, base64 encoded
    const bytes = new Uint8Array(16);
    return utils.arrayBufToBase64(crypto.getRandomValues(bytes).buffer);
}

/**
 * @typedef {Object} Password
 * @property {string} Password.name
 * @property {string} Password.ck
 * @property {string} Password.sk
 * @property {number} Password.iter
 * @property {string} salt
 */

const scram = {
    /**
     * On success, sets
     * connection_sasl_data["server-signature"]
     * and
     * connection._sasl_data.keys
     *
     * The server signature should be verified after this function completes..
     *
     * On failure, returns connection._sasl_failure_cb();
     * @param {Connection} connection
     * @param {string} challenge
     * @param {string} hashName
     * @param {number} hashBits
     */
    async scramResponse(connection, challenge, hashName, hashBits) {
        const cnonce = connection._sasl_data.cnonce;
        const challengeData = scramParseChallenge(challenge);

        // The RFC requires that we verify the (server) nonce has the client
        // nonce as an initial substring.
        if (!challengeData && challengeData?.nonce.slice(0, cnonce.length) !== cnonce) {
            log.warn('Failing SCRAM authentication because server supplied incorrect nonce.');
            connection._sasl_data = {};
            return connection._sasl_failure_cb();
        }

        let clientKey, serverKey;

        const { pass } = connection;

        if (typeof connection.pass === 'string' || connection.pass instanceof String) {
            const keys = await scramDeriveKeys(
                /** @type {string} */ (pass),
                challengeData.salt,
                challengeData.iter,
                hashName,
                hashBits
            );
            clientKey = keys.ck;
            serverKey = keys.sk;
        } else if (
            // Either restore the client key and server key passed in, or derive new ones
            /** @type {Password} */ (pass)?.name === hashName &&
            /** @type {Password} */ (pass)?.salt === utils.arrayBufToBase64(challengeData.salt) &&
            /** @type {Password} */ (pass)?.iter === challengeData.iter
        ) {
            const { ck, sk } = /** @type {Password} */ (pass);
            clientKey = utils.base64ToArrayBuf(ck);
            serverKey = utils.base64ToArrayBuf(sk);
        } else {
            return connection._sasl_failure_cb();
        }

        const clientFirstMessageBare = connection._sasl_data['client-first-message-bare'];
        const serverFirstMessage = challenge;
        const clientFinalMessageBare = `c=biws,r=${challengeData.nonce}`;

        const authMessage = `${clientFirstMessageBare},${serverFirstMessage},${clientFinalMessageBare}`;

        const clientProof = await scramClientProof(authMessage, clientKey, hashName);
        const serverSignature = await scramServerSign(authMessage, serverKey, hashName);

        connection._sasl_data['server-signature'] = utils.arrayBufToBase64(serverSignature);
        connection._sasl_data.keys = {
            'name': hashName,
            'iter': challengeData.iter,
            'salt': utils.arrayBufToBase64(challengeData.salt),
            'ck': utils.arrayBufToBase64(clientKey),
            'sk': utils.arrayBufToBase64(serverKey),
        };

        return `${clientFinalMessageBare},p=${utils.arrayBufToBase64(clientProof)}`;
    },

    /**
     * Returns a string containing the client first message
     * @param {Connection} connection
     * @param {string} test_cnonce
     */
    clientChallenge(connection, test_cnonce) {
        const cnonce = test_cnonce || generate_cnonce();
        const client_first_message_bare = `n=${connection.authcid},r=${cnonce}`;
        connection._sasl_data.cnonce = cnonce;
        connection._sasl_data['client-first-message-bare'] = client_first_message_bare;
        return `n,,${client_first_message_bare}`;
    },
};

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLSHA1 extends SASLMechanism {
    /**
     * SASL SCRAM SHA 1 authentication.
     */
    constructor(mechname = 'SCRAM-SHA-1', isClientFirst = true, priority = 60) {
        super(mechname, isClientFirst, priority);
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    test(connection) {
        return connection.authcid !== null;
    }

    /**
     * @param {Connection} connection
     * @param {string} [challenge]
     * @return {Promise<string|false>} Mechanism response.
     */
    // eslint-disable-next-line class-methods-use-this
    async onChallenge(connection, challenge) {
        return await scram.scramResponse(connection, challenge, 'SHA-1', 160);
    }

    /**
     * @param {Connection} connection
     * @param {string} [test_cnonce]
     */
    // eslint-disable-next-line class-methods-use-this
    clientChallenge(connection, test_cnonce) {
        return scram.clientChallenge(connection, test_cnonce);
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLSHA256 extends SASLMechanism {
    /**
     * SASL SCRAM SHA 256 authentication.
     */
    constructor(mechname = 'SCRAM-SHA-256', isClientFirst = true, priority = 70) {
        super(mechname, isClientFirst, priority);
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    test(connection) {
        return connection.authcid !== null;
    }

    /**
     * @param {Connection} connection
     * @param {string} [challenge]
     */
    // eslint-disable-next-line class-methods-use-this
    async onChallenge(connection, challenge) {
        return await scram.scramResponse(connection, challenge, 'SHA-256', 256);
    }

    /**
     * @param {Connection} connection
     * @param {string} [test_cnonce]
     */
    // eslint-disable-next-line class-methods-use-this
    clientChallenge(connection, test_cnonce) {
        return scram.clientChallenge(connection, test_cnonce);
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLSHA384 extends SASLMechanism {
    /**
     * SASL SCRAM SHA 384 authentication.
     */
    constructor(mechname = 'SCRAM-SHA-384', isClientFirst = true, priority = 71) {
        super(mechname, isClientFirst, priority);
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    test(connection) {
        return connection.authcid !== null;
    }

    /**
     * @param {Connection} connection
     * @param {string} [challenge]
     */
    // eslint-disable-next-line class-methods-use-this
    async onChallenge(connection, challenge) {
        return await scram.scramResponse(connection, challenge, 'SHA-384', 384);
    }

    /**
     * @param {Connection} connection
     * @param {string} [test_cnonce]
     */
    // eslint-disable-next-line class-methods-use-this
    clientChallenge(connection, test_cnonce) {
        return scram.clientChallenge(connection, test_cnonce);
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLSHA512 extends SASLMechanism {
    /**
     * SASL SCRAM SHA 512 authentication.
     */
    constructor(mechname = 'SCRAM-SHA-512', isClientFirst = true, priority = 72) {
        super(mechname, isClientFirst, priority);
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    test(connection) {
        return connection.authcid !== null;
    }

    /**
     * @param {Connection} connection
     * @param {string} [challenge]
     */
    // eslint-disable-next-line class-methods-use-this
    async onChallenge(connection, challenge) {
        return await scram.scramResponse(connection, challenge, 'SHA-512', 512);
    }

    /**
     * @param {Connection} connection
     * @param {string} [test_cnonce]
     */
    // eslint-disable-next-line class-methods-use-this
    clientChallenge(connection, test_cnonce) {
        return scram.clientChallenge(connection, test_cnonce);
    }
}

/**
 * @typedef {import("./connection.js").default} Connection
 */

class SASLXOAuth2 extends SASLMechanism {
    /**
     * SASL X-OAuth2 authentication.
     */
    constructor(mechname = 'X-OAUTH2', isClientFirst = true, priority = 30) {
        super(mechname, isClientFirst, priority);
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    test(connection) {
        return connection.pass !== null;
    }

    /**
     * @param {Connection} connection
     */
    // eslint-disable-next-line class-methods-use-this
    onChallenge(connection) {
        let auth_str = '\u0000';
        if (connection.authcid !== null) {
            auth_str = auth_str + connection.authzid;
        }
        auth_str = auth_str + '\u0000';
        auth_str = auth_str + connection.pass;
        return utils.utf16to8(auth_str);
    }
}

class SessionError extends Error {
    /**
     * @param {string} message
     */
    constructor(message) {
        super(message);
        this.name = 'StropheSessionError';
    }
}

/**
 * A JavaScript library to enable XMPP over Websocket in Strophejs.
 *
 * This file implements XMPP over WebSockets for Strophejs.
 * If a Connection is established with a Websocket url (ws://...)
 * Strophe will use WebSockets.
 * For more information on XMPP-over-WebSocket see RFC 7395:
 * http://tools.ietf.org/html/rfc7395
 *
 * WebSocket support implemented by Andreas Guth (andreas.guth@rwth-aachen.de)
 */

/**
 * Helper class that handles WebSocket Connections
 *
 * The WebSocket class is used internally by Connection
 * to encapsulate WebSocket sessions. It is not meant to be used from user's code.
 */
class Websocket {
    /**
     * Create and initialize a WebSocket object.
     * Currently only sets the connection Object.
     * @param {Connection} connection - The Connection that will use WebSockets.
     */
    constructor(connection) {
        this._conn = connection;
        this.strip = 'wrapper';

        const service = connection.service;
        if (service.indexOf('ws:') !== 0 && service.indexOf('wss:') !== 0) {
            // If the service is not an absolute URL, assume it is a path and put the absolute
            // URL together from options, current URL and the path.
            let new_service = '';
            if (connection.options.protocol === 'ws' && location.protocol !== 'https:') {
                new_service += 'ws';
            } else {
                new_service += 'wss';
            }

            new_service += '://' + location.host;
            if (service.indexOf('/') !== 0) {
                new_service += location.pathname + service;
            } else {
                new_service += service;
            }
            connection.service = new_service;
        }
    }

    /**
     * _Private_ helper function to generate the <stream> start tag for WebSockets
     * @private
     * @return {Builder} - A Builder with a <stream> element.
     */
    _buildStream() {
        return $build('open', {
            'xmlns': NS.FRAMING,
            'to': this._conn.domain,
            'version': '1.0',
        });
    }

    /**
     * _Private_ checks a message for stream:error
     * @private
     * @param {Element} bodyWrap - The received stanza.
     * @param {number} connectstatus - The ConnectStatus that will be set on error.
     * @return {boolean} - true if there was a streamerror, false otherwise.
     */
    _checkStreamError(bodyWrap, connectstatus) {
        let errors;
        if (bodyWrap.getElementsByTagNameNS) {
            errors = bodyWrap.getElementsByTagNameNS(NS.STREAM, 'error');
        } else {
            errors = bodyWrap.getElementsByTagName('stream:error');
        }
        if (errors.length === 0) {
            return false;
        }

        const error = errors[0];

        let condition = '';
        let text = '';

        const ns = 'urn:ietf:params:xml:ns:xmpp-streams';
        for (let i = 0; i < error.childNodes.length; i++) {
            const e = error.childNodes[i];
            if (e.nodeType === e.ELEMENT_NODE) {
                /** @type {Element} */
                const el = /** @type {any} */ (e);
                if (el.getAttribute('xmlns') !== ns) {
                    break;
                }
            }
            if (e.nodeName === 'text') {
                text = e.textContent;
            } else {
                condition = e.nodeName;
            }
        }

        let errorString = 'WebSocket stream error: ';
        if (condition) {
            errorString += condition;
        } else {
            errorString += 'unknown';
        }
        if (text) {
            errorString += ' - ' + text;
        }
        log.error(errorString);

        // close the connection on stream_error
        this._conn._changeConnectStatus(connectstatus, condition);
        this._conn._doDisconnect();
        return true;
    }

    /**
     * Reset the connection.
     *
     * This function is called by the reset function of the Strophe Connection.
     * Is not needed by WebSockets.
     */
    // eslint-disable-next-line class-methods-use-this
    _reset() {
        return;
    }

    /**
     * _Private_ function called by Connection.connect
     *
     * Creates a WebSocket for a connection and assigns Callbacks to it.
     * Does nothing if there already is a WebSocket.
     */
    _connect() {
        // Ensure that there is no open WebSocket from a previous Connection.
        this._closeSocket();

        /**
         * @typedef {Object} WebsocketLike
         * @property {(str: string) => void} WebsocketLike.send
         * @property {function(): void} WebsocketLike.close
         * @property {function(): void} WebsocketLike.onopen
         * @property {(e: ErrorEvent) => void} WebsocketLike.onerror
         * @property {(e: CloseEvent) => void} WebsocketLike.onclose
         * @property {(message: MessageEvent) => void} WebsocketLike.onmessage
         * @property {string} WebsocketLike.readyState
         */

        /** @type {import('ws')|WebSocket|WebsocketLike} */
        this.socket = new WebSocket(this._conn.service, 'xmpp');
        this.socket.onopen = () => this._onOpen();
        /** @param {ErrorEvent} e */
        this.socket.onerror = (e) => this._onError(e);
        /** @param {CloseEvent} e */
        this.socket.onclose = (e) => this._onClose(e);
        /**
         * Gets replaced with this._onMessage once _onInitialMessage is called
         * @param {MessageEvent} message
         */
        this.socket.onmessage = (message) => this._onInitialMessage(message);
    }

    /**
     * _Private_ function called by Connection._connect_cb
     * checks for stream:error
     * @param {Element} bodyWrap - The received stanza.
     */
    _connect_cb(bodyWrap) {
        const error = this._checkStreamError(bodyWrap, Status.CONNFAIL);
        if (error) {
            return Status.CONNFAIL;
        }
    }

    /**
     * _Private_ function that checks the opening <open /> tag for errors.
     *
     * Disconnects if there is an error and returns false, true otherwise.
     * @private
     * @param {Element} message - Stanza containing the <open /> tag.
     */
    _handleStreamStart(message) {
        let error = null;

        // Check for errors in the <open /> tag
        const ns = message.getAttribute('xmlns');
        if (typeof ns !== 'string') {
            error = 'Missing xmlns in <open />';
        } else if (ns !== NS.FRAMING) {
            error = 'Wrong xmlns in <open />: ' + ns;
        }

        const ver = message.getAttribute('version');
        if (typeof ver !== 'string') {
            error = 'Missing version in <open />';
        } else if (ver !== '1.0') {
            error = 'Wrong version in <open />: ' + ver;
        }

        if (error) {
            this._conn._changeConnectStatus(Status.CONNFAIL, error);
            this._conn._doDisconnect();
            return false;
        }
        return true;
    }

    /**
     * _Private_ function that handles the first connection messages.
     *
     * On receiving an opening stream tag this callback replaces itself with the real
     * message handler. On receiving a stream error the connection is terminated.
     * @param {MessageEvent} message
     */
    _onInitialMessage(message) {
        if (message.data.indexOf('<open ') === 0 || message.data.indexOf('<?xml') === 0) {
            // Strip the XML Declaration, if there is one
            const data = message.data.replace(/^(<\?.*?\?>\s*)*/, '');
            if (data === '') return;

            const streamStart = new DOMParser$1().parseFromString(data, 'text/xml').documentElement;
            this._conn.xmlInput(streamStart);
            this._conn.rawInput(message.data);

            //_handleStreamSteart will check for XML errors and disconnect on error
            if (this._handleStreamStart(streamStart)) {
                //_connect_cb will check for stream:error and disconnect on error
                this._connect_cb(streamStart);
            }
        } else if (message.data.indexOf('<close ') === 0) {
            // <close xmlns="urn:ietf:params:xml:ns:xmpp-framing />
            // Parse the raw string to an XML element
            const parsedMessage = new DOMParser$1().parseFromString(message.data, 'text/xml').documentElement;
            // Report this input to the raw and xml handlers
            this._conn.xmlInput(parsedMessage);
            this._conn.rawInput(message.data);
            const see_uri = parsedMessage.getAttribute('see-other-uri');
            if (see_uri) {
                const service = this._conn.service;
                // Valid scenarios: WSS->WSS, WS->ANY
                const isSecureRedirect =
                    (service.indexOf('wss:') >= 0 && see_uri.indexOf('wss:') >= 0) || service.indexOf('ws:') >= 0;
                if (isSecureRedirect) {
                    this._conn._changeConnectStatus(
                        Status.REDIRECT,
                        'Received see-other-uri, resetting connection'
                    );
                    this._conn.reset();
                    this._conn.service = see_uri;
                    this._connect();
                }
            } else {
                this._conn._changeConnectStatus(Status.CONNFAIL, 'Received closing stream');
                this._conn._doDisconnect();
            }
        } else {
            this._replaceMessageHandler();
            const string = this._streamWrap(message.data);
            const elem = new DOMParser$1().parseFromString(string, 'text/xml').documentElement;
            this._conn._connect_cb(elem, null, message.data);
        }
    }

    /**
     * Called by _onInitialMessage in order to replace itself with the general message handler.
     * This method is overridden by WorkerWebsocket, which manages a
     * websocket connection via a service worker and doesn't have direct access
     * to the socket.
     */
    _replaceMessageHandler() {
        /** @param {MessageEvent} m */
        this.socket.onmessage = (m) => this._onMessage(m);
    }

    /**
     * _Private_ function called by Connection.disconnect
     * Disconnects and sends a last stanza if one is given
     * @param {Element|Builder} [pres] - This stanza will be sent before disconnecting.
     */
    _disconnect(pres) {
        if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
            if (pres) {
                this._conn.send(pres);
            }
            const close = $build('close', { 'xmlns': NS.FRAMING });
            this._conn.xmlOutput(close.tree());
            const closeString = Builder.serialize(close);
            this._conn.rawOutput(closeString);
            try {
                this.socket.send(closeString);
            } catch (e) {
                log.warn(`Couldn't send <close /> tag. "${e.message}"`);
            }
        }
        setTimeout(() => this._conn._doDisconnect(), 0);
    }

    /**
     * _Private_ function to disconnect.
     * Just closes the Socket for WebSockets
     */
    _doDisconnect() {
        log.debug('WebSockets _doDisconnect was called');
        this._closeSocket();
    }

    /**
     * PrivateFunction _streamWrap
     * _Private_ helper function to wrap a stanza in a <stream> tag.
     * This is used so Strophe can process stanzas from WebSockets like BOSH
     * @param {string} stanza
     */
    // eslint-disable-next-line class-methods-use-this
    _streamWrap(stanza) {
        return '<wrapper>' + stanza + '</wrapper>';
    }

    /**
     * _Private_ function to close the WebSocket.
     *
     * Closes the socket if it is still open and deletes it
     */
    _closeSocket() {
        if (this.socket) {
            try {
                this.socket.onclose = null;
                this.socket.onerror = null;
                this.socket.onmessage = null;
                this.socket.close();
            } catch (e) {
                log.debug(e.message);
            }
        }
        this.socket = null;
    }

    /**
     * _Private_ function to check if the message queue is empty.
     * @return {true} - True, because WebSocket messages are send immediately after queueing.
     */
    // eslint-disable-next-line class-methods-use-this
    _emptyQueue() {
        return true;
    }

    /**
     * _Private_ function to handle websockets closing.
     * @param {CloseEvent} [e]
     */
    _onClose(e) {
        if (this._conn.connected && !this._conn.disconnecting) {
            log.error('Websocket closed unexpectedly');
            this._conn._doDisconnect();
        } else if (e && e.code === 1006 && !this._conn.connected && this.socket) {
            // in case the onError callback was not called (Safari 10 does not
            // call onerror when the initial connection fails) we need to
            // dispatch a CONNFAIL status update to be consistent with the
            // behavior on other browsers.
            log.error('Websocket closed unexcectedly');
            this._conn._changeConnectStatus(
                Status.CONNFAIL,
                'The WebSocket connection could not be established or was disconnected.'
            );
            this._conn._doDisconnect();
        } else {
            log.debug('Websocket closed');
        }
    }

    /**
     * @callback connectionCallback
     * @param {Connection} connection
     */

    /**
     * Called on stream start/restart when no stream:features
     * has been received.
     * @param {connectionCallback} callback
     */
    _no_auth_received(callback) {
        log.error('Server did not offer a supported authentication mechanism');
        this._conn._changeConnectStatus(Status.CONNFAIL, ErrorCondition.NO_AUTH_MECH);
        callback?.call(this._conn);
        this._conn._doDisconnect();
    }

    /**
     * _Private_ timeout handler for handling non-graceful disconnection.
     *
     * This does nothing for WebSockets
     */
    _onDisconnectTimeout() {} // eslint-disable-line class-methods-use-this

    /**
     * _Private_ helper function that makes sure all pending requests are aborted.
     */
    _abortAllRequests() {} // eslint-disable-line class-methods-use-this

    /**
     * _Private_ function to handle websockets errors.
     * @param {Object} error - The websocket error.
     */
    _onError(error) {
        log.error('Websocket error ' + JSON.stringify(error));
        this._conn._changeConnectStatus(
            Status.CONNFAIL,
            'The WebSocket connection could not be established or was disconnected.'
        );
        this._disconnect();
    }

    /**
     * _Private_ function called by Connection._onIdle
     * sends all queued stanzas
     */
    _onIdle() {
        const data = this._conn._data;
        if (data.length > 0 && !this._conn.paused) {
            for (let i = 0; i < data.length; i++) {
                if (data[i] !== null) {
                    const stanza = data[i] === 'restart' ? this._buildStream().tree() : data[i];
                    if (stanza === 'restart') throw new Error('Wrong type for stanza'); // Shut up tsc
                    const rawStanza = Builder.serialize(stanza);
                    this._conn.xmlOutput(stanza);
                    this._conn.rawOutput(rawStanza);
                    this.socket.send(rawStanza);
                }
            }
            this._conn._data = [];
        }
    }

    /**
     * _Private_ function to handle websockets messages.
     *
     * This function parses each of the messages as if they are full documents.
     * [TODO : We may actually want to use a SAX Push parser].
     *
     * Since all XMPP traffic starts with
     * <stream:stream version='1.0'
     *                xml:lang='en'
     *                xmlns='jabber:client'
     *                xmlns:stream='http://etherx.jabber.org/streams'
     *                id='3697395463'
     *                from='SERVER'>
     *
     * The first stanza will always fail to be parsed.
     *
     * Additionally, the seconds stanza will always be <stream:features> with
     * the stream NS defined in the previous stanza, so we need to 'force'
     * the inclusion of the NS in this stanza.
     *
     * @param {MessageEvent} message - The websocket message event
     */
    _onMessage(message) {
        let elem;
        // check for closing stream
        const close = '<close xmlns="urn:ietf:params:xml:ns:xmpp-framing" />';
        if (message.data === close) {
            this._conn.rawInput(close);
            this._conn.xmlInput(message);
            if (!this._conn.disconnecting) {
                this._conn._doDisconnect();
            }
            return;
        } else if (message.data.search('<open ') === 0) {
            // This handles stream restarts
            elem = new DOMParser$1().parseFromString(message.data, 'text/xml').documentElement;
            if (!this._handleStreamStart(elem)) {
                return;
            }
        } else {
            const data = this._streamWrap(message.data);
            elem = new DOMParser$1().parseFromString(data, 'text/xml').documentElement;
        }

        if (this._checkStreamError(elem, Status.ERROR)) {
            return;
        }

        //handle unavailable presence stanza before disconnecting
        if (
            this._conn.disconnecting &&
            elem.firstElementChild.nodeName === 'presence' &&
            elem.firstElementChild.getAttribute('type') === 'unavailable'
        ) {
            this._conn.xmlInput(elem);
            this._conn.rawInput(Builder.serialize(elem));
            // if we are already disconnecting we will ignore the unavailable stanza and
            // wait for the </stream:stream> tag before we close the connection
            return;
        }
        this._conn._dataRecv(elem, message.data);
    }

    /**
     * _Private_ function to handle websockets connection setup.
     * The opening stream tag is sent here.
     * @private
     */
    _onOpen() {
        log.debug('Websocket open');
        const start = this._buildStream();
        this._conn.xmlOutput(start.tree());

        const startString = Builder.serialize(start);
        this._conn.rawOutput(startString);
        this.socket.send(startString);
    }

    /**
     * _Private_ part of the Connection.send function for WebSocket
     * Just flushes the messages that are in the queue
     */
    _send() {
        this._conn.flush();
    }

    /**
     * Send an xmpp:restart stanza.
     */
    _sendRestart() {
        clearTimeout(this._conn._idleTimeout);
        this._conn._onIdle.bind(this._conn)();
    }
}

/**
 * @license MIT
 * @copyright JC Brand
 */

/**
 * Helper class that handles a websocket connection inside a shared worker.
 */
class WorkerWebsocket extends Websocket {
    /**
     * @typedef {import("./connection.js").default} Connection
     */

    /**
     * Create and initialize a WorkerWebsocket object.
     * @param {Connection} connection - The Connection
     */
    constructor(connection) {
        super(connection);
        this._conn = connection;
        this.worker = new SharedWorker(this._conn.options.worker, 'Strophe XMPP Connection');
        this.worker.onerror = (e) => {
            console?.error(e);
            log.error(`Shared Worker Error: ${e}`);
        };
    }

    /**
     * @private
     */
    _setSocket() {
        this.socket = {
            /** @param {string} str */
            send: (str) => this.worker.port.postMessage(['send', str]),
            close: () => this.worker.port.postMessage(['_closeSocket']),
            onopen: () => {},
            /** @param {ErrorEvent} e */
            onerror: (e) => this._onError(e),
            /** @param {CloseEvent} e */
            onclose: (e) => this._onClose(e),
            onmessage: () => {},
            readyState: null,
        };
    }

    _connect() {
        this._setSocket();
        /** @param {MessageEvent} m */
        this._messageHandler = (m) => this._onInitialMessage(m);
        this.worker.port.start();
        this.worker.port.onmessage = (ev) => this._onWorkerMessage(ev);
        this.worker.port.postMessage(['_connect', this._conn.service, this._conn.jid]);
    }

    /**
     * @param {Function} callback
     */
    _attach(callback) {
        this._setSocket();
        /** @param {MessageEvent} m */
        this._messageHandler = (m) => this._onMessage(m);
        this._conn.connect_callback = callback;
        this.worker.port.start();
        this.worker.port.onmessage = (ev) => this._onWorkerMessage(ev);
        this.worker.port.postMessage(['_attach', this._conn.service]);
    }

    /**
     * @param {number} status
     * @param {string} jid
     */
    _attachCallback(status, jid) {
        if (status === Status.ATTACHED) {
            this._conn.jid = jid;
            this._conn.authenticated = true;
            this._conn.connected = true;
            this._conn.restored = true;
            this._conn._changeConnectStatus(Status.ATTACHED);
        } else if (status === Status.ATTACHFAIL) {
            this._conn.authenticated = false;
            this._conn.connected = false;
            this._conn.restored = false;
            this._conn._changeConnectStatus(Status.ATTACHFAIL);
        }
    }

    /**
     * @param {Element|Builder} pres - This stanza will be sent before disconnecting.
     */
    _disconnect(pres) {
        pres && this._conn.send(pres);
        const close = $build('close', { 'xmlns': NS.FRAMING });
        this._conn.xmlOutput(close.tree());
        const closeString = Builder.serialize(close);
        this._conn.rawOutput(closeString);
        this.worker.port.postMessage(['send', closeString]);
        this._conn._doDisconnect();
    }

    _closeSocket() {
        this.socket.close();
    }

    /**
     * Called by _onInitialMessage in order to replace itself with the general message handler.
     * This method is overridden by WorkerWebsocket, which manages a
     * websocket connection via a service worker and doesn't have direct access
     * to the socket.
     */
    _replaceMessageHandler() {
        /** @param {MessageEvent} m */
        this._messageHandler = (m) => this._onMessage(m);
    }

    /**
     * function that handles messages received from the service worker
     * @private
     * @param {MessageEvent} ev
     */
    _onWorkerMessage(ev) {
        const { data } = ev;
        const method_name = data[0];
        if (method_name === '_onMessage') {
            this._messageHandler(data[1]);
        } else if (method_name in this) {
            try {
                this[
                    /** @type {'_attachCallback'|'_onOpen'|'_onClose'|'_onError'} */
                    (method_name)
                ].apply(this, ev.data.slice(1));
            } catch (e) {
                log.error(e);
            }
        } else if (method_name === 'log') {
            /** @type {Object.<string, number>} */
            const lmap = {
                debug: LOG_LEVELS.DEBUG,
                info: LOG_LEVELS.INFO,
                warn: LOG_LEVELS.WARN,
                error: LOG_LEVELS.ERROR,
                fatal: LOG_LEVELS.FATAL,
            };
            const level = data[1];
            const msg = data[2];
            log.log(lmap[level], msg);
        } else {
            log.error(`Found unhandled service worker message: ${data}`);
        }
    }
}

/**
 * @typedef {import("./sasl.js").default} SASLMechanism
 * @typedef {import("./request.js").default} Request
 *
 * @typedef {Object} ConnectionOptions
 * @property {Cookies} [cookies]
 *  Allows you to pass in cookies that will be included in HTTP requests.
 *  Relevant to both the BOSH and Websocket transports.
 *
 *  The passed in value must be a map of cookie names and string values.
 *
 *  > { "myCookie": {
 *  >     "value": "1234",
 *  >     "domain": ".example.org",
 *  >     "path": "/",
 *  >     "expires": expirationDate
 *  >     }
 *  > }
 *
 *  Note that cookies can't be set in this way for domains other than the one
 *  that's hosting Strophe (i.e. cross-domain).
 *  Those cookies need to be set under those domains, for example they can be
 *  set server-side by making a XHR call to that domain to ask it to set any
 *  necessary cookies.
 * @property {SASLMechanism[]} [mechanisms]
 *  Allows you to specify the SASL authentication mechanisms that this
 *  instance of Connection (and therefore your XMPP client) will support.
 *
 *  The value must be an array of objects with {@link SASLMechanism}
 *  prototypes.
 *
 *  If nothing is specified, then the following mechanisms (and their
 *  priorities) are registered:
 *
 *      Mechanism       Priority
 *      ------------------------
 *      SCRAM-SHA-512   72
 *      SCRAM-SHA-384   71
 *      SCRAM-SHA-256   70
 *      SCRAM-SHA-1     60
 *      PLAIN           50
 *      OAUTHBEARER     40
 *      X-OAUTH2        30
 *      ANONYMOUS       20
 *      EXTERNAL        10
 *
 * @property {boolean} [explicitResourceBinding]
 *  If `explicitResourceBinding` is set to `true`, then the XMPP client
 *  needs to explicitly call {@link Connection.bind} once the XMPP
 *  server has advertised the `urn:ietf:propertys:xml:ns:xmpp-bind` feature.
 *
 *  Making this step explicit allows client authors to first finish other
 *  stream related tasks, such as setting up an XEP-0198 Stream Management
 *  session, before binding the JID resource for this session.
 *
 * @property {'ws'|'wss'} [protocol]
 *  _Note: This option is only relevant to Websocket connections, and not BOSH_
 *
 *  If you want to connect to the current host with a WebSocket connection you
 *  can tell Strophe to use WebSockets through the "protocol" option.
 *  Valid values are `ws` for WebSocket and `wss` for Secure WebSocket.
 *  So to connect to "wss://CURRENT_HOSTNAME/xmpp-websocket" you would call
 *
 *      const conn = new Strophe.Connection(
 *          "/xmpp-websocket/",
 *          {protocol: "wss"}
 *      );
 *
 *  Note that relative URLs _NOT_ starting with a "/" will also include the path
 *  of the current site.
 *
 *  Also because downgrading security is not permitted by browsers, when using
 *  relative URLs both BOSH and WebSocket connections will use their secure
 *  variants if the current connection to the site is also secure (https).
 *
 * @property {string} [worker]
 *  _Note: This option is only relevant to Websocket connections, and not BOSH_
 *
 *  Set this option to URL from where the shared worker script should be loaded.
 *
 *  To run the websocket connection inside a shared worker.
 *  This allows you to share a single websocket-based connection between
 *  multiple Connection instances, for example one per browser tab.
 *
 *  The script to use is the one in `src/shared-connection-worker.js`.
 *
 * @property {boolean} [sync]
 *  Used to control whether BOSH HTTP requests will be made synchronously or not.
 *  The default behaviour is asynchronous. If you want to make requests
 *  synchronous, make "sync" evaluate to true.
 *
 *  > const conn = new Strophe.Connection("/http-bind/", {sync: true});
 *
 *  You can also toggle this on an already established connection.
 *
 *  > conn.options.sync = true;
 *
 * @property {string[]} [customHeaders]
 *  Used to provide custom HTTP headers to be included in the BOSH HTTP requests.
 *
 * @property {boolean} [keepalive]
 *  Used to instruct Strophe to maintain the current BOSH session across
 *  interruptions such as webpage reloads.
 *
 *  It will do this by caching the sessions tokens in sessionStorage, and when
 *  "restore" is called it will check whether there are cached tokens with
 *  which it can resume an existing session.
 *
 * @property {boolean} [withCredentials]
 *  Used to indicate wether cookies should be included in HTTP requests (by default
 *  they're not).
 *  Set this value to `true` if you are connecting to a BOSH service
 *  and for some reason need to send cookies to it.
 *  In order for this to work cross-domain, the server must also enable
 *  credentials by setting the `Access-Control-Allow-Credentials` response header
 *  to "true". For most usecases however this setting should be false (which
 *  is the default).
 *  Additionally, when using `Access-Control-Allow-Credentials`, the
 *  `Access-Control-Allow-Origin` header can't be set to the wildcard "*", but
 *  instead must be restricted to actual domains.
 *
 * @property {string} [contentType]
 *  Used to change the default Content-Type, which is "text/xml; charset=utf-8".
 *  Can be useful to reduce the amount of CORS preflight requests that are sent
 *  to the server.
 */


/**
 * _Private_ variable Used to store plugin names that need
 * initialization during Connection construction.
 * @type {Object.<string, Object>}
 */
const connectionPlugins = {};

/**
 * **XMPP Connection manager**
 *
 * This class is the main part of Strophe.  It manages a BOSH or websocket
 * connection to an XMPP server and dispatches events to the user callbacks
 * as data arrives.
 *
 * It supports various authentication mechanisms (e.g. SASL PLAIN, SASL SCRAM),
 * and more can be added via
 * {@link Connection#registerSASLMechanisms|registerSASLMechanisms()}.
 *
 * After creating a Connection object, the user will typically
 * call {@link Connection#connect|connect()} with a user supplied callback
 * to handle connection level events like authentication failure,
 * disconnection, or connection complete.
 *
 * The user will also have several event handlers defined by using
 * {@link Connection#addHandler|addHandler()} and
 * {@link Connection#addTimedHandler|addTimedHandler()}.
 * These will allow the user code to respond to interesting stanzas or do
 * something periodically with the connection. These handlers will be active
 * once authentication is finished.
 *
 * To send data to the connection, use {@link Connection#send|send()}.
 *
 * @memberof Strophe
 */
class Connection {
    /**
     * @typedef {Object.<string, string>} Cookie
     * @typedef {Cookie|Object.<string, Cookie>} Cookies
     */


    /**
     * Create and initialize a {@link Connection} object.
     *
     * The transport-protocol for this connection will be chosen automatically
     * based on the given service parameter. URLs starting with "ws://" or
     * "wss://" will use WebSockets, URLs starting with "http://", "https://"
     * or without a protocol will use [BOSH](https://xmpp.org/extensions/xep-0124.html).
     *
     * To make Strophe connect to the current host you can leave out the protocol
     * and host part and just pass the path:
     *
     *  const conn = new Strophe.Connection("/http-bind/");
     *
     * @param {string} service - The BOSH or WebSocket service URL.
     * @param {ConnectionOptions} options - A object containing configuration options
     */
    constructor(service, options = {}) {
        // The service URL
        this.service = service;
        // Configuration options
        this.options = options;

        this.setProtocol();

        /* The connected JID. */
        this.jid = '';
        /* the JIDs domain */
        this.domain = null;
        /* stream:features */
        this.features = null;

        // SASL
        /**
         * @typedef {Object.<string, any>} SASLData
         * @property {Object} [SASLData.keys]
         */

        /** @type {SASLData} */
        this._sasl_data = {};
        this.do_bind = false;
        this.do_session = false;

        /** @type {Object.<string, SASLMechanism>} */
        this.mechanisms = {};

        /** @type {TimedHandler[]} */
        this.timedHandlers = [];

        /** @type {Handler[]} */
        this.handlers = [];

        /** @type {TimedHandler[]} */
        this.removeTimeds = [];

        /** @type {Handler[]} */
        this.removeHandlers = [];

        /** @type {TimedHandler[]} */
        this.addTimeds = [];

        /** @type {Handler[]} */
        this.addHandlers = [];

        this.protocolErrorHandlers = {
            /** @type {Object.<number, Function>} */
            'HTTP': {},
            /** @type {Object.<number, Function>} */
            'websocket': {},
        };

        this._idleTimeout = null;
        this._disconnectTimeout = null;

        this.authenticated = false;
        this.connected = false;
        this.disconnecting = false;
        this.do_authentication = true;
        this.paused = false;
        this.restored = false;

        /** @type {(Element|'restart')[]} */
        this._data = [];
        this._uniqueId = 0;

        this._sasl_success_handler = null;
        this._sasl_failure_handler = null;
        this._sasl_challenge_handler = null;

        // Max retries before disconnecting
        this.maxRetries = 5;

        // Call onIdle callback every 1/10th of a second
        this._idleTimeout = setTimeout(() => this._onIdle(), 100);

        addCookies(this.options.cookies);
        this.registerSASLMechanisms(this.options.mechanisms);

        // A client must always respond to incoming IQ "set" and "get" stanzas.
        // See https://datatracker.ietf.org/doc/html/rfc6120#section-8.2.3
        //
        // This is a fallback handler which gets called when no other handler
        // was called for a received IQ "set" or "get".
        this.iqFallbackHandler = new Handler(
            /**
             * @param {Element} iq
             */
            (iq) =>
                this.send(
                    $iq({ type: 'error', id: iq.getAttribute('id') })
                        .c('error', { 'type': 'cancel' })
                        .c('service-unavailable', { 'xmlns': NS.STANZAS })
                ),
            null,
            'iq',
            ['get', 'set']
        );

        // initialize plugins
        for (const k in connectionPlugins) {
            if (Object.prototype.hasOwnProperty.call(connectionPlugins, k)) {
                const F = function () {};
                F.prototype = connectionPlugins[k];
                // @ts-ignore
                this[k] = new F();
                // @ts-ignore
                this[k].init(this);
            }
        }
    }

    /**
     * Extends the Connection object with the given plugin.
     * @param {string} name - The name of the extension.
     * @param {Object} ptype - The plugin's prototype.
     */
    static addConnectionPlugin(name, ptype) {
        connectionPlugins[name] = ptype;
    }

    /**
     * Select protocal based on this.options or this.service
     */
    setProtocol() {
        const proto = this.options.protocol || '';
        if (this.options.worker) {
            this._proto = new WorkerWebsocket(this);
        } else if (
            this.service.indexOf('ws:') === 0 ||
            this.service.indexOf('wss:') === 0 ||
            proto.indexOf('ws') === 0
        ) {
            this._proto = new Websocket(this);
        } else {
            this._proto = new Bosh(this);
        }
    }

    /**
     * Reset the connection.
     *
     * This function should be called after a connection is disconnected
     * before that connection is reused.
     */
    reset() {
        this._proto._reset();

        // SASL
        this.do_session = false;
        this.do_bind = false;

        // handler lists
        this.timedHandlers = [];
        this.handlers = [];
        this.removeTimeds = [];
        this.removeHandlers = [];
        this.addTimeds = [];
        this.addHandlers = [];

        this.authenticated = false;
        this.connected = false;
        this.disconnecting = false;
        this.restored = false;
        this._data = [];
        /** @type {Request[]} */
        this._requests = [];
        this._uniqueId = 0;
    }

    /**
     * Pause the request manager.
     *
     * This will prevent Strophe from sending any more requests to the
     * server.  This is very useful for temporarily pausing
     * BOSH-Connections while a lot of send() calls are happening quickly.
     * This causes Strophe to send the data in a single request, saving
     * many request trips.
     */
    pause() {
        this.paused = true;
    }

    /**
     * Resume the request manager.
     *
     * This resumes after pause() has been called.
     */
    resume() {
        this.paused = false;
    }

    /**
     * Generate a unique ID for use in <iq/> elements.
     *
     * All <iq/> stanzas are required to have unique id attributes.  This
     * function makes creating these easy.  Each connection instance has
     * a counter which starts from zero, and the value of this counter
     * plus a colon followed by the suffix becomes the unique id. If no
     * suffix is supplied, the counter is used as the unique id.
     *
     * Suffixes are used to make debugging easier when reading the stream
     * data, and their use is recommended.  The counter resets to 0 for
     * every new connection for the same reason.  For connections to the
     * same server that authenticate the same way, all the ids should be
     * the same, which makes it easy to see changes.  This is useful for
     * automated testing as well.
     *
     * @param {string} suffix - A optional suffix to append to the id.
     * @returns {string} A unique string to be used for the id attribute.
     */
    // eslint-disable-next-line class-methods-use-this
    getUniqueId(suffix) {
        const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
        if (typeof suffix === 'string' || typeof suffix === 'number') {
            return uuid + ':' + suffix;
        } else {
            return uuid + '';
        }
    }

    /**
     * Register a handler function for when a protocol (websocker or HTTP)
     * error occurs.
     *
     * NOTE: Currently only HTTP errors for BOSH requests are handled.
     * Patches that handle websocket errors would be very welcome.
     *
     * @example
     *  function onError(err_code){
     *    //do stuff
     *  }
     *
     *  const conn = Strophe.connect('http://example.com/http-bind');
     *  conn.addProtocolErrorHandler('HTTP', 500, onError);
     *  // Triggers HTTP 500 error and onError handler will be called
     *  conn.connect('user_jid@incorrect_jabber_host', 'secret', onConnect);
     *
     * @param {'HTTP'|'websocket'} protocol - 'HTTP' or 'websocket'
     * @param {number} status_code - Error status code (e.g 500, 400 or 404)
     * @param {Function} callback - Function that will fire on Http error
     */
    addProtocolErrorHandler(protocol, status_code, callback) {
        this.protocolErrorHandlers[protocol][status_code] = callback;
    }

    /**
     * @typedef {Object} Password
     * @property {string} Password.name
     * @property {string} Password.ck
     * @property {string} Password.sk
     * @property {number} Password.iter
     * @property {string} Password.salt
     */

    /**
     * Starts the connection process.
     *
     * As the connection process proceeds, the user supplied callback will
     * be triggered multiple times with status updates.  The callback
     * should take two arguments - the status code and the error condition.
     *
     * The status code will be one of the values in the Strophe.Status
     * constants.  The error condition will be one of the conditions
     * defined in RFC 3920 or the condition 'strophe-parsererror'.
     *
     * The Parameters _wait_, _hold_ and _route_ are optional and only relevant
     * for BOSH connections. Please see XEP 124 for a more detailed explanation
     * of the optional parameters.
     *
     * @param {string} jid - The user's JID.  This may be a bare JID,
     *     or a full JID.  If a node is not supplied, SASL OAUTHBEARER or
     *     SASL ANONYMOUS authentication will be attempted (OAUTHBEARER will
     *     process the provided password value as an access token).
     *   (String or Object) pass - The user's password, or an object containing
     *     the users SCRAM client and server keys, in a fashion described as follows:
     *
     *     { name: String, representing the hash used (eg. SHA-1),
     *       salt: String, base64 encoded salt used to derive the client key,
     *       iter: Int,    the iteration count used to derive the client key,
     *       ck:   String, the base64 encoding of the SCRAM client key
     *       sk:   String, the base64 encoding of the SCRAM server key
     *     }
     * @param {string|Password} pass - The user password
     * @param {Function} callback - The connect callback function.
     * @param {number} [wait] - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     * @param {number} [hold] - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param {string} [route] - The optional route value.
     * @param {string} [authcid] - The optional alternative authentication identity
     *     (username) if intending to impersonate another user.
     *     When using the SASL-EXTERNAL authentication mechanism, for example
     *     with client certificates, then the authcid value is used to
     *     determine whether an authorization JID (authzid) should be sent to
     *     the server. The authzid should NOT be sent to the server if the
     *     authzid and authcid are the same. So to prevent it from being sent
     *     (for example when the JID is already contained in the client
     *     certificate), set authcid to that same JID. See XEP-178 for more
     *     details.
     *  @param {number} [disconnection_timeout=3000] - The optional disconnection timeout
     *     in milliseconds before _doDisconnect will be called.
     */
    connect(jid, pass, callback, wait, hold, route, authcid, disconnection_timeout = 3000) {
        this.jid = jid;
        /** Authorization identity */
        this.authzid = getBareJidFromJid(this.jid);
        /** Authentication identity (User name) */
        this.authcid = authcid || getNodeFromJid(this.jid);
        /** Authentication identity (User password) */
        this.pass = pass;

        /**
         * The SASL SCRAM client and server keys. This variable will be populated with a non-null
         * object of the above described form after a successful SCRAM connection
         */
        this.scram_keys = null;

        this.connect_callback = callback;
        this.disconnecting = false;
        this.connected = false;
        this.authenticated = false;
        this.restored = false;
        this.disconnection_timeout = disconnection_timeout;

        // parse jid for domain
        this.domain = getDomainFromJid(this.jid);

        this._changeConnectStatus(Status.CONNECTING, null);

        this._proto._connect(wait, hold, route);
    }

    /**
     * Attach to an already created and authenticated BOSH session.
     *
     * This function is provided to allow Strophe to attach to BOSH
     * sessions which have been created externally, perhaps by a Web
     * application.  This is often used to support auto-login type features
     * without putting user credentials into the page.
     *
     * @param {string|Function} jid - The full JID that is bound by the session.
     * @param {string} [sid] - The SID of the BOSH session.
     * @param {number} [rid] - The current RID of the BOSH session.  This RID
     *     will be used by the next request.
     * @param {Function} [callback] - The connect callback function.
     * @param {number} [wait] - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     *     Other settings will require tweaks to the Strophe.TIMEOUT value.
     * @param {number} [hold] - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param {number} [wind] - The optional HTTBIND window value.  This is the
     *     allowed range of request ids that are valid.  The default is 5.
     */
    attach(jid, sid, rid, callback, wait, hold, wind) {
        if (this._proto instanceof Bosh && typeof jid === 'string') {
            return this._proto._attach(jid, sid, rid, callback, wait, hold, wind);
        } else if (this._proto instanceof WorkerWebsocket && typeof jid === 'function') {
            const callback = jid;
            return this._proto._attach(callback);
        } else {
            throw new SessionError('The "attach" method is not available for your connection protocol');
        }
    }

    /**
     * Attempt to restore a cached BOSH session.
     *
     * This function is only useful in conjunction with providing the
     * "keepalive":true option when instantiating a new {@link Connection}.
     *
     * When "keepalive" is set to true, Strophe will cache the BOSH tokens
     * RID (Request ID) and SID (Session ID) and then when this function is
     * called, it will attempt to restore the session from those cached
     * tokens.
     *
     * This function must therefore be called instead of connect or attach.
     *
     * For an example on how to use it, please see examples/restore.js
     *
     * @param {string} jid - The user's JID.  This may be a bare JID or a full JID.
     * @param {Function} callback - The connect callback function.
     * @param {number} [wait] - The optional HTTPBIND wait value.  This is the
     *     time the server will wait before returning an empty result for
     *     a request.  The default setting of 60 seconds is recommended.
     * @param {number} [hold] - The optional HTTPBIND hold value.  This is the
     *     number of connections the server will hold at one time.  This
     *     should almost always be set to 1 (the default).
     * @param {number} [wind] - The optional HTTBIND window value.  This is the
     *     allowed range of request ids that are valid.  The default is 5.
     */
    restore(jid, callback, wait, hold, wind) {
        if (!(this._proto instanceof Bosh) || !this._sessionCachingSupported()) {
            throw new SessionError('The "restore" method can only be used with a BOSH connection.');
        }

        if (this._sessionCachingSupported()) {
            this._proto._restore(jid, callback, wait, hold, wind);
        }
    }

    /**
     * Checks whether sessionStorage and JSON are supported and whether we're
     * using BOSH.
     */
    _sessionCachingSupported() {
        if (this._proto instanceof Bosh) {
            if (!JSON) {
                return false;
            }
            try {
                sessionStorage.setItem('_strophe_', '_strophe_');
                sessionStorage.removeItem('_strophe_');
            } catch (e) { // eslint-disable-line no-unused-vars
                return false;
            }
            return true;
        }
        return false;
    }

    /**
     * User overrideable function that receives XML data coming into the
     * connection.
     *
     * The default function does nothing.  User code can override this with
     * > Connection.xmlInput = function (elem) {
     * >   (user code)
     * > };
     *
     * Due to limitations of current Browsers' XML-Parsers the opening and closing
     * <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
     *
     * BOSH-Connections will have all stanzas wrapped in a <body> tag. See
     * <Bosh.strip> if you want to strip this tag.
     *
     * @param {Node|MessageEvent} elem - The XML data received by the connection.
     */
    // eslint-disable-next-line no-unused-vars, class-methods-use-this
    xmlInput(elem) {
        return;
    }

    /**
     * User overrideable function that receives XML data sent to the
     * connection.
     *
     * The default function does nothing.  User code can override this with
     * > Connection.xmlOutput = function (elem) {
     * >   (user code)
     * > };
     *
     * Due to limitations of current Browsers' XML-Parsers the opening and closing
     * <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
     *
     * BOSH-Connections will have all stanzas wrapped in a <body> tag. See
     * <Bosh.strip> if you want to strip this tag.
     *
     * @param {Element} elem - The XMLdata sent by the connection.
     */
    // eslint-disable-next-line no-unused-vars, class-methods-use-this
    xmlOutput(elem) {
        return;
    }

    /**
     * User overrideable function that receives raw data coming into the
     * connection.
     *
     * The default function does nothing.  User code can override this with
     * > Connection.rawInput = function (data) {
     * >   (user code)
     * > };
     *
     * @param {string} data - The data received by the connection.
     */
    // eslint-disable-next-line no-unused-vars, class-methods-use-this
    rawInput(data) {
        return;
    }

    /**
     * User overrideable function that receives raw data sent to the
     * connection.
     *
     * The default function does nothing.  User code can override this with
     * > Connection.rawOutput = function (data) {
     * >   (user code)
     * > };
     *
     * @param {string} data - The data sent by the connection.
     */
    // eslint-disable-next-line no-unused-vars, class-methods-use-this
    rawOutput(data) {
        return;
    }

    /**
     * User overrideable function that receives the new valid rid.
     *
     * The default function does nothing. User code can override this with
     * > Connection.nextValidRid = function (rid) {
     * >    (user code)
     * > };
     *
     * @param {number} rid - The next valid rid
     */
    // eslint-disable-next-line no-unused-vars, class-methods-use-this
    nextValidRid(rid) {
        return;
    }

    /**
     * Send a stanza.
     *
     * This function is called to push data onto the send queue to
     * go out over the wire.  Whenever a request is sent to the BOSH
     * server, all pending data is sent and the queue is flushed.
     *
     * @param {Element|Builder|Element[]|Builder[]} stanza - The stanza to send
     */
    send(stanza) {
        if (stanza === null) return;

        if (Array.isArray(stanza)) {
            stanza.forEach((s) => this._queueData(s instanceof Builder ? s.tree() : s));
        } else {
            const el = stanza instanceof Builder ? stanza.tree() : stanza;
            this._queueData(el);
        }
        this._proto._send();
    }

    /**
     * Immediately send any pending outgoing data.
     *
     * Normally send() queues outgoing data until the next idle period
     * (100ms), which optimizes network use in the common cases when
     * several send()s are called in succession. flush() can be used to
     * immediately send all pending data.
     */
    flush() {
        // cancel the pending idle period and run the idle function
        // immediately
        clearTimeout(this._idleTimeout);
        this._onIdle();
    }

    /**
     * Helper function to send presence stanzas. The main benefit is for
     * sending presence stanzas for which you expect a responding presence
     * stanza with the same id (for example when leaving a chat room).
     *
     * @param {Element} stanza - The stanza to send.
     * @param {Function} [callback] - The callback function for a successful request.
     * @param {Function} [errback] - The callback function for a failed or timed
     *    out request.  On timeout, the stanza will be null.
     * @param {number} [timeout] - The time specified in milliseconds for a
     *    timeout to occur.
     * @return {string} The id used to send the presence.
     */
    sendPresence(stanza, callback, errback, timeout) {
        /** @type {TimedHandler} */
        let timeoutHandler = null;

        const el = stanza instanceof Builder ? stanza.tree() : stanza;

        let id = el.getAttribute('id');
        if (!id) {
            // inject id if not found
            id = this.getUniqueId('sendPresence');
            el.setAttribute('id', id);
        }

        if (typeof callback === 'function' || typeof errback === 'function') {
            const handler = this.addHandler(
                /** @param {Element} stanza */
                (stanza) => {
                    // remove timeout handler if there is one
                    if (timeoutHandler) this.deleteTimedHandler(timeoutHandler);

                    if (stanza.getAttribute('type') === 'error') {
                        errback?.(stanza);
                    } else if (callback) {
                        callback(stanza);
                    }
                },
                null,
                'presence',
                null,
                id
            );

            // if timeout specified, set up a timeout handler.
            if (timeout) {
                timeoutHandler = this.addTimedHandler(timeout, () => {
                    // get rid of normal handler
                    this.deleteHandler(handler);
                    // call errback on timeout with null stanza
                    errback?.(null);
                    return false;
                });
            }
        }
        this.send(el);
        return id;
    }

    /**
     * Helper function to send IQ stanzas.
     *
     * @param {Element|Builder} stanza - The stanza to send.
     * @param {Function} [callback] - The callback function for a successful request.
     * @param {Function} [errback] - The callback function for a failed or timed
     *     out request.  On timeout, the stanza will be null.
     * @param {number} [timeout] - The time specified in milliseconds for a
     *     timeout to occur.
     * @return {string} The id used to send the IQ.
     */
    sendIQ(stanza, callback, errback, timeout) {
        /** @type {TimedHandler} */
        let timeoutHandler = null;

        const el = stanza instanceof Builder ? stanza.tree() : stanza;

        let id = el.getAttribute('id');
        if (!id) {
            // inject id if not found
            id = this.getUniqueId('sendIQ');
            el.setAttribute('id', id);
        }

        if (typeof callback === 'function' || typeof errback === 'function') {
            const handler = this.addHandler(
                /** @param {Element} stanza */
                (stanza) => {
                    // remove timeout handler if there is one
                    if (timeoutHandler) this.deleteTimedHandler(timeoutHandler);

                    const iqtype = stanza.getAttribute('type');
                    if (iqtype === 'result') {
                        callback?.(stanza);
                    } else if (iqtype === 'error') {
                        errback?.(stanza);
                    } else {
                        const error = new Error(`Got bad IQ type of ${iqtype}`);
                        error.name = 'StropheError';
                        throw error;
                    }
                },
                null,
                'iq',
                ['error', 'result'],
                id
            );

            // if timeout specified, set up a timeout handler.
            if (timeout) {
                timeoutHandler = this.addTimedHandler(timeout, () => {
                    // get rid of normal handler
                    this.deleteHandler(handler);
                    // call errback on timeout with null stanza
                    errback?.(null);
                    return false;
                });
            }
        }
        this.send(el);
        return id;
    }

    /**
     * Queue outgoing data for later sending.  Also ensures that the data
     * is a DOMElement.
     * @private
     * @param {Element} element
     */
    _queueData(element) {
        if (element === null || !element.tagName || !element.childNodes) {
            const error = new Error('Cannot queue non-DOMElement.');
            error.name = 'StropheError';
            throw error;
        }
        this._data.push(element);
    }

    /**
     * Send an xmpp:restart stanza.
     * @private
     */
    _sendRestart() {
        this._data.push('restart');
        this._proto._sendRestart();
        this._idleTimeout = setTimeout(() => this._onIdle(), 100);
    }

    /**
     * Add a timed handler to the connection.
     *
     * This function adds a timed handler.  The provided handler will
     * be called every period milliseconds until it returns false,
     * the connection is terminated, or the handler is removed.  Handlers
     * that wish to continue being invoked should return true.
     *
     * Because of method binding it is necessary to save the result of
     * this function if you wish to remove a handler with
     * deleteTimedHandler().
     *
     * Note that user handlers are not active until authentication is
     * successful.
     *
     * @param {number} period - The period of the handler.
     * @param {Function} handler - The callback function.
     * @return {TimedHandler} A reference to the handler that can be used to remove it.
     */
    addTimedHandler(period, handler) {
        const thand = new TimedHandler(period, handler);
        this.addTimeds.push(thand);
        return thand;
    }

    /**
     * Delete a timed handler for a connection.
     *
     * This function removes a timed handler from the connection.  The
     * handRef parameter is *not* the function passed to addTimedHandler(),
     * but is the reference returned from addTimedHandler().
     * @param {TimedHandler} handRef - The handler reference.
     */
    deleteTimedHandler(handRef) {
        // this must be done in the Idle loop so that we don't change
        // the handlers during iteration
        this.removeTimeds.push(handRef);
    }

    /**
     * @typedef {Object} HandlerOptions
     * @property {boolean} [HandlerOptions.matchBareFromJid]
     * @property {boolean} [HandlerOptions.ignoreNamespaceFragment]
     */

    /**
     * Add a stanza handler for the connection.
     *
     * This function adds a stanza handler to the connection.  The
     * handler callback will be called for any stanza that matches
     * the parameters.  Note that if multiple parameters are supplied,
     * they must all match for the handler to be invoked.
     *
     * The handler will receive the stanza that triggered it as its argument.
     * *The handler should return true if it is to be invoked again;
     * returning false will remove the handler after it returns.*
     *
     * As a convenience, the ns parameters applies to the top level element
     * and also any of its immediate children.  This is primarily to make
     * matching /iq/query elements easy.
     *
     * ### Options
     *
     * With the options argument, you can specify boolean flags that affect how
     * matches are being done.
     *
     * Currently two flags exist:
     *
     * * *matchBareFromJid*:
     *     When set to true, the from parameter and the
     *     from attribute on the stanza will be matched as bare JIDs instead
     *     of full JIDs. To use this, pass {matchBareFromJid: true} as the
     *     value of options. The default value for matchBareFromJid is false.
     *
     * * *ignoreNamespaceFragment*:
     *     When set to true, a fragment specified on the stanza's namespace
     *     URL will be ignored when it's matched with the one configured for
     *     the handler.
     *
     *     This means that if you register like this:
     *
     *     >   connection.addHandler(
     *     >       handler,
     *     >       'http://jabber.org/protocol/muc',
     *     >       null, null, null, null,
     *     >       {'ignoreNamespaceFragment': true}
     *     >   );
     *
     *     Then a stanza with XML namespace of
     *     'http://jabber.org/protocol/muc#user' will also be matched. If
     *     'ignoreNamespaceFragment' is false, then only stanzas with
     *     'http://jabber.org/protocol/muc' will be matched.
     *
     * ### Deleting the handler
     *
     * The return value should be saved if you wish to remove the handler
     * with `deleteHandler()`.
     *
     * @param {Function} handler - The user callback.
     * @param {string} ns - The namespace to match.
     * @param {string} name - The stanza name to match.
     * @param {string|string[]} type - The stanza type (or types if an array) to match.
     * @param {string} [id] - The stanza id attribute to match.
     * @param {string} [from] - The stanza from attribute to match.
     * @param {HandlerOptions} [options] - The handler options
     * @return {Handler} A reference to the handler that can be used to remove it.
     */
    addHandler(handler, ns, name, type, id, from, options) {
        const hand = new Handler(handler, ns, name, type, id, from, options);
        this.addHandlers.push(hand);
        return hand;
    }

    /**
     * Delete a stanza handler for a connection.
     *
     * This function removes a stanza handler from the connection.  The
     * handRef parameter is *not* the function passed to addHandler(),
     * but is the reference returned from addHandler().
     *
     * @param {Handler} handRef - The handler reference.
     */
    deleteHandler(handRef) {
        // this must be done in the Idle loop so that we don't change
        // the handlers during iteration
        this.removeHandlers.push(handRef);
        // If a handler is being deleted while it is being added,
        // prevent it from getting added
        const i = this.addHandlers.indexOf(handRef);
        if (i >= 0) {
            this.addHandlers.splice(i, 1);
        }
    }

    /**
     * Register the SASL mechanisms which will be supported by this instance of
     * Connection (i.e. which this XMPP client will support).
     * @param {SASLMechanism[]} mechanisms - Array of objects with SASLMechanism prototypes
     */
    registerSASLMechanisms(mechanisms) {
        this.mechanisms = {};
        (
            mechanisms || [
                SASLAnonymous,
                SASLExternal,
                SASLOAuthBearer,
                SASLXOAuth2,
                SASLPlain,
                SASLSHA1,
                SASLSHA256,
                SASLSHA384,
                SASLSHA512,
            ]
        ).forEach((m) => this.registerSASLMechanism(m));
    }

    /**
     * Register a single SASL mechanism, to be supported by this client.
     * @param {any} Mechanism - Object with a Strophe.SASLMechanism prototype
     */
    registerSASLMechanism(Mechanism) {
        const mechanism = new Mechanism();
        this.mechanisms[mechanism.mechname] = mechanism;
    }

    /**
     * Start the graceful disconnection process.
     *
     * This function starts the disconnection process.  This process starts
     * by sending unavailable presence and sending BOSH body of type
     * terminate.  A timeout handler makes sure that disconnection happens
     * even if the BOSH server does not respond.
     * If the Connection object isn't connected, at least tries to abort all pending requests
     * so the connection object won't generate successful requests (which were already opened).
     *
     * The user supplied connection callback will be notified of the
     * progress as this process happens.
     *
     * @param {string} [reason] - The reason the disconnect is occuring.
     */
    disconnect(reason) {
        this._changeConnectStatus(Status.DISCONNECTING, reason);
        if (reason) {
            log.info('Disconnect was called because: ' + reason);
        } else {
            log.debug('Disconnect was called');
        }
        if (this.connected) {
            let pres = null;
            this.disconnecting = true;
            if (this.authenticated) {
                pres = $pres({
                    'xmlns': NS.CLIENT,
                    'type': 'unavailable',
                });
            }
            // setup timeout handler
            this._disconnectTimeout = this._addSysTimedHandler(
                this.disconnection_timeout,
                this._onDisconnectTimeout.bind(this)
            );
            this._proto._disconnect(pres);
        } else {
            log.debug('Disconnect was called before Strophe connected to the server');
            this._proto._abortAllRequests();
            this._doDisconnect();
        }
    }

    /**
     * _Private_ helper function that makes sure plugins and the user's
     * callback are notified of connection status changes.
     * @param {number} status - the new connection status, one of the values
     *     in Strophe.Status
     * @param {string|null} [condition] - the error condition
     * @param {Element} [elem] - The triggering stanza.
     */
    _changeConnectStatus(status, condition, elem) {
        // notify all plugins listening for status changes
        for (const k in connectionPlugins) {
            if (Object.prototype.hasOwnProperty.call(connectionPlugins, k)) {
                // @ts-ignore
                const plugin = this[k];
                if (plugin.statusChanged) {
                    try {
                        plugin.statusChanged(status, condition);
                    } catch (err) {
                        log.error(`${k} plugin caused an exception changing status: ${err}`);
                    }
                }
            }
        }
        // notify the user's callback
        if (this.connect_callback) {
            try {
                this.connect_callback(status, condition, elem);
            } catch (e) {
                handleError(e);
                log.error(`User connection callback caused an exception: ${e}`);
            }
        }
    }

    /**
     * _Private_ function to disconnect.
     *
     * This is the last piece of the disconnection logic.  This resets the
     * connection and alerts the user's connection callback.
     * @param {string|null} [condition] - the error condition
     */
    _doDisconnect(condition) {
        if (typeof this._idleTimeout === 'number') {
            clearTimeout(this._idleTimeout);
        }

        // Cancel Disconnect Timeout
        if (this._disconnectTimeout !== null) {
            this.deleteTimedHandler(this._disconnectTimeout);
            this._disconnectTimeout = null;
        }

        log.debug('_doDisconnect was called');
        this._proto._doDisconnect();

        this.authenticated = false;
        this.disconnecting = false;
        this.restored = false;

        // delete handlers
        this.handlers = [];
        this.timedHandlers = [];
        this.removeTimeds = [];
        this.removeHandlers = [];
        this.addTimeds = [];
        this.addHandlers = [];

        // tell the parent we disconnected
        this._changeConnectStatus(Status.DISCONNECTED, condition);
        this.connected = false;
    }

    /**
     * _Private_ handler to processes incoming data from the the connection.
     *
     * Except for _connect_cb handling the initial connection request,
     * this function handles the incoming data for all requests.  This
     * function also fires stanza handlers that match each incoming
     * stanza.
     * @param {Element | Request} req - The request that has data ready.
     * @param {string} [raw] - The stanza as raw string.
     */
    _dataRecv(req, raw) {
        const elem = /** @type {Element} */ (
            '_reqToData' in this._proto ? this._proto._reqToData(/** @type {Request} */ (req)) : req
        );
        if (elem === null) {
            return;
        }

        if (this.xmlInput !== Connection.prototype.xmlInput) {
            if (elem.nodeName === this._proto.strip && elem.childNodes.length) {
                this.xmlInput(elem.childNodes[0]);
            } else {
                this.xmlInput(elem);
            }
        }
        if (this.rawInput !== Connection.prototype.rawInput) {
            if (raw) {
                this.rawInput(raw);
            } else {
                this.rawInput(Builder.serialize(elem));
            }
        }

        // remove handlers scheduled for deletion
        while (this.removeHandlers.length > 0) {
            const hand = this.removeHandlers.pop();
            const i = this.handlers.indexOf(hand);
            if (i >= 0) {
                this.handlers.splice(i, 1);
            }
        }

        // add handlers scheduled for addition
        while (this.addHandlers.length > 0) {
            this.handlers.push(this.addHandlers.pop());
        }

        // handle graceful disconnect
        if (this.disconnecting && this._proto._emptyQueue()) {
            this._doDisconnect();
            return;
        }

        const type = elem.getAttribute('type');
        if (type !== null && type === 'terminate') {
            // Don't process stanzas that come in after disconnect
            if (this.disconnecting) {
                return;
            }
            // an error occurred
            let cond = elem.getAttribute('condition');
            const conflict = elem.getElementsByTagName('conflict');
            if (cond !== null) {
                if (cond === 'remote-stream-error' && conflict.length > 0) {
                    cond = 'conflict';
                }
                this._changeConnectStatus(Status.CONNFAIL, cond);
            } else {
                this._changeConnectStatus(Status.CONNFAIL, ErrorCondition.UNKNOWN_REASON);
            }
            this._doDisconnect(cond);
            return;
        }

        // send each incoming stanza through the handler chain
        forEachChild(
            elem,
            null,
            /** @param {Element} child */
            (child) => {
                const matches = [];
                this.handlers = this.handlers.reduce((handlers, handler) => {
                    try {
                        if (handler.isMatch(child) && (this.authenticated || !handler.user)) {
                            if (handler.run(child)) {
                                handlers.push(handler);
                            }
                            matches.push(handler);
                        } else {
                            handlers.push(handler);
                        }
                    } catch (e) {
                        // if the handler throws an exception, we consider it as false
                        log.warn('Removing Strophe handlers due to uncaught exception: ' + e.message);
                    }

                    return handlers;
                }, []);

                // If no handler was fired for an incoming IQ with type="set",
                // then we return an IQ error stanza with service-unavailable.
                if (!matches.length && this.iqFallbackHandler.isMatch(child)) {
                    this.iqFallbackHandler.run(child);
                }
            }
        );
    }

    /**
     * @callback connectionCallback
     * @param {Connection} connection
     */

    /**
     * _Private_ handler for initial connection request.
     *
     * This handler is used to process the initial connection request
     * response from the BOSH server. It is used to set up authentication
     * handlers and start the authentication process.
     *
     * SASL authentication will be attempted if available, otherwise
     * the code will fall back to legacy authentication.
     *
     * @param {Element | Request} req - The current request.
     * @param {connectionCallback} _callback - low level (xmpp) connect callback function.
     *     Useful for plugins with their own xmpp connect callback (when they
     *     want to do something special).
     * @param {string} [raw] - The stanza as raw string.
     */
    _connect_cb(req, _callback, raw) {
        log.debug('_connect_cb was called');
        this.connected = true;

        let bodyWrap;
        try {
            bodyWrap = /** @type {Element} */ (
                '_reqToData' in this._proto ? this._proto._reqToData(/** @type {Request} */ (req)) : req
            );
        } catch (e) {
            if (e.name !== ErrorCondition.BAD_FORMAT) {
                throw e;
            }
            this._changeConnectStatus(Status.CONNFAIL, ErrorCondition.BAD_FORMAT);
            this._doDisconnect(ErrorCondition.BAD_FORMAT);
        }
        if (!bodyWrap) {
            return;
        }

        if (this.xmlInput !== Connection.prototype.xmlInput) {
            if (bodyWrap.nodeName === this._proto.strip && bodyWrap.childNodes.length) {
                this.xmlInput(bodyWrap.childNodes[0]);
            } else {
                this.xmlInput(bodyWrap);
            }
        }
        if (this.rawInput !== Connection.prototype.rawInput) {
            if (raw) {
                this.rawInput(raw);
            } else {
                this.rawInput(Builder.serialize(bodyWrap));
            }
        }

        const conncheck = this._proto._connect_cb(bodyWrap);
        if (conncheck === Status.CONNFAIL) {
            return;
        }

        // Check for the stream:features tag
        let hasFeatures;
        if (bodyWrap.getElementsByTagNameNS) {
            hasFeatures = bodyWrap.getElementsByTagNameNS(NS.STREAM, 'features').length > 0;
        } else {
            hasFeatures =
                bodyWrap.getElementsByTagName('stream:features').length > 0 ||
                bodyWrap.getElementsByTagName('features').length > 0;
        }
        if (!hasFeatures) {
            this._proto._no_auth_received(_callback);
            return;
        }

        const matched = Array.from(bodyWrap.getElementsByTagName('mechanism'))
            .map((m) => this.mechanisms[m.textContent])
            .filter((m) => m);

        if (matched.length === 0) {
            if (bodyWrap.getElementsByTagName('auth').length === 0) {
                // There are no matching SASL mechanisms and also no legacy
                // auth available.
                this._proto._no_auth_received(_callback);
                return;
            }
        }
        if (this.do_authentication !== false) {
            this.authenticate(matched);
        }
    }

    /**
     * Sorts an array of objects with prototype SASLMechanism according to
     * their priorities.
     * @param {SASLMechanism[]} mechanisms - Array of SASL mechanisms.
     */
    // eslint-disable-next-line  class-methods-use-this
    sortMechanismsByPriority(mechanisms) {
        // Sorting mechanisms according to priority.
        for (let i = 0; i < mechanisms.length - 1; ++i) {
            let higher = i;
            for (let j = i + 1; j < mechanisms.length; ++j) {
                if (mechanisms[j].priority > mechanisms[higher].priority) {
                    higher = j;
                }
            }
            if (higher !== i) {
                const swap = mechanisms[i];
                mechanisms[i] = mechanisms[higher];
                mechanisms[higher] = swap;
            }
        }
        return mechanisms;
    }

    /**
     * Set up authentication
     *
     * Continues the initial connection request by setting up authentication
     * handlers and starting the authentication process.
     *
     * SASL authentication will be attempted if available, otherwise
     * the code will fall back to legacy authentication.
     *
     * @param {SASLMechanism[]} matched - Array of SASL mechanisms supported.
     */
    authenticate(matched) {
        if (!this._attemptSASLAuth(matched)) {
            this._attemptLegacyAuth();
        }
    }

    /**
     * Iterate through an array of SASL mechanisms and attempt authentication
     * with the highest priority (enabled) mechanism.
     *
     * @private
     * @param {SASLMechanism[]} mechanisms - Array of SASL mechanisms.
     * @return {Boolean} mechanism_found - true or false, depending on whether a
     *  valid SASL mechanism was found with which authentication could be started.
     */
    _attemptSASLAuth(mechanisms) {
        mechanisms = this.sortMechanismsByPriority(mechanisms || []);
        let mechanism_found = false;
        for (let i = 0; i < mechanisms.length; ++i) {
            if (!mechanisms[i].test(this)) {
                continue;
            }
            this._sasl_success_handler = this._addSysHandler(
                this._sasl_success_cb.bind(this),
                null,
                'success',
                null,
                null
            );
            this._sasl_failure_handler = this._addSysHandler(
                this._sasl_failure_cb.bind(this),
                null,
                'failure',
                null,
                null
            );
            this._sasl_challenge_handler = this._addSysHandler(
                this._sasl_challenge_cb.bind(this),
                null,
                'challenge',
                null,
                null
            );

            this._sasl_mechanism = mechanisms[i];
            this._sasl_mechanism.onStart(this);

            const request_auth_exchange = $build('auth', {
                'xmlns': NS.SASL,
                'mechanism': this._sasl_mechanism.mechname,
            });
            if (this._sasl_mechanism.isClientFirst) {
                const response = this._sasl_mechanism.clientChallenge(this);
                request_auth_exchange.t(btoa(/** @type {string} */ (response)));
            }
            this.send(request_auth_exchange.tree());
            mechanism_found = true;
            break;
        }
        return mechanism_found;
    }

    /**
     * _Private_ handler for the SASL challenge
     * @private
     * @param {Element} elem
     */
    async _sasl_challenge_cb(elem) {
        const challenge = atob(getText(elem));
        const response = await this._sasl_mechanism.onChallenge(this, challenge);
        const stanza = $build('response', { 'xmlns': NS.SASL });
        if (response) stanza.t(btoa(response));
        this.send(stanza.tree());
        return true;
    }

    /**
     * Attempt legacy (i.e. non-SASL) authentication.
     * @private
     */
    _attemptLegacyAuth() {
        if (getNodeFromJid(this.jid) === null) {
            // we don't have a node, which is required for non-anonymous
            // client connections
            this._changeConnectStatus(Status.CONNFAIL, ErrorCondition.MISSING_JID_NODE);
            this.disconnect(ErrorCondition.MISSING_JID_NODE);
        } else {
            // Fall back to legacy authentication
            this._changeConnectStatus(Status.AUTHENTICATING, null);
            this._addSysHandler(this._onLegacyAuthIQResult.bind(this), null, null, null, '_auth_1');
            this.send(
                $iq({
                    'type': 'get',
                    'to': this.domain,
                    'id': '_auth_1',
                })
                    .c('query', { xmlns: NS.AUTH })
                    .c('username', {})
                    .t(getNodeFromJid(this.jid))
                    .tree()
            );
        }
    }

    /**
     * _Private_ handler for legacy authentication.
     *
     * This handler is called in response to the initial <iq type='get'/>
     * for legacy authentication.  It builds an authentication <iq/> and
     * sends it, creating a handler (calling back to _auth2_cb()) to
     * handle the result
     * @private
     * @return {false} `false` to remove the handler.
     */
    _onLegacyAuthIQResult() {
        const pass = typeof this.pass === 'string' ? this.pass : '';

        // build plaintext auth iq
        const iq = $iq({ type: 'set', id: '_auth_2' })
            .c('query', { xmlns: NS.AUTH })
            .c('username', {})
            .t(getNodeFromJid(this.jid))
            .up()
            .c('password')
            .t(pass);

        if (!getResourceFromJid(this.jid)) {
            // since the user has not supplied a resource, we pick
            // a default one here.  unlike other auth methods, the server
            // cannot do this for us.
            this.jid = getBareJidFromJid(this.jid) + '/strophe';
        }
        iq.up().c('resource', {}).t(getResourceFromJid(this.jid));

        this._addSysHandler(this._auth2_cb.bind(this), null, null, null, '_auth_2');
        this.send(iq.tree());
        return false;
    }

    /**
     * _Private_ handler for succesful SASL authentication.
     * @private
     * @param {Element} elem - The matching stanza.
     * @return {false} `false` to remove the handler.
     */
    _sasl_success_cb(elem) {
        if (this._sasl_data['server-signature']) {
            let serverSignature;
            const success = atob(getText(elem));
            const attribMatch = /([a-z]+)=([^,]+)(,|$)/;
            const matches = success.match(attribMatch);
            if (matches[1] === 'v') {
                serverSignature = matches[2];
            }
            if (serverSignature !== this._sasl_data['server-signature']) {
                // remove old handlers
                this.deleteHandler(this._sasl_failure_handler);
                this._sasl_failure_handler = null;
                if (this._sasl_challenge_handler) {
                    this.deleteHandler(this._sasl_challenge_handler);
                    this._sasl_challenge_handler = null;
                }
                this._sasl_data = {};
                return this._sasl_failure_cb(null);
            }
        }
        log.info('SASL authentication succeeded.');

        if (this._sasl_data.keys) {
            this.scram_keys = this._sasl_data.keys;
        }

        if (this._sasl_mechanism) {
            this._sasl_mechanism.onSuccess();
        }
        // remove old handlers
        this.deleteHandler(this._sasl_failure_handler);
        this._sasl_failure_handler = null;
        if (this._sasl_challenge_handler) {
            this.deleteHandler(this._sasl_challenge_handler);
            this._sasl_challenge_handler = null;
        }
        /** @type {Handler[]} */
        const streamfeature_handlers = [];

        /**
         * @param {Handler[]} handlers
         * @param {Element} elem
         */
        const wrapper = (handlers, elem) => {
            while (handlers.length) {
                this.deleteHandler(handlers.pop());
            }
            this._onStreamFeaturesAfterSASL(elem);
            return false;
        };

        streamfeature_handlers.push(
            this._addSysHandler(
                /** @param {Element} elem */
                (elem) => wrapper(streamfeature_handlers, elem),
                null,
                'stream:features',
                null,
                null
            )
        );

        streamfeature_handlers.push(
            this._addSysHandler(
                /** @param {Element} elem */
                (elem) => wrapper(streamfeature_handlers, elem),
                NS.STREAM,
                'features',
                null,
                null
            )
        );

        // we must send an xmpp:restart now
        this._sendRestart();
        return false;
    }

    /**
     * @private
     * @param {Element} elem - The matching stanza.
     * @return {false} `false` to remove the handler.
     */
    _onStreamFeaturesAfterSASL(elem) {
        // save stream:features for future usage
        this.features = elem;
        for (let i = 0; i < elem.childNodes.length; i++) {
            const child = elem.childNodes[i];
            if (child.nodeName === 'bind') {
                this.do_bind = true;
            }
            if (child.nodeName === 'session') {
                this.do_session = true;
            }
        }

        if (!this.do_bind) {
            this._changeConnectStatus(Status.AUTHFAIL, null);
            return false;
        } else if (!this.options.explicitResourceBinding) {
            this.bind();
        } else {
            this._changeConnectStatus(Status.BINDREQUIRED, null);
        }
        return false;
    }

    /**
     * Sends an IQ to the XMPP server to bind a JID resource for this session.
     *
     * https://tools.ietf.org/html/rfc6120#section-7.5
     *
     * If `explicitResourceBinding` was set to a truthy value in the options
     * passed to the Connection constructor, then this function needs
     * to be called explicitly by the client author.
     *
     * Otherwise it'll be called automatically as soon as the XMPP server
     * advertises the "urn:ietf:params:xml:ns:xmpp-bind" stream feature.
     */
    bind() {
        if (!this.do_bind) {
            log.info(`Connection.prototype.bind called but "do_bind" is false`);
            return;
        }
        this._addSysHandler(this._onResourceBindResultIQ.bind(this), null, null, null, '_bind_auth_2');

        const resource = getResourceFromJid(this.jid);
        if (resource) {
            this.send(
                $iq({ type: 'set', id: '_bind_auth_2' })
                    .c('bind', { xmlns: NS.BIND })
                    .c('resource', {})
                    .t(resource)
                    .tree()
            );
        } else {
            this.send($iq({ type: 'set', id: '_bind_auth_2' }).c('bind', { xmlns: NS.BIND }).tree());
        }
    }

    /**
     * _Private_ handler for binding result and session start.
     * @private
     * @param {Element} elem - The matching stanza.
     * @return {false} `false` to remove the handler.
     */
    _onResourceBindResultIQ(elem) {
        if (elem.getAttribute('type') === 'error') {
            log.warn('Resource binding failed.');
            const conflict = elem.getElementsByTagName('conflict');
            let condition;
            if (conflict.length > 0) {
                condition = ErrorCondition.CONFLICT;
            }
            this._changeConnectStatus(Status.AUTHFAIL, condition, elem);
            return false;
        }
        // TODO - need to grab errors
        const bind = elem.getElementsByTagName('bind');
        if (bind.length > 0) {
            const jidNode = bind[0].getElementsByTagName('jid');
            if (jidNode.length > 0) {
                this.authenticated = true;
                this.jid = getText(jidNode[0]);
                if (this.do_session) {
                    this._establishSession();
                } else {
                    this._changeConnectStatus(Status.CONNECTED, null);
                }
            }
        } else {
            log.warn('Resource binding failed.');
            this._changeConnectStatus(Status.AUTHFAIL, null, elem);
            return false;
        }
    }

    /**
     * Send IQ request to establish a session with the XMPP server.
     *
     * See https://xmpp.org/rfcs/rfc3921.html#session
     *
     * Note: The protocol for session establishment has been determined as
     * unnecessary and removed in RFC-6121.
     * @private
     */
    _establishSession() {
        if (!this.do_session) {
            throw new Error(
                `Connection.prototype._establishSession ` +
                    `called but apparently ${NS.SESSION} wasn't advertised by the server`
            );
        }
        this._addSysHandler(this._onSessionResultIQ.bind(this), null, null, null, '_session_auth_2');

        this.send($iq({ type: 'set', id: '_session_auth_2' }).c('session', { xmlns: NS.SESSION }).tree());
    }

    /**
     * _Private_ handler for the server's IQ response to a client's session
     * request.
     *
     * This sets Connection.authenticated to true on success, which
     * starts the processing of user handlers.
     *
     * See https://xmpp.org/rfcs/rfc3921.html#session
     *
     * Note: The protocol for session establishment has been determined as
     * unnecessary and removed in RFC-6121.
     * @private
     * @param {Element} elem - The matching stanza.
     * @return {false} `false` to remove the handler.
     */
    _onSessionResultIQ(elem) {
        if (elem.getAttribute('type') === 'result') {
            this.authenticated = true;
            this._changeConnectStatus(Status.CONNECTED, null);
        } else if (elem.getAttribute('type') === 'error') {
            this.authenticated = false;
            log.warn('Session creation failed.');
            this._changeConnectStatus(Status.AUTHFAIL, null, elem);
            return false;
        }
        return false;
    }

    /**
     * _Private_ handler for SASL authentication failure.
     * @param {Element} [elem] - The matching stanza.
     * @return {false} `false` to remove the handler.
     */
    _sasl_failure_cb(elem) {
        // delete unneeded handlers
        if (this._sasl_success_handler) {
            this.deleteHandler(this._sasl_success_handler);
            this._sasl_success_handler = null;
        }
        if (this._sasl_challenge_handler) {
            this.deleteHandler(this._sasl_challenge_handler);
            this._sasl_challenge_handler = null;
        }

        if (this._sasl_mechanism) this._sasl_mechanism.onFailure();
        this._changeConnectStatus(Status.AUTHFAIL, null, elem);
        return false;
    }

    /**
     * _Private_ handler to finish legacy authentication.
     *
     * This handler is called when the result from the jabber:iq:auth
     * <iq/> stanza is returned.
     * @private
     * @param {Element} elem - The stanza that triggered the callback.
     * @return {false} `false` to remove the handler.
     */
    _auth2_cb(elem) {
        if (elem.getAttribute('type') === 'result') {
            this.authenticated = true;
            this._changeConnectStatus(Status.CONNECTED, null);
        } else if (elem.getAttribute('type') === 'error') {
            this._changeConnectStatus(Status.AUTHFAIL, null, elem);
            this.disconnect('authentication failed');
        }
        return false;
    }

    /**
     * _Private_ function to add a system level timed handler.
     *
     * This function is used to add a TimedHandler for the
     * library code.  System timed handlers are allowed to run before
     * authentication is complete.
     * @param {number} period - The period of the handler.
     * @param {Function} handler - The callback function.
     */
    _addSysTimedHandler(period, handler) {
        const thand = new TimedHandler(period, handler);
        thand.user = false;
        this.addTimeds.push(thand);
        return thand;
    }

    /**
     * _Private_ function to add a system level stanza handler.
     *
     * This function is used to add a Handler for the
     * library code.  System stanza handlers are allowed to run before
     * authentication is complete.
     * @param {Function} handler - The callback function.
     * @param {string} ns - The namespace to match.
     * @param {string} name - The stanza name to match.
     * @param {string} type - The stanza type attribute to match.
     * @param {string} id - The stanza id attribute to match.
     */
    _addSysHandler(handler, ns, name, type, id) {
        const hand = new Handler(handler, ns, name, type, id);
        hand.user = false;
        this.addHandlers.push(hand);
        return hand;
    }

    /**
     * _Private_ timeout handler for handling non-graceful disconnection.
     *
     * If the graceful disconnect process does not complete within the
     * time allotted, this handler finishes the disconnect anyway.
     * @return {false} `false` to remove the handler.
     */
    _onDisconnectTimeout() {
        log.debug('_onDisconnectTimeout was called');
        this._changeConnectStatus(Status.CONNTIMEOUT, null);
        this._proto._onDisconnectTimeout();
        // actually disconnect
        this._doDisconnect();
        return false;
    }

    /**
     * _Private_ handler to process events during idle cycle.
     *
     * This handler is called every 100ms to fire timed handlers that
     * are ready and keep poll requests going.
     */
    _onIdle() {
        // add timed handlers scheduled for addition
        // NOTE: we add before remove in the case a timed handler is
        // added and then deleted before the next _onIdle() call.
        while (this.addTimeds.length > 0) {
            this.timedHandlers.push(this.addTimeds.pop());
        }

        // remove timed handlers that have been scheduled for deletion
        while (this.removeTimeds.length > 0) {
            const thand = this.removeTimeds.pop();
            const i = this.timedHandlers.indexOf(thand);
            if (i >= 0) {
                this.timedHandlers.splice(i, 1);
            }
        }

        // call ready timed handlers
        const now = new Date().getTime();
        const newList = [];
        for (let i = 0; i < this.timedHandlers.length; i++) {
            const thand = this.timedHandlers[i];
            if (this.authenticated || !thand.user) {
                const since = thand.lastCalled + thand.period;
                if (since - now <= 0) {
                    if (thand.run()) {
                        newList.push(thand);
                    }
                } else {
                    newList.push(thand);
                }
            }
        }
        this.timedHandlers = newList;
        clearTimeout(this._idleTimeout);
        this._proto._onIdle();

        // reactivate the timer only if connected
        if (this.connected) {
            this._idleTimeout = setTimeout(() => this._onIdle(), 100);
        }
    }
}

class UnsafeXML extends String {}

/**
 * A Stanza represents a XML element used in XMPP (commonly referred to as stanzas).
 */
class Stanza extends Builder {
    /** @type {string} */
    #string;
    /** @type {Array<string>} */
    #strings;
    /**
     * @typedef {Array<string|Stanza|Builder>} StanzaValue
     * @type {StanzaValue|Array<StanzaValue>}
     */
    #values;

    /**
     * @param {string[]} strings
     * @param {any[]} values
     */
    constructor(strings, values) {
        super('stanza');
        this.#strings = strings;
        this.#values = values;
    }

    /**
     * A directive which can be used to pass a string of XML as a value to the
     * stx tagged template literal.
     *
     * It's considered "unsafe" because it can pose a security risk if used with
     * untrusted input.
     *
     * @param {string} string
     * @returns {UnsafeXML}
     * @example
     *    const status = '<status>I am busy!</status>';
     *    const pres = stx`
     *       <presence from='juliet@example.com/chamber' id='pres1'>
     *           <show>dnd</show>
     *           ${unsafeXML(status)}
     *       </presence>`;
     *    connection.send(pres);
     */
    static unsafeXML(string) {
        return new UnsafeXML(string);
    }

    /**
     * Turns the passed-in string into an XML Element.
     * @param {string} string
     * @param {boolean} [throwErrorIfInvalidNS]
     * @returns {Element}
     */
    static toElement(string, throwErrorIfInvalidNS) {
        const doc = xmlHtmlNode(string);
        const parserError = getParserError(doc);
        if (parserError) {
            throw new Error(`Parser Error: ${parserError}`);
        }

        const node = stripWhitespace(getFirstElementChild(doc));
        if (
            ['message', 'iq', 'presence'].includes(node.nodeName.toLowerCase()) &&
            node.namespaceURI !== 'jabber:client' &&
            node.namespaceURI !== 'jabber:server'
        ) {
            const err_msg = `Invalid namespaceURI ${node.namespaceURI}`;
            if (throwErrorIfInvalidNS) {
                throw new Error(err_msg);
            } else {
                log.error(err_msg);
            }
        }
        return node;
    }

    buildTree() {
        return Stanza.toElement(this.toString(), true);
    }

    /**
     * @return {string}
     */
    toString() {
        this.#string =
            this.#string ||
            this.#strings
                .reduce((acc, str, idx) => {
                    const value = this.#values.length > idx ? this.#values[idx] : '';
                    return (
                        acc +
                        str +
                        (Array.isArray(value)
                            ? value
                                  .map((v) =>
                                      v instanceof UnsafeXML || v instanceof Builder
                                          ? v
                                          : xmlescape(v.toString())
                                  )
                                  .join('')
                            : value instanceof UnsafeXML || value instanceof Builder
                              ? value
                              : xmlescape((value ?? '').toString()))
                    );
                }, '')
                .trim();

        return this.#string;
    }
}

/**
 * Tagged template literal function which generates {@link Stanza} objects
 *
 * @example
 *      const pres = stx`<presence type="${type}" xmlns="jabber:client"><show>${show}</show></presence>`
 *
 *      connection.send(msg);
 *
 * @example
 *      const msg = stx`<message
 *          from='sender@example.org'
 *          id='hgn27af1'
 *          to='recipient@example.org'
 *          type='chat'>
 *          <body>Hello world</body>
 *      </message>`;
 *
 *      connection.send(msg);
 *
 * @param {string[]} strings
 * @param {...any} values
 * @returns {Stanza}
 */
function stx(strings, ...values) {
    return new Stanza(strings, values);
}

/*global globalThis*/

/**
 * A container for all Strophe library functions.
 *
 * This object is a container for all the objects and constants
 * used in the library.  It is not meant to be instantiated, but to
 * provide a namespace for library objects, constants, and functions.
 *
 * @namespace Strophe
 * @property {Handler} Handler
 * @property {Builder} Builder
 * @property {Request} Request Represents HTTP Requests made for a BOSH connection
 * @property {Bosh} Bosh Support for XMPP-over-HTTP via XEP-0124 (BOSH)
 * @property {Websocket} Websocket Support for XMPP over websocket
 * @property {WorkerWebsocket} WorkerWebsocket Support for XMPP over websocket in a shared worker
 * @property {number} TIMEOUT=1.1 Timeout multiplier. A waiting BOSH HTTP request
 *  will be considered failed after Math.floor(TIMEOUT * wait) seconds have elapsed.
 *  This defaults to 1.1, and with default wait, 66 seconds.
 * @property {number} SECONDARY_TIMEOUT=0.1 Secondary timeout multiplier.
 *  In cases where Strophe can detect early failure, it will consider the request
 *  failed if it doesn't return after `Math.floor(SECONDARY_TIMEOUT * wait)`
 *  seconds have elapsed. This defaults to 0.1, and with default wait, 6 seconds.
 * @property {SASLAnonymous} SASLAnonymous SASL ANONYMOUS authentication.
 * @property {SASLPlain} SASLPlain SASL PLAIN authentication
 * @property {SASLSHA1} SASLSHA1 SASL SCRAM-SHA-1 authentication
 * @property {SASLSHA256} SASLSHA256 SASL SCRAM-SHA-256 authentication
 * @property {SASLSHA384} SASLSHA384 SASL SCRAM-SHA-384 authentication
 * @property {SASLSHA512} SASLSHA512 SASL SCRAM-SHA-512 authentication
 * @property {SASLOAuthBearer} SASLOAuthBearer SASL OAuth Bearer authentication
 * @property {SASLExternal} SASLExternal SASL EXTERNAL authentication
 * @property {SASLXOAuth2} SASLXOAuth2 SASL X-OAuth2 authentication
 * @property {Status} Status
 * @property {Object.<string, string>} NS
 * @property {XHTML} XHTML
 */
const Strophe$1 = {
    /** @constant: VERSION */
    VERSION: '3.0.0',

    /**
     * @returns {number}
     */
    get TIMEOUT() {
        return Bosh.getTimeoutMultplier();
    },

    /**
     * @param {number} n
     */
    set TIMEOUT(n) {
        Bosh.setTimeoutMultiplier(n);
    },

    /**
     * @returns {number}
     */
    get SECONDARY_TIMEOUT() {
        return Bosh.getSecondaryTimeoutMultplier();
    },

    /**
     * @param {number} n
     */
    set SECONDARY_TIMEOUT(n) {
        Bosh.setSecondaryTimeoutMultiplier(n);
    },

    ...utils$1,
    ...log,

    shims,

    Request,

    // Transports
    Bosh,
    Websocket,
    WorkerWebsocket,
    Connection,
    Handler,

    // Available authentication mechanisms
    SASLAnonymous,
    SASLPlain,
    SASLSHA1,
    SASLSHA256,
    SASLSHA384,
    SASLSHA512,
    SASLOAuthBearer,
    SASLExternal,
    SASLXOAuth2,

    Stanza,
    Builder,
    ElementType,
    ErrorCondition,
    LogLevel: LOG_LEVELS,
    /** @type {Object.<string, string>} */
    NS,
    SASLMechanism,
    /** @type {Status} */
    Status,
    TimedHandler,

    XHTML: {
        ...XHTML,
        validTag: validTag,
        validCSS: validCSS,
        validAttribute: validAttribute,
    },

    /**
     * Render a DOM element and all descendants to a String.
     * @method Strophe.serialize
     * @param {Element|Builder} elem - A DOM element.
     * @return {string} - The serialized element tree as a String.
     */
    serialize(elem) {
        return Builder.serialize(elem);
    },

    /**
     * @typedef {import('./constants').LogLevel} LogLevel
     *
     * Library consumers can use this function to set the log level of Strophe.
     * The default log level is Strophe.LogLevel.INFO.
     * @param {LogLevel} level
     * @example Strophe.setLogLevel(Strophe.LogLevel.DEBUG);
     */
    setLogLevel(level) {
        log.setLogLevel(level);
    },

    /**
     * This function is used to extend the current namespaces in
     * Strophe.NS. It takes a key and a value with the key being the
     * name of the new namespace, with its actual value.
     * @example: Strophe.addNamespace('PUBSUB', "http://jabber.org/protocol/pubsub");
     *
     * @param {string} name - The name under which the namespace will be
     *     referenced under Strophe.NS
     * @param {string} value - The actual namespace.
     */
    addNamespace(name, value) {
        Strophe$1.NS[name] = value;
    },

    /**
     * Extends the Strophe.Connection object with the given plugin.
     * @param {string} name - The name of the extension.
     * @param {Object} ptype - The plugin's prototype.
     */
    addConnectionPlugin(name, ptype) {
        Connection.addConnectionPlugin(name, ptype);
    },
};

globalThis.$build = $build;
globalThis.$iq = $iq;
globalThis.$msg = $msg;
globalThis.$pres = $pres;
globalThis.Strophe = Strophe$1;
globalThis.stx = stx;

const toStanza = Stanza.toElement;
globalThis.toStanza = Stanza.toElement; // Deprecated

var src$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Builder: Builder,
  $build: $build,
  $iq: $iq,
  $msg: $msg,
  $pres: $pres,
  Strophe: Strophe$1,
  Stanza: Stanza,
  stx: stx,
  toStanza: toStanza,
  Request: Request
});

/**
 * Implementation of atob() according to the HTML and Infra specs, except that
 * instead of throwing INVALID_CHARACTER_ERR we return null.
 */
function atob$1(data) {
  if (arguments.length === 0) {
    throw new TypeError("1 argument required, but only 0 present.");
  }

  // Web IDL requires DOMStrings to just be converted using ECMAScript
  // ToString, which in our case amounts to using a template literal.
  data = `${data}`;
  // "Remove all ASCII whitespace from data."
  data = data.replace(/[ \t\n\f\r]/g, "");
  // "If data's length divides by 4 leaving no remainder, then: if data ends
  // with one or two U+003D (=) code points, then remove them from data."
  if (data.length % 4 === 0) {
    data = data.replace(/==?$/, "");
  }
  // "If data's length divides by 4 leaving a remainder of 1, then return
  // failure."
  //
  // "If data contains a code point that is not one of
  //
  // U+002B (+)
  // U+002F (/)
  // ASCII alphanumeric
  //
  // then return failure."
  if (data.length % 4 === 1 || /[^+/0-9A-Za-z]/.test(data)) {
    return null;
  }
  // "Let output be an empty byte sequence."
  let output = "";
  // "Let buffer be an empty buffer that can have bits appended to it."
  //
  // We append bits via left-shift and or.  accumulatedBits is used to track
  // when we've gotten to 24 bits.
  let buffer = 0;
  let accumulatedBits = 0;
  // "Let position be a position variable for data, initially pointing at the
  // start of data."
  //
  // "While position does not point past the end of data:"
  for (let i = 0; i < data.length; i++) {
    // "Find the code point pointed to by position in the second column of
    // Table 1: The Base 64 Alphabet of RFC 4648. Let n be the number given in
    // the first cell of the same row.
    //
    // "Append to buffer the six bits corresponding to n, most significant bit
    // first."
    //
    // atobLookup() implements the table from RFC 4648.
    buffer <<= 6;
    buffer |= atobLookup(data[i]);
    accumulatedBits += 6;
    // "If buffer has accumulated 24 bits, interpret them as three 8-bit
    // big-endian numbers. Append three bytes with values equal to those
    // numbers to output, in the same order, and then empty buffer."
    if (accumulatedBits === 24) {
      output += String.fromCharCode((buffer & 0xff0000) >> 16);
      output += String.fromCharCode((buffer & 0xff00) >> 8);
      output += String.fromCharCode(buffer & 0xff);
      buffer = accumulatedBits = 0;
    }
    // "Advance position by 1."
  }
  // "If buffer is not empty, it contains either 12 or 18 bits. If it contains
  // 12 bits, then discard the last four and interpret the remaining eight as
  // an 8-bit big-endian number. If it contains 18 bits, then discard the last
  // two and interpret the remaining 16 as two 8-bit big-endian numbers. Append
  // the one or two bytes with values equal to those one or two numbers to
  // output, in the same order."
  if (accumulatedBits === 12) {
    buffer >>= 4;
    output += String.fromCharCode(buffer);
  } else if (accumulatedBits === 18) {
    buffer >>= 2;
    output += String.fromCharCode((buffer & 0xff00) >> 8);
    output += String.fromCharCode(buffer & 0xff);
  }
  // "Return output."
  return output;
}
/**
 * A lookup table for atob(), which converts an ASCII character to the
 * corresponding six-bit number.
 */

const keystr =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

function atobLookup(chr) {
  const index = keystr.indexOf(chr);
  // Throw exception if character is not in the lookup string; should not be hit in tests
  return index < 0 ? undefined : index;
}

var atob_1 = atob$1;

/**
 * btoa() as defined by the HTML and Infra specs, which mostly just references
 * RFC 4648.
 */
function btoa$1(s) {
  if (arguments.length === 0) {
    throw new TypeError("1 argument required, but only 0 present.");
  }

  let i;
  // String conversion as required by Web IDL.
  s = `${s}`;
  // "The btoa() method must throw an "InvalidCharacterError" DOMException if
  // data contains any character whose code point is greater than U+00FF."
  for (i = 0; i < s.length; i++) {
    if (s.charCodeAt(i) > 255) {
      return null;
    }
  }
  let out = "";
  for (i = 0; i < s.length; i += 3) {
    const groupsOfSix = [undefined, undefined, undefined, undefined];
    groupsOfSix[0] = s.charCodeAt(i) >> 2;
    groupsOfSix[1] = (s.charCodeAt(i) & 0x03) << 4;
    if (s.length > i + 1) {
      groupsOfSix[1] |= s.charCodeAt(i + 1) >> 4;
      groupsOfSix[2] = (s.charCodeAt(i + 1) & 0x0f) << 2;
    }
    if (s.length > i + 2) {
      groupsOfSix[2] |= s.charCodeAt(i + 2) >> 6;
      groupsOfSix[3] = s.charCodeAt(i + 2) & 0x3f;
    }
    for (let j = 0; j < groupsOfSix.length; j++) {
      if (typeof groupsOfSix[j] === "undefined") {
        out += "=";
      } else {
        out += btoaLookup(groupsOfSix[j]);
      }
    }
  }
  return out;
}

/**
 * Lookup table for btoa(), which converts a six-bit number into the
 * corresponding ASCII character.
 */
const keystr$1 =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

function btoaLookup(index) {
  if (index >= 0 && index < 64) {
    return keystr$1[index];
  }

  // Throw INVALID_CHARACTER_ERR exception here -- won't be hit in the tests.
  return undefined;
}

var btoa_1 = btoa$1;

var abab = {
  atob: atob_1,
  btoa: btoa_1
};
var abab_1 = abab.atob;
var abab_2 = abab.btoa;

var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};

/*
 * This module provides uniform
 * Shims APIs and globals that are not present in all JS environments,
 * the most common example for Strophe being browser APIs like WebSocket
 * and DOM that don't exist under nodejs.
 *
 * Usually these will be supplied in nodejs by conditionally requiring a
 * NPM module that provides a compatible implementation.
 */

/* global global */

/**
 * WHATWG WebSockets API
 * https://www.w3.org/TR/websockets/
 *
 * Interface to use the web socket protocol
 *
 * Used implementations:
 * - supported browsers: built-in in WebSocket global
 *   https://developer.mozilla.org/en-US/docs/Web/API/WebSocket#Browser_compatibility
 * - nodejs: use standard-compliant 'ws' module
 *   https://www.npmjs.com/package/ws
 */
function getWebSocketImplementation$1() {
  let WebSocketImplementation = global$1.WebSocket;
  if (typeof WebSocketImplementation === 'undefined') {
    try {
      WebSocketImplementation = require('ws');
    } catch (err) {
      throw new Error('You must install the "ws" package to use Strophe in nodejs.');
    }
  }
  return WebSocketImplementation;
}
const WebSocket$1 = getWebSocketImplementation$1();

/**
 * DOMParser
 * https://w3c.github.io/DOM-Parsing/#the-domparser-interface
 *
 * Interface to parse XML strings into Document objects
 *
 * Used implementations:
 * - supported browsers: built-in in DOMParser global
 *   https://developer.mozilla.org/en-US/docs/Web/API/DOMParser#Browser_compatibility
 * - nodejs: use '@xmldom/xmldom' module
 *   https://www.npmjs.com/package/@xmldom/xmldom
 */
function getDOMParserImplementation$1() {
  let DOMParserImplementation = global$1.DOMParser;
  if (typeof DOMParserImplementation === 'undefined') {
    try {
      DOMParserImplementation = require('@xmldom/xmldom').DOMParser;
    } catch (err) {
      throw new Error('You must install the "@xmldom/xmldom" package to use Strophe in nodejs.');
    }
  }
  return DOMParserImplementation;
}
const DOMParser$2 = getDOMParserImplementation$1();

/**
 *  Gets IE xml doc object. Used by getDummyXMLDocument shim.
 *
 *  Returns:
 *    A Microsoft XML DOM Object
 *  See Also:
 *    http://msdn.microsoft.com/en-us/library/ms757837%28VS.85%29.aspx
 */
function _getIEXmlDom() {
  const docStrings = ["Msxml2.DOMDocument.6.0", "Msxml2.DOMDocument.5.0", "Msxml2.DOMDocument.4.0", "MSXML2.DOMDocument.3.0", "MSXML2.DOMDocument", "MSXML.DOMDocument", "Microsoft.XMLDOM"];
  for (let d = 0; d < docStrings.length; d++) {
    try {
      // eslint-disable-next-line no-undef
      const doc = new ActiveXObject(docStrings[d]);
      return doc;
    } catch (e) {
      // Try next one
    }
  }
}

/**
 * Creates a dummy XML DOM document to serve as an element and text node generator.
 *
 * Used implementations:
 *  - IE < 10: avoid using createDocument() due to a memory leak, use ie-specific
 *    workaround
 *  - other supported browsers: use document's createDocument
 *  - nodejs: use '@xmldom/xmldom'
 */
function getDummyXMLDOMDocument$1() {
  // nodejs
  if (typeof document === 'undefined') {
    try {
      const DOMImplementation = require('@xmldom/xmldom').DOMImplementation;
      return new DOMImplementation().createDocument('jabber:client', 'strophe', null);
    } catch (err) {
      throw new Error('You must install the "@xmldom/xmldom" package to use Strophe in nodejs.');
    }
  }
  // IE < 10
  if (document.implementation.createDocument === undefined || document.implementation.createDocument && document.documentMode && document.documentMode < 10) {
    const doc = _getIEXmlDom();
    doc.appendChild(doc.createElement('strophe'));
    return doc;
  }
  // All other supported browsers
  return document.implementation.createDocument('jabber:client', 'strophe', null);
}

/** Class: Strophe.SASLMechanism
 *
 *  Encapsulates an SASL authentication mechanism.
 *
 *  User code may override the priority for each mechanism or disable it completely.
 *  See <priority> for information about changing priority and <test> for informatian on
 *  how to disable a mechanism.
 *
 *  By default, all mechanisms are enabled and the priorities are
 *
 *      SCRAM-SHA-512 - 72
 *      SCRAM-SHA-384 - 71
 *      SCRAM-SHA-256 - 70
 *      SCRAM-SHA-1   - 60
 *      PLAIN         - 50
 *      OAUTHBEARER   - 40
 *      X-OAUTH2      - 30
 *      ANONYMOUS     - 20
 *      EXTERNAL      - 10
 *
 *  See: Strophe.Connection.addSupportedSASLMechanisms
 */
class SASLMechanism$1 {
  /**
   * PrivateConstructor: Strophe.SASLMechanism
   * SASL auth mechanism abstraction.
   *
   *  Parameters:
   *    (String) name - SASL Mechanism name.
   *    (Boolean) isClientFirst - If client should send response first without challenge.
   *    (Number) priority - Priority.
   *
   *  Returns:
   *    A new Strophe.SASLMechanism object.
   */
  constructor(name, isClientFirst, priority) {
    /** PrivateVariable: mechname
     *  Mechanism name.
     */
    this.mechname = name;

    /** PrivateVariable: isClientFirst
     *  If client sends response without initial server challenge.
     */
    this.isClientFirst = isClientFirst;

    /** Variable: priority
     *  Determines which <SASLMechanism> is chosen for authentication (Higher is better).
     *  Users may override this to prioritize mechanisms differently.
     *
     *  Example: (This will cause Strophe to choose the mechanism that the server sent first)
     *
     *  > Strophe.SASLPlain.priority = Strophe.SASLSHA1.priority;
     *
     *  See <SASL mechanisms> for a list of available mechanisms.
     *
     */
    this.priority = priority;
  }

  /**
   *  Function: test
   *  Checks if mechanism able to run.
   *  To disable a mechanism, make this return false;
   *
   *  To disable plain authentication run
   *  > Strophe.SASLPlain.test = function() {
   *  >   return false;
   *  > }
   *
   *  See <SASL mechanisms> for a list of available mechanisms.
   *
   *  Parameters:
   *    (Strophe.Connection) connection - Target Connection.
   *
   *  Returns:
   *    (Boolean) If mechanism was able to run.
   */
  test() {
    // eslint-disable-line class-methods-use-this
    return true;
  }

  /** PrivateFunction: onStart
   *  Called before starting mechanism on some connection.
   *
   *  Parameters:
   *    (Strophe.Connection) connection - Target Connection.
   */
  onStart(connection) {
    this._connection = connection;
  }

  /** PrivateFunction: onChallenge
   *  Called by protocol implementation on incoming challenge.
   *
   *  By deafult, if the client is expected to send data first (isClientFirst === true),
   *  this method is called with `challenge` as null on the first call,
   *  unless `clientChallenge` is overridden in the relevant subclass.
   *
   *  Parameters:
   *    (Strophe.Connection) connection - Target Connection.
   *    (String) challenge - current challenge to handle.
   *
   *  Returns:
   *    (String) Mechanism response.
   */
  onChallenge(connection, challenge) {
    // eslint-disable-line
    throw new Error("You should implement challenge handling!");
  }

  /** PrivateFunction: clientChallenge
   *  Called by the protocol implementation if the client is expected to send
   *  data first in the authentication exchange (i.e. isClientFirst === true).
   *
   *  Parameters:
   *    (Strophe.Connection) connection - Target Connection.
   *
   *  Returns:
   *    (String) Mechanism response.
   */
  clientChallenge(connection) {
    if (!this.isClientFirst) {
      throw new Error("clientChallenge should not be called if isClientFirst is false!");
    }
    return this.onChallenge(connection);
  }

  /** PrivateFunction: onFailure
   *  Protocol informs mechanism implementation about SASL failure.
   */
  onFailure() {
    this._connection = null;
  }

  /** PrivateFunction: onSuccess
   *  Protocol informs mechanism implementation about SASL success.
   */
  onSuccess() {
    this._connection = null;
  }
}

// Building SASL callbacks

class SASLAnonymous$1 extends SASLMechanism$1 {
  /** PrivateConstructor: SASLAnonymous
   *  SASL ANONYMOUS authentication.
   */
  constructor() {
    let mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ANONYMOUS';
    let isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
    super(mechname, isClientFirst, priority);
  }
  test(connection) {
    // eslint-disable-line class-methods-use-this
    return connection.authcid === null;
  }
}

class SASLExternal$1 extends SASLMechanism$1 {
  /** PrivateConstructor: SASLExternal
   *  SASL EXTERNAL authentication.
   *
   *  The EXTERNAL mechanism allows a client to request the server to use
   *  credentials established by means external to the mechanism to
   *  authenticate the client. The external means may be, for instance,
   *  TLS services.
   */
  constructor() {
    let mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'EXTERNAL';
    let isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    super(mechname, isClientFirst, priority);
  }
  onChallenge(connection) {
    // eslint-disable-line class-methods-use-this
    /** According to XEP-178, an authzid SHOULD NOT be presented when the
     * authcid contained or implied in the client certificate is the JID (i.e.
     * authzid) with which the user wants to log in as.
     *
     * To NOT send the authzid, the user should therefore set the authcid equal
     * to the JID when instantiating a new Strophe.Connection object.
     */
    return connection.authcid === connection.authzid ? '' : connection.authzid;
  }
}

const utils$2 = {
  utf16to8(str) {
    let out = "";
    const len = str.length;
    for (let i = 0; i < len; i++) {
      const c = str.charCodeAt(i);
      if (c >= 0x0000 && c <= 0x007F) {
        out += str.charAt(i);
      } else if (c > 0x07FF) {
        out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
        out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
        out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
      } else {
        out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
        out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
      }
    }
    return out;
  },
  xorArrayBuffers(x, y) {
    const xIntArray = new Uint8Array(x);
    const yIntArray = new Uint8Array(y);
    const zIntArray = new Uint8Array(x.byteLength);
    for (let i = 0; i < x.byteLength; i++) {
      zIntArray[i] = xIntArray[i] ^ yIntArray[i];
    }
    return zIntArray.buffer;
  },
  arrayBufToBase64(buffer) {
    // This function is due to mobz (https://stackoverflow.com/users/1234628/mobz)
    //  and Emmanuel (https://stackoverflow.com/users/288564/emmanuel)
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  },
  base64ToArrayBuf(str) {
    var _Uint8Array$from;
    return (_Uint8Array$from = Uint8Array.from(atob(str), c => c.charCodeAt(0))) === null || _Uint8Array$from === void 0 ? void 0 : _Uint8Array$from.buffer;
  },
  stringToArrayBuf(str) {
    const bytes = new TextEncoder("utf-8").encode(str);
    return bytes.buffer;
  },
  addCookies(cookies) {
    /* Parameters:
     *  (Object) cookies - either a map of cookie names
     *    to string values or to maps of cookie values.
     *
     * For example:
     * { "myCookie": "1234" }
     *
     * or:
     * { "myCookie": {
     *      "value": "1234",
     *      "domain": ".example.org",
     *      "path": "/",
     *      "expires": expirationDate
     *      }
     *  }
     *
     *  These values get passed to Strophe.Connection via
     *   options.cookies
     */
    cookies = cookies || {};
    for (const cookieName in cookies) {
      if (Object.prototype.hasOwnProperty.call(cookies, cookieName)) {
        let expires = '';
        let domain = '';
        let path = '';
        const cookieObj = cookies[cookieName];
        const isObj = typeof cookieObj === "object";
        const cookieValue = escape(unescape(isObj ? cookieObj.value : cookieObj));
        if (isObj) {
          expires = cookieObj.expires ? ";expires=" + cookieObj.expires : '';
          domain = cookieObj.domain ? ";domain=" + cookieObj.domain : '';
          path = cookieObj.path ? ";path=" + cookieObj.path : '';
        }
        document.cookie = cookieName + '=' + cookieValue + expires + domain + path;
      }
    }
  }
};

class SASLOAuthBearer$1 extends SASLMechanism$1 {
  /** PrivateConstructor: SASLOAuthBearer
   *  SASL OAuth Bearer authentication.
   */
  constructor() {
    let mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'OAUTHBEARER';
    let isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 40;
    super(mechname, isClientFirst, priority);
  }
  test(connection) {
    // eslint-disable-line class-methods-use-this
    return connection.pass !== null;
  }
  onChallenge(connection) {
    // eslint-disable-line class-methods-use-this
    let auth_str = 'n,';
    if (connection.authcid !== null) {
      auth_str = auth_str + 'a=' + connection.authzid;
    }
    auth_str = auth_str + ',';
    auth_str = auth_str + "\u0001";
    auth_str = auth_str + 'auth=Bearer ';
    auth_str = auth_str + connection.pass;
    auth_str = auth_str + "\u0001";
    auth_str = auth_str + "\u0001";
    return utils$2.utf16to8(auth_str);
  }
}

class SASLPlain$1 extends SASLMechanism$1 {
  /** PrivateConstructor: SASLPlain
   *  SASL PLAIN authentication.
   */
  constructor() {
    let mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PLAIN';
    let isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
    super(mechname, isClientFirst, priority);
  }
  test(connection) {
    // eslint-disable-line class-methods-use-this
    return connection.authcid !== null;
  }
  onChallenge(connection) {
    // eslint-disable-line class-methods-use-this
    const {
      authcid,
      authzid,
      domain,
      pass
    } = connection;
    if (!domain) {
      throw new Error("SASLPlain onChallenge: domain is not defined!");
    }
    // Only include authzid if it differs from authcid.
    // See: https://tools.ietf.org/html/rfc6120#section-6.3.8
    let auth_str = authzid !== `${authcid}@${domain}` ? authzid : '';
    auth_str = auth_str + "\u0000";
    auth_str = auth_str + authcid;
    auth_str = auth_str + "\u0000";
    auth_str = auth_str + pass;
    return utils$2.utf16to8(auth_str);
  }
}

async function scramClientProof$1(authMessage, clientKey, hashName) {
  const storedKey = await window.crypto.subtle.importKey("raw", await window.crypto.subtle.digest(hashName, clientKey), {
    "name": "HMAC",
    "hash": hashName
  }, false, ["sign"]);
  const clientSignature = await window.crypto.subtle.sign("HMAC", storedKey, utils$2.stringToArrayBuf(authMessage));
  return utils$2.xorArrayBuffers(clientKey, clientSignature);
}

/* This function parses the information in a SASL SCRAM challenge response,
 * into an object of the form
 * { nonce: String,
 *   salt:  ArrayBuffer,
 *   iter:  Int
 * }
 * Returns undefined on failure.
 */
function scramParseChallenge$1(challenge) {
  let nonce, salt, iter;
  const attribMatch = /([a-z]+)=([^,]+)(,|$)/;
  while (challenge.match(attribMatch)) {
    const matches = challenge.match(attribMatch);
    challenge = challenge.replace(matches[0], "");
    switch (matches[1]) {
      case "r":
        nonce = matches[2];
        break;
      case "s":
        salt = utils$2.base64ToArrayBuf(matches[2]);
        break;
      case "i":
        iter = parseInt(matches[2], 10);
        break;
      default:
        return undefined;
    }
  }

  // Consider iteration counts less than 4096 insecure, as reccommended by
  // RFC 5802
  if (isNaN(iter) || iter < 4096) {
    Strophe$2.warn("Failing SCRAM authentication because server supplied iteration count < 4096.");
    return undefined;
  }
  if (!salt) {
    Strophe$2.warn("Failing SCRAM authentication because server supplied incorrect salt.");
    return undefined;
  }
  return {
    "nonce": nonce,
    "salt": salt,
    "iter": iter
  };
}

/* Derive the client and server keys given a string password,
 * a hash name, and a bit length.
 * Returns an object of the following form:
 * { ck: ArrayBuffer, the client key
 *   sk: ArrayBuffer, the server key
 * }
 */
async function scramDeriveKeys$1(password, salt, iter, hashName, hashBits) {
  const saltedPasswordBits = await window.crypto.subtle.deriveBits({
    "name": "PBKDF2",
    "salt": salt,
    "iterations": iter,
    "hash": {
      "name": hashName
    }
  }, await window.crypto.subtle.importKey("raw", utils$2.stringToArrayBuf(password), "PBKDF2", false, ["deriveBits"]), hashBits);
  const saltedPassword = await window.crypto.subtle.importKey("raw", saltedPasswordBits, {
    "name": "HMAC",
    "hash": hashName
  }, false, ["sign"]);
  return {
    "ck": await window.crypto.subtle.sign("HMAC", saltedPassword, utils$2.stringToArrayBuf("Client Key")),
    "sk": await window.crypto.subtle.sign("HMAC", saltedPassword, utils$2.stringToArrayBuf("Server Key"))
  };
}
async function scramServerSign$1(authMessage, sk, hashName) {
  const serverKey = await window.crypto.subtle.importKey("raw", sk, {
    "name": "HMAC",
    "hash": hashName
  }, false, ["sign"]);
  return window.crypto.subtle.sign("HMAC", serverKey, utils$2.stringToArrayBuf(authMessage));
}

// Generate an ASCII nonce (not containing the ',' character)
function generate_cnonce$1() {
  // generate 16 random bytes of nonce, base64 encoded
  const bytes = new Uint8Array(16);
  return utils$2.arrayBufToBase64(crypto.getRandomValues(bytes).buffer);
}
const scram$1 = {
  /* On success, sets
   * connection_sasl_data["server-signature"]
   * and
   * connection._sasl_data.keys
   *
   * The server signature should be verified after this function completes..
   *
   * On failure, returns connection._sasl_failure_cb();
   */
  async scramResponse(connection, challenge, hashName, hashBits) {
    var _connection$pass, _connection$pass2, _connection$pass3;
    const cnonce = connection._sasl_data.cnonce;
    const challengeData = scramParseChallenge$1(challenge);

    // The RFC requires that we verify the (server) nonce has the client
    // nonce as an initial substring.
    if (!challengeData && (challengeData === null || challengeData === void 0 ? void 0 : challengeData.nonce.slice(0, cnonce.length)) !== cnonce) {
      Strophe$2.warn("Failing SCRAM authentication because server supplied incorrect nonce.");
      connection._sasl_data = {};
      return connection._sasl_failure_cb();
    }
    let clientKey, serverKey;

    // Either restore the client key and server key passed in, or derive new ones
    if (((_connection$pass = connection.pass) === null || _connection$pass === void 0 ? void 0 : _connection$pass.name) === hashName && ((_connection$pass2 = connection.pass) === null || _connection$pass2 === void 0 ? void 0 : _connection$pass2.salt) === utils$2.arrayBufToBase64(challengeData.salt) && ((_connection$pass3 = connection.pass) === null || _connection$pass3 === void 0 ? void 0 : _connection$pass3.iter) === challengeData.iter) {
      clientKey = utils$2.base64ToArrayBuf(connection.pass.ck);
      serverKey = utils$2.base64ToArrayBuf(connection.pass.sk);
    } else if (typeof connection.pass === "string" || connection.pass instanceof String) {
      const keys = await scramDeriveKeys$1(connection.pass, challengeData.salt, challengeData.iter, hashName, hashBits);
      clientKey = keys.ck;
      serverKey = keys.sk;
    } else {
      return connection._sasl_failure_cb();
    }
    const clientFirstMessageBare = connection._sasl_data["client-first-message-bare"];
    const serverFirstMessage = challenge;
    const clientFinalMessageBare = `c=biws,r=${challengeData.nonce}`;
    const authMessage = `${clientFirstMessageBare},${serverFirstMessage},${clientFinalMessageBare}`;
    const clientProof = await scramClientProof$1(authMessage, clientKey, hashName);
    const serverSignature = await scramServerSign$1(authMessage, serverKey, hashName);
    connection._sasl_data["server-signature"] = utils$2.arrayBufToBase64(serverSignature);
    connection._sasl_data.keys = {
      "name": hashName,
      "iter": challengeData.iter,
      "salt": utils$2.arrayBufToBase64(challengeData.salt),
      "ck": utils$2.arrayBufToBase64(clientKey),
      "sk": utils$2.arrayBufToBase64(serverKey)
    };
    return `${clientFinalMessageBare},p=${utils$2.arrayBufToBase64(clientProof)}`;
  },
  // Returns a string containing the client first message
  clientChallenge(connection, test_cnonce) {
    const cnonce = test_cnonce || generate_cnonce$1();
    const client_first_message_bare = `n=${connection.authcid},r=${cnonce}`;
    connection._sasl_data.cnonce = cnonce;
    connection._sasl_data["client-first-message-bare"] = client_first_message_bare;
    return `n,,${client_first_message_bare}`;
  }
};

class SASLSHA1$1 extends SASLMechanism$1 {
  /** PrivateConstructor: SASLSHA1
   *  SASL SCRAM SHA 1 authentication.
   */
  constructor() {
    let mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SCRAM-SHA-1';
    let isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60;
    super(mechname, isClientFirst, priority);
  }
  test(connection) {
    // eslint-disable-line class-methods-use-this
    return connection.authcid !== null;
  }
  async onChallenge(connection, challenge) {
    // eslint-disable-line class-methods-use-this, require-await
    return scram$1.scramResponse(connection, challenge, "SHA-1", 160);
  }
  clientChallenge(connection, test_cnonce) {
    // eslint-disable-line class-methods-use-this
    return scram$1.clientChallenge(connection, test_cnonce);
  }
}

class SASLSHA256$1 extends SASLMechanism$1 {
  /** PrivateConstructor: SASLSHA256
   *  SASL SCRAM SHA 256 authentication.
   */
  constructor() {
    let mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SCRAM-SHA-256';
    let isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 70;
    super(mechname, isClientFirst, priority);
  }
  test(connection) {
    // eslint-disable-line class-methods-use-this
    return connection.authcid !== null;
  }
  async onChallenge(connection, challenge) {
    // eslint-disable-line class-methods-use-this, require-await
    return scram$1.scramResponse(connection, challenge, "SHA-256", 256);
  }
  clientChallenge(connection, test_cnonce) {
    // eslint-disable-line class-methods-use-this
    return scram$1.clientChallenge(connection, test_cnonce);
  }
}

class SASLSHA384$1 extends SASLMechanism$1 {
  /** PrivateConstructor: SASLSHA384
   *  SASL SCRAM SHA 384 authentication.
   */
  constructor() {
    let mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SCRAM-SHA-384';
    let isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 71;
    super(mechname, isClientFirst, priority);
  }
  test(connection) {
    // eslint-disable-line class-methods-use-this
    return connection.authcid !== null;
  }
  async onChallenge(connection, challenge) {
    // eslint-disable-line class-methods-use-this, require-await
    return scram$1.scramResponse(connection, challenge, "SHA-384", 384);
  }
  clientChallenge(connection, test_cnonce) {
    // eslint-disable-line class-methods-use-this
    return scram$1.clientChallenge(connection, test_cnonce);
  }
}

class SASLSHA512$1 extends SASLMechanism$1 {
  /** PrivateConstructor: SASLSHA512
   *  SASL SCRAM SHA 512 authentication.
   */
  constructor() {
    let mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'SCRAM-SHA-512';
    let isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 72;
    super(mechname, isClientFirst, priority);
  }
  test(connection) {
    // eslint-disable-line class-methods-use-this
    return connection.authcid !== null;
  }
  async onChallenge(connection, challenge) {
    // eslint-disable-line class-methods-use-this, require-await
    return scram$1.scramResponse(connection, challenge, "SHA-512", 512);
  }
  clientChallenge(connection, test_cnonce) {
    // eslint-disable-line class-methods-use-this
    return scram$1.clientChallenge(connection, test_cnonce);
  }
}

class SASLXOAuth2$1 extends SASLMechanism$1 {
  /** PrivateConstructor: SASLXOAuth2
   *  SASL X-OAuth2 authentication.
   */
  constructor() {
    let mechname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'X-OAUTH2';
    let isClientFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 30;
    super(mechname, isClientFirst, priority);
  }
  test(connection) {
    // eslint-disable-line class-methods-use-this
    return connection.pass !== null;
  }
  onChallenge(connection) {
    // eslint-disable-line class-methods-use-this
    let auth_str = '\u0000';
    if (connection.authcid !== null) {
      auth_str = auth_str + connection.authzid;
    }
    auth_str = auth_str + "\u0000";
    auth_str = auth_str + connection.pass;
    return utils$2.utf16to8(auth_str);
  }
}

/*
    This program is distributed under the terms of the MIT license.
    Please see the LICENSE file for details.

    Copyright 2006-2018, OGG, LLC
*/

/** Function: $build
 *  Create a Strophe.Builder.
 *  This is an alias for 'new Strophe.Builder(name, attrs)'.
 *
 *  Parameters:
 *    (String) name - The root element name.
 *    (Object) attrs - The attributes for the root element in object notation.
 *
 *  Returns:
 *    A new Strophe.Builder object.
 */
function $build$1(name, attrs) {
  return new Strophe$2.Builder(name, attrs);
}

/** Function: $msg
 *  Create a Strophe.Builder with a <message/> element as the root.
 *
 *  Parameters:
 *    (Object) attrs - The <message/> element attributes in object notation.
 *
 *  Returns:
 *    A new Strophe.Builder object.
 */
function $msg$1(attrs) {
  return new Strophe$2.Builder("message", attrs);
}

/** Function: $iq
 *  Create a Strophe.Builder with an <iq/> element as the root.
 *
 *  Parameters:
 *    (Object) attrs - The <iq/> element attributes in object notation.
 *
 *  Returns:
 *    A new Strophe.Builder object.
 */
function $iq$1(attrs) {
  return new Strophe$2.Builder("iq", attrs);
}

/** Function: $pres
 *  Create a Strophe.Builder with a <presence/> element as the root.
 *
 *  Parameters:
 *    (Object) attrs - The <presence/> element attributes in object notation.
 *
 *  Returns:
 *    A new Strophe.Builder object.
 */
function $pres$1(attrs) {
  return new Strophe$2.Builder("presence", attrs);
}

/** Class: Strophe
 *  An object container for all Strophe library functions.
 *
 *  This class is just a container for all the objects and constants
 *  used in the library.  It is not meant to be instantiated, but to
 *  provide a namespace for library objects, constants, and functions.
 */
const Strophe$2 = {
  /** Constant: VERSION */
  VERSION: "1.6.0",
  /** Constants: XMPP Namespace Constants
   *  Common namespace constants from the XMPP RFCs and XEPs.
   *
   *  NS.HTTPBIND - HTTP BIND namespace from XEP 124.
   *  NS.BOSH - BOSH namespace from XEP 206.
   *  NS.CLIENT - Main XMPP client namespace.
   *  NS.AUTH - Legacy authentication namespace.
   *  NS.ROSTER - Roster operations namespace.
   *  NS.PROFILE - Profile namespace.
   *  NS.DISCO_INFO - Service discovery info namespace from XEP 30.
   *  NS.DISCO_ITEMS - Service discovery items namespace from XEP 30.
   *  NS.MUC - Multi-User Chat namespace from XEP 45.
   *  NS.SASL - XMPP SASL namespace from RFC 3920.
   *  NS.STREAM - XMPP Streams namespace from RFC 3920.
   *  NS.BIND - XMPP Binding namespace from RFC 3920 and RFC 6120.
   *  NS.SESSION - XMPP Session namespace from RFC 3920.
   *  NS.XHTML_IM - XHTML-IM namespace from XEP 71.
   *  NS.XHTML - XHTML body namespace from XEP 71.
   */
  NS: {
    HTTPBIND: "http://jabber.org/protocol/httpbind",
    BOSH: "urn:xmpp:xbosh",
    CLIENT: "jabber:client",
    AUTH: "jabber:iq:auth",
    ROSTER: "jabber:iq:roster",
    PROFILE: "jabber:iq:profile",
    DISCO_INFO: "http://jabber.org/protocol/disco#info",
    DISCO_ITEMS: "http://jabber.org/protocol/disco#items",
    MUC: "http://jabber.org/protocol/muc",
    SASL: "urn:ietf:params:xml:ns:xmpp-sasl",
    STREAM: "http://etherx.jabber.org/streams",
    FRAMING: "urn:ietf:params:xml:ns:xmpp-framing",
    BIND: "urn:ietf:params:xml:ns:xmpp-bind",
    SESSION: "urn:ietf:params:xml:ns:xmpp-session",
    VERSION: "jabber:iq:version",
    STANZAS: "urn:ietf:params:xml:ns:xmpp-stanzas",
    XHTML_IM: "http://jabber.org/protocol/xhtml-im",
    XHTML: "http://www.w3.org/1999/xhtml"
  },
  /** Constants: XHTML_IM Namespace
   *  contains allowed tags, tag attributes, and css properties.
   *  Used in the createHtml function to filter incoming html into the allowed XHTML-IM subset.
   *  See http://xmpp.org/extensions/xep-0071.html#profile-summary for the list of recommended
   *  allowed tags and their attributes.
   */
  XHTML: {
    tags: ['a', 'blockquote', 'br', 'cite', 'em', 'img', 'li', 'ol', 'p', 'span', 'strong', 'ul', 'body'],
    attributes: {
      'a': ['href'],
      'blockquote': ['style'],
      'br': [],
      'cite': ['style'],
      'em': [],
      'img': ['src', 'alt', 'style', 'height', 'width'],
      'li': ['style'],
      'ol': ['style'],
      'p': ['style'],
      'span': ['style'],
      'strong': [],
      'ul': ['style'],
      'body': []
    },
    css: ['background-color', 'color', 'font-family', 'font-size', 'font-style', 'font-weight', 'margin-left', 'margin-right', 'text-align', 'text-decoration'],
    /** Function: XHTML.validTag
     *
     * Utility method to determine whether a tag is allowed
     * in the XHTML_IM namespace.
     *
     * XHTML tag names are case sensitive and must be lower case.
     */
    validTag(tag) {
      for (let i = 0; i < Strophe$2.XHTML.tags.length; i++) {
        if (tag === Strophe$2.XHTML.tags[i]) {
          return true;
        }
      }
      return false;
    },
    /** Function: XHTML.validAttribute
     *
     * Utility method to determine whether an attribute is allowed
     * as recommended per XEP-0071
     *
     * XHTML attribute names are case sensitive and must be lower case.
     */
    validAttribute(tag, attribute) {
      if (typeof Strophe$2.XHTML.attributes[tag] !== 'undefined' && Strophe$2.XHTML.attributes[tag].length > 0) {
        for (let i = 0; i < Strophe$2.XHTML.attributes[tag].length; i++) {
          if (attribute === Strophe$2.XHTML.attributes[tag][i]) {
            return true;
          }
        }
      }
      return false;
    },
    validCSS(style) {
      for (let i = 0; i < Strophe$2.XHTML.css.length; i++) {
        if (style === Strophe$2.XHTML.css[i]) {
          return true;
        }
      }
      return false;
    }
  },
  /** Constants: Connection Status Constants
   *  Connection status constants for use by the connection handler
   *  callback.
   *
   *  Status.ERROR - An error has occurred
   *  Status.CONNECTING - The connection is currently being made
   *  Status.CONNFAIL - The connection attempt failed
   *  Status.AUTHENTICATING - The connection is authenticating
   *  Status.AUTHFAIL - The authentication attempt failed
   *  Status.CONNECTED - The connection has succeeded
   *  Status.DISCONNECTED - The connection has been terminated
   *  Status.DISCONNECTING - The connection is currently being terminated
   *  Status.ATTACHED - The connection has been attached
   *  Status.REDIRECT - The connection has been redirected
   *  Status.CONNTIMEOUT - The connection has timed out
   */
  Status: {
    ERROR: 0,
    CONNECTING: 1,
    CONNFAIL: 2,
    AUTHENTICATING: 3,
    AUTHFAIL: 4,
    CONNECTED: 5,
    DISCONNECTED: 6,
    DISCONNECTING: 7,
    ATTACHED: 8,
    REDIRECT: 9,
    CONNTIMEOUT: 10,
    BINDREQUIRED: 11,
    ATTACHFAIL: 12
  },
  ErrorCondition: {
    BAD_FORMAT: "bad-format",
    CONFLICT: "conflict",
    MISSING_JID_NODE: "x-strophe-bad-non-anon-jid",
    NO_AUTH_MECH: "no-auth-mech",
    UNKNOWN_REASON: "unknown"
  },
  /** Constants: Log Level Constants
   *  Logging level indicators.
   *
   *  LogLevel.DEBUG - Debug output
   *  LogLevel.INFO - Informational output
   *  LogLevel.WARN - Warnings
   *  LogLevel.ERROR - Errors
   *  LogLevel.FATAL - Fatal errors
   */
  LogLevel: {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    FATAL: 4
  },
  /** PrivateConstants: DOM Element Type Constants
   *  DOM element types.
   *
   *  ElementType.NORMAL - Normal element.
   *  ElementType.TEXT - Text data element.
   *  ElementType.FRAGMENT - XHTML fragment element.
   */
  ElementType: {
    NORMAL: 1,
    TEXT: 3,
    CDATA: 4,
    FRAGMENT: 11
  },
  /** PrivateConstants: Timeout Values
   *  Timeout values for error states.  These values are in seconds.
   *  These should not be changed unless you know exactly what you are
   *  doing.
   *
   *  TIMEOUT - Timeout multiplier. A waiting request will be considered
   *      failed after Math.floor(TIMEOUT * wait) seconds have elapsed.
   *      This defaults to 1.1, and with default wait, 66 seconds.
   *  SECONDARY_TIMEOUT - Secondary timeout multiplier. In cases where
   *      Strophe can detect early failure, it will consider the request
   *      failed if it doesn't return after
   *      Math.floor(SECONDARY_TIMEOUT * wait) seconds have elapsed.
   *      This defaults to 0.1, and with default wait, 6 seconds.
   */
  TIMEOUT: 1.1,
  SECONDARY_TIMEOUT: 0.1,
  /** Function: addNamespace
   *  This function is used to extend the current namespaces in
   *  Strophe.NS.  It takes a key and a value with the key being the
   *  name of the new namespace, with its actual value.
   *  For example:
   *  Strophe.addNamespace('PUBSUB', "http://jabber.org/protocol/pubsub");
   *
   *  Parameters:
   *    (String) name - The name under which the namespace will be
   *      referenced under Strophe.NS
   *    (String) value - The actual namespace.
   */
  addNamespace(name, value) {
    Strophe$2.NS[name] = value;
  },
  /** Function: forEachChild
   *  Map a function over some or all child elements of a given element.
   *
   *  This is a small convenience function for mapping a function over
   *  some or all of the children of an element.  If elemName is null, all
   *  children will be passed to the function, otherwise only children
   *  whose tag names match elemName will be passed.
   *
   *  Parameters:
   *    (XMLElement) elem - The element to operate on.
   *    (String) elemName - The child element tag name filter.
   *    (Function) func - The function to apply to each child.  This
   *      function should take a single argument, a DOM element.
   */
  forEachChild(elem, elemName, func) {
    for (let i = 0; i < elem.childNodes.length; i++) {
      const childNode = elem.childNodes[i];
      if (childNode.nodeType === Strophe$2.ElementType.NORMAL && (!elemName || this.isTagEqual(childNode, elemName))) {
        func(childNode);
      }
    }
  },
  /** Function: isTagEqual
   *  Compare an element's tag name with a string.
   *
   *  This function is case sensitive.
   *
   *  Parameters:
   *    (XMLElement) el - A DOM element.
   *    (String) name - The element name.
   *
   *  Returns:
   *    true if the element's tag name matches _el_, and false
   *    otherwise.
   */
  isTagEqual(el, name) {
    return el.tagName === name;
  },
  /** PrivateVariable: _xmlGenerator
   *  _Private_ variable that caches a DOM document to
   *  generate elements.
   */
  _xmlGenerator: null,
  /** Function: xmlGenerator
   *  Get the DOM document to generate elements.
   *
   *  Returns:
   *    The currently used DOM document.
   */
  xmlGenerator() {
    if (!Strophe$2._xmlGenerator) {
      Strophe$2._xmlGenerator = getDummyXMLDOMDocument$1();
    }
    return Strophe$2._xmlGenerator;
  },
  /** Function: xmlElement
   *  Create an XML DOM element.
   *
   *  This function creates an XML DOM element correctly across all
   *  implementations. Note that these are not HTML DOM elements, which
   *  aren't appropriate for XMPP stanzas.
   *
   *  Parameters:
   *    (String) name - The name for the element.
   *    (Array|Object) attrs - An optional array or object containing
   *      key/value pairs to use as element attributes. The object should
   *      be in the format {'key': 'value'} or {key: 'value'}. The array
   *      should have the format [['key1', 'value1'], ['key2', 'value2']].
   *    (String) text - The text child data for the element.
   *
   *  Returns:
   *    A new XML DOM element.
   */
  xmlElement(name) {
    if (!name) {
      return null;
    }
    const node = Strophe$2.xmlGenerator().createElement(name);
    // FIXME: this should throw errors if args are the wrong type or
    // there are more than two optional args
    for (let a = 1; a < arguments.length; a++) {
      const arg = arguments[a];
      if (!arg) {
        continue;
      }
      if (typeof arg === "string" || typeof arg === "number") {
        node.appendChild(Strophe$2.xmlTextNode(arg));
      } else if (typeof arg === "object" && typeof arg.sort === "function") {
        for (let i = 0; i < arg.length; i++) {
          const attr = arg[i];
          if (typeof attr === "object" && typeof attr.sort === "function" && attr[1] !== undefined && attr[1] !== null) {
            node.setAttribute(attr[0], attr[1]);
          }
        }
      } else if (typeof arg === "object") {
        for (const k in arg) {
          if (Object.prototype.hasOwnProperty.call(arg, k) && arg[k] !== undefined && arg[k] !== null) {
            node.setAttribute(k, arg[k]);
          }
        }
      }
    }
    return node;
  },
  /*  Function: xmlescape
   *  Excapes invalid xml characters.
   *
   *  Parameters:
   *     (String) text - text to escape.
   *
   *  Returns:
   *      Escaped text.
   */
  xmlescape(text) {
    text = text.replace(/\&/g, "&amp;");
    text = text.replace(/</g, "&lt;");
    text = text.replace(/>/g, "&gt;");
    text = text.replace(/'/g, "&apos;");
    text = text.replace(/"/g, "&quot;");
    return text;
  },
  /*  Function: xmlunescape
  *  Unexcapes invalid xml characters.
  *
  *  Parameters:
  *     (String) text - text to unescape.
  *
  *  Returns:
  *      Unescaped text.
  */
  xmlunescape(text) {
    text = text.replace(/\&amp;/g, "&");
    text = text.replace(/&lt;/g, "<");
    text = text.replace(/&gt;/g, ">");
    text = text.replace(/&apos;/g, "'");
    text = text.replace(/&quot;/g, "\"");
    return text;
  },
  /** Function: xmlTextNode
   *  Creates an XML DOM text node.
   *
   *  Provides a cross implementation version of document.createTextNode.
   *
   *  Parameters:
   *    (String) text - The content of the text node.
   *
   *  Returns:
   *    A new XML DOM text node.
   */
  xmlTextNode(text) {
    return Strophe$2.xmlGenerator().createTextNode(text);
  },
  /** Function: xmlHtmlNode
   *  Creates an XML DOM html node.
   *
   *  Parameters:
   *    (String) html - The content of the html node.
   *
   *  Returns:
   *    A new XML DOM text node.
   */
  xmlHtmlNode(html) {
    let node;
    //ensure text is escaped
    if (DOMParser$2) {
      const parser = new DOMParser$2();
      node = parser.parseFromString(html, "text/xml");
    } else {
      node = new ActiveXObject("Microsoft.XMLDOM");
      node.async = "false";
      node.loadXML(html);
    }
    return node;
  },
  /** Function: getText
   *  Get the concatenation of all text children of an element.
   *
   *  Parameters:
   *    (XMLElement) elem - A DOM element.
   *
   *  Returns:
   *    A String with the concatenated text of all text element children.
   */
  getText(elem) {
    if (!elem) {
      return null;
    }
    let str = "";
    if (elem.childNodes.length === 0 && elem.nodeType === Strophe$2.ElementType.TEXT) {
      str += elem.nodeValue;
    }
    for (let i = 0; i < elem.childNodes.length; i++) {
      if (elem.childNodes[i].nodeType === Strophe$2.ElementType.TEXT) {
        str += elem.childNodes[i].nodeValue;
      }
    }
    return Strophe$2.xmlescape(str);
  },
  /** Function: copyElement
   *  Copy an XML DOM element.
   *
   *  This function copies a DOM element and all its descendants and returns
   *  the new copy.
   *
   *  Parameters:
   *    (XMLElement) elem - A DOM element.
   *
   *  Returns:
   *    A new, copied DOM element tree.
   */
  copyElement(elem) {
    let el;
    if (elem.nodeType === Strophe$2.ElementType.NORMAL) {
      el = Strophe$2.xmlElement(elem.tagName);
      for (let i = 0; i < elem.attributes.length; i++) {
        el.setAttribute(elem.attributes[i].nodeName, elem.attributes[i].value);
      }
      for (let i = 0; i < elem.childNodes.length; i++) {
        el.appendChild(Strophe$2.copyElement(elem.childNodes[i]));
      }
    } else if (elem.nodeType === Strophe$2.ElementType.TEXT) {
      el = Strophe$2.xmlGenerator().createTextNode(elem.nodeValue);
    }
    return el;
  },
  /** Function: createHtml
   *  Copy an HTML DOM element into an XML DOM.
   *
   *  This function copies a DOM element and all its descendants and returns
   *  the new copy.
   *
   *  Parameters:
   *    (HTMLElement) elem - A DOM element.
   *
   *  Returns:
   *    A new, copied DOM element tree.
   */
  createHtml(elem) {
    let el;
    if (elem.nodeType === Strophe$2.ElementType.NORMAL) {
      const tag = elem.nodeName.toLowerCase(); // XHTML tags must be lower case.
      if (Strophe$2.XHTML.validTag(tag)) {
        try {
          el = Strophe$2.xmlElement(tag);
          for (let i = 0; i < Strophe$2.XHTML.attributes[tag].length; i++) {
            const attribute = Strophe$2.XHTML.attributes[tag][i];
            let value = elem.getAttribute(attribute);
            if (typeof value === 'undefined' || value === null || value === '' || value === false || value === 0) {
              continue;
            }
            if (attribute === 'style' && typeof value === 'object' && typeof value.cssText !== 'undefined') {
              value = value.cssText; // we're dealing with IE, need to get CSS out
            }
            // filter out invalid css styles
            if (attribute === 'style') {
              const css = [];
              const cssAttrs = value.split(';');
              for (let j = 0; j < cssAttrs.length; j++) {
                const attr = cssAttrs[j].split(':');
                const cssName = attr[0].replace(/^\s*/, "").replace(/\s*$/, "").toLowerCase();
                if (Strophe$2.XHTML.validCSS(cssName)) {
                  const cssValue = attr[1].replace(/^\s*/, "").replace(/\s*$/, "");
                  css.push(cssName + ': ' + cssValue);
                }
              }
              if (css.length > 0) {
                value = css.join('; ');
                el.setAttribute(attribute, value);
              }
            } else {
              el.setAttribute(attribute, value);
            }
          }
          for (let i = 0; i < elem.childNodes.length; i++) {
            el.appendChild(Strophe$2.createHtml(elem.childNodes[i]));
          }
        } catch (e) {
          // invalid elements
          el = Strophe$2.xmlTextNode('');
        }
      } else {
        el = Strophe$2.xmlGenerator().createDocumentFragment();
        for (let i = 0; i < elem.childNodes.length; i++) {
          el.appendChild(Strophe$2.createHtml(elem.childNodes[i]));
        }
      }
    } else if (elem.nodeType === Strophe$2.ElementType.FRAGMENT) {
      el = Strophe$2.xmlGenerator().createDocumentFragment();
      for (let i = 0; i < elem.childNodes.length; i++) {
        el.appendChild(Strophe$2.createHtml(elem.childNodes[i]));
      }
    } else if (elem.nodeType === Strophe$2.ElementType.TEXT) {
      el = Strophe$2.xmlTextNode(elem.nodeValue);
    }
    return el;
  },
  /** Function: escapeNode
   *  Escape the node part (also called local part) of a JID.
   *
   *  Parameters:
   *    (String) node - A node (or local part).
   *
   *  Returns:
   *    An escaped node (or local part).
   */
  escapeNode(node) {
    if (typeof node !== "string") {
      return node;
    }
    return node.replace(/^\s+|\s+$/g, '').replace(/\\/g, "\\5c").replace(/ /g, "\\20").replace(/\"/g, "\\22").replace(/\&/g, "\\26").replace(/\'/g, "\\27").replace(/\//g, "\\2f").replace(/:/g, "\\3a").replace(/</g, "\\3c").replace(/>/g, "\\3e").replace(/@/g, "\\40");
  },
  /** Function: unescapeNode
   *  Unescape a node part (also called local part) of a JID.
   *
   *  Parameters:
   *    (String) node - A node (or local part).
   *
   *  Returns:
   *    An unescaped node (or local part).
   */
  unescapeNode(node) {
    if (typeof node !== "string") {
      return node;
    }
    return node.replace(/\\20/g, " ").replace(/\\22/g, '"').replace(/\\26/g, "&").replace(/\\27/g, "'").replace(/\\2f/g, "/").replace(/\\3a/g, ":").replace(/\\3c/g, "<").replace(/\\3e/g, ">").replace(/\\40/g, "@").replace(/\\5c/g, "\\");
  },
  /** Function: getNodeFromJid
   *  Get the node portion of a JID String.
   *
   *  Parameters:
   *    (String) jid - A JID.
   *
   *  Returns:
   *    A String containing the node.
   */
  getNodeFromJid(jid) {
    if (jid.indexOf("@") < 0) {
      return null;
    }
    return jid.split("@")[0];
  },
  /** Function: getDomainFromJid
   *  Get the domain portion of a JID String.
   *
   *  Parameters:
   *    (String) jid - A JID.
   *
   *  Returns:
   *    A String containing the domain.
   */
  getDomainFromJid(jid) {
    const bare = Strophe$2.getBareJidFromJid(jid);
    if (bare.indexOf("@") < 0) {
      return bare;
    } else {
      const parts = bare.split("@");
      parts.splice(0, 1);
      return parts.join('@');
    }
  },
  /** Function: getResourceFromJid
   *  Get the resource portion of a JID String.
   *
   *  Parameters:
   *    (String) jid - A JID.
   *
   *  Returns:
   *    A String containing the resource.
   */
  getResourceFromJid(jid) {
    if (!jid) {
      return null;
    }
    const s = jid.split("/");
    if (s.length < 2) {
      return null;
    }
    s.splice(0, 1);
    return s.join('/');
  },
  /** Function: getBareJidFromJid
   *  Get the bare JID from a JID String.
   *
   *  Parameters:
   *    (String) jid - A JID.
   *
   *  Returns:
   *    A String containing the bare JID.
   */
  getBareJidFromJid(jid) {
    return jid ? jid.split("/")[0] : null;
  },
  /** PrivateFunction: _handleError
   *  _Private_ function that properly logs an error to the console
   */
  _handleError(e) {
    if (typeof e.stack !== "undefined") {
      Strophe$2.fatal(e.stack);
    }
    if (e.sourceURL) {
      Strophe$2.fatal("error: " + this.handler + " " + e.sourceURL + ":" + e.line + " - " + e.name + ": " + e.message);
    } else if (e.fileName) {
      Strophe$2.fatal("error: " + this.handler + " " + e.fileName + ":" + e.lineNumber + " - " + e.name + ": " + e.message);
    } else {
      Strophe$2.fatal("error: " + e.message);
    }
  },
  /** Function: log
   *  User overrideable logging function.
   *
   *  This function is called whenever the Strophe library calls any
   *  of the logging functions.  The default implementation of this
   *  function logs only fatal errors.  If client code wishes to handle the logging
   *  messages, it should override this with
   *  > Strophe.log = function (level, msg) {
   *  >   (user code here)
   *  > };
   *
   *  Please note that data sent and received over the wire is logged
   *  via Strophe.Connection.rawInput() and Strophe.Connection.rawOutput().
   *
   *  The different levels and their meanings are
   *
   *    DEBUG - Messages useful for debugging purposes.
   *    INFO - Informational messages.  This is mostly information like
   *      'disconnect was called' or 'SASL auth succeeded'.
   *    WARN - Warnings about potential problems.  This is mostly used
   *      to report transient connection errors like request timeouts.
   *    ERROR - Some error occurred.
   *    FATAL - A non-recoverable fatal error occurred.
   *
   *  Parameters:
   *    (Integer) level - The log level of the log message.  This will
   *      be one of the values in Strophe.LogLevel.
   *    (String) msg - The log message.
   */
  log(level, msg) {
    if (level === this.LogLevel.FATAL) {
      var _console;
      (_console = console) === null || _console === void 0 ? void 0 : _console.error(msg);
    }
  },
  /** Function: debug
   *  Log a message at the Strophe.LogLevel.DEBUG level.
   *
   *  Parameters:
   *    (String) msg - The log message.
   */
  debug(msg) {
    this.log(this.LogLevel.DEBUG, msg);
  },
  /** Function: info
   *  Log a message at the Strophe.LogLevel.INFO level.
   *
   *  Parameters:
   *    (String) msg - The log message.
   */
  info(msg) {
    this.log(this.LogLevel.INFO, msg);
  },
  /** Function: warn
   *  Log a message at the Strophe.LogLevel.WARN level.
   *
   *  Parameters:
   *    (String) msg - The log message.
   */
  warn(msg) {
    this.log(this.LogLevel.WARN, msg);
  },
  /** Function: error
   *  Log a message at the Strophe.LogLevel.ERROR level.
   *
   *  Parameters:
   *    (String) msg - The log message.
   */
  error(msg) {
    this.log(this.LogLevel.ERROR, msg);
  },
  /** Function: fatal
   *  Log a message at the Strophe.LogLevel.FATAL level.
   *
   *  Parameters:
   *    (String) msg - The log message.
   */
  fatal(msg) {
    this.log(this.LogLevel.FATAL, msg);
  },
  /** Function: serialize
   *  Render a DOM element and all descendants to a String.
   *
   *  Parameters:
   *    (XMLElement) elem - A DOM element.
   *
   *  Returns:
   *    The serialized element tree as a String.
   */
  serialize(elem) {
    if (!elem) {
      return null;
    }
    if (typeof elem.tree === "function") {
      elem = elem.tree();
    }
    const names = [...Array(elem.attributes.length).keys()].map(i => elem.attributes[i].nodeName);
    names.sort();
    let result = names.reduce((a, n) => `${a} ${n}="${Strophe$2.xmlescape(elem.attributes.getNamedItem(n).value)}"`, `<${elem.nodeName}`);
    if (elem.childNodes.length > 0) {
      result += ">";
      for (let i = 0; i < elem.childNodes.length; i++) {
        const child = elem.childNodes[i];
        switch (child.nodeType) {
          case Strophe$2.ElementType.NORMAL:
            // normal element, so recurse
            result += Strophe$2.serialize(child);
            break;
          case Strophe$2.ElementType.TEXT:
            // text element to escape values
            result += Strophe$2.xmlescape(child.nodeValue);
            break;
          case Strophe$2.ElementType.CDATA:
            // cdata section so don't escape values
            result += "<![CDATA[" + child.nodeValue + "]]>";
        }
      }
      result += "</" + elem.nodeName + ">";
    } else {
      result += "/>";
    }
    return result;
  },
  /** PrivateVariable: _requestId
   *  _Private_ variable that keeps track of the request ids for
   *  connections.
   */
  _requestId: 0,
  /** PrivateVariable: Strophe.connectionPlugins
   *  _Private_ variable Used to store plugin names that need
   *  initialization on Strophe.Connection construction.
   */
  _connectionPlugins: {},
  /** Function: addConnectionPlugin
   *  Extends the Strophe.Connection object with the given plugin.
   *
   *  Parameters:
   *    (String) name - The name of the extension.
   *    (Object) ptype - The plugin's prototype.
   */
  addConnectionPlugin(name, ptype) {
    Strophe$2._connectionPlugins[name] = ptype;
  }
};

/** Class: Strophe.Builder
 *  XML DOM builder.
 *
 *  This object provides an interface similar to JQuery but for building
 *  DOM elements easily and rapidly.  All the functions except for toString()
 *  and tree() return the object, so calls can be chained.  Here's an
 *  example using the $iq() builder helper.
 *  > $iq({to: 'you', from: 'me', type: 'get', id: '1'})
 *  >     .c('query', {xmlns: 'strophe:example'})
 *  >     .c('example')
 *  >     .toString()
 *
 *  The above generates this XML fragment
 *  > <iq to='you' from='me' type='get' id='1'>
 *  >   <query xmlns='strophe:example'>
 *  >     <example/>
 *  >   </query>
 *  > </iq>
 *  The corresponding DOM manipulations to get a similar fragment would be
 *  a lot more tedious and probably involve several helper variables.
 *
 *  Since adding children makes new operations operate on the child, up()
 *  is provided to traverse up the tree.  To add two children, do
 *  > builder.c('child1', ...).up().c('child2', ...)
 *  The next operation on the Builder will be relative to the second child.
 */

/** Constructor: Strophe.Builder
 *  Create a Strophe.Builder object.
 *
 *  The attributes should be passed in object notation.  For example
 *  > let b = new Builder('message', {to: 'you', from: 'me'});
 *  or
 *  > let b = new Builder('messsage', {'xml:lang': 'en'});
 *
 *  Parameters:
 *    (String) name - The name of the root element.
 *    (Object) attrs - The attributes for the root element in object notation.
 *
 *  Returns:
 *    A new Strophe.Builder.
 */

Strophe$2.Builder = class Builder {
  constructor(name, attrs) {
    // Set correct namespace for jabber:client elements
    if (name === "presence" || name === "message" || name === "iq") {
      if (attrs && !attrs.xmlns) {
        attrs.xmlns = Strophe$2.NS.CLIENT;
      } else if (!attrs) {
        attrs = {
          xmlns: Strophe$2.NS.CLIENT
        };
      }
    }
    // Holds the tree being built.
    this.nodeTree = Strophe$2.xmlElement(name, attrs);
    // Points to the current operation node.
    this.node = this.nodeTree;
  }

  /** Function: tree
   *  Return the DOM tree.
   *
   *  This function returns the current DOM tree as an element object.  This
   *  is suitable for passing to functions like Strophe.Connection.send().
   *
   *  Returns:
   *    The DOM tree as a element object.
   */
  tree() {
    return this.nodeTree;
  }

  /** Function: toString
   *  Serialize the DOM tree to a String.
   *
   *  This function returns a string serialization of the current DOM
   *  tree.  It is often used internally to pass data to a
   *  Strophe.Request object.
   *
   *  Returns:
   *    The serialized DOM tree in a String.
   */
  toString() {
    return Strophe$2.serialize(this.nodeTree);
  }

  /** Function: up
   *  Make the current parent element the new current element.
   *
   *  This function is often used after c() to traverse back up the tree.
   *  For example, to add two children to the same element
   *  > builder.c('child1', {}).up().c('child2', {});
   *
   *  Returns:
   *    The Stophe.Builder object.
   */
  up() {
    this.node = this.node.parentNode;
    return this;
  }

  /** Function: root
   *  Make the root element the new current element.
   *
   *  When at a deeply nested element in the tree, this function can be used
   *  to jump back to the root of the tree, instead of having to repeatedly
   *  call up().
   *
   *  Returns:
   *    The Stophe.Builder object.
   */
  root() {
    this.node = this.nodeTree;
    return this;
  }

  /** Function: attrs
   *  Add or modify attributes of the current element.
   *
   *  The attributes should be passed in object notation.  This function
   *  does not move the current element pointer.
   *
   *  Parameters:
   *    (Object) moreattrs - The attributes to add/modify in object notation.
   *
   *  Returns:
   *    The Strophe.Builder object.
   */
  attrs(moreattrs) {
    for (const k in moreattrs) {
      if (Object.prototype.hasOwnProperty.call(moreattrs, k)) {
        if (moreattrs[k] === undefined) {
          this.node.removeAttribute(k);
        } else {
          this.node.setAttribute(k, moreattrs[k]);
        }
      }
    }
    return this;
  }

  /** Function: c
   *  Add a child to the current element and make it the new current
   *  element.
   *
   *  This function moves the current element pointer to the child,
   *  unless text is provided.  If you need to add another child, it
   *  is necessary to use up() to go back to the parent in the tree.
   *
   *  Parameters:
   *    (String) name - The name of the child.
   *    (Object) attrs - The attributes of the child in object notation.
   *    (String) text - The text to add to the child.
   *
   *  Returns:
   *    The Strophe.Builder object.
   */
  c(name, attrs, text) {
    const child = Strophe$2.xmlElement(name, attrs, text);
    this.node.appendChild(child);
    if (typeof text !== "string" && typeof text !== "number") {
      this.node = child;
    }
    return this;
  }

  /** Function: cnode
   *  Add a child to the current element and make it the new current
   *  element.
   *
   *  This function is the same as c() except that instead of using a
   *  name and an attributes object to create the child it uses an
   *  existing DOM element object.
   *
   *  Parameters:
   *    (XMLElement) elem - A DOM element.
   *
   *  Returns:
   *    The Strophe.Builder object.
   */
  cnode(elem) {
    let impNode;
    const xmlGen = Strophe$2.xmlGenerator();
    try {
      impNode = xmlGen.importNode !== undefined;
    } catch (e) {
      impNode = false;
    }
    const newElem = impNode ? xmlGen.importNode(elem, true) : Strophe$2.copyElement(elem);
    this.node.appendChild(newElem);
    this.node = newElem;
    return this;
  }

  /** Function: t
   *  Add a child text element.
   *
   *  This *does not* make the child the new current element since there
   *  are no children of text elements.
   *
   *  Parameters:
   *    (String) text - The text data to append to the current element.
   *
   *  Returns:
   *    The Strophe.Builder object.
   */
  t(text) {
    const child = Strophe$2.xmlTextNode(text);
    this.node.appendChild(child);
    return this;
  }

  /** Function: h
   *  Replace current element contents with the HTML passed in.
   *
   *  This *does not* make the child the new current element
   *
   *  Parameters:
   *    (String) html - The html to insert as contents of current element.
   *
   *  Returns:
   *    The Strophe.Builder object.
   */
  h(html) {
    const fragment = Strophe$2.xmlGenerator().createElement('body');
    // force the browser to try and fix any invalid HTML tags
    fragment.innerHTML = html;
    // copy cleaned html into an xml dom
    const xhtml = Strophe$2.createHtml(fragment);
    while (xhtml.childNodes.length > 0) {
      this.node.appendChild(xhtml.childNodes[0]);
    }
    return this;
  }
};

/** PrivateClass: Strophe.Handler
 *  _Private_ helper class for managing stanza handlers.
 *
 *  A Strophe.Handler encapsulates a user provided callback function to be
 *  executed when matching stanzas are received by the connection.
 *  Handlers can be either one-off or persistant depending on their
 *  return value. Returning true will cause a Handler to remain active, and
 *  returning false will remove the Handler.
 *
 *  Users will not use Strophe.Handler objects directly, but instead they
 *  will use Strophe.Connection.addHandler() and
 *  Strophe.Connection.deleteHandler().
 */

/** PrivateConstructor: Strophe.Handler
 *  Create and initialize a new Strophe.Handler.
 *
 *  Parameters:
 *    (Function) handler - A function to be executed when the handler is run.
 *    (String) ns - The namespace to match.
 *    (String) name - The element name to match.
 *    (String) type - The element type to match.
 *    (String) id - The element id attribute to match.
 *    (String) from - The element from attribute to match.
 *    (Object) options - Handler options
 *
 *  Returns:
 *    A new Strophe.Handler object.
 */
Strophe$2.Handler = function (handler, ns, name, type, id, from, options) {
  this.handler = handler;
  this.ns = ns;
  this.name = name;
  this.type = type;
  this.id = id;
  this.options = options || {
    'matchBareFromJid': false,
    'ignoreNamespaceFragment': false
  };
  // BBB: Maintain backward compatibility with old `matchBare` option
  if (this.options.matchBare) {
    Strophe$2.warn('The "matchBare" option is deprecated, use "matchBareFromJid" instead.');
    this.options.matchBareFromJid = this.options.matchBare;
    delete this.options.matchBare;
  }
  if (this.options.matchBareFromJid) {
    this.from = from ? Strophe$2.getBareJidFromJid(from) : null;
  } else {
    this.from = from;
  }
  // whether the handler is a user handler or a system handler
  this.user = true;
};
Strophe$2.Handler.prototype = {
  /** PrivateFunction: getNamespace
   *  Returns the XML namespace attribute on an element.
   *  If `ignoreNamespaceFragment` was passed in for this handler, then the
   *  URL fragment will be stripped.
   *
   *  Parameters:
   *    (XMLElement) elem - The XML element with the namespace.
   *
   *  Returns:
   *    The namespace, with optionally the fragment stripped.
   */
  getNamespace(elem) {
    let elNamespace = elem.getAttribute("xmlns");
    if (elNamespace && this.options.ignoreNamespaceFragment) {
      elNamespace = elNamespace.split('#')[0];
    }
    return elNamespace;
  },
  /** PrivateFunction: namespaceMatch
   *  Tests if a stanza matches the namespace set for this Strophe.Handler.
   *
   *  Parameters:
   *    (XMLElement) elem - The XML element to test.
   *
   *  Returns:
   *    true if the stanza matches and false otherwise.
   */
  namespaceMatch(elem) {
    let nsMatch = false;
    if (!this.ns) {
      return true;
    } else {
      Strophe$2.forEachChild(elem, null, elem => {
        if (this.getNamespace(elem) === this.ns) {
          nsMatch = true;
        }
      });
      return nsMatch || this.getNamespace(elem) === this.ns;
    }
  },
  /** PrivateFunction: isMatch
   *  Tests if a stanza matches the Strophe.Handler.
   *
   *  Parameters:
   *    (XMLElement) elem - The XML element to test.
   *
   *  Returns:
   *    true if the stanza matches and false otherwise.
   */
  isMatch(elem) {
    let from = elem.getAttribute('from');
    if (this.options.matchBareFromJid) {
      from = Strophe$2.getBareJidFromJid(from);
    }
    const elem_type = elem.getAttribute("type");
    if (this.namespaceMatch(elem) && (!this.name || Strophe$2.isTagEqual(elem, this.name)) && (!this.type || (Array.isArray(this.type) ? this.type.indexOf(elem_type) !== -1 : elem_type === this.type)) && (!this.id || elem.getAttribute("id") === this.id) && (!this.from || from === this.from)) {
      return true;
    }
    return false;
  },
  /** PrivateFunction: run
   *  Run the callback on a matching stanza.
   *
   *  Parameters:
   *    (XMLElement) elem - The DOM element that triggered the
   *      Strophe.Handler.
   *
   *  Returns:
   *    A boolean indicating if the handler should remain active.
   */
  run(elem) {
    let result = null;
    try {
      result = this.handler(elem);
    } catch (e) {
      Strophe$2._handleError(e);
      throw e;
    }
    return result;
  },
  /** PrivateFunction: toString
   *  Get a String representation of the Strophe.Handler object.
   *
   *  Returns:
   *    A String.
   */
  toString() {
    return "{Handler: " + this.handler + "(" + this.name + "," + this.id + "," + this.ns + ")}";
  }
};

/** PrivateClass: Strophe.TimedHandler
 *  _Private_ helper class for managing timed handlers.
 *
 *  A Strophe.TimedHandler encapsulates a user provided callback that
 *  should be called after a certain period of time or at regular
 *  intervals.  The return value of the callback determines whether the
 *  Strophe.TimedHandler will continue to fire.
 *
 *  Users will not use Strophe.TimedHandler objects directly, but instead
 *  they will use Strophe.Connection.addTimedHandler() and
 *  Strophe.Connection.deleteTimedHandler().
 */
Strophe$2.TimedHandler = class TimedHandler {
  /** PrivateConstructor: Strophe.TimedHandler
   *  Create and initialize a new Strophe.TimedHandler object.
   *
   *  Parameters:
   *    (Integer) period - The number of milliseconds to wait before the
   *      handler is called.
   *    (Function) handler - The callback to run when the handler fires.  This
   *      function should take no arguments.
   *
   *  Returns:
   *    A new Strophe.TimedHandler object.
   */
  constructor(period, handler) {
    this.period = period;
    this.handler = handler;
    this.lastCalled = new Date().getTime();
    this.user = true;
  }

  /** PrivateFunction: run
   *  Run the callback for the Strophe.TimedHandler.
   *
   *  Returns:
   *    true if the Strophe.TimedHandler should be called again, and false
   *      otherwise.
   */
  run() {
    this.lastCalled = new Date().getTime();
    return this.handler();
  }

  /** PrivateFunction: reset
   *  Reset the last called time for the Strophe.TimedHandler.
   */
  reset() {
    this.lastCalled = new Date().getTime();
  }

  /** PrivateFunction: toString
   *  Get a string representation of the Strophe.TimedHandler object.
   *
   *  Returns:
   *    The string representation.
   */
  toString() {
    return "{TimedHandler: " + this.handler + "(" + this.period + ")}";
  }
};

/** Class: Strophe.Connection
 *  XMPP Connection manager.
 *
 *  This class is the main part of Strophe.  It manages a BOSH or websocket
 *  connection to an XMPP server and dispatches events to the user callbacks
 *  as data arrives. It supports SASL PLAIN, SASL SCRAM-SHA-1
 *  and legacy authentication.
 *
 *  After creating a Strophe.Connection object, the user will typically
 *  call connect() with a user supplied callback to handle connection level
 *  events like authentication failure, disconnection, or connection
 *  complete.
 *
 *  The user will also have several event handlers defined by using
 *  addHandler() and addTimedHandler().  These will allow the user code to
 *  respond to interesting stanzas or do something periodically with the
 *  connection. These handlers will be active once authentication is
 *  finished.
 *
 *  To send data to the connection, use send().
 */

/** Constructor: Strophe.Connection
 *  Create and initialize a Strophe.Connection object.
 *
 *  The transport-protocol for this connection will be chosen automatically
 *  based on the given service parameter. URLs starting with "ws://" or
 *  "wss://" will use WebSockets, URLs starting with "http://", "https://"
 *  or without a protocol will use BOSH.
 *
 *  To make Strophe connect to the current host you can leave out the protocol
 *  and host part and just pass the path, e.g.
 *
 *  > let conn = new Strophe.Connection("/http-bind/");
 *
 *  Options common to both Websocket and BOSH:
 *  ------------------------------------------
 *
 *  cookies:
 *
 *  The *cookies* option allows you to pass in cookies to be added to the
 *  document. These cookies will then be included in the BOSH XMLHttpRequest
 *  or in the websocket connection.
 *
 *  The passed in value must be a map of cookie names and string values.
 *
 *  > { "myCookie": {
 *  >     "value": "1234",
 *  >     "domain": ".example.org",
 *  >     "path": "/",
 *  >     "expires": expirationDate
 *  >     }
 *  > }
 *
 *  Note that cookies can't be set in this way for other domains (i.e. cross-domain).
 *  Those cookies need to be set under those domains, for example they can be
 *  set server-side by making a XHR call to that domain to ask it to set any
 *  necessary cookies.
 *
 *  mechanisms:
 *
 *  The *mechanisms* option allows you to specify the SASL mechanisms that this
 *  instance of Strophe.Connection (and therefore your XMPP client) will
 *  support.
 *
 *  The value must be an array of objects with Strophe.SASLMechanism
 *  prototypes.
 *
 *  If nothing is specified, then the following mechanisms (and their
 *  priorities) are registered:
 *
 *      SCRAM-SHA-512 - 72
 *      SCRAM-SHA-384 - 71
 *      SCRAM-SHA-256 - 70
 *      SCRAM-SHA-1   - 60
 *      PLAIN         - 50
 *      OAUTHBEARER   - 40
 *      X-OAUTH2      - 30
 *      ANONYMOUS     - 20
 *      EXTERNAL      - 10
 *
 *  explicitResourceBinding:
 *
 *  If `explicitResourceBinding` is set to a truthy value, then the XMPP client
 *  needs to explicitly call `Strophe.Connection.prototype.bind` once the XMPP
 *  server has advertised the "urn:ietf:params:xml:ns:xmpp-bind" feature.
 *
 *  Making this step explicit allows client authors to first finish other
 *  stream related tasks, such as setting up an XEP-0198 Stream Management
 *  session, before binding the JID resource for this session.
 *
 *  WebSocket options:
 *  ------------------
 *
 *  protocol:
 *
 *  If you want to connect to the current host with a WebSocket connection you
 *  can tell Strophe to use WebSockets through a "protocol" attribute in the
 *  optional options parameter. Valid values are "ws" for WebSocket and "wss"
 *  for Secure WebSocket.
 *  So to connect to "wss://CURRENT_HOSTNAME/xmpp-websocket" you would call
 *
 *  > let conn = new Strophe.Connection("/xmpp-websocket/", {protocol: "wss"});
 *
 *  Note that relative URLs _NOT_ starting with a "/" will also include the path
 *  of the current site.
 *
 *  Also because downgrading security is not permitted by browsers, when using
 *  relative URLs both BOSH and WebSocket connections will use their secure
 *  variants if the current connection to the site is also secure (https).
 *
 *  worker:
 *
 *  Set this option to URL from where the shared worker script should be loaded.
 *
 *  To run the websocket connection inside a shared worker.
 *  This allows you to share a single websocket-based connection between
 *  multiple Strophe.Connection instances, for example one per browser tab.
 *
 *  The script to use is the one in `src/shared-connection-worker.js`.
 *
 *  BOSH options:
 *  -------------
 *
 *  By adding "sync" to the options, you can control if requests will
 *  be made synchronously or not. The default behaviour is asynchronous.
 *  If you want to make requests synchronous, make "sync" evaluate to true.
 *  > let conn = new Strophe.Connection("/http-bind/", {sync: true});
 *
 *  You can also toggle this on an already established connection.
 *  > conn.options.sync = true;
 *
 *  The *customHeaders* option can be used to provide custom HTTP headers to be
 *  included in the XMLHttpRequests made.
 *
 *  The *keepalive* option can be used to instruct Strophe to maintain the
 *  current BOSH session across interruptions such as webpage reloads.
 *
 *  It will do this by caching the sessions tokens in sessionStorage, and when
 *  "restore" is called it will check whether there are cached tokens with
 *  which it can resume an existing session.
 *
 *  The *withCredentials* option should receive a Boolean value and is used to
 *  indicate wether cookies should be included in ajax requests (by default
 *  they're not).
 *  Set this value to true if you are connecting to a BOSH service
 *  and for some reason need to send cookies to it.
 *  In order for this to work cross-domain, the server must also enable
 *  credentials by setting the Access-Control-Allow-Credentials response header
 *  to "true". For most usecases however this setting should be false (which
 *  is the default).
 *  Additionally, when using Access-Control-Allow-Credentials, the
 *  Access-Control-Allow-Origin header can't be set to the wildcard "*", but
 *  instead must be restricted to actual domains.
 *
 *  The *contentType* option can be set to change the default Content-Type
 *  of "text/xml; charset=utf-8", which can be useful to reduce the amount of
 *  CORS preflight requests that are sent to the server.
 *
 *  Parameters:
 *    (String) service - The BOSH or WebSocket service URL.
 *    (Object) options - A hash of configuration options
 *
 *  Returns:
 *    A new Strophe.Connection object.
 */

Strophe$2.Connection = class Connection {
  constructor(service, options) {
    // The service URL
    this.service = service;
    // Configuration options
    this.options = options || {};
    this.setProtocol();

    /* The connected JID. */
    this.jid = "";
    /* the JIDs domain */
    this.domain = null;
    /* stream:features */
    this.features = null;

    // SASL
    this._sasl_data = {};
    this.do_bind = false;
    this.do_session = false;
    this.mechanisms = {};

    // handler lists
    this.timedHandlers = [];
    this.handlers = [];
    this.removeTimeds = [];
    this.removeHandlers = [];
    this.addTimeds = [];
    this.addHandlers = [];
    this.protocolErrorHandlers = {
      'HTTP': {},
      'websocket': {}
    };
    this._idleTimeout = null;
    this._disconnectTimeout = null;
    this.authenticated = false;
    this.connected = false;
    this.disconnecting = false;
    this.do_authentication = true;
    this.paused = false;
    this.restored = false;
    this._data = [];
    this._uniqueId = 0;
    this._sasl_success_handler = null;
    this._sasl_failure_handler = null;
    this._sasl_challenge_handler = null;

    // Max retries before disconnecting
    this.maxRetries = 5;

    // Call onIdle callback every 1/10th of a second
    this._idleTimeout = setTimeout(() => this._onIdle(), 100);
    utils$2.addCookies(this.options.cookies);
    this.registerSASLMechanisms(this.options.mechanisms);

    // A client must always respond to incoming IQ "set" and "get" stanzas.
    // See https://datatracker.ietf.org/doc/html/rfc6120#section-8.2.3
    //
    // This is a fallback handler which gets called when no other handler
    // was called for a received IQ "set" or "get".
    this.iqFallbackHandler = new Strophe$2.Handler(iq => this.send($iq$1({
      type: 'error',
      id: iq.getAttribute('id')
    }).c('error', {
      'type': 'cancel'
    }).c('service-unavailable', {
      'xmlns': Strophe$2.NS.STANZAS
    })), null, 'iq', ['get', 'set']);

    // initialize plugins
    for (const k in Strophe$2._connectionPlugins) {
      if (Object.prototype.hasOwnProperty.call(Strophe$2._connectionPlugins, k)) {
        const F = function () {};
        F.prototype = Strophe$2._connectionPlugins[k];
        this[k] = new F();
        this[k].init(this);
      }
    }
  }

  /** Function: setProtocol
   *  Select protocal based on this.options or this.service
   */
  setProtocol() {
    const proto = this.options.protocol || "";
    if (this.options.worker) {
      this._proto = new Strophe$2.WorkerWebsocket(this);
    } else if (this.service.indexOf("ws:") === 0 || this.service.indexOf("wss:") === 0 || proto.indexOf("ws") === 0) {
      this._proto = new Strophe$2.Websocket(this);
    } else {
      this._proto = new Strophe$2.Bosh(this);
    }
  }

  /** Function: reset
   *  Reset the connection.
   *
   *  This function should be called after a connection is disconnected
   *  before that connection is reused.
   */
  reset() {
    this._proto._reset();

    // SASL
    this.do_session = false;
    this.do_bind = false;

    // handler lists
    this.timedHandlers = [];
    this.handlers = [];
    this.removeTimeds = [];
    this.removeHandlers = [];
    this.addTimeds = [];
    this.addHandlers = [];
    this.authenticated = false;
    this.connected = false;
    this.disconnecting = false;
    this.restored = false;
    this._data = [];
    this._requests = [];
    this._uniqueId = 0;
  }

  /** Function: pause
   *  Pause the request manager.
   *
   *  This will prevent Strophe from sending any more requests to the
   *  server.  This is very useful for temporarily pausing
   *  BOSH-Connections while a lot of send() calls are happening quickly.
   *  This causes Strophe to send the data in a single request, saving
   *  many request trips.
   */
  pause() {
    this.paused = true;
  }

  /** Function: resume
   *  Resume the request manager.
   *
   *  This resumes after pause() has been called.
   */
  resume() {
    this.paused = false;
  }

  /** Function: getUniqueId
   *  Generate a unique ID for use in <iq/> elements.
   *
   *  All <iq/> stanzas are required to have unique id attributes.  This
   *  function makes creating these easy.  Each connection instance has
   *  a counter which starts from zero, and the value of this counter
   *  plus a colon followed by the suffix becomes the unique id. If no
   *  suffix is supplied, the counter is used as the unique id.
   *
   *  Suffixes are used to make debugging easier when reading the stream
   *  data, and their use is recommended.  The counter resets to 0 for
   *  every new connection for the same reason.  For connections to the
   *  same server that authenticate the same way, all the ids should be
   *  the same, which makes it easy to see changes.  This is useful for
   *  automated testing as well.
   *
   *  Parameters:
   *    (String) suffix - A optional suffix to append to the id.
   *
   *  Returns:
   *    A unique string to be used for the id attribute.
   */
  getUniqueId(suffix) {
    // eslint-disable-line class-methods-use-this
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0,
        v = c === 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
    if (typeof suffix === "string" || typeof suffix === "number") {
      return uuid + ":" + suffix;
    } else {
      return uuid + "";
    }
  }

  /** Function: addProtocolErrorHandler
   *  Register a handler function for when a protocol (websocker or HTTP)
   *  error occurs.
   *
   *  NOTE: Currently only HTTP errors for BOSH requests are handled.
   *  Patches that handle websocket errors would be very welcome.
   *
   *  Parameters:
   *    (String) protocol - 'HTTP' or 'websocket'
   *    (Integer) status_code - Error status code (e.g 500, 400 or 404)
   *    (Function) callback - Function that will fire on Http error
   *
   *  Example:
   *  function onError(err_code){
   *    //do stuff
   *  }
   *
   *  let conn = Strophe.connect('http://example.com/http-bind');
   *  conn.addProtocolErrorHandler('HTTP', 500, onError);
   *  // Triggers HTTP 500 error and onError handler will be called
   *  conn.connect('user_jid@incorrect_jabber_host', 'secret', onConnect);
   */
  addProtocolErrorHandler(protocol, status_code, callback) {
    this.protocolErrorHandlers[protocol][status_code] = callback;
  }

  /** Function: connect
   *  Starts the connection process.
   *
   *  As the connection process proceeds, the user supplied callback will
   *  be triggered multiple times with status updates.  The callback
   *  should take two arguments - the status code and the error condition.
   *
   *  The status code will be one of the values in the Strophe.Status
   *  constants.  The error condition will be one of the conditions
   *  defined in RFC 3920 or the condition 'strophe-parsererror'.
   *
   *  The Parameters _wait_, _hold_ and _route_ are optional and only relevant
   *  for BOSH connections. Please see XEP 124 for a more detailed explanation
   *  of the optional parameters.
   *
   *  Parameters:
   *    (String) jid - The user's JID.  This may be a bare JID,
   *      or a full JID.  If a node is not supplied, SASL OAUTHBEARER or
   *      SASL ANONYMOUS authentication will be attempted (OAUTHBEARER will
   *      process the provided password value as an access token).
   *    (String or Object) pass - The user's password, or an object containing
   *      the users SCRAM client and server keys, in a fashion described as follows:
   *
   *      { name: String, representing the hash used (eg. SHA-1),
   *        salt: String, base64 encoded salt used to derive the client key,
   *        iter: Int,    the iteration count used to derive the client key,
   *        ck:   String, the base64 encoding of the SCRAM client key
   *        sk:   String, the base64 encoding of the SCRAM server key
   *      }
   *
   *    (Function) callback - The connect callback function.
   *    (Integer) wait - The optional HTTPBIND wait value.  This is the
   *      time the server will wait before returning an empty result for
   *      a request.  The default setting of 60 seconds is recommended.
   *    (Integer) hold - The optional HTTPBIND hold value.  This is the
   *      number of connections the server will hold at one time.  This
   *      should almost always be set to 1 (the default).
   *    (String) route - The optional route value.
   *    (String) authcid - The optional alternative authentication identity
   *      (username) if intending to impersonate another user.
   *      When using the SASL-EXTERNAL authentication mechanism, for example
   *      with client certificates, then the authcid value is used to
   *      determine whether an authorization JID (authzid) should be sent to
   *      the server. The authzid should NOT be sent to the server if the
   *      authzid and authcid are the same. So to prevent it from being sent
   *      (for example when the JID is already contained in the client
   *      certificate), set authcid to that same JID. See XEP-178 for more
   *      details.
   *     (Integer) disconnection_timeout - The optional disconnection timeout
   *      in milliseconds before _doDisconnect will be called.
   */
  connect(jid, pass, callback, wait, hold, route, authcid) {
    let disconnection_timeout = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 3000;
    this.jid = jid;
    /** Variable: authzid
     *  Authorization identity.
     */
    this.authzid = Strophe$2.getBareJidFromJid(this.jid);

    /** Variable: authcid
     *  Authentication identity (User name).
     */
    this.authcid = authcid || Strophe$2.getNodeFromJid(this.jid);

    /** Variable: pass
     *  Authentication identity (User password).
     *
     */
    this.pass = pass;

    /** Variable: scram_keys
     *  The SASL SCRAM client and server keys. This variable will be populated with a non-null
     *  object of the above described form after a successful SCRAM connection
     *
     */
    this.scram_keys = null;
    this.connect_callback = callback;
    this.disconnecting = false;
    this.connected = false;
    this.authenticated = false;
    this.restored = false;
    this.disconnection_timeout = disconnection_timeout;

    // parse jid for domain
    this.domain = Strophe$2.getDomainFromJid(this.jid);
    this._changeConnectStatus(Strophe$2.Status.CONNECTING, null);
    this._proto._connect(wait, hold, route);
  }

  /** Function: attach
   *  Attach to an already created and authenticated BOSH session.
   *
   *  This function is provided to allow Strophe to attach to BOSH
   *  sessions which have been created externally, perhaps by a Web
   *  application.  This is often used to support auto-login type features
   *  without putting user credentials into the page.
   *
   *  Parameters:
   *    (String) jid - The full JID that is bound by the session.
   *    (String) sid - The SID of the BOSH session.
   *    (String) rid - The current RID of the BOSH session.  This RID
   *      will be used by the next request.
   *    (Function) callback The connect callback function.
   *    (Integer) wait - The optional HTTPBIND wait value.  This is the
   *      time the server will wait before returning an empty result for
   *      a request.  The default setting of 60 seconds is recommended.
   *      Other settings will require tweaks to the Strophe.TIMEOUT value.
   *    (Integer) hold - The optional HTTPBIND hold value.  This is the
   *      number of connections the server will hold at one time.  This
   *      should almost always be set to 1 (the default).
   *    (Integer) wind - The optional HTTBIND window value.  This is the
   *      allowed range of request ids that are valid.  The default is 5.
   */
  attach(jid, sid, rid, callback, wait, hold, wind) {
    if (this._proto._attach) {
      return this._proto._attach(jid, sid, rid, callback, wait, hold, wind);
    } else {
      const error = new Error('The "attach" method is not available for your connection protocol');
      error.name = 'StropheSessionError';
      throw error;
    }
  }

  /** Function: restore
   *  Attempt to restore a cached BOSH session.
   *
   *  This function is only useful in conjunction with providing the
   *  "keepalive":true option when instantiating a new Strophe.Connection.
   *
   *  When "keepalive" is set to true, Strophe will cache the BOSH tokens
   *  RID (Request ID) and SID (Session ID) and then when this function is
   *  called, it will attempt to restore the session from those cached
   *  tokens.
   *
   *  This function must therefore be called instead of connect or attach.
   *
   *  For an example on how to use it, please see examples/restore.js
   *
   *  Parameters:
   *    (String) jid - The user's JID.  This may be a bare JID or a full JID.
   *    (Function) callback - The connect callback function.
   *    (Integer) wait - The optional HTTPBIND wait value.  This is the
   *      time the server will wait before returning an empty result for
   *      a request.  The default setting of 60 seconds is recommended.
   *    (Integer) hold - The optional HTTPBIND hold value.  This is the
   *      number of connections the server will hold at one time.  This
   *      should almost always be set to 1 (the default).
   *    (Integer) wind - The optional HTTBIND window value.  This is the
   *      allowed range of request ids that are valid.  The default is 5.
   */
  restore(jid, callback, wait, hold, wind) {
    if (this._sessionCachingSupported()) {
      this._proto._restore(jid, callback, wait, hold, wind);
    } else {
      const error = new Error('The "restore" method can only be used with a BOSH connection.');
      error.name = 'StropheSessionError';
      throw error;
    }
  }

  /** PrivateFunction: _sessionCachingSupported
   * Checks whether sessionStorage and JSON are supported and whether we're
   * using BOSH.
   */
  _sessionCachingSupported() {
    if (this._proto instanceof Strophe$2.Bosh) {
      if (!JSON) {
        return false;
      }
      try {
        sessionStorage.setItem('_strophe_', '_strophe_');
        sessionStorage.removeItem('_strophe_');
      } catch (e) {
        return false;
      }
      return true;
    }
    return false;
  }

  /** Function: xmlInput
   *  User overrideable function that receives XML data coming into the
   *  connection.
   *
   *  The default function does nothing.  User code can override this with
   *  > Strophe.Connection.xmlInput = function (elem) {
   *  >   (user code)
   *  > };
   *
   *  Due to limitations of current Browsers' XML-Parsers the opening and closing
   *  <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
   *
   *  BOSH-Connections will have all stanzas wrapped in a <body> tag. See
   *  <Strophe.Bosh.strip> if you want to strip this tag.
   *
   *  Parameters:
   *    (XMLElement) elem - The XML data received by the connection.
   */
  xmlInput(elem) {
    // eslint-disable-line
    return;
  }

  /** Function: xmlOutput
   *  User overrideable function that receives XML data sent to the
   *  connection.
   *
   *  The default function does nothing.  User code can override this with
   *  > Strophe.Connection.xmlOutput = function (elem) {
   *  >   (user code)
   *  > };
   *
   *  Due to limitations of current Browsers' XML-Parsers the opening and closing
   *  <stream> tag for WebSocket-Connoctions will be passed as selfclosing here.
   *
   *  BOSH-Connections will have all stanzas wrapped in a <body> tag. See
   *  <Strophe.Bosh.strip> if you want to strip this tag.
   *
   *  Parameters:
   *    (XMLElement) elem - The XMLdata sent by the connection.
   */
  xmlOutput(elem) {
    // eslint-disable-line
    return;
  }

  /** Function: rawInput
   *  User overrideable function that receives raw data coming into the
   *  connection.
   *
   *  The default function does nothing.  User code can override this with
   *  > Strophe.Connection.rawInput = function (data) {
   *  >   (user code)
   *  > };
   *
   *  Parameters:
   *    (String) data - The data received by the connection.
   */
  rawInput(data) {
    // eslint-disable-line
    return;
  }

  /** Function: rawOutput
   *  User overrideable function that receives raw data sent to the
   *  connection.
   *
   *  The default function does nothing.  User code can override this with
   *  > Strophe.Connection.rawOutput = function (data) {
   *  >   (user code)
   *  > };
   *
   *  Parameters:
   *    (String) data - The data sent by the connection.
   */
  rawOutput(data) {
    // eslint-disable-line
    return;
  }

  /** Function: nextValidRid
   *  User overrideable function that receives the new valid rid.
   *
   *  The default function does nothing. User code can override this with
   *  > Strophe.Connection.nextValidRid = function (rid) {
   *  >    (user code)
   *  > };
   *
   *  Parameters:
   *    (Number) rid - The next valid rid
   */
  nextValidRid(rid) {
    // eslint-disable-line
    return;
  }

  /** Function: send
   *  Send a stanza.
   *
   *  This function is called to push data onto the send queue to
   *  go out over the wire.  Whenever a request is sent to the BOSH
   *  server, all pending data is sent and the queue is flushed.
   *
   *  Parameters:
   *    (XMLElement |
   *     [XMLElement] |
   *     Strophe.Builder) elem - The stanza to send.
   */
  send(elem) {
    if (elem === null) {
      return;
    }
    if (typeof elem.sort === "function") {
      for (let i = 0; i < elem.length; i++) {
        this._queueData(elem[i]);
      }
    } else if (typeof elem.tree === "function") {
      this._queueData(elem.tree());
    } else {
      this._queueData(elem);
    }
    this._proto._send();
  }

  /** Function: flush
   *  Immediately send any pending outgoing data.
   *
   *  Normally send() queues outgoing data until the next idle period
   *  (100ms), which optimizes network use in the common cases when
   *  several send()s are called in succession. flush() can be used to
   *  immediately send all pending data.
   */
  flush() {
    // cancel the pending idle period and run the idle function
    // immediately
    clearTimeout(this._idleTimeout);
    this._onIdle();
  }

  /** Function: sendPresence
   *  Helper function to send presence stanzas. The main benefit is for
   *  sending presence stanzas for which you expect a responding presence
   *  stanza with the same id (for example when leaving a chat room).
   *
   *  Parameters:
   *    (XMLElement) elem - The stanza to send.
   *    (Function) callback - The callback function for a successful request.
   *    (Function) errback - The callback function for a failed or timed
   *      out request.  On timeout, the stanza will be null.
   *    (Integer) timeout - The time specified in milliseconds for a
   *      timeout to occur.
   *
   *  Returns:
   *    The id used to send the presence.
   */
  sendPresence(elem, callback, errback, timeout) {
    let timeoutHandler = null;
    if (typeof elem.tree === "function") {
      elem = elem.tree();
    }
    let id = elem.getAttribute('id');
    if (!id) {
      // inject id if not found
      id = this.getUniqueId("sendPresence");
      elem.setAttribute("id", id);
    }
    if (typeof callback === "function" || typeof errback === "function") {
      const handler = this.addHandler(stanza => {
        // remove timeout handler if there is one
        if (timeoutHandler) {
          this.deleteTimedHandler(timeoutHandler);
        }
        if (stanza.getAttribute('type') === 'error') {
          if (errback) {
            errback(stanza);
          }
        } else if (callback) {
          callback(stanza);
        }
      }, null, 'presence', null, id);

      // if timeout specified, set up a timeout handler.
      if (timeout) {
        timeoutHandler = this.addTimedHandler(timeout, () => {
          // get rid of normal handler
          this.deleteHandler(handler);
          // call errback on timeout with null stanza
          if (errback) {
            errback(null);
          }
          return false;
        });
      }
    }
    this.send(elem);
    return id;
  }

  /** Function: sendIQ
   *  Helper function to send IQ stanzas.
   *
   *  Parameters:
   *    (XMLElement) elem - The stanza to send.
   *    (Function) callback - The callback function for a successful request.
   *    (Function) errback - The callback function for a failed or timed
   *      out request.  On timeout, the stanza will be null.
   *    (Integer) timeout - The time specified in milliseconds for a
   *      timeout to occur.
   *
   *  Returns:
   *    The id used to send the IQ.
  */
  sendIQ(elem, callback, errback, timeout) {
    let timeoutHandler = null;
    if (typeof elem.tree === "function") {
      elem = elem.tree();
    }
    let id = elem.getAttribute('id');
    if (!id) {
      // inject id if not found
      id = this.getUniqueId("sendIQ");
      elem.setAttribute("id", id);
    }
    if (typeof callback === "function" || typeof errback === "function") {
      const handler = this.addHandler(stanza => {
        // remove timeout handler if there is one
        if (timeoutHandler) {
          this.deleteTimedHandler(timeoutHandler);
        }
        const iqtype = stanza.getAttribute('type');
        if (iqtype === 'result') {
          if (callback) {
            callback(stanza);
          }
        } else if (iqtype === 'error') {
          if (errback) {
            errback(stanza);
          }
        } else {
          const error = new Error(`Got bad IQ type of ${iqtype}`);
          error.name = "StropheError";
          throw error;
        }
      }, null, 'iq', ['error', 'result'], id);

      // if timeout specified, set up a timeout handler.
      if (timeout) {
        timeoutHandler = this.addTimedHandler(timeout, () => {
          // get rid of normal handler
          this.deleteHandler(handler);
          // call errback on timeout with null stanza
          if (errback) {
            errback(null);
          }
          return false;
        });
      }
    }
    this.send(elem);
    return id;
  }

  /** PrivateFunction: _queueData
   *  Queue outgoing data for later sending.  Also ensures that the data
   *  is a DOMElement.
   */
  _queueData(element) {
    if (element === null || !element.tagName || !element.childNodes) {
      const error = new Error("Cannot queue non-DOMElement.");
      error.name = "StropheError";
      throw error;
    }
    this._data.push(element);
  }

  /** PrivateFunction: _sendRestart
   *  Send an xmpp:restart stanza.
   */
  _sendRestart() {
    this._data.push("restart");
    this._proto._sendRestart();
    this._idleTimeout = setTimeout(() => this._onIdle(), 100);
  }

  /** Function: addTimedHandler
   *  Add a timed handler to the connection.
   *
   *  This function adds a timed handler.  The provided handler will
   *  be called every period milliseconds until it returns false,
   *  the connection is terminated, or the handler is removed.  Handlers
   *  that wish to continue being invoked should return true.
   *
   *  Because of method binding it is necessary to save the result of
   *  this function if you wish to remove a handler with
   *  deleteTimedHandler().
   *
   *  Note that user handlers are not active until authentication is
   *  successful.
   *
   *  Parameters:
   *    (Integer) period - The period of the handler.
   *    (Function) handler - The callback function.
   *
   *  Returns:
   *    A reference to the handler that can be used to remove it.
   */
  addTimedHandler(period, handler) {
    const thand = new Strophe$2.TimedHandler(period, handler);
    this.addTimeds.push(thand);
    return thand;
  }

  /** Function: deleteTimedHandler
   *  Delete a timed handler for a connection.
   *
   *  This function removes a timed handler from the connection.  The
   *  handRef parameter is *not* the function passed to addTimedHandler(),
   *  but is the reference returned from addTimedHandler().
   *
   *  Parameters:
   *    (Strophe.TimedHandler) handRef - The handler reference.
   */
  deleteTimedHandler(handRef) {
    // this must be done in the Idle loop so that we don't change
    // the handlers during iteration
    this.removeTimeds.push(handRef);
  }

  /** Function: addHandler
   *  Add a stanza handler for the connection.
   *
   *  This function adds a stanza handler to the connection.  The
   *  handler callback will be called for any stanza that matches
   *  the parameters.  Note that if multiple parameters are supplied,
   *  they must all match for the handler to be invoked.
   *
   *  The handler will receive the stanza that triggered it as its argument.
   *  *The handler should return true if it is to be invoked again;
   *  returning false will remove the handler after it returns.*
   *
   *  As a convenience, the ns parameters applies to the top level element
   *  and also any of its immediate children.  This is primarily to make
   *  matching /iq/query elements easy.
   *
   *  Options
   *  ~~~~~~~
   *  With the options argument, you can specify boolean flags that affect how
   *  matches are being done.
   *
   *  Currently two flags exist:
   *
   *  - matchBareFromJid:
   *      When set to true, the from parameter and the
   *      from attribute on the stanza will be matched as bare JIDs instead
   *      of full JIDs. To use this, pass {matchBareFromJid: true} as the
   *      value of options. The default value for matchBareFromJid is false.
   *
   *  - ignoreNamespaceFragment:
   *      When set to true, a fragment specified on the stanza's namespace
   *      URL will be ignored when it's matched with the one configured for
   *      the handler.
   *
   *      This means that if you register like this:
   *      >   connection.addHandler(
   *      >       handler,
   *      >       'http://jabber.org/protocol/muc',
   *      >       null, null, null, null,
   *      >       {'ignoreNamespaceFragment': true}
   *      >   );
   *
   *      Then a stanza with XML namespace of
   *      'http://jabber.org/protocol/muc#user' will also be matched. If
   *      'ignoreNamespaceFragment' is false, then only stanzas with
   *      'http://jabber.org/protocol/muc' will be matched.
   *
   *  Deleting the handler
   *  ~~~~~~~~~~~~~~~~~~~~
   *  The return value should be saved if you wish to remove the handler
   *  with deleteHandler().
   *
   *  Parameters:
   *    (Function) handler - The user callback.
   *    (String) ns - The namespace to match.
   *    (String) name - The stanza name to match.
   *    (String|Array) type - The stanza type (or types if an array) to match.
   *    (String) id - The stanza id attribute to match.
   *    (String) from - The stanza from attribute to match.
   *    (String) options - The handler options
   *
   *  Returns:
   *    A reference to the handler that can be used to remove it.
   */
  addHandler(handler, ns, name, type, id, from, options) {
    const hand = new Strophe$2.Handler(handler, ns, name, type, id, from, options);
    this.addHandlers.push(hand);
    return hand;
  }

  /** Function: deleteHandler
   *  Delete a stanza handler for a connection.
   *
   *  This function removes a stanza handler from the connection.  The
   *  handRef parameter is *not* the function passed to addHandler(),
   *  but is the reference returned from addHandler().
   *
   *  Parameters:
   *    (Strophe.Handler) handRef - The handler reference.
   */
  deleteHandler(handRef) {
    // this must be done in the Idle loop so that we don't change
    // the handlers during iteration
    this.removeHandlers.push(handRef);
    // If a handler is being deleted while it is being added,
    // prevent it from getting added
    const i = this.addHandlers.indexOf(handRef);
    if (i >= 0) {
      this.addHandlers.splice(i, 1);
    }
  }

  /** Function: registerSASLMechanisms
   *
   * Register the SASL mechanisms which will be supported by this instance of
   * Strophe.Connection (i.e. which this XMPP client will support).
   *
   *  Parameters:
   *    (Array) mechanisms - Array of objects with Strophe.SASLMechanism prototypes
   *
   */
  registerSASLMechanisms(mechanisms) {
    this.mechanisms = {};
    mechanisms = mechanisms || [Strophe$2.SASLAnonymous, Strophe$2.SASLExternal, Strophe$2.SASLOAuthBearer, Strophe$2.SASLXOAuth2, Strophe$2.SASLPlain, Strophe$2.SASLSHA1, Strophe$2.SASLSHA256, Strophe$2.SASLSHA384, Strophe$2.SASLSHA512];
    mechanisms.forEach(m => this.registerSASLMechanism(m));
  }

  /** Function: registerSASLMechanism
   *
   * Register a single SASL mechanism, to be supported by this client.
   *
   *  Parameters:
   *    (Object) mechanism - Object with a Strophe.SASLMechanism prototype
   *
   */
  registerSASLMechanism(Mechanism) {
    const mechanism = new Mechanism();
    this.mechanisms[mechanism.mechname] = mechanism;
  }

  /** Function: disconnect
   *  Start the graceful disconnection process.
   *
   *  This function starts the disconnection process.  This process starts
   *  by sending unavailable presence and sending BOSH body of type
   *  terminate.  A timeout handler makes sure that disconnection happens
   *  even if the BOSH server does not respond.
   *  If the Connection object isn't connected, at least tries to abort all pending requests
   *  so the connection object won't generate successful requests (which were already opened).
   *
   *  The user supplied connection callback will be notified of the
   *  progress as this process happens.
   *
   *  Parameters:
   *    (String) reason - The reason the disconnect is occuring.
   */
  disconnect(reason) {
    this._changeConnectStatus(Strophe$2.Status.DISCONNECTING, reason);
    if (reason) {
      Strophe$2.warn("Disconnect was called because: " + reason);
    } else {
      Strophe$2.info("Disconnect was called");
    }
    if (this.connected) {
      let pres = false;
      this.disconnecting = true;
      if (this.authenticated) {
        pres = $pres$1({
          'xmlns': Strophe$2.NS.CLIENT,
          'type': 'unavailable'
        });
      }
      // setup timeout handler
      this._disconnectTimeout = this._addSysTimedHandler(this.disconnection_timeout, this._onDisconnectTimeout.bind(this));
      this._proto._disconnect(pres);
    } else {
      Strophe$2.warn("Disconnect was called before Strophe connected to the server");
      this._proto._abortAllRequests();
      this._doDisconnect();
    }
  }

  /** PrivateFunction: _changeConnectStatus
   *  _Private_ helper function that makes sure plugins and the user's
   *  callback are notified of connection status changes.
   *
   *  Parameters:
   *    (Integer) status - the new connection status, one of the values
   *      in Strophe.Status
   *    (String) condition - the error condition or null
   *    (XMLElement) elem - The triggering stanza.
   */
  _changeConnectStatus(status, condition, elem) {
    // notify all plugins listening for status changes
    for (const k in Strophe$2._connectionPlugins) {
      if (Object.prototype.hasOwnProperty.call(Strophe$2._connectionPlugins, k)) {
        const plugin = this[k];
        if (plugin.statusChanged) {
          try {
            plugin.statusChanged(status, condition);
          } catch (err) {
            Strophe$2.error(`${k} plugin caused an exception changing status: ${err}`);
          }
        }
      }
    }
    // notify the user's callback
    if (this.connect_callback) {
      try {
        this.connect_callback(status, condition, elem);
      } catch (e) {
        Strophe$2._handleError(e);
        Strophe$2.error(`User connection callback caused an exception: ${e}`);
      }
    }
  }

  /** PrivateFunction: _doDisconnect
   *  _Private_ function to disconnect.
   *
   *  This is the last piece of the disconnection logic.  This resets the
   *  connection and alerts the user's connection callback.
   */
  _doDisconnect(condition) {
    if (typeof this._idleTimeout === "number") {
      clearTimeout(this._idleTimeout);
    }

    // Cancel Disconnect Timeout
    if (this._disconnectTimeout !== null) {
      this.deleteTimedHandler(this._disconnectTimeout);
      this._disconnectTimeout = null;
    }
    Strophe$2.debug("_doDisconnect was called");
    this._proto._doDisconnect();
    this.authenticated = false;
    this.disconnecting = false;
    this.restored = false;

    // delete handlers
    this.handlers = [];
    this.timedHandlers = [];
    this.removeTimeds = [];
    this.removeHandlers = [];
    this.addTimeds = [];
    this.addHandlers = [];

    // tell the parent we disconnected
    this._changeConnectStatus(Strophe$2.Status.DISCONNECTED, condition);
    this.connected = false;
  }

  /** PrivateFunction: _dataRecv
   *  _Private_ handler to processes incoming data from the the connection.
   *
   *  Except for _connect_cb handling the initial connection request,
   *  this function handles the incoming data for all requests.  This
   *  function also fires stanza handlers that match each incoming
   *  stanza.
   *
   *  Parameters:
   *    (Strophe.Request) req - The request that has data ready.
   *    (string) req - The stanza a raw string (optiona).
   */
  _dataRecv(req, raw) {
    const elem = this._proto._reqToData(req);
    if (elem === null) {
      return;
    }
    if (this.xmlInput !== Strophe$2.Connection.prototype.xmlInput) {
      if (elem.nodeName === this._proto.strip && elem.childNodes.length) {
        this.xmlInput(elem.childNodes[0]);
      } else {
        this.xmlInput(elem);
      }
    }
    if (this.rawInput !== Strophe$2.Connection.prototype.rawInput) {
      if (raw) {
        this.rawInput(raw);
      } else {
        this.rawInput(Strophe$2.serialize(elem));
      }
    }

    // remove handlers scheduled for deletion
    while (this.removeHandlers.length > 0) {
      const hand = this.removeHandlers.pop();
      const i = this.handlers.indexOf(hand);
      if (i >= 0) {
        this.handlers.splice(i, 1);
      }
    }

    // add handlers scheduled for addition
    while (this.addHandlers.length > 0) {
      this.handlers.push(this.addHandlers.pop());
    }

    // handle graceful disconnect
    if (this.disconnecting && this._proto._emptyQueue()) {
      this._doDisconnect();
      return;
    }
    const type = elem.getAttribute("type");
    if (type !== null && type === "terminate") {
      // Don't process stanzas that come in after disconnect
      if (this.disconnecting) {
        return;
      }
      // an error occurred
      let cond = elem.getAttribute("condition");
      const conflict = elem.getElementsByTagName("conflict");
      if (cond !== null) {
        if (cond === "remote-stream-error" && conflict.length > 0) {
          cond = "conflict";
        }
        this._changeConnectStatus(Strophe$2.Status.CONNFAIL, cond);
      } else {
        this._changeConnectStatus(Strophe$2.Status.CONNFAIL, Strophe$2.ErrorCondition.UNKOWN_REASON);
      }
      this._doDisconnect(cond);
      return;
    }

    // send each incoming stanza through the handler chain
    Strophe$2.forEachChild(elem, null, child => {
      const matches = [];
      this.handlers = this.handlers.reduce((handlers, handler) => {
        try {
          if (handler.isMatch(child) && (this.authenticated || !handler.user)) {
            if (handler.run(child)) {
              handlers.push(handler);
            }
            matches.push(handler);
          } else {
            handlers.push(handler);
          }
        } catch (e) {
          // if the handler throws an exception, we consider it as false
          Strophe$2.warn('Removing Strophe handlers due to uncaught exception: ' + e.message);
        }
        return handlers;
      }, []);

      // If no handler was fired for an incoming IQ with type="set",
      // then we return an IQ error stanza with service-unavailable.
      if (!matches.length && this.iqFallbackHandler.isMatch(child)) {
        this.iqFallbackHandler.run(child);
      }
    });
  }

  /** PrivateFunction: _connect_cb
   *  _Private_ handler for initial connection request.
   *
   *  This handler is used to process the initial connection request
   *  response from the BOSH server. It is used to set up authentication
   *  handlers and start the authentication process.
   *
   *  SASL authentication will be attempted if available, otherwise
   *  the code will fall back to legacy authentication.
   *
   *  Parameters:
   *    (Strophe.Request) req - The current request.
   *    (Function) _callback - low level (xmpp) connect callback function.
   *      Useful for plugins with their own xmpp connect callback (when they
   *      want to do something special).
   */
  _connect_cb(req, _callback, raw) {
    Strophe$2.debug("_connect_cb was called");
    this.connected = true;
    let bodyWrap;
    try {
      bodyWrap = this._proto._reqToData(req);
    } catch (e) {
      if (e.name !== Strophe$2.ErrorCondition.BAD_FORMAT) {
        throw e;
      }
      this._changeConnectStatus(Strophe$2.Status.CONNFAIL, Strophe$2.ErrorCondition.BAD_FORMAT);
      this._doDisconnect(Strophe$2.ErrorCondition.BAD_FORMAT);
    }
    if (!bodyWrap) {
      return;
    }
    if (this.xmlInput !== Strophe$2.Connection.prototype.xmlInput) {
      if (bodyWrap.nodeName === this._proto.strip && bodyWrap.childNodes.length) {
        this.xmlInput(bodyWrap.childNodes[0]);
      } else {
        this.xmlInput(bodyWrap);
      }
    }
    if (this.rawInput !== Strophe$2.Connection.prototype.rawInput) {
      if (raw) {
        this.rawInput(raw);
      } else {
        this.rawInput(Strophe$2.serialize(bodyWrap));
      }
    }
    const conncheck = this._proto._connect_cb(bodyWrap);
    if (conncheck === Strophe$2.Status.CONNFAIL) {
      return;
    }

    // Check for the stream:features tag
    let hasFeatures;
    if (bodyWrap.getElementsByTagNameNS) {
      hasFeatures = bodyWrap.getElementsByTagNameNS(Strophe$2.NS.STREAM, "features").length > 0;
    } else {
      hasFeatures = bodyWrap.getElementsByTagName("stream:features").length > 0 || bodyWrap.getElementsByTagName("features").length > 0;
    }
    if (!hasFeatures) {
      this._proto._no_auth_received(_callback);
      return;
    }
    const matched = Array.from(bodyWrap.getElementsByTagName("mechanism")).map(m => this.mechanisms[m.textContent]).filter(m => m);
    if (matched.length === 0) {
      if (bodyWrap.getElementsByTagName("auth").length === 0) {
        // There are no matching SASL mechanisms and also no legacy
        // auth available.
        this._proto._no_auth_received(_callback);
        return;
      }
    }
    if (this.do_authentication !== false) {
      this.authenticate(matched);
    }
  }

  /** Function: sortMechanismsByPriority
   *
   *  Sorts an array of objects with prototype SASLMechanism according to
   *  their priorities.
   *
   *  Parameters:
   *    (Array) mechanisms - Array of SASL mechanisms.
   *
   */
  sortMechanismsByPriority(mechanisms) {
    // eslint-disable-line class-methods-use-this
    // Sorting mechanisms according to priority.
    for (let i = 0; i < mechanisms.length - 1; ++i) {
      let higher = i;
      for (let j = i + 1; j < mechanisms.length; ++j) {
        if (mechanisms[j].priority > mechanisms[higher].priority) {
          higher = j;
        }
      }
      if (higher !== i) {
        const swap = mechanisms[i];
        mechanisms[i] = mechanisms[higher];
        mechanisms[higher] = swap;
      }
    }
    return mechanisms;
  }

  /** Function: authenticate
   * Set up authentication
   *
   *  Continues the initial connection request by setting up authentication
   *  handlers and starting the authentication process.
   *
   *  SASL authentication will be attempted if available, otherwise
   *  the code will fall back to legacy authentication.
   *
   *  Parameters:
   *    (Array) matched - Array of SASL mechanisms supported.
   *
   */
  authenticate(matched) {
    if (!this._attemptSASLAuth(matched)) {
      this._attemptLegacyAuth();
    }
  }

  /** PrivateFunction: _attemptSASLAuth
   *
   *  Iterate through an array of SASL mechanisms and attempt authentication
   *  with the highest priority (enabled) mechanism.
   *
   *  Parameters:
   *    (Array) mechanisms - Array of SASL mechanisms.
   *
   *  Returns:
   *    (Boolean) mechanism_found - true or false, depending on whether a
   *          valid SASL mechanism was found with which authentication could be
   *          started.
   */
  _attemptSASLAuth(mechanisms) {
    mechanisms = this.sortMechanismsByPriority(mechanisms || []);
    let mechanism_found = false;
    for (let i = 0; i < mechanisms.length; ++i) {
      if (!mechanisms[i].test(this)) {
        continue;
      }
      this._sasl_success_handler = this._addSysHandler(this._sasl_success_cb.bind(this), null, "success", null, null);
      this._sasl_failure_handler = this._addSysHandler(this._sasl_failure_cb.bind(this), null, "failure", null, null);
      this._sasl_challenge_handler = this._addSysHandler(this._sasl_challenge_cb.bind(this), null, "challenge", null, null);
      this._sasl_mechanism = mechanisms[i];
      this._sasl_mechanism.onStart(this);
      const request_auth_exchange = $build$1("auth", {
        'xmlns': Strophe$2.NS.SASL,
        'mechanism': this._sasl_mechanism.mechname
      });
      if (this._sasl_mechanism.isClientFirst) {
        const response = this._sasl_mechanism.clientChallenge(this);
        request_auth_exchange.t(abab_2(response));
      }
      this.send(request_auth_exchange.tree());
      mechanism_found = true;
      break;
    }
    return mechanism_found;
  }

  /** PrivateFunction: _sasl_challenge_cb
   *  _Private_ handler for the SASL challenge
   *
   */
  async _sasl_challenge_cb(elem) {
    const challenge = abab_1(Strophe$2.getText(elem));
    const response = await this._sasl_mechanism.onChallenge(this, challenge);
    const stanza = $build$1('response', {
      'xmlns': Strophe$2.NS.SASL
    });
    if (response !== "") {
      stanza.t(abab_2(response));
    }
    this.send(stanza.tree());
    return true;
  }

  /** PrivateFunction: _attemptLegacyAuth
   *
   *  Attempt legacy (i.e. non-SASL) authentication.
   */
  _attemptLegacyAuth() {
    if (Strophe$2.getNodeFromJid(this.jid) === null) {
      // we don't have a node, which is required for non-anonymous
      // client connections
      this._changeConnectStatus(Strophe$2.Status.CONNFAIL, Strophe$2.ErrorCondition.MISSING_JID_NODE);
      this.disconnect(Strophe$2.ErrorCondition.MISSING_JID_NODE);
    } else {
      // Fall back to legacy authentication
      this._changeConnectStatus(Strophe$2.Status.AUTHENTICATING, null);
      this._addSysHandler(this._onLegacyAuthIQResult.bind(this), null, null, null, "_auth_1");
      this.send($iq$1({
        'type': "get",
        'to': this.domain,
        'id': "_auth_1"
      }).c("query", {
        xmlns: Strophe$2.NS.AUTH
      }).c("username", {}).t(Strophe$2.getNodeFromJid(this.jid)).tree());
    }
  }

  /** PrivateFunction: _onLegacyAuthIQResult
   *  _Private_ handler for legacy authentication.
   *
   *  This handler is called in response to the initial <iq type='get'/>
   *  for legacy authentication.  It builds an authentication <iq/> and
   *  sends it, creating a handler (calling back to _auth2_cb()) to
   *  handle the result
   *
   *  Parameters:
   *    (XMLElement) elem - The stanza that triggered the callback.
   *
   *  Returns:
   *    false to remove the handler.
   */
  _onLegacyAuthIQResult(elem) {
    // eslint-disable-line no-unused-vars
    // build plaintext auth iq
    const iq = $iq$1({
      type: "set",
      id: "_auth_2"
    }).c('query', {
      xmlns: Strophe$2.NS.AUTH
    }).c('username', {}).t(Strophe$2.getNodeFromJid(this.jid)).up().c('password').t(this.pass);
    if (!Strophe$2.getResourceFromJid(this.jid)) {
      // since the user has not supplied a resource, we pick
      // a default one here.  unlike other auth methods, the server
      // cannot do this for us.
      this.jid = Strophe$2.getBareJidFromJid(this.jid) + '/strophe';
    }
    iq.up().c('resource', {}).t(Strophe$2.getResourceFromJid(this.jid));
    this._addSysHandler(this._auth2_cb.bind(this), null, null, null, "_auth_2");
    this.send(iq.tree());
    return false;
  }

  /** PrivateFunction: _sasl_success_cb
   *  _Private_ handler for succesful SASL authentication.
   *
   *  Parameters:
   *    (XMLElement) elem - The matching stanza.
   *
   *  Returns:
   *    false to remove the handler.
   */
  _sasl_success_cb(elem) {
    if (this._sasl_data["server-signature"]) {
      let serverSignature;
      const success = abab_1(Strophe$2.getText(elem));
      const attribMatch = /([a-z]+)=([^,]+)(,|$)/;
      const matches = success.match(attribMatch);
      if (matches[1] === "v") {
        serverSignature = matches[2];
      }
      if (serverSignature !== this._sasl_data["server-signature"]) {
        // remove old handlers
        this.deleteHandler(this._sasl_failure_handler);
        this._sasl_failure_handler = null;
        if (this._sasl_challenge_handler) {
          this.deleteHandler(this._sasl_challenge_handler);
          this._sasl_challenge_handler = null;
        }
        this._sasl_data = {};
        return this._sasl_failure_cb(null);
      }
    }
    Strophe$2.info("SASL authentication succeeded.");
    if (this._sasl_data.keys) {
      this.scram_keys = this._sasl_data.keys;
    }
    if (this._sasl_mechanism) {
      this._sasl_mechanism.onSuccess();
    }
    // remove old handlers
    this.deleteHandler(this._sasl_failure_handler);
    this._sasl_failure_handler = null;
    if (this._sasl_challenge_handler) {
      this.deleteHandler(this._sasl_challenge_handler);
      this._sasl_challenge_handler = null;
    }
    const streamfeature_handlers = [];
    const wrapper = (handlers, elem) => {
      while (handlers.length) {
        this.deleteHandler(handlers.pop());
      }
      this._onStreamFeaturesAfterSASL(elem);
      return false;
    };
    streamfeature_handlers.push(this._addSysHandler(elem => wrapper(streamfeature_handlers, elem), null, "stream:features", null, null));
    streamfeature_handlers.push(this._addSysHandler(elem => wrapper(streamfeature_handlers, elem), Strophe$2.NS.STREAM, "features", null, null));

    // we must send an xmpp:restart now
    this._sendRestart();
    return false;
  }

  /** PrivateFunction: _onStreamFeaturesAfterSASL
   *  Parameters:
   *    (XMLElement) elem - The matching stanza.
   *
   *  Returns:
   *    false to remove the handler.
   */
  _onStreamFeaturesAfterSASL(elem) {
    // save stream:features for future usage
    this.features = elem;
    for (let i = 0; i < elem.childNodes.length; i++) {
      const child = elem.childNodes[i];
      if (child.nodeName === 'bind') {
        this.do_bind = true;
      }
      if (child.nodeName === 'session') {
        this.do_session = true;
      }
    }
    if (!this.do_bind) {
      this._changeConnectStatus(Strophe$2.Status.AUTHFAIL, null);
      return false;
    } else if (!this.options.explicitResourceBinding) {
      this.bind();
    } else {
      this._changeConnectStatus(Strophe$2.Status.BINDREQUIRED, null);
    }
    return false;
  }

  /** Function: bind
   *
   *  Sends an IQ to the XMPP server to bind a JID resource for this session.
   *
   *  https://tools.ietf.org/html/rfc6120#section-7.5
   *
   *  If `explicitResourceBinding` was set to a truthy value in the options
   *  passed to the Strophe.Connection constructor, then this function needs
   *  to be called explicitly by the client author.
   *
   *  Otherwise it'll be called automatically as soon as the XMPP server
   *  advertises the "urn:ietf:params:xml:ns:xmpp-bind" stream feature.
   */
  bind() {
    if (!this.do_bind) {
      Strophe$2.log(Strophe$2.LogLevel.INFO, `Strophe.Connection.prototype.bind called but "do_bind" is false`);
      return;
    }
    this._addSysHandler(this._onResourceBindResultIQ.bind(this), null, null, null, "_bind_auth_2");
    const resource = Strophe$2.getResourceFromJid(this.jid);
    if (resource) {
      this.send($iq$1({
        type: "set",
        id: "_bind_auth_2"
      }).c('bind', {
        xmlns: Strophe$2.NS.BIND
      }).c('resource', {}).t(resource).tree());
    } else {
      this.send($iq$1({
        type: "set",
        id: "_bind_auth_2"
      }).c('bind', {
        xmlns: Strophe$2.NS.BIND
      }).tree());
    }
  }

  /** PrivateFunction: _onResourceBindIQ
   *  _Private_ handler for binding result and session start.
   *
   *  Parameters:
   *    (XMLElement) elem - The matching stanza.
   *
   *  Returns:
   *    false to remove the handler.
   */
  _onResourceBindResultIQ(elem) {
    if (elem.getAttribute("type") === "error") {
      Strophe$2.warn("Resource binding failed.");
      const conflict = elem.getElementsByTagName("conflict");
      let condition;
      if (conflict.length > 0) {
        condition = Strophe$2.ErrorCondition.CONFLICT;
      }
      this._changeConnectStatus(Strophe$2.Status.AUTHFAIL, condition, elem);
      return false;
    }
    // TODO - need to grab errors
    const bind = elem.getElementsByTagName("bind");
    if (bind.length > 0) {
      const jidNode = bind[0].getElementsByTagName("jid");
      if (jidNode.length > 0) {
        this.authenticated = true;
        this.jid = Strophe$2.getText(jidNode[0]);
        if (this.do_session) {
          this._establishSession();
        } else {
          this._changeConnectStatus(Strophe$2.Status.CONNECTED, null);
        }
      }
    } else {
      Strophe$2.warn("Resource binding failed.");
      this._changeConnectStatus(Strophe$2.Status.AUTHFAIL, null, elem);
      return false;
    }
  }

  /** PrivateFunction: _establishSession
   *  Send IQ request to establish a session with the XMPP server.
   *
   *  See https://xmpp.org/rfcs/rfc3921.html#session
   *
   *  Note: The protocol for session establishment has been determined as
   *  unnecessary and removed in RFC-6121.
   */
  _establishSession() {
    if (!this.do_session) {
      throw new Error(`Strophe.Connection.prototype._establishSession ` + `called but apparently ${Strophe$2.NS.SESSION} wasn't advertised by the server`);
    }
    this._addSysHandler(this._onSessionResultIQ.bind(this), null, null, null, "_session_auth_2");
    this.send($iq$1({
      type: "set",
      id: "_session_auth_2"
    }).c('session', {
      xmlns: Strophe$2.NS.SESSION
    }).tree());
  }

  /** PrivateFunction: _onSessionResultIQ
   *  _Private_ handler for the server's IQ response to a client's session
   *  request.
   *
   *  This sets Connection.authenticated to true on success, which
   *  starts the processing of user handlers.
   *
   *  See https://xmpp.org/rfcs/rfc3921.html#session
   *
   *  Note: The protocol for session establishment has been determined as
   *  unnecessary and removed in RFC-6121.
   *
   *  Parameters:
   *    (XMLElement) elem - The matching stanza.
   *
   *  Returns:
   *    false to remove the handler.
   */
  _onSessionResultIQ(elem) {
    if (elem.getAttribute("type") === "result") {
      this.authenticated = true;
      this._changeConnectStatus(Strophe$2.Status.CONNECTED, null);
    } else if (elem.getAttribute("type") === "error") {
      this.authenticated = false;
      Strophe$2.warn("Session creation failed.");
      this._changeConnectStatus(Strophe$2.Status.AUTHFAIL, null, elem);
      return false;
    }
    return false;
  }

  /** PrivateFunction: _sasl_failure_cb
   *  _Private_ handler for SASL authentication failure.
   *
   *  Parameters:
   *    (XMLElement) elem - The matching stanza.
   *
   *  Returns:
   *    false to remove the handler.
   */
  _sasl_failure_cb(elem) {
    // delete unneeded handlers
    if (this._sasl_success_handler) {
      this.deleteHandler(this._sasl_success_handler);
      this._sasl_success_handler = null;
    }
    if (this._sasl_challenge_handler) {
      this.deleteHandler(this._sasl_challenge_handler);
      this._sasl_challenge_handler = null;
    }
    if (this._sasl_mechanism) this._sasl_mechanism.onFailure();
    this._changeConnectStatus(Strophe$2.Status.AUTHFAIL, null, elem);
    return false;
  }

  /** PrivateFunction: _auth2_cb
   *  _Private_ handler to finish legacy authentication.
   *
   *  This handler is called when the result from the jabber:iq:auth
   *  <iq/> stanza is returned.
   *
   *  Parameters:
   *    (XMLElement) elem - The stanza that triggered the callback.
   *
   *  Returns:
   *    false to remove the handler.
   */
  _auth2_cb(elem) {
    if (elem.getAttribute("type") === "result") {
      this.authenticated = true;
      this._changeConnectStatus(Strophe$2.Status.CONNECTED, null);
    } else if (elem.getAttribute("type") === "error") {
      this._changeConnectStatus(Strophe$2.Status.AUTHFAIL, null, elem);
      this.disconnect('authentication failed');
    }
    return false;
  }

  /** PrivateFunction: _addSysTimedHandler
   *  _Private_ function to add a system level timed handler.
   *
   *  This function is used to add a Strophe.TimedHandler for the
   *  library code.  System timed handlers are allowed to run before
   *  authentication is complete.
   *
   *  Parameters:
   *    (Integer) period - The period of the handler.
   *    (Function) handler - The callback function.
   */
  _addSysTimedHandler(period, handler) {
    const thand = new Strophe$2.TimedHandler(period, handler);
    thand.user = false;
    this.addTimeds.push(thand);
    return thand;
  }

  /** PrivateFunction: _addSysHandler
   *  _Private_ function to add a system level stanza handler.
   *
   *  This function is used to add a Strophe.Handler for the
   *  library code.  System stanza handlers are allowed to run before
   *  authentication is complete.
   *
   *  Parameters:
   *    (Function) handler - The callback function.
   *    (String) ns - The namespace to match.
   *    (String) name - The stanza name to match.
   *    (String) type - The stanza type attribute to match.
   *    (String) id - The stanza id attribute to match.
   */
  _addSysHandler(handler, ns, name, type, id) {
    const hand = new Strophe$2.Handler(handler, ns, name, type, id);
    hand.user = false;
    this.addHandlers.push(hand);
    return hand;
  }

  /** PrivateFunction: _onDisconnectTimeout
   *  _Private_ timeout handler for handling non-graceful disconnection.
   *
   *  If the graceful disconnect process does not complete within the
   *  time allotted, this handler finishes the disconnect anyway.
   *
   *  Returns:
   *    false to remove the handler.
   */
  _onDisconnectTimeout() {
    Strophe$2.debug("_onDisconnectTimeout was called");
    this._changeConnectStatus(Strophe$2.Status.CONNTIMEOUT, null);
    this._proto._onDisconnectTimeout();
    // actually disconnect
    this._doDisconnect();
    return false;
  }

  /** PrivateFunction: _onIdle
   *  _Private_ handler to process events during idle cycle.
   *
   *  This handler is called every 100ms to fire timed handlers that
   *  are ready and keep poll requests going.
   */
  _onIdle() {
    // add timed handlers scheduled for addition
    // NOTE: we add before remove in the case a timed handler is
    // added and then deleted before the next _onIdle() call.
    while (this.addTimeds.length > 0) {
      this.timedHandlers.push(this.addTimeds.pop());
    }

    // remove timed handlers that have been scheduled for deletion
    while (this.removeTimeds.length > 0) {
      const thand = this.removeTimeds.pop();
      const i = this.timedHandlers.indexOf(thand);
      if (i >= 0) {
        this.timedHandlers.splice(i, 1);
      }
    }

    // call ready timed handlers
    const now = new Date().getTime();
    const newList = [];
    for (let i = 0; i < this.timedHandlers.length; i++) {
      const thand = this.timedHandlers[i];
      if (this.authenticated || !thand.user) {
        const since = thand.lastCalled + thand.period;
        if (since - now <= 0) {
          if (thand.run()) {
            newList.push(thand);
          }
        } else {
          newList.push(thand);
        }
      }
    }
    this.timedHandlers = newList;
    clearTimeout(this._idleTimeout);
    this._proto._onIdle();

    // reactivate the timer only if connected
    if (this.connected) {
      this._idleTimeout = setTimeout(() => this._onIdle(), 100);
    }
  }
};
Strophe$2.SASLMechanism = SASLMechanism$1;

/** Constants: SASL mechanisms
 *  Available authentication mechanisms
 *
 *  Strophe.SASLAnonymous   - SASL ANONYMOUS authentication.
 *  Strophe.SASLPlain       - SASL PLAIN authentication.
 *  Strophe.SASLSHA1        - SASL SCRAM-SHA-1 authentication
 *  Strophe.SASLSHA256      - SASL SCRAM-SHA-256 authentication
 *  Strophe.SASLSHA384      - SASL SCRAM-SHA-384 authentication
 *  Strophe.SASLSHA512      - SASL SCRAM-SHA-512 authentication
 *  Strophe.SASLOAuthBearer - SASL OAuth Bearer authentication
 *  Strophe.SASLExternal    - SASL EXTERNAL authentication
 *  Strophe.SASLXOAuth2     - SASL X-OAuth2 authentication
 */
Strophe$2.SASLAnonymous = SASLAnonymous$1;
Strophe$2.SASLPlain = SASLPlain$1;
Strophe$2.SASLSHA1 = SASLSHA1$1;
Strophe$2.SASLSHA256 = SASLSHA256$1;
Strophe$2.SASLSHA384 = SASLSHA384$1;
Strophe$2.SASLSHA512 = SASLSHA512$1;
Strophe$2.SASLOAuthBearer = SASLOAuthBearer$1;
Strophe$2.SASLExternal = SASLExternal$1;
Strophe$2.SASLXOAuth2 = SASLXOAuth2$1;
var core = {
  'Strophe': Strophe$2,
  '$build': $build$1,
  '$iq': $iq$1,
  '$msg': $msg$1,
  '$pres': $pres$1
};

/*
    This program is distributed under the terms of the MIT license.
    Please see the LICENSE file for details.

    Copyright 2006-2008, OGG, LLC
*/

/** PrivateClass: Strophe.Request
 *  _Private_ helper class that provides a cross implementation abstraction
 *  for a BOSH related XMLHttpRequest.
 *
 *  The Strophe.Request class is used internally to encapsulate BOSH request
 *  information.  It is not meant to be used from user's code.
 */
Strophe$2.Request = class Request {
  /** PrivateConstructor: Strophe.Request
   *  Create and initialize a new Strophe.Request object.
   *
   *  Parameters:
   *    (XMLElement) elem - The XML data to be sent in the request.
   *    (Function) func - The function that will be called when the
   *      XMLHttpRequest readyState changes.
   *    (Integer) rid - The BOSH rid attribute associated with this request.
   *    (Integer) sends - The number of times this same request has been sent.
   */
  constructor(elem, func, rid, sends) {
    this.id = ++Strophe$2._requestId;
    this.xmlData = elem;
    this.data = Strophe$2.serialize(elem);
    // save original function in case we need to make a new request
    // from this one.
    this.origFunc = func;
    this.func = func;
    this.rid = rid;
    this.date = NaN;
    this.sends = sends || 0;
    this.abort = false;
    this.dead = null;
    this.age = function () {
      if (!this.date) {
        return 0;
      }
      const now = new Date();
      return (now - this.date) / 1000;
    };
    this.timeDead = function () {
      if (!this.dead) {
        return 0;
      }
      const now = new Date();
      return (now - this.dead) / 1000;
    };
    this.xhr = this._newXHR();
  }

  /** PrivateFunction: getResponse
   *  Get a response from the underlying XMLHttpRequest.
   *
   *  This function attempts to get a response from the request and checks
   *  for errors.
   *
   *  Throws:
   *    "parsererror" - A parser error occured.
   *    "bad-format" - The entity has sent XML that cannot be processed.
   *
   *  Returns:
   *    The DOM element tree of the response.
   */
  getResponse() {
    let node = null;
    if (this.xhr.responseXML && this.xhr.responseXML.documentElement) {
      node = this.xhr.responseXML.documentElement;
      if (node.tagName === "parsererror") {
        Strophe$2.error("invalid response received");
        Strophe$2.error("responseText: " + this.xhr.responseText);
        Strophe$2.error("responseXML: " + Strophe$2.serialize(this.xhr.responseXML));
        throw new Error("parsererror");
      }
    } else if (this.xhr.responseText) {
      // In React Native, we may get responseText but no responseXML.  We can try to parse it manually.
      Strophe$2.debug("Got responseText but no responseXML; attempting to parse it with DOMParser...");
      node = new DOMParser$2().parseFromString(this.xhr.responseText, 'application/xml').documentElement;
      if (!node) {
        throw new Error('Parsing produced null node');
      } else if (node.querySelector('parsererror')) {
        Strophe$2.error("invalid response received: " + node.querySelector('parsererror').textContent);
        Strophe$2.error("responseText: " + this.xhr.responseText);
        const error = new Error();
        error.name = Strophe$2.ErrorCondition.BAD_FORMAT;
        throw error;
      }
    }
    return node;
  }

  /** PrivateFunction: _newXHR
   *  _Private_ helper function to create XMLHttpRequests.
   *
   *  This function creates XMLHttpRequests across all implementations.
   *
   *  Returns:
   *    A new XMLHttpRequest.
   */
  _newXHR() {
    let xhr = null;
    if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest();
      if (xhr.overrideMimeType) {
        xhr.overrideMimeType("text/xml; charset=utf-8");
      }
    } else if (window.ActiveXObject) {
      xhr = new ActiveXObject("Microsoft.XMLHTTP");
    }
    // use Function.bind() to prepend ourselves as an argument
    xhr.onreadystatechange = this.func.bind(null, this);
    return xhr;
  }
};

/** Class: Strophe.Bosh
 *  _Private_ helper class that handles BOSH Connections
 *
 *  The Strophe.Bosh class is used internally by Strophe.Connection
 *  to encapsulate BOSH sessions. It is not meant to be used from user's code.
 */

/** File: bosh.js
 *  A JavaScript library to enable BOSH in Strophejs.
 *
 *  this library uses Bidirectional-streams Over Synchronous HTTP (BOSH)
 *  to emulate a persistent, stateful, two-way connection to an XMPP server.
 *  More information on BOSH can be found in XEP 124.
 */

/** PrivateConstructor: Strophe.Bosh
 *  Create and initialize a Strophe.Bosh object.
 *
 *  Parameters:
 *    (Strophe.Connection) connection - The Strophe.Connection that will use BOSH.
 *
 *  Returns:
 *    A new Strophe.Bosh object.
 */
Strophe$2.Bosh = class Bosh {
  constructor(connection) {
    this._conn = connection;
    /* request id for body tags */
    this.rid = Math.floor(Math.random() * 4294967295);
    /* The current session ID. */
    this.sid = null;

    // default BOSH values
    this.hold = 1;
    this.wait = 60;
    this.window = 5;
    this.errors = 0;
    this.inactivity = null;
    this.lastResponseHeaders = null;
    this._requests = [];
  }

  /** PrivateFunction: _buildBody
   *  _Private_ helper function to generate the <body/> wrapper for BOSH.
   *
   *  Returns:
   *    A Strophe.Builder with a <body/> element.
   */
  _buildBody() {
    const bodyWrap = $build$1('body', {
      'rid': this.rid++,
      'xmlns': Strophe$2.NS.HTTPBIND
    });
    if (this.sid !== null) {
      bodyWrap.attrs({
        'sid': this.sid
      });
    }
    if (this._conn.options.keepalive && this._conn._sessionCachingSupported()) {
      this._cacheSession();
    }
    return bodyWrap;
  }

  /** PrivateFunction: _reset
   *  Reset the connection.
   *
   *  This function is called by the reset function of the Strophe Connection
   */
  _reset() {
    this.rid = Math.floor(Math.random() * 4294967295);
    this.sid = null;
    this.errors = 0;
    if (this._conn._sessionCachingSupported()) {
      window.sessionStorage.removeItem('strophe-bosh-session');
    }
    this._conn.nextValidRid(this.rid);
  }

  /** PrivateFunction: _connect
   *  _Private_ function that initializes the BOSH connection.
   *
   *  Creates and sends the Request that initializes the BOSH connection.
   */
  _connect(wait, hold, route) {
    this.wait = wait || this.wait;
    this.hold = hold || this.hold;
    this.errors = 0;
    const body = this._buildBody().attrs({
      "to": this._conn.domain,
      "xml:lang": "en",
      "wait": this.wait,
      "hold": this.hold,
      "content": "text/xml; charset=utf-8",
      "ver": "1.6",
      "xmpp:version": "1.0",
      "xmlns:xmpp": Strophe$2.NS.BOSH
    });
    if (route) {
      body.attrs({
        'route': route
      });
    }
    const _connect_cb = this._conn._connect_cb;
    this._requests.push(new Strophe$2.Request(body.tree(), this._onRequestStateChange.bind(this, _connect_cb.bind(this._conn)), body.tree().getAttribute("rid")));
    this._throttledRequestHandler();
  }

  /** PrivateFunction: _attach
   *  Attach to an already created and authenticated BOSH session.
   *
   *  This function is provided to allow Strophe to attach to BOSH
   *  sessions which have been created externally, perhaps by a Web
   *  application.  This is often used to support auto-login type features
   *  without putting user credentials into the page.
   *
   *  Parameters:
   *    (String) jid - The full JID that is bound by the session.
   *    (String) sid - The SID of the BOSH session.
   *    (String) rid - The current RID of the BOSH session.  This RID
   *      will be used by the next request.
   *    (Function) callback The connect callback function.
   *    (Integer) wait - The optional HTTPBIND wait value.  This is the
   *      time the server will wait before returning an empty result for
   *      a request.  The default setting of 60 seconds is recommended.
   *      Other settings will require tweaks to the Strophe.TIMEOUT value.
   *    (Integer) hold - The optional HTTPBIND hold value.  This is the
   *      number of connections the server will hold at one time.  This
   *      should almost always be set to 1 (the default).
   *    (Integer) wind - The optional HTTBIND window value.  This is the
   *      allowed range of request ids that are valid.  The default is 5.
   */
  _attach(jid, sid, rid, callback, wait, hold, wind) {
    this._conn.jid = jid;
    this.sid = sid;
    this.rid = rid;
    this._conn.connect_callback = callback;
    this._conn.domain = Strophe$2.getDomainFromJid(this._conn.jid);
    this._conn.authenticated = true;
    this._conn.connected = true;
    this.wait = wait || this.wait;
    this.hold = hold || this.hold;
    this.window = wind || this.window;
    this._conn._changeConnectStatus(Strophe$2.Status.ATTACHED, null);
  }

  /** PrivateFunction: _restore
   *  Attempt to restore a cached BOSH session
   *
   *  Parameters:
   *    (String) jid - The full JID that is bound by the session.
   *      This parameter is optional but recommended, specifically in cases
   *      where prebinded BOSH sessions are used where it's important to know
   *      that the right session is being restored.
   *    (Function) callback The connect callback function.
   *    (Integer) wait - The optional HTTPBIND wait value.  This is the
   *      time the server will wait before returning an empty result for
   *      a request.  The default setting of 60 seconds is recommended.
   *      Other settings will require tweaks to the Strophe.TIMEOUT value.
   *    (Integer) hold - The optional HTTPBIND hold value.  This is the
   *      number of connections the server will hold at one time.  This
   *      should almost always be set to 1 (the default).
   *    (Integer) wind - The optional HTTBIND window value.  This is the
   *      allowed range of request ids that are valid.  The default is 5.
   */
  _restore(jid, callback, wait, hold, wind) {
    const session = JSON.parse(window.sessionStorage.getItem('strophe-bosh-session'));
    if (typeof session !== "undefined" && session !== null && session.rid && session.sid && session.jid && (typeof jid === "undefined" || jid === null || Strophe$2.getBareJidFromJid(session.jid) === Strophe$2.getBareJidFromJid(jid) ||
    // If authcid is null, then it's an anonymous login, so
    // we compare only the domains:
    Strophe$2.getNodeFromJid(jid) === null && Strophe$2.getDomainFromJid(session.jid) === jid)) {
      this._conn.restored = true;
      this._attach(session.jid, session.sid, session.rid, callback, wait, hold, wind);
    } else {
      const error = new Error("_restore: no restoreable session.");
      error.name = "StropheSessionError";
      throw error;
    }
  }

  /** PrivateFunction: _cacheSession
   *  _Private_ handler for the beforeunload event.
   *
   *  This handler is used to process the Bosh-part of the initial request.
   *  Parameters:
   *    (Strophe.Request) bodyWrap - The received stanza.
   */
  _cacheSession() {
    if (this._conn.authenticated) {
      if (this._conn.jid && this.rid && this.sid) {
        window.sessionStorage.setItem('strophe-bosh-session', JSON.stringify({
          'jid': this._conn.jid,
          'rid': this.rid,
          'sid': this.sid
        }));
      }
    } else {
      window.sessionStorage.removeItem('strophe-bosh-session');
    }
  }

  /** PrivateFunction: _connect_cb
   *  _Private_ handler for initial connection request.
   *
   *  This handler is used to process the Bosh-part of the initial request.
   *  Parameters:
   *    (Strophe.Request) bodyWrap - The received stanza.
   */
  _connect_cb(bodyWrap) {
    const typ = bodyWrap.getAttribute("type");
    if (typ !== null && typ === "terminate") {
      // an error occurred
      let cond = bodyWrap.getAttribute("condition");
      Strophe$2.error("BOSH-Connection failed: " + cond);
      const conflict = bodyWrap.getElementsByTagName("conflict");
      if (cond !== null) {
        if (cond === "remote-stream-error" && conflict.length > 0) {
          cond = "conflict";
        }
        this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, cond);
      } else {
        this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, "unknown");
      }
      this._conn._doDisconnect(cond);
      return Strophe$2.Status.CONNFAIL;
    }

    // check to make sure we don't overwrite these if _connect_cb is
    // called multiple times in the case of missing stream:features
    if (!this.sid) {
      this.sid = bodyWrap.getAttribute("sid");
    }
    const wind = bodyWrap.getAttribute('requests');
    if (wind) {
      this.window = parseInt(wind, 10);
    }
    const hold = bodyWrap.getAttribute('hold');
    if (hold) {
      this.hold = parseInt(hold, 10);
    }
    const wait = bodyWrap.getAttribute('wait');
    if (wait) {
      this.wait = parseInt(wait, 10);
    }
    const inactivity = bodyWrap.getAttribute('inactivity');
    if (inactivity) {
      this.inactivity = parseInt(inactivity, 10);
    }
  }

  /** PrivateFunction: _disconnect
   *  _Private_ part of Connection.disconnect for Bosh
   *
   *  Parameters:
   *    (Request) pres - This stanza will be sent before disconnecting.
   */
  _disconnect(pres) {
    this._sendTerminate(pres);
  }

  /** PrivateFunction: _doDisconnect
   *  _Private_ function to disconnect.
   *
   *  Resets the SID and RID.
   */
  _doDisconnect() {
    this.sid = null;
    this.rid = Math.floor(Math.random() * 4294967295);
    if (this._conn._sessionCachingSupported()) {
      window.sessionStorage.removeItem('strophe-bosh-session');
    }
    this._conn.nextValidRid(this.rid);
  }

  /** PrivateFunction: _emptyQueue
   * _Private_ function to check if the Request queue is empty.
   *
   *  Returns:
   *    True, if there are no Requests queued, False otherwise.
   */
  _emptyQueue() {
    return this._requests.length === 0;
  }

  /** PrivateFunction: _callProtocolErrorHandlers
   *  _Private_ function to call error handlers registered for HTTP errors.
   *
   *  Parameters:
   *    (Strophe.Request) req - The request that is changing readyState.
   */
  _callProtocolErrorHandlers(req) {
    const reqStatus = Bosh._getRequestStatus(req);
    const err_callback = this._conn.protocolErrorHandlers.HTTP[reqStatus];
    if (err_callback) {
      err_callback.call(this, reqStatus);
    }
  }

  /** PrivateFunction: _hitError
   *  _Private_ function to handle the error count.
   *
   *  Requests are resent automatically until their error count reaches
   *  5.  Each time an error is encountered, this function is called to
   *  increment the count and disconnect if the count is too high.
   *
   *  Parameters:
   *    (Integer) reqStatus - The request status.
   */
  _hitError(reqStatus) {
    this.errors++;
    Strophe$2.warn("request errored, status: " + reqStatus + ", number of errors: " + this.errors);
    if (this.errors > 4) {
      this._conn._onDisconnectTimeout();
    }
  }

  /** PrivateFunction: _no_auth_received
   *
   * Called on stream start/restart when no stream:features
   * has been received and sends a blank poll request.
   */
  _no_auth_received(callback) {
    Strophe$2.warn("Server did not yet offer a supported authentication " + "mechanism. Sending a blank poll request.");
    if (callback) {
      callback = callback.bind(this._conn);
    } else {
      callback = this._conn._connect_cb.bind(this._conn);
    }
    const body = this._buildBody();
    this._requests.push(new Strophe$2.Request(body.tree(), this._onRequestStateChange.bind(this, callback), body.tree().getAttribute("rid")));
    this._throttledRequestHandler();
  }

  /** PrivateFunction: _onDisconnectTimeout
   *  _Private_ timeout handler for handling non-graceful disconnection.
   *
   *  Cancels all remaining Requests and clears the queue.
   */
  _onDisconnectTimeout() {
    this._abortAllRequests();
  }

  /** PrivateFunction: _abortAllRequests
   *  _Private_ helper function that makes sure all pending requests are aborted.
   */
  _abortAllRequests() {
    while (this._requests.length > 0) {
      const req = this._requests.pop();
      req.abort = true;
      req.xhr.abort();
      req.xhr.onreadystatechange = function () {};
    }
  }

  /** PrivateFunction: _onIdle
   *  _Private_ handler called by Strophe.Connection._onIdle
   *
   *  Sends all queued Requests or polls with empty Request if there are none.
   */
  _onIdle() {
    const data = this._conn._data;
    // if no requests are in progress, poll
    if (this._conn.authenticated && this._requests.length === 0 && data.length === 0 && !this._conn.disconnecting) {
      Strophe$2.debug("no requests during idle cycle, sending blank request");
      data.push(null);
    }
    if (this._conn.paused) {
      return;
    }
    if (this._requests.length < 2 && data.length > 0) {
      const body = this._buildBody();
      for (let i = 0; i < data.length; i++) {
        if (data[i] !== null) {
          if (data[i] === "restart") {
            body.attrs({
              "to": this._conn.domain,
              "xml:lang": "en",
              "xmpp:restart": "true",
              "xmlns:xmpp": Strophe$2.NS.BOSH
            });
          } else {
            body.cnode(data[i]).up();
          }
        }
      }
      delete this._conn._data;
      this._conn._data = [];
      this._requests.push(new Strophe$2.Request(body.tree(), this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)), body.tree().getAttribute("rid")));
      this._throttledRequestHandler();
    }
    if (this._requests.length > 0) {
      const time_elapsed = this._requests[0].age();
      if (this._requests[0].dead !== null) {
        if (this._requests[0].timeDead() > Math.floor(Strophe$2.SECONDARY_TIMEOUT * this.wait)) {
          this._throttledRequestHandler();
        }
      }
      if (time_elapsed > Math.floor(Strophe$2.TIMEOUT * this.wait)) {
        Strophe$2.warn("Request " + this._requests[0].id + " timed out, over " + Math.floor(Strophe$2.TIMEOUT * this.wait) + " seconds since last activity");
        this._throttledRequestHandler();
      }
    }
  }

  /** PrivateFunction: _getRequestStatus
   *
   *  Returns the HTTP status code from a Strophe.Request
   *
   *  Parameters:
   *    (Strophe.Request) req - The Strophe.Request instance.
   *    (Integer) def - The default value that should be returned if no
   *          status value was found.
   */
  static _getRequestStatus(req, def) {
    let reqStatus;
    if (req.xhr.readyState === 4) {
      try {
        reqStatus = req.xhr.status;
      } catch (e) {
        // ignore errors from undefined status attribute. Works
        // around a browser bug
        Strophe$2.error("Caught an error while retrieving a request's status, " + "reqStatus: " + reqStatus);
      }
    }
    if (typeof reqStatus === "undefined") {
      reqStatus = typeof def === 'number' ? def : 0;
    }
    return reqStatus;
  }

  /** PrivateFunction: _onRequestStateChange
   *  _Private_ handler for Strophe.Request state changes.
   *
   *  This function is called when the XMLHttpRequest readyState changes.
   *  It contains a lot of error handling logic for the many ways that
   *  requests can fail, and calls the request callback when requests
   *  succeed.
   *
   *  Parameters:
   *    (Function) func - The handler for the request.
   *    (Strophe.Request) req - The request that is changing readyState.
   */
  _onRequestStateChange(func, req) {
    Strophe$2.debug("request id " + req.id + "." + req.sends + " state changed to " + req.xhr.readyState);
    if (req.abort) {
      req.abort = false;
      return;
    }
    if (req.xhr.readyState !== 4) {
      // The request is not yet complete
      return;
    }
    const reqStatus = Bosh._getRequestStatus(req);
    this.lastResponseHeaders = req.xhr.getAllResponseHeaders();
    if (this._conn.disconnecting && reqStatus >= 400) {
      this._hitError(reqStatus);
      this._callProtocolErrorHandlers(req);
      return;
    }
    const reqIs0 = this._requests[0] === req;
    const reqIs1 = this._requests[1] === req;
    const valid_request = reqStatus > 0 && reqStatus < 500;
    const too_many_retries = req.sends > this._conn.maxRetries;
    if (valid_request || too_many_retries) {
      // remove from internal queue
      this._removeRequest(req);
      Strophe$2.debug("request id " + req.id + " should now be removed");
    }
    if (reqStatus === 200) {
      // request succeeded
      // if request 1 finished, or request 0 finished and request
      // 1 is over Strophe.SECONDARY_TIMEOUT seconds old, we need to
      // restart the other - both will be in the first spot, as the
      // completed request has been removed from the queue already
      if (reqIs1 || reqIs0 && this._requests.length > 0 && this._requests[0].age() > Math.floor(Strophe$2.SECONDARY_TIMEOUT * this.wait)) {
        this._restartRequest(0);
      }
      this._conn.nextValidRid(Number(req.rid) + 1);
      Strophe$2.debug("request id " + req.id + "." + req.sends + " got 200");
      func(req); // call handler
      this.errors = 0;
    } else if (reqStatus === 0 || reqStatus >= 400 && reqStatus < 600 || reqStatus >= 12000) {
      // request failed
      Strophe$2.error("request id " + req.id + "." + req.sends + " error " + reqStatus + " happened");
      this._hitError(reqStatus);
      this._callProtocolErrorHandlers(req);
      if (reqStatus >= 400 && reqStatus < 500) {
        this._conn._changeConnectStatus(Strophe$2.Status.DISCONNECTING, null);
        this._conn._doDisconnect();
      }
    } else {
      Strophe$2.error("request id " + req.id + "." + req.sends + " error " + reqStatus + " happened");
    }
    if (!valid_request && !too_many_retries) {
      this._throttledRequestHandler();
    } else if (too_many_retries && !this._conn.connected) {
      this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, "giving-up");
    }
  }

  /** PrivateFunction: _processRequest
   *  _Private_ function to process a request in the queue.
   *
   *  This function takes requests off the queue and sends them and
   *  restarts dead requests.
   *
   *  Parameters:
   *    (Integer) i - The index of the request in the queue.
   */
  _processRequest(i) {
    let req = this._requests[i];
    const reqStatus = Bosh._getRequestStatus(req, -1);

    // make sure we limit the number of retries
    if (req.sends > this._conn.maxRetries) {
      this._conn._onDisconnectTimeout();
      return;
    }
    const time_elapsed = req.age();
    const primary_timeout = !isNaN(time_elapsed) && time_elapsed > Math.floor(Strophe$2.TIMEOUT * this.wait);
    const secondary_timeout = req.dead !== null && req.timeDead() > Math.floor(Strophe$2.SECONDARY_TIMEOUT * this.wait);
    const server_error = req.xhr.readyState === 4 && (reqStatus < 1 || reqStatus >= 500);
    if (primary_timeout || secondary_timeout || server_error) {
      if (secondary_timeout) {
        Strophe$2.error(`Request ${this._requests[i].id} timed out (secondary), restarting`);
      }
      req.abort = true;
      req.xhr.abort();
      // setting to null fails on IE6, so set to empty function
      req.xhr.onreadystatechange = function () {};
      this._requests[i] = new Strophe$2.Request(req.xmlData, req.origFunc, req.rid, req.sends);
      req = this._requests[i];
    }
    if (req.xhr.readyState === 0) {
      Strophe$2.debug("request id " + req.id + "." + req.sends + " posting");
      try {
        const content_type = this._conn.options.contentType || "text/xml; charset=utf-8";
        req.xhr.open("POST", this._conn.service, this._conn.options.sync ? false : true);
        if (typeof req.xhr.setRequestHeader !== 'undefined') {
          // IE9 doesn't have setRequestHeader
          req.xhr.setRequestHeader("Content-Type", content_type);
        }
        if (this._conn.options.withCredentials) {
          req.xhr.withCredentials = true;
        }
      } catch (e2) {
        Strophe$2.error("XHR open failed: " + e2.toString());
        if (!this._conn.connected) {
          this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, "bad-service");
        }
        this._conn.disconnect();
        return;
      }

      // Fires the XHR request -- may be invoked immediately
      // or on a gradually expanding retry window for reconnects
      const sendFunc = () => {
        req.date = new Date();
        if (this._conn.options.customHeaders) {
          const headers = this._conn.options.customHeaders;
          for (const header in headers) {
            if (Object.prototype.hasOwnProperty.call(headers, header)) {
              req.xhr.setRequestHeader(header, headers[header]);
            }
          }
        }
        req.xhr.send(req.data);
      };

      // Implement progressive backoff for reconnects --
      // First retry (send === 1) should also be instantaneous
      if (req.sends > 1) {
        // Using a cube of the retry number creates a nicely
        // expanding retry window
        const backoff = Math.min(Math.floor(Strophe$2.TIMEOUT * this.wait), Math.pow(req.sends, 3)) * 1000;
        setTimeout(function () {
          // XXX: setTimeout should be called only with function expressions (23974bc1)
          sendFunc();
        }, backoff);
      } else {
        sendFunc();
      }
      req.sends++;
      if (this._conn.xmlOutput !== Strophe$2.Connection.prototype.xmlOutput) {
        if (req.xmlData.nodeName === this.strip && req.xmlData.childNodes.length) {
          this._conn.xmlOutput(req.xmlData.childNodes[0]);
        } else {
          this._conn.xmlOutput(req.xmlData);
        }
      }
      if (this._conn.rawOutput !== Strophe$2.Connection.prototype.rawOutput) {
        this._conn.rawOutput(req.data);
      }
    } else {
      Strophe$2.debug("_processRequest: " + (i === 0 ? "first" : "second") + " request has readyState of " + req.xhr.readyState);
    }
  }

  /** PrivateFunction: _removeRequest
   *  _Private_ function to remove a request from the queue.
   *
   *  Parameters:
   *    (Strophe.Request) req - The request to remove.
   */
  _removeRequest(req) {
    Strophe$2.debug("removing request");
    for (let i = this._requests.length - 1; i >= 0; i--) {
      if (req === this._requests[i]) {
        this._requests.splice(i, 1);
      }
    }
    // IE6 fails on setting to null, so set to empty function
    req.xhr.onreadystatechange = function () {};
    this._throttledRequestHandler();
  }

  /** PrivateFunction: _restartRequest
   *  _Private_ function to restart a request that is presumed dead.
   *
   *  Parameters:
   *    (Integer) i - The index of the request in the queue.
   */
  _restartRequest(i) {
    const req = this._requests[i];
    if (req.dead === null) {
      req.dead = new Date();
    }
    this._processRequest(i);
  }

  /** PrivateFunction: _reqToData
   * _Private_ function to get a stanza out of a request.
   *
   * Tries to extract a stanza out of a Request Object.
   * When this fails the current connection will be disconnected.
   *
   *  Parameters:
   *    (Object) req - The Request.
   *
   *  Returns:
   *    The stanza that was passed.
   */
  _reqToData(req) {
    try {
      return req.getResponse();
    } catch (e) {
      if (e.message !== "parsererror") {
        throw e;
      }
      this._conn.disconnect("strophe-parsererror");
    }
  }

  /** PrivateFunction: _sendTerminate
   *  _Private_ function to send initial disconnect sequence.
   *
   *  This is the first step in a graceful disconnect.  It sends
   *  the BOSH server a terminate body and includes an unavailable
   *  presence if authentication has completed.
   */
  _sendTerminate(pres) {
    Strophe$2.debug("_sendTerminate was called");
    const body = this._buildBody().attrs({
      type: "terminate"
    });
    if (pres) {
      body.cnode(pres.tree());
    }
    const req = new Strophe$2.Request(body.tree(), this._onRequestStateChange.bind(this, this._conn._dataRecv.bind(this._conn)), body.tree().getAttribute("rid"));
    this._requests.push(req);
    this._throttledRequestHandler();
  }

  /** PrivateFunction: _send
   *  _Private_ part of the Connection.send function for BOSH
   *
   * Just triggers the RequestHandler to send the messages that are in the queue
   */
  _send() {
    clearTimeout(this._conn._idleTimeout);
    this._throttledRequestHandler();
    this._conn._idleTimeout = setTimeout(() => this._conn._onIdle(), 100);
  }

  /** PrivateFunction: _sendRestart
   *
   *  Send an xmpp:restart stanza.
   */
  _sendRestart() {
    this._throttledRequestHandler();
    clearTimeout(this._conn._idleTimeout);
  }

  /** PrivateFunction: _throttledRequestHandler
   *  _Private_ function to throttle requests to the connection window.
   *
   *  This function makes sure we don't send requests so fast that the
   *  request ids overflow the connection window in the case that one
   *  request died.
   */
  _throttledRequestHandler() {
    if (!this._requests) {
      Strophe$2.debug("_throttledRequestHandler called with " + "undefined requests");
    } else {
      Strophe$2.debug("_throttledRequestHandler called with " + this._requests.length + " requests");
    }
    if (!this._requests || this._requests.length === 0) {
      return;
    }
    if (this._requests.length > 0) {
      this._processRequest(0);
    }
    if (this._requests.length > 1 && Math.abs(this._requests[0].rid - this._requests[1].rid) < this.window) {
      this._processRequest(1);
    }
  }
};

/** Variable: strip
 *
 *  BOSH-Connections will have all stanzas wrapped in a <body> tag when
 *  passed to <Strophe.Connection.xmlInput> or <Strophe.Connection.xmlOutput>.
 *  To strip this tag, User code can set <Strophe.Bosh.strip> to "body":
 *
 *  > Strophe.Bosh.prototype.strip = "body";
 *
 *  This will enable stripping of the body tag in both
 *  <Strophe.Connection.xmlInput> and <Strophe.Connection.xmlOutput>.
 */
Strophe$2.Bosh.prototype.strip = null;

/*
    This program is distributed under the terms of the MIT license.
    Please see the LICENSE file for details.

    Copyright 2006-2008, OGG, LLC
*/

/** Class: Strophe.WebSocket
 *  _Private_ helper class that handles WebSocket Connections
 *
 *  The Strophe.WebSocket class is used internally by Strophe.Connection
 *  to encapsulate WebSocket sessions. It is not meant to be used from user's code.
 */

/** File: websocket.js
 *  A JavaScript library to enable XMPP over Websocket in Strophejs.
 *
 *  This file implements XMPP over WebSockets for Strophejs.
 *  If a Connection is established with a Websocket url (ws://...)
 *  Strophe will use WebSockets.
 *  For more information on XMPP-over-WebSocket see RFC 7395:
 *  http://tools.ietf.org/html/rfc7395
 *
 *  WebSocket support implemented by Andreas Guth (andreas.guth@rwth-aachen.de)
 */
Strophe$2.Websocket = class Websocket {
  /** PrivateConstructor: Strophe.Websocket
   *  Create and initialize a Strophe.WebSocket object.
   *  Currently only sets the connection Object.
   *
   *  Parameters:
   *    (Strophe.Connection) connection - The Strophe.Connection that will use WebSockets.
   *
   *  Returns:
   *    A new Strophe.WebSocket object.
   */
  constructor(connection) {
    this._conn = connection;
    this.strip = "wrapper";
    const service = connection.service;
    if (service.indexOf("ws:") !== 0 && service.indexOf("wss:") !== 0) {
      // If the service is not an absolute URL, assume it is a path and put the absolute
      // URL together from options, current URL and the path.
      let new_service = "";
      if (connection.options.protocol === "ws" && window.location.protocol !== "https:") {
        new_service += "ws";
      } else {
        new_service += "wss";
      }
      new_service += "://" + window.location.host;
      if (service.indexOf("/") !== 0) {
        new_service += window.location.pathname + service;
      } else {
        new_service += service;
      }
      connection.service = new_service;
    }
  }

  /** PrivateFunction: _buildStream
   *  _Private_ helper function to generate the <stream> start tag for WebSockets
   *
   *  Returns:
   *    A Strophe.Builder with a <stream> element.
   */
  _buildStream() {
    return $build$1("open", {
      "xmlns": Strophe$2.NS.FRAMING,
      "to": this._conn.domain,
      "version": '1.0'
    });
  }

  /** PrivateFunction: _checkStreamError
   * _Private_ checks a message for stream:error
   *
   *  Parameters:
   *    (Strophe.Request) bodyWrap - The received stanza.
   *    connectstatus - The ConnectStatus that will be set on error.
   *  Returns:
   *     true if there was a streamerror, false otherwise.
   */
  _checkStreamError(bodyWrap, connectstatus) {
    let errors;
    if (bodyWrap.getElementsByTagNameNS) {
      errors = bodyWrap.getElementsByTagNameNS(Strophe$2.NS.STREAM, "error");
    } else {
      errors = bodyWrap.getElementsByTagName("stream:error");
    }
    if (errors.length === 0) {
      return false;
    }
    const error = errors[0];
    let condition = "";
    let text = "";
    const ns = "urn:ietf:params:xml:ns:xmpp-streams";
    for (let i = 0; i < error.childNodes.length; i++) {
      const e = error.childNodes[i];
      if (e.getAttribute("xmlns") !== ns) {
        break;
      }
      if (e.nodeName === "text") {
        text = e.textContent;
      } else {
        condition = e.nodeName;
      }
    }
    let errorString = "WebSocket stream error: ";
    if (condition) {
      errorString += condition;
    } else {
      errorString += "unknown";
    }
    if (text) {
      errorString += " - " + text;
    }
    Strophe$2.error(errorString);

    // close the connection on stream_error
    this._conn._changeConnectStatus(connectstatus, condition);
    this._conn._doDisconnect();
    return true;
  }

  /** PrivateFunction: _reset
   *  Reset the connection.
   *
   *  This function is called by the reset function of the Strophe Connection.
   *  Is not needed by WebSockets.
   */
  _reset() {
    // eslint-disable-line class-methods-use-this
    return;
  }

  /** PrivateFunction: _connect
   *  _Private_ function called by Strophe.Connection.connect
   *
   *  Creates a WebSocket for a connection and assigns Callbacks to it.
   *  Does nothing if there already is a WebSocket.
   */
  _connect() {
    // Ensure that there is no open WebSocket from a previous Connection.
    this._closeSocket();
    this.socket = new WebSocket$1(this._conn.service, "xmpp");
    this.socket.onopen = () => this._onOpen();
    this.socket.onerror = e => this._onError(e);
    this.socket.onclose = e => this._onClose(e);
    // Gets replaced with this._onMessage once _onInitialMessage is called
    this.socket.onmessage = message => this._onInitialMessage(message);
  }

  /** PrivateFunction: _connect_cb
   *  _Private_ function called by Strophe.Connection._connect_cb
   *
   * checks for stream:error
   *
   *  Parameters:
   *    (Strophe.Request) bodyWrap - The received stanza.
   */
  _connect_cb(bodyWrap) {
    const error = this._checkStreamError(bodyWrap, Strophe$2.Status.CONNFAIL);
    if (error) {
      return Strophe$2.Status.CONNFAIL;
    }
  }

  /** PrivateFunction: _handleStreamStart
   * _Private_ function that checks the opening <open /> tag for errors.
   *
   * Disconnects if there is an error and returns false, true otherwise.
   *
   *  Parameters:
   *    (Node) message - Stanza containing the <open /> tag.
   */
  _handleStreamStart(message) {
    let error = false;

    // Check for errors in the <open /> tag
    const ns = message.getAttribute("xmlns");
    if (typeof ns !== "string") {
      error = "Missing xmlns in <open />";
    } else if (ns !== Strophe$2.NS.FRAMING) {
      error = "Wrong xmlns in <open />: " + ns;
    }
    const ver = message.getAttribute("version");
    if (typeof ver !== "string") {
      error = "Missing version in <open />";
    } else if (ver !== "1.0") {
      error = "Wrong version in <open />: " + ver;
    }
    if (error) {
      this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, error);
      this._conn._doDisconnect();
      return false;
    }
    return true;
  }

  /** PrivateFunction: _onInitialMessage
   * _Private_ function that handles the first connection messages.
   *
   * On receiving an opening stream tag this callback replaces itself with the real
   * message handler. On receiving a stream error the connection is terminated.
   */
  _onInitialMessage(message) {
    if (message.data.indexOf("<open ") === 0 || message.data.indexOf("<?xml") === 0) {
      // Strip the XML Declaration, if there is one
      const data = message.data.replace(/^(<\?.*?\?>\s*)*/, "");
      if (data === '') return;
      const streamStart = new DOMParser$2().parseFromString(data, "text/xml").documentElement;
      this._conn.xmlInput(streamStart);
      this._conn.rawInput(message.data);

      //_handleStreamSteart will check for XML errors and disconnect on error
      if (this._handleStreamStart(streamStart)) {
        //_connect_cb will check for stream:error and disconnect on error
        this._connect_cb(streamStart);
      }
    } else if (message.data.indexOf("<close ") === 0) {
      // <close xmlns="urn:ietf:params:xml:ns:xmpp-framing />
      // Parse the raw string to an XML element
      const parsedMessage = new DOMParser$2().parseFromString(message.data, "text/xml").documentElement;
      // Report this input to the raw and xml handlers
      this._conn.xmlInput(parsedMessage);
      this._conn.rawInput(message.data);
      const see_uri = parsedMessage.getAttribute("see-other-uri");
      if (see_uri) {
        const service = this._conn.service;
        // Valid scenarios: WSS->WSS, WS->ANY
        const isSecureRedirect = service.indexOf("wss:") >= 0 && see_uri.indexOf("wss:") >= 0 || service.indexOf("ws:") >= 0;
        if (isSecureRedirect) {
          this._conn._changeConnectStatus(Strophe$2.Status.REDIRECT, "Received see-other-uri, resetting connection");
          this._conn.reset();
          this._conn.service = see_uri;
          this._connect();
        }
      } else {
        this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, "Received closing stream");
        this._conn._doDisconnect();
      }
    } else {
      this._replaceMessageHandler();
      const string = this._streamWrap(message.data);
      const elem = new DOMParser$2().parseFromString(string, "text/xml").documentElement;
      this._conn._connect_cb(elem, null, message.data);
    }
  }

  /** PrivateFunction: _replaceMessageHandler
   *
   * Called by _onInitialMessage in order to replace itself with the general message handler.
   * This method is overridden by Strophe.WorkerWebsocket, which manages a
   * websocket connection via a service worker and doesn't have direct access
   * to the socket.
   */
  _replaceMessageHandler() {
    this.socket.onmessage = m => this._onMessage(m);
  }

  /** PrivateFunction: _disconnect
   *  _Private_ function called by Strophe.Connection.disconnect
   *
   *  Disconnects and sends a last stanza if one is given
   *
   *  Parameters:
   *    (Request) pres - This stanza will be sent before disconnecting.
   */
  _disconnect(pres) {
    if (this.socket && this.socket.readyState !== WebSocket$1.CLOSED) {
      if (pres) {
        this._conn.send(pres);
      }
      const close = $build$1("close", {
        "xmlns": Strophe$2.NS.FRAMING
      });
      this._conn.xmlOutput(close.tree());
      const closeString = Strophe$2.serialize(close);
      this._conn.rawOutput(closeString);
      try {
        this.socket.send(closeString);
      } catch (e) {
        Strophe$2.warn("Couldn't send <close /> tag.");
      }
    }
    setTimeout(() => this._conn._doDisconnect, 0);
  }

  /** PrivateFunction: _doDisconnect
   *  _Private_ function to disconnect.
   *
   *  Just closes the Socket for WebSockets
   */
  _doDisconnect() {
    Strophe$2.debug("WebSockets _doDisconnect was called");
    this._closeSocket();
  }

  /** PrivateFunction _streamWrap
   *  _Private_ helper function to wrap a stanza in a <stream> tag.
   *  This is used so Strophe can process stanzas from WebSockets like BOSH
   */
  _streamWrap(stanza) {
    // eslint-disable-line class-methods-use-this
    return "<wrapper>" + stanza + '</wrapper>';
  }

  /** PrivateFunction: _closeSocket
   *  _Private_ function to close the WebSocket.
   *
   *  Closes the socket if it is still open and deletes it
   */
  _closeSocket() {
    if (this.socket) {
      try {
        this.socket.onclose = null;
        this.socket.onerror = null;
        this.socket.onmessage = null;
        this.socket.close();
      } catch (e) {
        Strophe$2.debug(e.message);
      }
    }
    this.socket = null;
  }

  /** PrivateFunction: _emptyQueue
   * _Private_ function to check if the message queue is empty.
   *
   *  Returns:
   *    True, because WebSocket messages are send immediately after queueing.
   */
  _emptyQueue() {
    // eslint-disable-line class-methods-use-this
    return true;
  }

  /** PrivateFunction: _onClose
   * _Private_ function to handle websockets closing.
   */
  _onClose(e) {
    if (this._conn.connected && !this._conn.disconnecting) {
      Strophe$2.error("Websocket closed unexpectedly");
      this._conn._doDisconnect();
    } else if (e && e.code === 1006 && !this._conn.connected && this.socket) {
      // in case the onError callback was not called (Safari 10 does not
      // call onerror when the initial connection fails) we need to
      // dispatch a CONNFAIL status update to be consistent with the
      // behavior on other browsers.
      Strophe$2.error("Websocket closed unexcectedly");
      this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, "The WebSocket connection could not be established or was disconnected.");
      this._conn._doDisconnect();
    } else {
      Strophe$2.debug("Websocket closed");
    }
  }

  /** PrivateFunction: _no_auth_received
   *
   * Called on stream start/restart when no stream:features
   * has been received.
   */
  _no_auth_received(callback) {
    Strophe$2.error("Server did not offer a supported authentication mechanism");
    this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, Strophe$2.ErrorCondition.NO_AUTH_MECH);
    if (callback) {
      callback.call(this._conn);
    }
    this._conn._doDisconnect();
  }

  /** PrivateFunction: _onDisconnectTimeout
   *  _Private_ timeout handler for handling non-graceful disconnection.
   *
   *  This does nothing for WebSockets
   */
  _onDisconnectTimeout() {} // eslint-disable-line class-methods-use-this

  /** PrivateFunction: _abortAllRequests
   *  _Private_ helper function that makes sure all pending requests are aborted.
   */
  _abortAllRequests() {} // eslint-disable-line class-methods-use-this

  /** PrivateFunction: _onError
   * _Private_ function to handle websockets errors.
   *
   * Parameters:
   * (Object) error - The websocket error.
   */
  _onError(error) {
    Strophe$2.error("Websocket error " + JSON.stringify(error));
    this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, "The WebSocket connection could not be established or was disconnected.");
    this._disconnect();
  }

  /** PrivateFunction: _onIdle
   *  _Private_ function called by Strophe.Connection._onIdle
   *
   *  sends all queued stanzas
   */
  _onIdle() {
    const data = this._conn._data;
    if (data.length > 0 && !this._conn.paused) {
      for (let i = 0; i < data.length; i++) {
        if (data[i] !== null) {
          let stanza;
          if (data[i] === "restart") {
            stanza = this._buildStream().tree();
          } else {
            stanza = data[i];
          }
          const rawStanza = Strophe$2.serialize(stanza);
          this._conn.xmlOutput(stanza);
          this._conn.rawOutput(rawStanza);
          this.socket.send(rawStanza);
        }
      }
      this._conn._data = [];
    }
  }

  /** PrivateFunction: _onMessage
   * _Private_ function to handle websockets messages.
   *
   * This function parses each of the messages as if they are full documents.
   * [TODO : We may actually want to use a SAX Push parser].
   *
   * Since all XMPP traffic starts with
   *  <stream:stream version='1.0'
   *                 xml:lang='en'
   *                 xmlns='jabber:client'
   *                 xmlns:stream='http://etherx.jabber.org/streams'
   *                 id='3697395463'
   *                 from='SERVER'>
   *
   * The first stanza will always fail to be parsed.
   *
   * Additionally, the seconds stanza will always be <stream:features> with
   * the stream NS defined in the previous stanza, so we need to 'force'
   * the inclusion of the NS in this stanza.
   *
   * Parameters:
   * (string) message - The websocket message.
   */
  _onMessage(message) {
    let elem;
    // check for closing stream
    const close = '<close xmlns="urn:ietf:params:xml:ns:xmpp-framing" />';
    if (message.data === close) {
      this._conn.rawInput(close);
      this._conn.xmlInput(message);
      if (!this._conn.disconnecting) {
        this._conn._doDisconnect();
      }
      return;
    } else if (message.data.search("<open ") === 0) {
      // This handles stream restarts
      elem = new DOMParser$2().parseFromString(message.data, "text/xml").documentElement;
      if (!this._handleStreamStart(elem)) {
        return;
      }
    } else {
      const data = this._streamWrap(message.data);
      elem = new DOMParser$2().parseFromString(data, "text/xml").documentElement;
    }
    if (this._checkStreamError(elem, Strophe$2.Status.ERROR)) {
      return;
    }

    //handle unavailable presence stanza before disconnecting
    if (this._conn.disconnecting && elem.firstChild.nodeName === "presence" && elem.firstChild.getAttribute("type") === "unavailable") {
      this._conn.xmlInput(elem);
      this._conn.rawInput(Strophe$2.serialize(elem));
      // if we are already disconnecting we will ignore the unavailable stanza and
      // wait for the </stream:stream> tag before we close the connection
      return;
    }
    this._conn._dataRecv(elem, message.data);
  }

  /** PrivateFunction: _onOpen
   * _Private_ function to handle websockets connection setup.
   *
   * The opening stream tag is sent here.
   */
  _onOpen() {
    Strophe$2.debug("Websocket open");
    const start = this._buildStream();
    this._conn.xmlOutput(start.tree());
    const startString = Strophe$2.serialize(start);
    this._conn.rawOutput(startString);
    this.socket.send(startString);
  }

  /** PrivateFunction: _reqToData
   * _Private_ function to get a stanza out of a request.
   *
   * WebSockets don't use requests, so the passed argument is just returned.
   *
   *  Parameters:
   *    (Object) stanza - The stanza.
   *
   *  Returns:
   *    The stanza that was passed.
   */
  _reqToData(stanza) {
    // eslint-disable-line class-methods-use-this
    return stanza;
  }

  /** PrivateFunction: _send
   *  _Private_ part of the Connection.send function for WebSocket
   *
   * Just flushes the messages that are in the queue
   */
  _send() {
    this._conn.flush();
  }

  /** PrivateFunction: _sendRestart
   *
   *  Send an xmpp:restart stanza.
   */
  _sendRestart() {
    clearTimeout(this._conn._idleTimeout);
    this._conn._onIdle.bind(this._conn)();
  }
};

/*
    This program is distributed under the terms of the MIT license.
    Please see the LICENSE file for details.

    Copyright 2020, JC Brand
*/
const lmap = {};
lmap['debug'] = Strophe$2.LogLevel.DEBUG;
lmap['info'] = Strophe$2.LogLevel.INFO;
lmap['warn'] = Strophe$2.LogLevel.WARN;
lmap['error'] = Strophe$2.LogLevel.ERROR;
lmap['fatal'] = Strophe$2.LogLevel.FATAL;

/** Class: Strophe.WorkerWebsocket
 *  _Private_ helper class that handles a websocket connection inside a shared worker.
 */
Strophe$2.WorkerWebsocket = class WorkerWebsocket extends Strophe$2.Websocket {
  /** PrivateConstructor: Strophe.WorkerWebsocket
   *  Create and initialize a Strophe.WorkerWebsocket object.
   *
   *  Parameters:
   *    (Strophe.Connection) connection - The Strophe.Connection
   *
   *  Returns:
   *    A new Strophe.WorkerWebsocket object.
   */
  constructor(connection) {
    super(connection);
    this._conn = connection;
    this.worker = new SharedWorker(this._conn.options.worker, 'Strophe XMPP Connection');
    this.worker.onerror = e => {
      var _console;
      (_console = console) === null || _console === void 0 ? void 0 : _console.error(e);
      Strophe$2.log(Strophe$2.LogLevel.ERROR, `Shared Worker Error: ${e}`);
    };
  }
  get socket() {
    return {
      'send': str => this.worker.port.postMessage(['send', str])
    };
  }
  _connect() {
    this._messageHandler = m => this._onInitialMessage(m);
    this.worker.port.start();
    this.worker.port.onmessage = ev => this._onWorkerMessage(ev);
    this.worker.port.postMessage(['_connect', this._conn.service, this._conn.jid]);
  }
  _attach(callback) {
    this._messageHandler = m => this._onMessage(m);
    this._conn.connect_callback = callback;
    this.worker.port.start();
    this.worker.port.onmessage = ev => this._onWorkerMessage(ev);
    this.worker.port.postMessage(['_attach', this._conn.service]);
  }
  _attachCallback(status, jid) {
    if (status === Strophe$2.Status.ATTACHED) {
      this._conn.jid = jid;
      this._conn.authenticated = true;
      this._conn.connected = true;
      this._conn.restored = true;
      this._conn._changeConnectStatus(Strophe$2.Status.ATTACHED);
    } else if (status === Strophe$2.Status.ATTACHFAIL) {
      this._conn.authenticated = false;
      this._conn.connected = false;
      this._conn.restored = false;
      this._conn._changeConnectStatus(Strophe$2.Status.ATTACHFAIL);
    }
  }
  _disconnect(readyState, pres) {
    pres && this._conn.send(pres);
    const close = $build$1("close", {
      "xmlns": Strophe$2.NS.FRAMING
    });
    this._conn.xmlOutput(close.tree());
    const closeString = Strophe$2.serialize(close);
    this._conn.rawOutput(closeString);
    this.worker.port.postMessage(['send', closeString]);
    this._conn._doDisconnect();
  }
  _onClose(e) {
    if (this._conn.connected && !this._conn.disconnecting) {
      Strophe$2.error("Websocket closed unexpectedly");
      this._conn._doDisconnect();
    } else if (e && e.code === 1006 && !this._conn.connected) {
      // in case the onError callback was not called (Safari 10 does not
      // call onerror when the initial connection fails) we need to
      // dispatch a CONNFAIL status update to be consistent with the
      // behavior on other browsers.
      Strophe$2.error("Websocket closed unexcectedly");
      this._conn._changeConnectStatus(Strophe$2.Status.CONNFAIL, "The WebSocket connection could not be established or was disconnected.");
      this._conn._doDisconnect();
    } else {
      Strophe$2.debug("Websocket closed");
    }
  }
  _closeSocket() {
    this.worker.port.postMessage(['_closeSocket']);
  }

  /** PrivateFunction: _replaceMessageHandler
   *
   * Called by _onInitialMessage in order to replace itself with the general message handler.
   * This method is overridden by Strophe.WorkerWebsocket, which manages a
   * websocket connection via a service worker and doesn't have direct access
   * to the socket.
   */
  _replaceMessageHandler() {
    this._messageHandler = m => this._onMessage(m);
  }

  /** PrivateFunction: _onWorkerMessage
   * _Private_ function that handles messages received from the service worker
   */
  _onWorkerMessage(ev) {
    const {
      data
    } = ev;
    const method_name = data[0];
    if (method_name === '_onMessage') {
      this._messageHandler(data[1]);
    } else if (method_name in this) {
      try {
        this[method_name].apply(this, ev.data.slice(1));
      } catch (e) {
        Strophe$2.log(Strophe$2.LogLevel.ERROR, e);
      }
    } else if (method_name === 'log') {
      const level = data[1];
      const msg = data[2];
      Strophe$2.log(lmap[level], msg);
    } else {
      Strophe$2.log(Strophe$2.LogLevel.ERROR, `Found unhandled service worker message: ${data}`);
    }
  }
};

global$1.$build = core.$build;
global$1.$iq = core.$iq;
global$1.$msg = core.$msg;
global$1.$pres = core.$pres;
global$1.Strophe = core.Strophe;

var strophe_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  $build: $build$1,
  $iq: $iq$1,
  $msg: $msg$1,
  $pres: $pres$1,
  Strophe: Strophe$2
});

createCommonjsModule(function (module, exports) {
(function (global, factory) {
	factory(strophe_esm) ;
}(commonjsGlobal, (function (strophe_js) {
/**
 * Roster Plugin
 * Allow easily roster management
 *
 *  Features
 *  * Get roster from server
 *  * handle presence
 *  * handle roster iq
 *  * subscribe/unsubscribe
 *  * authorize/unauthorize
 *  * roster versioning (xep 237)
 */
strophe_js.Strophe.addConnectionPlugin('roster',
{
    /** Function: init
     * Plugin init
     *
     * Parameters:
     *   (Strophe.Connection) conn - Strophe connection
     */
    init: function(conn)
    {
        this._connection = conn;
        this._callbacks = [];
        this._callbacks_request = [];

        // Override the connect and attach methods to always add presence and roster handlers.
        // They are removed when the connection disconnects, so must be added on connection.
        var oldCallback, roster = this, _connect = conn.connect, _attach = conn.attach;
        var newCallback = function(status)
        {
            if (status == strophe_js.Strophe.Status.ATTACHED || status == strophe_js.Strophe.Status.CONNECTED)
            {
                try
                {
                    // Presence subscription
                    conn.addHandler(roster._onReceivePresence.bind(roster), null, 'presence', null, null, null);
                    conn.addHandler(roster._onReceiveIQ.bind(roster), strophe_js.Strophe.NS.ROSTER, 'iq', "set", null, null);
                }
                catch (e)
                {
                    strophe_js.Strophe.error(e);
                }
            }
            if (typeof oldCallback === "function") {
                oldCallback.apply(this, arguments);
            }
        };
        conn.connect = function(jid, pass, callback, wait, hold, route, authcid)
        {
            oldCallback = callback;
            if (typeof jid  == "undefined")
                jid  = null;
            if (typeof pass == "undefined")
                pass = null;
            callback = newCallback;
            _connect.apply(conn, [jid, pass, callback, wait, hold, route, authcid]);
        };
        conn.attach = function(jid, sid, rid, callback, wait, hold, wind)
        {
            oldCallback = callback;
            if (typeof jid == "undefined")
                jid = null;
            if (typeof sid == "undefined")
                sid = null;
            if (typeof rid == "undefined")
                rid = null;
            callback = newCallback;
            _attach.apply(conn, [jid, sid, rid, callback, wait, hold, wind]);
        };

        strophe_js.Strophe.addNamespace('ROSTER_VER', 'urn:xmpp:features:rosterver');
        strophe_js.Strophe.addNamespace('NICK', 'http://jabber.org/protocol/nick');
    },
    /** Function: supportVersioning
     * return true if roster versioning is enabled on server
     */
    supportVersioning: function()
    {
        return (this._connection.features && this._connection.features.getElementsByTagName('ver').length > 0);
    },
    /** Function: get
     * Get Roster on server
     *
     * Parameters:
     *   (Function) userCallback - callback on roster result
     *   (String) ver - current rev of roster
     *      (only used if roster versioning is enabled)
     *   (Array) items - initial items of ver
     *      (only used if roster versioning is enabled)
     *     In browser context you can use sessionStorage
     *     to store your roster in json (JSON.stringify())
     */
    get: function(userCallback, ver, items)
    {
        var attrs = {xmlns: strophe_js.Strophe.NS.ROSTER};
        this.items = [];
        if (this.supportVersioning())
        {
            // empty rev because i want an rev attribute in the result
            attrs.ver = ver || '';
            this.items = items || [];
        }
        var iq = strophe_js.$iq({type: 'get',  'id' : this._connection.getUniqueId('roster')}).c('query', attrs);
        return this._connection.sendIQ(iq,
                                this._onReceiveRosterSuccess.bind(this, userCallback),
                                this._onReceiveRosterError.bind(this, userCallback));
    },
    /** Function: registerCallback
     * register callback on roster (presence and iq)
     *
     * Parameters:
     *   (Function) call_back
     */
    registerCallback: function(call_back)
    {
        this._callbacks.push(call_back);
    },

    registerRequestCallback: function (call_back)
    {
        this._callbacks_request.push(call_back);
    },

    /** Function: findItem
     * Find item by JID
     *
     * Parameters:
     *     (String) jid
     */
    findItem : function(jid)
    {
        if(this.items)
	{
          for (var i = 0; i < this.items.length; i++)
          {
              if (this.items[i] && this.items[i].jid == jid)
              {
                  return this.items[i];
              }
          }
	}
        return false;
    },
    /** Function: removeItem
     * Remove item by JID
     *
     * Parameters:
     *     (String) jid
     */
    removeItem : function(jid)
    {
        for (var i = 0; i < this.items.length; i++)
        {
            if (this.items[i] && this.items[i].jid == jid)
            {
                this.items.splice(i, 1);
                return true;
            }
        }
        return false;
    },
    /** Function: subscribe
     * Subscribe presence
     *
     * Parameters:
     *     (String) jid
     *     (String) message (optional)
     *     (String) nick  (optional)
     */
    subscribe: function(jid, message, nick) {
        var pres = strophe_js.$pres({to: jid, type: "subscribe"});
        if (message && message !== "") {
            pres.c("status").t(message).up();
        }
        if (nick && nick !== "") {
            pres.c('nick', {'xmlns': strophe_js.Strophe.NS.NICK}).t(nick).up();
        }
        this._connection.send(pres);
    },
    /** Function: unsubscribe
     * Unsubscribe presence
     *
     * Parameters:
     *     (String) jid
     *     (String) message
     */
    unsubscribe: function(jid, message)
    {
        var pres = strophe_js.$pres({to: jid, type: "unsubscribe"});
        if (message && message !== "")
            pres.c("status").t(message);
        this._connection.send(pres);
    },
    /** Function: authorize
     * Authorize presence subscription
     *
     * Parameters:
     *     (String) jid
     *     (String) message
     */
    authorize: function(jid, message)
    {
        var pres = strophe_js.$pres({to: jid, type: "subscribed"});
        if (message && message !== "")
            pres.c("status").t(message);
        this._connection.send(pres);
    },
    /** Function: unauthorize
     * Unauthorize presence subscription
     *
     * Parameters:
     *     (String) jid
     *     (String) message
     */
    unauthorize: function(jid, message)
    {
        var pres = strophe_js.$pres({to: jid, type: "unsubscribed"});
        if (message && message !== "")
            pres.c("status").t(message);
        this._connection.send(pres);
    },
    /** Function: add
     * Add roster item
     *
     * Parameters:
     *   (String) jid - item jid
     *   (String) name - name
     *   (Array) groups
     *   (Function) call_back
     */
    add: function(jid, name, groups, call_back)
    {
        var iq = strophe_js.$iq({type: 'set'}).c('query', {xmlns: strophe_js.Strophe.NS.ROSTER}).c('item', {jid: jid,
                                                                                      name: name});
        for (var i = 0; i < groups.length; i++)
        {
            iq.c('group').t(groups[i]).up();
        }
        this._connection.sendIQ(iq, call_back, call_back);
    },
    /** Function: update
     * Update roster item
     *
     * Parameters:
     *   (String) jid - item jid
     *   (String) name - name
     *   (Array) groups
     *   (Function) call_back
     */
    update: function(jid, name, groups, call_back)
    {
        var item = this.findItem(jid);
        if (!item)
        {
            throw "item not found";
        }
        var newName = name || item.name;
        var newGroups = groups || item.groups;
        var iq = strophe_js.$iq({type: 'set'}).c('query', {xmlns: strophe_js.Strophe.NS.ROSTER}).c('item', {jid: item.jid,
                                                                                      name: newName});
        for (var i = 0; i < newGroups.length; i++)
        {
            iq.c('group').t(newGroups[i]).up();
        }
        return this._connection.sendIQ(iq, call_back, call_back);
    },
    /** Function: remove
     * Remove roster item
     *
     * Parameters:
     *   (String) jid - item jid
     *   (Function) call_back
     */
    remove: function(jid, call_back)
    {
        var item = this.findItem(jid);
        if (!item)
        {
            throw "item not found";
        }
        var iq = strophe_js.$iq({type: 'set'}).c('query', {xmlns: strophe_js.Strophe.NS.ROSTER}).c('item', {jid: item.jid,
                                                                                      subscription: "remove"});
        this._connection.sendIQ(iq, call_back, call_back);
    },
    /** PrivateFunction: _onReceiveRosterSuccess
     *
     */
    _onReceiveRosterSuccess: function(userCallback, stanza)
    {
        this._updateItems(stanza);
        this._call_backs(this.items);
        if (typeof userCallback === "function") {
            userCallback(this.items);
        }
    },
    /** PrivateFunction: _onReceiveRosterError
     *
     */
    _onReceiveRosterError: function(userCallback, stanza)
    {
        userCallback(this.items);
    },
    /** PrivateFunction: _onReceivePresence
     * Handle presence
     */
    _onReceivePresence : function(presence)
    {
        // TODO: from is optional
        var jid = presence.getAttribute('from');
        var from = strophe_js.Strophe.getBareJidFromJid(jid);
        var item = this.findItem(from);
        var type = presence.getAttribute('type');
        // not in roster
        if (!item)
        {
            // if 'friend request' presence
            if (type === 'subscribe') {
                this._call_backs_request(from);
            }
            return true;
        }
        if (type == 'unavailable')
        {
            delete item.resources[strophe_js.Strophe.getResourceFromJid(jid)];
        }
        else if (!type)
        {
            // TODO: add timestamp
            item.resources[strophe_js.Strophe.getResourceFromJid(jid)] = {
                show     : (presence.getElementsByTagName('show').length !== 0) ? strophe_js.Strophe.getText(presence.getElementsByTagName('show')[0]) : "",
                status   : (presence.getElementsByTagName('status').length !== 0) ? strophe_js.Strophe.getText(presence.getElementsByTagName('status')[0]) : "",
                priority : (presence.getElementsByTagName('priority').length !== 0) ? strophe_js.Strophe.getText(presence.getElementsByTagName('priority')[0]) : ""
            };
        }
        else
        {
            // Stanza is not a presence notification. (It's probably a subscription type stanza.)
            return true;
        }
        this._call_backs(this.items, item);
        return true;
    },
    /** PrivateFunction: _call_backs_request
     * call all the callbacks waiting for 'friend request' presences
     */
    _call_backs_request : function(from)
    {
        for (var i = 0; i < this._callbacks_request.length; i++) // [].forEach my love ...
        {
            this._callbacks_request[i](from);
        }
    },

    /** PrivateFunction: _call_backs
     * first parameter is the full roster
     * second is optional, newly added or updated item
     * third is otional, in case of update, send the previous state of the
     *  update item
     */
    _call_backs : function(items, item, previousItem)
    {
        for (var i = 0; i < this._callbacks.length; i++) // [].forEach my love ...
        {
            this._callbacks[i](items, item, previousItem);
        }
    },
    /** PrivateFunction: _onReceiveIQ
     * Handle roster push.
     */
    _onReceiveIQ : function(iq)
    {
        var id = iq.getAttribute('id');
        var from = iq.getAttribute('from');
        // Receiving client MUST ignore stanza unless it has no from or from = user's JID.
        if (from && from !== "" && from != this._connection.jid && from != strophe_js.Strophe.getBareJidFromJid(this._connection.jid))
            return true;
        var iqresult = strophe_js.$iq({type: 'result', id: id, from: this._connection.jid});
        this._connection.send(iqresult);
        this._updateItems(iq);
        return true;
    },
    /** PrivateFunction: _updateItems
     * Update items from iq
     */
    _updateItems : function(iq)
    {
        var query = iq.getElementsByTagName('query');
        if (query.length !== 0)
        {
            this.ver = query.item(0).getAttribute('ver');
            var self = this;
            strophe_js.Strophe.forEachChild(query.item(0), 'item',
                function (item)
                {
                    self._updateItem(item);
                }
           );
        }
    },
    /** PrivateFunction: _updateItem
     * Update internal representation of roster item
     */
    _updateItem : function(itemTag)
    {
        var jid           = itemTag.getAttribute("jid");
        var name          = itemTag.getAttribute("name");
        var subscription  = itemTag.getAttribute("subscription");
        var ask           = itemTag.getAttribute("ask");
        var groups        = [];

        strophe_js.Strophe.forEachChild(itemTag, 'group',
            function(group)
            {
                groups.push(strophe_js.Strophe.getText(group));
            }
        );

        var item;
        var previousItem;

        if (subscription == "remove")
        {
            var hashBeenRemoved = this.removeItem(jid);
            if (hashBeenRemoved) {
                this._call_backs(
                    this.items,
                    {jid: jid, subscription: 'remove'}
                );
            }
            return;
        }

        item = this.findItem(jid);
        if (!item)
        {
            item = {
                name         : name,
                jid          : jid,
                subscription : subscription,
                ask          : ask,
                groups       : groups,
                resources    : {}
            };
            this.items.push(item);
        }
        else
        {
            previousItem = {
                name: item.name,
                subscription: item.subscription,
                ask: item.ask,
                groups: item.groups
            };
            item.name = name;
            item.subscription = subscription;
            item.ask = ask;
            item.groups = groups;
        }
        this._call_backs(this.items, item, previousItem);
    }
});

})));

});

createCommonjsModule(function (module, exports) {
(function (global, factory) {
	factory(strophe_esm) ;
}(commonjsGlobal, (function (strophe_js) {
strophe_js.Strophe.addConnectionPlugin('disco',
{
    _connection: null,
    _identities : [],
    _features : [],
    _items : [],
    /** Function: init
     * Plugin init
     *
     * Parameters:
     *   (Strophe.Connection) conn - Strophe connection
     */
    init: function(conn)
    {
    this._connection = conn;
        this._identities = [];
        this._features   = [];
        this._items      = [];
        // disco info
        conn.addHandler(this._onDiscoInfo.bind(this), strophe_js.Strophe.NS.DISCO_INFO, 'iq', 'get', null, null);
        // disco items
        conn.addHandler(this._onDiscoItems.bind(this), strophe_js.Strophe.NS.DISCO_ITEMS, 'iq', 'get', null, null);
    },
    /** Function: addIdentity
     * See http://xmpp.org/registrar/disco-categories.html
     * Parameters:
     *   (String) category - category of identity (like client, automation, etc ...)
     *   (String) type - type of identity (like pc, web, bot , etc ...)
     *   (String) name - name of identity in natural language
     *   (String) lang - lang of name parameter
     *
     * Returns:
     *   Boolean
     */
    addIdentity: function(category, type, name, lang)
    {
        for (var i=0; i<this._identities.length; i++)
        {
            if (this._identities[i].category == category &&
                this._identities[i].type == type &&
                this._identities[i].name == name &&
                this._identities[i].lang == lang)
            {
                return false;
            }
        }
        this._identities.push({category: category, type: type, name: name, lang: lang});
        return true;
    },
    /** Function: addFeature
     *
     * Parameters:
     *   (String) var_name - feature name (like jabber:iq:version)
     *
     * Returns:
     *   boolean
     */
    addFeature: function(var_name)
    {
        for (var i=0; i<this._features.length; i++)
        {
             if (this._features[i] == var_name)
                 return false;
        }
        this._features.push(var_name);
        return true;
    },
    /** Function: removeFeature
     *
     * Parameters:
     *   (String) var_name - feature name (like jabber:iq:version)
     *
     * Returns:
     *   boolean
     */
    removeFeature: function(var_name)
    {
        for (var i=0; i<this._features.length; i++)
        {
             if (this._features[i] === var_name){
                 this._features.splice(i,1);
                 return true;
             }
        }
        return false;
    },
    /** Function: addItem
     *
     * Parameters:
     *   (String) jid
     *   (String) name
     *   (String) node
     *   (Function) call_back
     *
     * Returns:
     *   boolean
     */
    addItem: function(jid, name, node, call_back)
    {
        if (node && !call_back)
            return false;
        this._items.push({jid: jid, name: name, node: node, call_back: call_back});
        return true;
    },
    /** Function: info
     * Info query
     *
     * Parameters:
     *   (Function) call_back
     *   (String) jid
     *   (String) node
     */
    info: function(jid, node, success, error, timeout)
    {
        var attrs = {xmlns: strophe_js.Strophe.NS.DISCO_INFO};
        if (node)
            attrs.node = node;

        var info = strophe_js.$iq({from:this._connection.jid,
                         to:jid, type:'get'}).c('query', attrs);
        this._connection.sendIQ(info, success, error, timeout);
    },
    /** Function: items
     * Items query
     *
     * Parameters:
     *   (Function) call_back
     *   (String) jid
     *   (String) node
     */
    items: function(jid, node, success, error, timeout)
    {
        var attrs = {xmlns: strophe_js.Strophe.NS.DISCO_ITEMS};
        if (node)
            attrs.node = node;

        var items = strophe_js.$iq({from:this._connection.jid,
                         to:jid, type:'get'}).c('query', attrs);
        this._connection.sendIQ(items, success, error, timeout);
    },

    /** PrivateFunction: _buildIQResult
     */
    _buildIQResult: function(stanza, query_attrs)
    {
        var id   =  stanza.getAttribute('id');
        var from = stanza.getAttribute('from');
        var iqresult = strophe_js.$iq({type: 'result', id: id});

        if (from !== null) {
            iqresult.attrs({to: from});
        }

        return iqresult.c('query', query_attrs);
    },

    /** PrivateFunction: _onDiscoInfo
     * Called when receive info request
     */
    _onDiscoInfo: function(stanza)
    {
        var node = stanza.getElementsByTagName('query')[0].getAttribute('node');
        var attrs = {xmlns: strophe_js.Strophe.NS.DISCO_INFO};
        var i;
        if (node)
        {
            attrs.node = node;
        }
        var iqresult = this._buildIQResult(stanza, attrs);
        for (i=0; i<this._identities.length; i++)
        {
            attrs = {category: this._identities[i].category,
                         type    : this._identities[i].type};
            if (this._identities[i].name)
                attrs.name = this._identities[i].name;
            if (this._identities[i].lang)
                attrs['xml:lang'] = this._identities[i].lang;
            iqresult.c('identity', attrs).up();
        }
        for (i=0; i<this._features.length; i++)
        {
            iqresult.c('feature', {'var':this._features[i]}).up();
        }
        this._connection.send(iqresult.tree());
        return true;
    },
    /** PrivateFunction: _onDiscoItems
     * Called when receive items request
     */
    _onDiscoItems: function(stanza)
    {
        var query_attrs = {xmlns: strophe_js.Strophe.NS.DISCO_ITEMS};
        var node = stanza.getElementsByTagName('query')[0].getAttribute('node');
        var items, i;
        if (node)
        {
            query_attrs.node = node;
            items = [];
            for (i = 0; i < this._items.length; i++)
            {
                if (this._items[i].node == node)
                {
                    items = this._items[i].call_back(stanza);
                    break;
                }
            }
        }
        else
        {
            items = this._items;
        }
        var iqresult = this._buildIQResult(stanza, query_attrs);
        for (i = 0; i < items.length; i++)
        {
            var attrs = {jid:  items[i].jid};
            if (items[i].name)
                attrs.name = items[i].name;
            if (items[i].node)
                attrs.node = items[i].node;
            iqresult.c('item', attrs).up();
        }
        this._connection.send(iqresult.tree());
        return true;
    }
});

})));

});

createCommonjsModule(function (module, exports) {
(function (global, factory) {
	factory(strophe_esm) ;
}(commonjsGlobal, (function (strophe_js) {
strophe_js.Strophe.addNamespace('RSM', 'http://jabber.org/protocol/rsm');

strophe_js.Strophe.RSM = function(options) {
  this.attribs = ['max', 'first', 'last', 'after', 'before', 'index', 'count'];

  if (typeof options.xml != 'undefined') {
    this.fromXMLElement(options.xml);
  } else {
    for (var ii = 0; ii < this.attribs.length; ii++) {
      var attrib = this.attribs[ii];
      this[attrib] = options[attrib];
    }
  }
};

strophe_js.Strophe.RSM.prototype = {
  toXML: function() {
    var xml = strophe_js.$build('set', {xmlns: strophe_js.Strophe.NS.RSM});
    for (var ii = 0; ii < this.attribs.length; ii++) {
      var attrib = this.attribs[ii];
      if (typeof this[attrib] != 'undefined') {
        xml = xml.c(attrib).t(this[attrib].toString()).up();
      }
    }
    return xml.tree();
  },

  next: function(max) {
    var newSet = new strophe_js.Strophe.RSM({max: max, after: this.last});
    return newSet;
  },

  previous: function(max) {
    var newSet = new strophe_js.Strophe.RSM({max: max, before: this.first});
    return newSet;
  },

  fromXMLElement: function(xmlElement) {
    for (var ii = 0; ii < this.attribs.length; ii++) {
      var attrib = this.attribs[ii];
      var elem = xmlElement.getElementsByTagName(attrib)[0];
      if (typeof elem != 'undefined' && elem !== null) {
        this[attrib] = strophe_js.Strophe.getText(elem);
        if (attrib == 'first') {
          this.index = elem.getAttribute('index');
        }
      }
    }
  }
};

})));

});

createCommonjsModule(function (module, exports) {
(function (global, factory) {
	factory(strophe_esm) ;
}(commonjsGlobal, (function (strophe_js) {
/* XEP-0313: Message Archive Management
 * Copyright (C) 2012 Kim Alvefur
 *
 * This file is MIT/X11 licensed. Please see the
 * LICENSE.txt file in the source package for more information.
 *
 * Modified by: Chris Tunbridge (github.com/Destreyf/)
 * Updated to support v0.3 of the XMPP XEP-0313 standard
 * http://xmpp.org/extensions/xep-0313.html
 *
 */
strophe_js.Strophe.addConnectionPlugin('mam', {
    _c: null,
    _p: [ 'with', 'start', 'end' ],
    init: function (conn) {
        this._c = conn;
        strophe_js.Strophe.addNamespace('MAM', 'urn:xmpp:mam:2');
    },
    query: function (jid, options) {
        var _p = this._p;
        var attr = {
            type:'set',
            to:jid
        };
        options = options || {};
        var mamAttr = {xmlns: strophe_js.Strophe.NS.MAM};
        if (!!options.queryid) {
            mamAttr.queryid = options.queryid;
            delete options.queryid;
        }
        var iq = strophe_js.$iq(attr).c('query', mamAttr).c('x',{xmlns:'jabber:x:data', type:'submit'});

        iq.c('field',{var:'FORM_TYPE', type:'hidden'}).c('value').t(strophe_js.Strophe.NS.MAM).up().up();
        var i;
        for (i = 0; i < this._p.length; i++) {
            var pn = _p[i];
            var p = options[pn];
            delete options[pn];
            if (!!p) {
                iq.c('field',{var:pn}).c('value').t(p).up().up();
            }
        }
        iq.up();

        var onMessage = options.onMessage;
        delete options.onMessage;
        var onComplete = options.onComplete;
        delete options.onComplete;
        iq.cnode(new strophe_js.Strophe.RSM(options).toXML());

        var _c = this._c;
        var handler = _c.addHandler(onMessage, strophe_js.Strophe.NS.MAM, 'message', null);
        return this._c.sendIQ(iq, function(){
           _c.deleteHandler(handler);
           onComplete.apply(this, arguments);
        });
    }
});

})));

});

var strophePluginCarbons = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


const debugConnection = (0, src.default)('huangcha:connection');
(() => {
    src$1.Strophe.addConnectionPlugin("messageCarbons", {
        _connection: null,
        _onCarbon: null,
        init: function (conn) {
            this._connection = conn;
            src$1.Strophe.addNamespace("CARBONS", "urn:xmpp:carbons:2");
            src$1.Strophe.addNamespace("FORWARD", "urn:xmpp:forward:0");
            this._connection.addHandler(this._messageHandler.bind(this), null, "message");
            debugConnection("added carbon copy message handler");
        },
        enable: function (onCarbon) {
            var _a, _b;
            this._onCarbon = onCarbon;
            const id = (_a = this._connection) === null || _a === void 0 ? void 0 : _a.getUniqueId("carbons");
            const iq = (0, src$1.$iq)({ type: "set", id })
                .c("enable", { xmlns: src$1.Strophe.NS.CARBONS });
            (_b = this._connection) === null || _b === void 0 ? void 0 : _b.sendIQ(iq);
        },
        disable: function () {
            var _a, _b;
            const id = (_a = this._connection) === null || _a === void 0 ? void 0 : _a.getUniqueId("carbons");
            const iq = (0, src$1.$iq)({ type: "set", id })
                .c("disable", { xmlns: src$1.Strophe.NS.CARBONS });
            (_b = this._connection) === null || _b === void 0 ? void 0 : _b.sendIQ(iq);
        },
        _messageHandler: function (msg) {
            const sent = msg.getElementsByTagName("sent");
            if (sent.length > 0) {
                const forwarded = sent[0].getElementsByTagName("forwarded");
                if (forwarded.length > 0) {
                    const message = forwarded[0].getElementsByTagName("message");
                    if (message.length > 0) {
                        const item = {
                            direction: "sent",
                            type: message[0].getAttribute("type") || "",
                            to: message[0].getAttribute("to") || "",
                            from: message[0].getAttribute("from") || "",
                            innerMessage: message[0],
                        };
                        this._onCarbon(item);
                    }
                }
            }
            const received = msg.getElementsByTagName("received");
            if (received.length > 0) {
                const forwarded = received[0].getElementsByTagName("forwarded");
                if (forwarded.length > 0) {
                    const message = forwarded[0].getElementsByTagName("message");
                    if (message.length > 0) {
                        const item = {
                            direction: "received",
                            type: message[0].getAttribute("type") || "",
                            to: message[0].getAttribute("to") || "",
                            from: message[0].getAttribute("from") || "",
                            innerMessage: message[0],
                        };
                        this._onCarbon(item);
                    }
                }
            }
            return true;
        },
    });
})();

});

unwrapExports(strophePluginCarbons);

createCommonjsModule(function (module, exports) {
(function (global, factory) {
    factory(strophe_esm) ;
}(commonjsGlobal, (function (strophe_js) {
    /* Plugin to implement the vCard extension.
     *  http://xmpp.org/extensions/xep-0054.html
     *
     *  Author: Nathan Zorn (nathan.zorn@gmail.com)
     *  AMD support by JC Brand
     */

        var buildIq = function(type, jid, vCardEl) {
            var iq = strophe_js.$iq(jid ? {type: type, to: jid} : {type: type});
            iq.c("vCard", {xmlns: strophe_js.Strophe.NS.VCARD});
            if (vCardEl) {
                iq.cnode(vCardEl);
            }
            return iq;
        };

        strophe_js.Strophe.addConnectionPlugin('vcard', {
            _connection: null,
            init: function(conn) {
                this._connection = conn;
                return strophe_js.Strophe.addNamespace('VCARD', 'vcard-temp');
            },

            /* Function
             * Retrieve a vCard for a JID/Entity
             * Parameters:
             * (Function) handler_cb - The callback function used to handle the request.
             * (String) jid - optional - The name of the entity to request the vCard
             *     If no jid is given, this function retrieves the current user's vcard.
             * */
            get: function(handler_cb, jid, error_cb) {
                var iq = buildIq("get", jid);
                return this._connection.sendIQ(iq, handler_cb, error_cb);
            },

            /* Function
             *  Set an entity's vCard.
             */
            set: function(handler_cb, vCardEl, jid, error_cb) {
                var iq = buildIq("set", jid, vCardEl);
                return this._connection.sendIQ(iq, handler_cb, error_cb);
            }
        });

})));

});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function isFunction(value) {
    return typeof value === 'function';
}

function createErrorClass(createImpl) {
    var _super = function (instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

var UnsubscriptionError = createErrorClass(function (_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors
            ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ')
            : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

var Subscription = (function () {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function () {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) {
                    try {
                        for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
                            var parent_1 = _parentage_1_1.value;
                            parent_1.remove(this);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else {
                    _parentage.remove(this);
                }
            }
            var initialFinalizer = this.initialTeardown;
            if (isFunction(initialFinalizer)) {
                try {
                    initialFinalizer();
                }
                catch (e) {
                    errors = e instanceof UnsubscriptionError ? e.errors : [e];
                }
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        }
                        catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof UnsubscriptionError) {
                                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
                            }
                            else {
                                errors.push(err);
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            if (errors) {
                throw new UnsubscriptionError(errors);
            }
        }
    };
    Subscription.prototype.add = function (teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                execFinalizer(teardown);
            }
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function (parent) {
        var _parentage = this._parentage;
        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
    };
    Subscription.prototype._addParent = function (parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
    };
    Subscription.prototype._removeParent = function (parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
            this._parentage = null;
        }
        else if (Array.isArray(_parentage)) {
            arrRemove(_parentage, parent);
        }
    };
    Subscription.prototype.remove = function (teardown) {
        var _finalizers = this._finalizers;
        _finalizers && arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    };
    Subscription.EMPTY = (function () {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    })();
    return Subscription;
}());
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return (value instanceof Subscription ||
        (value && 'closed' in value && isFunction(value.remove) && isFunction(value.add) && isFunction(value.unsubscribe)));
}
function execFinalizer(finalizer) {
    if (isFunction(finalizer)) {
        finalizer();
    }
    else {
        finalizer.unsubscribe();
    }
}

var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false,
};

var timeoutProvider = {
    setTimeout: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var delegate = timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
            return delegate.setTimeout.apply(delegate, __spreadArray([handler, timeout], __read(args)));
        }
        return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearTimeout: function (handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined,
};

function reportUnhandledError(err) {
    timeoutProvider.setTimeout(function () {
        var onUnhandledError = config.onUnhandledError;
        if (onUnhandledError) {
            onUnhandledError(err);
        }
        else {
            throw err;
        }
    });
}

function noop$1() { }

var COMPLETE_NOTIFICATION = (function () { return createNotification('C', undefined, undefined); })();
function errorNotification(error) {
    return createNotification('E', undefined, error);
}
function nextNotification(value) {
    return createNotification('N', value, undefined);
}
function createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error,
    };
}

var context = null;
function errorContext(cb) {
    if (config.useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) {
            context = { errorThrown: false, error: null };
        }
        cb();
        if (isRoot) {
            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
            context = null;
            if (errorThrown) {
                throw error;
            }
        }
    }
    else {
        cb();
    }
}
function captureError(err) {
    if (config.useDeprecatedSynchronousErrorHandling && context) {
        context.errorThrown = true;
        context.error = err;
    }
}

var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if (isSubscription(destination)) {
                destination.add(_this);
            }
        }
        else {
            _this.destination = EMPTY_OBSERVER;
        }
        return _this;
    }
    Subscriber.create = function (next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function (value) {
        if (this.isStopped) {
            handleStoppedNotification(nextNotification(value), this);
        }
        else {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (this.isStopped) {
            handleStoppedNotification(errorNotification(err), this);
        }
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (this.isStopped) {
            handleStoppedNotification(COMPLETE_NOTIFICATION, this);
        }
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        try {
            this.destination.error(err);
        }
        finally {
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function () {
        try {
            this.destination.complete();
        }
        finally {
            this.unsubscribe();
        }
    };
    return Subscriber;
}(Subscription));
var _bind = Function.prototype.bind;
function bind$1(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
var ConsumerObserver = (function () {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function (value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) {
            try {
                partialObserver.next(value);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    ConsumerObserver.prototype.error = function (err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) {
            try {
                partialObserver.error(err);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
        else {
            handleUnhandledError(err);
        }
    };
    ConsumerObserver.prototype.complete = function () {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) {
            try {
                partialObserver.complete();
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    return ConsumerObserver;
}());
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if (isFunction(observerOrNext) || !observerOrNext) {
            partialObserver = {
                next: (observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined),
                error: error !== null && error !== void 0 ? error : undefined,
                complete: complete !== null && complete !== void 0 ? complete : undefined,
            };
        }
        else {
            var context_1;
            if (_this && config.useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function () { return _this.unsubscribe(); };
                partialObserver = {
                    next: observerOrNext.next && bind$1(observerOrNext.next, context_1),
                    error: observerOrNext.error && bind$1(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && bind$1(observerOrNext.complete, context_1),
                };
            }
            else {
                partialObserver = observerOrNext;
            }
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber));
function handleUnhandledError(error) {
    if (config.useDeprecatedSynchronousErrorHandling) {
        captureError(error);
    }
    else {
        reportUnhandledError(error);
    }
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = config.onStoppedNotification;
    onStoppedNotification && timeoutProvider.setTimeout(function () { return onStoppedNotification(notification, subscriber); });
}
var EMPTY_OBSERVER = {
    closed: true,
    next: noop$1,
    error: defaultErrorHandler,
    complete: noop$1,
};

var observable = (function () { return (typeof Symbol === 'function' && Symbol.observable) || '@@observable'; })();

function identity(x) {
    return x;
}

function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}

var Observable = (function () {
    function Observable(subscribe) {
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error, complete);
        errorContext(function () {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator
                ?
                    operator.call(subscriber, source)
                : source
                    ?
                        _this._subscribe(subscriber)
                    :
                        _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscriber = new SafeSubscriber({
                next: function (value) {
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve,
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[observable] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        return pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return (value = x); }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && isFunction(value.next) && isFunction(value.error) && isFunction(value.complete);
}
function isSubscriber(value) {
    return (value && value instanceof Subscriber) || (isObserver(value) && isSubscription(value));
}

function hasLift(source) {
    return isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function (source) {
        if (hasLift(source)) {
            return source.lift(function (liftedSource) {
                try {
                    return init(liftedSource, this);
                }
                catch (err) {
                    this.error(err);
                }
            });
        }
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = (function (_super) {
    __extends(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext
            ? function (value) {
                try {
                    onNext(value);
                }
                catch (err) {
                    destination.error(err);
                }
            }
            : _super.prototype._next;
        _this._error = onError
            ? function (err) {
                try {
                    onError(err);
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._error;
        _this._complete = onComplete
            ? function () {
                try {
                    onComplete();
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function () {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
        }
    };
    return OperatorSubscriber;
}(Subscriber));

function refCount() {
    return operate(function (source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = createOperatorSubscriber(subscriber, undefined, undefined, undefined, function () {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) {
                sharedConnection.unsubscribe();
            }
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) {
            connection = source.connect();
        }
    });
}

var ConnectableObservable = (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if (hasLift(source)) {
            _this.lift = source.lift;
        }
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function () {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 ? void 0 : _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function () {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new Subscription();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe(createOperatorSubscriber(subject_1, undefined, function () {
                _this._teardown();
                subject_1.complete();
            }, function (err) {
                _this._teardown();
                subject_1.error(err);
            }, function () { return _this._teardown(); })));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription.EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return refCount()(this);
    };
    return ConnectableObservable;
}(Observable));

var performanceTimestampProvider = {
    now: function () {
        return (performanceTimestampProvider.delegate || performance).now();
    },
    delegate: undefined,
};

var animationFrameProvider = {
    schedule: function (callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = animationFrameProvider.delegate;
        if (delegate) {
            request = delegate.requestAnimationFrame;
            cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function (timestamp) {
            cancel = undefined;
            callback(timestamp);
        });
        return new Subscription(function () { return cancel === null || cancel === void 0 ? void 0 : cancel(handle); });
    },
    requestAnimationFrame: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
    },
    cancelAnimationFrame: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, __spreadArray([], __read(args)));
    },
    delegate: undefined,
};

function animationFrames(timestampProvider) {
    return timestampProvider ? animationFramesFactory(timestampProvider) : DEFAULT_ANIMATION_FRAMES;
}
function animationFramesFactory(timestampProvider) {
    return new Observable(function (subscriber) {
        var provider = timestampProvider || performanceTimestampProvider;
        var start = provider.now();
        var id = 0;
        var run = function () {
            if (!subscriber.closed) {
                id = animationFrameProvider.requestAnimationFrame(function (timestamp) {
                    id = 0;
                    var now = provider.now();
                    subscriber.next({
                        timestamp: timestampProvider ? now : timestamp,
                        elapsed: now - start,
                    });
                    run();
                });
            }
        };
        run();
        return function () {
            if (id) {
                animationFrameProvider.cancelAnimationFrame(id);
            }
        };
    });
}
var DEFAULT_ANIMATION_FRAMES = animationFramesFactory();

var ObjectUnsubscribedError = createErrorClass(function (_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});

var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
    };
    Subject.prototype.next = function (value) {
        var _this = this;
        errorContext(function () {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) {
                    _this.currentObservers = Array.from(_this.observers);
                }
                try {
                    for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var observer = _c.value;
                        observer.next(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        });
    };
    Subject.prototype.error = function (err) {
        var _this = this;
        errorContext(function () {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while (observers.length) {
                    observers.shift().error(err);
                }
            }
        });
    };
    Subject.prototype.complete = function () {
        var _this = this;
        errorContext(function () {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while (observers.length) {
                    observers.shift().complete();
                }
            }
        });
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function () {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function (subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function (subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) {
            return EMPTY_SUBSCRIPTION;
        }
        this.currentObservers = null;
        observers.push(subscriber);
        return new Subscription(function () {
            _this.currentObservers = null;
            arrRemove(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (isStopped) {
            subscriber.complete();
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable));
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function (err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function () {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : EMPTY_SUBSCRIPTION;
    };
    return AnonymousSubject;
}(Subject));

var BehaviorSubject = (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) {
            throw thrownError;
        }
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, (this._value = value));
    };
    return BehaviorSubject;
}(Subject));

var dateTimestampProvider = {
    now: function () {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined,
};

var ReplaySubject = (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) { _bufferSize = Infinity; }
        if (_windowTime === void 0) { _windowTime = Infinity; }
        if (_timestampProvider === void 0) { _timestampProvider = dateTimestampProvider; }
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function (value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
            subscriber.next(copy[i]);
        }
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function () {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
                last = i;
            }
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}(Subject));

var AsyncSubject = (function (_super) {
    __extends(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = null;
        _this._hasValue = false;
        _this._isComplete = false;
        return _this;
    }
    AsyncSubject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped, _isComplete = _a._isComplete;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (isStopped || _isComplete) {
            _hasValue && subscriber.next(_value);
            subscriber.complete();
        }
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.isStopped) {
            this._value = value;
            this._hasValue = true;
        }
    };
    AsyncSubject.prototype.complete = function () {
        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
        if (!_isComplete) {
            this._isComplete = true;
            _hasValue && _super.prototype.next.call(this, _value);
            _super.prototype.complete.call(this);
        }
    };
    return AsyncSubject;
}(Subject));

var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        return this;
    };
    return Action;
}(Subscription));

var intervalProvider = {
    setInterval: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var delegate = intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) {
            return delegate.setInterval.apply(delegate, __spreadArray([handler, timeout], __read(args)));
        }
        return setInterval.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearInterval: function (handle) {
        var delegate = intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined,
};

var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        var _a;
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
        if (delay === void 0) { delay = 0; }
        return intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay != null && this.delay === delay && this.pending === false) {
            return id;
        }
        if (id != null) {
            intervalProvider.clearInterval(id);
        }
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function () {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            arrRemove(actions, this);
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, null);
            }
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}(Action));

var nextHandle = 1;
var resolved;
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        if (!resolved) {
            resolved = Promise.resolve();
        }
        resolved.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};

var setImmediate = Immediate.setImmediate, clearImmediate = Immediate.clearImmediate;
var immediateProvider = {
    setImmediate: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, __spreadArray([], __read(args)));
    },
    clearImmediate: function (handle) {
        var delegate = immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || clearImmediate)(handle);
    },
    delegate: undefined,
};

var AsapAction = (function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = immediateProvider.setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        var _a;
        if (delay === void 0) { delay = 0; }
        if (delay != null ? delay > 0 : this.delay > 0) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            immediateProvider.clearImmediate(id);
            if (scheduler._scheduled === id) {
                scheduler._scheduled = undefined;
            }
        }
        return undefined;
    };
    return AsapAction;
}(AsyncAction));

var Scheduler = (function () {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = dateTimestampProvider.now;
    return Scheduler;
}());

var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions.shift()));
        this._active = false;
        if (error) {
            while ((action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler));

var AsapScheduler = (function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while ((action = actions[0]) && action.id === flushId && actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler));

var asapScheduler = new AsapScheduler(AsapAction);
var asap = asapScheduler;

var asyncScheduler = new AsyncScheduler(AsyncAction);
var async = asyncScheduler;

var QueueAction = (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.flush(this);
        return 0;
    };
    return QueueAction;
}(AsyncAction));

var QueueScheduler = (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(AsyncScheduler));

var queueScheduler = new QueueScheduler(QueueAction);
var queue = queueScheduler;

var AnimationFrameAction = (function (_super) {
    __extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = animationFrameProvider.requestAnimationFrame(function () { return scheduler.flush(undefined); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        var _a;
        if (delay === void 0) { delay = 0; }
        if (delay != null ? delay > 0 : this.delay > 0) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        var actions = scheduler.actions;
        if (id != null && id === scheduler._scheduled && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            animationFrameProvider.cancelAnimationFrame(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction));

var AnimationFrameScheduler = (function (_super) {
    __extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this._active = true;
        var flushId;
        if (action) {
            flushId = action.id;
        }
        else {
            flushId = this._scheduled;
            this._scheduled = undefined;
        }
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while ((action = actions[0]) && action.id === flushId && actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler));

var animationFrameScheduler = new AnimationFrameScheduler(AnimationFrameAction);
var animationFrame = animationFrameScheduler;

var VirtualTimeScheduler = (function (_super) {
    __extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
        if (schedulerActionCtor === void 0) { schedulerActionCtor = VirtualAction; }
        if (maxFrames === void 0) { maxFrames = Infinity; }
        var _this = _super.call(this, schedulerActionCtor, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error;
        var action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        }
        if (error) {
            while ((action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler));
var VirtualAction = (function (_super) {
    __extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) { index = (scheduler.index += 1); }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (Number.isFinite(delay)) {
            if (!this.id) {
                return _super.prototype.schedule.call(this, state, delay);
            }
            this.active = false;
            var action = new VirtualAction(this.scheduler, this.work);
            this.add(action);
            return action.schedule(state, delay);
        }
        else {
            return Subscription.EMPTY;
        }
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return 1;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction));

var EMPTY = new Observable(function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}

function isScheduler(value) {
    return value && isFunction(value.schedule);
}

function last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return isFunction(last(args)) ? args.pop() : undefined;
}
function popScheduler(args) {
    return isScheduler(last(args)) ? args.pop() : undefined;
}
function popNumber(args, defaultValue) {
    return typeof last(args) === 'number' ? args.pop() : defaultValue;
}

var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

function isPromise$1(value) {
    return isFunction(value === null || value === void 0 ? void 0 : value.then);
}

function isInteropObservable(input) {
    return isFunction(input[observable]);
}

function isAsyncIterable(obj) {
    return Symbol.asyncIterator && isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = getSymbolIterator();

function isIterable(input) {
    return isFunction(input === null || input === void 0 ? void 0 : input[iterator]);
}

function readableStreamLikeToAsyncGenerator(readableStream) {
    return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 9, 10]);
                    _b.label = 2;
                case 2:
                    return [4, __await(reader.read())];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [3, 5];
                    return [4, __await(void 0)];
                case 4: return [2, _b.sent()];
                case 5: return [4, __await(value)];
                case 6: return [4, _b.sent()];
                case 7:
                    _b.sent();
                    return [3, 2];
                case 8: return [3, 10];
                case 9:
                    reader.releaseLock();
                    return [7];
                case 10: return [2];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

function innerFrom(input) {
    if (input instanceof Observable) {
        return input;
    }
    if (input != null) {
        if (isInteropObservable(input)) {
            return fromInteropObservable(input);
        }
        if (isArrayLike(input)) {
            return fromArrayLike(input);
        }
        if (isPromise$1(input)) {
            return fromPromise(input);
        }
        if (isAsyncIterable(input)) {
            return fromAsyncIterable(input);
        }
        if (isIterable(input)) {
            return fromIterable(input);
        }
        if (isReadableStreamLike(input)) {
            return fromReadableStreamLike(input);
        }
    }
    throw createInvalidObservableTypeError(input);
}
function fromInteropObservable(obj) {
    return new Observable(function (subscriber) {
        var obs = obj[observable]();
        if (isFunction(obs.subscribe)) {
            return obs.subscribe(subscriber);
        }
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function fromArrayLike(array) {
    return new Observable(function (subscriber) {
        for (var i = 0; i < array.length && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new Observable(function (subscriber) {
        promise
            .then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, reportUnhandledError);
    });
}
function fromIterable(iterable) {
    return new Observable(function (subscriber) {
        var e_1, _a;
        try {
            for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) {
                    return;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new Observable(function (subscriber) {
        process$2(asyncIterable, subscriber).catch(function (err) { return subscriber.error(err); });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process$2(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return __awaiter(this, void 0, void 0, function () {
        var value, e_2_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 11]);
                    asyncIterable_1 = __asyncValues(asyncIterable);
                    _b.label = 1;
                case 1: return [4, asyncIterable_1.next()];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) {
                        return [2];
                    }
                    _b.label = 3;
                case 3: return [3, 1];
                case 4: return [3, 11];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3, 11];
                case 6:
                    _b.trys.push([6, , 9, 10]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
                    return [4, _a.call(asyncIterable_1)];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [3, 10];
                case 9:
                    if (e_2) throw e_2.error;
                    return [7];
                case 10: return [7];
                case 11:
                    subscriber.complete();
                    return [2];
            }
        });
    });
}

function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) { delay = 0; }
    if (repeat === void 0) { repeat = false; }
    var scheduleSubscription = scheduler.schedule(function () {
        work();
        if (repeat) {
            parentSubscription.add(this.schedule(null, delay));
        }
        else {
            this.unsubscribe();
        }
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) {
        return scheduleSubscription;
    }
}

function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return operate(function (source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return executeSchedule(subscriber, scheduler, function () { return subscriber.next(value); }, delay); }, function () { return executeSchedule(subscriber, scheduler, function () { return subscriber.complete(); }, delay); }, function (err) { return executeSchedule(subscriber, scheduler, function () { return subscriber.error(err); }, delay); }));
    });
}

function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return operate(function (source, subscriber) {
        subscriber.add(scheduler.schedule(function () { return source.subscribe(subscriber); }, delay));
    });
}

function scheduleObservable(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}

function schedulePromise(input, scheduler) {
    return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
}

function scheduleArray(input, scheduler) {
    return new Observable(function (subscriber) {
        var i = 0;
        return scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
            }
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) {
                    this.schedule();
                }
            }
        });
    });
}

function scheduleIterable(input, scheduler) {
    return new Observable(function (subscriber) {
        var iterator$1;
        executeSchedule(subscriber, scheduler, function () {
            iterator$1 = input[iterator]();
            executeSchedule(subscriber, scheduler, function () {
                var _a;
                var value;
                var done;
                try {
                    (_a = iterator$1.next(), value = _a.value, done = _a.done);
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                }
            }, 0, true);
        });
        return function () { return isFunction(iterator$1 === null || iterator$1 === void 0 ? void 0 : iterator$1.return) && iterator$1.return(); };
    });
}

function scheduleAsyncIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new Observable(function (subscriber) {
        executeSchedule(subscriber, scheduler, function () {
            var iterator = input[Symbol.asyncIterator]();
            executeSchedule(subscriber, scheduler, function () {
                iterator.next().then(function (result) {
                    if (result.done) {
                        subscriber.complete();
                    }
                    else {
                        subscriber.next(result.value);
                    }
                });
            }, 0, true);
        });
    });
}

function scheduleReadableStreamLike(input, scheduler) {
    return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input), scheduler);
}

function scheduled(input, scheduler) {
    if (input != null) {
        if (isInteropObservable(input)) {
            return scheduleObservable(input, scheduler);
        }
        if (isArrayLike(input)) {
            return scheduleArray(input, scheduler);
        }
        if (isPromise$1(input)) {
            return schedulePromise(input, scheduler);
        }
        if (isAsyncIterable(input)) {
            return scheduleAsyncIterable(input, scheduler);
        }
        if (isIterable(input)) {
            return scheduleIterable(input, scheduler);
        }
        if (isReadableStreamLike(input)) {
            return scheduleReadableStreamLike(input, scheduler);
        }
    }
    throw createInvalidObservableTypeError(input);
}

function from(input, scheduler) {
    return scheduler ? scheduled(input, scheduler) : innerFrom(input);
}

function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    return from(args, scheduler);
}

function throwError(errorOrErrorFactory, scheduler) {
    var errorFactory = isFunction(errorOrErrorFactory) ? errorOrErrorFactory : function () { return errorOrErrorFactory; };
    var init = function (subscriber) { return subscriber.error(errorFactory()); };
    return new Observable(scheduler ? function (subscriber) { return scheduler.schedule(init, 0, subscriber); } : init);
}

var NotificationKind;
(function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        return observeNotification(this, observer);
    };
    Notification.prototype.do = function (nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        var _a;
        return isFunction((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next)
            ? this.observe(nextOrObserver)
            : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function () {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === 'N'
            ?
                of(value)
            :
                kind === 'E'
                    ?
                        throwError(function () { return error; })
                    :
                        kind === 'C'
                            ?
                                EMPTY
                            :
                                0;
        if (!result) {
            throw new TypeError("Unexpected notification kind " + kind);
        }
        return result;
    };
    Notification.createNext = function (value) {
        return new Notification('N', value);
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    return Notification;
}());
function observeNotification(notification, observer) {
    var _a, _b, _c;
    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
    if (typeof kind !== 'string') {
        throw new TypeError('Invalid notification, missing "kind"');
    }
    kind === 'N' ? (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
}

function isObservable(obj) {
    return !!obj && (obj instanceof Observable || (isFunction(obj.lift) && isFunction(obj.subscribe)));
}

var EmptyError = createErrorClass(function (_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});

function lastValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function (resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function (value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function () {
                if (_hasValue) {
                    resolve(_value);
                }
                else if (hasConfig) {
                    resolve(config.defaultValue);
                }
                else {
                    reject(new EmptyError());
                }
            },
        });
    });
}

function firstValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function (resolve, reject) {
        var subscriber = new SafeSubscriber({
            next: function (value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function () {
                if (hasConfig) {
                    resolve(config.defaultValue);
                }
                else {
                    reject(new EmptyError());
                }
            },
        });
        source.subscribe(subscriber);
    });
}

var ArgumentOutOfRangeError = createErrorClass(function (_super) {
    return function ArgumentOutOfRangeErrorImpl() {
        _super(this);
        this.name = 'ArgumentOutOfRangeError';
        this.message = 'argument out of range';
    };
});

var NotFoundError = createErrorClass(function (_super) {
    return function NotFoundErrorImpl(message) {
        _super(this);
        this.name = 'NotFoundError';
        this.message = message;
    };
});

var SequenceError = createErrorClass(function (_super) {
    return function SequenceErrorImpl(message) {
        _super(this);
        this.name = 'SequenceError';
        this.message = message;
    };
});

function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}

var TimeoutError = createErrorClass(function (_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) { info = null; }
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function timeout(config, schedulerArg) {
    var _a = (isValidDate(config) ? { first: config } : typeof config === 'number' ? { each: config } : config), first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : asyncScheduler : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) {
        throw new TypeError('No timeout provided.');
    }
    return operate(function (source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function (delay) {
            timerSubscription = executeSchedule(subscriber, scheduler, function () {
                try {
                    originalSourceSubscription.unsubscribe();
                    innerFrom(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen,
                    })).subscribe(subscriber);
                }
                catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
            seen++;
            subscriber.next((lastValue = value));
            each > 0 && startTimer(each);
        }, undefined, undefined, function () {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) {
                timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
            }
            lastValue = null;
        }));
        !seen && startTimer(first != null ? (typeof first === 'number' ? first : +first - scheduler.now()) : each);
    });
}
function timeoutErrorFactory(info) {
    throw new TimeoutError(info);
}

function map(project, thisArg) {
    return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

var isArray$1 = Array.isArray;
function callOrApply(fn, args) {
    return isArray$1(args) ? fn.apply(void 0, __spreadArray([], __read(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return map(function (args) { return callOrApply(fn, args); });
}

function bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallbackInternals(isNodeStyle, callbackFunc, scheduler)
                    .apply(this, args)
                    .pipe(mapOneOrManyArgs(resultSelector));
            };
        }
    }
    if (scheduler) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return bindCallbackInternals(isNodeStyle, callbackFunc)
                .apply(this, args)
                .pipe(subscribeOn(scheduler), observeOn(scheduler));
        };
    }
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var subject = new AsyncSubject();
        var uninitialized = true;
        return new Observable(function (subscriber) {
            var subs = subject.subscribe(subscriber);
            if (uninitialized) {
                uninitialized = false;
                var isAsync_1 = false;
                var isComplete_1 = false;
                callbackFunc.apply(_this, __spreadArray(__spreadArray([], __read(args)), [
                    function () {
                        var results = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            results[_i] = arguments[_i];
                        }
                        if (isNodeStyle) {
                            var err = results.shift();
                            if (err != null) {
                                subject.error(err);
                                return;
                            }
                        }
                        subject.next(1 < results.length ? results : results[0]);
                        isComplete_1 = true;
                        if (isAsync_1) {
                            subject.complete();
                        }
                    },
                ]));
                if (isComplete_1) {
                    subject.complete();
                }
                isAsync_1 = true;
            }
            return subs;
        });
    };
}

function bindCallback(callbackFunc, resultSelector, scheduler) {
    return bindCallbackInternals(false, callbackFunc, resultSelector, scheduler);
}

function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    return bindCallbackInternals(true, callbackFunc, resultSelector, scheduler);
}

var isArray$2 = Array.isArray;
var getPrototypeOf = Object.getPrototypeOf, objectProto = Object.prototype, getKeys = Object.keys;
function argsArgArrayOrObject(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if (isArray$2(first_1)) {
            return { args: first_1, keys: null };
        }
        if (isPOJO(first_1)) {
            var keys = getKeys(first_1);
            return {
                args: keys.map(function (key) { return first_1[key]; }),
                keys: keys,
            };
        }
    }
    return { args: args, keys: null };
}
function isPOJO(obj) {
    return obj && typeof obj === 'object' && getPrototypeOf(obj) === objectProto;
}

function createObject(keys, values) {
    return keys.reduce(function (result, key, i) { return ((result[key] = values[i]), result); }, {});
}

function combineLatest() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    var resultSelector = popResultSelector(args);
    var _a = argsArgArrayOrObject(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) {
        return from([], scheduler);
    }
    var result = new Observable(combineLatestInit(observables, scheduler, keys
        ?
            function (values) { return createObject(keys, values); }
        :
            identity));
    return resultSelector ? result.pipe(mapOneOrManyArgs(resultSelector)) : result;
}
function combineLatestInit(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) { valueTransform = identity; }
    return function (subscriber) {
        maybeSchedule(scheduler, function () {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function (i) {
                maybeSchedule(scheduler, function () {
                    var source = from(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) {
                            subscriber.next(valueTransform(values.slice()));
                        }
                    }, function () {
                        if (!--active) {
                            subscriber.complete();
                        }
                    }));
                }, subscriber);
            };
            for (var i = 0; i < length; i++) {
                _loop_1(i);
            }
        }, subscriber);
    };
}
function maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) {
        executeSchedule(subscription, scheduler, execute);
    }
    else {
        execute();
    }
}

function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function () {
        if (isComplete && !buffer.length && !active) {
            subscriber.complete();
        }
    };
    var outerNext = function (value) { return (active < concurrent ? doInnerSub(value) : buffer.push(value)); };
    var doInnerSub = function (value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        innerFrom(project(value, index++)).subscribe(createOperatorSubscriber(subscriber, function (innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
            if (expand) {
                outerNext(innerValue);
            }
            else {
                subscriber.next(innerValue);
            }
        }, function () {
            innerComplete = true;
        }, undefined, function () {
            if (innerComplete) {
                try {
                    active--;
                    var _loop_1 = function () {
                        var bufferedValue = buffer.shift();
                        if (innerSubScheduler) {
                            executeSchedule(subscriber, innerSubScheduler, function () { return doInnerSub(bufferedValue); });
                        }
                        else {
                            doInnerSub(bufferedValue);
                        }
                    };
                    while (buffer.length && active < concurrent) {
                        _loop_1();
                    }
                    checkComplete();
                }
                catch (err) {
                    subscriber.error(err);
                }
            }
        }));
    };
    source.subscribe(createOperatorSubscriber(subscriber, outerNext, function () {
        isComplete = true;
        checkComplete();
    }));
    return function () {
        additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
    };
}

function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    if (isFunction(resultSelector)) {
        return mergeMap(function (a, i) { return map(function (b, ii) { return resultSelector(a, b, i, ii); })(innerFrom(project(a, i))); }, concurrent);
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return operate(function (source, subscriber) { return mergeInternals(source, subscriber, project, concurrent); });
}

function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    return mergeMap(identity, concurrent);
}

function concatAll() {
    return mergeAll(1);
}

function concat$2() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return concatAll()(from(args, popScheduler(args)));
}

function defer(observableFactory) {
    return new Observable(function (subscriber) {
        innerFrom(observableFactory()).subscribe(subscriber);
    });
}

var DEFAULT_CONFIG = {
    connector: function () { return new Subject(); },
    resetOnDisconnect: true,
};
function connectable(source, config) {
    if (config === void 0) { config = DEFAULT_CONFIG; }
    var connection = null;
    var connector = config.connector, _a = config.resetOnDisconnect, resetOnDisconnect = _a === void 0 ? true : _a;
    var subject = connector();
    var result = new Observable(function (subscriber) {
        return subject.subscribe(subscriber);
    });
    result.connect = function () {
        if (!connection || connection.closed) {
            connection = defer(function () { return source; }).subscribe(subject);
            if (resetOnDisconnect) {
                connection.add(function () { return (subject = connector()); });
            }
        }
        return connection;
    };
    return result;
}

function forkJoin() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resultSelector = popResultSelector(args);
    var _a = argsArgArrayOrObject(args), sources = _a.args, keys = _a.keys;
    var result = new Observable(function (subscriber) {
        var length = sources.length;
        if (!length) {
            subscriber.complete();
            return;
        }
        var values = new Array(length);
        var remainingCompletions = length;
        var remainingEmissions = length;
        var _loop_1 = function (sourceIndex) {
            var hasValue = false;
            innerFrom(sources[sourceIndex]).subscribe(createOperatorSubscriber(subscriber, function (value) {
                if (!hasValue) {
                    hasValue = true;
                    remainingEmissions--;
                }
                values[sourceIndex] = value;
            }, function () { return remainingCompletions--; }, undefined, function () {
                if (!remainingCompletions || !hasValue) {
                    if (!remainingEmissions) {
                        subscriber.next(keys ? createObject(keys, values) : values);
                    }
                    subscriber.complete();
                }
            }));
        };
        for (var sourceIndex = 0; sourceIndex < length; sourceIndex++) {
            _loop_1(sourceIndex);
        }
    });
    return resultSelector ? result.pipe(mapOneOrManyArgs(resultSelector)) : result;
}

var nodeEventEmitterMethods = ['addListener', 'removeListener'];
var eventTargetMethods = ['addEventListener', 'removeEventListener'];
var jqueryMethods = ['on', 'off'];
function fromEvent(target, eventName, options, resultSelector) {
    if (isFunction(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(mapOneOrManyArgs(resultSelector));
    }
    var _a = __read(isEventTarget(target)
        ? eventTargetMethods.map(function (methodName) { return function (handler) { return target[methodName](eventName, handler, options); }; })
        :
            isNodeStyleEventEmitter(target)
                ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName))
                : isJQueryStyleEventEmitter(target)
                    ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName))
                    : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if (isArrayLike(target)) {
            return mergeMap(function (subTarget) { return fromEvent(subTarget, eventName, options); })(innerFrom(target));
        }
    }
    if (!add) {
        throw new TypeError('Invalid event target');
    }
    return new Observable(function (subscriber) {
        var handler = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function () { return remove(handler); };
    });
}
function toCommonHandlerRegistry(target, eventName) {
    return function (methodName) { return function (handler) { return target[methodName](eventName, handler); }; };
}
function isNodeStyleEventEmitter(target) {
    return isFunction(target.addListener) && isFunction(target.removeListener);
}
function isJQueryStyleEventEmitter(target) {
    return isFunction(target.on) && isFunction(target.off);
}
function isEventTarget(target) {
    return isFunction(target.addEventListener) && isFunction(target.removeEventListener);
}

function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(mapOneOrManyArgs(resultSelector));
    }
    return new Observable(function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return isFunction(removeHandler) ? function () { return removeHandler(handler, retValue); } : undefined;
    });
}

function generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
    var _a, _b;
    var resultSelector;
    var initialState;
    if (arguments.length === 1) {
        (_a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? identity : _b, scheduler = _a.scheduler);
    }
    else {
        initialState = initialStateOrOptions;
        if (!resultSelectorOrScheduler || isScheduler(resultSelectorOrScheduler)) {
            resultSelector = identity;
            scheduler = resultSelectorOrScheduler;
        }
        else {
            resultSelector = resultSelectorOrScheduler;
        }
    }
    function gen() {
        var state;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = initialState;
                    _a.label = 1;
                case 1:
                    if (!(!condition || condition(state))) return [3, 4];
                    return [4, resultSelector(state)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    state = iterate(state);
                    return [3, 1];
                case 4: return [2];
            }
        });
    }
    return defer((scheduler
        ?
            function () { return scheduleIterable(gen(), scheduler); }
        :
            gen));
}

function iif(condition, trueResult, falseResult) {
    return defer(function () { return (condition() ? trueResult : falseResult); });
}

function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) { dueTime = 0; }
    if (scheduler === void 0) { scheduler = async; }
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if (isScheduler(intervalOrScheduler)) {
            scheduler = intervalOrScheduler;
        }
        else {
            intervalDuration = intervalOrScheduler;
        }
    }
    return new Observable(function (subscriber) {
        var due = isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) {
            due = 0;
        }
        var n = 0;
        return scheduler.schedule(function () {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) {
                    this.schedule(undefined, intervalDuration);
                }
                else {
                    subscriber.complete();
                }
            }
        }, due);
    });
}

function interval(period, scheduler) {
    if (period === void 0) { period = 0; }
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    if (period < 0) {
        period = 0;
    }
    return timer(period, period, scheduler);
}

function merge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    var concurrent = popNumber(args, Infinity);
    var sources = args;
    return !sources.length
        ?
            EMPTY
        : sources.length === 1
            ?
                innerFrom(sources[0])
            :
                mergeAll(concurrent)(from(sources, scheduler));
}

var NEVER = new Observable(noop$1);
function never() {
    return NEVER;
}

var isArray$3 = Array.isArray;
function argsOrArgArray(args) {
    return args.length === 1 && isArray$3(args[0]) ? args[0] : args;
}

function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var nextSources = argsOrArgArray(sources);
    return new Observable(function (subscriber) {
        var sourceIndex = 0;
        var subscribeNext = function () {
            if (sourceIndex < nextSources.length) {
                var nextSource = void 0;
                try {
                    nextSource = innerFrom(nextSources[sourceIndex++]);
                }
                catch (err) {
                    subscribeNext();
                    return;
                }
                var innerSubscriber = new OperatorSubscriber(subscriber, undefined, noop$1, noop$1);
                nextSource.subscribe(innerSubscriber);
                innerSubscriber.add(subscribeNext);
            }
            else {
                subscriber.complete();
            }
        };
        subscribeNext();
    });
}

function pairs(obj, scheduler) {
    return from(Object.entries(obj), scheduler);
}

function not(pred, thisArg) {
    return function (value, index) { return !pred.call(thisArg, value, index); };
}

function filter(predicate, thisArg) {
    return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return predicate.call(thisArg, value, index++) && subscriber.next(value); }));
    });
}

function partition(source, predicate, thisArg) {
    return [filter(predicate, thisArg)(innerFrom(source)), filter(not(predicate, thisArg))(innerFrom(source))];
}

function race() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    sources = argsOrArgArray(sources);
    return sources.length === 1 ? innerFrom(sources[0]) : new Observable(raceInit(sources));
}
function raceInit(sources) {
    return function (subscriber) {
        var subscriptions = [];
        var _loop_1 = function (i) {
            subscriptions.push(innerFrom(sources[i]).subscribe(createOperatorSubscriber(subscriber, function (value) {
                if (subscriptions) {
                    for (var s = 0; s < subscriptions.length; s++) {
                        s !== i && subscriptions[s].unsubscribe();
                    }
                    subscriptions = null;
                }
                subscriber.next(value);
            })));
        };
        for (var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++) {
            _loop_1(i);
        }
    };
}

function range(start, count, scheduler) {
    if (count == null) {
        count = start;
        start = 0;
    }
    if (count <= 0) {
        return EMPTY;
    }
    var end = count + start;
    return new Observable(scheduler
        ?
            function (subscriber) {
                var n = start;
                return scheduler.schedule(function () {
                    if (n < end) {
                        subscriber.next(n++);
                        this.schedule();
                    }
                    else {
                        subscriber.complete();
                    }
                });
            }
        :
            function (subscriber) {
                var n = start;
                while (n < end && !subscriber.closed) {
                    subscriber.next(n++);
                }
                subscriber.complete();
            });
}

function using(resourceFactory, observableFactory) {
    return new Observable(function (subscriber) {
        var resource = resourceFactory();
        var result = observableFactory(resource);
        var source = result ? innerFrom(result) : EMPTY;
        source.subscribe(subscriber);
        return function () {
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}

function zip() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resultSelector = popResultSelector(args);
    var sources = argsOrArgArray(args);
    return sources.length
        ? new Observable(function (subscriber) {
            var buffers = sources.map(function () { return []; });
            var completed = sources.map(function () { return false; });
            subscriber.add(function () {
                buffers = completed = null;
            });
            var _loop_1 = function (sourceIndex) {
                innerFrom(sources[sourceIndex]).subscribe(createOperatorSubscriber(subscriber, function (value) {
                    buffers[sourceIndex].push(value);
                    if (buffers.every(function (buffer) { return buffer.length; })) {
                        var result = buffers.map(function (buffer) { return buffer.shift(); });
                        subscriber.next(resultSelector ? resultSelector.apply(void 0, __spreadArray([], __read(result))) : result);
                        if (buffers.some(function (buffer, i) { return !buffer.length && completed[i]; })) {
                            subscriber.complete();
                        }
                    }
                }, function () {
                    completed[sourceIndex] = true;
                    !buffers[sourceIndex].length && subscriber.complete();
                }));
            };
            for (var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++) {
                _loop_1(sourceIndex);
            }
            return function () {
                buffers = completed = null;
            };
        })
        : EMPTY;
}

function audit(durationSelector) {
    return operate(function (source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var isComplete = false;
        var endDuration = function () {
            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
            isComplete && subscriber.complete();
        };
        var cleanupDuration = function () {
            durationSubscriber = null;
            isComplete && subscriber.complete();
        };
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            lastValue = value;
            if (!durationSubscriber) {
                innerFrom(durationSelector(value)).subscribe((durationSubscriber = createOperatorSubscriber(subscriber, endDuration, cleanupDuration)));
            }
        }, function () {
            isComplete = true;
            (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
        }));
    });
}

function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    return audit(function () { return timer(duration, scheduler); });
}

function buffer(closingNotifier) {
    return operate(function (source, subscriber) {
        var currentBuffer = [];
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return currentBuffer.push(value); }, function () {
            subscriber.next(currentBuffer);
            subscriber.complete();
        }));
        innerFrom(closingNotifier).subscribe(createOperatorSubscriber(subscriber, function () {
            var b = currentBuffer;
            currentBuffer = [];
            subscriber.next(b);
        }, noop$1));
        return function () {
            currentBuffer = null;
        };
    });
}

function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
    return operate(function (source, subscriber) {
        var buffers = [];
        var count = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a, e_2, _b;
            var toEmit = null;
            if (count++ % startBufferEvery === 0) {
                buffers.push([]);
            }
            try {
                for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                    if (bufferSize <= buffer.length) {
                        toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
                        toEmit.push(buffer);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (toEmit) {
                try {
                    for (var toEmit_1 = __values(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()) {
                        var buffer = toEmit_1_1.value;
                        arrRemove(buffers, buffer);
                        subscriber.next(buffer);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }, function () {
            var e_3, _a;
            try {
                for (var buffers_2 = __values(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()) {
                    var buffer = buffers_2_1.value;
                    subscriber.next(buffer);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
            subscriber.complete();
        }, undefined, function () {
            buffers = null;
        }));
    });
}

function bufferTime(bufferTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherArgs[_i - 1] = arguments[_i];
    }
    var scheduler = (_a = popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : asyncScheduler;
    var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxBufferSize = otherArgs[1] || Infinity;
    return operate(function (source, subscriber) {
        var bufferRecords = [];
        var restartOnEmit = false;
        var emit = function (record) {
            var buffer = record.buffer, subs = record.subs;
            subs.unsubscribe();
            arrRemove(bufferRecords, record);
            subscriber.next(buffer);
            restartOnEmit && startBuffer();
        };
        var startBuffer = function () {
            if (bufferRecords) {
                var subs = new Subscription();
                subscriber.add(subs);
                var buffer = [];
                var record_1 = {
                    buffer: buffer,
                    subs: subs,
                };
                bufferRecords.push(record_1);
                executeSchedule(subs, scheduler, function () { return emit(record_1); }, bufferTimeSpan);
            }
        };
        if (bufferCreationInterval !== null && bufferCreationInterval >= 0) {
            executeSchedule(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
        }
        else {
            restartOnEmit = true;
        }
        startBuffer();
        var bufferTimeSubscriber = createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a;
            var recordsCopy = bufferRecords.slice();
            try {
                for (var recordsCopy_1 = __values(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()) {
                    var record = recordsCopy_1_1.value;
                    var buffer = record.buffer;
                    buffer.push(value);
                    maxBufferSize <= buffer.length && emit(record);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a = recordsCopy_1.return)) _a.call(recordsCopy_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }, function () {
            while (bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length) {
                subscriber.next(bufferRecords.shift().buffer);
            }
            bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 ? void 0 : bufferTimeSubscriber.unsubscribe();
            subscriber.complete();
            subscriber.unsubscribe();
        }, undefined, function () { return (bufferRecords = null); });
        source.subscribe(bufferTimeSubscriber);
    });
}

function bufferToggle(openings, closingSelector) {
    return operate(function (source, subscriber) {
        var buffers = [];
        innerFrom(openings).subscribe(createOperatorSubscriber(subscriber, function (openValue) {
            var buffer = [];
            buffers.push(buffer);
            var closingSubscription = new Subscription();
            var emitBuffer = function () {
                arrRemove(buffers, buffer);
                subscriber.next(buffer);
                closingSubscription.unsubscribe();
            };
            closingSubscription.add(innerFrom(closingSelector(openValue)).subscribe(createOperatorSubscriber(subscriber, emitBuffer, noop$1)));
        }, noop$1));
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a;
            try {
                for (var buffers_1 = __values(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()) {
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }, function () {
            while (buffers.length > 0) {
                subscriber.next(buffers.shift());
            }
            subscriber.complete();
        }));
    });
}

function bufferWhen(closingSelector) {
    return operate(function (source, subscriber) {
        var buffer = null;
        var closingSubscriber = null;
        var openBuffer = function () {
            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
            var b = buffer;
            buffer = [];
            b && subscriber.next(b);
            innerFrom(closingSelector()).subscribe((closingSubscriber = createOperatorSubscriber(subscriber, openBuffer, noop$1)));
        };
        openBuffer();
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return buffer === null || buffer === void 0 ? void 0 : buffer.push(value); }, function () {
            buffer && subscriber.next(buffer);
            subscriber.complete();
        }, undefined, function () { return (buffer = closingSubscriber = null); }));
    });
}

function catchError(selector) {
    return operate(function (source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
            handledResult = innerFrom(selector(err, catchError(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            }
            else {
                syncUnsub = true;
            }
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function (source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var i = index++;
            state = hasState
                ?
                    accumulator(state, value, i)
                :
                    ((hasState = true), value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete &&
            (function () {
                hasState && subscriber.next(state);
                subscriber.complete();
            })));
    };
}

function reduce(accumulator, seed) {
    return operate(scanInternals(accumulator, seed, arguments.length >= 2, false, true));
}

var arrReducer = function (arr, value) { return (arr.push(value), arr); };
function toArray() {
    return operate(function (source, subscriber) {
        reduce(arrReducer, [])(source).subscribe(subscriber);
    });
}

function joinAllInternals(joinFn, project) {
    return pipe(toArray(), mergeMap(function (sources) { return joinFn(sources); }), project ? mapOneOrManyArgs(project) : identity);
}

function combineLatestAll(project) {
    return joinAllInternals(combineLatest, project);
}

var combineAll = combineLatestAll;

function combineLatest$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resultSelector = popResultSelector(args);
    return resultSelector
        ? pipe(combineLatest$1.apply(void 0, __spreadArray([], __read(args))), mapOneOrManyArgs(resultSelector))
        : operate(function (source, subscriber) {
            combineLatestInit(__spreadArray([source], __read(argsOrArgArray(args))))(subscriber);
        });
}

function combineLatestWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return combineLatest$1.apply(void 0, __spreadArray([], __read(otherSources)));
}

function concatMap(project, resultSelector) {
    return isFunction(resultSelector) ? mergeMap(project, resultSelector, 1) : mergeMap(project, 1);
}

function concatMapTo(innerObservable, resultSelector) {
    return isFunction(resultSelector) ? concatMap(function () { return innerObservable; }, resultSelector) : concatMap(function () { return innerObservable; });
}

function concat$3() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    return operate(function (source, subscriber) {
        concatAll()(from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
    });
}

function concatWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return concat$3.apply(void 0, __spreadArray([], __read(otherSources)));
}

function fromSubscribable(subscribable) {
    return new Observable(function (subscriber) { return subscribable.subscribe(subscriber); });
}

var DEFAULT_CONFIG$1 = {
    connector: function () { return new Subject(); },
};
function connect(selector, config) {
    if (config === void 0) { config = DEFAULT_CONFIG$1; }
    var connector = config.connector;
    return operate(function (source, subscriber) {
        var subject = connector();
        innerFrom(selector(fromSubscribable(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
    });
}

function count(predicate) {
    return reduce(function (total, value, i) { return (!predicate || predicate(value, i) ? total + 1 : total); }, 0);
}

function debounce(durationSelector) {
    return operate(function (source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var emit = function () {
            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            durationSubscriber === null || durationSubscriber === void 0 ? void 0 : durationSubscriber.unsubscribe();
            hasValue = true;
            lastValue = value;
            durationSubscriber = createOperatorSubscriber(subscriber, emit, noop$1);
            innerFrom(durationSelector(value)).subscribe(durationSubscriber);
        }, function () {
            emit();
            subscriber.complete();
        }, undefined, function () {
            lastValue = durationSubscriber = null;
        }));
    });
}

function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    return operate(function (source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function () {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function () {
            emit();
            subscriber.complete();
        }, undefined, function () {
            lastValue = activeTask = null;
        }));
    });
}

function defaultIfEmpty(defaultValue) {
    return operate(function (source, subscriber) {
        var hasValue = false;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            subscriber.next(value);
        }, function () {
            if (!hasValue) {
                subscriber.next(defaultValue);
            }
            subscriber.complete();
        }));
    });
}

function take(count) {
    return count <= 0
        ?
            function () { return EMPTY; }
        : operate(function (source, subscriber) {
            var seen = 0;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                if (++seen <= count) {
                    subscriber.next(value);
                    if (count <= seen) {
                        subscriber.complete();
                    }
                }
            }));
        });
}

function ignoreElements() {
    return operate(function (source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, noop$1));
    });
}

function mapTo(value) {
    return map(function () { return value; });
}

function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function (source) {
            return concat$2(subscriptionDelay.pipe(take(1), ignoreElements()), source.pipe(delayWhen(delayDurationSelector)));
        };
    }
    return mergeMap(function (value, index) { return innerFrom(delayDurationSelector(value, index)).pipe(take(1), mapTo(value)); });
}

function delay(due, scheduler) {
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    var duration = timer(due, scheduler);
    return delayWhen(function () { return duration; });
}

function dematerialize() {
    return operate(function (source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, function (notification) { return observeNotification(notification, subscriber); }));
    });
}

function distinct(keySelector, flushes) {
    return operate(function (source, subscriber) {
        var distinctKeys = new Set();
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var key = keySelector ? keySelector(value) : value;
            if (!distinctKeys.has(key)) {
                distinctKeys.add(key);
                subscriber.next(value);
            }
        }));
        flushes && innerFrom(flushes).subscribe(createOperatorSubscriber(subscriber, function () { return distinctKeys.clear(); }, noop$1));
    });
}

function distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) { keySelector = identity; }
    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
    return operate(function (source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function defaultCompare(a, b) {
    return a === b;
}

function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged(function (x, y) { return (compare ? compare(x[key], y[key]) : x[key] === y[key]); });
}

function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) { errorFactory = defaultErrorFactory; }
    return operate(function (source, subscriber) {
        var hasValue = false;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            subscriber.next(value);
        }, function () { return (hasValue ? subscriber.complete() : subscriber.error(errorFactory())); }));
    });
}
function defaultErrorFactory() {
    return new EmptyError();
}

function elementAt(index, defaultValue) {
    if (index < 0) {
        throw new ArgumentOutOfRangeError();
    }
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(filter(function (v, i) { return i === index; }), take(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new ArgumentOutOfRangeError(); }));
    };
}

function endWith() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return function (source) { return concat$2(source, of.apply(void 0, __spreadArray([], __read(values)))); };
}

function every(predicate, thisArg) {
    return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            if (!predicate.call(thisArg, value, index++, source)) {
                subscriber.next(false);
                subscriber.complete();
            }
        }, function () {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}

function exhaustMap(project, resultSelector) {
    if (resultSelector) {
        return function (source) {
            return source.pipe(exhaustMap(function (a, i) { return innerFrom(project(a, i)).pipe(map(function (b, ii) { return resultSelector(a, b, i, ii); })); }));
        };
    }
    return operate(function (source, subscriber) {
        var index = 0;
        var innerSub = null;
        var isComplete = false;
        source.subscribe(createOperatorSubscriber(subscriber, function (outerValue) {
            if (!innerSub) {
                innerSub = createOperatorSubscriber(subscriber, undefined, function () {
                    innerSub = null;
                    isComplete && subscriber.complete();
                });
                innerFrom(project(outerValue, index++)).subscribe(innerSub);
            }
        }, function () {
            isComplete = true;
            !innerSub && subscriber.complete();
        }));
    });
}

function exhaustAll() {
    return exhaustMap(identity);
}

var exhaust = exhaustAll;

function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) { concurrent = Infinity; }
    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
    return operate(function (source, subscriber) {
        return mergeInternals(source, subscriber, project, concurrent, undefined, true, scheduler);
    });
}

function finalize(callback) {
    return operate(function (source, subscriber) {
        try {
            source.subscribe(subscriber);
        }
        finally {
            subscriber.add(callback);
        }
    });
}

function find$1(predicate, thisArg) {
    return operate(createFind(predicate, thisArg, 'value'));
}
function createFind(predicate, thisArg, emit) {
    var findIndex = emit === 'index';
    return function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var i = index++;
            if (predicate.call(thisArg, value, i, source)) {
                subscriber.next(findIndex ? i : value);
                subscriber.complete();
            }
        }, function () {
            subscriber.next(findIndex ? -1 : undefined);
            subscriber.complete();
        }));
    };
}

function findIndex(predicate, thisArg) {
    return operate(createFind(predicate, thisArg, 'index'));
}

function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(predicate ? filter(function (v, i) { return predicate(v, i, source); }) : identity, take(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError(); }));
    };
}

function groupBy(keySelector, elementOrOptions, duration, connector) {
    return operate(function (source, subscriber) {
        var element;
        if (!elementOrOptions || typeof elementOrOptions === 'function') {
            element = elementOrOptions;
        }
        else {
            (duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector);
        }
        var groups = new Map();
        var notify = function (cb) {
            groups.forEach(cb);
            cb(subscriber);
        };
        var handleError = function (err) { return notify(function (consumer) { return consumer.error(err); }); };
        var activeGroups = 0;
        var teardownAttempted = false;
        var groupBySourceSubscriber = new OperatorSubscriber(subscriber, function (value) {
            try {
                var key_1 = keySelector(value);
                var group_1 = groups.get(key_1);
                if (!group_1) {
                    groups.set(key_1, (group_1 = connector ? connector() : new Subject()));
                    var grouped = createGroupedObservable(key_1, group_1);
                    subscriber.next(grouped);
                    if (duration) {
                        var durationSubscriber_1 = createOperatorSubscriber(group_1, function () {
                            group_1.complete();
                            durationSubscriber_1 === null || durationSubscriber_1 === void 0 ? void 0 : durationSubscriber_1.unsubscribe();
                        }, undefined, undefined, function () { return groups.delete(key_1); });
                        groupBySourceSubscriber.add(innerFrom(duration(grouped)).subscribe(durationSubscriber_1));
                    }
                }
                group_1.next(element ? element(value) : value);
            }
            catch (err) {
                handleError(err);
            }
        }, function () { return notify(function (consumer) { return consumer.complete(); }); }, handleError, function () { return groups.clear(); }, function () {
            teardownAttempted = true;
            return activeGroups === 0;
        });
        source.subscribe(groupBySourceSubscriber);
        function createGroupedObservable(key, groupSubject) {
            var result = new Observable(function (groupSubscriber) {
                activeGroups++;
                var innerSub = groupSubject.subscribe(groupSubscriber);
                return function () {
                    innerSub.unsubscribe();
                    --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
                };
            });
            result.key = key;
            return result;
        }
    });
}

function isEmpty() {
    return operate(function (source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, function () {
            subscriber.next(false);
            subscriber.complete();
        }, function () {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}

function takeLast(count) {
    return count <= 0
        ? function () { return EMPTY; }
        : operate(function (source, subscriber) {
            var buffer = [];
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                buffer.push(value);
                count < buffer.length && buffer.shift();
            }, function () {
                var e_1, _a;
                try {
                    for (var buffer_1 = __values(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()) {
                        var value = buffer_1_1.value;
                        subscriber.next(value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                subscriber.complete();
            }, undefined, function () {
                buffer = null;
            }));
        });
}

function last$1(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(predicate ? filter(function (v, i) { return predicate(v, i, source); }) : identity, takeLast(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError(); }));
    };
}

function materialize() {
    return operate(function (source, subscriber) {
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(Notification.createNext(value));
        }, function () {
            subscriber.next(Notification.createComplete());
            subscriber.complete();
        }, function (err) {
            subscriber.next(Notification.createError(err));
            subscriber.complete();
        }));
    });
}

function max$3(comparer) {
    return reduce(isFunction(comparer) ? function (x, y) { return (comparer(x, y) > 0 ? x : y); } : function (x, y) { return (x > y ? x : y); });
}

var flatMap = mergeMap;

function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    if (isFunction(resultSelector)) {
        return mergeMap(function () { return innerObservable; }, resultSelector, concurrent);
    }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return mergeMap(function () { return innerObservable; }, concurrent);
}

function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    return operate(function (source, subscriber) {
        var state = seed;
        return mergeInternals(source, subscriber, function (value, index) { return accumulator(state, value, index); }, concurrent, function (value) {
            state = value;
        }, false, undefined, function () { return (state = null); });
    });
}

function merge$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = popScheduler(args);
    var concurrent = popNumber(args, Infinity);
    return operate(function (source, subscriber) {
        mergeAll(concurrent)(from(__spreadArray([source], __read(args)), scheduler)).subscribe(subscriber);
    });
}

function mergeWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return merge$1.apply(void 0, __spreadArray([], __read(otherSources)));
}

function min$4(comparer) {
    return reduce(isFunction(comparer) ? function (x, y) { return (comparer(x, y) < 0 ? x : y); } : function (x, y) { return (x < y ? x : y); });
}

function multicast(subjectOrSubjectFactory, selector) {
    var subjectFactory = isFunction(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function () { return subjectOrSubjectFactory; };
    if (isFunction(selector)) {
        return connect(selector, {
            connector: subjectFactory,
        });
    }
    return function (source) { return new ConnectableObservable(source, subjectFactory); };
}

function onErrorResumeNextWith() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var nextSources = argsOrArgArray(sources);
    return function (source) { return onErrorResumeNext.apply(void 0, __spreadArray([source], __read(nextSources))); };
}
var onErrorResumeNext$1 = onErrorResumeNextWith;

function pairwise() {
    return operate(function (source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([p, value]);
            hasPrev = true;
        }));
    });
}

function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return map(function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    });
}

function publish(selector) {
    return selector ? function (source) { return connect(selector)(source); } : function (source) { return multicast(new Subject())(source); };
}

function publishBehavior(initialValue) {
    return function (source) {
        var subject = new BehaviorSubject(initialValue);
        return new ConnectableObservable(source, function () { return subject; });
    };
}

function publishLast() {
    return function (source) {
        var subject = new AsyncSubject();
        return new ConnectableObservable(source, function () { return subject; });
    };
}

function publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
    if (selectorOrScheduler && !isFunction(selectorOrScheduler)) {
        timestampProvider = selectorOrScheduler;
    }
    var selector = isFunction(selectorOrScheduler) ? selectorOrScheduler : undefined;
    return function (source) { return multicast(new ReplaySubject(bufferSize, windowTime, timestampProvider), selector)(source); };
}

function raceWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return !otherSources.length
        ? identity
        : operate(function (source, subscriber) {
            raceInit(__spreadArray([source], __read(otherSources)))(subscriber);
        });
}

function repeat$1(countOrConfig) {
    var _a;
    var count = Infinity;
    var delay;
    if (countOrConfig != null) {
        if (typeof countOrConfig === 'object') {
            (_a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay = countOrConfig.delay);
        }
        else {
            count = countOrConfig;
        }
    }
    return count <= 0
        ? function () { return EMPTY; }
        : operate(function (source, subscriber) {
            var soFar = 0;
            var sourceSub;
            var resubscribe = function () {
                sourceSub === null || sourceSub === void 0 ? void 0 : sourceSub.unsubscribe();
                sourceSub = null;
                if (delay != null) {
                    var notifier = typeof delay === 'number' ? timer(delay) : innerFrom(delay(soFar));
                    var notifierSubscriber_1 = createOperatorSubscriber(subscriber, function () {
                        notifierSubscriber_1.unsubscribe();
                        subscribeToSource();
                    });
                    notifier.subscribe(notifierSubscriber_1);
                }
                else {
                    subscribeToSource();
                }
            };
            var subscribeToSource = function () {
                var syncUnsub = false;
                sourceSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, function () {
                    if (++soFar < count) {
                        if (sourceSub) {
                            resubscribe();
                        }
                        else {
                            syncUnsub = true;
                        }
                    }
                    else {
                        subscriber.complete();
                    }
                }));
                if (syncUnsub) {
                    resubscribe();
                }
            };
            subscribeToSource();
        });
}

function repeatWhen(notifier) {
    return operate(function (source, subscriber) {
        var innerSub;
        var syncResub = false;
        var completions$;
        var isNotifierComplete = false;
        var isMainComplete = false;
        var checkComplete = function () { return isMainComplete && isNotifierComplete && (subscriber.complete(), true); };
        var getCompletionSubject = function () {
            if (!completions$) {
                completions$ = new Subject();
                innerFrom(notifier(completions$)).subscribe(createOperatorSubscriber(subscriber, function () {
                    if (innerSub) {
                        subscribeForRepeatWhen();
                    }
                    else {
                        syncResub = true;
                    }
                }, function () {
                    isNotifierComplete = true;
                    checkComplete();
                }));
            }
            return completions$;
        };
        var subscribeForRepeatWhen = function () {
            isMainComplete = false;
            innerSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, function () {
                isMainComplete = true;
                !checkComplete() && getCompletionSubject().next();
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRepeatWhen();
            }
        };
        subscribeForRepeatWhen();
    });
}

function retry(configOrCount) {
    if (configOrCount === void 0) { configOrCount = Infinity; }
    var config;
    if (configOrCount && typeof configOrCount === 'object') {
        config = configOrCount;
    }
    else {
        config = {
            count: configOrCount,
        };
    }
    var _a = config.count, count = _a === void 0 ? Infinity : _a, delay = config.delay, _b = config.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
    return count <= 0
        ? identity
        : operate(function (source, subscriber) {
            var soFar = 0;
            var innerSub;
            var subscribeForRetry = function () {
                var syncUnsub = false;
                innerSub = source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                    if (resetOnSuccess) {
                        soFar = 0;
                    }
                    subscriber.next(value);
                }, undefined, function (err) {
                    if (soFar++ < count) {
                        var resub_1 = function () {
                            if (innerSub) {
                                innerSub.unsubscribe();
                                innerSub = null;
                                subscribeForRetry();
                            }
                            else {
                                syncUnsub = true;
                            }
                        };
                        if (delay != null) {
                            var notifier = typeof delay === 'number' ? timer(delay) : innerFrom(delay(err, soFar));
                            var notifierSubscriber_1 = createOperatorSubscriber(subscriber, function () {
                                notifierSubscriber_1.unsubscribe();
                                resub_1();
                            }, function () {
                                subscriber.complete();
                            });
                            notifier.subscribe(notifierSubscriber_1);
                        }
                        else {
                            resub_1();
                        }
                    }
                    else {
                        subscriber.error(err);
                    }
                }));
                if (syncUnsub) {
                    innerSub.unsubscribe();
                    innerSub = null;
                    subscribeForRetry();
                }
            };
            subscribeForRetry();
        });
}

function retryWhen(notifier) {
    return operate(function (source, subscriber) {
        var innerSub;
        var syncResub = false;
        var errors$;
        var subscribeForRetryWhen = function () {
            innerSub = source.subscribe(createOperatorSubscriber(subscriber, undefined, undefined, function (err) {
                if (!errors$) {
                    errors$ = new Subject();
                    innerFrom(notifier(errors$)).subscribe(createOperatorSubscriber(subscriber, function () {
                        return innerSub ? subscribeForRetryWhen() : (syncResub = true);
                    }));
                }
                if (errors$) {
                    errors$.next(err);
                }
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRetryWhen();
            }
        };
        subscribeForRetryWhen();
    });
}

function sample(notifier) {
    return operate(function (source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            lastValue = value;
        }));
        innerFrom(notifier).subscribe(createOperatorSubscriber(subscriber, function () {
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        }, noop$1));
    });
}

function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    return sample(interval(period, scheduler));
}

function scan(accumulator, seed) {
    return operate(scanInternals(accumulator, seed, arguments.length >= 2, true));
}

function sequenceEqual(compareTo, comparator) {
    if (comparator === void 0) { comparator = function (a, b) { return a === b; }; }
    return operate(function (source, subscriber) {
        var aState = createState();
        var bState = createState();
        var emit = function (isEqual) {
            subscriber.next(isEqual);
            subscriber.complete();
        };
        var createSubscriber = function (selfState, otherState) {
            var sequenceEqualSubscriber = createOperatorSubscriber(subscriber, function (a) {
                var buffer = otherState.buffer, complete = otherState.complete;
                if (buffer.length === 0) {
                    complete ? emit(false) : selfState.buffer.push(a);
                }
                else {
                    !comparator(a, buffer.shift()) && emit(false);
                }
            }, function () {
                selfState.complete = true;
                var complete = otherState.complete, buffer = otherState.buffer;
                complete && emit(buffer.length === 0);
                sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 ? void 0 : sequenceEqualSubscriber.unsubscribe();
            });
            return sequenceEqualSubscriber;
        };
        source.subscribe(createSubscriber(aState, bState));
        innerFrom(compareTo).subscribe(createSubscriber(bState, aState));
    });
}
function createState() {
    return {
        buffer: [],
        complete: false,
    };
}

function share(options) {
    if (options === void 0) { options = {}; }
    var _a = options.connector, connector = _a === void 0 ? function () { return new Subject(); } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function (wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function () {
            resetConnection === null || resetConnection === void 0 ? void 0 : resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function () {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function () {
            var conn = connection;
            reset();
            conn === null || conn === void 0 ? void 0 : conn.unsubscribe();
        };
        return operate(function (source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) {
                cancelReset();
            }
            var dest = (subject = subject !== null && subject !== void 0 ? subject : connector());
            subscriber.add(function () {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) {
                    resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
                }
            });
            dest.subscribe(subscriber);
            if (!connection &&
                refCount > 0) {
                connection = new SafeSubscriber({
                    next: function (value) { return dest.next(value); },
                    error: function (err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function () {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnComplete);
                        dest.complete();
                    },
                });
                innerFrom(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function handleReset(reset, on) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (on === true) {
        reset();
        return;
    }
    if (on === false) {
        return;
    }
    var onSubscriber = new SafeSubscriber({
        next: function () {
            onSubscriber.unsubscribe();
            reset();
        },
    });
    return innerFrom(on.apply(void 0, __spreadArray([], __read(args)))).subscribe(onSubscriber);
}

function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') {
        (_a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler);
    }
    else {
        bufferSize = (configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity);
    }
    return share({
        connector: function () { return new ReplaySubject(bufferSize, windowTime, scheduler); },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount,
    });
}

function single(predicate) {
    return operate(function (source, subscriber) {
        var hasValue = false;
        var singleValue;
        var seenValue = false;
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            seenValue = true;
            if (!predicate || predicate(value, index++, source)) {
                hasValue && subscriber.error(new SequenceError('Too many matching values'));
                hasValue = true;
                singleValue = value;
            }
        }, function () {
            if (hasValue) {
                subscriber.next(singleValue);
                subscriber.complete();
            }
            else {
                subscriber.error(seenValue ? new NotFoundError('No matching values') : new EmptyError());
            }
        }));
    });
}

function skip(count) {
    return filter(function (_, index) { return count <= index; });
}

function skipLast(skipCount) {
    return skipCount <= 0
        ?
            identity
        : operate(function (source, subscriber) {
            var ring = new Array(skipCount);
            var seen = 0;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                var valueIndex = seen++;
                if (valueIndex < skipCount) {
                    ring[valueIndex] = value;
                }
                else {
                    var index = valueIndex % skipCount;
                    var oldValue = ring[index];
                    ring[index] = value;
                    subscriber.next(oldValue);
                }
            }));
            return function () {
                ring = null;
            };
        });
}

function skipUntil(notifier) {
    return operate(function (source, subscriber) {
        var taking = false;
        var skipSubscriber = createOperatorSubscriber(subscriber, function () {
            skipSubscriber === null || skipSubscriber === void 0 ? void 0 : skipSubscriber.unsubscribe();
            taking = true;
        }, noop$1);
        innerFrom(notifier).subscribe(skipSubscriber);
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return taking && subscriber.next(value); }));
    });
}

function skipWhile(predicate) {
    return operate(function (source, subscriber) {
        var taking = false;
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return (taking || (taking = !predicate(value, index++))) && subscriber.next(value); }));
    });
}

function startWith() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var scheduler = popScheduler(values);
    return operate(function (source, subscriber) {
        (scheduler ? concat$2(values, source, scheduler) : concat$2(values, source)).subscribe(subscriber);
    });
}

function switchMap(project, resultSelector) {
    return operate(function (source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function () { return isComplete && !innerSubscriber && subscriber.complete(); };
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            innerFrom(project(value, outerIndex)).subscribe((innerSubscriber = createOperatorSubscriber(subscriber, function (innerValue) { return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue); }, function () {
                innerSubscriber = null;
                checkComplete();
            })));
        }, function () {
            isComplete = true;
            checkComplete();
        }));
    });
}

function switchAll() {
    return switchMap(identity);
}

function switchMapTo(innerObservable, resultSelector) {
    return isFunction(resultSelector) ? switchMap(function () { return innerObservable; }, resultSelector) : switchMap(function () { return innerObservable; });
}

function switchScan(accumulator, seed) {
    return operate(function (source, subscriber) {
        var state = seed;
        switchMap(function (value, index) { return accumulator(state, value, index); }, function (_, innerValue) { return ((state = innerValue), innerValue); })(source).subscribe(subscriber);
        return function () {
            state = null;
        };
    });
}

function takeUntil(notifier) {
    return operate(function (source, subscriber) {
        innerFrom(notifier).subscribe(createOperatorSubscriber(subscriber, function () { return subscriber.complete(); }, noop$1));
        !subscriber.closed && source.subscribe(subscriber);
    });
}

function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) { inclusive = false; }
    return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var result = predicate(value, index++);
            (result || inclusive) && subscriber.next(value);
            !result && subscriber.complete();
        }));
    });
}

function tap(observerOrNext, error, complete) {
    var tapObserver = isFunction(observerOrNext) || error || complete
        ?
            { next: observerOrNext, error: error, complete: complete }
        : observerOrNext;
    return tapObserver
        ? operate(function (source, subscriber) {
            var _a;
            (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
            var isUnsub = true;
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                var _a;
                (_a = tapObserver.next) === null || _a === void 0 ? void 0 : _a.call(tapObserver, value);
                subscriber.next(value);
            }, function () {
                var _a;
                isUnsub = false;
                (_a = tapObserver.complete) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
                subscriber.complete();
            }, function (err) {
                var _a;
                isUnsub = false;
                (_a = tapObserver.error) === null || _a === void 0 ? void 0 : _a.call(tapObserver, err);
                subscriber.error(err);
            }, function () {
                var _a, _b;
                if (isUnsub) {
                    (_a = tapObserver.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
                }
                (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
            }));
        })
        :
            identity;
}

function throttle(durationSelector, config) {
    return operate(function (source, subscriber) {
        var _a = config !== null && config !== void 0 ? config : {}, _b = _a.leading, leading = _b === void 0 ? true : _b, _c = _a.trailing, trailing = _c === void 0 ? false : _c;
        var hasValue = false;
        var sendValue = null;
        var throttled = null;
        var isComplete = false;
        var endThrottling = function () {
            throttled === null || throttled === void 0 ? void 0 : throttled.unsubscribe();
            throttled = null;
            if (trailing) {
                send();
                isComplete && subscriber.complete();
            }
        };
        var cleanupThrottling = function () {
            throttled = null;
            isComplete && subscriber.complete();
        };
        var startThrottle = function (value) {
            return (throttled = innerFrom(durationSelector(value)).subscribe(createOperatorSubscriber(subscriber, endThrottling, cleanupThrottling)));
        };
        var send = function () {
            if (hasValue) {
                hasValue = false;
                var value = sendValue;
                sendValue = null;
                subscriber.next(value);
                !isComplete && startThrottle(value);
            }
        };
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            hasValue = true;
            sendValue = value;
            !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
        }, function () {
            isComplete = true;
            !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
        }));
    });
}

function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    var duration$ = timer(duration, scheduler);
    return throttle(function () { return duration$; }, config);
}

function timeInterval(scheduler) {
    if (scheduler === void 0) { scheduler = asyncScheduler; }
    return operate(function (source, subscriber) {
        var last = scheduler.now();
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var now = scheduler.now();
            var interval = now - last;
            last = now;
            subscriber.next(new TimeInterval(value, interval));
        }));
    });
}
var TimeInterval = (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());

function timeoutWith(due, withObservable, scheduler) {
    var first;
    var each;
    var _with;
    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : async;
    if (isValidDate(due)) {
        first = due;
    }
    else if (typeof due === 'number') {
        each = due;
    }
    if (withObservable) {
        _with = function () { return withObservable; };
    }
    else {
        throw new TypeError('No observable provided to switch to');
    }
    if (first == null && each == null) {
        throw new TypeError('No timeout provided.');
    }
    return timeout({
        first: first,
        each: each,
        scheduler: scheduler,
        with: _with,
    });
}

function timestamp(timestampProvider) {
    if (timestampProvider === void 0) { timestampProvider = dateTimestampProvider; }
    return map(function (value) { return ({ value: value, timestamp: timestampProvider.now() }); });
}

function window$1(windowBoundaries) {
    return operate(function (source, subscriber) {
        var windowSubject = new Subject();
        subscriber.next(windowSubject.asObservable());
        var errorHandler = function (err) {
            windowSubject.error(err);
            subscriber.error(err);
        };
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value); }, function () {
            windowSubject.complete();
            subscriber.complete();
        }, errorHandler));
        innerFrom(windowBoundaries).subscribe(createOperatorSubscriber(subscriber, function () {
            windowSubject.complete();
            subscriber.next((windowSubject = new Subject()));
        }, noop$1, errorHandler));
        return function () {
            windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.unsubscribe();
            windowSubject = null;
        };
    });
}

function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) { startWindowEvery = 0; }
    var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
    return operate(function (source, subscriber) {
        var windows = [new Subject()];
        var starts = [];
        var count = 0;
        subscriber.next(windows[0].asObservable());
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a;
            try {
                for (var windows_1 = __values(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()) {
                    var window_1 = windows_1_1.value;
                    window_1.next(value);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var c = count - windowSize + 1;
            if (c >= 0 && c % startEvery === 0) {
                windows.shift().complete();
            }
            if (++count % startEvery === 0) {
                var window_2 = new Subject();
                windows.push(window_2);
                subscriber.next(window_2.asObservable());
            }
        }, function () {
            while (windows.length > 0) {
                windows.shift().complete();
            }
            subscriber.complete();
        }, function (err) {
            while (windows.length > 0) {
                windows.shift().error(err);
            }
            subscriber.error(err);
        }, function () {
            starts = null;
            windows = null;
        }));
    });
}

function windowTime(windowTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        otherArgs[_i - 1] = arguments[_i];
    }
    var scheduler = (_a = popScheduler(otherArgs)) !== null && _a !== void 0 ? _a : asyncScheduler;
    var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxWindowSize = otherArgs[1] || Infinity;
    return operate(function (source, subscriber) {
        var windowRecords = [];
        var restartOnClose = false;
        var closeWindow = function (record) {
            var window = record.window, subs = record.subs;
            window.complete();
            subs.unsubscribe();
            arrRemove(windowRecords, record);
            restartOnClose && startWindow();
        };
        var startWindow = function () {
            if (windowRecords) {
                var subs = new Subscription();
                subscriber.add(subs);
                var window_1 = new Subject();
                var record_1 = {
                    window: window_1,
                    subs: subs,
                    seen: 0,
                };
                windowRecords.push(record_1);
                subscriber.next(window_1.asObservable());
                executeSchedule(subs, scheduler, function () { return closeWindow(record_1); }, windowTimeSpan);
            }
        };
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            executeSchedule(subscriber, scheduler, startWindow, windowCreationInterval, true);
        }
        else {
            restartOnClose = true;
        }
        startWindow();
        var loop = function (cb) { return windowRecords.slice().forEach(cb); };
        var terminate = function (cb) {
            loop(function (_a) {
                var window = _a.window;
                return cb(window);
            });
            cb(subscriber);
            subscriber.unsubscribe();
        };
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            loop(function (record) {
                record.window.next(value);
                maxWindowSize <= ++record.seen && closeWindow(record);
            });
        }, function () { return terminate(function (consumer) { return consumer.complete(); }); }, function (err) { return terminate(function (consumer) { return consumer.error(err); }); }));
        return function () {
            windowRecords = null;
        };
    });
}

function windowToggle(openings, closingSelector) {
    return operate(function (source, subscriber) {
        var windows = [];
        var handleError = function (err) {
            while (0 < windows.length) {
                windows.shift().error(err);
            }
            subscriber.error(err);
        };
        innerFrom(openings).subscribe(createOperatorSubscriber(subscriber, function (openValue) {
            var window = new Subject();
            windows.push(window);
            var closingSubscription = new Subscription();
            var closeWindow = function () {
                arrRemove(windows, window);
                window.complete();
                closingSubscription.unsubscribe();
            };
            var closingNotifier;
            try {
                closingNotifier = innerFrom(closingSelector(openValue));
            }
            catch (err) {
                handleError(err);
                return;
            }
            subscriber.next(window.asObservable());
            closingSubscription.add(closingNotifier.subscribe(createOperatorSubscriber(subscriber, closeWindow, noop$1, handleError)));
        }, noop$1));
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var e_1, _a;
            var windowsCopy = windows.slice();
            try {
                for (var windowsCopy_1 = __values(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()) {
                    var window_1 = windowsCopy_1_1.value;
                    window_1.next(value);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }, function () {
            while (0 < windows.length) {
                windows.shift().complete();
            }
            subscriber.complete();
        }, handleError, function () {
            while (0 < windows.length) {
                windows.shift().unsubscribe();
            }
        }));
    });
}

function windowWhen(closingSelector) {
    return operate(function (source, subscriber) {
        var window;
        var closingSubscriber;
        var handleError = function (err) {
            window.error(err);
            subscriber.error(err);
        };
        var openWindow = function () {
            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
            window === null || window === void 0 ? void 0 : window.complete();
            window = new Subject();
            subscriber.next(window.asObservable());
            var closingNotifier;
            try {
                closingNotifier = innerFrom(closingSelector());
            }
            catch (err) {
                handleError(err);
                return;
            }
            closingNotifier.subscribe((closingSubscriber = createOperatorSubscriber(subscriber, openWindow, openWindow, handleError)));
        };
        openWindow();
        source.subscribe(createOperatorSubscriber(subscriber, function (value) { return window.next(value); }, function () {
            window.complete();
            subscriber.complete();
        }, handleError, function () {
            closingSubscriber === null || closingSubscriber === void 0 ? void 0 : closingSubscriber.unsubscribe();
            window = null;
        }));
    });
}

function withLatestFrom() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    var project = popResultSelector(inputs);
    return operate(function (source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function () { return false; });
        var ready = false;
        var _loop_1 = function (i) {
            innerFrom(inputs[i]).subscribe(createOperatorSubscriber(subscriber, function (value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every(identity)) && (hasValue = null);
                }
            }, noop$1));
        };
        for (var i = 0; i < len; i++) {
            _loop_1(i);
        }
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            if (ready) {
                var values = __spreadArray([value], __read(otherValues));
                subscriber.next(project ? project.apply(void 0, __spreadArray([], __read(values))) : values);
            }
        }));
    });
}

function zipAll(project) {
    return joinAllInternals(zip, project);
}

function zip$1() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return operate(function (source, subscriber) {
        zip.apply(void 0, __spreadArray([source], __read(sources))).subscribe(subscriber);
    });
}

function zipWith() {
    var otherInputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherInputs[_i] = arguments[_i];
    }
    return zip$1.apply(void 0, __spreadArray([], __read(otherInputs)));
}

var esm5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Observable: Observable,
  ConnectableObservable: ConnectableObservable,
  observable: observable,
  animationFrames: animationFrames,
  Subject: Subject,
  BehaviorSubject: BehaviorSubject,
  ReplaySubject: ReplaySubject,
  AsyncSubject: AsyncSubject,
  asap: asap,
  asapScheduler: asapScheduler,
  async: async,
  asyncScheduler: asyncScheduler,
  queue: queue,
  queueScheduler: queueScheduler,
  animationFrame: animationFrame,
  animationFrameScheduler: animationFrameScheduler,
  VirtualTimeScheduler: VirtualTimeScheduler,
  VirtualAction: VirtualAction,
  Scheduler: Scheduler,
  Subscription: Subscription,
  Subscriber: Subscriber,
  Notification: Notification,
  get NotificationKind () { return NotificationKind; },
  pipe: pipe,
  noop: noop$1,
  identity: identity,
  isObservable: isObservable,
  lastValueFrom: lastValueFrom,
  firstValueFrom: firstValueFrom,
  ArgumentOutOfRangeError: ArgumentOutOfRangeError,
  EmptyError: EmptyError,
  NotFoundError: NotFoundError,
  ObjectUnsubscribedError: ObjectUnsubscribedError,
  SequenceError: SequenceError,
  TimeoutError: TimeoutError,
  UnsubscriptionError: UnsubscriptionError,
  bindCallback: bindCallback,
  bindNodeCallback: bindNodeCallback,
  combineLatest: combineLatest,
  concat: concat$2,
  connectable: connectable,
  defer: defer,
  empty: empty,
  forkJoin: forkJoin,
  from: from,
  fromEvent: fromEvent,
  fromEventPattern: fromEventPattern,
  generate: generate,
  iif: iif,
  interval: interval,
  merge: merge,
  never: never,
  of: of,
  onErrorResumeNext: onErrorResumeNext,
  pairs: pairs,
  partition: partition,
  race: race,
  range: range,
  throwError: throwError,
  timer: timer,
  using: using,
  zip: zip,
  scheduled: scheduled,
  EMPTY: EMPTY,
  NEVER: NEVER,
  config: config,
  audit: audit,
  auditTime: auditTime,
  buffer: buffer,
  bufferCount: bufferCount,
  bufferTime: bufferTime,
  bufferToggle: bufferToggle,
  bufferWhen: bufferWhen,
  catchError: catchError,
  combineAll: combineAll,
  combineLatestAll: combineLatestAll,
  combineLatestWith: combineLatestWith,
  concatAll: concatAll,
  concatMap: concatMap,
  concatMapTo: concatMapTo,
  concatWith: concatWith,
  connect: connect,
  count: count,
  debounce: debounce,
  debounceTime: debounceTime,
  defaultIfEmpty: defaultIfEmpty,
  delay: delay,
  delayWhen: delayWhen,
  dematerialize: dematerialize,
  distinct: distinct,
  distinctUntilChanged: distinctUntilChanged,
  distinctUntilKeyChanged: distinctUntilKeyChanged,
  elementAt: elementAt,
  endWith: endWith,
  every: every,
  exhaust: exhaust,
  exhaustAll: exhaustAll,
  exhaustMap: exhaustMap,
  expand: expand,
  filter: filter,
  finalize: finalize,
  find: find$1,
  findIndex: findIndex,
  first: first,
  groupBy: groupBy,
  ignoreElements: ignoreElements,
  isEmpty: isEmpty,
  last: last$1,
  map: map,
  mapTo: mapTo,
  materialize: materialize,
  max: max$3,
  mergeAll: mergeAll,
  flatMap: flatMap,
  mergeMap: mergeMap,
  mergeMapTo: mergeMapTo,
  mergeScan: mergeScan,
  mergeWith: mergeWith,
  min: min$4,
  multicast: multicast,
  observeOn: observeOn,
  onErrorResumeNextWith: onErrorResumeNextWith,
  pairwise: pairwise,
  pluck: pluck,
  publish: publish,
  publishBehavior: publishBehavior,
  publishLast: publishLast,
  publishReplay: publishReplay,
  raceWith: raceWith,
  reduce: reduce,
  repeat: repeat$1,
  repeatWhen: repeatWhen,
  retry: retry,
  retryWhen: retryWhen,
  refCount: refCount,
  sample: sample,
  sampleTime: sampleTime,
  scan: scan,
  sequenceEqual: sequenceEqual,
  share: share,
  shareReplay: shareReplay,
  single: single,
  skip: skip,
  skipLast: skipLast,
  skipUntil: skipUntil,
  skipWhile: skipWhile,
  startWith: startWith,
  subscribeOn: subscribeOn,
  switchAll: switchAll,
  switchMap: switchMap,
  switchMapTo: switchMapTo,
  switchScan: switchScan,
  take: take,
  takeLast: takeLast,
  takeUntil: takeUntil,
  takeWhile: takeWhile,
  tap: tap,
  throttle: throttle,
  throttleTime: throttleTime,
  throwIfEmpty: throwIfEmpty,
  timeInterval: timeInterval,
  timeout: timeout,
  timeoutWith: timeoutWith,
  timestamp: timestamp,
  toArray: toArray,
  window: window$1,
  windowCount: windowCount,
  windowTime: windowTime,
  windowToggle: windowToggle,
  windowWhen: windowWhen,
  withLatestFrom: withLatestFrom,
  zipAll: zipAll,
  zipWith: zipWith
});

function partition$1(predicate, thisArg) {
    return function (source) {
        return [filter(predicate, thisArg)(source), filter(not(predicate, thisArg))(source)];
    };
}

function race$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return raceWith.apply(void 0, __spreadArray([], __read(argsOrArgArray(args))));
}

var operators = /*#__PURE__*/Object.freeze({
  __proto__: null,
  audit: audit,
  auditTime: auditTime,
  buffer: buffer,
  bufferCount: bufferCount,
  bufferTime: bufferTime,
  bufferToggle: bufferToggle,
  bufferWhen: bufferWhen,
  catchError: catchError,
  combineAll: combineAll,
  combineLatestAll: combineLatestAll,
  combineLatest: combineLatest$1,
  combineLatestWith: combineLatestWith,
  concat: concat$3,
  concatAll: concatAll,
  concatMap: concatMap,
  concatMapTo: concatMapTo,
  concatWith: concatWith,
  connect: connect,
  count: count,
  debounce: debounce,
  debounceTime: debounceTime,
  defaultIfEmpty: defaultIfEmpty,
  delay: delay,
  delayWhen: delayWhen,
  dematerialize: dematerialize,
  distinct: distinct,
  distinctUntilChanged: distinctUntilChanged,
  distinctUntilKeyChanged: distinctUntilKeyChanged,
  elementAt: elementAt,
  endWith: endWith,
  every: every,
  exhaust: exhaust,
  exhaustAll: exhaustAll,
  exhaustMap: exhaustMap,
  expand: expand,
  filter: filter,
  finalize: finalize,
  find: find$1,
  findIndex: findIndex,
  first: first,
  groupBy: groupBy,
  ignoreElements: ignoreElements,
  isEmpty: isEmpty,
  last: last$1,
  map: map,
  mapTo: mapTo,
  materialize: materialize,
  max: max$3,
  merge: merge$1,
  mergeAll: mergeAll,
  flatMap: flatMap,
  mergeMap: mergeMap,
  mergeMapTo: mergeMapTo,
  mergeScan: mergeScan,
  mergeWith: mergeWith,
  min: min$4,
  multicast: multicast,
  observeOn: observeOn,
  onErrorResumeNext: onErrorResumeNext$1,
  pairwise: pairwise,
  partition: partition$1,
  pluck: pluck,
  publish: publish,
  publishBehavior: publishBehavior,
  publishLast: publishLast,
  publishReplay: publishReplay,
  race: race$1,
  raceWith: raceWith,
  reduce: reduce,
  repeat: repeat$1,
  repeatWhen: repeatWhen,
  retry: retry,
  retryWhen: retryWhen,
  refCount: refCount,
  sample: sample,
  sampleTime: sampleTime,
  scan: scan,
  sequenceEqual: sequenceEqual,
  share: share,
  shareReplay: shareReplay,
  single: single,
  skip: skip,
  skipLast: skipLast,
  skipUntil: skipUntil,
  skipWhile: skipWhile,
  startWith: startWith,
  subscribeOn: subscribeOn,
  switchAll: switchAll,
  switchMap: switchMap,
  switchMapTo: switchMapTo,
  switchScan: switchScan,
  take: take,
  takeLast: takeLast,
  takeUntil: takeUntil,
  takeWhile: takeWhile,
  tap: tap,
  throttle: throttle,
  throttleTime: throttleTime,
  throwIfEmpty: throwIfEmpty,
  timeInterval: timeInterval,
  timeout: timeout,
  timeoutWith: timeoutWith,
  timestamp: timestamp,
  toArray: toArray,
  window: window$1,
  windowCount: windowCount,
  windowTime: windowTime,
  windowToggle: windowToggle,
  windowWhen: windowWhen,
  withLatestFrom: withLatestFrom,
  zip: zip$1,
  zipAll: zipAll,
  zipWith: zipWith
});

var xmlHelpers = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstChildWithTag = firstChildWithTag;
exports.childTagText = childTagText;
exports.parseXML = parseXML;

function firstChildWithTag(e, tagname) {
    const candidates = e.getElementsByTagName(tagname);
    if (candidates.length === 0) {
        return undefined;
    }
    return candidates[0];
}
function childTagText(e, tagname) {
    const child = firstChildWithTag(e, tagname);
    if (child === undefined) {
        return undefined;
    }
    return src$1.Strophe.getText(child);
}
function parseXML(serializedXML) {
    const document = src$1.Strophe.xmlHtmlNode(serializedXML);
    for (let i = 0; i < document.childNodes.length; i++) {
        const node = document.childNodes[i];
        if (node.nodeType == node.ELEMENT_NODE) {
            return node;
        }
    }
    throw new Error('invalid xml (no element found)');
}

});

unwrapExports(xmlHelpers);
xmlHelpers.firstChildWithTag;
xmlHelpers.childTagText;
xmlHelpers.parseXML;

var main = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.xml = exports.Builders = exports.Helpers = exports.Huangcha = exports.defaultConnectionOptions = exports.defaultClientOptions = exports.SubscriptionRequestBehaviour = void 0;











const debugRawXMPP = (0, src.default)('huangcha:raw');
const debugConnection = (0, src.default)('huangcha:connection');
const debugRoster = (0, src.default)('huangcha:roster');
const debugMAM = (0, src.default)('huangcha:mam');
const debugVCard = (0, src.default)('huangcha:vcard');
const debugReceipts = (0, src.default)('huangcha:receipts');
function randomUUID() {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}
var SubscriptionRequestBehaviour;
(function (SubscriptionRequestBehaviour) {
    SubscriptionRequestBehaviour[SubscriptionRequestBehaviour["Accept"] = 0] = "Accept";
    SubscriptionRequestBehaviour[SubscriptionRequestBehaviour["Refuse"] = 1] = "Refuse";
    SubscriptionRequestBehaviour[SubscriptionRequestBehaviour["DoNothing"] = 2] = "DoNothing";
})(SubscriptionRequestBehaviour || (exports.SubscriptionRequestBehaviour = SubscriptionRequestBehaviour = {}));
exports.defaultClientOptions = {
    receiptsAutoReply: true,
    receiptsAutoAsk: true,
    subscriptionRequestBehaviour: SubscriptionRequestBehaviour.DoNothing,
    subscriptionAutoReciprocalSubscribe: false,
    priority: 0,
    askRosterToServer: false,
    carbon: false
};
exports.defaultConnectionOptions = {
    keepalive: true,
    sync: false,
    mechanisms: [src$1.Strophe.SASLPlain]
};
const emptyMonlog = {
    debug: () => { },
    error: () => { },
    info: () => { },
    trace: () => { },
    warn: () => { }
};
class Huangcha {
    constructor(host, connectionOptions = {}, clientOptions = {}, logger = emptyMonlog) {
        this.connectionOptions = connectionOptions;
        this.clientOptions = clientOptions;
        this.logger = logger;
        this.connectionEstablished = new Promise((resolve, reject) => {
            this.triggerConnectionEstablished = resolve;
            this.triggerConnectionFail = reject;
        });
        this._messages = new esm5.Subject();
        this.messages$ = this._messages.asObservable();
        this._presences = new esm5.Subject();
        this.presences$ = this._presences.asObservable();
        this._iqs = new esm5.Subject();
        this.iqs$ = this._iqs.asObservable();
        this._roster = new esm5.BehaviorSubject({ roster: [] });
        this.roster$ = this._roster.asObservable();
        this._chatStates = new esm5.Subject();
        this.chatStates$ = this._chatStates.asObservable();
        this._receipts = new esm5.Subject();
        this.receipts$ = this._receipts.asObservable();
        this._mamMessages = new esm5.Subject();
        this.mamMessages$ = this._mamMessages.asObservable();
        this.reconnectionIntervalMs = 10000;
        this.onConnectionStatusUpdate = (status) => {
            let msg;
            switch (status) {
                case src$1.Strophe.Status.CONNECTING:
                    msg = 'Connecting to XMPP';
                    debugConnection(msg);
                    this.logger.info(msg);
                    break;
                case src$1.Strophe.Status.CONNECTED:
                    msg = 'Connected to XMPP';
                    debugConnection(msg);
                    this.logger.info(msg);
                    if (this.clientOptions.carbon) {
                        this.connection.messageCarbons.enable((carbon) => {
                            debugConnection("Carbon message received:", carbon);
                        });
                    }
                    this.addStandardHandlers();
                    this.onConnected();
                    if (this.clientOptions.askRosterToServer) {
                        this.connection.roster.get(() => debugRoster('Sent initial roster request'));
                    }
                    this.sendPresence();
                    break;
                case src$1.Strophe.Status.ATTACHED:
                    msg = 'Strophe is attached.';
                    debugConnection(msg);
                    this.logger.debug(msg);
                    break;
                case src$1.Strophe.Status.DISCONNECTING:
                    msg = 'Disconnecting from XMPP';
                    debugConnection(msg);
                    this.logger.debug(msg);
                    break;
                case src$1.Strophe.Status.DISCONNECTED:
                    msg = `No XMPP connection. Will try to reconnect in ${this.reconnectionIntervalMs / 1000} s`;
                    debugConnection(msg);
                    this.logger.warn(msg);
                    setTimeout(() => {
                        this.connect(this.connection.jid, this.connection.pass).catch(err => {
                            msg = "XMPP reconnection error. Abort reconnection";
                            debugConnection(msg);
                            this.logger.error(msg);
                        });
                    }, this.reconnectionIntervalMs);
                    break;
                case src$1.Strophe.Status.CONNFAIL:
                    msg = 'XMPP connection failed. Trying to reconnect';
                    debugConnection(msg);
                    this.logger.debug(msg);
                    break;
                case src$1.Strophe.Status.AUTHFAIL:
                    msg = 'XMPP Authentication failed';
                    debugConnection(msg);
                    this.logger.error(msg);
                    this.onConnectionFailed();
                    break;
                default:
                    msg = `Unhandled connection status: ${status}`;
                    debugConnection(msg);
                    this.logger.error(msg);
                    break;
            }
            Object.assign(this.connection, { status });
        };
        this.connectionOptions = Object.assign(Object.assign({}, exports.defaultConnectionOptions), connectionOptions);
        this.clientOptions = Object.assign(Object.assign({}, exports.defaultClientOptions), clientOptions);
        src$1.Strophe.Connection.addConnectionPlugin('ping', {
            _c: null,
            init: function (conn) {
                this._c = conn;
                src$1.Strophe.addNamespace('PING', "urn:xmpp:ping");
            },
            ping: function (jid, success, error, timeout) {
                var id = this._c.getUniqueId('ping');
                var iq = (0, src$1.$iq)({ type: 'get', to: jid, id: id }).c('ping', { xmlns: src$1.Strophe.NS.PING });
                this._c.sendIQ(iq, success, error, timeout);
            },
            pong: function (ping) {
                var _a, _b;
                var from = (_a = ping.getAttribute('from')) !== null && _a !== void 0 ? _a : '';
                var id = (_b = ping.getAttribute('id')) !== null && _b !== void 0 ? _b : '';
                var iq = (0, src$1.$iq)({ type: 'result', to: from, id: id });
                this._c.sendIQ(iq);
            },
            addPingHandler: function (handler) {
                return this._c.addHandler(handler, src$1.Strophe.NS.PING, "iq", "get");
            }
        });
        this.connection = new src$1.Strophe.Connection(host, Object.assign(Object.assign({}, exports.defaultConnectionOptions), connectionOptions));
        this.connection.rawInput = (msg) => debugRawXMPP('IN: %s', msg);
        this.connection.rawOutput = (msg) => debugRawXMPP('OUT: %s', msg);
        this.roster$ = this._roster.asObservable().pipe((0, operators.debounceTime)(1000));
    }
    get jid() {
        return this.connection.jid;
    }
    get connectionStatus() {
        return this._connectionStatus || src$1.Strophe.Status.ERROR;
    }
    get bareJid() {
        return src$1.Strophe.getBareJidFromJid(this.connection.jid);
    }
    get node() {
        return src$1.Strophe.getNodeFromJid(this.connection.jid);
    }
    get domain() {
        return src$1.Strophe.getDomainFromJid(this.connection.jid);
    }
    get connected() {
        return this.connection.connected;
    }
    static use(plugin) {
        Object.getOwnPropertyNames(plugin.prototype).forEach(name => {
            Huangcha.prototype[name] = plugin.prototype[name];
        });
    }
    normalizeToBareJid(contactString) {
        if (contactString.indexOf('@') === -1) {
            if (!this.connection.jid) {
                throw new Error('Cannot get jid from node before connecting to xmpp,'
                    + ' I don\'t know which domain to use!');
            }
            return `${contactString}@${this.domain}`;
        }
        return src$1.Strophe.getBareJidFromJid(contactString);
    }
    async connect(jid, password) {
        if (this.connected) {
            const msg = 'Called "connect" but already connected, ignoring';
            debugConnection(msg);
            this.logger.debug(msg);
            return true;
        }
        if (jid == null || password == null) {
            this.logger.warn('Cannot create a new connection because no jid/password supplied.');
            return false;
        }
        this.connection.connect(jid, password, this.onConnectionStatusUpdate, 60, 1);
        return this.connectionEstablished;
    }
    disconnect(reason = 'no-reason') {
        this.connection.disconnect(reason);
    }
    parseStanza(xmlStanza) {
        let from, to;
        if (xmlStanza.getElementsByTagName('message')[0]) {
            from = xmlStanza.getElementsByTagName('message')[0].getAttribute('from');
            to = xmlStanza.getElementsByTagName('message')[0].getAttribute('to');
        }
        else {
            from = xmlStanza.getAttribute('from');
            to = xmlStanza.getAttribute('to');
        }
        const direction = src$1.Strophe.getBareJidFromJid(to) === this.bareJid ? 'in' : 'out';
        return {
            from: from,
            to: to,
            id: xmlStanza.getAttribute('id'),
            type: xmlStanza.getAttribute('type') || undefined,
            lang: xmlStanza.getAttribute('xml:lang') || undefined,
            direction: direction,
            contact: src$1.Strophe.getBareJidFromJid(direction === 'in' ? from : to),
            timestamp: new Date().toISOString(),
            rawStanza: src$1.Strophe.serialize(xmlStanza),
        };
    }
    parseMessage(xmlStanza) {
        const stanza = this.parseStanza(xmlStanza);
        return Object.assign(Object.assign({}, stanza), { body: (0, xmlHelpers.childTagText)(xmlStanza, 'body'), x: (0, xmlHelpers.firstChildWithTag)(xmlStanza, 'x'), subject: (0, xmlHelpers.childTagText)(xmlStanza, 'subject'), thread: (0, xmlHelpers.childTagText)(xmlStanza, 'thread'), service: (0, xmlHelpers.childTagText)(xmlStanza, 'service'), platform: (0, xmlHelpers.childTagText)(xmlStanza, 'platform') });
    }
    parsePresence(presenceStanza) {
        const stanza = this.parseStanza(presenceStanza);
        return Object.assign(Object.assign({}, stanza), { show: (0, xmlHelpers.childTagText)(presenceStanza, 'show'), status: (0, xmlHelpers.childTagText)(presenceStanza, 'status'), priority: parseInt((0, xmlHelpers.childTagText)(presenceStanza, 'priority') || '') || undefined });
    }
    parseIQ(iqStanza) {
        return this.parseStanza(iqStanza);
    }
    parseVCard(vCardStanza) {
        const iqStanza = this.parseIQ(vCardStanza);
        const vCardElement = vCardStanza.getElementsByTagName('vCard')[0];
        return {
            stanza: iqStanza,
            content: vCardElement,
        };
    }
    parseMessageFromMamResult(mamMessage) {
        const xmlMessageStanza = mamMessage.getElementsByTagName('message')[0];
        const resultElement = mamMessage.getElementsByTagName('result')[0];
        const delayElement = mamMessage.getElementsByTagName('delay')[0];
        const message = this.parseMessage(xmlMessageStanza);
        message.timestamp = delayElement.getAttribute('stamp');
        message.mamId = resultElement.getAttribute('id');
        return message;
    }
    addStandardHandlers() {
        this.connection.addHandler(this.onMessage.bind(this), '', 'message', '', '', '');
        this.connection.addHandler(this.onPresence.bind(this), '', 'presence', '', '', '');
        this.connection.addHandler(this.onIQ.bind(this), '', 'iq', '', '', '');
        this.connection.addHandler(this.onChatState.bind(this), 'http://jabber.org/protocol/chatstates', 'message', '', '', '');
        this.connection.addHandler(this.onReceiptRequestOrResponse.bind(this), 'urn:xmpp:receipts', 'message', '', '', '');
        this.connection.ping.addPingHandler(this.onPing.bind(this));
        if (this.clientOptions.askRosterToServer) {
            this.connection.roster.registerRequestCallback(this.onSubscribeRequest.bind(this));
            this.connection.roster.registerCallback(this.onRosterUpdate.bind(this));
        }
    }
    onConnected() {
        this.connectionEstablished = this.triggerConnectionEstablished();
    }
    onConnectionFailed() {
        this.connectionEstablished = this.triggerConnectionFail();
    }
    onMessage(messageStanza) {
        if (!(0, xmlHelpers.firstChildWithTag)(messageStanza, 'body') && !(0, xmlHelpers.firstChildWithTag)(messageStanza, 'x')) {
            return true;
        }
        this._messages.next(this.parseMessage(messageStanza));
        return true;
    }
    onPresence(presenceStanza) {
        const presence = this.parsePresence(presenceStanza);
        const { type, from } = presence;
        if (type === 'subscribe') {
            this.onSubscribeRequest(from);
        }
        this._presences.next(presence);
        return true;
    }
    onIQ(iqStanza) {
        const iq = this.parseIQ(iqStanza);
        this._iqs.next(iq);
        return true;
    }
    onChatState(chatStateStanza) {
        const stateTag = chatStateStanza.firstElementChild;
        if (!stateTag) {
            return true;
        }
        const state = stateTag.tagName.toLowerCase();
        this._chatStates.next({
            stanza: this.parseStanza(chatStateStanza),
            state: state,
        });
        return true;
    }
    onReceiptRequestOrResponse(receiptStanza) {
        const stanza = this.parseMessage(receiptStanza);
        let receiptType;
        let msgId;
        if (receiptStanza.getElementsByTagName('request').length !== 0) {
            receiptType = 'request';
            msgId = stanza.id;
            if (this.clientOptions.receiptsAutoReply) {
                this.sendDeliveryReceipt(msgId, stanza.from, {
                    thread: this.clientOptions.receiptsKeepThread ? stanza.thread : undefined,
                });
            }
        }
        else if (receiptStanza.getElementsByTagName('received').length !== 0) {
            const received = receiptStanza.getElementsByTagName('received')[0];
            receiptType = 'receipt';
            msgId = received.getAttribute('id');
        }
        else {
            debugReceipts('Received element with receipts namespace which is neither'
                + ' a request nor a receipt. Ignoring...');
            return true;
        }
        const receipt = {
            stanza: stanza,
            msgId: msgId,
            type: receiptType
        };
        this._receipts.next(receipt);
        return true;
    }
    onSubscribeRequest(from) {
        if (this.clientOptions.askRosterToServer) {
            switch (this.clientOptions.subscriptionRequestBehaviour) {
                case SubscriptionRequestBehaviour.Accept:
                    this.connection.roster.authorize(from);
                    break;
                case SubscriptionRequestBehaviour.Refuse:
                    this.connection.roster.unauthorize(from);
                    break;
                case SubscriptionRequestBehaviour.DoNothing:
                    debugRoster(`Ignoring subscribe request from: ${from}`);
                    break;
            }
        }
        if (this.clientOptions.subscriptionAutoReciprocalSubscribe && this.clientOptions.askRosterToServer) {
            this.connection.roster.subscribe(from);
        }
        return true;
    }
    onRosterUpdate(items, updatedItem) {
        if (updatedItem && updatedItem.subscription === 'remove') {
            debugRoster(`Successfully removed ${updatedItem.jid} from roster`);
        }
        this._roster.next({ roster: items, updatedItem: updatedItem });
    }
    onPing(pingStanza) {
        this.connection.ping.pong(pingStanza);
        return true;
    }
    sendStanza(stanza) {
        this.connection.send(stanza);
    }
    sendMessage(data, options = {}) {
        const opts = Object.assign({ askReceipt: this.clientOptions.receiptsAutoAsk }, options);
        let xmlMsg = (0, src$1.$msg)({
            from: this.jid,
            to: data.to,
            type: data.type || 'chat',
            id: data.id || randomUUID(),
        });
        if (data.body) {
            xmlMsg.c('body').t(data.body).up();
        }
        if (data.subject) {
            xmlMsg.c('subject').t(data.subject).up();
        }
        if (data.thread) {
            xmlMsg.c('thread').t(data.thread).up();
        }
        if (data.x) {
            xmlMsg.cnode(data.x).up();
        }
        if (data.service) {
            xmlMsg.c('service').t(data.service).up();
        }
        if (data.platform) {
            xmlMsg.c('platform').t(data.platform).up();
        }
        if (opts.askReceipt) {
            xmlMsg.c('request', { xmlns: 'urn:xmpp:receipts' }).up();
        }
        this.sendStanza(xmlMsg);
        return this.parseMessage(xmlMsg.tree());
    }
    sendPresence(attrs = {}) {
        let _attrs = undefined;
        if (attrs.to != null) {
            _attrs = Object.assign(Object.assign({}, _attrs !== null && _attrs !== void 0 ? _attrs : {}), { to: attrs.to });
        }
        if (attrs.type != null) {
            _attrs = Object.assign(Object.assign({}, _attrs !== null && _attrs !== void 0 ? _attrs : {}), { type: attrs.type });
        }
        const presence = (0, src$1.$pres)(_attrs)
            .c('priority').t(`${this.clientOptions.priority}`);
        this.sendStanza(presence);
    }
    sendDeliveryReceipt(msgId, to, { messageType = 'chat', thread, } = {}) {
        const stanza = (0, src$1.$msg)({
            from: this.jid,
            to: to,
            id: randomUUID(),
            type: messageType,
        });
        stanza.c('received', { xmlns: 'urn:xmpp:receipts', id: msgId }).up();
        if (thread) {
            stanza.c('thread', thread).up();
        }
        this.sendStanza(stanza);
    }
    sendChatState(state, to, thread) {
        const chatStateStanza = (0, src$1.$msg)({
            to: to,
            type: 'chat'
        }).c(state, {
            xmlns: 'http://jabber.org/protocol/chatstates'
        }).up();
        if (thread) {
            chatStateStanza.c('thread', thread).up();
        }
        this.sendStanza(chatStateStanza);
    }
    findContact(contact) {
        const contactJid = this.normalizeToBareJid(contact);
        return this.connection.roster.findItem(contactJid);
    }
    addContact(contact, callback) {
        const contactJid = this.normalizeToBareJid(contact);
        const contactNick = src$1.Strophe.getNodeFromJid(contactJid);
        this.connection.roster.add(contactJid, contactNick, [], callback);
        this.connection.roster.subscribe(contactJid);
        this.connection.roster.authorize(contactJid);
    }
    removeContact(contact) {
        const contactJid = this.normalizeToBareJid(contact);
        this.connection.roster.remove(contactJid, () => {
            debugRoster(`Sent request to delete roster item ${contactJid}`);
        });
    }
    fetchVCard(jid) {
        debugVCard(`Asking vcard of ${jid}`);
        return new Promise((resolve, reject) => {
            this.connection.vcard.get(vcardStanza => resolve(this.parseVCard(vcardStanza)), jid, err => reject(err));
        });
    }
    setVCard(vCardStanza) {
        return this.sendStanza(vCardStanza);
    }
    queryMamArchive(contact, queryOptions = { max: 20 }, onCompleteCallback) {
        const queryId = `mamquery-${contact}-${queryOptions.before || 'initial'}-${Date.now()}`;
        debugMAM('Generated queryId: %s', queryId);
        const onMamMessage = (mamMessage) => {
            const resultElement = mamMessage.getElementsByTagName('result')[0];
            if (resultElement.getAttribute('queryid') !== queryId) {
                return true;
            }
            const msg = this.parseMessageFromMamResult(mamMessage);
            this._mamMessages.next(msg);
            return true;
        };
        const onMamComplete = (endMamIQ) => {
            const finElement = endMamIQ.getElementsByTagName('fin')[0];
            const rsm = new src$1.Strophe.RSM({ xml: finElement });
            const count = rsm.count ? +rsm.count : 0;
            const index = rsm.index ? +rsm.index : 0;
            const result = {
                complete: count === 0 || index === 0,
                index: index,
                firstId: rsm.first,
                lastId: rsm.last,
                count: count,
            };
            debugMAM('End mam archive result: %o', result);
            if (onCompleteCallback) {
                onCompleteCallback(result);
            }
            return true;
        };
        const options = Object.assign({}, queryOptions, {
            queryid: queryId,
            onMessage: onMamMessage,
            onComplete: onMamComplete,
        });
        this.connection.mam.query(this.bareJid, options);
    }
}
exports.Huangcha = Huangcha;
exports.Helpers = {
    firstChildWithTag: xmlHelpers.firstChildWithTag,
    childTagText: xmlHelpers.childTagText,
    parseXML: xmlHelpers.parseXML,
    getDomainFromJid: src$1.Strophe.getDomainFromJid,
    getResourceFromJid: src$1.Strophe.getResourceFromJid,
};
exports.Builders = {
    $build: src$1.$build,
    $iq: src$1.$iq,
    $msg: src$1.$msg,
    $pres: src$1.$pres,
};
exports.xml = {
    Helpers: exports.Helpers,
    Builders: exports.Builders
};

});

unwrapExports(main);
main.xml;
main.Builders;
main.Helpers;
var main_4 = main.Huangcha;
main.defaultConnectionOptions;
main.defaultClientOptions;
main.SubscriptionRequestBehaviour;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction$1(x) {
    return typeof x === 'function';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config$1 = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}

/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */
var empty$1 = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (config$1.useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            hostReportError(err);
        }
    },
    complete: function () { }
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray$4 = /*@__PURE__*/ (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject$2(x) {
    return x !== null && typeof x === 'object';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var UnsubscriptionErrorImpl = /*@__PURE__*/ (function () {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ?
            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
})();
var UnsubscriptionError$1 = UnsubscriptionErrorImpl;

/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */
var Subscription$1 = /*@__PURE__*/ (function () {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function () {
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) {
            _parentOrParents.remove(this);
        }
        else if (_parentOrParents !== null) {
            for (var index = 0; index < _parentOrParents.length; ++index) {
                var parent_1 = _parentOrParents[index];
                parent_1.remove(this);
            }
        }
        if (isFunction$1(_unsubscribe)) {
            if (_ctorUnsubscribe) {
                this._unsubscribe = undefined;
            }
            try {
                _unsubscribe.call(this);
            }
            catch (e) {
                errors = e instanceof UnsubscriptionError$1 ? flattenUnsubscriptionErrors(e.errors) : [e];
            }
        }
        if (isArray$4(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject$2(sub)) {
                    try {
                        sub.unsubscribe();
                    }
                    catch (e) {
                        errors = errors || [];
                        if (e instanceof UnsubscriptionError$1) {
                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                        }
                        else {
                            errors.push(e);
                        }
                    }
                }
            }
        }
        if (errors) {
            throw new UnsubscriptionError$1(errors);
        }
    };
    Subscription.prototype.add = function (teardown) {
        var subscription = teardown;
        if (!teardown) {
            return Subscription.EMPTY;
        }
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default: {
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) {
            subscription._parentOrParents = this;
        }
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) {
                return subscription;
            }
            subscription._parentOrParents = [_parentOrParents, this];
        }
        else if (_parentOrParents.indexOf(this) === -1) {
            _parentOrParents.push(this);
        }
        else {
            return subscription;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions === null) {
            this._subscriptions = [subscription];
        }
        else {
            subscriptions.push(subscription);
        }
        return subscription;
    };
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError$1) ? err.errors : err); }, []);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = /*@__PURE__*/ (function () {
    return typeof Symbol === 'function'
        ? /*@__PURE__*/ Symbol('rxSubscriber')
        : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();
})();

/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */
var Subscriber$1 = /*@__PURE__*/ (function (_super) {
    __extends$1(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = empty$1;
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = empty$1;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber$1(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber$1(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[rxSubscriber] = function () { return this; };
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}(Subscription$1));
var SafeSubscriber$1 = /*@__PURE__*/ (function (_super) {
    __extends$1(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (isFunction$1(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== empty$1) {
                context = Object.create(observerOrNext);
                if (isFunction$1(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!config$1.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = config$1.useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                hostReportError(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    hostReportError(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!config$1.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (config$1.useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                hostReportError(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!config$1.useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (config$1.useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                hostReportError(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber$1));

/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
function canReportError(observer) {
    while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
            return false;
        }
        else if (destination && destination instanceof Subscriber$1) {
            observer = destination;
        }
        else {
            observer = null;
        }
    }
    return true;
}

/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber$1) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber]) {
            return nextOrObserver[rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber$1(empty$1);
    }
    return new Subscriber$1(nextOrObserver, error, complete);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable$1 = /*@__PURE__*/ (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity$1(x) {
    return x;
}

/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */
function pipeFromArray$1(fns) {
    if (fns.length === 0) {
        return identity$1;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}

/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */
var Observable$1 = /*@__PURE__*/ (function () {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber(observerOrNext, error, complete);
        if (operator) {
            sink.add(operator.call(sink, this.source));
        }
        else {
            sink.add(this.source || (config$1.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                this._subscribe(sink) :
                this._trySubscribe(sink));
        }
        if (config$1.useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (config$1.useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if (canReportError(sink)) {
                sink.error(err);
            }
            else {
                console.warn(err);
            }
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor$1(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[observable$1] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipeFromArray$1(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor$1(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
function getPromiseCtor$1(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
    return function (subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    };
};

/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */
var subscribeToPromise = function (promise) {
    return function (subscriber) {
        promise.then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, hostReportError);
        return subscriber;
    };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator$1() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator$1 = /*@__PURE__*/ getSymbolIterator$1();

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
var subscribeToIterable = function (iterable) {
    return function (subscriber) {
        var iterator = iterable[iterator$1]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            }
            catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) {
                break;
            }
        } while (true);
        if (typeof iterator.return === 'function') {
            subscriber.add(function () {
                if (iterator.return) {
                    iterator.return();
                }
            });
        }
        return subscriber;
    };
};

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
var subscribeToObservable = function (obj) {
    return function (subscriber) {
        var obs = obj[observable$1]();
        if (typeof obs.subscribe !== 'function') {
            throw new TypeError('Provided object does not correctly implement Symbol.observable');
        }
        else {
            return obs.subscribe(subscriber);
        }
    };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike$1 = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise$2(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}

/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */
var subscribeTo = function (result) {
    if (!!result && typeof result[observable$1] === 'function') {
        return subscribeToObservable(result);
    }
    else if (isArrayLike$1(result)) {
        return subscribeToArray(result);
    }
    else if (isPromise$2(result)) {
        return subscribeToPromise(result);
    }
    else if (!!result && typeof result[iterator$1] === 'function') {
        return subscribeToIterable(result);
    }
    else {
        var value = isObject$2(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};

/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */
var SimpleInnerSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}(Subscriber$1));
var SimpleOuterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function () {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}(Subscriber$1));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof Observable$1) {
        return result.subscribe(innerSubscriber);
    }
    return subscribeTo(result)(innerSubscriber);
}

/** PURE_IMPORTS_START tslib,_innerSubscribe PURE_IMPORTS_END */
function catchError$1(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return (operator.caught = caught);
    };
}
var CatchOperator = /*@__PURE__*/ (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
var CatchSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            var innerSubscriber = new SimpleInnerSubscriber(this);
            this.add(innerSubscriber);
            var innerSubscription = innerSubscribe(result, innerSubscriber);
            if (innerSubscription !== innerSubscriber) {
                this.add(innerSubscription);
            }
        }
    };
    return CatchSubscriber;
}(SimpleOuterSubscriber));

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function map$1(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
var MapSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber$1));

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function filter$1(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
var FilterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends$1(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber$1));

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? functionBindContext(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray;

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
_export({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray_1(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

var arraySlice = functionUncurryThis([].slice);

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('slice');

var SPECIES$3 = wellKnownSymbol('species');
var $Array$1 = Array;
var max$4 = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array$1 || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject$1(Constructor)) {
        Constructor = Constructor[SPECIES$3];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array$1 || Constructor === undefined) {
        return arraySlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array$1 : Constructor)(max$4(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var floor$2 = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor$2(length / 2);
    var left = sort(arraySlice(array, 0, middle), comparefn);
    var right = sort(arraySlice(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

var arraySort = sort;

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var firefox = environmentUserAgent.match(/firefox\/(\d+)/i);

var environmentFfVersion = !!firefox && +firefox[1];

var environmentIsIeOrEdge = /MSIE|Trident/.test(environmentUserAgent);

var webkit = environmentUserAgent.match(/AppleWebKit\/(\d+)\./);

var environmentWebkitVersion = !!webkit && +webkit[1];

var test$1 = [];
var nativeSort = functionUncurryThis(test$1.sort);
var push$3 = functionUncurryThis(test$1.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (environmentV8Version) return environmentV8Version < 70;
  if (environmentFfVersion && environmentFfVersion > 3) return;
  if (environmentIsIeOrEdge) return true;
  if (environmentWebkitVersion) return environmentWebkitVersion < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$1.push({ k: chr + index, v: value });
    }
  }

  test$1.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED$1 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString_1(x) > toString_1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED$1 }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$3(items, array[index]);
    }

    arraySort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module


// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwnProperty_1(R, 'flags') && objectIsPrototypeOf(RegExpPrototype$1, R)
    ? functionCall(regexpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;






var TO_STRING = 'toString';
var RegExpPrototype$2 = RegExp.prototype;
var nativeToString = RegExpPrototype$2[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExpPrototype$2, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = toString_1(R.source);
    var flags = toString_1(regexpGetFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var replace$2 = functionUncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$3 = function (TYPE) {
  return function ($this) {
    var string = toString_1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace$2(string, ltrim, '');
    if (TYPE & 2) string = replace$2(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;



var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME$1 && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $trim = stringTrim.trim;


// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
_export({ target: 'String', proto: true, forced: stringTrimForced('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __awaiter$1(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator$1(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __spreadArray$1(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * FingerprintJS v3.4.2 - Copyright (c) FingerprintJS, Inc, 2023 (https://fingerprint.com)
 * Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
 *
 * This software contains code from open-source projects:
 * MurmurHash3 by Karan Lyons (https://github.com/karanlyons/murmurHash3.js)
 */

var version$2 = "3.4.2";

function wait(durationMs, resolveWith) {
    return new Promise(function (resolve) { return setTimeout(resolve, durationMs, resolveWith); });
}
function requestIdleCallbackIfAvailable(fallbackTimeout, deadlineTimeout) {
    if (deadlineTimeout === void 0) { deadlineTimeout = Infinity; }
    var requestIdleCallback = window.requestIdleCallback;
    if (requestIdleCallback) {
        // The function `requestIdleCallback` loses the binding to `window` here.
        // `globalThis` isn't always equal `window` (see https://github.com/fingerprintjs/fingerprintjs/issues/683).
        // Therefore, an error can occur. `call(window,` prevents the error.
        return new Promise(function (resolve) { return requestIdleCallback.call(window, function () { return resolve(); }, { timeout: deadlineTimeout }); });
    }
    else {
        return wait(Math.min(fallbackTimeout, deadlineTimeout));
    }
}
function isPromise$3(value) {
    return !!value && typeof value.then === 'function';
}
/**
 * Calls a maybe asynchronous function without creating microtasks when the function is synchronous.
 * Catches errors in both cases.
 *
 * If just you run a code like this:
 * ```
 * console.time('Action duration')
 * await action()
 * console.timeEnd('Action duration')
 * ```
 * The synchronous function time can be measured incorrectly because another microtask may run before the `await`
 * returns the control back to the code.
 */
function awaitIfAsync(action, callback) {
    try {
        var returnedValue = action();
        if (isPromise$3(returnedValue)) {
            returnedValue.then(function (result) { return callback(true, result); }, function (error) { return callback(false, error); });
        }
        else {
            callback(true, returnedValue);
        }
    }
    catch (error) {
        callback(false, error);
    }
}
/**
 * If you run many synchronous tasks without using this function, the JS main loop will be busy and asynchronous tasks
 * (e.g. completing a network request, rendering the page) won't be able to happen.
 * This function allows running many synchronous tasks such way that asynchronous tasks can run too in background.
 */
function mapWithBreaks(items, callback, loopReleaseInterval) {
    if (loopReleaseInterval === void 0) { loopReleaseInterval = 16; }
    return __awaiter$1(this, void 0, void 0, function () {
        var results, lastLoopReleaseTime, i, now;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    results = Array(items.length);
                    lastLoopReleaseTime = Date.now();
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < items.length)) return [3 /*break*/, 4];
                    results[i] = callback(items[i], i);
                    now = Date.now();
                    if (!(now >= lastLoopReleaseTime + loopReleaseInterval)) return [3 /*break*/, 3];
                    lastLoopReleaseTime = now;
                    // Allows asynchronous actions and microtasks to happen
                    return [4 /*yield*/, wait(0)];
                case 2:
                    // Allows asynchronous actions and microtasks to happen
                    _a.sent();
                    _a.label = 3;
                case 3:
                    ++i;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, results];
            }
        });
    });
}
/**
 * Makes the given promise never emit an unhandled promise rejection console warning.
 * The promise will still pass errors to the next promises.
 *
 * Otherwise, promise emits a console warning unless it has a `catch` listener.
 */
function suppressUnhandledRejectionWarning(promise) {
    promise.then(undefined, function () { return undefined; });
}

/*
 * Taken from https://github.com/karanlyons/murmurHash3.js/blob/a33d0723127e2e5415056c455f8aed2451ace208/murmurHash3.js
 */
//
// Given two 64bit ints (as an array of two 32bit ints) returns the two
// added together as a 64bit int (as an array of two 32bit ints).
//
function x64Add(m, n) {
    m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
    n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
    var o = [0, 0, 0, 0];
    o[3] += m[3] + n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] + n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] + n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] + n[0];
    o[0] &= 0xffff;
    return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
}
//
// Given two 64bit ints (as an array of two 32bit ints) returns the two
// multiplied together as a 64bit int (as an array of two 32bit ints).
//
function x64Multiply(m, n) {
    m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
    n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
    var o = [0, 0, 0, 0];
    o[3] += m[3] * n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] * n[3];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[2] += m[3] * n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] * n[3];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[2] * n[2];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[3] * n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
    o[0] &= 0xffff;
    return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
}
//
// Given a 64bit int (as an array of two 32bit ints) and an int
// representing a number of bit positions, returns the 64bit int (as an
// array of two 32bit ints) rotated left by that number of positions.
//
function x64Rotl(m, n) {
    n %= 64;
    if (n === 32) {
        return [m[1], m[0]];
    }
    else if (n < 32) {
        return [(m[0] << n) | (m[1] >>> (32 - n)), (m[1] << n) | (m[0] >>> (32 - n))];
    }
    else {
        n -= 32;
        return [(m[1] << n) | (m[0] >>> (32 - n)), (m[0] << n) | (m[1] >>> (32 - n))];
    }
}
//
// Given a 64bit int (as an array of two 32bit ints) and an int
// representing a number of bit positions, returns the 64bit int (as an
// array of two 32bit ints) shifted left by that number of positions.
//
function x64LeftShift(m, n) {
    n %= 64;
    if (n === 0) {
        return m;
    }
    else if (n < 32) {
        return [(m[0] << n) | (m[1] >>> (32 - n)), m[1] << n];
    }
    else {
        return [m[1] << (n - 32), 0];
    }
}
//
// Given two 64bit ints (as an array of two 32bit ints) returns the two
// xored together as a 64bit int (as an array of two 32bit ints).
//
function x64Xor(m, n) {
    return [m[0] ^ n[0], m[1] ^ n[1]];
}
//
// Given a block, returns murmurHash3's final x64 mix of that block.
// (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
// only place where we need to right shift 64bit ints.)
//
function x64Fmix(h) {
    h = x64Xor(h, [0, h[0] >>> 1]);
    h = x64Multiply(h, [0xff51afd7, 0xed558ccd]);
    h = x64Xor(h, [0, h[0] >>> 1]);
    h = x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
    h = x64Xor(h, [0, h[0] >>> 1]);
    return h;
}
//
// Given a string and an optional seed as an int, returns a 128 bit
// hash using the x64 flavor of MurmurHash3, as an unsigned hex.
//
function x64hash128(key, seed) {
    key = key || '';
    seed = seed || 0;
    var remainder = key.length % 16;
    var bytes = key.length - remainder;
    var h1 = [0, seed];
    var h2 = [0, seed];
    var k1 = [0, 0];
    var k2 = [0, 0];
    var c1 = [0x87c37b91, 0x114253d5];
    var c2 = [0x4cf5ad43, 0x2745937f];
    var i;
    for (i = 0; i < bytes; i = i + 16) {
        k1 = [
            (key.charCodeAt(i + 4) & 0xff) |
                ((key.charCodeAt(i + 5) & 0xff) << 8) |
                ((key.charCodeAt(i + 6) & 0xff) << 16) |
                ((key.charCodeAt(i + 7) & 0xff) << 24),
            (key.charCodeAt(i) & 0xff) |
                ((key.charCodeAt(i + 1) & 0xff) << 8) |
                ((key.charCodeAt(i + 2) & 0xff) << 16) |
                ((key.charCodeAt(i + 3) & 0xff) << 24),
        ];
        k2 = [
            (key.charCodeAt(i + 12) & 0xff) |
                ((key.charCodeAt(i + 13) & 0xff) << 8) |
                ((key.charCodeAt(i + 14) & 0xff) << 16) |
                ((key.charCodeAt(i + 15) & 0xff) << 24),
            (key.charCodeAt(i + 8) & 0xff) |
                ((key.charCodeAt(i + 9) & 0xff) << 8) |
                ((key.charCodeAt(i + 10) & 0xff) << 16) |
                ((key.charCodeAt(i + 11) & 0xff) << 24),
        ];
        k1 = x64Multiply(k1, c1);
        k1 = x64Rotl(k1, 31);
        k1 = x64Multiply(k1, c2);
        h1 = x64Xor(h1, k1);
        h1 = x64Rotl(h1, 27);
        h1 = x64Add(h1, h2);
        h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
        k2 = x64Multiply(k2, c2);
        k2 = x64Rotl(k2, 33);
        k2 = x64Multiply(k2, c1);
        h2 = x64Xor(h2, k2);
        h2 = x64Rotl(h2, 31);
        h2 = x64Add(h2, h1);
        h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
    }
    k1 = [0, 0];
    k2 = [0, 0];
    switch (remainder) {
        case 15:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48));
        // fallthrough
        case 14:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40));
        // fallthrough
        case 13:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32));
        // fallthrough
        case 12:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24));
        // fallthrough
        case 11:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16));
        // fallthrough
        case 10:
            k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8));
        // fallthrough
        case 9:
            k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)]);
            k2 = x64Multiply(k2, c2);
            k2 = x64Rotl(k2, 33);
            k2 = x64Multiply(k2, c1);
            h2 = x64Xor(h2, k2);
        // fallthrough
        case 8:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56));
        // fallthrough
        case 7:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48));
        // fallthrough
        case 6:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40));
        // fallthrough
        case 5:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32));
        // fallthrough
        case 4:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24));
        // fallthrough
        case 3:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16));
        // fallthrough
        case 2:
            k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8));
        // fallthrough
        case 1:
            k1 = x64Xor(k1, [0, key.charCodeAt(i)]);
            k1 = x64Multiply(k1, c1);
            k1 = x64Rotl(k1, 31);
            k1 = x64Multiply(k1, c2);
            h1 = x64Xor(h1, k1);
        // fallthrough
    }
    h1 = x64Xor(h1, [0, key.length]);
    h2 = x64Xor(h2, [0, key.length]);
    h1 = x64Add(h1, h2);
    h2 = x64Add(h2, h1);
    h1 = x64Fmix(h1);
    h2 = x64Fmix(h2);
    h1 = x64Add(h1, h2);
    h2 = x64Add(h2, h1);
    return (('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) +
        ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) +
        ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) +
        ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8));
}

/**
 * Converts an error object to a plain object that can be used with `JSON.stringify`.
 * If you just run `JSON.stringify(error)`, you'll get `'{}'`.
 */
function errorToObject(error) {
    var _a;
    return __assign({ name: error.name, message: error.message, stack: (_a = error.stack) === null || _a === void 0 ? void 0 : _a.split('\n') }, error);
}

/*
 * This file contains functions to work with pure data only (no browser features, DOM, side effects, etc).
 */
/**
 * Does the same as Array.prototype.includes but has better typing
 */
function includes(haystack, needle) {
    for (var i = 0, l = haystack.length; i < l; ++i) {
        if (haystack[i] === needle) {
            return true;
        }
    }
    return false;
}
/**
 * Like `!includes()` but with proper typing
 */
function excludes(haystack, needle) {
    return !includes(haystack, needle);
}
/**
 * Be careful, NaN can return
 */
function toInt(value) {
    return parseInt(value);
}
/**
 * Be careful, NaN can return
 */
function toFloat(value) {
    return parseFloat(value);
}
function replaceNaN(value, replacement) {
    return typeof value === 'number' && isNaN(value) ? replacement : value;
}
function countTruthy(values) {
    return values.reduce(function (sum, value) { return sum + (value ? 1 : 0); }, 0);
}
function round(value, base) {
    if (base === void 0) { base = 1; }
    if (Math.abs(base) >= 1) {
        return Math.round(value / base) * base;
    }
    else {
        // Sometimes when a number is multiplied by a small number, precision is lost,
        // for example 1234 * 0.0001 === 0.12340000000000001, and it's more precise divide: 1234 / (1 / 0.0001) === 0.1234.
        var counterBase = 1 / base;
        return Math.round(value * counterBase) / counterBase;
    }
}
/**
 * Parses a CSS selector into tag name with HTML attributes.
 * Only single element selector are supported (without operators like space, +, >, etc).
 *
 * Multiple values can be returned for each attribute. You decide how to handle them.
 */
function parseSimpleCssSelector(selector) {
    var _a, _b;
    var errorMessage = "Unexpected syntax '".concat(selector, "'");
    var tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector);
    var tag = tagMatch[1] || undefined;
    var attributes = {};
    var partsRegex = /([.:#][\w-]+|\[.+?\])/gi;
    var addAttribute = function (name, value) {
        attributes[name] = attributes[name] || [];
        attributes[name].push(value);
    };
    for (;;) {
        var match = partsRegex.exec(tagMatch[2]);
        if (!match) {
            break;
        }
        var part = match[0];
        switch (part[0]) {
            case '.':
                addAttribute('class', part.slice(1));
                break;
            case '#':
                addAttribute('id', part.slice(1));
                break;
            case '[': {
                var attributeMatch = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part);
                if (attributeMatch) {
                    addAttribute(attributeMatch[1], (_b = (_a = attributeMatch[4]) !== null && _a !== void 0 ? _a : attributeMatch[5]) !== null && _b !== void 0 ? _b : '');
                }
                else {
                    throw new Error(errorMessage);
                }
                break;
            }
            default:
                throw new Error(errorMessage);
        }
    }
    return [tag, attributes];
}

function ensureErrorWithMessage(error) {
    return error && typeof error === 'object' && 'message' in error ? error : { message: error };
}
function isFinalResultLoaded(loadResult) {
    return typeof loadResult !== 'function';
}
/**
 * Loads the given entropy source. Returns a function that gets an entropy component from the source.
 *
 * The result is returned synchronously to prevent `loadSources` from
 * waiting for one source to load before getting the components from the other sources.
 */
function loadSource(source, sourceOptions) {
    var sourceLoadPromise = new Promise(function (resolveLoad) {
        var loadStartTime = Date.now();
        // `awaitIfAsync` is used instead of just `await` in order to measure the duration of synchronous sources
        // correctly (other microtasks won't affect the duration).
        awaitIfAsync(source.bind(null, sourceOptions), function () {
            var loadArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                loadArgs[_i] = arguments[_i];
            }
            var loadDuration = Date.now() - loadStartTime;
            // Source loading failed
            if (!loadArgs[0]) {
                return resolveLoad(function () { return ({ error: ensureErrorWithMessage(loadArgs[1]), duration: loadDuration }); });
            }
            var loadResult = loadArgs[1];
            // Source loaded with the final result
            if (isFinalResultLoaded(loadResult)) {
                return resolveLoad(function () { return ({ value: loadResult, duration: loadDuration }); });
            }
            // Source loaded with "get" stage
            resolveLoad(function () {
                return new Promise(function (resolveGet) {
                    var getStartTime = Date.now();
                    awaitIfAsync(loadResult, function () {
                        var getArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            getArgs[_i] = arguments[_i];
                        }
                        var duration = loadDuration + Date.now() - getStartTime;
                        // Source getting failed
                        if (!getArgs[0]) {
                            return resolveGet({ error: ensureErrorWithMessage(getArgs[1]), duration: duration });
                        }
                        // Source getting succeeded
                        resolveGet({ value: getArgs[1], duration: duration });
                    });
                });
            });
        });
    });
    suppressUnhandledRejectionWarning(sourceLoadPromise);
    return function getComponent() {
        return sourceLoadPromise.then(function (finalizeSource) { return finalizeSource(); });
    };
}
/**
 * Loads the given entropy sources. Returns a function that collects the entropy components.
 *
 * The result is returned synchronously in order to allow start getting the components
 * before the sources are loaded completely.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function loadSources(sources, sourceOptions, excludeSources) {
    var includedSources = Object.keys(sources).filter(function (sourceKey) { return excludes(excludeSources, sourceKey); });
    // Using `mapWithBreaks` allows asynchronous sources to complete between synchronous sources
    // and measure the duration correctly
    var sourceGettersPromise = mapWithBreaks(includedSources, function (sourceKey) {
        return loadSource(sources[sourceKey], sourceOptions);
    });
    suppressUnhandledRejectionWarning(sourceGettersPromise);
    return function getComponents() {
        return __awaiter$1(this, void 0, void 0, function () {
            var sourceGetters, componentPromises, componentArray, components, index;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sourceGettersPromise];
                    case 1:
                        sourceGetters = _a.sent();
                        return [4 /*yield*/, mapWithBreaks(sourceGetters, function (sourceGetter) {
                                var componentPromise = sourceGetter();
                                suppressUnhandledRejectionWarning(componentPromise);
                                return componentPromise;
                            })];
                    case 2:
                        componentPromises = _a.sent();
                        return [4 /*yield*/, Promise.all(componentPromises)
                            // Keeping the component keys order the same as the source keys order
                        ];
                    case 3:
                        componentArray = _a.sent();
                        components = {};
                        for (index = 0; index < includedSources.length; ++index) {
                            components[includedSources[index]] = componentArray[index];
                        }
                        return [2 /*return*/, components];
                }
            });
        });
    };
}

/*
 * Functions to help with features that vary through browsers
 */
/**
 * Checks whether the browser is based on Trident (the Internet Explorer engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isTrident() {
    var w = window;
    var n = navigator;
    // The properties are checked to be in IE 10, IE 11 and not to be in other browsers in October 2020
    return (countTruthy([
        'MSCSSMatrix' in w,
        'msSetImmediate' in w,
        'msIndexedDB' in w,
        'msMaxTouchPoints' in n,
        'msPointerEnabled' in n,
    ]) >= 4);
}
/**
 * Checks whether the browser is based on EdgeHTML (the pre-Chromium Edge engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isEdgeHTML() {
    // Based on research in October 2020
    var w = window;
    var n = navigator;
    return (countTruthy(['msWriteProfilerMark' in w, 'MSStream' in w, 'msLaunchUri' in n, 'msSaveBlob' in n]) >= 3 &&
        !isTrident());
}
/**
 * Checks whether the browser is based on Chromium without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isChromium() {
    // Based on research in October 2020. Tested to detect Chromium 42-86.
    var w = window;
    var n = navigator;
    return (countTruthy([
        'webkitPersistentStorage' in n,
        'webkitTemporaryStorage' in n,
        n.vendor.indexOf('Google') === 0,
        'webkitResolveLocalFileSystemURL' in w,
        'BatteryManager' in w,
        'webkitMediaStream' in w,
        'webkitSpeechGrammar' in w,
    ]) >= 5);
}
/**
 * Checks whether the browser is based on mobile or desktop Safari without using user-agent.
 * All iOS browsers use WebKit (the Safari engine).
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isWebKit() {
    // Based on research in September 2020
    var w = window;
    var n = navigator;
    return (countTruthy([
        'ApplePayError' in w,
        'CSSPrimitiveValue' in w,
        'Counter' in w,
        n.vendor.indexOf('Apple') === 0,
        'getStorageUpdates' in n,
        'WebKitMediaKeys' in w,
    ]) >= 4);
}
/**
 * Checks whether the WebKit browser is a desktop Safari.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isDesktopSafari() {
    var w = window;
    return (countTruthy([
        'safari' in w,
        !('DeviceMotionEvent' in w),
        !('ongestureend' in w),
        !('standalone' in navigator),
    ]) >= 3);
}
/**
 * Checks whether the browser is based on Gecko (Firefox engine) without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isGecko() {
    var _a, _b;
    var w = window;
    // Based on research in September 2020
    return (countTruthy([
        'buildID' in navigator,
        'MozAppearance' in ((_b = (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.style) !== null && _b !== void 0 ? _b : {}),
        'onmozfullscreenchange' in w,
        'mozInnerScreenX' in w,
        'CSSMozDocumentRule' in w,
        'CanvasCaptureMediaStream' in w,
    ]) >= 4);
}
/**
 * Checks whether the browser is based on Chromium version ≥86 without using user-agent.
 * It doesn't check that the browser is based on Chromium, there is a separate function for this.
 */
function isChromium86OrNewer() {
    // Checked in Chrome 85 vs Chrome 86 both on desktop and Android
    var w = window;
    return (countTruthy([
        !('MediaSettingsRange' in w),
        'RTCEncodedAudioFrame' in w,
        '' + w.Intl === '[object Intl]',
        '' + w.Reflect === '[object Reflect]',
    ]) >= 3);
}
/**
 * Checks whether the browser is based on WebKit version ≥606 (Safari ≥12) without using user-agent.
 * It doesn't check that the browser is based on WebKit, there is a separate function for this.
 *
 * @link https://en.wikipedia.org/wiki/Safari_version_history#Release_history Safari-WebKit versions map
 */
function isWebKit606OrNewer() {
    // Checked in Safari 9–14
    var w = window;
    return (countTruthy([
        'DOMRectList' in w,
        'RTCPeerConnectionIceEvent' in w,
        'SVGGeometryElement' in w,
        'ontransitioncancel' in w,
    ]) >= 3);
}
/**
 * Checks whether the device is an iPad.
 * It doesn't check that the engine is WebKit and that the WebKit isn't desktop.
 */
function isIPad() {
    // Checked on:
    // Safari on iPadOS (both mobile and desktop modes): 8, 11, 12, 13, 14
    // Chrome on iPadOS (both mobile and desktop modes): 11, 12, 13, 14
    // Safari on iOS (both mobile and desktop modes): 9, 10, 11, 12, 13, 14
    // Chrome on iOS (both mobile and desktop modes): 9, 10, 11, 12, 13, 14
    // Before iOS 13. Safari tampers the value in "request desktop site" mode since iOS 13.
    if (navigator.platform === 'iPad') {
        return true;
    }
    var s = screen;
    var screenRatio = s.width / s.height;
    return (countTruthy([
        'MediaSource' in window,
        !!Element.prototype.webkitRequestFullscreen,
        // iPhone 4S that runs iOS 9 matches this. But it won't match the criteria above, so it won't be detected as iPad.
        screenRatio > 0.65 && screenRatio < 1.53,
    ]) >= 2);
}
/**
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function getFullscreenElement() {
    var d = document;
    return d.fullscreenElement || d.msFullscreenElement || d.mozFullScreenElement || d.webkitFullscreenElement || null;
}
function exitFullscreen() {
    var d = document;
    // `call` is required because the function throws an error without a proper "this" context
    return (d.exitFullscreen || d.msExitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen).call(d);
}
/**
 * Checks whether the device runs on Android without using user-agent.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function isAndroid() {
    var isItChromium = isChromium();
    var isItGecko = isGecko();
    // Only 2 browser engines are presented on Android.
    // Actually, there is also Android 4.1 browser, but it's not worth detecting it at the moment.
    if (!isItChromium && !isItGecko) {
        return false;
    }
    var w = window;
    // Chrome removes all words "Android" from `navigator` when desktop version is requested
    // Firefox keeps "Android" in `navigator.appVersion` when desktop version is requested
    return (countTruthy([
        'onorientationchange' in w,
        'orientation' in w,
        isItChromium && !('SharedWorker' in w),
        isItGecko && /android/i.test(navigator.appVersion),
    ]) >= 2);
}

/**
 * A deep description: https://fingerprint.com/blog/audio-fingerprinting/
 * Inspired by and based on https://github.com/cozylife/audio-fingerprint
 */
function getAudioFingerprint() {
    var w = window;
    var AudioContext = w.OfflineAudioContext || w.webkitOfflineAudioContext;
    if (!AudioContext) {
        return -2 /* SpecialFingerprint.NotSupported */;
    }
    // In some browsers, audio context always stays suspended unless the context is started in response to a user action
    // (e.g. a click or a tap). It prevents audio fingerprint from being taken at an arbitrary moment of time.
    // Such browsers are old and unpopular, so the audio fingerprinting is just skipped in them.
    // See a similar case explanation at https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
    if (doesCurrentBrowserSuspendAudioContext()) {
        return -1 /* SpecialFingerprint.KnownToSuspend */;
    }
    var hashFromIndex = 4500;
    var hashToIndex = 5000;
    var context = new AudioContext(1, hashToIndex, 44100);
    var oscillator = context.createOscillator();
    oscillator.type = 'triangle';
    oscillator.frequency.value = 10000;
    var compressor = context.createDynamicsCompressor();
    compressor.threshold.value = -50;
    compressor.knee.value = 40;
    compressor.ratio.value = 12;
    compressor.attack.value = 0;
    compressor.release.value = 0.25;
    oscillator.connect(compressor);
    compressor.connect(context.destination);
    oscillator.start(0);
    var _a = startRenderingAudio(context), renderPromise = _a[0], finishRendering = _a[1];
    var fingerprintPromise = renderPromise.then(function (buffer) { return getHash(buffer.getChannelData(0).subarray(hashFromIndex)); }, function (error) {
        if (error.name === "timeout" /* InnerErrorName.Timeout */ || error.name === "suspended" /* InnerErrorName.Suspended */) {
            return -3 /* SpecialFingerprint.Timeout */;
        }
        throw error;
    });
    // Suppresses the console error message in case when the fingerprint fails before requested
    suppressUnhandledRejectionWarning(fingerprintPromise);
    return function () {
        finishRendering();
        return fingerprintPromise;
    };
}
/**
 * Checks if the current browser is known to always suspend audio context
 */
function doesCurrentBrowserSuspendAudioContext() {
    return isWebKit() && !isDesktopSafari() && !isWebKit606OrNewer();
}
/**
 * Starts rendering the audio context.
 * When the returned function is called, the render process starts finishing.
 */
function startRenderingAudio(context) {
    var renderTryMaxCount = 3;
    var renderRetryDelay = 500;
    var runningMaxAwaitTime = 500;
    var runningSufficientTime = 5000;
    var finalize = function () { return undefined; };
    var resultPromise = new Promise(function (resolve, reject) {
        var isFinalized = false;
        var renderTryCount = 0;
        var startedRunningAt = 0;
        context.oncomplete = function (event) { return resolve(event.renderedBuffer); };
        var startRunningTimeout = function () {
            setTimeout(function () { return reject(makeInnerError("timeout" /* InnerErrorName.Timeout */)); }, Math.min(runningMaxAwaitTime, startedRunningAt + runningSufficientTime - Date.now()));
        };
        var tryRender = function () {
            try {
                var renderingPromise = context.startRendering();
                // `context.startRendering` has two APIs: Promise and callback, we check that it's really a promise just in case
                if (isPromise$3(renderingPromise)) {
                    // Suppresses all unhadled rejections in case of scheduled redundant retries after successful rendering
                    suppressUnhandledRejectionWarning(renderingPromise);
                }
                switch (context.state) {
                    case 'running':
                        startedRunningAt = Date.now();
                        if (isFinalized) {
                            startRunningTimeout();
                        }
                        break;
                    // Sometimes the audio context doesn't start after calling `startRendering` (in addition to the cases where
                    // audio context doesn't start at all). A known case is starting an audio context when the browser tab is in
                    // background on iPhone. Retries usually help in this case.
                    case 'suspended':
                        // The audio context can reject starting until the tab is in foreground. Long fingerprint duration
                        // in background isn't a problem, therefore the retry attempts don't count in background. It can lead to
                        // a situation when a fingerprint takes very long time and finishes successfully. FYI, the audio context
                        // can be suspended when `document.hidden === false` and start running after a retry.
                        if (!document.hidden) {
                            renderTryCount++;
                        }
                        if (isFinalized && renderTryCount >= renderTryMaxCount) {
                            reject(makeInnerError("suspended" /* InnerErrorName.Suspended */));
                        }
                        else {
                            setTimeout(tryRender, renderRetryDelay);
                        }
                        break;
                }
            }
            catch (error) {
                reject(error);
            }
        };
        tryRender();
        finalize = function () {
            if (!isFinalized) {
                isFinalized = true;
                if (startedRunningAt > 0) {
                    startRunningTimeout();
                }
            }
        };
    });
    return [resultPromise, finalize];
}
function getHash(signal) {
    var hash = 0;
    for (var i = 0; i < signal.length; ++i) {
        hash += Math.abs(signal[i]);
    }
    return hash;
}
function makeInnerError(name) {
    var error = new Error(name);
    error.name = name;
    return error;
}

/**
 * Creates and keeps an invisible iframe while the given function runs.
 * The given function is called when the iframe is loaded and has a body.
 * The iframe allows to measure DOM sizes inside itself.
 *
 * Notice: passing an initial HTML code doesn't work in IE.
 *
 * Warning for package users:
 * This function is out of Semantic Versioning, i.e. can change unexpectedly. Usage is at your own risk.
 */
function withIframe(action, initialHtml, domPollInterval) {
    var _a, _b, _c;
    if (domPollInterval === void 0) { domPollInterval = 50; }
    return __awaiter$1(this, void 0, void 0, function () {
        var d, iframe;
        return __generator$1(this, function (_d) {
            switch (_d.label) {
                case 0:
                    d = document;
                    _d.label = 1;
                case 1:
                    if (!!d.body) return [3 /*break*/, 3];
                    return [4 /*yield*/, wait(domPollInterval)];
                case 2:
                    _d.sent();
                    return [3 /*break*/, 1];
                case 3:
                    iframe = d.createElement('iframe');
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, , 10, 11]);
                    return [4 /*yield*/, new Promise(function (_resolve, _reject) {
                            var isComplete = false;
                            var resolve = function () {
                                isComplete = true;
                                _resolve();
                            };
                            var reject = function (error) {
                                isComplete = true;
                                _reject(error);
                            };
                            iframe.onload = resolve;
                            iframe.onerror = reject;
                            var style = iframe.style;
                            style.setProperty('display', 'block', 'important'); // Required for browsers to calculate the layout
                            style.position = 'absolute';
                            style.top = '0';
                            style.left = '0';
                            style.visibility = 'hidden';
                            if (initialHtml && 'srcdoc' in iframe) {
                                iframe.srcdoc = initialHtml;
                            }
                            else {
                                iframe.src = 'about:blank';
                            }
                            d.body.appendChild(iframe);
                            // WebKit in WeChat doesn't fire the iframe's `onload` for some reason.
                            // This code checks for the loading state manually.
                            // See https://github.com/fingerprintjs/fingerprintjs/issues/645
                            var checkReadyState = function () {
                                var _a, _b;
                                // The ready state may never become 'complete' in Firefox despite the 'load' event being fired.
                                // So an infinite setTimeout loop can happen without this check.
                                // See https://github.com/fingerprintjs/fingerprintjs/pull/716#issuecomment-986898796
                                if (isComplete) {
                                    return;
                                }
                                // Make sure iframe.contentWindow and iframe.contentWindow.document are both loaded
                                // The contentWindow.document can miss in JSDOM (https://github.com/jsdom/jsdom).
                                if (((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.readyState) === 'complete') {
                                    resolve();
                                }
                                else {
                                    setTimeout(checkReadyState, 10);
                                }
                            };
                            checkReadyState();
                        })];
                case 5:
                    _d.sent();
                    _d.label = 6;
                case 6:
                    if (!!((_b = (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.body)) return [3 /*break*/, 8];
                    return [4 /*yield*/, wait(domPollInterval)];
                case 7:
                    _d.sent();
                    return [3 /*break*/, 6];
                case 8: return [4 /*yield*/, action(iframe, iframe.contentWindow)];
                case 9: return [2 /*return*/, _d.sent()];
                case 10:
                    (_c = iframe.parentNode) === null || _c === void 0 ? void 0 : _c.removeChild(iframe);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    });
}
/**
 * Creates a DOM element that matches the given selector.
 * Only single element selector are supported (without operators like space, +, >, etc).
 */
function selectorToElement(selector) {
    var _a = parseSimpleCssSelector(selector), tag = _a[0], attributes = _a[1];
    var element = document.createElement(tag !== null && tag !== void 0 ? tag : 'div');
    for (var _i = 0, _b = Object.keys(attributes); _i < _b.length; _i++) {
        var name_1 = _b[_i];
        var value = attributes[name_1].join(' ');
        // Changing the `style` attribute can cause a CSP error, therefore we change the `style.cssText` property.
        // https://github.com/fingerprintjs/fingerprintjs/issues/733
        if (name_1 === 'style') {
            addStyleString(element.style, value);
        }
        else {
            element.setAttribute(name_1, value);
        }
    }
    return element;
}
/**
 * Adds CSS styles from a string in such a way that doesn't trigger a CSP warning (unsafe-inline or unsafe-eval)
 */
function addStyleString(style, source) {
    // We don't use `style.cssText` because browsers must block it when no `unsafe-eval` CSP is presented: https://csplite.com/csp145/#w3c_note
    // Even though the browsers ignore this standard, we don't use `cssText` just in case.
    for (var _i = 0, _a = source.split(';'); _i < _a.length; _i++) {
        var property = _a[_i];
        var match = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(property);
        if (match) {
            var name_2 = match[1], value = match[2], priority = match[4];
            style.setProperty(name_2, value, priority || ''); // The last argument can't be undefined in IE11
        }
    }
}

// We use m or w because these two characters take up the maximum width.
// And we use a LLi so that the same matching fonts can get separated.
var testString = 'mmMwWLliI0O&1';
// We test using 48px font size, we may use any size. I guess larger the better.
var textSize = '48px';
// A font will be compared against all the three default fonts.
// And if for any default fonts it doesn't match, then that font is available.
var baseFonts = ['monospace', 'sans-serif', 'serif'];
var fontList = [
    // This is android-specific font from "Roboto" family
    'sans-serif-thin',
    'ARNO PRO',
    'Agency FB',
    'Arabic Typesetting',
    'Arial Unicode MS',
    'AvantGarde Bk BT',
    'BankGothic Md BT',
    'Batang',
    'Bitstream Vera Sans Mono',
    'Calibri',
    'Century',
    'Century Gothic',
    'Clarendon',
    'EUROSTILE',
    'Franklin Gothic',
    'Futura Bk BT',
    'Futura Md BT',
    'GOTHAM',
    'Gill Sans',
    'HELV',
    'Haettenschweiler',
    'Helvetica Neue',
    'Humanst521 BT',
    'Leelawadee',
    'Letter Gothic',
    'Levenim MT',
    'Lucida Bright',
    'Lucida Sans',
    'Menlo',
    'MS Mincho',
    'MS Outlook',
    'MS Reference Specialty',
    'MS UI Gothic',
    'MT Extra',
    'MYRIAD PRO',
    'Marlett',
    'Meiryo UI',
    'Microsoft Uighur',
    'Minion Pro',
    'Monotype Corsiva',
    'PMingLiU',
    'Pristina',
    'SCRIPTINA',
    'Segoe UI Light',
    'Serifa',
    'SimHei',
    'Small Fonts',
    'Staccato222 BT',
    'TRAJAN PRO',
    'Univers CE 55 Medium',
    'Vrinda',
    'ZWAdobeF',
];
// kudos to http://www.lalit.org/lab/javascript-css-font-detect/
function getFonts() {
    // Running the script in an iframe makes it not affect the page look and not be affected by the page CSS. See:
    // https://github.com/fingerprintjs/fingerprintjs/issues/592
    // https://github.com/fingerprintjs/fingerprintjs/issues/628
    return withIframe(function (_, _a) {
        var document = _a.document;
        var holder = document.body;
        holder.style.fontSize = textSize;
        // div to load spans for the default fonts and the fonts to detect
        var spansContainer = document.createElement('div');
        var defaultWidth = {};
        var defaultHeight = {};
        // creates a span where the fonts will be loaded
        var createSpan = function (fontFamily) {
            var span = document.createElement('span');
            var style = span.style;
            style.position = 'absolute';
            style.top = '0';
            style.left = '0';
            style.fontFamily = fontFamily;
            span.textContent = testString;
            spansContainer.appendChild(span);
            return span;
        };
        // creates a span and load the font to detect and a base font for fallback
        var createSpanWithFonts = function (fontToDetect, baseFont) {
            return createSpan("'".concat(fontToDetect, "',").concat(baseFont));
        };
        // creates spans for the base fonts and adds them to baseFontsDiv
        var initializeBaseFontsSpans = function () {
            return baseFonts.map(createSpan);
        };
        // creates spans for the fonts to detect and adds them to fontsDiv
        var initializeFontsSpans = function () {
            // Stores {fontName : [spans for that font]}
            var spans = {};
            var _loop_1 = function (font) {
                spans[font] = baseFonts.map(function (baseFont) { return createSpanWithFonts(font, baseFont); });
            };
            for (var _i = 0, fontList_1 = fontList; _i < fontList_1.length; _i++) {
                var font = fontList_1[_i];
                _loop_1(font);
            }
            return spans;
        };
        // checks if a font is available
        var isFontAvailable = function (fontSpans) {
            return baseFonts.some(function (baseFont, baseFontIndex) {
                return fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] ||
                    fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont];
            });
        };
        // create spans for base fonts
        var baseFontsSpans = initializeBaseFontsSpans();
        // create spans for fonts to detect
        var fontsSpans = initializeFontsSpans();
        // add all the spans to the DOM
        holder.appendChild(spansContainer);
        // get the default width for the three base fonts
        for (var index = 0; index < baseFonts.length; index++) {
            defaultWidth[baseFonts[index]] = baseFontsSpans[index].offsetWidth; // width for the default font
            defaultHeight[baseFonts[index]] = baseFontsSpans[index].offsetHeight; // height for the default font
        }
        // check available fonts
        return fontList.filter(function (font) { return isFontAvailable(fontsSpans[font]); });
    });
}

function getPlugins() {
    var rawPlugins = navigator.plugins;
    if (!rawPlugins) {
        return undefined;
    }
    var plugins = [];
    // Safari 10 doesn't support iterating navigator.plugins with for...of
    for (var i = 0; i < rawPlugins.length; ++i) {
        var plugin = rawPlugins[i];
        if (!plugin) {
            continue;
        }
        var mimeTypes = [];
        for (var j = 0; j < plugin.length; ++j) {
            var mimeType = plugin[j];
            mimeTypes.push({
                type: mimeType.type,
                suffixes: mimeType.suffixes,
            });
        }
        plugins.push({
            name: plugin.name,
            description: plugin.description,
            mimeTypes: mimeTypes,
        });
    }
    return plugins;
}

// https://www.browserleaks.com/canvas#how-does-it-work
function getCanvasFingerprint() {
    var winding = false;
    var geometry;
    var text;
    var _a = makeCanvasContext(), canvas = _a[0], context = _a[1];
    if (!isSupported(canvas, context)) {
        geometry = text = ''; // The value will be 'unsupported' in v3.4
    }
    else {
        winding = doesSupportWinding(context);
        renderTextImage(canvas, context);
        var textImage1 = canvasToString(canvas);
        var textImage2 = canvasToString(canvas); // It's slightly faster to double-encode the text image
        // Some browsers add a noise to the canvas: https://github.com/fingerprintjs/fingerprintjs/issues/791
        // The canvas is excluded from the fingerprint in this case
        if (textImage1 !== textImage2) {
            geometry = text = 'unstable';
        }
        else {
            text = textImage1;
            // Text is unstable:
            // https://github.com/fingerprintjs/fingerprintjs/issues/583
            // https://github.com/fingerprintjs/fingerprintjs/issues/103
            // Therefore it's extracted into a separate image.
            renderGeometryImage(canvas, context);
            geometry = canvasToString(canvas);
        }
    }
    return { winding: winding, geometry: geometry, text: text };
}
function makeCanvasContext() {
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    return [canvas, canvas.getContext('2d')];
}
function isSupported(canvas, context) {
    return !!(context && canvas.toDataURL);
}
function doesSupportWinding(context) {
    // https://web.archive.org/web/20170825024655/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
    context.rect(0, 0, 10, 10);
    context.rect(2, 2, 6, 6);
    return !context.isPointInPath(5, 5, 'evenodd');
}
function renderTextImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 240;
    canvas.height = 60;
    context.textBaseline = 'alphabetic';
    context.fillStyle = '#f60';
    context.fillRect(100, 1, 62, 20);
    context.fillStyle = '#069';
    // It's important to use explicit built-in fonts in order to exclude the affect of font preferences
    // (there is a separate entropy source for them).
    context.font = '11pt "Times New Roman"';
    // The choice of emojis has a gigantic impact on rendering performance (especially in FF).
    // Some newer emojis cause it to slow down 50-200 times.
    // There must be no text to the right of the emoji, see https://github.com/fingerprintjs/fingerprintjs/issues/574
    // A bare emoji shouldn't be used because the canvas will change depending on the script encoding:
    // https://github.com/fingerprintjs/fingerprintjs/issues/66
    // Escape sequence shouldn't be used too because Terser will turn it into a bare unicode.
    var printedText = "Cwm fjordbank gly ".concat(String.fromCharCode(55357, 56835) /* 😃 */);
    context.fillText(printedText, 2, 15);
    context.fillStyle = 'rgba(102, 204, 0, 0.2)';
    context.font = '18pt Arial';
    context.fillText(printedText, 4, 45);
}
function renderGeometryImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 122;
    canvas.height = 110;
    // Canvas blending
    // https://web.archive.org/web/20170826194121/http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
    // http://jsfiddle.net/NDYV8/16/
    context.globalCompositeOperation = 'multiply';
    for (var _i = 0, _a = [
        ['#f2f', 40, 40],
        ['#2ff', 80, 40],
        ['#ff2', 60, 80],
    ]; _i < _a.length; _i++) {
        var _b = _a[_i], color = _b[0], x = _b[1], y = _b[2];
        context.fillStyle = color;
        context.beginPath();
        context.arc(x, y, 40, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
    }
    // Canvas winding
    // https://web.archive.org/web/20130913061632/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // http://jsfiddle.net/NDYV8/19/
    context.fillStyle = '#f9c';
    context.arc(60, 60, 60, 0, Math.PI * 2, true);
    context.arc(60, 60, 20, 0, Math.PI * 2, true);
    context.fill('evenodd');
}
function canvasToString(canvas) {
    return canvas.toDataURL();
}

/**
 * This is a crude and primitive touch screen detection. It's not possible to currently reliably detect the availability
 * of a touch screen with a JS, without actually subscribing to a touch event.
 *
 * @see http://www.stucox.com/blog/you-cant-detect-a-touchscreen/
 * @see https://github.com/Modernizr/Modernizr/issues/548
 */
function getTouchSupport() {
    var n = navigator;
    var maxTouchPoints = 0;
    var touchEvent;
    if (n.maxTouchPoints !== undefined) {
        maxTouchPoints = toInt(n.maxTouchPoints);
    }
    else if (n.msMaxTouchPoints !== undefined) {
        maxTouchPoints = n.msMaxTouchPoints;
    }
    try {
        document.createEvent('TouchEvent');
        touchEvent = true;
    }
    catch (_a) {
        touchEvent = false;
    }
    var touchStart = 'ontouchstart' in window;
    return {
        maxTouchPoints: maxTouchPoints,
        touchEvent: touchEvent,
        touchStart: touchStart,
    };
}

function getOsCpu() {
    return navigator.oscpu;
}

function getLanguages() {
    var n = navigator;
    var result = [];
    var language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
    if (language !== undefined) {
        result.push([language]);
    }
    if (Array.isArray(n.languages)) {
        // Starting from Chromium 86, there is only a single value in `navigator.language` in Incognito mode:
        // the value of `navigator.language`. Therefore the value is ignored in this browser.
        if (!(isChromium() && isChromium86OrNewer())) {
            result.push(n.languages);
        }
    }
    else if (typeof n.languages === 'string') {
        var languages = n.languages;
        if (languages) {
            result.push(languages.split(','));
        }
    }
    return result;
}

function getColorDepth() {
    return window.screen.colorDepth;
}

function getDeviceMemory() {
    // `navigator.deviceMemory` is a string containing a number in some unidentified cases
    return replaceNaN(toFloat(navigator.deviceMemory), undefined);
}

function getScreenResolution() {
    var s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    // Some browsers even return  screen resolution as not numbers.
    var parseDimension = function (value) { return replaceNaN(toInt(value), null); };
    var dimensions = [parseDimension(s.width), parseDimension(s.height)];
    dimensions.sort().reverse();
    return dimensions;
}

var screenFrameCheckInterval = 2500;
var roundingPrecision = 10;
// The type is readonly to protect from unwanted mutations
var screenFrameBackup;
var screenFrameSizeTimeoutId;
/**
 * Starts watching the screen frame size. When a non-zero size appears, the size is saved and the watch is stopped.
 * Later, when `getScreenFrame` runs, it will return the saved non-zero size if the current size is null.
 *
 * This trick is required to mitigate the fact that the screen frame turns null in some cases.
 * See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
 */
function watchScreenFrame() {
    if (screenFrameSizeTimeoutId !== undefined) {
        return;
    }
    var checkScreenFrame = function () {
        var frameSize = getCurrentScreenFrame();
        if (isFrameSizeNull(frameSize)) {
            screenFrameSizeTimeoutId = setTimeout(checkScreenFrame, screenFrameCheckInterval);
        }
        else {
            screenFrameBackup = frameSize;
            screenFrameSizeTimeoutId = undefined;
        }
    };
    checkScreenFrame();
}
function getScreenFrame() {
    var _this = this;
    watchScreenFrame();
    return function () { return __awaiter$1(_this, void 0, void 0, function () {
        var frameSize;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    frameSize = getCurrentScreenFrame();
                    if (!isFrameSizeNull(frameSize)) return [3 /*break*/, 2];
                    if (screenFrameBackup) {
                        return [2 /*return*/, __spreadArray$1([], screenFrameBackup, true)];
                    }
                    if (!getFullscreenElement()) return [3 /*break*/, 2];
                    // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                    // There is a chance of getting a non-zero frame after exiting the fullscreen.
                    // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                    return [4 /*yield*/, exitFullscreen()];
                case 1:
                    // Some browsers set the screen frame to zero when programmatic fullscreen is on.
                    // There is a chance of getting a non-zero frame after exiting the fullscreen.
                    // See more on this at https://github.com/fingerprintjs/fingerprintjs/issues/568
                    _a.sent();
                    frameSize = getCurrentScreenFrame();
                    _a.label = 2;
                case 2:
                    if (!isFrameSizeNull(frameSize)) {
                        screenFrameBackup = frameSize;
                    }
                    return [2 /*return*/, frameSize];
            }
        });
    }); };
}
/**
 * Sometimes the available screen resolution changes a bit, e.g. 1900x1440 → 1900x1439. A possible reason: macOS Dock
 * shrinks to fit more icons when there is too little space. The rounding is used to mitigate the difference.
 */
function getRoundedScreenFrame() {
    var _this = this;
    var screenFrameGetter = getScreenFrame();
    return function () { return __awaiter$1(_this, void 0, void 0, function () {
        var frameSize, processSize;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, screenFrameGetter()];
                case 1:
                    frameSize = _a.sent();
                    processSize = function (sideSize) { return (sideSize === null ? null : round(sideSize, roundingPrecision)); };
                    // It might look like I don't know about `for` and `map`.
                    // In fact, such code is used to avoid TypeScript issues without using `as`.
                    return [2 /*return*/, [processSize(frameSize[0]), processSize(frameSize[1]), processSize(frameSize[2]), processSize(frameSize[3])]];
            }
        });
    }); };
}
function getCurrentScreenFrame() {
    var s = screen;
    // Some browsers return screen resolution as strings, e.g. "1200", instead of a number, e.g. 1200.
    // I suspect it's done by certain plugins that randomize browser properties to prevent fingerprinting.
    //
    // Some browsers (IE, Edge ≤18) don't provide `screen.availLeft` and `screen.availTop`. The property values are
    // replaced with 0 in such cases to not lose the entropy from `screen.availWidth` and `screen.availHeight`.
    return [
        replaceNaN(toFloat(s.availTop), null),
        replaceNaN(toFloat(s.width) - toFloat(s.availWidth) - replaceNaN(toFloat(s.availLeft), 0), null),
        replaceNaN(toFloat(s.height) - toFloat(s.availHeight) - replaceNaN(toFloat(s.availTop), 0), null),
        replaceNaN(toFloat(s.availLeft), null),
    ];
}
function isFrameSizeNull(frameSize) {
    for (var i = 0; i < 4; ++i) {
        if (frameSize[i]) {
            return false;
        }
    }
    return true;
}

function getHardwareConcurrency() {
    // sometimes hardware concurrency is a string
    return replaceNaN(toInt(navigator.hardwareConcurrency), undefined);
}

function getTimezone() {
    var _a;
    var DateTimeFormat = (_a = window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat;
    if (DateTimeFormat) {
        var timezone = new DateTimeFormat().resolvedOptions().timeZone;
        if (timezone) {
            return timezone;
        }
    }
    // For browsers that don't support timezone names
    // The minus is intentional because the JS offset is opposite to the real offset
    var offset = -getTimezoneOffset();
    return "UTC".concat(offset >= 0 ? '+' : '').concat(Math.abs(offset));
}
function getTimezoneOffset() {
    var currentYear = new Date().getFullYear();
    // The timezone offset may change over time due to daylight saving time (DST) shifts.
    // The non-DST timezone offset is used as the result timezone offset.
    // Since the DST season differs in the northern and the southern hemispheres,
    // both January and July timezones offsets are considered.
    return Math.max(
    // `getTimezoneOffset` returns a number as a string in some unidentified cases
    toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()), toFloat(new Date(currentYear, 6, 1).getTimezoneOffset()));
}

function getSessionStorage() {
    try {
        return !!window.sessionStorage;
    }
    catch (error) {
        /* SecurityError when referencing it means it exists */
        return true;
    }
}

// https://bugzilla.mozilla.org/show_bug.cgi?id=781447
function getLocalStorage() {
    try {
        return !!window.localStorage;
    }
    catch (e) {
        /* SecurityError when referencing it means it exists */
        return true;
    }
}

function getIndexedDB() {
    // IE and Edge don't allow accessing indexedDB in private mode, therefore IE and Edge will have different
    // visitor identifier in normal and private modes.
    if (isTrident() || isEdgeHTML()) {
        return undefined;
    }
    try {
        return !!window.indexedDB;
    }
    catch (e) {
        /* SecurityError when referencing it means it exists */
        return true;
    }
}

function getOpenDatabase() {
    return !!window.openDatabase;
}

function getCpuClass() {
    return navigator.cpuClass;
}

function getPlatform() {
    // Android Chrome 86 and 87 and Android Firefox 80 and 84 don't mock the platform value when desktop mode is requested
    var platform = navigator.platform;
    // iOS mocks the platform value when desktop version is requested: https://github.com/fingerprintjs/fingerprintjs/issues/514
    // iPad uses desktop mode by default since iOS 13
    // The value is 'MacIntel' on M1 Macs
    // The value is 'iPhone' on iPod Touch
    if (platform === 'MacIntel') {
        if (isWebKit() && !isDesktopSafari()) {
            return isIPad() ? 'iPad' : 'iPhone';
        }
    }
    return platform;
}

function getVendor() {
    return navigator.vendor || '';
}

/**
 * Checks for browser-specific (not engine specific) global variables to tell browsers with the same engine apart.
 * Only somewhat popular browsers are considered.
 */
function getVendorFlavors() {
    var flavors = [];
    for (var _i = 0, _a = [
        // Blink and some browsers on iOS
        'chrome',
        // Safari on macOS
        'safari',
        // Chrome on iOS (checked in 85 on 13 and 87 on 14)
        '__crWeb',
        '__gCrWeb',
        // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
        'yandex',
        // Yandex Browser on iOS (checked in 21.2 on 14)
        '__yb',
        '__ybro',
        // Firefox on iOS (checked in 32 on 14)
        '__firefox__',
        // Edge on iOS (checked in 46 on 14)
        '__edgeTrackingPreventionStatistics',
        'webkit',
        // Opera Touch on iOS (checked in 2.6 on 14)
        'oprt',
        // Samsung Internet on Android (checked in 11.1)
        'samsungAr',
        // UC Browser on Android (checked in 12.10 and 13.0)
        'ucweb',
        'UCShellJava',
        // Puffin on Android (checked in 9.0)
        'puffinDevice',
        // UC on iOS and Opera on Android have no specific global variables
        // Edge for Android isn't checked
    ]; _i < _a.length; _i++) {
        var key = _a[_i];
        var value = window[key];
        if (value && typeof value === 'object') {
            flavors.push(key);
        }
    }
    return flavors.sort();
}

/**
 * navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
 * cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past with
 * site-specific exceptions. Don't rely on it.
 *
 * @see https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js Taken from here
 */
function areCookiesEnabled() {
    var d = document;
    // Taken from here: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js
    // navigator.cookieEnabled cannot detect custom or nuanced cookie blocking configurations. For example, when blocking
    // cookies via the Advanced Privacy Settings in IE9, it always returns true. And there have been issues in the past
    // with site-specific exceptions. Don't rely on it.
    // try..catch because some in situations `document.cookie` is exposed but throws a
    // SecurityError if you try to access it; e.g. documents created from data URIs
    // or in sandboxed iframes (depending on flags/context)
    try {
        // Create cookie
        d.cookie = 'cookietest=1; SameSite=Strict;';
        var result = d.cookie.indexOf('cookietest=') !== -1;
        // Delete cookie
        d.cookie = 'cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        return result;
    }
    catch (e) {
        return false;
    }
}

/**
 * Only single element selector are supported (no operators like space, +, >, etc).
 * `embed` and `position: fixed;` will be considered as blocked anyway because it always has no offsetParent.
 * Avoid `iframe` and anything with `[src=]` because they produce excess HTTP requests.
 *
 * The "inappropriate" selectors are obfuscated. See https://github.com/fingerprintjs/fingerprintjs/issues/734.
 * A function is used instead of a plain object to help tree-shaking.
 *
 * The function code is generated automatically. See docs/content_blockers.md to learn how to make the list.
 */
function getFilters() {
    var fromB64 = atob; // Just for better minification
    return {
        abpIndo: [
            '#Iklan-Melayang',
            '#Kolom-Iklan-728',
            '#SidebarIklan-wrapper',
            '[title="ALIENBOLA" i]',
            fromB64('I0JveC1CYW5uZXItYWRz'),
        ],
        abpvn: ['.quangcao', '#mobileCatfish', fromB64('LmNsb3NlLWFkcw=='), '[id^="bn_bottom_fixed_"]', '#pmadv'],
        adBlockFinland: [
            '.mainostila',
            fromB64('LnNwb25zb3JpdA=='),
            '.ylamainos',
            fromB64('YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd'),
        ],
        adBlockPersian: [
            '#navbar_notice_50',
            '.kadr',
            'TABLE[width="140px"]',
            '#divAgahi',
            fromB64('YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd'),
        ],
        adBlockWarningRemoval: [
            '#adblock-honeypot',
            '.adblocker-root',
            '.wp_adblock_detect',
            fromB64('LmhlYWRlci1ibG9ja2VkLWFk'),
            fromB64('I2FkX2Jsb2NrZXI='),
        ],
        adGuardAnnoyances: [
            '.hs-sosyal',
            '#cookieconsentdiv',
            'div[class^="app_gdpr"]',
            '.as-oil',
            '[data-cypress="soft-push-notification-modal"]',
        ],
        adGuardBase: [
            '.BetterJsPopOverlay',
            fromB64('I2FkXzMwMFgyNTA='),
            fromB64('I2Jhbm5lcmZsb2F0MjI='),
            fromB64('I2NhbXBhaWduLWJhbm5lcg=='),
            fromB64('I0FkLUNvbnRlbnQ='),
        ],
        adGuardChinese: [
            fromB64('LlppX2FkX2FfSA=='),
            fromB64('YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd'),
            '#widget-quan',
            fromB64('YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd'),
            fromB64('YVtocmVmKj0iLjE5NTZobC5jb20vIl0='),
        ],
        adGuardFrench: [
            '#pavePub',
            fromB64('LmFkLWRlc2t0b3AtcmVjdGFuZ2xl'),
            '.mobile_adhesion',
            '.widgetadv',
            fromB64('LmFkc19iYW4='),
        ],
        adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
        adGuardJapanese: [
            '#kauli_yad_1',
            fromB64('YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0='),
            fromB64('Ll9wb3BJbl9pbmZpbml0ZV9hZA=='),
            fromB64('LmFkZ29vZ2xl'),
            fromB64('Ll9faXNib29zdFJldHVybkFk'),
        ],
        adGuardMobile: [
            fromB64('YW1wLWF1dG8tYWRz'),
            fromB64('LmFtcF9hZA=='),
            'amp-embed[type="24smi"]',
            '#mgid_iframe1',
            fromB64('I2FkX2ludmlld19hcmVh'),
        ],
        adGuardRussian: [
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0='),
            fromB64('LnJlY2xhbWE='),
            'div[id^="smi2adblock"]',
            fromB64('ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd'),
            '#psyduckpockeball',
        ],
        adGuardSocial: [
            fromB64('YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0='),
            fromB64('YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0='),
            '.etsy-tweet',
            '#inlineShare',
            '.popup-social',
        ],
        adGuardSpanishPortuguese: ['#barraPublicidade', '#Publicidade', '#publiEspecial', '#queTooltip', '.cnt-publi'],
        adGuardTrackingProtection: [
            '#qoo-counter',
            fromB64('YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=='),
            fromB64('YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0='),
            fromB64('YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=='),
            '#top100counter',
        ],
        adGuardTurkish: [
            '#backkapat',
            fromB64('I3Jla2xhbWk='),
            fromB64('YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0='),
            fromB64('YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd'),
            fromB64('YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ=='),
        ],
        bulgarian: [fromB64('dGQjZnJlZW5ldF90YWJsZV9hZHM='), '#ea_intext_div', '.lapni-pop-over', '#xenium_hot_offers'],
        easyList: [
            '.yb-floorad',
            fromB64('LndpZGdldF9wb19hZHNfd2lkZ2V0'),
            fromB64('LnRyYWZmaWNqdW5reS1hZA=='),
            '.textad_headline',
            fromB64('LnNwb25zb3JlZC10ZXh0LWxpbmtz'),
        ],
        easyListChina: [
            fromB64('LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=='),
            fromB64('LmZyb250cGFnZUFkdk0='),
            '#taotaole',
            '#aafoot.top_box',
            '.cfa_popup',
        ],
        easyListCookie: [
            '.ezmob-footer',
            '.cc-CookieWarning',
            '[data-cookie-number]',
            fromB64('LmF3LWNvb2tpZS1iYW5uZXI='),
            '.sygnal24-gdpr-modal-wrap',
        ],
        easyListCzechSlovak: [
            '#onlajny-stickers',
            fromB64('I3Jla2xhbW5pLWJveA=='),
            fromB64('LnJla2xhbWEtbWVnYWJvYXJk'),
            '.sklik',
            fromB64('W2lkXj0ic2tsaWtSZWtsYW1hIl0='),
        ],
        easyListDutch: [
            fromB64('I2FkdmVydGVudGll'),
            fromB64('I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=='),
            '.adstekst',
            fromB64('YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0='),
            '#semilo-lrectangle',
        ],
        easyListGermany: [
            '#SSpotIMPopSlider',
            fromB64('LnNwb25zb3JsaW5rZ3J1ZW4='),
            fromB64('I3dlcmJ1bmdza3k='),
            fromB64('I3Jla2xhbWUtcmVjaHRzLW1pdHRl'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0='),
        ],
        easyListItaly: [
            fromB64('LmJveF9hZHZfYW5udW5jaQ=='),
            '.sb-box-pubbliredazionale',
            fromB64('YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ=='),
        ],
        easyListLithuania: [
            fromB64('LnJla2xhbW9zX3RhcnBhcw=='),
            fromB64('LnJla2xhbW9zX251b3JvZG9z'),
            fromB64('aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd'),
            fromB64('aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd'),
            fromB64('aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd'),
        ],
        estonian: [fromB64('QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==')],
        fanboyAnnoyances: ['#ac-lre-player', '.navigate-to-top', '#subscribe_popup', '.newsletter_holder', '#back-top'],
        fanboyAntiFacebook: ['.util-bar-module-firefly-visible'],
        fanboyEnhancedTrackers: [
            '.open.pushModal',
            '#issuem-leaky-paywall-articles-zero-remaining-nag',
            '#sovrn_container',
            'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
            '.BlockNag__Card',
        ],
        fanboySocial: ['#FollowUs', '#meteored_share', '#social_follow', '.article-sharer', '.community__social-desc'],
        frellwitSwedish: [
            fromB64('YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=='),
            fromB64('YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=='),
            'article.category-samarbete',
            fromB64('ZGl2LmhvbGlkQWRz'),
            'ul.adsmodern',
        ],
        greekAdBlock: [
            fromB64('QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd'),
            fromB64('QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=='),
            fromB64('QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd'),
            'DIV.agores300',
            'TABLE.advright',
        ],
        hungarian: [
            '#cemp_doboz',
            '.optimonk-iframe-container',
            fromB64('LmFkX19tYWlu'),
            fromB64('W2NsYXNzKj0iR29vZ2xlQWRzIl0='),
            '#hirdetesek_box',
        ],
        iDontCareAboutCookies: [
            '.alert-info[data-block-track*="CookieNotice"]',
            '.ModuleTemplateCookieIndicator',
            '.o--cookies--container',
            '#cookies-policy-sticky',
            '#stickyCookieBar',
        ],
        icelandicAbp: [fromB64('QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==')],
        latvian: [
            fromB64('YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0O' +
                'iA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0='),
            fromB64('YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6I' +
                'DMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ=='),
        ],
        listKr: [
            fromB64('YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0='),
            fromB64('I2xpdmVyZUFkV3JhcHBlcg=='),
            fromB64('YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=='),
            fromB64('aW5zLmZhc3R2aWV3LWFk'),
            '.revenue_unit_item.dable',
        ],
        listeAr: [
            fromB64('LmdlbWluaUxCMUFk'),
            '.right-and-left-sponsers',
            fromB64('YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=='),
            fromB64('YVtocmVmKj0iYm9vcmFxLm9yZyJd'),
            fromB64('YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd'),
        ],
        listeFr: [
            fromB64('YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=='),
            fromB64('I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=='),
            fromB64('YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0='),
            '.site-pub-interstitiel',
            'div[id^="crt-"][data-criteo-id]',
        ],
        officialPolish: [
            '#ceneo-placeholder-ceneo-12',
            fromB64('W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd'),
            fromB64('YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=='),
            fromB64('YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=='),
            fromB64('ZGl2I3NrYXBpZWNfYWQ='),
        ],
        ro: [
            fromB64('YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd'),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0='),
            fromB64('YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd'),
            'a[href^="/url/"]',
        ],
        ruAd: [
            fromB64('YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd'),
            fromB64('YVtocmVmKj0iLy91dGltZy5ydS8iXQ=='),
            fromB64('YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0='),
            '#pgeldiz',
            '.yandex-rtb-block',
        ],
        thaiAds: [
            'a[href*=macau-uta-popup]',
            fromB64('I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=='),
            fromB64('LmFkczMwMHM='),
            '.bumq',
            '.img-kosana',
        ],
        webAnnoyancesUltralist: [
            '#mod-social-share-2',
            '#social-tools',
            fromB64('LmN0cGwtZnVsbGJhbm5lcg=='),
            '.zergnet-recommend',
            '.yt.btn-link.btn-md.btn',
        ],
    };
}
/**
 * The order of the returned array means nothing (it's always sorted alphabetically).
 *
 * Notice that the source is slightly unstable.
 * Safari provides a 2-taps way to disable all content blockers on a page temporarily.
 * Also content blockers can be disabled permanently for a domain, but it requires 4 taps.
 * So empty array shouldn't be treated as "no blockers", it should be treated as "no signal".
 * If you are a website owner, don't make your visitors want to disable content blockers.
 */
function getDomBlockers(_a) {
    var _b = _a === void 0 ? {} : _a, debug = _b.debug;
    return __awaiter$1(this, void 0, void 0, function () {
        var filters, filterNames, allSelectors, blockedSelectors, activeBlockers;
        var _c;
        return __generator$1(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!isApplicable()) {
                        return [2 /*return*/, undefined];
                    }
                    filters = getFilters();
                    filterNames = Object.keys(filters);
                    allSelectors = (_c = []).concat.apply(_c, filterNames.map(function (filterName) { return filters[filterName]; }));
                    return [4 /*yield*/, getBlockedSelectors(allSelectors)];
                case 1:
                    blockedSelectors = _d.sent();
                    if (debug) {
                        printDebug(filters, blockedSelectors);
                    }
                    activeBlockers = filterNames.filter(function (filterName) {
                        var selectors = filters[filterName];
                        var blockedCount = countTruthy(selectors.map(function (selector) { return blockedSelectors[selector]; }));
                        return blockedCount > selectors.length * 0.6;
                    });
                    activeBlockers.sort();
                    return [2 /*return*/, activeBlockers];
            }
        });
    });
}
function isApplicable() {
    // Safari (desktop and mobile) and all Android browsers keep content blockers in both regular and private mode
    return isWebKit() || isAndroid();
}
function getBlockedSelectors(selectors) {
    var _a;
    return __awaiter$1(this, void 0, void 0, function () {
        var d, root, elements, blockedSelectors, i, element, holder, i;
        return __generator$1(this, function (_b) {
            switch (_b.label) {
                case 0:
                    d = document;
                    root = d.createElement('div');
                    elements = new Array(selectors.length);
                    blockedSelectors = {} // Set() isn't used just in case somebody need older browser support
                    ;
                    forceShow(root);
                    // First create all elements that can be blocked. If the DOM steps below are done in a single cycle,
                    // browser will alternate tree modification and layout reading, that is very slow.
                    for (i = 0; i < selectors.length; ++i) {
                        element = selectorToElement(selectors[i]);
                        if (element.tagName === 'DIALOG') {
                            element.show();
                        }
                        holder = d.createElement('div') // Protects from unwanted effects of `+` and `~` selectors of filters
                        ;
                        forceShow(holder);
                        holder.appendChild(element);
                        root.appendChild(holder);
                        elements[i] = element;
                    }
                    _b.label = 1;
                case 1:
                    if (!!d.body) return [3 /*break*/, 3];
                    return [4 /*yield*/, wait(50)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 1];
                case 3:
                    d.body.appendChild(root);
                    try {
                        // Then check which of the elements are blocked
                        for (i = 0; i < selectors.length; ++i) {
                            if (!elements[i].offsetParent) {
                                blockedSelectors[selectors[i]] = true;
                            }
                        }
                    }
                    finally {
                        // Then remove the elements
                        (_a = root.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(root);
                    }
                    return [2 /*return*/, blockedSelectors];
            }
        });
    });
}
function forceShow(element) {
    element.style.setProperty('display', 'block', 'important');
}
function printDebug(filters, blockedSelectors) {
    var message = 'DOM blockers debug:\n```';
    for (var _i = 0, _a = Object.keys(filters); _i < _a.length; _i++) {
        var filterName = _a[_i];
        message += "\n".concat(filterName, ":");
        for (var _b = 0, _c = filters[filterName]; _b < _c.length; _b++) {
            var selector = _c[_b];
            message += "\n  ".concat(blockedSelectors[selector] ? '🚫' : '➡️', " ").concat(selector);
        }
    }
    // console.log is ok here because it's under a debug clause
    // eslint-disable-next-line no-console
    console.log("".concat(message, "\n```"));
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/color-gamut
 */
function getColorGamut() {
    // rec2020 includes p3 and p3 includes srgb
    for (var _i = 0, _a = ['rec2020', 'p3', 'srgb']; _i < _a.length; _i++) {
        var gamut = _a[_i];
        if (matchMedia("(color-gamut: ".concat(gamut, ")")).matches) {
            return gamut;
        }
    }
    return undefined;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/inverted-colors
 */
function areColorsInverted() {
    if (doesMatch$4('inverted')) {
        return true;
    }
    if (doesMatch$4('none')) {
        return false;
    }
    return undefined;
}
function doesMatch$4(value) {
    return matchMedia("(inverted-colors: ".concat(value, ")")).matches;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/forced-colors
 */
function areColorsForced() {
    if (doesMatch$3('active')) {
        return true;
    }
    if (doesMatch$3('none')) {
        return false;
    }
    return undefined;
}
function doesMatch$3(value) {
    return matchMedia("(forced-colors: ".concat(value, ")")).matches;
}

var maxValueToCheck = 100;
/**
 * If the display is monochrome (e.g. black&white), the value will be ≥0 and will mean the number of bits per pixel.
 * If the display is not monochrome, the returned value will be 0.
 * If the browser doesn't support this feature, the returned value will be undefined.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/monochrome
 */
function getMonochromeDepth() {
    if (!matchMedia('(min-monochrome: 0)').matches) {
        // The media feature isn't supported by the browser
        return undefined;
    }
    // A variation of binary search algorithm can be used here.
    // But since expected values are very small (≤10), there is no sense in adding the complexity.
    for (var i = 0; i <= maxValueToCheck; ++i) {
        if (matchMedia("(max-monochrome: ".concat(i, ")")).matches) {
            return i;
        }
    }
    throw new Error('Too high value');
}

/**
 * @see https://www.w3.org/TR/mediaqueries-5/#prefers-contrast
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-contrast
 */
function getContrastPreference() {
    if (doesMatch$2('no-preference')) {
        return 0 /* ContrastPreference.None */;
    }
    // The sources contradict on the keywords. Probably 'high' and 'low' will never be implemented.
    // Need to check it when all browsers implement the feature.
    if (doesMatch$2('high') || doesMatch$2('more')) {
        return 1 /* ContrastPreference.More */;
    }
    if (doesMatch$2('low') || doesMatch$2('less')) {
        return -1 /* ContrastPreference.Less */;
    }
    if (doesMatch$2('forced')) {
        return 10 /* ContrastPreference.ForcedColors */;
    }
    return undefined;
}
function doesMatch$2(value) {
    return matchMedia("(prefers-contrast: ".concat(value, ")")).matches;
}

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */
function isMotionReduced() {
    if (doesMatch$1('reduce')) {
        return true;
    }
    if (doesMatch$1('no-preference')) {
        return false;
    }
    return undefined;
}
function doesMatch$1(value) {
    return matchMedia("(prefers-reduced-motion: ".concat(value, ")")).matches;
}

/**
 * @see https://www.w3.org/TR/mediaqueries-5/#dynamic-range
 */
function isHDR() {
    if (doesMatch('high')) {
        return true;
    }
    if (doesMatch('standard')) {
        return false;
    }
    return undefined;
}
function doesMatch(value) {
    return matchMedia("(dynamic-range: ".concat(value, ")")).matches;
}

var M = Math; // To reduce the minified code size
var fallbackFn = function () { return 0; };
/**
 * @see https://gitlab.torproject.org/legacy/trac/-/issues/13018
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=531915
 */
function getMathFingerprint() {
    // Native operations
    var acos = M.acos || fallbackFn;
    var acosh = M.acosh || fallbackFn;
    var asin = M.asin || fallbackFn;
    var asinh = M.asinh || fallbackFn;
    var atanh = M.atanh || fallbackFn;
    var atan = M.atan || fallbackFn;
    var sin = M.sin || fallbackFn;
    var sinh = M.sinh || fallbackFn;
    var cos = M.cos || fallbackFn;
    var cosh = M.cosh || fallbackFn;
    var tan = M.tan || fallbackFn;
    var tanh = M.tanh || fallbackFn;
    var exp = M.exp || fallbackFn;
    var expm1 = M.expm1 || fallbackFn;
    var log1p = M.log1p || fallbackFn;
    // Operation polyfills
    var powPI = function (value) { return M.pow(M.PI, value); };
    var acoshPf = function (value) { return M.log(value + M.sqrt(value * value - 1)); };
    var asinhPf = function (value) { return M.log(value + M.sqrt(value * value + 1)); };
    var atanhPf = function (value) { return M.log((1 + value) / (1 - value)) / 2; };
    var sinhPf = function (value) { return M.exp(value) - 1 / M.exp(value) / 2; };
    var coshPf = function (value) { return (M.exp(value) + 1 / M.exp(value)) / 2; };
    var expm1Pf = function (value) { return M.exp(value) - 1; };
    var tanhPf = function (value) { return (M.exp(2 * value) - 1) / (M.exp(2 * value) + 1); };
    var log1pPf = function (value) { return M.log(1 + value); };
    // Note: constant values are empirical
    return {
        acos: acos(0.123124234234234242),
        acosh: acosh(1e308),
        acoshPf: acoshPf(1e154),
        asin: asin(0.123124234234234242),
        asinh: asinh(1),
        asinhPf: asinhPf(1),
        atanh: atanh(0.5),
        atanhPf: atanhPf(0.5),
        atan: atan(0.5),
        sin: sin(-1e300),
        sinh: sinh(1),
        sinhPf: sinhPf(1),
        cos: cos(10.000000000123),
        cosh: cosh(1),
        coshPf: coshPf(1),
        tan: tan(-1e300),
        tanh: tanh(1),
        tanhPf: tanhPf(1),
        exp: exp(1),
        expm1: expm1(1),
        expm1Pf: expm1Pf(1),
        log1p: log1p(10),
        log1pPf: log1pPf(10),
        powPI: powPI(-100),
    };
}

/**
 * We use m or w because these two characters take up the maximum width.
 * Also there are a couple of ligatures.
 */
var defaultText = 'mmMwWLliI0fiflO&1';
/**
 * Settings of text blocks to measure. The keys are random but persistent words.
 */
var presets = {
    /**
     * The default font. User can change it in desktop Chrome, desktop Firefox, IE 11,
     * Android Chrome (but only when the size is ≥ than the default) and Android Firefox.
     */
    default: [],
    /** OS font on macOS. User can change its size and weight. Applies after Safari restart. */
    apple: [{ font: '-apple-system-body' }],
    /** User can change it in desktop Chrome and desktop Firefox. */
    serif: [{ fontFamily: 'serif' }],
    /** User can change it in desktop Chrome and desktop Firefox. */
    sans: [{ fontFamily: 'sans-serif' }],
    /** User can change it in desktop Chrome and desktop Firefox. */
    mono: [{ fontFamily: 'monospace' }],
    /**
     * Check the smallest allowed font size. User can change it in desktop Chrome, desktop Firefox and desktop Safari.
     * The height can be 0 in Chrome on a retina display.
     */
    min: [{ fontSize: '1px' }],
    /** Tells one OS from another in desktop Chrome. */
    system: [{ fontFamily: 'system-ui' }],
};
/**
 * The result is a dictionary of the width of the text samples.
 * Heights aren't included because they give no extra entropy and are unstable.
 *
 * The result is very stable in IE 11, Edge 18 and Safari 14.
 * The result changes when the OS pixel density changes in Chromium 87. The real pixel density is required to solve,
 * but seems like it's impossible: https://stackoverflow.com/q/1713771/1118709.
 * The "min" and the "mono" (only on Windows) value may change when the page is zoomed in Firefox 87.
 */
function getFontPreferences() {
    return withNaturalFonts(function (document, container) {
        var elements = {};
        var sizes = {};
        // First create all elements to measure. If the DOM steps below are done in a single cycle,
        // browser will alternate tree modification and layout reading, that is very slow.
        for (var _i = 0, _a = Object.keys(presets); _i < _a.length; _i++) {
            var key = _a[_i];
            var _b = presets[key], _c = _b[0], style = _c === void 0 ? {} : _c, _d = _b[1], text = _d === void 0 ? defaultText : _d;
            var element = document.createElement('span');
            element.textContent = text;
            element.style.whiteSpace = 'nowrap';
            for (var _e = 0, _f = Object.keys(style); _e < _f.length; _e++) {
                var name_1 = _f[_e];
                var value = style[name_1];
                if (value !== undefined) {
                    element.style[name_1] = value;
                }
            }
            elements[key] = element;
            container.appendChild(document.createElement('br'));
            container.appendChild(element);
        }
        // Then measure the created elements
        for (var _g = 0, _h = Object.keys(presets); _g < _h.length; _g++) {
            var key = _h[_g];
            sizes[key] = elements[key].getBoundingClientRect().width;
        }
        return sizes;
    });
}
/**
 * Creates a DOM environment that provides the most natural font available, including Android OS font.
 * Measurements of the elements are zoom-independent.
 * Don't put a content to measure inside an absolutely positioned element.
 */
function withNaturalFonts(action, containerWidthPx) {
    if (containerWidthPx === void 0) { containerWidthPx = 4000; }
    /*
     * Requirements for Android Chrome to apply the system font size to a text inside an iframe:
     * - The iframe mustn't have a `display: none;` style;
     * - The text mustn't be positioned absolutely;
     * - The text block must be wide enough.
     *   2560px on some devices in portrait orientation for the biggest font size option (32px);
     * - There must be much enough text to form a few lines (I don't know the exact numbers);
     * - The text must have the `text-size-adjust: none` style. Otherwise the text will scale in "Desktop site" mode;
     *
     * Requirements for Android Firefox to apply the system font size to a text inside an iframe:
     * - The iframe document must have a header: `<meta name="viewport" content="width=device-width, initial-scale=1" />`.
     *   The only way to set it is to use the `srcdoc` attribute of the iframe;
     * - The iframe content must get loaded before adding extra content with JavaScript;
     *
     * https://example.com as the iframe target always inherits Android font settings so it can be used as a reference.
     *
     * Observations on how page zoom affects the measurements:
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - macOS Safari 11.1, 12.1, 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - macOS Safari 14.0: offsetWidth = 5% fluctuation;
     * - macOS Safari 14.0: getBoundingClientRect = 5% fluctuation;
     * - iOS Safari 9, 10, 11.0, 12.0: haven't found a way to zoom a page (pinch doesn't change layout);
     * - iOS Safari 13.1, 14.0: zoom reset + offsetWidth = 100% reliable;
     * - iOS Safari 13.1, 14.0: zoom reset + getBoundingClientRect = 100% reliable;
     * - iOS Safari 14.0: offsetWidth = 100% reliable;
     * - iOS Safari 14.0: getBoundingClientRect = 100% reliable;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + offsetWidth = 1px fluctuation;
     * - Chrome 42, 65, 80, 87: zoom 1/devicePixelRatio + getBoundingClientRect = 100% reliable;
     * - Chrome 87: offsetWidth = 1px fluctuation;
     * - Chrome 87: getBoundingClientRect = 0.7px fluctuation;
     * - Firefox 48, 51: offsetWidth = 10% fluctuation;
     * - Firefox 48, 51: getBoundingClientRect = 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: offsetWidth = width 100% reliable, height 10% fluctuation;
     * - Firefox 52, 53, 57, 62, 66, 67, 68, 71, 75, 80, 84: getBoundingClientRect = width 100% reliable, height 10%
     *   fluctuation;
     * - Android Chrome 86: haven't found a way to zoom a page (pinch doesn't change layout);
     * - Android Firefox 84: font size in accessibility settings changes all the CSS sizes, but offsetWidth and
     *   getBoundingClientRect keep measuring with regular units, so the size reflects the font size setting and doesn't
     *   fluctuate;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + offsetWidth = 100% reliable;
     * - IE 11, Edge 18: zoom 1/devicePixelRatio + getBoundingClientRect = reflects the zoom level;
     * - IE 11, Edge 18: offsetWidth = 100% reliable;
     * - IE 11, Edge 18: getBoundingClientRect = 100% reliable;
     */
    return withIframe(function (_, iframeWindow) {
        var iframeDocument = iframeWindow.document;
        var iframeBody = iframeDocument.body;
        var bodyStyle = iframeBody.style;
        bodyStyle.width = "".concat(containerWidthPx, "px");
        bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = 'none';
        // See the big comment above
        if (isChromium()) {
            iframeBody.style.zoom = "".concat(1 / iframeWindow.devicePixelRatio);
        }
        else if (isWebKit()) {
            iframeBody.style.zoom = 'reset';
        }
        // See the big comment above
        var linesOfText = iframeDocument.createElement('div');
        linesOfText.textContent = __spreadArray$1([], Array((containerWidthPx / 20) << 0), true).map(function () { return 'word'; }).join(' ');
        iframeBody.appendChild(linesOfText);
        return action(iframeDocument, iframeBody);
    }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}

/**
 * @see Credits: https://stackoverflow.com/a/49267844
 */
function getVideoCard() {
    var _a;
    var canvas = document.createElement('canvas');
    var gl = (_a = canvas.getContext('webgl')) !== null && _a !== void 0 ? _a : canvas.getContext('experimental-webgl');
    if (gl && 'getExtension' in gl) {
        var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) {
            return {
                vendor: (gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) || '').toString(),
                renderer: (gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || '').toString(),
            };
        }
    }
    return undefined;
}

function isPdfViewerEnabled() {
    return navigator.pdfViewerEnabled;
}

/**
 * Unlike most other architectures, on x86/x86-64 when floating-point instructions
 * have no NaN arguments, but produce NaN output, the output NaN has sign bit set.
 * We use it to distinguish x86/x86-64 from other architectures, by doing subtraction
 * of two infinities (must produce NaN per IEEE 754 standard).
 *
 * See https://codebrowser.bddppq.com/pytorch/pytorch/third_party/XNNPACK/src/init.c.html#79
 */
function getArchitecture() {
    var f = new Float32Array(1);
    var u8 = new Uint8Array(f.buffer);
    f[0] = Infinity;
    f[0] = f[0] - f[0];
    return u8[3];
}

/**
 * The list of entropy sources used to make visitor identifiers.
 *
 * This value isn't restricted by Semantic Versioning, i.e. it may be changed without bumping minor or major version of
 * this package.
 *
 * Note: Rollup and Webpack are smart enough to remove unused properties of this object during tree-shaking, so there is
 * no need to export the sources individually.
 */
var sources = {
    // READ FIRST:
    // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
    // to learn how entropy source works and how to make your own.
    // The sources run in this exact order.
    // The asynchronous sources are at the start to run in parallel with other sources.
    fonts: getFonts,
    domBlockers: getDomBlockers,
    fontPreferences: getFontPreferences,
    audio: getAudioFingerprint,
    screenFrame: getRoundedScreenFrame,
    osCpu: getOsCpu,
    languages: getLanguages,
    colorDepth: getColorDepth,
    deviceMemory: getDeviceMemory,
    screenResolution: getScreenResolution,
    hardwareConcurrency: getHardwareConcurrency,
    timezone: getTimezone,
    sessionStorage: getSessionStorage,
    localStorage: getLocalStorage,
    indexedDB: getIndexedDB,
    openDatabase: getOpenDatabase,
    cpuClass: getCpuClass,
    platform: getPlatform,
    plugins: getPlugins,
    canvas: getCanvasFingerprint,
    touchSupport: getTouchSupport,
    vendor: getVendor,
    vendorFlavors: getVendorFlavors,
    cookiesEnabled: areCookiesEnabled,
    colorGamut: getColorGamut,
    invertedColors: areColorsInverted,
    forcedColors: areColorsForced,
    monochrome: getMonochromeDepth,
    contrast: getContrastPreference,
    reducedMotion: isMotionReduced,
    hdr: isHDR,
    math: getMathFingerprint,
    videoCard: getVideoCard,
    pdfViewerEnabled: isPdfViewerEnabled,
    architecture: getArchitecture,
};
/**
 * Loads the built-in entropy sources.
 * Returns a function that collects the entropy components to make the visitor identifier.
 */
function loadBuiltinSources(options) {
    return loadSources(sources, options, []);
}

var commentTemplate = '$ if upgrade to Pro: https://fpjs.dev/pro';
function getConfidence(components) {
    var openConfidenceScore = getOpenConfidenceScore(components);
    var proConfidenceScore = deriveProConfidenceScore(openConfidenceScore);
    return { score: openConfidenceScore, comment: commentTemplate.replace(/\$/g, "".concat(proConfidenceScore)) };
}
function getOpenConfidenceScore(components) {
    // In order to calculate the true probability of the visitor identifier being correct, we need to know the number of
    // website visitors (the higher the number, the less the probability because the fingerprint entropy is limited).
    // JS agent doesn't know the number of visitors, so we can only do an approximate assessment.
    if (isAndroid()) {
        return 0.4;
    }
    // Safari (mobile and desktop)
    if (isWebKit()) {
        return isDesktopSafari() ? 0.5 : 0.3;
    }
    var platform = components.platform.value || '';
    // Windows
    if (/^Win/.test(platform)) {
        // The score is greater than on macOS because of the higher variety of devices running Windows.
        // Chrome provides more entropy than Firefox according too
        // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Windows%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
        // So we assign the same score to them.
        return 0.6;
    }
    // macOS
    if (/^Mac/.test(platform)) {
        // Chrome provides more entropy than Safari and Safari provides more entropy than Firefox.
        // Chrome is more popular than Safari and Safari is more popular than Firefox according to
        // https://netmarketshare.com/browser-market-share.aspx?options=%7B%22filter%22%3A%7B%22%24and%22%3A%5B%7B%22platform%22%3A%7B%22%24in%22%3A%5B%22Mac%20OS%22%5D%7D%7D%5D%7D%2C%22dateLabel%22%3A%22Trend%22%2C%22attributes%22%3A%22share%22%2C%22group%22%3A%22browser%22%2C%22sort%22%3A%7B%22share%22%3A-1%7D%2C%22id%22%3A%22browsersDesktop%22%2C%22dateInterval%22%3A%22Monthly%22%2C%22dateStart%22%3A%222019-11%22%2C%22dateEnd%22%3A%222020-10%22%2C%22segments%22%3A%22-1000%22%7D
        // So we assign the same score to them.
        return 0.5;
    }
    // Another platform, e.g. a desktop Linux. It's rare, so it should be pretty unique.
    return 0.7;
}
function deriveProConfidenceScore(openConfidenceScore) {
    return round(0.99 + 0.01 * openConfidenceScore, 0.0001);
}

function componentsToCanonicalString(components) {
    var result = '';
    for (var _i = 0, _a = Object.keys(components).sort(); _i < _a.length; _i++) {
        var componentKey = _a[_i];
        var component = components[componentKey];
        var value = component.error ? 'error' : JSON.stringify(component.value);
        result += "".concat(result ? '|' : '').concat(componentKey.replace(/([:|\\])/g, '\\$1'), ":").concat(value);
    }
    return result;
}
function componentsToDebugString(components) {
    return JSON.stringify(components, function (_key, value) {
        if (value instanceof Error) {
            return errorToObject(value);
        }
        return value;
    }, 2);
}
function hashComponents(components) {
    return x64hash128(componentsToCanonicalString(components));
}
/**
 * Makes a GetResult implementation that calculates the visitor id hash on demand.
 * Designed for optimisation.
 */
function makeLazyGetResult(components) {
    var visitorIdCache;
    // This function runs very fast, so there is no need to make it lazy
    var confidence = getConfidence(components);
    // A plain class isn't used because its getters and setters aren't enumerable.
    return {
        get visitorId() {
            if (visitorIdCache === undefined) {
                visitorIdCache = hashComponents(this.components);
            }
            return visitorIdCache;
        },
        set visitorId(visitorId) {
            visitorIdCache = visitorId;
        },
        confidence: confidence,
        components: components,
        version: version$2,
    };
}
/**
 * A delay is required to ensure consistent entropy components.
 * See https://github.com/fingerprintjs/fingerprintjs/issues/254
 * and https://github.com/fingerprintjs/fingerprintjs/issues/307
 * and https://github.com/fingerprintjs/fingerprintjs/commit/945633e7c5f67ae38eb0fea37349712f0e669b18
 */
function prepareForSources(delayFallback) {
    if (delayFallback === void 0) { delayFallback = 50; }
    // A proper deadline is unknown. Let it be twice the fallback timeout so that both cases have the same average time.
    return requestIdleCallbackIfAvailable(delayFallback, delayFallback * 2);
}
/**
 * The function isn't exported from the index file to not allow to call it without `load()`.
 * The hiding gives more freedom for future non-breaking updates.
 *
 * A factory function is used instead of a class to shorten the attribute names in the minified code.
 * Native private class fields could've been used, but TypeScript doesn't allow them with `"target": "es5"`.
 */
function makeAgent(getComponents, debug) {
    var creationTime = Date.now();
    return {
        get: function (options) {
            return __awaiter$1(this, void 0, void 0, function () {
                var startTime, components, result;
                return __generator$1(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            startTime = Date.now();
                            return [4 /*yield*/, getComponents()];
                        case 1:
                            components = _a.sent();
                            result = makeLazyGetResult(components);
                            if (debug || (options === null || options === void 0 ? void 0 : options.debug)) {
                                // console.log is ok here because it's under a debug clause
                                // eslint-disable-next-line no-console
                                console.log("Copy the text below to get the debug data:\n\n```\nversion: ".concat(result.version, "\nuserAgent: ").concat(navigator.userAgent, "\ntimeBetweenLoadAndGet: ").concat(startTime - creationTime, "\nvisitorId: ").concat(result.visitorId, "\ncomponents: ").concat(componentsToDebugString(components), "\n```"));
                            }
                            return [2 /*return*/, result];
                    }
                });
            });
        },
    };
}
/**
 * Sends an unpersonalized AJAX request to collect installation statistics
 */
function monitor() {
    // The FingerprintJS CDN (https://github.com/fingerprintjs/cdn) replaces `window.__fpjs_d_m` with `true`
    if (window.__fpjs_d_m || Math.random() >= 0.001) {
        return;
    }
    try {
        var request = new XMLHttpRequest();
        request.open('get', "https://m1.openfpcdn.io/fingerprintjs/v".concat(version$2, "/npm-monitoring"), true);
        request.send();
    }
    catch (error) {
        // console.error is ok here because it's an unexpected error handler
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
/**
 * Builds an instance of Agent and waits a delay required for a proper operation.
 */
function load(_a) {
    var _b = _a === void 0 ? {} : _a, delayFallback = _b.delayFallback, debug = _b.debug, _c = _b.monitoring, monitoring = _c === void 0 ? true : _c;
    return __awaiter$1(this, void 0, void 0, function () {
        var getComponents;
        return __generator$1(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (monitoring) {
                        monitor();
                    }
                    return [4 /*yield*/, prepareForSources(delayFallback)];
                case 1:
                    _d.sent();
                    getComponents = loadBuiltinSources({ debug: debug });
                    return [2 /*return*/, makeAgent(getComponents, debug)];
            }
        });
    });
}

// The default export is a syntax sugar (`import * as FP from '...' → import FP from '...'`).
// It should contain all the public exported values.
var index = { load: load, hashComponents: hashComponents, componentsToDebugString: componentsToDebugString };

function getUniqueVisitorId() {
  return _getUniqueVisitorId.apply(this, arguments);
}
function _getUniqueVisitorId() {
  _getUniqueVisitorId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var fingerprintPromise, _yield$fingerprintPro, visitorId;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return index.load();
        case 1:
          fingerprintPromise = _context.v;
          _context.n = 2;
          return fingerprintPromise.get();
        case 2:
          _yield$fingerprintPro = _context.v;
          visitorId = _yield$fingerprintPro.visitorId;
          if (!visitorId) {
            _context.n = 3;
            break;
          }
          console.log("unique identifier generated: ", visitorId);
          return _context.a(2, Promise.resolve(visitorId));
        case 3:
          return _context.a(2, Promise.reject("Unable to generate unique identifier."));
        case 4:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _getUniqueVisitorId.apply(this, arguments);
}
function convertHoursToMS(hour) {
  var hoursMs = hour * 60 * 60 * 1000;
  return hoursMs;
}
function getTimeExpiryByHour(hour) {
  var today = new Date();
  var hourMs = convertHoursToMS(hour);
  return today.getTime() + hourMs;
}
function getBase64EncodeFromKey() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Will";
  return key && btoa(key);
}
function getBase64DecodeFromKey() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return key && atob(key);
}
function stripTags(value) {
  if (value) {
    return value.replace(/(<([^>]+)>)/gi, "").replace(/(?:&nbsp;)+/g, " ").trim();
  } else {
    return '';
  }
}
function generateUUID() {
  var _this = this;
  var dt = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    _newArrowCheck(this, _this);
    var r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === "x" ? r : r & 0x3 | 0x8).toString(16);
  }.bind(this));
  return uuid;
}
function getStanzaItemId() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var stanza = item.stanza;
  return stanza ? "item-".concat(stanza.id) : "item-".concat(generateUUID());
}
function getMamIdFromXML(xmlRawStanza) {
  var xmlElement = new DOMParser().parseFromString(xmlRawStanza, "text/xml");
  var resultElement = xmlElement.getElementsByTagName('result')[0];
  // if mam query result
  if (resultElement) {
    return resultElement.getAttribute("id");
  } else {
    // message exchanges
    var stanzaElement = xmlElement.getElementsByTagName('stanza-id')[0];
    return stanzaElement ? stanzaElement.getAttribute("id") : "";
  }
}
function getPreviousDateByDays() {
  var daysLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var date = arguments.length > 1 ? arguments[1] : undefined;
  var today = date ? new Date(date) : new Date();
  today.setDate(today.getDate() - daysLimit);
  return new Date(today).toISOString();
}
function getReplacedNewlineContentWithBr(content) {
  return content && content.replaceAll('\n', '<br/>');
}
function getSortedArray(unsortedArr, itemKey) {
  var _this2 = this;
  var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    isDescending: false,
    isNumberSort: true
  };
  var isDescending = methods.isDescending,
    isNumberSort = methods.isNumberSort;
  var sortedArr = [];
  if (isNumberSort) {
    sortedArr = _toConsumableArray(unsortedArr).sort(function (prevItem, nextItem) {
      _newArrowCheck(this, _this2);
      var prevItemTimeMilliSec = new Date(prevItem.timestamp).getTime();
      var nextItemTimeMilliSec = new Date(nextItem.timestamp).getTime();
      if (isDescending) {
        return nextItemTimeMilliSec - prevItemTimeMilliSec;
      } else {
        return prevItemTimeMilliSec - nextItemTimeMilliSec;
      }
    }.bind(this));
  } else {
    sortedArr = _toConsumableArray(unsortedArr).sort(function (prevItem, nextItem) {
      _newArrowCheck(this, _this2);
      var prevItemVal = String(prevItem[itemKey]).toLocaleLowerCase();
      var nextItemVal = String(nextItem[itemKey]).toLocaleLowerCase();
      if (prevItemVal < nextItemVal) {
        return -1;
      }
      if (prevItemVal > nextItemVal) {
        return 1;
      }
      // names must be equal
      return 0;
    }.bind(this));
  }
  return sortedArr;
}
function getChosenOptionsPayload() {
  var _optionPayload$layout;
  var optionPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var selectedOption = arguments.length > 1 ? arguments[1] : undefined;
  var _selectedOption$conte = _slicedToArray(selectedOption.content, 1),
    optionItem = _selectedOption$conte[0];
  var payload = _objectSpread2({}, optionItem);
  var selectionMode = ((_optionPayload$layout = optionPayload.layout) === null || _optionPayload$layout === void 0 ? void 0 : _optionPayload$layout.selectionMode) || "button";
  if (selectionMode !== "input") {
    payload.selectedChoices = [selectedOption.command];
  }
  // Analyze 'interaction' field data
  /* Interaction & { adamActions?: [] } */
  var interaction = selectedOption.interaction;
  return _objectSpread2(_objectSpread2({}, payload), {}, {
    content: interaction.content
  });
}
function getCorrectedSingleChoicePayload() {
  var optionPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var selectedOption = arguments.length > 1 ? arguments[1] : undefined;
  var command = selectedOption.command;
  var payload = getChosenOptionsPayload(optionPayload, selectedOption);
  var type = "chat_dynamic";
  var action = "chat_dynamic";
  var subject = "dynamic";
  // intercept restart node from the conversation
  if (command === "command.restart") {
    type = "chat_text";
    action = "chat_text";
    subject = "text";
  }
  return {
    language: "it",
    // type: "chat_dynamic", // messageType as MonkMessage['type'],
    // action: "chat_dynamic", // interaction.action,
    // @ts-ignore
    type: type,
    action: action,
    subject: subject,
    payload: payload
  };
}
function getCorrectedMultipleChoicePayload() {
  var _this3 = this;
  var optionPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var selectionMode = optionPayload.layout && optionPayload.layout.selectionMode ? optionPayload.layout.selectionMode : "button";
  var action = selectionMode === "input" ? optionPayload.inputData && optionPayload.inputData.interaction ? optionPayload.inputData.interaction.action : "chat_dynamic" : selectedOptions[0].interaction.action;
  return {
    language: "it",
    type: "chat_dynamic",
    action: action,
    payload: {
      selectedChoices: selectedOptions.flatMap(function (item) {
        _newArrowCheck(this, _this3);
        return item.command;
      }.bind(this)),
      content: selectedOptions.flatMap(function (item) {
        _newArrowCheck(this, _this3);
        return item.content;
      }.bind(this))
    }
  };
}

var adam_action = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(adam_action);

var chat_text = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_text);

var chat_date = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_date);

var chat_html = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_html);

var chat_image = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_image);

var chat_audio = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_audio);

var chat_video = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_video);

var chat_file = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_file);

var chat_location = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_location);

var chat_contact = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_contact);

var chat_sticker = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_sticker);

var chat_generic = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_generic);

var chat_interactive = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_interactive);

var interactions = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(interactions);

var chat_dynamic = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(interactions, exports);

});

unwrapExports(chat_dynamic);

var chat_notice = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(chat_notice);

var adam_service = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(adam_service);

var messages = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(chat_text, exports);
__exportStar(chat_date, exports);
__exportStar(chat_html, exports);
__exportStar(chat_image, exports);
__exportStar(chat_audio, exports);
__exportStar(chat_video, exports);
__exportStar(chat_file, exports);
__exportStar(chat_location, exports);
__exportStar(chat_contact, exports);
__exportStar(chat_sticker, exports);
__exportStar(chat_generic, exports);
__exportStar(chat_interactive, exports);
__exportStar(chat_dynamic, exports);
__exportStar(chat_notice, exports);
__exportStar(adam_service, exports);

});

unwrapExports(messages);

var text = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(text);

var file = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(file);

var audio = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(audio);

var video = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(video);

var image = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(image);

var html$1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(html$1);

var notice = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(notice);

var dynamic = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(dynamic);

var location_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(location_1);

var adam_service$1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(adam_service$1);

var EIMe2 = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(text, exports);
__exportStar(file, exports);
__exportStar(audio, exports);
__exportStar(video, exports);
__exportStar(image, exports);
__exportStar(html$1, exports);
__exportStar(notice, exports);
__exportStar(dynamic, exports);
__exportStar(location_1, exports);
__exportStar(adam_service$1, exports);

});

unwrapExports(EIMe2);

var base = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(base);

var build = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(adam_action, exports);
__exportStar(messages, exports);
__exportStar(chat_dynamic, exports);
__exportStar(EIMe2, exports);
__exportStar(base, exports);

});

unwrapExports(build);

var defaultMonkClientOptions = {
  defaultMonkLanguage: "it"
};
var EIMeV2Plugin = /*#__PURE__*/function (_Huangcha) {
  function EIMeV2Plugin(host, connectionOptions, clientOptions) {
    var _this2 = this;
    var _this;
    _classCallCheck(this, EIMeV2Plugin);
    _this = _callSuper(this, EIMeV2Plugin, [host, connectionOptions, clientOptions]);
    _this.monkMessages$ = _this.messages$.pipe(filter$1(function (msg) {
      _newArrowCheck(this, _this2);
      return msg.body !== undefined;
    }.bind(this)), map$1(_this.parseMonkMessage), catchError$1(function (err, obs) {
      _newArrowCheck(this, _this2);
      console.error("Error parsing message: ".concat(err.message));
      return obs;
    }.bind(this)));
    // we need the iq$ observable
    // so we can subscrive iq result after mam query
    _this.monkIqs$ = _this.iqs$;
    _this.clientOptions = _objectSpread2(_objectSpread2({}, defaultMonkClientOptions), _this.clientOptions);
    return _this;
  }
  _inherits(EIMeV2Plugin, _Huangcha);
  return _createClass(EIMeV2Plugin, [{
    key: "parseMonkMessage",
    value: function parseMonkMessage(chatMessage) {
      var body = chatMessage.body;
      var cleanBodyContent = new DOMParser().parseFromString(body, "text/html").body.textContent;
      var parsedXMLBodyContent = cleanBodyContent ? JSON.parse(cleanBodyContent) : {};
      var payload = parsedXMLBodyContent.hasOwnProperty("arguments") ? parsedXMLBodyContent.arguments : undefined;
      var action = parsedXMLBodyContent.action || "chat_dynamic";
      var type = parsedXMLBodyContent.type || "chat_dynamic";
      return {
        stanza: chatMessage,
        type: type,
        action: action,
        payload: payload
      };
    }
  }, {
    key: "sendMonkMessage",
    value: function sendMonkMessage(xmppData, monkMsg, options) {
      var translatedMessage = this.translateToEIMeV2Message(monkMsg, xmppData);
      var body = JSON.stringify(translatedMessage);
      var thread = translatedMessage.thread || "anonymous";
      var outgoingMsg = _objectSpread2(_objectSpread2({}, xmppData), {}, {
        body: body,
        thread: thread
      });
      console.log("outgoingMsg", outgoingMsg);
      this.sendMessage(outgoingMsg, options);
    }
  }, {
    key: "translateToEIMeV2Message",
    value: function translateToEIMeV2Message(originalMessage, xmppData) {
      var _this3 = this;
      var type = xmppData.type || originalMessage.type || "chat_dynamic";
      var thread = xmppData.thread || (originalMessage.hasOwnProperty("payload") ? originalMessage.payload.thread || originalMessage.payload.data.thread : "anonymous");
      var EIMeV2envelope = {
        subject: type.replace("chat_", ""),
        type: type,
        domain: "chat",
        identifier: originalMessage.identifier || originalMessage.id || generateUUID(),
        // to: originalMessage.to || xmppData.to,
        // action: xmppData.action || originalMessage.action || 'cmd_step',
        creation_date: originalMessage.creation_date || (originalMessage.timestamp ? new Date(originalMessage.timestamp).getTime() : Date.now()),
        thread: thread,
        arguments: originalMessage.payload || originalMessage.arguments
      };
      var fieldsToCheck = ["language", "version", "recipient", "sender", "domain", "subject"];
      fieldsToCheck.forEach(function (key) {
        _newArrowCheck(this, _this3);
        if (originalMessage.hasOwnProperty(key)) {
          Object.assign(EIMeV2envelope, _defineProperty({}, key, originalMessage[key]));
        }
      }.bind(this));
      return EIMeV2envelope;
    }
  }]);
}(main_4);

var actions$1 = {
  setupXmppConnection: function setupXmppConnection(_ref, connector) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var state, commit, dispatch, user, password, host, domain, priority, uniqueVisitorId, _state$xmppInstance$r, _state$xmppInstance, _state$xmppInstance$c, connectionOptions, clientOptions, resource, jid, xmppInstance;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            state = _ref.state, commit = _ref.commit, dispatch = _ref.dispatch;
            user = connector.user, password = connector.password, host = connector.host, domain = connector.domain, priority = connector.priority, uniqueVisitorId = connector.uniqueVisitorId;
            if (!(!user || !password)) {
              _context.n = 1;
              break;
            }
            return _context.a(2, false);
          case 1:
            /*
             * 1. CLEAN UP EXISTING CONNECTION
             */
            if (state.xmppInstance) {
              try {
                console.log("instantiating clean connection...");
                (_state$xmppInstance$r = (_state$xmppInstance = state.xmppInstance).removeAllListeners) === null || _state$xmppInstance$r === void 0 ? void 0 : _state$xmppInstance$r.call(_state$xmppInstance);
                (_state$xmppInstance$c = state.xmppInstance.connection) === null || _state$xmppInstance$c === void 0 ? void 0 : _state$xmppInstance$c.disconnect("reconnect");
              } catch (e) {
                console.warn("Error disconnecting old XMPP instance", e);
              }
              commit("xmppsetup", null);
            }
            /*
             * 2. BUILD OPTIONS
             */
            connectionOptions = {
              protocol: "wss"
            };
            clientOptions = {
              defaultMonkLanguage: "it",
              carbon: true,
              priority: priority
            }; // this checks if the user is a GUEST or not
            if (lsGet("_al")) {
              connectionOptions.mechanisms = [Strophe.SASLAnonymous];
            }
            /*
             * 3. RESOURCE HANDLING
             */
            resource = lsGet("resource"); // on first load, no resource yet on local storage
            if (!resource) {
              // TODO: get back later and see if Date.now is necessary
              // resource = `web_${uniqueVisitorId}_${Date.now()}`;
              resource = "web_".concat(uniqueVisitorId);
              // set unique identifier to local storage
              lsSet("resource", resource);
              // set resource to local storage
              localStorage.setItem("_unique_id", uniqueVisitorId);
            }
            /*
             * 4. BUILD JID
             */
            // assign 'user' to avoid UI changes
            jid = user;
            if (jid && jid.indexOf("@") === -1) {
              jid = "".concat(jid, "@").concat(domain);
            } else {
              if (!jid) {
                jid = domain;
              }
            }
            jid = "".concat(jid, "/").concat(resource);
            /*
             * 5. CREATE INSTANCE
             */
            xmppInstance = new EIMeV2Plugin(host, connectionOptions, clientOptions);
            /*
             * 6. CONNECT (await!)
             */
            _context.n = 2;
            return xmppInstance.connect(jid, password);
          case 2:
            commit("xmppsetup", xmppInstance);
            /*
             * 7. SUBSCRIBE ONCE
             */
            // dispatch subscribe to xmpp messages
            dispatch("subscribeXmppMessages", xmppInstance);
            // dispatch subscribe to xmpp iqs
            dispatch("subscribeXmppIqs", xmppInstance);
            return _context.a(2, true);
        }
      }, _callee);
    }))();
  },
  subscribeXmppMessages: function subscribeXmppMessages(_ref2, xmppInstance) {
    var _this = this;
    var commit = _ref2.commit;
    if (!xmppInstance || xmppInstance._messagesSubscribed) {
      return;
    }
    xmppInstance._messagesSubscribed = true;
    xmppInstance.monkMessages$.subscribe(function (messages) {
      _newArrowCheck(this, _this);
      // console.log("subscribed to messages...", messages);
      var body = messages.stanza.body;
      var cleanMsg = new DOMParser().parseFromString(body, "text/html").body.textContent;
      // console.log("incomingMsgBody: ", JSON.parse(cleanMsg));
      console.log("incomingMsgBody: ", JSON.stringify(JSON.parse(cleanMsg)));
      commit("retrieveMessages", messages);
    }.bind(this));
  },
  subscribeXmppIqs: function subscribeXmppIqs(_ref3, xmppInstance) {
    var _this2 = this;
    var commit = _ref3.commit;
    if (!xmppInstance || xmppInstance._iqsSubscribed) {
      return;
    }
    xmppInstance._iqsSubscribed = true;
    // subscrived to incoming/outgoing xmpp iqs
    xmppInstance.monkIqs$.subscribe(function (iqs) {
      _newArrowCheck(this, _this2);
      // console.log("subscribed to iq: ", iqs);
      var iqDoc = new DOMParser().parseFromString(iqs.rawStanza, "text/xml");
      var finElement = iqDoc.getElementsByTagName("fin")[0];
      if (finElement) {
        var rsm = new Strophe.RSM({
          xml: finElement
        });
        var finResult = {
          index: rsm.index || 0,
          count: rsm.count || 0,
          firstId: rsm.first || "",
          lastId: rsm.last || ""
        };
        console.log("finElement: ", finElement);
        // console.log("finResult: ", finResult);
        // record pagination options
        commit("setXmppMamPagination", finResult);
        // toggle shouldForceQueryArchivePagination
        commit("setShouldForceQueryArchivePagination", false);
        // toggle isXmppQueryArchive
        commit("setIsXmppQueryArchive", false);
        // toggle isXmppQueryArchivePagination
        commit("setIsXmppQueryArchivePagination", false);
      } else {
        var errorElement = iqDoc.getElementsByTagName('error')[0];
        if (errorElement) {
          console.log("Error: ", errorElement);
          // toggle shouldForceQueryArchivePagination
          commit("setShouldForceQueryArchivePagination", false);
          // toggle isXmppQueryArchive
          commit("setIsXmppQueryArchive", false);
          // toggle isXmppQueryArchivePagination
          commit("setIsXmppQueryArchivePagination", false);
        }
      }
    }.bind(this));
  },
  updateVCard: function updateVCard(_ref4, vCardInfos) {
    _ref4.commit;
  } // commit('updateVCard', vCardInfos);
  ,
  setIsXmppQueryArchivePagination: function setIsXmppQueryArchivePagination(_ref5, toggle) {
    var commit = _ref5.commit;
    commit('setIsXmppQueryArchivePagination', toggle);
  },
  setShouldForceQueryArchivePagination: function setShouldForceQueryArchivePagination(_ref6, toggle) {
    var commit = _ref6.commit;
    commit('setShouldForceQueryArchivePagination', toggle);
  },
  setIsXmppQueryArchive: function setIsXmppQueryArchive(_ref7, toggle) {
    var commit = _ref7.commit;
    commit('setIsXmppQueryArchive', toggle);
  },
  setIsXmppQueryArchiveAfter: function setIsXmppQueryArchiveAfter(_ref8, toggle) {
    var commit = _ref8.commit;
    commit('setIsXmppQueryArchiveAfter', toggle);
  },
  setXmppMamPagination: function setXmppMamPagination(_ref9, pagination) {
    var commit = _ref9.commit;
    commit('setXmppMamPagination', pagination);
  }
};

var mutations$1 = {
  xmppsetup: function xmppsetup(state, instance) {
    Vue$2.set(state, "xmppInstance", instance);
  },
  retrieveMessages: function retrieveMessages(state, messages) {
    Vue$2.set(state, "messages", messages);
  },
  updateVCard: function updateVCard(state, vcard) {
    Vue$2.set(state, "vcard", vcard);
  },
  updateRoster: function updateRoster(state, contacts) {
    Vue$2.set(state, "contacts", contacts);
  },
  setIsXmppQueryArchivePagination: function setIsXmppQueryArchivePagination(state, toggle) {
    Vue$2.set(state, "isXmppQueryArchivePagination", toggle);
  },
  setShouldForceQueryArchivePagination: function setShouldForceQueryArchivePagination(state, toggle) {
    Vue$2.set(state, "shouldForceQueryArchivePagination", toggle);
  },
  setIsXmppQueryArchive: function setIsXmppQueryArchive(state, toggle) {
    Vue$2.set(state, "isXmppQueryArchive", toggle);
  },
  setIsXmppQueryArchiveAfter: function setIsXmppQueryArchiveAfter(state, toggle) {
    Vue$2.set(state, "isXmppQueryArchiveAfter", toggle);
  },
  setXmppMamPagination: function setXmppMamPagination(state) {
    var pagination = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var mamPagination = _objectSpread2(_objectSpread2({}, state.xmppMamPagination), pagination);
    Vue$2.set(state, "xmppMamPagination", mamPagination);
  }
};

// @ts-ignore
var state$1 = {
  xmppInstance: {},
  messages: {},
  clientOptions: {
    defaultMonkLanguage: "it"
  },
  contacts: [],
  vcard: {},
  genesysErrorsMap: {
    "GENESYS_CLOSE_BY_USER#0001": "You have closed this conversation"
  },
  // flag that tells query with pagination started
  isXmppQueryArchivePagination: false,
  // flag to force query with pagination
  shouldForceQueryArchivePagination: false,
  isXmppQueryArchive: false,
  isXmppQueryArchiveAfter: false,
  xmppMamPagination: {
    index: 0,
    count: 0,
    limit: 0,
    firstId: "",
    lastId: ""
  }
};
var namespaced$1 = true;
var xmpp = {
  namespaced: namespaced$1,
  state: state$1,
  getters: getters$1,
  actions: actions$1,
  mutations: mutations$1
};

var actions$2 = {
  setCurrentContextCode: function setCurrentContextCode(_ref, contextCode) {
    var commit = _ref.commit;
    commit("_setCurrentContextCode", contextCode);
  },
  setProactivitySettingsData: function setProactivitySettingsData(_ref2, payload) {
    var commit = _ref2.commit;
    commit("_setProactivitySettingsData", payload);
  },
  addProactivitySettingsItem: function addProactivitySettingsItem(_ref3, payload) {
    var commit = _ref3.commit;
    commit("_addProactivitySettingsItem", payload);
  },
  updateProactivitySettingsItem: function updateProactivitySettingsItem(_ref4, payload) {
    var commit = _ref4.commit;
    commit("_updateProactivitySettingsItem", payload);
  },
  removeProactivitySettingsByItem: function removeProactivitySettingsByItem(_ref5, payload) {
    var commit = _ref5.commit;
    commit("_removeProactivitySettingsByItem", payload);
  },
  setProactivityExpiry: function setProactivityExpiry(_ref6, payload) {
    var commit = _ref6.commit;
    commit("_setProactivityExpiry", payload);
  },
  addProactivityExpiryItem: function addProactivityExpiryItem(_ref7, payload) {
    var commit = _ref7.commit;
    commit("_addProactivityExpiryItem", payload);
  },
  removeProactivityExpiryByItem: function removeProactivityExpiryByItem(_ref8, payload) {
    var commit = _ref8.commit;
    commit("_removeProactivityExpiryByItem", payload);
  }
};

var $find = arrayIteration.find;


var FIND = 'find';
var SKIPS_HOLES$1 = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES$1 = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return functionUncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isPossiblePrototype = function (argument) {
  return isObject$1(argument) || argument === null;
};

var $String$4 = String;
var $TypeError$a = TypeError;

var aPossiblePrototype = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$a("Can't set " + $String$4(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */





// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = functionUncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible(O);
    aPossiblePrototype(proto);
    if (!isObject$1(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$1(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) === 'RegExp');
};

var defineProperty$2 = objectDefineProperty.f;

var proxyAccessor = function (Target, Source, key) {
  key in Target || defineProperty$2(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, { setter: true });
  return objectDefineProperty.f(target, name, descriptor);
};

var SPECIES$4 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (descriptors && Constructor && !Constructor[SPECIES$4]) {
    defineBuiltInAccessor(Constructor, SPECIES$4, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;









var enforceInternalState = internalState.enforce;





var MATCH$1 = wellKnownSymbol('match');
var NativeRegExp = globalThis_1.RegExp;
var RegExpPrototype$3 = NativeRegExp.prototype;
var SyntaxError = globalThis_1.SyntaxError;
var exec$1 = functionUncurryThis(RegExpPrototype$3.exec);
var charAt$4 = functionUncurryThis(''.charAt);
var replace$3 = functionUncurryThis(''.replace);
var stringIndexOf$1 = functionUncurryThis(''.indexOf);
var stringSlice$5 = functionUncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY$1 = regexpStickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = descriptors &&
  (!CORRECT_NEW || MISSED_STICKY$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg || fails(function () {
    re2[MATCH$1] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    // eslint-disable-next-line sonar/inconsistent-function-call -- required for testing
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt$4(string, index);
    if (chr === '\\') {
      result += chr + charAt$4(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = objectCreate(null);
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt$4(string, index);
    if (chr === '\\') {
      chr += charAt$4(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        result += chr;
        // ignore non-capturing groups
        if (stringSlice$5(string, index + 1, index + 3) === '?:') {
          continue;
        }
        if (exec$1(IS_NCG, stringSlice$5(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwnProperty_1(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced_1('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = objectIsPrototypeOf(RegExpPrototype$3, this);
    var patternIsRegExp = isRegexp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || objectIsPrototypeOf(RegExpPrototype$3, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = regexpGetFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString_1(pattern);
    flags = flags === undefined ? '' : toString_1(flags);
    rawPattern = pattern;

    if (regexpUnsupportedDotAll && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf$1(flags, 's') > -1;
      if (dotAll) flags = replace$3(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY$1 && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf$1(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y$2) flags = replace$3(flags, /y/g, '');
    }

    if (regexpUnsupportedNcg) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype$3, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys$1 = getOwnPropertyNames(NativeRegExp), index$1 = 0; keys$1.length > index$1;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys$1[index$1++]);
  }

  RegExpPrototype$3.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype$3;
  defineBuiltIn(globalThis_1, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

function isXmppConnectionActive() {
  var xmppInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!xmppInstance) {
    return false;
  }
  var connection = xmppInstance.connection;
  if (connection) {
    var connected = connection.connected;
    return connected !== undefined;
  }
  return false;
}
function isContentNotEmpty(content) {
  return !!content;
}
function isChatText(type) {
  return type === "chat_text";
}
function isChatLocation(type) {
  return type === "chat_location";
}
function isChatHtml(type) {
  return type === "chat_html";
}
function isChatImage(type) {
  return type === "chat_image";
}
function isChatVideo(type) {
  return type === "chat_video";
}
function isChatAudio(type) {
  return type === "chat_audio";
}
function isChatFile(type) {
  return type === "chat_file";
}
function isChatDate(type) {
  return type === "chat_date";
}
function isChatNotice(type) {
  return type === "chat_notice";
}
function isContentUrlHasVideos(url) {
  return url.indexOf("/videos/") !== -1;
}
function isContentUrlHasAudios(url) {
  return url.indexOf("/audios/") !== -1;
}
function isContentUrlHasPictures(url) {
  return url.indexOf("/pictures/") !== -1;
}
function isUrlImage(url) {
  return /(http)?s?:?(\/\/[^"']*\.(?:png|jpg|jpeg))/g.test(url);
}
function isUrlValidated(str) {
  var parseHtml = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var pattern = new RegExp("(https?:\\/\\/)?" +
  // protocol
  "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
  // domain name
  "((\\d{1,3}\\.){3}\\d{1,3}))" +
  // OR ip (v4) address
  "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
  // port and path
  "(\\?[;&a-z\\d%_.~+=-]*)?" +
  // query string
  "(\\#[-a-z\\d_]*)?", "i"); // fragment locator
  return parseHtml ? pattern.exec(str) : !!pattern.test(str);
}
function isTypeInsertLocation(type) {
  return type === "insert_location";
}
function hasItemContentUrl(itemContent) {
  var url = itemContent.url;
  return url && isContentNotEmpty(url);
}
// START NODE METAS VALIDATIONS
function hasMetaStanza(metas) {
  return metas && metas.hasOwnProperty("stanza");
}
function hasMetaPayload(metas) {
  return metas && metas.hasOwnProperty("payload");
}
function hasMetaContent(metas) {
  return metas && metas.payload.hasOwnProperty("content");
}
function hasMetaPayloadLayout(metas) {
  return metas && metas.payload.hasOwnProperty("layout");
}
function hasMetaPayloadInputData(metas) {
  return metas && metas.payload.hasOwnProperty("inputData");
}
function hasMetaPayloadContent(metas) {
  return hasMetaPayload(metas) && hasMetaContent(metas);
}
function isStanzaDirectionIn(metas) {
  return metas && metas.stanza.direction === "in";
}
function isStanzaDirectionOut(metas) {
  return metas && metas.stanza.direction === "out";
}
function isSelectionModeInput(metas) {
  return metas.payload.layout.selectionMode === "input";
}
function isSelectionModeInputChoices(metas) {
  return !isSelectionModeInput(metas) && metas.payload.inputData.choice;
}
function isChoiceSelectionMultiple(mode) {
  return mode === "multiple";
}
function isNodeSingleChoiceList(metas) {
  if (!hasMetaPayloadLayout(metas)) {
    return false;
  }
  var selectionMode = metas.payload.layout.selectionMode;
  return !isChoiceSelectionMultiple(selectionMode) && !isSelectionModeCarouselChoices(metas);
}
function isNodeMultipleChoiceList(metas) {
  if (!hasMetaPayloadLayout(metas)) {
    return false;
  }
  var selectionMode = metas.payload.layout.selectionMode;
  return isChoiceSelectionMultiple(selectionMode) && !isSelectionModeCarouselChoices(metas);
}
function isMultipleMinMaxSelectableNotOk() {
  var selectedChoices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var minMaxParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var minSelectable = minMaxParams.minSelectable,
    maxSelectable = minMaxParams.maxSelectable;
  var minMaxOptions = _objectSpread2({}, minMaxParams);
  if (!minSelectable) {
    minMaxOptions.minSelectable = 1;
  }
  if (!maxSelectable) {
    minMaxOptions.maxSelectable = 1;
  }
  return selectedChoices.length < minMaxOptions.minSelectable || selectedChoices.length > minMaxOptions.maxSelectable;
}
/**
 * Will show autocomplete if the single choices list
 * elements length is more than the specified limit
 * @param metas
 * @param limitCount
 * @returns boolean
 */
function isChoiceSelectionModeSingleAutocomplete(metas) {
  var limitCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  if (isNodeSingleChoiceList(metas)) {
    if (!isSelectionModeInputChoices(metas)) {
      return false;
    }
    var choice = metas.payload.inputData.choice;
    if (!choice) {
      return false;
    }
    var choiceList = choice.list;
    if (!isSelectionModeHasChoices(choiceList)) {
      return false;
    }
    return choiceList.length > limitCount;
  }
  return false;
}
/**
 * Will show autocomplete for multiple if the choices list
 * elements length is more than the specified limit
 * @param metas
 * @param limitCount
 * @returns boolean
 */
function isChoiceSelectionModeMultipleAutocomplete(metas) {
  var limitCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  if (isNodeMultipleChoiceList(metas)) {
    if (!isSelectionModeInputChoices(metas)) {
      return false;
    }
    var choice = metas.payload.inputData.choice;
    if (!choice) {
      return false;
    }
    var choiceList = choice.list;
    if (!isSelectionModeHasChoices(choiceList)) {
      return false;
    }
    return choiceList.length > limitCount;
  }
  return false;
}
function isSelectionModeCarouselChoices(metas) {
  if (!isSelectionModeInputChoices(metas)) {
    return false;
  }
  var choice = metas.payload.inputData.choice;
  if (!choice) {
    return false;
  }
  var choiceList = choice.list;
  if (!isSelectionModeHasChoices(choiceList)) {
    return false;
  }
  var _choiceList = _slicedToArray(choiceList, 1),
    listItem = _choiceList[0];
  var contentItem = listItem.content;
  return isSelectionModeCarouselImage(contentItem);
}
function isSelectionModeHasChoices() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return list && list.length > 0;
}
function isSelectionModeCarouselImage() {
  var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!content) {
    return false;
  }
  var _content = _slicedToArray(content, 1),
    contentItem = _content[0];
  if (!contentItem) {
    return false;
  }
  var contentType = contentItem.type;
  return contentType === "chat_image";
}
function isBubbleStanzaOutAndModeInput(metas) {
  return isStanzaDirectionOut(metas) && isSelectionModeInput(metas);
}
function isBubbleStanzaInAndModeInput(metas) {
  return isStanzaDirectionIn(metas) && isSelectionModeInput(metas);
}
function isBubbleStanzaInAndModeInputLocation(metas) {
  var interaction = metas.payload.inputData.interaction;
  if (interaction) {
    var type = interaction.type;
    return isStanzaDirectionIn(metas) && isTypeInsertLocation(type);
  }
  return false;
}
// END NODE METAS VALIDATIONS
function isTimeExpired(expiry) {
  var today = new Date();
  return today.getTime() > expiry;
}
function isMessageAdamService(message) {
  var type = message.type,
    action = message.action;
  return type === "adam_service" && action === "adam_service";
}

var _this = this;
var getters$2 = {
  isProactivitySettingsNotEmpty: function isProactivitySettingsNotEmpty(state) {
    _newArrowCheck(this, _this);
    return state.proactivitySettings.length ? true : false;
  }.bind(this),
  isProactivityEnabled: function isProactivityEnabled(state, getters) {
    var _this2 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      _newArrowCheck(this, _this2);
      if (!contextCode) contextCode = state.currentContextCode;
      return getters.isProactivitySettingsNotEmpty && getters.hasProactivitySettingsPageByKey(contextCode) && getters.isChatbotProactive(contextCode) && !getters.isProactivityStandbyHoursExpired(contextCode);
    }.bind(this);
  }.bind(this),
  isChatbotProactive: function isChatbotProactive(state, getters) {
    var _this3 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      _newArrowCheck(this, _this3);
      if (!contextCode) contextCode = state.currentContextCode;
      return getters.hasProactivitySettingsPageByKey(contextCode) && getters.getProactivitySettingsByPage(contextCode).isChatbotProactive;
    }.bind(this);
  }.bind(this),
  isProactivityExpiryNotEmpty: function isProactivityExpiryNotEmpty(state) {
    _newArrowCheck(this, _this);
    return state.proactivityExpiry.length ? true : false;
  }.bind(this),
  isProactivityStandbyHoursExpired: function isProactivityStandbyHoursExpired(state, getters) {
    var _this4 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      _newArrowCheck(this, _this4);
      if (!contextCode) contextCode = state.currentContextCode;
      if (!getters.hasProactivityExpiryByKey(contextCode)) return false;
      var expiryTime = getters.getProactivityExpiryByPage(contextCode).expiryTime;
      return isTimeExpired(expiryTime);
    }.bind(this);
  }.bind(this),
  hasProactivityExpiryByKey: function hasProactivityExpiryByKey(state) {
    var _this5 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      var _this6 = this;
      _newArrowCheck(this, _this5);
      if (!contextCode) contextCode = state.currentContextCode;
      return state.proactivityExpiry.find(function (item) {
        _newArrowCheck(this, _this6);
        return item.contextCode === contextCode;
      }.bind(this)) !== undefined;
    }.bind(this);
  }.bind(this),
  hasProactivitySettingsPageByKey: function hasProactivitySettingsPageByKey(state) {
    var _this7 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      var _this8 = this;
      _newArrowCheck(this, _this7);
      if (!contextCode) contextCode = state.currentContextCode;
      return state.proactivitySettings.find(function (item) {
        _newArrowCheck(this, _this8);
        return item.contextCode === contextCode;
      }.bind(this)) !== undefined;
    }.bind(this);
  }.bind(this),
  getCurrentContextCode: function getCurrentContextCode(state) {
    _newArrowCheck(this, _this);
    return state.currentContextCode;
  }.bind(this),
  getProactivityExpiry: function getProactivityExpiry(state) {
    _newArrowCheck(this, _this);
    return state.proactivityExpiry;
  }.bind(this),
  getProactivitySettings: function getProactivitySettings(state) {
    _newArrowCheck(this, _this);
    return state.proactivitySettings;
  }.bind(this),
  getProactivitySettingsDefault: function getProactivitySettingsDefault(state) {
    _newArrowCheck(this, _this);
    return state.proactivitySettingsDefault;
  }.bind(this),
  getProactivityExpiryByPage: function getProactivityExpiryByPage(state) {
    var _this9 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      var _this0 = this;
      _newArrowCheck(this, _this9);
      if (!contextCode) contextCode = state.currentContextCode;
      return state.proactivityExpiry.find(function (item) {
        _newArrowCheck(this, _this0);
        return item.contextCode === contextCode;
      }.bind(this));
    }.bind(this);
  }.bind(this),
  getProactivitySettingsByPage: function getProactivitySettingsByPage(state) {
    var _this1 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      var _this10 = this;
      _newArrowCheck(this, _this1);
      if (!contextCode) contextCode = state.currentContextCode;
      return state.proactivitySettings.find(function (item) {
        _newArrowCheck(this, _this10);
        return item.contextCode === contextCode;
      }.bind(this));
    }.bind(this);
  }.bind(this),
  getProactivityMessageContent: function getProactivityMessageContent(state, getters) {
    var _this11 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      _newArrowCheck(this, _this11);
      if (!contextCode) contextCode = state.currentContextCode;
      return getters.isProactivityEnabled(contextCode) ? getters.getProactivitySettingsByPage(contextCode).proactiveBubbleMessage : state.proactivitySettingsDefault.proactiveBubbleMessage;
    }.bind(this);
  }.bind(this),
  getProactivityMessageTimeout: function getProactivityMessageTimeout(state, getters) {
    var _this12 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      _newArrowCheck(this, _this12);
      if (!contextCode) contextCode = state.currentContextCode;
      return getters.isProactivityEnabled(contextCode) ? getters.getProactivitySettingsByPage(contextCode).proactivePromptTimeout : state.proactivitySettingsDefault.proactivePromptTimeout;
    }.bind(this);
  }.bind(this),
  getProactivityChatTitle: function getProactivityChatTitle(state, getters) {
    var _this13 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      _newArrowCheck(this, _this13);
      if (!contextCode) contextCode = state.currentContextCode;
      return getters.isProactivityEnabled(contextCode) ? getters.getProactivitySettingsByPage(contextCode).proactiveChatTitle : state.proactivitySettingsDefault.proactiveChatTitle;
    }.bind(this);
  }.bind(this),
  getProactivityOpeningMessage: function getProactivityOpeningMessage(state, getters) {
    var _this14 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      _newArrowCheck(this, _this14);
      if (!contextCode) contextCode = state.currentContextCode;
      return getters.isProactivityEnabled(contextCode) ? getters.getProactivitySettingsByPage(contextCode).openingMessage : state.proactivitySettingsDefault.openingMessage;
    }.bind(this);
  }.bind(this),
  getProactivityStandbyHours: function getProactivityStandbyHours(state, getters) {
    var _this15 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      _newArrowCheck(this, _this15);
      if (!contextCode) contextCode = state.currentContextCode;
      return getters.isProactivityEnabled(contextCode) ? getters.getProactivitySettingsByPage(contextCode).proactivityStandbyHours : state.proactivitySettingsDefault.proactivityStandbyHours;
    }.bind(this);
  }.bind(this),
  getProactivityExpiryTime: function getProactivityExpiryTime(state, getters) {
    var _this16 = this;
    _newArrowCheck(this, _this);
    return function (contextCode) {
      _newArrowCheck(this, _this16);
      if (!contextCode) contextCode = state.currentContextCode;
      return getters.hasProactivityExpiryByKey(contextCode) ? getters.getProactivityExpiryByPage(contextCode).expiryTime : 0;
    }.bind(this);
  }.bind(this)
};

var $filter = arrayIteration.filter;


var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$3 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var mutations$2 = {
  _setCurrentContextCode: function _setCurrentContextCode(state, contextCode) {
    state.currentContextCode = contextCode;
  },
  _setProactivitySettingsData: function _setProactivitySettingsData(state, items) {
    state.proactivitySettings = items;
  },
  _addProactivitySettingsItem: function _addProactivitySettingsItem(state, item) {
    state.proactivitySettings.push(item);
  },
  _updateProactivitySettingsItem: function _updateProactivitySettingsItem(state, payload) {
    var _this = this;
    state.proactivitySettings = state.proactivitySettings.map(function (item) {
      _newArrowCheck(this, _this);
      // if (item.contextCode === payload.item.contextCode) {
      //   return payload.item
      // }
      return item;
    }.bind(this));
  },
  _removeProactivitySettingsByItem: function _removeProactivitySettingsByItem(state, contextCode) {
    var _this2 = this;
    state.proactivitySettings = state.proactivitySettings.filter(function (item) {
      _newArrowCheck(this, _this2);
      return item.contextCode !== contextCode;
    }.bind(this));
  },
  _setProactivityExpiry: function _setProactivityExpiry(state, items) {
    state.proactivityExpiry = items;
  },
  _addProactivityExpiryItem: function _addProactivityExpiryItem(state, item) {
    state.proactivityExpiry.push(item);
  },
  _removeProactivityExpiryByItem: function _removeProactivityExpiryByItem(state, contextCode) {
    var _this3 = this;
    state.proactivityExpiry = state.proactivityExpiry.filter(function (item) {
      _newArrowCheck(this, _this3);
      return item.contextCode !== contextCode;
    }.bind(this));
  }
};

var proactivitySettings = {
  isChatbotProactive: true,
  proactivePromptTimeout: 3000,
  proactivityStandbyHours: 24,
  proactiveChatTitle: "Supporto",
  proactiveBubbleMessage: "Serve aiuto?",
  openingMessage: "",
  switchDirectlyToHumanChat: false
};
var proactivityDefault = _objectSpread2(_objectSpread2({}, proactivitySettings), {}, {
  contextCode: "DEFAULT",
  isChatbotProactive: false
});
var state$2 = {
  currentContextCode: "DEFAULT",
  proactivitySettings: [],
  proactivitySettingsDefault: proactivityDefault,
  proactivityExpiry: []
};
var namespaced$2 = true;
var proactivity = {
  namespaced: namespaced$2,
  state: state$2,
  actions: actions$2,
  getters: getters$2,
  mutations: mutations$2
};

var actions$3 = {
  setBaseUrl: function setBaseUrl(_ref, baseUrl) {
    var commit = _ref.commit;
    commit("setBaseUrl", baseUrl);
  },
  setSttLang: function setSttLang(_ref2, language) {
    var commit = _ref2.commit;
    commit("setSttLang", language);
  },
  setIsVoiceInterfaceEnabled: function setIsVoiceInterfaceEnabled(_ref3, payload) {
    var commit = _ref3.commit;
    commit("setIsVoiceInterfaceEnabled", payload);
  },
  setIsVoiceAudioEnabled: function setIsVoiceAudioEnabled(_ref4, payload) {
    var commit = _ref4.commit;
    commit("setIsVoiceAudioEnabled", payload);
  },
  setIsMicListening: function setIsMicListening(_ref5, payload) {
    var commit = _ref5.commit;
    commit("setIsMicListening", payload);
  },
  setIsMicHasErrors: function setIsMicHasErrors(_ref6, payload) {
    var commit = _ref6.commit;
    commit("setIsMicHasErrors", payload);
  },
  setIsSTTProcessing: function setIsSTTProcessing(_ref7, payload) {
    var commit = _ref7.commit;
    commit("setIsSTTProcessing", payload);
  }
};

var _this$1 = this;
var getters$3 = {
  getVoiceInterfaceBaseUrl: function getVoiceInterfaceBaseUrl(state) {
    _newArrowCheck(this, _this$1);
    return state.baseUrl;
  }.bind(this),
  getSttLang: function getSttLang(state) {
    _newArrowCheck(this, _this$1);
    return state.sttLang;
  }.bind(this),
  isVoiceInterfaceEnabled: function isVoiceInterfaceEnabled(state) {
    _newArrowCheck(this, _this$1);
    return state.isVoiceInterfaceEnabled;
  }.bind(this),
  isVoiceAudioEnabled: function isVoiceAudioEnabled(state) {
    _newArrowCheck(this, _this$1);
    return state.isVoiceAudioEnabled;
  }.bind(this),
  isMicListening: function isMicListening(state) {
    _newArrowCheck(this, _this$1);
    return state.isMicListening;
  }.bind(this),
  isMicHasErrors: function isMicHasErrors(state) {
    _newArrowCheck(this, _this$1);
    return state.isMicHasErrors;
  }.bind(this),
  isSTTProcessing: function isSTTProcessing(state) {
    _newArrowCheck(this, _this$1);
    return state.isSTTProcessing;
  }.bind(this)
};

var mutations$3 = {
  setBaseUrl: function setBaseUrl(state, baseUrl) {
    Vue$2.set(state, "baseUrl", baseUrl);
  },
  setSttLang: function setSttLang(state, language) {
    Vue$2.set(state, "sttLang", language);
  },
  setIsVoiceInterfaceEnabled: function setIsVoiceInterfaceEnabled(state, toggle) {
    Vue$2.set(state, "isVoiceInterfaceEnabled", toggle);
  },
  setIsVoiceAudioEnabled: function setIsVoiceAudioEnabled(state, toggle) {
    Vue$2.set(state, "isVoiceAudioEnabled", toggle);
  },
  setIsMicListening: function setIsMicListening(state, toggle) {
    Vue$2.set(state, "isMicListening", toggle);
  },
  setIsMicHasErrors: function setIsMicHasErrors(state, toggle) {
    Vue$2.set(state, "isMicHasErrors", toggle);
  },
  setIsSTTProcessing: function setIsSTTProcessing(state, toggle) {
    Vue$2.set(state, "isSTTProcessing", toggle);
  }
};

var state$3 = {
  baseUrl: "https://chatbot-svil.tim.monksoftware.it",
  sttLang: "en-US",
  isVoiceInterfaceEnabled: false,
  isVoiceAudioEnabled: true,
  isMicListening: true,
  isMicHasErrors: false,
  isSTTProcessing: false
};
var namespaced$3 = true;
var voiceInterface = {
  namespaced: namespaced$3,
  state: state$3,
  actions: actions$3,
  getters: getters$3,
  mutations: mutations$3
};

Vue$2.use(vuex_common);
var store$1 = {
  state: {
    version: "1.0.1"
  },
  modules: {
    chat: chat,
    xmpp: xmpp,
    proactivity: proactivity,
    voiceInterface: voiceInterface
  }
};
var store$2 = new vuex_common.Store(store$1);

/**
  * vue-class-component v7.2.5
  * (c) 2015-present Evan You
  * @license MIT
  */

function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray$1(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return Vue$2.extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof$1(value);

  return value == null || type !== 'object' && type !== 'function';
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty$1({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof Vue$2 ? superProto.constructor : Vue$2;
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray$1(keys));
};

/** vue-property-decorator verson 8.5.1 MIT LICENSE copyright 2020 kaorun343 */
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    // @ts-ignore
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged and will be removed in an upcoming major release. Please refer to ' +
            'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.27.0';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

var core$1 = createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory();
	}
}(commonjsGlobal, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined$1) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof commonjsGlobal !== 'undefined' && commonjsGlobal.crypto) {
	        crypto = commonjsGlobal.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && typeof require === 'function') {
	        try {
	            crypto = crypto$1;
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined$1) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));
});

createCommonjsModule(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core$1);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));
});

var _this$2 = this;
Vue$2.filter("formatDate", function (value) {
  _newArrowCheck(this, _this$2);
  if (!value) return false;
  return moment(String(value)).format("DD/MM/YYYY");
}.bind(this));
Vue$2.filter("getTime", function (value) {
  _newArrowCheck(this, _this$2);
  if (!value) return false;
  return moment(String(value)).format("HH:mm");
}.bind(this));
Vue$2.filter("getDateSeparator", function (value) {
  _newArrowCheck(this, _this$2);
  if (!value) return false;
  var str = "";
  var momentizedDate = moment(value.split("T")[0]);
  var diff = moment().diff(momentizedDate, "days");
  if (diff === 0) {
    str = "OGGI";
  } else if (diff === 1) {
    str = "IERI";
  } else if (diff > 1) {
    str = moment(String(value)).format("DD/MM/YYYY");
  }
  return str;
}.bind(this));
Vue$2.filter("ellipsedFileName", function (str) {
  _newArrowCheck(this, _this$2);
  if (!str) return "File";
  var maxLength = 15;
  return str.length <= maxLength ? str : str.indexOf("://") !== -1 ? "".concat(str.split("://")[1].substr(0, maxLength), "...").concat(str.substr(-5)) : "".concat(str.substr(0, maxLength), "...").concat(str.substr(-5));
}.bind(this));

/*!
 * vue-i18n v8.22.3 
 * (c) 2021 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * constants
 */

var numberFormatKeys = [
  'compactDisplay',
  'currency',
  'currencyDisplay',
  'currencySign',
  'localeMatcher',
  'notation',
  'numberingSystem',
  'signDisplay',
  'style',
  'unit',
  'unitDisplay',
  'useGrouping',
  'minimumIntegerDigits',
  'minimumFractionDigits',
  'maximumFractionDigits',
  'minimumSignificantDigits',
  'maximumSignificantDigits'
];

/**
 * utilities
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.warn(err.stack);
    }
  }
}

function error (msg, err) {
  if (typeof console !== 'undefined') {
    console.error('[vue-i18n] ' + msg);
    /* istanbul ignore if */
    if (err) {
      console.error(err.stack);
    }
  }
}

var isArray$5 = Array.isArray;

function isObject$3 (obj) {
  return obj !== null && typeof obj === 'object'
}

function isBoolean (val) {
  return typeof val === 'boolean'
}

function isString (val) {
  return typeof val === 'string'
}

var toString$2 = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return toString$2.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function isFunction$2 (val) {
  return typeof val === 'function'
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject$3(args[0]) || isArray$5(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    /* istanbul ignore if */
    if (isObject$3(args[1]) || isArray$5(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

function includes$1 (arr, item) {
  return !!~arr.indexOf(item)
}

var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty$1.call(obj, key)
}

function merge$2 (target) {
  var arguments$1 = arguments;

  var output = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments$1[i];
    if (source !== undefined && source !== null) {
      var key = (void 0);
      for (key in source) {
        if (hasOwn(source, key)) {
          if (isObject$3(source[key])) {
            output[key] = merge$2(output[key], source[key]);
          } else {
            output[key] = source[key];
          }
        }
      }
    }
  }
  return output
}

function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject$3(a);
  var isObjectB = isObject$3(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = isArray$5(a);
      var isArrayB = isArray$5(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Sanitizes html special characters from input strings. For mitigating risk of XSS attacks.
 * @param rawText The raw input from the user that should be escaped.
 */
function escapeHtml(rawText) {
  return rawText
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;')
}

/**
 * Escapes html tags and special symbols from all provided params which were returned from parseArgs().params.
 * This method performs an in-place operation on the params object.
 *
 * @param {any} params Parameters as provided from `parseArgs().params`.
 *                     May be either an array of strings or a string->any map.
 *
 * @returns The manipulated `params` object.
 */
function escapeParams(params) {
  if(params != null) {
    Object.keys(params).forEach(function (key) {
      if(typeof(params[key]) == 'string') {
        params[key] = escapeHtml(params[key]);
      }
    });
  }
  return params
}

/*  */

function extend (Vue) {
  if (!Vue.prototype.hasOwnProperty('$i18n')) {
    // $FlowFixMe
    Object.defineProperty(Vue.prototype, '$i18n', {
      get: function get () { return this._i18n }
    });
  }

  Vue.prototype.$t = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this ].concat( values ))
  };

  Vue.prototype.$tc = function (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [ key, i18n.locale, i18n._getMessages(), this, choice ].concat( values ))
  };

  Vue.prototype.$te = function (key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n._getMessages(), locale)
  };

  Vue.prototype.$d = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).d.apply(ref, [ value ].concat( args ))
  };

  Vue.prototype.$n = function (value) {
    var ref;

    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];
    return (ref = this.$i18n).n.apply(ref, [ value ].concat( args ))
  };
}

/*  */

var mixin = {
  beforeCreate: function beforeCreate () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages = options.i18n && options.i18n.messages ? options.i18n.messages : {};
            options.__i18n.forEach(function (resource) {
              localeMessages = merge$2(localeMessages, JSON.parse(resource));
            });
            Object.keys(localeMessages).forEach(function (locale) {
              options.i18n.mergeLocaleMessage(locale, localeMessages[locale]);
            });
          } catch (e) {
          }
        }
        this._i18n = options.i18n;
        this._i18nWatcher = this._i18n.watchI18nData();
      } else if (isPlainObject(options.i18n)) {
        var rootI18n = this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n
          ? this.$root.$i18n
          : null;
        // component local i18n
        if (rootI18n) {
          options.i18n.root = this.$root;
          options.i18n.formatter = rootI18n.formatter;
          options.i18n.fallbackLocale = rootI18n.fallbackLocale;
          options.i18n.formatFallbackMessages = rootI18n.formatFallbackMessages;
          options.i18n.silentTranslationWarn = rootI18n.silentTranslationWarn;
          options.i18n.silentFallbackWarn = rootI18n.silentFallbackWarn;
          options.i18n.pluralizationRules = rootI18n.pluralizationRules;
          options.i18n.preserveDirectiveContent = rootI18n.preserveDirectiveContent;
        }

        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            var localeMessages$1 = options.i18n && options.i18n.messages ? options.i18n.messages : {};
            options.__i18n.forEach(function (resource) {
              localeMessages$1 = merge$2(localeMessages$1, JSON.parse(resource));
            });
            options.i18n.messages = localeMessages$1;
          } catch (e) {
          }
        }

        var ref = options.i18n;
        var sharedMessages = ref.sharedMessages;
        if (sharedMessages && isPlainObject(sharedMessages)) {
          options.i18n.messages = merge$2(options.i18n.messages, sharedMessages);
        }

        this._i18n = new VueI18n(options.i18n);
        this._i18nWatcher = this._i18n.watchI18nData();

        if (options.i18n.sync === undefined || !!options.i18n.sync) {
          this._localeWatcher = this.$i18n.watchLocale();
        }

        if (rootI18n) {
          rootI18n.onComponentInstanceCreated(this._i18n);
        }
      } else ;
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      // parent i18n
      this._i18n = options.parent.$i18n;
    }
  },

  beforeMount: function beforeMount () {
    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        // init locale messages via custom blocks
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else if (isPlainObject(options.i18n)) {
        this._i18n.subscribeDataChanging(this);
        this._subscribing = true;
      } else ;
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    } else if (options.parent && options.parent.$i18n && options.parent.$i18n instanceof VueI18n) {
      this._i18n.subscribeDataChanging(this);
      this._subscribing = true;
    }
  },

  beforeDestroy: function beforeDestroy () {
    if (!this._i18n) { return }

    var self = this;
    this.$nextTick(function () {
      if (self._subscribing) {
        self._i18n.unsubscribeDataChanging(self);
        delete self._subscribing;
      }

      if (self._i18nWatcher) {
        self._i18nWatcher();
        self._i18n.destroyVM();
        delete self._i18nWatcher;
      }

      if (self._localeWatcher) {
        self._localeWatcher();
        delete self._localeWatcher;
      }
    });
  }
};

/*  */

var interpolationComponent = {
  name: 'i18n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    path: {
      type: String,
      required: true
    },
    locale: {
      type: String
    },
    places: {
      type: [Array, Object]
    }
  },
  render: function render (h, ref) {
    var data = ref.data;
    var parent = ref.parent;
    var props = ref.props;
    var slots = ref.slots;

    var $i18n = parent.$i18n;
    if (!$i18n) {
      return
    }

    var path = props.path;
    var locale = props.locale;
    var places = props.places;
    var params = slots();
    var children = $i18n.i(
      path,
      locale,
      onlyHasDefaultPlace(params) || places
        ? useLegacyPlaces(params.default, places)
        : params
    );

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag ? h(tag, data, children) : children
  }
};

function onlyHasDefaultPlace (params) {
  var prop;
  for (prop in params) {
    if (prop !== 'default') { return false }
  }
  return Boolean(prop)
}

function useLegacyPlaces (children, places) {
  var params = places ? createParamsFromPlaces(places) : {};

  if (!children) { return params }

  // Filter empty text nodes
  children = children.filter(function (child) {
    return child.tag || child.text.trim() !== ''
  });

  var everyPlace = children.every(vnodeHasPlaceAttribute);

  return children.reduce(
    everyPlace ? assignChildPlace : assignChildIndex,
    params
  )
}

function createParamsFromPlaces (places) {

  return Array.isArray(places)
    ? places.reduce(assignChildIndex, {})
    : Object.assign({}, places)
}

function assignChildPlace (params, child) {
  if (child.data && child.data.attrs && child.data.attrs.place) {
    params[child.data.attrs.place] = child;
  }
  return params
}

function assignChildIndex (params, child, index) {
  params[index] = child;
  return params
}

function vnodeHasPlaceAttribute (vnode) {
  return Boolean(vnode.data && vnode.data.attrs && vnode.data.attrs.place)
}

/*  */

var numberComponent = {
  name: 'i18n-n',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    },
    locale: {
      type: String
    }
  },
  render: function render (h, ref) {
    var props = ref.props;
    var parent = ref.parent;
    var data = ref.data;

    var i18n = parent.$i18n;

    if (!i18n) {
      return null
    }

    var key = null;
    var options = null;

    if (isString(props.format)) {
      key = props.format;
    } else if (isObject$3(props.format)) {
      if (props.format.key) {
        key = props.format.key;
      }

      // Filter out number format options only
      options = Object.keys(props.format).reduce(function (acc, prop) {
        var obj;

        if (includes$1(numberFormatKeys, prop)) {
          return Object.assign({}, acc, ( obj = {}, obj[prop] = props.format[prop], obj ))
        }
        return acc
      }, null);
    }

    var locale = props.locale || i18n.locale;
    var parts = i18n._ntp(props.value, locale, key, options);

    var values = parts.map(function (part, index) {
      var obj;

      var slot = data.scopedSlots && data.scopedSlots[part.type];
      return slot ? slot(( obj = {}, obj[part.type] = part.value, obj.index = index, obj.parts = parts, obj )) : part.value
    });

    var tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span';
    return tag
      ? h(tag, {
        attrs: data.attrs,
        'class': data['class'],
        staticClass: data.staticClass
      }, values)
      : values
  }
};

/*  */

function bind$2 (el, binding, vnode) {
  if (!assert(el, vnode)) { return }

  t(el, binding, vnode);
}

function update$1 (el, binding, vnode, oldVNode) {
  if (!assert(el, vnode)) { return }

  var i18n = vnode.context.$i18n;
  if (localeEqual(el, vnode) &&
    (looseEqual(binding.value, binding.oldValue) &&
     looseEqual(el._localeMessage, i18n.getLocaleMessage(i18n.locale)))) { return }

  t(el, binding, vnode);
}

function unbind (el, binding, vnode, oldVNode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return
  }

  var i18n = vnode.context.$i18n || {};
  if (!binding.modifiers.preserve && !i18n.preserveDirectiveContent) {
    el.textContent = '';
  }
  el._vt = undefined;
  delete el['_vt'];
  el._locale = undefined;
  delete el['_locale'];
  el._localeMessage = undefined;
  delete el['_localeMessage'];
}

function assert (el, vnode) {
  var vm = vnode.context;
  if (!vm) {
    warn('Vue instance does not exists in VNode context');
    return false
  }

  if (!vm.$i18n) {
    warn('VueI18n instance does not exists in Vue instance');
    return false
  }

  return true
}

function localeEqual (el, vnode) {
  var vm = vnode.context;
  return el._locale === vm.$i18n.locale
}

function t (el, binding, vnode) {
  var ref$1, ref$2;

  var value = binding.value;

  var ref = parseValue(value);
  var path = ref.path;
  var locale = ref.locale;
  var args = ref.args;
  var choice = ref.choice;
  if (!path && !locale && !args) {
    warn('value type not supported');
    return
  }

  if (!path) {
    warn('`path` is required in v-t directive');
    return
  }

  var vm = vnode.context;
  if (choice != null) {
    el._vt = el.textContent = (ref$1 = vm.$i18n).tc.apply(ref$1, [ path, choice ].concat( makeParams(locale, args) ));
  } else {
    el._vt = el.textContent = (ref$2 = vm.$i18n).t.apply(ref$2, [ path ].concat( makeParams(locale, args) ));
  }
  el._locale = vm.$i18n.locale;
  el._localeMessage = vm.$i18n.getLocaleMessage(vm.$i18n.locale);
}

function parseValue (value) {
  var path;
  var locale;
  var args;
  var choice;

  if (isString(value)) {
    path = value;
  } else if (isPlainObject(value)) {
    path = value.path;
    locale = value.locale;
    args = value.args;
    choice = value.choice;
  }

  return { path: path, locale: locale, args: args, choice: choice }
}

function makeParams (locale, args) {
  var params = [];

  locale && params.push(locale);
  if (args && (Array.isArray(args) || isPlainObject(args))) {
    params.push(args);
  }

  return params
}

var Vue$1;

function install$2 (_Vue) {
  install$2.installed = true;

  Vue$1 = _Vue;

  (Vue$1.version && Number(Vue$1.version.split('.')[0])) || -1;

  extend(Vue$1);
  Vue$1.mixin(mixin);
  Vue$1.directive('t', { bind: bind$2, update: update$1, unbind: unbind });
  Vue$1.component(interpolationComponent.name, interpolationComponent);
  Vue$1.component(numberComponent.name, numberComponent);

  // use simple mergeStrategies to prevent i18n instance lose '__proto__'
  var strats = Vue$1.config.optionMergeStrategies;
  strats.i18n = function (parentVal, childVal) {
    return childVal === undefined
      ? parentVal
      : childVal
  };
}

/*  */

var BaseFormatter = function BaseFormatter () {
  this._caches = Object.create(null);
};

BaseFormatter.prototype.interpolate = function interpolate (message, values) {
  if (!values) {
    return [message]
  }
  var tokens = this._caches[message];
  if (!tokens) {
    tokens = parse$1(message);
    this._caches[message] = tokens;
  }
  return compile(tokens, values)
};



var RE_TOKEN_LIST_VALUE = /^(?:\d)+/;
var RE_TOKEN_NAMED_VALUE = /^(?:\w)+/;

function parse$1 (format) {
  var tokens = [];
  var position = 0;

  var text = '';
  while (position < format.length) {
    var char = format[position++];
    if (char === '{') {
      if (text) {
        tokens.push({ type: 'text', value: text });
      }

      text = '';
      var sub = '';
      char = format[position++];
      while (char !== undefined && char !== '}') {
        sub += char;
        char = format[position++];
      }
      var isClosed = char === '}';

      var type = RE_TOKEN_LIST_VALUE.test(sub)
        ? 'list'
        : isClosed && RE_TOKEN_NAMED_VALUE.test(sub)
          ? 'named'
          : 'unknown';
      tokens.push({ value: sub, type: type });
    } else if (char === '%') {
      // when found rails i18n syntax, skip text capture
      if (format[(position)] !== '{') {
        text += char;
      }
    } else {
      text += char;
    }
  }

  text && tokens.push({ type: 'text', value: text });

  return tokens
}

function compile (tokens, values) {
  var compiled = [];
  var index = 0;

  var mode = Array.isArray(values)
    ? 'list'
    : isObject$3(values)
      ? 'named'
      : 'unknown';
  if (mode === 'unknown') { return compiled }

  while (index < tokens.length) {
    var token = tokens[index];
    switch (token.type) {
      case 'text':
        compiled.push(token.value);
        break
      case 'list':
        compiled.push(values[parseInt(token.value, 10)]);
        break
      case 'named':
        if (mode === 'named') {
          compiled.push((values)[token.value]);
        }
        break
    }
    index++;
  }

  return compiled
}

/*  */

/**
 *  Path parser
 *  - Inspired:
 *    Vue.js Path parser
 */

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  return 'ident'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse$1$1 (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      if (key === undefined) { return false }
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}





var I18nPath = function I18nPath () {
  this._cache = Object.create(null);
};

/**
 * External parse that check for a cache hit first
 */
I18nPath.prototype.parsePath = function parsePath (path) {
  var hit = this._cache[path];
  if (!hit) {
    hit = parse$1$1(path);
    if (hit) {
      this._cache[path] = hit;
    }
  }
  return hit || []
};

/**
 * Get path value from path string
 */
I18nPath.prototype.getPathValue = function getPathValue (obj, path) {
  if (!isObject$3(obj)) { return null }

  var paths = this.parsePath(path);
  if (paths.length === 0) {
    return null
  } else {
    var length = paths.length;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined) {
        return null
      }
      last = value;
      i++;
    }

    return last
  }
};

/*  */



var htmlTagMatcher = /<\/?[\w\s="/.':;#-\/]+>/;
var linkKeyMatcher = /(?:@(?:\.[a-z]+)?:(?:[\w\-_|.]+|\([\w\-_|.]+\)))/g;
var linkKeyPrefixMatcher = /^@(?:\.([a-z]+))?:/;
var bracketsMatcher = /[()]/g;
var defaultModifiers = {
  'upper': function (str) { return str.toLocaleUpperCase(); },
  'lower': function (str) { return str.toLocaleLowerCase(); },
  'capitalize': function (str) { return ("" + (str.charAt(0).toLocaleUpperCase()) + (str.substr(1))); }
};

var defaultFormatter = new BaseFormatter();

var VueI18n = function VueI18n (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #290
  /* istanbul ignore if */
  if (!Vue$1 && typeof window !== 'undefined' && window.Vue) {
    install$2(window.Vue);
  }

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale === false
    ? false
    : options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  var dateTimeFormats = options.dateTimeFormats || {};
  var numberFormats = options.numberFormats || {};

  this._vm = null;
  this._formatter = options.formatter || defaultFormatter;
  this._modifiers = options.modifiers || {};
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._formatFallbackMessages = options.formatFallbackMessages === undefined
    ? false
    : !!options.formatFallbackMessages;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : options.silentTranslationWarn;
  this._silentFallbackWarn = options.silentFallbackWarn === undefined
    ? false
    : !!options.silentFallbackWarn;
  this._dateTimeFormatters = {};
  this._numberFormatters = {};
  this._path = new I18nPath();
  this._dataListeners = [];
  this._componentInstanceCreatedListener = options.componentInstanceCreatedListener || null;
  this._preserveDirectiveContent = options.preserveDirectiveContent === undefined
    ? false
    : !!options.preserveDirectiveContent;
  this.pluralizationRules = options.pluralizationRules || {};
  this._warnHtmlInMessage = options.warnHtmlInMessage || 'off';
  this._postTranslation = options.postTranslation || null;
  this._escapeParameterHtml = options.escapeParameterHtml || false;

  /**
   * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
   * @param choicesLength {number} an overall amount of available choices
   * @returns a final choice index
  */
  this.getChoiceIndex = function (choice, choicesLength) {
    var thisPrototype = Object.getPrototypeOf(this$1);
    if (thisPrototype && thisPrototype.getChoiceIndex) {
      var prototypeGetChoiceIndex = (thisPrototype.getChoiceIndex);
      return (prototypeGetChoiceIndex).call(this$1, choice, choicesLength)
    }

    // Default (old) getChoiceIndex implementation - english-compatible
    var defaultImpl = function (_choice, _choicesLength) {
      _choice = Math.abs(_choice);

      if (_choicesLength === 2) {
        return _choice
          ? _choice > 1
            ? 1
            : 0
          : 1
      }

      return _choice ? Math.min(_choice, 2) : 0
    };

    if (this$1.locale in this$1.pluralizationRules) {
      return this$1.pluralizationRules[this$1.locale].apply(this$1, [choice, choicesLength])
    } else {
      return defaultImpl(choice, choicesLength)
    }
  };


  this._exist = function (message, key) {
    if (!message || !key) { return false }
    if (!isNull(this$1._path.getPathValue(message, key))) { return true }
    // fallback for flat key
    if (message[key]) { return true }
    return false
  };

  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }

  this._initVM({
    locale: locale,
    fallbackLocale: fallbackLocale,
    messages: messages,
    dateTimeFormats: dateTimeFormats,
    numberFormats: numberFormats
  });
};

var prototypeAccessors$2 = { vm: { configurable: true },messages: { configurable: true },dateTimeFormats: { configurable: true },numberFormats: { configurable: true },availableLocales: { configurable: true },locale: { configurable: true },fallbackLocale: { configurable: true },formatFallbackMessages: { configurable: true },missing: { configurable: true },formatter: { configurable: true },silentTranslationWarn: { configurable: true },silentFallbackWarn: { configurable: true },preserveDirectiveContent: { configurable: true },warnHtmlInMessage: { configurable: true },postTranslation: { configurable: true } };

VueI18n.prototype._checkLocaleMessage = function _checkLocaleMessage (locale, level, message) {
  var paths = [];

  var fn = function (level, locale, message, paths) {
    if (isPlainObject(message)) {
      Object.keys(message).forEach(function (key) {
        var val = message[key];
        if (isPlainObject(val)) {
          paths.push(key);
          paths.push('.');
          fn(level, locale, val, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(key);
          fn(level, locale, val, paths);
          paths.pop();
        }
      });
    } else if (isArray$5(message)) {
      message.forEach(function (item, index) {
        if (isPlainObject(item)) {
          paths.push(("[" + index + "]"));
          paths.push('.');
          fn(level, locale, item, paths);
          paths.pop();
          paths.pop();
        } else {
          paths.push(("[" + index + "]"));
          fn(level, locale, item, paths);
          paths.pop();
        }
      });
    } else if (isString(message)) {
      var ret = htmlTagMatcher.test(message);
      if (ret) {
        var msg = "Detected HTML in message '" + message + "' of keypath '" + (paths.join('')) + "' at '" + locale + "'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";
        if (level === 'warn') {
          warn(msg);
        } else if (level === 'error') {
          error(msg);
        }
      }
    }
  };

  fn(level, locale, message, paths);
};

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue$1.config.silent;
  Vue$1.config.silent = true;
  this._vm = new Vue$1({ data: data });
  Vue$1.config.silent = silent;
};

VueI18n.prototype.destroyVM = function destroyVM () {
  this._vm.$destroy();
};

VueI18n.prototype.subscribeDataChanging = function subscribeDataChanging (vm) {
  this._dataListeners.push(vm);
};

VueI18n.prototype.unsubscribeDataChanging = function unsubscribeDataChanging (vm) {
  remove(this._dataListeners, vm);
};

VueI18n.prototype.watchI18nData = function watchI18nData () {
  var self = this;
  return this._vm.$watch('$data', function () {
    var i = self._dataListeners.length;
    while (i--) {
      Vue$1.nextTick(function () {
        self._dataListeners[i] && self._dataListeners[i].$forceUpdate();
      });
    }
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale () {
  /* istanbul ignore if */
  if (!this._sync || !this._root) { return null }
  var target = this._vm;
  return this._root.$i18n.vm.$watch('locale', function (val) {
    target.$set(target, 'locale', val);
    target.$forceUpdate();
  }, { immediate: true })
};

VueI18n.prototype.onComponentInstanceCreated = function onComponentInstanceCreated (newI18n) {
  if (this._componentInstanceCreatedListener) {
    this._componentInstanceCreatedListener(newI18n, this);
  }
};

prototypeAccessors$2.vm.get = function () { return this._vm };

prototypeAccessors$2.messages.get = function () { return looseClone(this._getMessages()) };
prototypeAccessors$2.dateTimeFormats.get = function () { return looseClone(this._getDateTimeFormats()) };
prototypeAccessors$2.numberFormats.get = function () { return looseClone(this._getNumberFormats()) };
prototypeAccessors$2.availableLocales.get = function () { return Object.keys(this.messages).sort() };

prototypeAccessors$2.locale.get = function () { return this._vm.locale };
prototypeAccessors$2.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors$2.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors$2.fallbackLocale.set = function (locale) {
  this._localeChainCache = {};
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors$2.formatFallbackMessages.get = function () { return this._formatFallbackMessages };
prototypeAccessors$2.formatFallbackMessages.set = function (fallback) { this._formatFallbackMessages = fallback; };

prototypeAccessors$2.missing.get = function () { return this._missing };
prototypeAccessors$2.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors$2.formatter.get = function () { return this._formatter };
prototypeAccessors$2.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors$2.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors$2.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

prototypeAccessors$2.silentFallbackWarn.get = function () { return this._silentFallbackWarn };
prototypeAccessors$2.silentFallbackWarn.set = function (silent) { this._silentFallbackWarn = silent; };

prototypeAccessors$2.preserveDirectiveContent.get = function () { return this._preserveDirectiveContent };
prototypeAccessors$2.preserveDirectiveContent.set = function (preserve) { this._preserveDirectiveContent = preserve; };

prototypeAccessors$2.warnHtmlInMessage.get = function () { return this._warnHtmlInMessage };
prototypeAccessors$2.warnHtmlInMessage.set = function (level) {
    var this$1 = this;

  var orgLevel = this._warnHtmlInMessage;
  this._warnHtmlInMessage = level;
  if (orgLevel !== level && (level === 'warn' || level === 'error')) {
    var messages = this._getMessages();
    Object.keys(messages).forEach(function (locale) {
      this$1._checkLocaleMessage(locale, this$1._warnHtmlInMessage, messages[locale]);
    });
  }
};

prototypeAccessors$2.postTranslation.get = function () { return this._postTranslation };
prototypeAccessors$2.postTranslation.set = function (handler) { this._postTranslation = handler; };

VueI18n.prototype._getMessages = function _getMessages () { return this._vm.messages };
VueI18n.prototype._getDateTimeFormats = function _getDateTimeFormats () { return this._vm.dateTimeFormats };
VueI18n.prototype._getNumberFormats = function _getNumberFormats () { return this._vm.numberFormats };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm, values, interpolateMode) {
  if (!isNull(result)) { return result }
  if (this._missing) {
    var missingRet = this._missing.apply(null, [locale, key, vm, values]);
    if (isString(missingRet)) {
      return missingRet
    }
  }

  if (this._formatFallbackMessages) {
    var parsedArgs = parseArgs.apply(void 0, values);
    return this._render(key, interpolateMode, parsedArgs.params, key)
  } else {
    return key
  }
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._isSilentFallbackWarn = function _isSilentFallbackWarn (key) {
  return this._silentFallbackWarn instanceof RegExp
    ? this._silentFallbackWarn.test(key)
    : this._silentFallbackWarn
};

VueI18n.prototype._isSilentFallback = function _isSilentFallback (locale, key) {
  return this._isSilentFallbackWarn(key) && (this._isFallbackRoot() || locale !== this.fallbackLocale)
};

VueI18n.prototype._isSilentTranslationWarn = function _isSilentTranslationWarn (key) {
  return this._silentTranslationWarn instanceof RegExp
    ? this._silentTranslationWarn.test(key)
    : this._silentTranslationWarn
};

VueI18n.prototype._interpolate = function _interpolate (
  locale,
  message,
  key,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  if (!message) { return null }

  var pathRet = this._path.getPathValue(message, key);
  if (isArray$5(pathRet) || isPlainObject(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    /* istanbul ignore else */
    if (isPlainObject(message)) {
      ret = message[key];
      if (!(isString(ret) || isFunction$2(ret))) {
        return null
      }
    } else {
      return null
    }
  } else {
    /* istanbul ignore else */
    if (isString(pathRet) || isFunction$2(pathRet)) {
      ret = pathRet;
    } else {
      return null
    }
  }

  // Check for the existence of links within the translated string
  if (isString(ret) && (ret.indexOf('@:') >= 0 || ret.indexOf('@.') >= 0)) {
    ret = this._link(locale, message, ret, host, 'raw', values, visitedLinkStack);
  }

  return this._render(ret, interpolateMode, values, key)
};

VueI18n.prototype._link = function _link (
  locale,
  message,
  str,
  host,
  interpolateMode,
  values,
  visitedLinkStack
) {
  var ret = str;

  // Match all the links within the local
  // We are going to replace each of
  // them with its translation
  var matches = ret.match(linkKeyMatcher);
  for (var idx in matches) {
    // ie compatible: filter custom array
    // prototype method
    if (!matches.hasOwnProperty(idx)) {
      continue
    }
    var link = matches[idx];
    var linkKeyPrefixMatches = link.match(linkKeyPrefixMatcher);
    var linkPrefix = linkKeyPrefixMatches[0];
      var formatterName = linkKeyPrefixMatches[1];

    // Remove the leading @:, @.case: and the brackets
    var linkPlaceholder = link.replace(linkPrefix, '').replace(bracketsMatcher, '');

    if (includes$1(visitedLinkStack, linkPlaceholder)) {
      return ret
    }
    visitedLinkStack.push(linkPlaceholder);

    // Translate the link
    var translated = this._interpolate(
      locale, message, linkPlaceholder, host,
      interpolateMode === 'raw' ? 'string' : interpolateMode,
      interpolateMode === 'raw' ? undefined : values,
      visitedLinkStack
    );

    if (this._isFallbackRoot(translated)) {
      /* istanbul ignore if */
      if (!this._root) { throw Error('unexpected error') }
      var root = this._root.$i18n;
      translated = root._translate(
        root._getMessages(), root.locale, root.fallbackLocale,
        linkPlaceholder, host, interpolateMode, values
      );
    }
    translated = this._warnDefault(
      locale, linkPlaceholder, translated, host,
      isArray$5(values) ? values : [values],
      interpolateMode
    );

    if (this._modifiers.hasOwnProperty(formatterName)) {
      translated = this._modifiers[formatterName](translated);
    } else if (defaultModifiers.hasOwnProperty(formatterName)) {
      translated = defaultModifiers[formatterName](translated);
    }

    visitedLinkStack.pop();

    // Replace the link with the translated
    ret = !translated ? ret : ret.replace(link, translated);
  }

  return ret
};

VueI18n.prototype._createMessageContext = function _createMessageContext (values) {
  var _list = isArray$5(values) ? values : [];
  var _named = isObject$3(values) ? values : {};
  var list = function (index) { return _list[index]; };
  var named = function (key) { return _named[key]; };
  return {
    list: list,
    named: named
  }
};

VueI18n.prototype._render = function _render (message, interpolateMode, values, path) {
  if (isFunction$2(message)) {
    return message(this._createMessageContext(values))
  }

  var ret = this._formatter.interpolate(message, values, path);

  // If the custom formatter refuses to work - apply the default one
  if (!ret) {
    ret = defaultFormatter.interpolate(message, values, path);
  }

  // if interpolateMode is **not** 'string' ('row'),
  // return the compiled data (e.g. ['foo', VNode, 'bar']) with formatter
  return interpolateMode === 'string' && !isString(ret) ? ret.join('') : ret
};

VueI18n.prototype._appendItemToChain = function _appendItemToChain (chain, item, blocks) {
  var follow = false;
  if (!includes$1(chain, item)) {
    follow = true;
    if (item) {
      follow = item[item.length - 1] !== '!';
      item = item.replace(/!/g, '');
      chain.push(item);
      if (blocks && blocks[item]) {
        follow = blocks[item];
      }
    }
  }
  return follow
};

VueI18n.prototype._appendLocaleToChain = function _appendLocaleToChain (chain, locale, blocks) {
  var follow;
  var tokens = locale.split('-');
  do {
    var item = tokens.join('-');
    follow = this._appendItemToChain(chain, item, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && (follow === true))
  return follow
};

VueI18n.prototype._appendBlockToChain = function _appendBlockToChain (chain, block, blocks) {
  var follow = true;
  for (var i = 0; (i < block.length) && (isBoolean(follow)); i++) {
    var locale = block[i];
    if (isString(locale)) {
      follow = this._appendLocaleToChain(chain, locale, blocks);
    }
  }
  return follow
};

VueI18n.prototype._getLocaleChain = function _getLocaleChain (start, fallbackLocale) {
  if (start === '') { return [] }

  if (!this._localeChainCache) {
    this._localeChainCache = {};
  }

  var chain = this._localeChainCache[start];
  if (!chain) {
    if (!fallbackLocale) {
      fallbackLocale = this.fallbackLocale;
    }
    chain = [];

    // first block defined by start
    var block = [start];

    // while any intervening block found
    while (isArray$5(block)) {
      block = this._appendBlockToChain(
        chain,
        block,
        fallbackLocale
      );
    }

    // last block defined by default
    var defaults;
    if (isArray$5(fallbackLocale)) {
      defaults = fallbackLocale;
    } else if (isObject$3(fallbackLocale)) {
      /* $FlowFixMe */
      if (fallbackLocale['default']) {
        defaults = fallbackLocale['default'];
      } else {
        defaults = null;
      }
    } else {
      defaults = fallbackLocale;
    }

    // convert defaults to array
    if (isString(defaults)) {
      block = [defaults];
    } else {
      block = defaults;
    }
    if (block) {
      this._appendBlockToChain(
        chain,
        block,
        null
      );
    }
    this._localeChainCache[start] = chain;
  }
  return chain
};

VueI18n.prototype._translate = function _translate (
  messages,
  locale,
  fallback,
  key,
  host,
  interpolateMode,
  args
) {
  var chain = this._getLocaleChain(locale, fallback);
  var res;
  for (var i = 0; i < chain.length; i++) {
    var step = chain[i];
    res =
      this._interpolate(step, messages[step], key, host, interpolateMode, args, [key]);
    if (!isNull(res)) {
      if (step !== locale && "production" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to translate the keypath '" + key + "' with '" + step + "' locale."));
      }
      return res
    }
  }
  return null
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var ref;

    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];
  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  if(this._escapeParameterHtml) {
    parsedArgs.params = escapeParams(parsedArgs.params);
  }

  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(
    messages, locale, this.fallbackLocale, key,
    host, 'string', parsedArgs.params
  );
  if (this._isFallbackRoot(ret)) {
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return (ref = this._root).$t.apply(ref, [ key ].concat( values ))
  } else {
    ret = this._warnDefault(locale, key, ret, host, values, 'string');
    if (this._postTranslation && ret !== null && ret !== undefined) {
      ret = this._postTranslation(ret, key);
    }
    return ret
  }
};

VueI18n.prototype.t = function t (key) {
    var ref;

    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];
  return (ref = this)._t.apply(ref, [ key, this.locale, this._getMessages(), null ].concat( values ))
};

VueI18n.prototype._i = function _i (key, locale, messages, host, values) {
  var ret =
    this._translate(messages, locale, this.fallbackLocale, key, host, 'raw', values);
  if (this._isFallbackRoot(ret)) {
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.i(key, locale, values)
  } else {
    return this._warnDefault(locale, key, ret, host, [values], 'raw')
  }
};

VueI18n.prototype.i = function i (key, locale, values) {
  /* istanbul ignore if */
  if (!key) { return '' }

  if (!isString(locale)) {
    locale = this.locale;
  }

  return this._i(key, locale, this._getMessages(), null, values)
};

VueI18n.prototype._tc = function _tc (
  key,
  _locale,
  messages,
  host,
  choice
) {
    var ref;

    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];
  if (!key) { return '' }
  if (choice === undefined) {
    choice = 1;
  }

  var predefined = { 'count': choice, 'n': choice };
  var parsedArgs = parseArgs.apply(void 0, values);
  parsedArgs.params = Object.assign(predefined, parsedArgs.params);
  values = parsedArgs.locale === null ? [parsedArgs.params] : [parsedArgs.locale, parsedArgs.params];
  return this.fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
};

VueI18n.prototype.fetchChoice = function fetchChoice (message, choice) {
  /* istanbul ignore if */
  if (!message || !isString(message)) { return null }
  var choices = message.split('|');

  choice = this.getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
};

VueI18n.prototype.tc = function tc (key, choice) {
    var ref;

    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];
  return (ref = this)._tc.apply(ref, [ key, this.locale, this._getMessages(), null, choice ].concat( values ))
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this._getMessages(), locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale] || {})
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, message);
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    this._checkLocaleMessage(locale, this._warnHtmlInMessage, message);
  }
  this._vm.$set(this._vm.messages, locale, merge$2({}, this._vm.messages[locale] || {}, message));
};

VueI18n.prototype.getDateTimeFormat = function getDateTimeFormat (locale) {
  return looseClone(this._vm.dateTimeFormats[locale] || {})
};

VueI18n.prototype.setDateTimeFormat = function setDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, format);
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype.mergeDateTimeFormat = function mergeDateTimeFormat (locale, format) {
  this._vm.$set(this._vm.dateTimeFormats, locale, merge$2(this._vm.dateTimeFormats[locale] || {}, format));
  this._clearDateTimeFormat(locale, format);
};

VueI18n.prototype._clearDateTimeFormat = function _clearDateTimeFormat (locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._dateTimeFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._dateTimeFormatters[id];
  }
};

VueI18n.prototype._localizeDateTime = function _localizeDateTime (
  value,
  locale,
  fallback,
  dateTimeFormats,
  key
) {
  var _locale = locale;
  var formats = dateTimeFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = dateTimeFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "production" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + step + "' datetime formats from '" + current + "' datetime formats."));
      }
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];
    var id = _locale + "__" + key;
    var formatter = this._dateTimeFormatters[id];
    if (!formatter) {
      formatter = this._dateTimeFormatters[id] = new Intl.DateTimeFormat(_locale, format);
    }
    return formatter.format(value)
  }
};

VueI18n.prototype._d = function _d (value, locale, key) {

  if (!key) {
    return new Intl.DateTimeFormat(locale).format(value)
  }

  var ret =
    this._localizeDateTime(value, locale, this.fallbackLocale, this._getDateTimeFormats(), key);
  if (this._isFallbackRoot(ret)) {
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.d(value, key, locale)
  } else {
    return ret || ''
  }
};

VueI18n.prototype.d = function d (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject$3(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._d(value, locale, key)
};

VueI18n.prototype.getNumberFormat = function getNumberFormat (locale) {
  return looseClone(this._vm.numberFormats[locale] || {})
};

VueI18n.prototype.setNumberFormat = function setNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, format);
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype.mergeNumberFormat = function mergeNumberFormat (locale, format) {
  this._vm.$set(this._vm.numberFormats, locale, merge$2(this._vm.numberFormats[locale] || {}, format));
  this._clearNumberFormat(locale, format);
};

VueI18n.prototype._clearNumberFormat = function _clearNumberFormat (locale, format) {
  for (var key in format) {
    var id = locale + "__" + key;

    if (!this._numberFormatters.hasOwnProperty(id)) {
      continue
    }

    delete this._numberFormatters[id];
  }
};

VueI18n.prototype._getNumberFormatter = function _getNumberFormatter (
  value,
  locale,
  fallback,
  numberFormats,
  key,
  options
) {
  var _locale = locale;
  var formats = numberFormats[_locale];

  var chain = this._getLocaleChain(locale, fallback);
  for (var i = 0; i < chain.length; i++) {
    var current = _locale;
    var step = chain[i];
    formats = numberFormats[step];
    _locale = step;
    // fallback locale
    if (isNull(formats) || isNull(formats[key])) {
      if (step !== locale && "production" !== 'production' && !this._isSilentTranslationWarn(key) && !this._isSilentFallbackWarn(key)) {
        warn(("Fall back to '" + step + "' number formats from '" + current + "' number formats."));
      }
    } else {
      break
    }
  }

  if (isNull(formats) || isNull(formats[key])) {
    return null
  } else {
    var format = formats[key];

    var formatter;
    if (options) {
      // If options specified - create one time number formatter
      formatter = new Intl.NumberFormat(_locale, Object.assign({}, format, options));
    } else {
      var id = _locale + "__" + key;
      formatter = this._numberFormatters[id];
      if (!formatter) {
        formatter = this._numberFormatters[id] = new Intl.NumberFormat(_locale, format);
      }
    }
    return formatter
  }
};

VueI18n.prototype._n = function _n (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    return ''
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.format(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.format(value);
  if (this._isFallbackRoot(ret)) {
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n.n(value, Object.assign({}, { key: key, locale: locale }, options))
  } else {
    return ret || ''
  }
};

VueI18n.prototype.n = function n (value) {
    var args = [], len = arguments.length - 1;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

  var locale = this.locale;
  var key = null;
  var options = null;

  if (args.length === 1) {
    if (isString(args[0])) {
      key = args[0];
    } else if (isObject$3(args[0])) {
      if (args[0].locale) {
        locale = args[0].locale;
      }
      if (args[0].key) {
        key = args[0].key;
      }

      // Filter out number format options only
      options = Object.keys(args[0]).reduce(function (acc, key) {
          var obj;

        if (includes$1(numberFormatKeys, key)) {
          return Object.assign({}, acc, ( obj = {}, obj[key] = args[0][key], obj ))
        }
        return acc
      }, null);
    }
  } else if (args.length === 2) {
    if (isString(args[0])) {
      key = args[0];
    }
    if (isString(args[1])) {
      locale = args[1];
    }
  }

  return this._n(value, locale, key, options)
};

VueI18n.prototype._ntp = function _ntp (value, locale, key, options) {
  /* istanbul ignore if */
  if (!VueI18n.availabilities.numberFormat) {
    return []
  }

  if (!key) {
    var nf = !options ? new Intl.NumberFormat(locale) : new Intl.NumberFormat(locale, options);
    return nf.formatToParts(value)
  }

  var formatter = this._getNumberFormatter(value, locale, this.fallbackLocale, this._getNumberFormats(), key, options);
  var ret = formatter && formatter.formatToParts(value);
  if (this._isFallbackRoot(ret)) {
    /* istanbul ignore if */
    if (!this._root) { throw Error('unexpected error') }
    return this._root.$i18n._ntp(value, locale, key, options)
  } else {
    return ret || []
  }
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors$2 );

var availabilities;
// $FlowFixMe
Object.defineProperty(VueI18n, 'availabilities', {
  get: function get () {
    if (!availabilities) {
      var intlDefined = typeof Intl !== 'undefined';
      availabilities = {
        dateTimeFormat: intlDefined && typeof Intl.DateTimeFormat !== 'undefined',
        numberFormat: intlDefined && typeof Intl.NumberFormat !== 'undefined'
      };
    }

    return availabilities
  }
});

VueI18n.install = install$2;
VueI18n.version = '8.22.3';

var it = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Pulisci'
    },
    datepicker: {
      now: 'Ora',
      today: 'Oggi',
      cancel: 'Cancella',
      clear: 'Pulisci',
      confirm: 'OK',
      selectDate: 'Seleziona data',
      selectTime: 'Seleziona ora',
      startDate: 'Data inizio',
      startTime: 'Ora inizio',
      endDate: 'Data fine',
      endTime: 'Ora fine',
      prevYear: 'Anno precedente',
      nextYear: 'Anno successivo',
      prevMonth: 'Mese precedente',
      nextMonth: 'Mese successivo',
      year: '',
      month1: 'Gennaio',
      month2: 'Febbraio',
      month3: 'Marzo',
      month4: 'Aprile',
      month5: 'Maggio',
      month6: 'Giugno',
      month7: 'Luglio',
      month8: 'Agosto',
      month9: 'Settembre',
      month10: 'Ottobre',
      month11: 'Novembre',
      month12: 'Dicembre',
      // week: 'settimana',
      weeks: {
        sun: 'Dom',
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thu: 'Gio',
        fri: 'Ven',
        sat: 'Sab'
      },
      months: {
        jan: 'Gen',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'Mag',
        jun: 'Giu',
        jul: 'Lug',
        aug: 'Ago',
        sep: 'Set',
        oct: 'Ott',
        nov: 'Nov',
        dec: 'Dic'
      }
    },
    select: {
      loading: 'Caricamento',
      noMatch: 'Nessuna corrispondenza',
      noData: 'Nessun dato',
      placeholder: 'Seleziona'
    },
    cascader: {
      noMatch: 'Nessuna corrispondenza',
      loading: 'Caricamento',
      placeholder: 'Seleziona',
      noData: 'Nessun dato'
    },
    pagination: {
      goto: 'Vai a',
      pagesize: '/page',
      total: 'Totale {total}',
      pageClassifier: ''
    },
    messagebox: {
      confirm: 'OK',
      cancel: 'Cancella',
      error: 'Input non valido'
    },
    upload: {
      deleteTip: 'Premi cancella per rimuovere',
      delete: 'Cancella',
      preview: 'Anteprima',
      continue: 'Continua'
    },
    table: {
      emptyText: 'Nessun dato',
      confirmFilter: 'Conferma',
      resetFilter: 'Reset',
      clearFilter: 'Tutti',
      sumText: 'Somma'
    },
    tree: {
      emptyText: 'Nessun dato'
    },
    transfer: {
      noMatch: 'Nessuna corrispondenza',
      noData: 'Nessun dato',
      titles: ['Lista 1', 'Lista 2'],
      filterPlaceholder: 'Inserisci filtro',
      noCheckedFormat: '{total} elementi',
      hasCheckedFormat: '{checked}/{total} selezionati'
    },
    image: {
      error: 'FAILED' // to be translated
    },
    pageHeader: {
      title: 'Back' // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes', // to be translated
      cancelButtonText: 'No' // to be translated
    }
  }
};
});

var langIt = unwrapExports(it);

var _this$3 = this;
Vue$2.use(VueI18n);
var messages$1 = {
  it: _objectSpread2({}, langIt)
};
var _i18n = new VueI18n({
  locale: "it",
  messages: messages$1 // set locale messages
});
Vue$2.use(Element$1, {
  i18n: function i18n(key, value) {
    _newArrowCheck(this, _this$3);
    return _i18n.t(key, value);
  }.bind(this)
});

function _initializerDefineProperty(e, i, r, l) {
  r && Object.defineProperty(e, i, {
    enumerable: r.enumerable,
    configurable: r.configurable,
    writable: r.writable,
    value: r.initializer ? r.initializer.call(l) : void 0
  });
}

function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}

var nativeJoin = functionUncurryThis([].join);

var ES3_STRINGS = indexedObject !== Object;
var FORCED$2 = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
_export({ target: 'Array', proto: true, forced: FORCED$2 }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var $Object$4 = Object;
var ObjectPrototype = $Object$4.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object$4.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$4 ? ObjectPrototype : null;
};

var $propertyIsEnumerable$1 = objectPropertyIsEnumerable.f;

var propertyIsEnumerable = functionUncurryThis($propertyIsEnumerable$1);
var push$4 = functionUncurryThis([].push);

// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-create -- safe
  var O = Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable(O, 2);
});

// `Object.{ entries, values }` methods implementation
var createMethod$4 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!descriptors || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
        push$4(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod$4(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod$4(false)
};

var $entries = objectToArray.entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
_export({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});

var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;


var FORCED$3 = !descriptors || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
_export({ target: 'Object', stat: true, forced: FORCED$3, sham: !descriptors }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});

var $TypeError$b = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError$b(tryToString(argument) + ' is not a constructor');
};

var SPECIES$5 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES$5]) ? defaultConstructor : aConstructor(S);
};

var UNSUPPORTED_Y$3 = regexpStickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$5 = Math.min;
var push$5 = functionUncurryThis([].push);
var stringSlice$6 = functionUncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' ||
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  'test'.split(/(?:)/, -1).length !== 4 ||
  'ab'.split(/(?:ab)*/).length !== 2 ||
  '.'.split(/(.?)(.?)/).length !== 4 ||
  // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  '.'.split(/()()/).length > 1 ||
  ''.split(/.?/).length;

// @@split logic
fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit = '0'.split(undefined, 0).length ? function (separator, limit) {
    return separator === undefined && limit === 0 ? [] : functionCall(nativeSplit, this, separator, limit);
  } : nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? functionCall(splitter, separator, O, limit)
        : functionCall(internalSplit, toString_1(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString_1(string);

      if (!BUGGY) {
        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
        if (res.done) return res.value;
      }

      var C = speciesConstructor(rx, RegExp);
      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y$3 ? 'g' : 'y');
      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y$3 ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y$3 ? 0 : q;
        var z = regexpExecAbstract(splitter, UNSUPPORTED_Y$3 ? stringSlice$6(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min$5(toLength(splitter.lastIndex + (UNSUPPORTED_Y$3 ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push$5(A, stringSlice$6(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$5(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$5(A, stringSlice$6(S, p));
      return A;
    }
  ];
}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y$3);

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`


var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

var $forEach = arrayIteration.forEach;


var STRICT_METHOD$1 = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$1 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
};

for (var COLLECTION_NAME in domIterables) {
  if (domIterables[COLLECTION_NAME]) {
    handlePrototype(globalThis_1[COLLECTION_NAME] && globalThis_1[COLLECTION_NAME].prototype);
  }
}

handlePrototype(domTokenListPrototype);

var Getter = createBindingHelper('computed', mapGetters$1);
var Action$1 = createBindingHelper('methods', mapActions$1);
function createBindingHelper(bindTo, mapFn) {
    function makeDecorator(map, namespace) {
        return createDecorator(function (componentOptions, key) {
            if (!componentOptions[bindTo]) {
                componentOptions[bindTo] = {};
            }
            var mapObject = (_a = {}, _a[key] = map, _a);
            componentOptions[bindTo][key] = namespace !== undefined
                ? mapFn(namespace, mapObject)[key]
                : mapFn(mapObject)[key];
            var _a;
        });
    }
    function helper(a, b) {
        if (typeof b === 'string') {
            var key = b;
            var proto = a;
            return makeDecorator(key, undefined)(proto, key);
        }
        var namespace = extractNamespace(b);
        var type = a;
        return makeDecorator(type, namespace);
    }
    return helper;
}
function extractNamespace(options) {
    var n = options && options.namespace;
    if (typeof n !== 'string') {
        return undefined;
    }
    if (n[n.length - 1] !== '/') {
        return n + '/';
    }
    return n;
}

var events = {
  XMPPLoginFailed: "XMPP_LOGIN_FAILED",
  sendMessage: "SEND_MESSAGE",
  sendMessageAction: "SEND_MESSAGE_ACTION",
  sendAttachmentMessage: "SEND_ATTACHMENT_MESSAGE",
  showLeaveDialog: "SHOW_LEAVE_DIALOG",
  attachmentUploadedResponse: "ATTACHMENT_UPLOADED_RESPONSE",
  enableMainInput: "ENABLE_MAIN_INPUT",
  userSuccessfullyConnected: "USER_SUCCESFULLY_CONNECTED",
  goBackFromConversationsList: "GO_BACK_FROM_CONVERSATIONS_LIST",
  backButtonFromConversationPressed: "BACK_BTN_FROM_CONVERSATION_EVENT",
  closeConversationEvent: "CLOSE_CONVERSATION_EVENT",
  archiveConversationEvent: "ARCHIVE_CONVERSATION_EVENT",
  sessionExpired: "XMPP_SESSION_EXPIRED",
  newUnreadMessageEvent: "NEW_UNREAD_MESSAGE_EVENT",
  resetUnreadMessagesCount: "RESET_UNREAD_MESSAGES_COUNT",
  proactiveBubbleShown: "PROACTIVE_BUBBLE_SHOWN",
  chatToggleStatus: "CHAT_TOGGLE_EVENT"
};
var EventHub = new Vue$2({
  data: function data() {
    return {
      events: events
    };
  }
});

var img = "data:image/png;base64,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";

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
var LoginProxy = (_dec = Prop(String), _dec2 = Prop(String), _dec3 = Action$1("xmpp/setup"), _dec4 = Action$1("chat/toggleLoginProxyView"), Component(_class = (_class2 = /*#__PURE__*/function (_Vue) {
  function LoginProxy() {
    var _this;
    _classCallCheck(this, LoginProxy);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, LoginProxy, [].concat(args));
    _defineProperty(_this, "credentials", {
      user: "",
      password: ""
    });
    _defineProperty(_this, "isLoggingIn", false);
    _initializerDefineProperty(_this, "xmppEndpoint", _descriptor, _this);
    _initializerDefineProperty(_this, "eimeVersion", _descriptor2, _this);
    _initializerDefineProperty(_this, "setup", _descriptor3, _this);
    _initializerDefineProperty(_this, "toggleLoginProxyView", _descriptor4, _this);
    return _this;
  }
  _inherits(LoginProxy, _Vue);
  return _createClass(LoginProxy, [{
    key: "botAvatarIcon",
    get: function get() {
      return img;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      lsSet("_al", "");
      this.credentials = Object.assign({}, this.credentials, {
        EIMeVersion: this.eimeVersion
      });
    }
  }, {
    key: "chatLogin",
    value: function () {
      var _chatLogin = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var domain;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              domain = this.credentials.user.split("@")[1];
              if (domain) {
                _context.n = 1;
                break;
              }
              this.$alert("Inserisci un username completo di dominio usando il formato <em>username@domain</em>", "Dominio non presente", {
                confirmButtonText: "OK",
                dangerouslyUseHTMLString: true
              });
              return _context.a(2, false);
            case 1:
              Object.assign(this.credentials, {
                host: this.xmppEndpoint || process.env.VUE_APP_XMPP_ENDPOINT
              });
              this.isLoggingIn = true;
              this.setup(this.credentials).then(function () {
                _newArrowCheck(this, _this2);
                lsSet("_d", domain);
                lsSet("_wcue", btoa(JSON.stringify(this.credentials)));
                this.toggleLoginProxyView(false);
              }.bind(this))["catch"](function (err) {
                _newArrowCheck(this, _this2);
                this.$alert("Si è verificato un errore. Controlla le credenziali e riprova", "Oops!");
              }.bind(this))["finally"](function () {
                _newArrowCheck(this, _this2);
                return this.isLoggingIn = false;
              }.bind(this));
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function chatLogin() {
        return _chatLogin.apply(this, arguments);
      }
      return chatLogin;
    }()
  }]);
}(Vue$2), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "xmppEndpoint", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "eimeVersion", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "setup", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "toggleLoginProxyView", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class);

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
var __vue_script__ = LoginProxy;

/* template */
var __vue_render__ = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "id": "login-proxy"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": {
        span: 20,
        offset: 2
      },
      "lg": {
        span: 8,
        offset: 8
      }
    }
  }, [_c('img', {
    staticClass: "m-bottom-2",
    attrs: {
      "src": _vm.botAvatarIcon
    }
  }), _vm._v(" "), _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "username@dominio"
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.chatLogin();
      }
    },
    model: {
      value: _vm.credentials.user,
      callback: function callback($$v) {
        _vm.$set(_vm.credentials, "user", $$v);
      },
      expression: "credentials.user"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password"
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.chatLogin();
      }
    },
    model: {
      value: _vm.credentials.password,
      callback: function callback($$v) {
        _vm.$set(_vm.credentials, "password", $$v);
      },
      expression: "credentials.password"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-button', {
    staticClass: "w-100",
    attrs: {
      "type": "primary",
      "loading": _vm.isLoggingIn
    },
    on: {
      "click": function click($event) {
        return _vm.chatLogin();
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)], 1);
};
var __vue_staticRenderFns__ = [];

/* style */
var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-ea3b4ce6_0", {
    source: ".el-message-box{width:90%;font-family:Montserrat,sans-serif}",
    map: undefined,
    media: undefined
  }), inject("data-v-ea3b4ce6_1", {
    source: "#login-proxy[data-v-ea3b4ce6]{margin-top:60px}#login-proxy img[data-v-ea3b4ce6]{max-width:75px;margin:10px 0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__ = "data-v-ea3b4ce6";
/* module identifier */
var __vue_module_identifier__ = undefined;
/* functional template */
var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

var $includes = arrayIncludes.includes;



// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var $TypeError$c = TypeError;

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw new $TypeError$c("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$2 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$2] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var stringIndexOf$2 = functionUncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$2(
      toString_1(requireObjectCoercible(this)),
      toString_1(notARegexp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var img$1 = "data:image/svg+xml,%3c!-- Generated by IcoMoon.io --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3e %3ctitle%3echat%3c/title%3e %3cpath fill='%23225080' d='M16 1.6c8.8 0 16 5.728 16 12.8s-7.2 12.8-16 12.8c-1.984 0-3.888-0.288-5.648-0.8-4.672 4-10.352 4-10.352 4 3.728-3.728 4.32-6.24 4.4-7.2-2.72-2.288-4.4-5.392-4.4-8.8 0-7.072 7.2-12.8 16-12.8z'%3e%3c/path%3e%3c/svg%3e";

var _dec$1, _dec2$1, _dec3$1, _dec4$1, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _class$1, _class2$1, _descriptor$1, _descriptor2$1, _descriptor3$1, _descriptor4$1, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27;
var ConversationsList = (_dec$1 = Component({
  filters: {
    formatDate: function formatDate(val) {
      if (!val) return "";
      return moment(val).format("DD/MM/YYYY HH:mm");
    }
  }
}), _dec2$1 = Getter("chat/messages"), _dec3$1 = Getter("chat/history"), _dec4$1 = Getter("chat/resource"), _dec5 = Getter("chat/getBackButtonLabel"), _dec6 = Getter("chat/getConversationAreaTitle"), _dec7 = Getter("chat/getActionsMenu"), _dec8 = Action$1("chat/toggleActionsMenu"), _dec9 = Getter("chat/getConversations"), _dec0 = Getter("chat/getConversationsCounter"), _dec1 = Getter("chat/getBotConfigSettings"), _dec10 = Action$1("chat/addMessageToHistory"), _dec11 = Action$1("chat/setHistory"), _dec12 = Action$1("chat/setConversationsArray"), _dec13 = Action$1("chat/setConversationsCounter"), _dec14 = Action$1("chat/setConversationsTitle"), _dec15 = Action$1("chat/setBackButtonLabel"), _dec16 = Action$1("chat/popConversation"), _dec17 = Action$1("chat/setCurrentChat"), _dec18 = Getter("xmpp/genesysErrorsMap"), _dec19 = Action$1("chat/updateConversation"), _dec20 = Action$1("chat/updateConversationClass"), _dec21 = Action$1("chat/setCurrentConversationMessages"), _dec22 = Action$1("xmpp/setShouldForceQueryArchivePagination"), _dec23 = Action$1("voiceInterface/setIsVoiceAudioEnabled"), _dec24 = Action$1("voiceInterface/setIsMicListening"), _dec25 = Prop({
  "default": true
}), _dec26 = Prop({
  "default": false
}), _dec27 = Prop({
  "default": true
}), _dec28 = Prop({
  "default": 50
}), _dec29 = Watch("getConversations"), _dec30 = Watch("history"), _dec31 = Watch("resource"), _dec$1(_class$1 = (_class2$1 = /*#__PURE__*/function (_Vue) {
  function ConversationsList() {
    var _this;
    _classCallCheck(this, ConversationsList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ConversationsList, [].concat(args));
    _initializerDefineProperty(_this, "allMessages", _descriptor$1, _this);
    _initializerDefineProperty(_this, "history", _descriptor2$1, _this);
    _initializerDefineProperty(_this, "resource", _descriptor3$1, _this);
    _initializerDefineProperty(_this, "backButtonLabel", _descriptor4$1, _this);
    _initializerDefineProperty(_this, "mainTitle", _descriptor5, _this);
    _initializerDefineProperty(_this, "actionsMenu", _descriptor6, _this);
    _initializerDefineProperty(_this, "toggleActionsMenu", _descriptor7, _this);
    _initializerDefineProperty(_this, "getConversations", _descriptor8, _this);
    _initializerDefineProperty(_this, "getConversationsCounter", _descriptor9, _this);
    _initializerDefineProperty(_this, "getBotConfigSettings", _descriptor0, _this);
    _initializerDefineProperty(_this, "addMessageToHistory", _descriptor1, _this);
    _initializerDefineProperty(_this, "setHistory", _descriptor10, _this);
    _initializerDefineProperty(_this, "setConversationsArray", _descriptor11, _this);
    _initializerDefineProperty(_this, "setConversationsCounter", _descriptor12, _this);
    _initializerDefineProperty(_this, "setConversationsTitle", _descriptor13, _this);
    _initializerDefineProperty(_this, "setBackButtonLabel", _descriptor14, _this);
    _initializerDefineProperty(_this, "popConversation", _descriptor15, _this);
    _initializerDefineProperty(_this, "setCurrentChat", _descriptor16, _this);
    _initializerDefineProperty(_this, "genesysNoticeMap", _descriptor17, _this);
    _initializerDefineProperty(_this, "updateConversation", _descriptor18, _this);
    _initializerDefineProperty(_this, "updateConversationClass", _descriptor19, _this);
    _initializerDefineProperty(_this, "setCurrentConversationMessages", _descriptor20, _this);
    _initializerDefineProperty(_this, "setShouldForceQueryArchivePagination", _descriptor21, _this);
    /** 
     * voiceInterface
     */
    _initializerDefineProperty(_this, "setIsVoiceAudioEnabled", _descriptor22, _this);
    _initializerDefineProperty(_this, "setIsMicListening", _descriptor23, _this);
    _initializerDefineProperty(_this, "allowSearchFilter", _descriptor24, _this);
    _initializerDefineProperty(_this, "showConversationList", _descriptor25, _this);
    _initializerDefineProperty(_this, "enableUnreadMessagesBadge", _descriptor26, _this);
    _initializerDefineProperty(_this, "lastMessageToDisplayTotal", _descriptor27, _this);
    _defineProperty(_this, "filter", "");
    _defineProperty(_this, "showEditDialog", false);
    _defineProperty(_this, "showArchiveDialog", false);
    _defineProperty(_this, "showDeleteDialog", false);
    _defineProperty(_this, "showArchivedCta", false);
    _defineProperty(_this, "isArchiveSection", false);
    _defineProperty(_this, "selectedChat", {
      title: "",
      thread: "",
      "class": ConversationType.Active,
      is_archived: false,
      pin_date: null
    });
    _defineProperty(_this, "selectedChatOldTitle", "");
    return _this;
  }
  _inherits(ConversationsList, _Vue);
  return _createClass(ConversationsList, [{
    key: "getLocalThread",
    get: function get() {
      return "_t";
    }
  }, {
    key: "getLocalResource",
    get: function get() {
      return "resource";
    }
  }, {
    key: "getLocalMessageTree",
    get: function get() {
      return "_lmt_".concat(this.resource);
    }
  }, {
    key: "getLocalConversationTree",
    get: function get() {
      return "_lct_".concat(this.resource);
    }
  }, {
    key: "getLocalConversationsCounter",
    get: function get() {
      return "_lcc_".concat(this.resource);
    }
  }, {
    key: "getConversationListHeading",
    get: function get() {
      return this.mainTitle || this.getLabel.heading_conversation_list;
    }
  }, {
    key: "getIconChatBubble",
    get: function get() {
      var assets = this.getBotConfigSettings.assets;
      return (assets === null || assets === void 0 ? void 0 : assets.icon_chat_bubble) || img$1;
    }
  }, {
    key: "getLabel",
    get: function get() {
      var labels = this.getBotConfigSettings.labels;
      return {
        label_ask_bot: labels === null || labels === void 0 ? void 0 : labels.label_ask_bot,
        heading_conversation_list: labels === null || labels === void 0 ? void 0 : labels.heading_conversation_list,
        heading_cases_history: labels === null || labels === void 0 ? void 0 : labels.heading_cases_history
      };
    }
  }, {
    key: "sortedConversations",
    get: function get() {
      var _this2 = this;
      // 1st, remove null items on array, sometimes there are null items
      var conversations = this.getConversations.filter(Boolean);
      // stage spoc conversation item
      var spocConversationItem = conversations.find(function (item) {
        _newArrowCheck(this, _this2);
        return item["class"] === ConversationType.Wfp;
      }.bind(this));

      // if spoc conversation is available
      if (!this.isArchiveSection && spocConversationItem) {
        conversations = conversations
        // then, temporary remove spoc item from conversation
        // dont worry, we will add them later, for now lets remove spoc out
        .filter(function (item) {
          _newArrowCheck(this, _this2);
          return item["class"] !== ConversationType.Wfp;
        }.bind(this))
        // we have to do another loop, to handle empty titles
        .map(function (item) {
          _newArrowCheck(this, _this2);
          var title = item.title;
          // in some cases, sometimes title is empty for support tickets
          if (this.isConversationHuman(item) && !title) {
            return _objectSpread2(_objectSpread2({}, item), {}, {
              // restore default title
              title: "Ticket"
            });
          }
          return item;
        }.bind(this));
      }

      // 2nd, sort with timestamp
      conversations = getSortedArray(conversations, "timestamp");
      // now, from here
      if (!this.isArchiveSection) {
        // restore spoc item conversation on the 1st element of the array
        conversations.splice(0, 0, spocConversationItem);
      }

      // console.log("sortedConversations: ", JSON.stringify(conversations));
      // NOTE: commented for removing the actions menu for conversations
      /* conversations.forEach((item: Conversation, index: number) => {
        if (item)
          this.toggleActionsMenu({
            index,
            enabled: item.class !== ConversationType.Wfp,
            active: this.actionsMenu && this.actionsMenu[index] ? this.actionsMenu[index].active : null
          });
      }); */
      return conversations;
    }
  }, {
    key: "sortedArchiveConversation",
    get: function get() {
      var _this3 = this;
      return this.sortedConversations.filter(function (conversation) {
        _newArrowCheck(this, _this3);
        return this.canShowConversationArchive(conversation);
      }.bind(this));
    }
  }, {
    key: "canShowConversationList",
    get: function get() {
      return this.sortedArchiveConversation.length > 0;
    }
  }, {
    key: "canShowChatArchive",
    get: function get() {
      return this.showArchivedCta && !this.isArchiveSection;
    }
  }, {
    key: "getConversationListHeaderClass",
    get: function get() {
      return this.isArchiveSection ? "is-archive" : "";
    }
  }, {
    key: "created",
    value: function created() {
      var _this4 = this;
      EventHub.$on(EventHub.events.backButtonFromConversationPressed, function (conversation) {
        _newArrowCheck(this, _this4);
        var is_archived = conversation.is_archived;
        if (is_archived) {
          this.isArchiveSection = true;
          this.renderArchivedConversations();
        } else {
          this.renderActiveConversations();
        }
        this.setCurrentChat({});
        // disable voice interface audio
        this.disableVoiceInterfaceAudio();
      }.bind(this));
      EventHub.$on(EventHub.events.closeConversationEvent, function (conversation) {
        _newArrowCheck(this, _this4);
        this.setCurrentChat({});
      }.bind(this));
      EventHub.$on(EventHub.events.archiveConversationEvent, function (conversation) {
        _newArrowCheck(this, _this4);
        var code = "GENESYS_CLOSE_BY_USER#0001";
        var message = {
          type: "chat_notice",
          action: "chat_notice",
          payload: {
            code: code
          }
        };
        this.confirmArchiveAction(conversation);
        EventHub.$emit(EventHub.events.sendMessageAction, message);
        this.setCurrentChat({});
      }.bind(this));
      EventHub.$on(EventHub.events.resetUnreadMessagesCount, function (thread) {
        _newArrowCheck(this, _this4);
        // reset unread message count
        this.handleResetUnreadMessagesCount(thread);
      }.bind(this));
    }
  }, {
    key: "mounted",
    value: function mounted() {
      document.getElementsByTagName("body")[0].style.margin = "0";
      var resource = lsGet(this.getLocalResource);
      // setup conversation counters
      this.handleSetupConversationsCounter();
      this.onCheckIfThereAreArchivedChats(resource);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      document.getElementsByTagName("body")[0].style.margin = "5px";
      EventHub.$off(EventHub.events.backButtonFromConversationPressed);
      EventHub.$off(EventHub.events.resetUnreadMessagesCount);
    }
  }, {
    key: "hasUnreadBadge",
    value: function hasUnreadBadge(conversation) {
      if (this.isConversationHuman(conversation) || this.isConversationMain(conversation)) {
        var mainThread = lsGet(this.getLocalThread);
        var threadKey = mainThread;
        var unreadCount = 0;
        if (this.isConversationHuman(conversation)) {
          var thread = conversation.thread;
          threadKey = thread;
        }
        if (this.getConversationsCounter.hasOwnProperty(threadKey)) {
          var unread_msg_count = this.getConversationsCounter[threadKey].unread_msg_count;
          unreadCount = unread_msg_count;
        }
        return unreadCount && this.enableUnreadMessagesBadge;
      } else {
        return false;
      }
    }
  }, {
    key: "canShowArchiveSeparator",
    value: function canShowArchiveSeparator(conversation) {
      return this.sortedArchiveConversation.length > 2 && this.getConversationListClass(conversation).includes('wfp');
    }
  }, {
    key: "isConversationMain",
    value: function isConversationMain(conversation) {
      var spocClass = conversation["class"];
      return spocClass === ConversationType.Wfp;
    }
  }, {
    key: "isConversationHuman",
    value: function isConversationHuman(conversation) {
      var threadKey = conversation.thread;
      var mainThread = lsGet(this.getLocalThread);
      return threadKey && threadKey.includes("".concat(mainThread, "|$|"));
    }
  }, {
    key: "isConversationDeleted",
    value: function isConversationDeleted(status) {
      return status === "deleted";
    }
  }, {
    key: "isConversationActive",
    value: function isConversationActive(status) {
      return status === "active";
    }
  }, {
    key: "isConversationNotArchivedDeleted",
    value: function isConversationNotArchivedDeleted(conversation) {
      var is_archived = conversation.is_archived,
        classField = conversation["class"];
      return !this.isConversationDeleted(classField) && !is_archived;
    }
  }, {
    key: "isActionsMenu",
    value: function isActionsMenu(index) {
      return this.actionsMenu[index];
    }
  }, {
    key: "isActionsMenuNotActive",
    value: function isActionsMenuNotActive(index) {
      var returnValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return returnValue ? this.actionsMenu[index].active : this.isActionsMenu(index) && this.actionsMenu[index].active === false;
    }
  }, {
    key: "isActionsMenuActive",
    value: function isActionsMenuActive(index) {
      return this.isActionsMenu(index) && this.actionsMenu[index].active;
    }
  }, {
    key: "isActionsMenuEnabled",
    value: function isActionsMenuEnabled(index) {
      return this.isActionsMenu(index) && this.actionsMenu[index].enabled;
    }
  }, {
    key: "canShowConversationArchive",
    value: function canShowConversationArchive(conversation) {
      if (!conversation) {
        return false;
      }
      var is_archived = conversation.is_archived,
        classField = conversation["class"];
      return this.isArchiveSection ? is_archived && !this.isConversationDeleted(classField) : !is_archived && this.isConversationNotArchivedDeleted(conversation);
    }
  }, {
    key: "hasConversationHistory",
    value: function hasConversationHistory(conversation) {
      var conversationThreadKey = this.getConversationThreadKey(conversation);
      return this.history.hasOwnProperty(conversationThreadKey) && Object.keys(this.history[conversationThreadKey].length > 0);
    }
  }, {
    key: "getUnreadCounterValue",
    value: function getUnreadCounterValue(conversation) {
      var mainThread = lsGet(this.getLocalThread);
      var thread = conversation.thread;
      if (this.isConversationHuman(conversation)) {
        return this.getConversationsCounter[thread].unread_msg_count;
      } else {
        return this.getConversationsCounter[mainThread].unread_msg_count;
      }
    }
  }, {
    key: "getConversationListClass",
    value: function getConversationListClass(conversation) {
      var is_archived = conversation.is_archived,
        classField = conversation["class"];
      return is_archived ? "archived" : "".concat(classField);
    }
  }, {
    key: "getConversationListWrapperClass",
    value: function getConversationListWrapperClass(conversation) {
      if (this.hasUnreadBadge(conversation)) {
        return "wrapper unread";
      } else {
        return "wrapper";
      }
    }
  }, {
    key: "getConversationListItemActiveClass",
    value: function getConversationListItemActiveClass(status) {
      return this.isConversationActive(status) ? "slide-out-33" : "slide-out";
    }
  }, {
    key: "getConversationListItemActiveArchivedClass",
    value: function getConversationListItemActiveArchivedClass(conversation) {
      var is_archived = conversation.is_archived,
        classField = conversation["class"];
      return is_archived ? "slide-out-66" : this.getConversationListItemActiveClass(classField);
    }
  }, {
    key: "getConversationListItemActionsMenuClass",
    value: function getConversationListItemActionsMenuClass(index) {
      this.isActionsMenuNotActive(index) ? "slide-in" : "";
    }
  }, {
    key: "getConversationListItemClass",
    value: function getConversationListItemClass(conversation, index) {
      return this.isActionsMenuActive(index) ? this.getConversationListItemActiveArchivedClass(conversation) : this.getConversationListItemActionsMenuClass(index);
    }
  }, {
    key: "getQuickActionsMenuClass",
    value: function getQuickActionsMenuClass(index) {
      return this.isActionsMenuActive(index) ? "slide-in" : this.isActionsMenuNotActive(index) ? "slide-out-menu" : "";
    }
  }, {
    key: "getButtonActionsClass",
    value: function getButtonActionsClass(conversation) {
      var is_archived = conversation.is_archived,
        classField = conversation["class"];
      return is_archived ? "archived" : "".concat(classField);
    }
  }, {
    key: "getButtonActionIconClass",
    value: function getButtonActionIconClass(index) {
      return this.isActionsMenuNotActive(index, true) !== true ? "el-icon-d-arrow-left" : "el-icon-d-arrow-right";
    }
  }, {
    key: "getConversationHistoryTimestamp",
    value: function getConversationHistoryTimestamp(conversation) {
      if (!this.hasConversationHistory(conversation)) return "";
      var conversationThreadKey = this.getConversationThreadKey(conversation);
      var timestamp = this.history[conversationThreadKey].timestamp;
      if (timestamp) {
        return timestamp || conversation.timestamp;
      } else {
        var stanza = this.history[conversationThreadKey].stanza;
        return stanza ? stanza.timestamp : "";
      }
    }
  }, {
    key: "getConversationHistoryMessage",
    value: function getConversationHistoryMessage(conversation) {
      var threadId = this.getConversationThreadKey(conversation);
      var lastMessageConversation = {};

      // if history is available
      // get the last message from history
      if (this.hasConversationHistory(conversation)) {
        lastMessageConversation = _objectSpread2({}, this.history[threadId]);
      } else {
        // otherwise, retrieve it from localMessageTree
        lastMessageConversation = this.getLastMessageFromMessageTreeByThreadId(threadId);
      }
      var _lastMessageConversat = lastMessageConversation,
        payload = _lastMessageConversat.payload;
      return this.renderPreviewContent(payload || {});
    }
  }, {
    key: "getConversationThreadKey",
    value: function getConversationThreadKey(conversation) {
      var _this5 = this;
      var localMessagesTree = lsGet(this.getLocalMessageTree) || {};
      var mainThread = lsGet(this.getLocalThread);
      var spocThreadKey = Object.keys(localMessagesTree).find(function (item) {
        _newArrowCheck(this, _this5);
        return item === mainThread;
      }.bind(this));
      return conversation["class"] !== ConversationType.Wfp ? conversation.thread : spocThreadKey;
    }
  }, {
    key: "getLastMessageFromMessageTreeByThreadId",
    value: function getLastMessageFromMessageTreeByThreadId(threadId) {
      var message = {};
      var messagesTree = lsGet(this.getLocalMessageTree) || {};
      if (messagesTree.hasOwnProperty(threadId) && messagesTree[threadId].length > 0) {
        var currentMessageTree = _toConsumableArray(messagesTree[threadId]);
        var _currentMessageTree$s = currentMessageTree.splice(-1),
          _currentMessageTree$s2 = _slicedToArray(_currentMessageTree$s, 1),
          lastItem = _currentMessageTree$s2[0];
        message = _objectSpread2(_objectSpread2({}, lastItem), {}, {
          key: threadId
        });
      }
      return message;
    }
  }, {
    key: "handleFetchHistoryMessages",
    value: function handleFetchHistoryMessages() {
      var _this6 = this;
      var localConversationTree = lsGet(this.getLocalConversationTree) || [];
      localConversationTree.forEach(function (conversation) {
        _newArrowCheck(this, _this6);
        var threadId = this.getConversationThreadKey(conversation);
        var lastMessage = this.getLastMessageFromMessageTreeByThreadId(threadId);
        if (Object.keys(lastMessage).length) {
          this.addMessageToHistory(lastMessage);
        }
      }.bind(this));
    }
  }, {
    key: "renderPreviewContent",
    value: function renderPreviewContent() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var content = payload.content;
      if (content) {
        var _content = _slicedToArray(content, 1),
          firstContent = _content[0];
        if (firstContent) {
          var msg = firstContent.hasOwnProperty("html") ? firstContent.html : firstContent.text || "";
          return stripTags(msg);
        } else {
          return "";
        }
      } else {
        if (payload.hasOwnProperty("text")) {
          return payload.text;
        } else if (payload.hasOwnProperty("code")) {
          return this.parseNoticeCode(payload.code);
        } else if (payload.hasOwnProperty("url")) {
          return "📄 Allegato";
        } else {
          return "";
        }
      }
    }
  }, {
    key: "parseNoticeCode",
    value: function parseNoticeCode(noticeKey) {
      var map = {
        "GENESYS#0001": "Sorry, an error has occurred",
        "GENESYS#0002": "The session has expired",
        "GENESYS#0003": "Sorry, an error has occurred",
        "GENESYS#0004": "This conversation has been closed; for other questions, ask SPOC",
        "GENESYS_CLOSE_BY_USER#0001": "You have closed this conversation",
        "FOREGROUND_CONVERSATION#0001": "Welcome!",
        "FOREGROUND_CONVERSATION#0002": "The conversation is already active"
      };
      return map[noticeKey] || "";
    }
  }, {
    key: "askSPOC",
    value: function askSPOC() {
      this.openConversation(this.sortedArchiveConversation[0], 0);
    }
  }, {
    key: "openConversation",
    value: function openConversation(conversation, conversationIndex) {
      // console.log("selected conversation, ", conversation, conversationIndex);
      // disable force query pagination
      this.setShouldForceQueryArchivePagination(false);
      this.setCurrentChat(conversation);
    }
  }, {
    key: "toggleActionMenuEvent",
    value: function toggleActionMenuEvent(key) {
      this.toggleActionsMenu({
        index: key,
        active: !this.actionsMenu[key].active
      });
    }
  }, {
    key: "disableVoiceInterfaceAudio",
    value: function disableVoiceInterfaceAudio() {
      // disable mic
      this.setIsMicListening(false);
      // disable audio
      this.setIsVoiceAudioEnabled(false);
    }
  }, {
    key: "handleSetupConversationsCounter",
    value: function handleSetupConversationsCounter() {
      // setup conversation counter
      var conversationsCounter = lsGet(this.getLocalConversationsCounter) || {};
      this.setConversationsCounter(conversationsCounter);
    }
  }, {
    key: "handleResetUnreadMessagesCount",
    value: function handleResetUnreadMessagesCount(thread) {
      if (thread) {
        var conversationsCounter = _objectSpread2({}, this.getConversationsCounter);
        if (!conversationsCounter.hasOwnProperty(thread)) {
          // if no thread yet, create it
          conversationsCounter[thread] = {};
        }
        // reset count
        conversationsCounter[thread].unread_msg_count = 0;
        // realign store
        this.setConversationsCounter(conversationsCounter);
        // realign localStorage
        lsSet(this.getLocalConversationsCounter, conversationsCounter);
      }
    }
  }, {
    key: "handleRefresh",
    value: function handleRefresh() {}
  }, {
    key: "goBack",
    value: function goBack() {
      this.setConversationsTitle("Chat");
      this.setBackButtonLabel("");
      if (this.isArchiveSection) {
        this.renderActiveConversations();
        this.isArchiveSection = false;
      } else {
        EventHub.$emit(EventHub.events.goBackFromConversationsList, true);
      }
    }
  }, {
    key: "conversationAction",
    value: function conversationAction(action, conversation, index) {
      if (!action) {
        this.showEditDialog = false;
        this.showArchiveDialog = false;
        this.showDeleteDialog = false;
      } else {
        this.selectedChat = conversation;
        switch (action) {
          case "edit":
            this.showEditDialog = true;
            this.selectedChatOldTitle = this.selectedChat.title;
            break;
          case "archive":
            this.showArchiveDialog = true;
            break;
          case "delete":
            this.showDeleteDialog = true;
            break;
        }
      }
    }
  }, {
    key: "cancelEditAction",
    value: function cancelEditAction() {
      this.showEditDialog = false;
      Object.assign(this.selectedChat, {
        title: this.selectedChatOldTitle
      });
    }
  }, {
    key: "confirmEditAction",
    value: function confirmEditAction() {
      var _this7 = this;
      var localConversationTree = lsGet(this.getLocalConversationTree) || [];
      lsGet(this.getLocalMessageTree) || {};
      var newHashedTitle = this.selectedChat.title.trim();
      var oldHashedTitle = this.selectedChatOldTitle.trim();
      if (oldHashedTitle.toLowerCase() === newHashedTitle.toLowerCase()) {
        this.cancelEditAction();
        return false;
      }
      var index = localConversationTree.findIndex(function (item) {
        _newArrowCheck(this, _this7);
        return item.thread === this.selectedChat.thread;
      }.bind(this));
      if (localConversationTree[index]) {
        localConversationTree[index].title = newHashedTitle;
        lsSet(this.getLocalConversationTree, localConversationTree);
      }
      this.showEditDialog = false;
      setTimeout(function () {
        _newArrowCheck(this, _this7);
        return this.handleFetchHistoryMessages();
      }.bind(this), 200);
    }
  }, {
    key: "confirmArchiveAction",
    value: function confirmArchiveAction(conversation) {
      var _this8 = this;
      console.log('in "confirmArchiveAction"');
      var conv = conversation || this.selectedChat;
      console.log("conv: ", conv);
      var mirrorChat = Object.assign({}, conv);
      console.log("mirrorChat: ", mirrorChat);
      var localConversationTree = lsGet(this.getLocalConversationTree) || [];
      var mirrorChatIndex = localConversationTree.findIndex(function (conversation) {
        _newArrowCheck(this, _this8);
        return conversation.thread === mirrorChat.thread;
      }.bind(this));
      // update info
      console.log("mirrorChatIndex: ", mirrorChatIndex);
      if (mirrorChatIndex !== -1) {
        localConversationTree[mirrorChatIndex]["class"] = ConversationType.Archived;
        localConversationTree[mirrorChatIndex].is_archived = true;
        lsSet(this.getLocalConversationTree, localConversationTree);
        // UI workaround
        this.updateConversation({
          thread: mirrorChat.thread,
          old: mirrorChat,
          "new": localConversationTree[mirrorChatIndex]
        });
      }
      // update UI
      this.showArchivedCta = true;
      this.showArchiveDialog = false;
    }
  }, {
    key: "confirmDeleteAction",
    value: function confirmDeleteAction(conversation) {
      var _this9 = this;
      var currentConversation = conversation || this.selectedChat;
      var localConversationTree = lsGet(this.getLocalConversationTree) || [];
      var conversationIndex = localConversationTree.findIndex(function (item) {
        _newArrowCheck(this, _this9);
        return item.thread === currentConversation.thread;
      }.bind(this));
      if (conversationIndex !== -1) {
        localConversationTree[conversationIndex]["class"] = ConversationType.Deleted;
        this.updateConversationClass({
          thread: localConversationTree[conversationIndex].thread,
          newClass: ConversationType.Deleted
        });
        lsSet(this.getLocalConversationTree, localConversationTree);
      }
      // update localStorage
      this.showDeleteDialog = false;
    }
  }, {
    key: "renderArchivedConversations",
    value: function renderArchivedConversations() {
      var _this0 = this;
      this.isArchiveSection = true;
      this.setConversationsTitle("Archivio");
      this.setBackButtonLabel("Chat");
      // console.log("renderArchivedConversations...");
      this.setConversationsArray(this.filterLocalConversations(true));
      setTimeout(function () {
        _newArrowCheck(this, _this0);
        return this.handleFetchHistoryMessages();
      }.bind(this), 100);
    }
  }, {
    key: "renderActiveConversations",
    value: function renderActiveConversations() {
      var _this1 = this;
      // console.log("renderActiveConversations...");
      this.setConversationsArray(this.filterLocalConversations());
      setTimeout(function () {
        _newArrowCheck(this, _this1);
        return this.handleFetchHistoryMessages();
      }.bind(this), 100);
    }
  }, {
    key: "onCheckIfThereAreArchivedChats",
    value: function onCheckIfThereAreArchivedChats(resource) {
      var _this10 = this;
      var localConversationTree = lsGet(this.getLocalConversationTree) || [];
      var archivedChatResult = localConversationTree.filter(function (_ref) {
        _newArrowCheck(this, _this10);
        var is_archived = _ref.is_archived,
          classField = _ref["class"];
        return is_archived && classField !== ConversationType.Deleted;
      }.bind(this));
      if (archivedChatResult.length > 0) {
        this.showArchivedCta = true;
      }
    }
  }, {
    key: "filterLocalConversations",
    value: function filterLocalConversations() {
      var _this11 = this;
      var filterArchived = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var localConversationsTree = lsGet(this.getLocalConversationTree) || [];
      var localConversation = this.getConversations.length > 0 ? _toConsumableArray(this.getConversations) : localConversationsTree;
      var filteredConversations = [];
      if (filterArchived) {
        filteredConversations = localConversation.filter(function (_ref2) {
          _newArrowCheck(this, _this11);
          var is_archived = _ref2.is_archived;
          return is_archived;
        }.bind(this));
      } else {
        filteredConversations = localConversation.filter(function (_ref3) {
          _newArrowCheck(this, _this11);
          var is_archived = _ref3.is_archived;
          return !is_archived;
        }.bind(this));
      }
      return filteredConversations;
    }
  }, {
    key: "handleOnConversationUpdated",
    value: function handleOnConversationUpdated(conversation) {
    }
  }, {
    key: "handleOnHistoryUpdated",
    value: function handleOnHistoryUpdated(history) {
    }
  }, {
    key: "toggleArchivedChatBanner",
    value: function toggleArchivedChatBanner(resource) {
      if (resource) {
        this.onCheckIfThereAreArchivedChats(resource);
      }
    }
  }]);
}(Vue$2), _descriptor$1 = _applyDecoratedDescriptor(_class2$1.prototype, "allMessages", [_dec2$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$1 = _applyDecoratedDescriptor(_class2$1.prototype, "history", [_dec3$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$1 = _applyDecoratedDescriptor(_class2$1.prototype, "resource", [_dec4$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$1 = _applyDecoratedDescriptor(_class2$1.prototype, "backButtonLabel", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2$1.prototype, "mainTitle", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2$1.prototype, "actionsMenu", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2$1.prototype, "toggleActionsMenu", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2$1.prototype, "getConversations", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2$1.prototype, "getConversationsCounter", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class2$1.prototype, "getBotConfigSettings", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class2$1.prototype, "addMessageToHistory", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2$1.prototype, "setHistory", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2$1.prototype, "setConversationsArray", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2$1.prototype, "setConversationsCounter", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2$1.prototype, "setConversationsTitle", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2$1.prototype, "setBackButtonLabel", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2$1.prototype, "popConversation", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2$1.prototype, "setCurrentChat", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2$1.prototype, "genesysNoticeMap", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2$1.prototype, "updateConversation", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2$1.prototype, "updateConversationClass", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2$1.prototype, "setCurrentConversationMessages", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class2$1.prototype, "setShouldForceQueryArchivePagination", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class2$1.prototype, "setIsVoiceAudioEnabled", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class2$1.prototype, "setIsMicListening", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class2$1.prototype, "allowSearchFilter", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class2$1.prototype, "showConversationList", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class2$1.prototype, "enableUnreadMessagesBadge", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class2$1.prototype, "lastMessageToDisplayTotal", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2$1.prototype, "handleOnConversationUpdated", [_dec29], Object.getOwnPropertyDescriptor(_class2$1.prototype, "handleOnConversationUpdated"), _class2$1.prototype), _applyDecoratedDescriptor(_class2$1.prototype, "handleOnHistoryUpdated", [_dec30], Object.getOwnPropertyDescriptor(_class2$1.prototype, "handleOnHistoryUpdated"), _class2$1.prototype), _applyDecoratedDescriptor(_class2$1.prototype, "toggleArchivedChatBanner", [_dec31], Object.getOwnPropertyDescriptor(_class2$1.prototype, "toggleArchivedChatBanner"), _class2$1.prototype), _class2$1)) || _class$1);

var __vue_script__$1 = ConversationsList;

/* template */
var __vue_render__$1 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "id": "conversations-list"
    }
  }, [_c('el-container', [_c('el-header', {
    "class": _vm.getConversationListHeaderClass,
    attrs: {
      "id": "head"
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle",
      "gutter": 10
    }
  }, [_vm.backButtonLabel ? [_vm.backButtonLabel ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.backButtonLabel))])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.getConversationListHeading))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleRefresh
    }
  }, [_c('span', {
    staticClass: "el-icon-refresh-right"
  })])], 1)] : [_c('el-col', {
    attrs: {
      "span": 24,
      "type": "flex",
      "justify": "center"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.getConversationListHeading))])])]], 2), _vm._v(" "), _vm.allowSearchFilter ? _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    staticClass: "w-100",
    attrs: {
      "id": "search-bar",
      "suffix-icon": "el-icon-search",
      "placeholder": "Search...",
      "clearable": ""
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-main', {
    attrs: {
      "id": "body"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "0 0 2rem"
    }
  }, [_vm.canShowConversationList ? _c('ul', _vm._l(_vm.sortedArchiveConversation, function (conversation, index) {
    return _c('li', {
      staticClass: "conversation",
      "class": _vm.getConversationListClass(conversation)
    }, [conversation.title ? _c('div', {
      "class": _vm.getConversationListWrapperClass(conversation)
    }, [_c('div', {
      "class": _vm.getConversationListItemClass(conversation, index)
    }, [_c('el-button', {
      staticClass: "wrapper-event-handler",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function click($event) {
          return _vm.openConversation(conversation, index);
        }
      }
    }, [_c('span', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": conversation.avatar,
        "alt": ""
      }
    }), _vm._v(" "), _vm.hasUnreadBadge(conversation) ? [_c('el-badge', {
      attrs: {
        "value": _vm.getUnreadCounterValue(conversation),
        "max": 10
      }
    })] : _vm._e()], 2), _vm._v(" "), _c('span', {
      staticClass: "info-wrapper"
    }, [_c('strong', {
      staticClass: "title"
    }, [_vm._v("\n                        " + _vm._s(conversation.title) + "\n                        " + _vm._s(_vm._f("formatDate")(_vm.getConversationHistoryTimestamp(conversation))) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "last-msg-preview"
    }, [_vm._v("\n                        " + _vm._s(_vm.getConversationHistoryMessage(conversation) || ' ') + "\n                      ")])]), _vm._v(" "), _c('small', {
      staticClass: "date"
    }, [_vm._v("\n                      " + _vm._s(_vm._f("formatDate")(_vm.getConversationHistoryTimestamp(conversation))) + "\n                    ")])])], 1)]) : _vm._e(), _vm._v(" "), _vm.canShowArchiveSeparator(conversation) ? _c('div', {
      staticClass: "separator"
    }, [_c('span', [_vm._v(_vm._s(_vm.getLabel.heading_cases_history))])]) : _vm._e()]);
  }), 0) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "ask-spoc",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function click($event) {
        return _vm.askSPOC();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.getIconChatBubble
    }
  }), _vm._v("\n    " + _vm._s(_vm.getLabel.label_ask_bot) + "\n  ")])], 1);
};
var __vue_staticRenderFns__$1 = [];

/* style */
var __vue_inject_styles__$1 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-4d170325_0", {
    source: ".w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}.el-row{margin-bottom:1em}.el-row:last-child{margin-bottom:0}.el-button:disabled{opacity:.6}.el-message-box{width:90%;max-width:420px;font-family:Avenir,sans-serif}.el-message{font-family:Avenir,sans-serif}.el-notification p{text-align:left}.m-1{margin:.5em!important}.m-top-2{margin-top:1em!important}.m-right-3{margin-right:1.5em!important}.m-bottom-4{margin-bottom:2em!important}.m-left-5{margin-left:2.5em!important}@-webkit-keyframes slide-in{100%{transform:translateX(5px)}}@-moz-keyframes slide-in{100%{transform:translateX(5px)}}@-ms-keyframes slide-in{100%{transform:translateX(5px)}}@keyframes slide-in{100%{transform:translateX(5px)}}@-webkit-keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@-moz-keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@-ms-keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@-webkit-keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@-moz-keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@-ms-keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@-webkit-keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@-moz-keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@-ms-keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@-webkit-keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@-moz-keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@-ms-keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@-webkit-keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@-moz-keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@-ms-keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@-webkit-keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@-moz-keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@-ms-keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@-webkit-keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@-moz-keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@-ms-keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@-webkit-keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}@-moz-keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}@-ms-keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}@keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}.slide-in{animation:slide-in .5s forwards;-webkit-animation:slide-in .5s forwards}.slide-in-menu{animation:slide-in-menu .5s forwards;-webkit-animation:slide-in-menu .5s forwards}.slide-out{animation:slide-out .5s forwards;-webkit-animation:slide-out .5s forwards}.slide-out-33{animation:slide-out-33 .5s forwards;-webkit-animation:slide-out-33 .5s forwards}.slide-out-66{animation:slide-out-66 .5s forwards;-webkit-animation:slide-out-66 .5s forwards}.slide-out-menu{animation:slide-out-menu .5s forwards;-webkit-animation:slide-out-menu .5s forwards}#conversations-list{background-color:#225080;min-height:100vh}#conversations-list .el-container{padding-top:115px}#conversations-list #head{position:fixed;inset:0 0 auto;height:115px!important;padding:0;display:flex;place-content:center;place-items:center;color:#fefefe;background-color:#20507f;z-index:999}#conversations-list #head.is-archive{background-color:#fbb03a}#conversations-list #head h1{margin:0;color:#fefefe}#conversations-list #body{border-radius:1em 1em 0 0;padding:0 1em;overflow:hidden}#conversations-list #body>.el-row{height:100%;overflow-x:hidden;overflow-y:auto}#conversations-list #body ul{list-style:none;padding:0;display:block;width:100%}#conversations-list #body ul li.conversation{float:none;width:100%}#conversations-list #body ul li.conversation .wrapper{box-sizing:border-box;padding:.3em;border:0 solid #bababa;border-radius:.75em;display:block;vertical-align:middle;min-height:50px;margin-bottom:0;position:relative;min-height:5.5rem;float:none;width:100%;overflow-x:hidden;box-shadow:none;background-color:#fefefe}#conversations-list #body ul li.conversation .wrapper .wrapper-event-handler{display:block;width:100%;height:100%;padding:0;margin:0;font-size:inherit;outline:0;padding:0}#conversations-list #body ul li.conversation .wrapper .wrapper-event-handler>span{position:relative;display:flex;place-content:start;place-items:center;gap:1rem;width:100%;height:100%}#conversations-list #body ul li.conversation .wrapper .wrapper-event-handler>span .avatar{display:flex;place-content:center;place-items:center;border-radius:2.5rem;background-position:center;background-repeat:no-repeat;background-size:30px 30px;box-shadow:0 1px .8em #bababa;margin:.5em;width:3.6rem;height:3.6rem;overflow:visible}#conversations-list #body ul li.conversation .wrapper .wrapper-event-handler>span .info-wrapper{display:inline-flex;flex-grow:1;flex-flow:column nowrap;padding:0;text-align:left}#conversations-list #body ul li.conversation .wrapper .wrapper-event-handler>span .info-wrapper .title{display:block;font-size:16px;margin-bottom:.2em}#conversations-list #body ul li.conversation .wrapper .wrapper-event-handler>span .info-wrapper .last-msg-preview{display:block;font-size:14px;line-height:1.2;margin:0;text-overflow:ellipsis;white-space:nowrap;max-width:225px;max-height:17px;padding-right:.5em;overflow:hidden}#conversations-list #body ul li.conversation .wrapper .wrapper-event-handler>span .info-wrapper.active{border-right:7px solid #28a745}#conversations-list #body ul li.conversation .wrapper .wrapper-event-handler>span .info-wrapper.closed{border-right:7px solid #dc3545}#conversations-list #body ul li.conversation .wrapper .wrapper-event-handler>span .date{position:absolute;inset:.5em .5em auto auto;display:block;padding:0;text-align:right;font-size:.75em;color:#bababa}#conversations-list #body ul li.conversation .wrapper .action-menu-toggler{position:absolute;right:-1px;top:0;bottom:0;margin:auto;padding:.3em;padding-right:0;padding-left:.1em;border-radius:50px 0 0 50px;font-size:1.2em;max-height:50px;height:fit-content;background-color:#bababa;border-color:#bababa;box-shadow:3px 0 10px rgba(0,0,0,.35);-ms-box-shadow:3px 0 10px rgba(0,0,0,.35);-moz-box-shadow:3px 0 10px rgba(0,0,0,.35)}#conversations-list #body ul li.conversation .wrapper .action-menu-toggler i{font-weight:600}#conversations-list #body ul li.conversation .wrapper .quick-actions-menu{position:absolute;top:0;bottom:0;right:0;transform:translateX(101%);-webkit-transform:translateX(101%);width:fit-content}#conversations-list #body ul li.conversation .wrapper .quick-actions-menu .btn-action{padding:.5em .3em;margin:0;font-size:2.2em;float:left;height:100%;border-radius:0}#conversations-list #body ul li.conversation .wrapper.unread.unread .el-badge{position:absolute;top:8px;left:52px}#conversations-list #body ul li.conversation .wrapper.unread.unread .el-badge .el-badge__content{font-size:14px}#conversations-list #body ul li.conversation .separator{position:relative;margin:1rem 0 0;height:22px;z-index:0}#conversations-list #body ul li.conversation .separator:before{content:\"\";position:absolute;inset:0;border-top:1px solid #fefefe;height:0;margin:auto;width:100%;z-index:0}#conversations-list #body ul li.conversation .separator span{background-color:#387dbc;z-index:1;color:#fefefe;display:inline-block;box-sizing:border-box;position:absolute;inset:0;padding:0;margin:auto;width:10rem}#conversations-list #body ul li.conversation.wfp .action-menu-toggler{position:absolute;right:-1px;top:0;bottom:0;margin:auto;padding:.3em;padding-right:0;padding-left:.1em;border-radius:50px 0 0 50px;font-size:1.2em;max-height:50px;height:fit-content;background-color:#bababa;border-color:#bababa;box-shadow:3px 0 10px rgba(0,0,0,.35);-ms-box-shadow:3px 0 10px rgba(0,0,0,.35);-moz-box-shadow:3px 0 10px rgba(0,0,0,.35)}#conversations-list #body ul li.conversation.wfp .action-menu-toggler i{font-weight:600}#conversations-list #body ul li.conversation.wfp .quick-actions-menu{position:absolute;top:0;bottom:0;right:0;transform:translateX(101%);-webkit-transform:translateX(101%);width:fit-content}#conversations-list #body ul li.conversation.wfp .quick-actions-menu .btn-action{padding:.5em .3em;margin:0;font-size:2.2em;float:left;height:100%;border-radius:0}#conversations-list #body ul li.conversation+li.conversation{margin-top:1.5em}#conversations-list #body .archived-chat-banner{position:fixed;left:0;bottom:0;right:0;height:fit-content;padding:.9em;background-color:#fbb03a;margin:0;text-align:left;font-size:1.2em;color:#fff;cursor:pointer}#conversations-list #body .archived-chat-banner strong{color:#fff!important;margin-left:.5em}#conversations-list #body .archived-chat-banner span{font-weight:600}#conversations-list #body .archived-chat-banner span:last-child{float:right;font-size:1.2em}#conversations-list #body .bottom-notice{position:fixed;left:0;bottom:0;right:0;padding:1em 3em;margin:0;color:gray;font-weight:600;font-size:.75em}#conversations-list .el-button--text.ask-spoc{position:fixed;display:flex;inset:auto 1em 1em auto;background-color:#fff;border-color:#fff;padding:1rem;border-radius:4rem;z-index:2;box-shadow:3px 3px 15px -5px #000}#conversations-list .el-button--text.ask-spoc span{display:inline-flex;place-content:center;place-items:center;gap:.5rem;font-weight:700;color:#225080}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$1 = undefined;
/* module identifier */
var __vue_module_identifier__$1 = undefined;
/* functional template */
var __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

var img$2 = "data:image/svg+xml,%3c!-- Generated by IcoMoon.io --%3e%3csvg version='1.1' xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3e %3ctitle%3ebot%3c/title%3e %3cpath fill='%23225080' d='M13.818 21.091c0 0.538-0.145 1.018-0.407 1.455-0.495-0.858-1.425-1.455-2.502-1.455s-2.007 0.596-2.502 1.455c-0.247-0.436-0.407-0.916-0.407-1.455 0-1.6 1.309-2.909 2.909-2.909s2.909 1.309 2.909 2.909zM32 20.364v4.364c0 0.8-0.655 1.455-1.455 1.455h-1.455v1.455c0 1.615-1.295 2.909-2.909 2.909h-20.364c-1.6 0-2.909-1.295-2.909-2.909v-1.455h-1.455c-0.8 0-1.455-0.655-1.455-1.455v-4.364c0-0.8 0.655-1.455 1.455-1.455h1.455c0-5.629 4.553-10.182 10.182-10.182h1.455v-1.847c-0.873-0.495-1.455-1.44-1.455-2.516 0-1.6 1.309-2.909 2.909-2.909s2.909 1.309 2.909 2.909c0 1.076-0.582 2.022-1.455 2.516v1.847h1.455c5.629 0 10.182 4.553 10.182 10.182h1.455c0.8 0 1.455 0.655 1.455 1.455zM29.091 21.818h-2.909v-2.909c0-4.015-3.258-7.273-7.273-7.273h-5.818c-4.015 0-7.273 3.258-7.273 7.273v2.909h-2.909v1.455h2.909v4.364h20.364v-4.364h2.909v-1.455zM21.091 18.182c-1.6 0-2.909 1.309-2.909 2.909 0 0.538 0.16 1.018 0.407 1.455 0.495-0.858 1.425-1.455 2.502-1.455s2.007 0.596 2.502 1.455c0.262-0.436 0.407-0.916 0.407-1.455 0-1.6-1.295-2.909-2.909-2.909z'%3e%3c/path%3e%3c/svg%3e";

var _dec$2,
  _dec2$2,
  _dec3$2,
  _dec4$2,
  _dec5$1,
  _dec6$1,
  _dec7$1,
  _dec8$1,
  _dec9$1,
  _dec0$1,
  _this$4 = this,
  _class$2,
  _class2$2,
  _descriptor$2,
  _descriptor2$2,
  _descriptor3$2,
  _descriptor4$2,
  _descriptor5$1,
  _descriptor6$1,
  _descriptor7$1,
  _descriptor8$1,
  _descriptor9$1,
  _descriptor0$1;
var ChatHeader = (_dec$2 = Prop(String), _dec2$2 = Prop(String), _dec3$2 = Prop({
  "default": true
}), _dec4$2 = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$4);
  }.bind(this)
}), _dec5$1 = Getter("chat/resource"), _dec6$1 = Getter("chat/getConversations"), _dec7$1 = Getter("chat/getCurrentChat"), _dec8$1 = Getter("chat/getIsConversationHeaderRawHtml"), _dec9$1 = Getter("chat/showRestartChatButton"), _dec0$1 = Getter("chat/getBotConfigSettings"), Component(_class$2 = (_class2$2 = /*#__PURE__*/function (_Vue) {
  function ChatHeader() {
    var _this2;
    _classCallCheck(this, ChatHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ChatHeader, [].concat(args));
    _initializerDefineProperty(_this2, "icon", _descriptor$2, _this2);
    _initializerDefineProperty(_this2, "message", _descriptor2$2, _this2);
    _initializerDefineProperty(_this2, "showBackButton", _descriptor3$2, _this2);
    _initializerDefineProperty(_this2, "handleOnRestartChat", _descriptor4$2, _this2);
    _initializerDefineProperty(_this2, "resource", _descriptor5$1, _this2);
    _initializerDefineProperty(_this2, "getConversations", _descriptor6$1, _this2);
    _initializerDefineProperty(_this2, "currentChat", _descriptor7$1, _this2);
    _initializerDefineProperty(_this2, "getIsConversationHeaderRawHtml", _descriptor8$1, _this2);
    _initializerDefineProperty(_this2, "showRestartChatButton", _descriptor9$1, _this2);
    _initializerDefineProperty(_this2, "getBotConfigSettings", _descriptor0$1, _this2);
    return _this2;
  }
  _inherits(ChatHeader, _Vue);
  return _createClass(ChatHeader, [{
    key: "botAvatarIcon",
    get: function get() {
      return img$2;
    }
  }, {
    key: "isRestartIconNewQuestion",
    get: function get() {
      var assets = this.getBotConfigSettings.assets;
      return (assets === null || assets === void 0 ? void 0 : assets.icon_restart) === "new_question";
    }
  }, {
    key: "getChatArchiveClass",
    get: function get() {
      return this.currentChat.is_archived ? "archived " : "";
    }
  }, {
    key: "getRawHtmlClass",
    get: function get() {
      return this.getIsConversationHeaderRawHtml ? " has-raw-html" : "";
    }
  }, {
    key: "getChatHeaderClass",
    get: function get() {
      return this.getChatArchiveClass + this.getRawHtmlClass;
    }
  }, {
    key: "getIconClass",
    get: function get() {
      var currentClass = this.currentChat["class"];
      return currentClass === ConversationType.Wfp ? "icon bot" : "icon support";
    }
  }, {
    key: "getButtonRestartClass",
    get: function get() {
      return this.isRestartIconNewQuestion ? "btn-floating btn-restart-chat new-question" : "btn-floating btn-restart-chat";
    }
  }, {
    key: "getBackToConversationListLabel",
    get: function get() {
      var _this$getBotConfigSet, _this$getBotConfigSet2;
      return (_this$getBotConfigSet = this.getBotConfigSettings) === null || _this$getBotConfigSet === void 0 ? void 0 : (_this$getBotConfigSet2 = _this$getBotConfigSet.labels) === null || _this$getBotConfigSet2 === void 0 ? void 0 : _this$getBotConfigSet2.label_back_to_conversation_list;
    }
  }, {
    key: "goToConversationsList",
    value: function goToConversationsList() {
      EventHub.$emit(EventHub.events.backButtonFromConversationPressed, this.currentChat);
    }
  }, {
    key: "onClickRestartChat",
    value: function onClickRestartChat() {
      this.handleOnRestartChat();
    }
  }]);
}(Vue$2), _descriptor$2 = _applyDecoratedDescriptor(_class2$2.prototype, "icon", [_dec$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$2 = _applyDecoratedDescriptor(_class2$2.prototype, "message", [_dec2$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$2 = _applyDecoratedDescriptor(_class2$2.prototype, "showBackButton", [_dec3$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$2 = _applyDecoratedDescriptor(_class2$2.prototype, "handleOnRestartChat", [_dec4$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5$1 = _applyDecoratedDescriptor(_class2$2.prototype, "resource", [_dec5$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6$1 = _applyDecoratedDescriptor(_class2$2.prototype, "getConversations", [_dec6$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7$1 = _applyDecoratedDescriptor(_class2$2.prototype, "currentChat", [_dec7$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8$1 = _applyDecoratedDescriptor(_class2$2.prototype, "getIsConversationHeaderRawHtml", [_dec8$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9$1 = _applyDecoratedDescriptor(_class2$2.prototype, "showRestartChatButton", [_dec9$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0$1 = _applyDecoratedDescriptor(_class2$2.prototype, "getBotConfigSettings", [_dec0$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$2)) || _class$2);

/* script */
var __vue_script__$2 = ChatHeader;

/* template */
var __vue_render__$2 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "id": "chat-header-wrap"
    }
  }, [_c('div', {
    "class": _vm.getChatHeaderClass,
    attrs: {
      "id": "chat-header"
    }
  }, [_vm.showBackButton ? [_c('el-button', {
    staticClass: "btn-floating",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.goToConversationsList
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getBackToConversationListLabel))])])] : _vm._e(), _vm._v(" "), _c('div', {
    "class": _vm.getIconClass
  }, [_c('img', {
    attrs: {
      "src": _vm.icon ? _vm.icon : _vm.botAvatarIcon
    }
  })]), _vm._v(" "), _vm.message ? [_vm.getIsConversationHeaderRawHtml ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }) : _c('strong', {
    staticClass: "slogan"
  }, [_vm._v(_vm._s(_vm.message))])] : _vm._e(), _vm._v(" "), _vm.showRestartChatButton ? _c('el-button', {
    "class": _vm.getButtonRestartClass,
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.onClickRestartChat
    }
  }, [_vm.isRestartIconNewQuestion ? _c('svg', {
    attrs: {
      "clip-rule": "evenodd",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "2",
      "viewBox": "0 0 77 38",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "a"
    }
  }, [_c('path', {
    attrs: {
      "clip-rule": "evenodd",
      "d": "m27.597 4.048h22.25v10.51h-22.25z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('path', {
    attrs: {
      "clip-rule": "evenodd",
      "d": "m27.6 23.016h22.25v10.51h-22.25z"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m0 0h77.038v38.005h-77.038z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#a)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m38.722 4.048c-5.113 0-9.383 3.161-11.125 7.625l1.631.375c.568-3.351 5.205-6.517 9.494-6.517 3.242 0 8.112 2.926 9 5.292h-5v1.225h7v-7h-1.222v4.345c-1.658-2.709-6.208-5.345-9.778-5.345zm9.281 15.625c-1.457 3.735-4.992 6.375-9.281 6.375-3.277 0-6.156-1.613-7.969-4h3.969v-2h-7v7h2v-3.093c2.187 2.48 5.394 4.093 9 4.093 5.113 0 9.383-3.16 11.125-7.625z",
      "fill": "#fff",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#b)"
    }
  }, [_c('path', {
    attrs: {
      "d": "m38.725 33.526c5.113 0 9.383-3.16 11.125-7.625l-1.631-.375c-.567 3.352-5.205 6.517-9.494 6.517-3.242 0-8.112-2.926-9-5.292h5v-1.225h-7v7h1.223v-4.345c1.657 2.709 6.207 5.345 9.777 5.345zm-9.281-15.625c1.457-3.734 4.992-6.375 9.281-6.375 3.278 0 6.156 1.613 7.969 4h-3.969v2h7v-7h-2v3.094c-2.187-2.481-5.394-4.094-9-4.094-5.113 0-9.383 3.16-11.125 7.625z",
      "fill": "#fff",
      "fill-rule": "nonzero"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#fff",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "m9.073 21.934h-1.318l-2.567-4.21v4.21h-1.318v-6.398h1.318l2.571 4.218v-4.218h1.314z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m14.524 19.161h-2.531v1.714h2.97v1.059h-4.289v-6.398h4.281v1.068h-2.962v1.524h2.531z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m21.17 20.088.862-4.552h1.313l-1.419 6.398h-1.327l-1.042-4.28-1.041 4.28h-1.327l-1.42-6.398h1.314l.866 4.544 1.055-4.544h1.116z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m32.446 18.88c0 .598-.097 1.117-.29 1.558-.194.441-.462.794-.805 1.061l1.064.835-.839.743-1.363-1.095c-.155.027-.316.04-.483.04-.53 0-1.004-.127-1.42-.382s-.738-.619-.966-1.092c-.229-.474-.345-1.018-.348-1.633v-.316c0-.63.114-1.185.341-1.664s.548-.846.962-1.103c.415-.256.889-.384 1.422-.384s1.007.128 1.422.384c.414.257.735.624.962 1.103s.341 1.032.341 1.659zm-1.336-.29c0-.671-.12-1.181-.361-1.529-.24-.349-.583-.523-1.028-.523-.442 0-.784.172-1.024.516s-.362.849-.365 1.514v.312c0 .653.121 1.16.361 1.52.24.361.586.541 1.037.541.442 0 .782-.174 1.019-.521.238-.347.358-.853.361-1.518z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m38.705 15.536v4.214c0 .7-.219 1.254-.657 1.661s-1.036.611-1.795.611c-.747 0-1.34-.198-1.78-.593-.439-.396-.663-.939-.672-1.631v-4.262h1.318v4.223c0 .419.101.724.301.916.201.192.479.288.833.288.741 0 1.118-.39 1.129-1.169v-4.258z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m44.086 19.161h-2.531v1.714h2.97v1.059h-4.289v-6.398h4.281v1.068h-2.962v1.524h2.531z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m49.067 20.255c0-.249-.088-.44-.264-.573s-.492-.274-.949-.422-.819-.294-1.086-.437c-.726-.393-1.09-.922-1.09-1.587 0-.345.098-.654.293-.925s.474-.482.839-.635c.365-.152.774-.228 1.228-.228.457 0 .865.083 1.222.248.357.166.635.399.833.701s.296.645.296 1.028h-1.318c0-.293-.092-.52-.277-.683-.184-.163-.444-.244-.778-.244-.322 0-.572.068-.751.204-.179.137-.268.316-.268.539 0 .208.105.382.314.523.21.14.518.272.925.395.75.226 1.296.506 1.639.84s.514.75.514 1.248c0 .553-.209.988-.628 1.303s-.983.472-1.692.472c-.492 0-.94-.09-1.345-.27-.404-.18-.712-.427-.925-.741-.212-.313-.318-.676-.318-1.09h1.322c0 .706.422 1.06 1.266 1.06.314 0 .558-.064.734-.192.176-.127.264-.305.264-.534z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m56.548 16.604h-1.96v5.33h-1.318v-5.33h-1.934v-1.068h5.212z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m57.833 15.536h1.318v6.398h-1.318z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m66.079 18.88c0 .63-.112 1.182-.334 1.657-.223.474-.541.84-.956 1.098s-.89.387-1.426.387c-.53 0-1.003-.127-1.419-.382s-.739-.619-.967-1.092c-.229-.474-.345-1.018-.347-1.633v-.316c0-.63.113-1.185.34-1.664s.548-.846.963-1.103c.414-.256.888-.384 1.421-.384s1.007.128 1.422.384c.414.257.735.624.962 1.103s.341 1.032.341 1.659zm-1.336-.29c0-.671-.12-1.181-.361-1.529-.24-.349-.583-.523-1.028-.523-.442 0-.784.172-1.024.516s-.362.849-.365 1.514v.312c0 .653.121 1.16.361 1.52.24.361.586.541 1.037.541.442 0 .782-.174 1.019-.521.238-.347.358-.853.361-1.518z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "m72.69 21.934h-1.318l-2.567-4.21v4.21h-1.318v-6.398h1.318l2.571 4.218v-4.218h1.314z"
    }
  })])]) : _c('span', {
    staticClass: "el-icon-refresh-right"
  })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  })]);
};
var __vue_staticRenderFns__$2 = [];

/* style */
var __vue_inject_styles__$2 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-3d677649_0", {
    source: ".w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}#chat-header-wrap #chat-header{background-color:#4386ff;position:fixed;top:0;left:0;right:0;z-index:99;box-shadow:0 1px 10px rgba(0,0,0,.4);padding:0!important;display:flex;place-content:center;place-items:center;flex-flow:column;height:115px!important}#chat-header-wrap #chat-header .btn-floating{position:absolute;inset:0 auto 0 1.5em;height:2.5rem;padding:0 1em}#chat-header-wrap #chat-header .icon{position:absolute;margin:0;z-index:999;width:50px;height:50px;top:0;bottom:0;left:0;right:0;border-radius:50px;background-color:#fff;display:flex;place-content:center;place-items:center}#chat-header-wrap #chat-header .icon img{width:55%;height:55%}#chat-header-wrap #chat-header .el-button.close{top:2rem;right:.5rem;position:absolute;font-size:2.3em;color:#fff}#chat-header-wrap #chat-header .el-button.btn-restart-chat{display:block;position:absolute;inset:0 .5em 0 auto;padding:0 .2em;font-size:2em;margin-top:-.1em;color:#fff;width:6rem;display:flex;place-content:center;place-items:center}#chat-header-wrap #chat-header .el-button.btn-restart-chat.new-question{height:57px;width:115px}#chat-header-wrap #chat-header .el-button.btn-restart-chat span{line-height:0}#chat-header-wrap #chat-header .el-button.btn-restart-chat svg{width:115px;aspect-ratio:115/57}#chat-header-wrap #chat-header.will.has-raw-html .icon{top:-2.5rem}#chat-header-wrap #chat-header.will.has-raw-html .slogan-desc{display:block;text-align:left;font-size:.85em;padding:.5em 1em 0}#chat-header-wrap .spacer{height:45px;display:block}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$2 = undefined;
/* module identifier */
var __vue_module_identifier__$2 = undefined;
/* functional template */
var __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

var _dec$3, _dec2$3, _dec3$3, _class$3, _class2$3, _descriptor$3, _descriptor2$3;
var BubbleContentFile = (_dec$3 = Component({}), _dec2$3 = Prop(), _dec3$3 = Getter("chat/fetchAttachmentsUploaderConfig"), _dec$3(_class$3 = (_class2$3 = /*#__PURE__*/function (_Vue) {
  function BubbleContentFile() {
    var _this;
    _classCallCheck(this, BubbleContentFile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BubbleContentFile, [].concat(args));
    _initializerDefineProperty(_this, "content", _descriptor$3, _this);
    /**
     * https://docs-demo.monksoftware.it/review-feature-5-94k298/windtre-services/custom-messages.html
     */
    _initializerDefineProperty(_this, "attachmentsUploaderConfig", _descriptor2$3, _this);
    return _this;
  }
  _inherits(BubbleContentFile, _Vue);
  return _createClass(BubbleContentFile, [{
    key: "filenameFromMessageContent",
    value: function filenameFromMessageContent(content) {
      return (content === null || content === void 0 ? void 0 : content.filename) || (content === null || content === void 0 ? void 0 : content.url.split("://")[1]) || "File";
    }
  }, {
    key: "downloadURI",
    value: function downloadURI(uri, name) {
      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      try {
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        window.open(uri, "_blank");
      }
    }
  }]);
}(Vue$2), _descriptor$3 = _applyDecoratedDescriptor(_class2$3.prototype, "content", [_dec2$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$3 = _applyDecoratedDescriptor(_class2$3.prototype, "attachmentsUploaderConfig", [_dec3$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$3)) || _class$3);

/* script */
var __vue_script__$3 = BubbleContentFile;

/* template */
var __vue_render__$3 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('el-row', {
    staticClass: "file"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 172 172"
    }
  }, [_c('g', {
    staticStyle: {
      "mix-blend-mode": "normal"
    },
    attrs: {
      "fill": "none",
      "fill-rule": "nonzero",
      "stroke": "none",
      "stroke-width": "1",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "stroke-dasharray": "",
      "stroke-dashoffset": "0",
      "font-family": "none",
      "font-weight": "none",
      "font-size": "none",
      "text-anchor": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,172v-172h172v172z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#3498db"
    }
  }, [_c('path', {
    attrs: {
      "d": "M141.65347,44.67987l-31.53333,-31.53333c-1.07787,-1.07787 -2.53413,-1.67987 -4.05347,-1.67987h-65.93333c-6.33533,0 -11.46667,5.13133 -11.46667,11.46667v126.13333c0,6.33533 5.13133,11.46667 11.46667,11.46667h91.73333c6.33533,0 11.46667,-5.13133 11.46667,-11.46667v-100.33333c0,-1.51933 -0.602,-2.9756 -1.67987,-4.05347zM97.46667,131.86667h-40.13333c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333c0,-3.1648 2.56853,-5.73333 5.73333,-5.73333h40.13333c3.1648,0 5.73333,2.56853 5.73333,5.73333c0,3.1648 -2.56853,5.73333 -5.73333,5.73333zM114.66667,108.93333h-57.33333c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333c0,-3.1648 2.56853,-5.73333 5.73333,-5.73333h57.33333c3.1648,0 5.73333,2.56853 5.73333,5.73333c0,3.1648 -2.56853,5.73333 -5.73333,5.73333zM114.66667,86h-57.33333c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333c0,-3.1648 2.56853,-5.73333 5.73333,-5.73333h57.33333c3.1648,0 5.73333,2.56853 5.73333,5.73333c0,3.1648 -2.56853,5.73333 -5.73333,5.73333zM108.93333,51.6c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333v-23.48373l29.21707,29.21707z"
    }
  })])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "0 0.3em 0 1em",
      "font-size": "1.1em"
    },
    attrs: {
      "span": 20
    }
  }, [_vm.attachmentsUploaderConfig.canDownloadAttachmentPreview ? [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function click($event) {
        _vm.downloadURI(_vm.content.url || _vm.content, _vm.filenameFromMessageContent(_vm.content));
      }
    }
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("\n          " + _vm._s(_vm._f("ellipsedFileName")(_vm.filenameFromMessageContent(_vm.content))) + "\n        ")])])] : [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("\n        " + _vm._s(_vm._f("ellipsedFileName")(_vm.filenameFromMessageContent(_vm.content))) + "\n      ")])]], 2)], 1);
};
var __vue_staticRenderFns__$3 = [];

/* style */
var __vue_inject_styles__$3 = undefined;
/* scoped */
var __vue_scope_id__$3 = "data-v-60045c34";
/* module identifier */
var __vue_module_identifier__$3 = undefined;
/* functional template */
var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var _dec$4, _dec2$4, _dec3$4, _dec4$3, _dec5$2, _dec6$2, _dec7$2, _class$4, _class2$4, _descriptor$4, _descriptor2$4, _descriptor3$3, _descriptor4$3, _descriptor5$2, _descriptor6$2;
var ChatBubbleContent = (_dec$4 = Component({
  components: {
    BubbleContentFile: __vue_component__$3
  }
}), _dec2$4 = Prop(), _dec3$4 = Prop(), _dec4$3 = Prop(), _dec5$2 = Prop(), _dec6$2 = Getter("xmpp/genesysErrorsMap"), _dec7$2 = Getter("chat/fetchAttachmentsUploaderConfig"), _dec$4(_class$4 = (_class2$4 = /*#__PURE__*/function (_Vue) {
  function ChatBubbleContent() {
    var _this;
    _classCallCheck(this, ChatBubbleContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatBubbleContent, [].concat(args));
    _defineProperty(_this, "viewerWidth", "100%");
    _defineProperty(_this, "viewerHeight", 0);
    _initializerDefineProperty(_this, "content", _descriptor$4, _this);
    _initializerDefineProperty(_this, "mam", _descriptor2$4, _this);
    _initializerDefineProperty(_this, "direction", _descriptor3$3, _this);
    _initializerDefineProperty(_this, "timestamp", _descriptor4$3, _this);
    /**
     * https://docs-demo.monksoftware.it/review-feature-5-94k298/windtre-services/custom-messages.html
     */
    _initializerDefineProperty(_this, "genesysNoticeMap", _descriptor5$2, _this);
    _initializerDefineProperty(_this, "attachmentsUploaderConfig", _descriptor6$2, _this);
    return _this;
  }
  _inherits(ChatBubbleContent, _Vue);
  return _createClass(ChatBubbleContent, [{
    key: "getIsNoticeClass",
    get: function get() {
      return this.content.hasOwnProperty("code") || this.content.is_notice ? " is-notice" : "";
    }
  }, {
    key: "getBubbleInlineClass",
    get: function get() {
      return this.mam ? " bubble-full" : this.content.is_notice ? " naked " : " bubble-inline";
    }
  }, {
    key: "getBubbleClass",
    get: function get() {
      return this.direction + this.getIsNoticeClass + this.getBubbleInlineClass;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.viewerHeight = window.innerHeight * 0.5;
    }
  }, {
    key: "canShowContentTextOrLocation",
    value: function canShowContentTextOrLocation(type) {
      return isChatText(type) || isChatLocation(type);
    }
  }, {
    key: "canShowContentUrl",
    value: function canShowContentUrl(itemContent) {
      return hasItemContentUrl(itemContent);
    }
  }, {
    key: "canShowContentHtml",
    value: function canShowContentHtml(type) {
      return isChatHtml(type);
    }
  }, {
    key: "canShowContentImage",
    value: function canShowContentImage(type) {
      return isChatImage(type);
    }
  }, {
    key: "canShowContentVideo",
    value: function canShowContentVideo(type) {
      return isChatVideo(type);
    }
  }, {
    key: "canShowContentAudio",
    value: function canShowContentAudio(type) {
      return isChatAudio(type);
    }
  }, {
    key: "canShowContentFile",
    value: function canShowContentFile(type) {
      return isChatFile(type);
    }
  }, {
    key: "canShowContentDate",
    value: function canShowContentDate(type) {
      return isChatDate(type);
    }
  }, {
    key: "canShowContentNotice",
    value: function canShowContentNotice(type) {
      return isChatNotice(type);
    }
  }, {
    key: "canShowContentLocation",
    value: function canShowContentLocation(type) {
      return isChatLocation(type);
    }
  }, {
    key: "canShowContentUrlPicture",
    value: function canShowContentUrlPicture(url) {
      return isContentUrlHasPictures(url) || isUrlImage(url);
    }
  }, {
    key: "canShowContentUrlVideos",
    value: function canShowContentUrlVideos(url) {
      return isContentUrlHasVideos(url);
    }
  }, {
    key: "canShowContentUrlAudios",
    value: function canShowContentUrlAudios(url) {
      return isContentUrlHasAudios(url);
    }
  }, {
    key: "isMessageOpeningDefault",
    value: function isMessageOpeningDefault(message) {
      return message.indexOf("--default-opening-message-bubble--") !== -1;
    }
  }, {
    key: "getSourceType",
    value: function getSourceType(content, type) {
      if (content) {
        switch (type) {
          case "video":
            return content.indexOf(".mp") !== -1 ? "video/mp4" : "video/ogg";
          case "audio":
            return content.indexOf(".mp") !== -1 ? "audio/mpeg" : "audio/ogg";
        }
      }
    }
  }, {
    key: "getGoogleDocEmbedSource",
    value: function getGoogleDocEmbedSource(url) {
      var embedded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (url) {
        return "https://docs.google.com/viewer?url=" + url + "&embedded=" + embedded;
      }
    }
  }, {
    key: "getHtmlContentWithLinkTargets",
    value: function getHtmlContentWithLinkTargets(html) {
      var htmlElement = new DOMParser().parseFromString(html, "text/html");
      var linkElements = htmlElement.getElementsByTagName("a");

      // add target="_blank" to all links before display
      for (var i = 0; i < linkElements.length; i++) {
        linkElements[i].setAttribute('target', '_blank');
      }
      return htmlElement.body.innerHTML;
    }
  }, {
    key: "getParseNewLine",
    value: function getParseNewLine(html) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "text";
      if (!html) return "";

      // convert \n into <br> tag, only for display
      var textHtmlContent = getReplacedNewlineContentWithBr(html);
      if (mode === "html") {
        return this.getHtmlContentWithLinkTargets(textHtmlContent);
      } else {
        return textHtmlContent;
      }
    }
  }, {
    key: "filenameFromMessageContent",
    value: function filenameFromMessageContent(content) {
      return (content === null || content === void 0 ? void 0 : content.filename) || (content === null || content === void 0 ? void 0 : content.url.split("://")[1]) || "File";
    }
  }, {
    key: "downloadURI",
    value: function downloadURI(uri, name) {
      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      try {
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        window.open(uri, "_blank");
      }
    }
  }, {
    key: "showImagePreviewModal",
    value: function showImagePreviewModal(uriOrHtml) {
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "html";
      console.log("preview uriOrHtml", mode, uriOrHtml);
      if (uriOrHtml && !this.isMessageOpeningDefault(uriOrHtml)) {
        var parsedUrl = isUrlValidated(uriOrHtml, true);
        if (parsedUrl) {
          var _parsedUrl = _slicedToArray(parsedUrl, 1),
            imgUrl = _parsedUrl[0];
          if (isUrlImage(imgUrl)) {
            this.$alert("<div class=\"el-image\"><img src=\"".concat(imgUrl, "\" class=\"el-image__inner\" /></div>"), "Preview", {
              customClass: "image-preview",
              center: true,
              closeOnClickModal: true,
              closeOnPressEscape: true,
              showConfirmButton: false,
              dangerouslyUseHTMLString: true
            });
          }
        }
      }
    }
  }]);
}(Vue$2), _descriptor$4 = _applyDecoratedDescriptor(_class2$4.prototype, "content", [_dec2$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$4 = _applyDecoratedDescriptor(_class2$4.prototype, "mam", [_dec3$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$3 = _applyDecoratedDescriptor(_class2$4.prototype, "direction", [_dec4$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$3 = _applyDecoratedDescriptor(_class2$4.prototype, "timestamp", [_dec5$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5$2 = _applyDecoratedDescriptor(_class2$4.prototype, "genesysNoticeMap", [_dec6$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6$2 = _applyDecoratedDescriptor(_class2$4.prototype, "attachmentsUploaderConfig", [_dec7$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$4)) || _class$4);

/* script */
var __vue_script__$4 = ChatBubbleContent;

/* template */
var __vue_render__$4 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "bubble",
    "class": _vm.getBubbleClass
  }, [_vm.canShowContentTextOrLocation(_vm.content.type) ? _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.getParseNewLine(_vm.content.text))
    }
  }) : _vm.canShowContentHtml(_vm.content.type) || _vm.content.hasOwnProperty('html') ? _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.getParseNewLine(_vm.content.html, 'html'))
    },
    on: {
      "click": function click($event) {
        return _vm.showImagePreviewModal(_vm.content.html, 'html');
      }
    }
  }) : _vm.canShowContentImage(_vm.content.type) ? [_vm.canShowContentUrl(_vm.content) ? _c('div', {
    staticClass: "bubble-image-wrapper"
  }, [_c('img', {
    staticClass: "mt-1 mb-2",
    attrs: {
      "src": _vm.content.url
    },
    on: {
      "click": function click($event) {
        return _vm.showImagePreviewModal(_vm.content.url, 'image');
      }
    }
  })]) : _vm._e()] : _vm.canShowContentVideo(_vm.content.type) ? [_c('video', {
    attrs: {
      "controls": "",
      "height": _vm.viewerHeight
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.content.payload.url,
      "type": _vm.getSourceType(_vm.content.payload.url, 'video')
    }
  })])] : _vm.canShowContentAudio(_vm.content.type) ? [_c('audio', {
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.content.payload.url,
      "type": _vm.getSourceType(_vm.content.payload.url, 'audio')
    }
  })])] : _vm.canShowContentFile(_vm.content.type) ? [_c('embed', {
    attrs: {
      "src": _vm.getGoogleDocEmbedSource(_vm.content.payload.url),
      "width": _vm.viewerWidth,
      "height": _vm.viewerHeight
    }
  })] : _vm.canShowContentDate(_vm.content.type) || _vm.content.dateType ? [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm._f("formatDate")(_vm.content.value)))])] : _vm.canShowContentNotice(_vm.content.type) && _vm.content.code ? [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.content.text))])] : _vm.canShowContentUrl(_vm.content) ? [_vm.canShowContentUrlPicture(_vm.content.url) ? [_c('div', {
    staticClass: "bubble-image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.content.url
    },
    on: {
      "click": function click($event) {
        return _vm.showImagePreviewModal(_vm.content.url, 'pictures');
      }
    }
  })])] : _vm.canShowContentUrlVideos(_vm.content.url) ? [_c('video', {
    attrs: {
      "controls": "",
      "height": _vm.viewerHeight
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.content.url,
      "type": _vm.getSourceType(_vm.content.url, 'video')
    }
  })])] : _vm.canShowContentUrlAudios(_vm.content.url) ? [_c('audio', {
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.content.url,
      "type": _vm.getSourceType(_vm.content.url, 'audio')
    }
  })])] : [_c('BubbleContentFile', {
    attrs: {
      "content": _vm.content
    }
  })]] : !_vm.content.type ? [_vm.content.hasOwnProperty('code') ? _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.genesysNoticeMap[_vm.content.code] || _vm.content.text)
    }
  }) : _c('p', {
    staticClass: "mb-0",
    domProps: {
      "innerHTML": _vm._s(_vm.getParseNewLine(_vm.content.text))
    }
  })] : _vm._e(), _vm._v(" "), _vm.timestamp && !_vm.content.hasOwnProperty('code') ? [_c('span', {
    staticClass: "timestamp"
  }, [_vm._v(_vm._s(_vm._f("getTime")(_vm.timestamp)))])] : _vm._e()], 2);
};
var __vue_staticRenderFns__$4 = [];

/* style */
var __vue_inject_styles__$4 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-05d68bb3_0", {
    source: "img[data-v-05d68bb3]{max-width:300px!important}.bubble-image-wrapper[data-v-05d68bb3]{height:130px;overflow:hidden}.bubble-image-wrapper img[data-v-05d68bb3]{width:100%;height:100%;object-fit:contain}",
    map: undefined,
    media: undefined
  }), inject("data-v-05d68bb3_1", {
    source: ".el-message-box.image-preview{max-width:45rem!important;padding-bottom:15px!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$4 = "data-v-05d68bb3";
/* module identifier */
var __vue_module_identifier__$4 = undefined;
/* functional template */
var __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

function isNumber(subject) {
  return typeof subject === 'number';
}
function isString$1(subject) {
  return typeof subject === 'string';
}
function isBoolean$1(subject) {
  return typeof subject === 'boolean';
}
function isObject$4(subject) {
  return Object.prototype.toString.call(subject) === '[object Object]';
}
function mathAbs(n) {
  return Math.abs(n);
}
function mathSign(n) {
  return Math.sign(n);
}
function deltaAbs(valueB, valueA) {
  return mathAbs(valueB - valueA);
}
function factorAbs(valueB, valueA) {
  if (valueB === 0 || valueA === 0) return 0;
  if (mathAbs(valueB) <= mathAbs(valueA)) return 0;
  const diff = deltaAbs(mathAbs(valueB), mathAbs(valueA));
  return mathAbs(diff / valueB);
}
function arrayKeys(array) {
  return objectKeys$1(array).map(Number);
}
function arrayLast(array) {
  return array[arrayLastIndex(array)];
}
function arrayLastIndex(array) {
  return Math.max(0, array.length - 1);
}
function arrayIsLastIndex(array, index) {
  return index === arrayLastIndex(array);
}
function arrayFromNumber(n, startAt = 0) {
  return Array.from(Array(n), (_, i) => startAt + i);
}
function objectKeys$1(object) {
  return Object.keys(object);
}
function objectsMergeDeep(objectA, objectB) {
  return [objectA, objectB].reduce((mergedObjects, currentObject) => {
    objectKeys$1(currentObject).forEach(key => {
      const valueA = mergedObjects[key];
      const valueB = currentObject[key];
      const areObjects = isObject$4(valueA) && isObject$4(valueB);
      mergedObjects[key] = areObjects ? objectsMergeDeep(valueA, valueB) : valueB;
    });
    return mergedObjects;
  }, {});
}
function isMouseEvent(evt, ownerWindow) {
  return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}

function Alignment(align, viewSize) {
  const predefined = {
    start,
    center,
    end
  };
  function start() {
    return 0;
  }
  function center(n) {
    return end(n) / 2;
  }
  function end(n) {
    return viewSize - n;
  }
  function measure(n, index) {
    if (isString$1(align)) return predefined[align](n);
    return align(viewSize, n, index);
  }
  const self = {
    measure
  };
  return self;
}

function EventStore() {
  let listeners = [];
  function add(node, type, handler, options = {
    passive: true
  }) {
    let removeListener;
    if ('addEventListener' in node) {
      node.addEventListener(type, handler, options);
      removeListener = () => node.removeEventListener(type, handler, options);
    } else {
      const legacyMediaQueryList = node;
      legacyMediaQueryList.addListener(handler);
      removeListener = () => legacyMediaQueryList.removeListener(handler);
    }
    listeners.push(removeListener);
    return self;
  }
  function clear() {
    listeners = listeners.filter(remove => remove());
  }
  const self = {
    add,
    clear
  };
  return self;
}

function Animations(ownerDocument, ownerWindow, update, render) {
  const documentVisibleHandler = EventStore();
  const timeStep = 1000 / 60;
  let lastTimeStamp = null;
  let lag = 0;
  let animationFrame = 0;
  function init() {
    documentVisibleHandler.add(ownerDocument, 'visibilitychange', () => {
      if (ownerDocument.hidden) reset();
    });
  }
  function destroy() {
    stop();
    documentVisibleHandler.clear();
  }
  function animate(timeStamp) {
    if (!animationFrame) return;
    if (!lastTimeStamp) lastTimeStamp = timeStamp;
    const elapsed = timeStamp - lastTimeStamp;
    lastTimeStamp = timeStamp;
    lag += elapsed;
    while (lag >= timeStep) {
      update();
      lag -= timeStep;
    }
    const lagOffset = mathAbs(lag / timeStep);
    render(lagOffset);
    if (animationFrame) ownerWindow.requestAnimationFrame(animate);
  }
  function start() {
    if (animationFrame) return;
    animationFrame = ownerWindow.requestAnimationFrame(animate);
  }
  function stop() {
    ownerWindow.cancelAnimationFrame(animationFrame);
    lastTimeStamp = null;
    lag = 0;
    animationFrame = 0;
  }
  function reset() {
    lastTimeStamp = null;
    lag = 0;
  }
  const self = {
    init,
    destroy,
    start,
    stop,
    update,
    render
  };
  return self;
}

function Axis(axis, contentDirection) {
  const isRightToLeft = contentDirection === 'rtl';
  const isVertical = axis === 'y';
  const scroll = isVertical ? 'y' : 'x';
  const cross = isVertical ? 'x' : 'y';
  const sign = !isVertical && isRightToLeft ? -1 : 1;
  const startEdge = getStartEdge();
  const endEdge = getEndEdge();
  function measureSize(nodeRect) {
    const {
      height,
      width
    } = nodeRect;
    return isVertical ? height : width;
  }
  function getStartEdge() {
    if (isVertical) return 'top';
    return isRightToLeft ? 'right' : 'left';
  }
  function getEndEdge() {
    if (isVertical) return 'bottom';
    return isRightToLeft ? 'left' : 'right';
  }
  function direction(n) {
    return n * sign;
  }
  const self = {
    scroll,
    cross,
    startEdge,
    endEdge,
    measureSize,
    direction
  };
  return self;
}

function Limit(min = 0, max = 0) {
  const length = mathAbs(min - max);
  function reachedMin(n) {
    return n < min;
  }
  function reachedMax(n) {
    return n > max;
  }
  function reachedAny(n) {
    return reachedMin(n) || reachedMax(n);
  }
  function constrain(n) {
    if (!reachedAny(n)) return n;
    return reachedMin(n) ? min : max;
  }
  function removeOffset(n) {
    if (!length) return n;
    return n - length * Math.ceil((n - max) / length);
  }
  const self = {
    length,
    max,
    min,
    constrain,
    reachedAny,
    reachedMax,
    reachedMin,
    removeOffset
  };
  return self;
}

function Counter(max, start, loop) {
  const {
    constrain
  } = Limit(0, max);
  const loopEnd = max + 1;
  let counter = withinLimit(start);
  function withinLimit(n) {
    return !loop ? constrain(n) : mathAbs((loopEnd + n) % loopEnd);
  }
  function get() {
    return counter;
  }
  function set(n) {
    counter = withinLimit(n);
    return self;
  }
  function add(n) {
    return clone().set(get() + n);
  }
  function clone() {
    return Counter(max, get(), loop);
  }
  const self = {
    get,
    set,
    add,
    clone
  };
  return self;
}

function DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
  const {
    cross: crossAxis,
    direction
  } = axis;
  const focusNodes = ['INPUT', 'SELECT', 'TEXTAREA'];
  const nonPassiveEvent = {
    passive: false
  };
  const initEvents = EventStore();
  const dragEvents = EventStore();
  const goToNextThreshold = Limit(50, 225).constrain(percentOfView.measure(20));
  const snapForceBoost = {
    mouse: 300,
    touch: 400
  };
  const freeForceBoost = {
    mouse: 500,
    touch: 600
  };
  const baseSpeed = dragFree ? 43 : 25;
  let isMoving = false;
  let startScroll = 0;
  let startCross = 0;
  let pointerIsDown = false;
  let preventScroll = false;
  let preventClick = false;
  let isMouse = false;
  function init(emblaApi) {
    if (!watchDrag) return;
    function downIfAllowed(evt) {
      if (isBoolean$1(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
    }
    const node = rootNode;
    initEvents.add(node, 'dragstart', evt => evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', () => undefined, nonPassiveEvent).add(node, 'touchend', () => undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
  }
  function destroy() {
    initEvents.clear();
    dragEvents.clear();
  }
  function addDragEvents() {
    const node = isMouse ? ownerDocument : rootNode;
    dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
  }
  function isFocusNode(node) {
    const nodeName = node.nodeName || '';
    return focusNodes.includes(nodeName);
  }
  function forceBoost() {
    const boost = dragFree ? freeForceBoost : snapForceBoost;
    const type = isMouse ? 'mouse' : 'touch';
    return boost[type];
  }
  function allowedForce(force, targetChanged) {
    const next = index.add(mathSign(force) * -1);
    const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
    if (dragFree || mathAbs(force) < goToNextThreshold) return baseForce;
    if (skipSnaps && targetChanged) return baseForce * 0.5;
    return scrollTarget.byIndex(next.get(), 0).distance;
  }
  function down(evt) {
    const isMouseEvt = isMouseEvent(evt, ownerWindow);
    isMouse = isMouseEvt;
    preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
    isMoving = deltaAbs(target.get(), location.get()) >= 2;
    if (isMouseEvt && evt.button !== 0) return;
    if (isFocusNode(evt.target)) return;
    pointerIsDown = true;
    dragTracker.pointerDown(evt);
    scrollBody.useFriction(0).useDuration(0);
    target.set(location);
    addDragEvents();
    startScroll = dragTracker.readPoint(evt);
    startCross = dragTracker.readPoint(evt, crossAxis);
    eventHandler.emit('pointerDown');
  }
  function move(evt) {
    const lastScroll = dragTracker.readPoint(evt);
    const lastCross = dragTracker.readPoint(evt, crossAxis);
    const diffScroll = deltaAbs(lastScroll, startScroll);
    const diffCross = deltaAbs(lastCross, startCross);
    if (!preventScroll && !isMouse) {
      if (!evt.cancelable) return up(evt);
      preventScroll = diffScroll > diffCross;
      if (!preventScroll) return up(evt);
    }
    const diff = dragTracker.pointerMove(evt);
    if (diffScroll > dragThreshold) preventClick = true;
    scrollBody.useFriction(0.3).useDuration(1);
    animation.start();
    target.add(direction(diff));
    evt.preventDefault();
  }
  function up(evt) {
    const currentLocation = scrollTarget.byDistance(0, false);
    const targetChanged = currentLocation.index !== index.get();
    const rawForce = dragTracker.pointerUp(evt) * forceBoost();
    const force = allowedForce(direction(rawForce), targetChanged);
    const forceFactor = factorAbs(rawForce, force);
    const speed = baseSpeed - 10 * forceFactor;
    const friction = baseFriction + forceFactor / 50;
    preventScroll = false;
    pointerIsDown = false;
    dragEvents.clear();
    scrollBody.useDuration(speed).useFriction(friction);
    scrollTo.distance(force, !dragFree);
    isMouse = false;
    eventHandler.emit('pointerUp');
  }
  function click(evt) {
    if (preventClick) {
      evt.stopPropagation();
      evt.preventDefault();
      preventClick = false;
    }
  }
  function pointerDown() {
    return pointerIsDown;
  }
  const self = {
    init,
    pointerDown,
    destroy
  };
  return self;
}

function DragTracker(axis, ownerWindow) {
  const logInterval = 170;
  let startEvent;
  let lastEvent;
  function readTime(evt) {
    return evt.timeStamp;
  }
  function readPoint(evt, evtAxis) {
    const property = evtAxis || axis.scroll;
    const coord = `client${property === 'x' ? 'X' : 'Y'}`;
    return (isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
  }
  function pointerDown(evt) {
    startEvent = evt;
    lastEvent = evt;
    return readPoint(evt);
  }
  function pointerMove(evt) {
    const diff = readPoint(evt) - readPoint(lastEvent);
    const expired = readTime(evt) - readTime(startEvent) > logInterval;
    lastEvent = evt;
    if (expired) startEvent = evt;
    return diff;
  }
  function pointerUp(evt) {
    if (!startEvent || !lastEvent) return 0;
    const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
    const diffTime = readTime(evt) - readTime(startEvent);
    const expired = readTime(evt) - readTime(lastEvent) > logInterval;
    const force = diffDrag / diffTime;
    const isFlick = diffTime && !expired && mathAbs(force) > 0.1;
    return isFlick ? force : 0;
  }
  const self = {
    pointerDown,
    pointerMove,
    pointerUp,
    readPoint
  };
  return self;
}

function NodeRects() {
  function measure(node) {
    const {
      offsetTop,
      offsetLeft,
      offsetWidth,
      offsetHeight
    } = node;
    const offset = {
      top: offsetTop,
      right: offsetLeft + offsetWidth,
      bottom: offsetTop + offsetHeight,
      left: offsetLeft,
      width: offsetWidth,
      height: offsetHeight
    };
    return offset;
  }
  const self = {
    measure
  };
  return self;
}

function PercentOfView(viewSize) {
  function measure(n) {
    return viewSize * (n / 100);
  }
  const self = {
    measure
  };
  return self;
}

function ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
  let resizeObserver;
  let containerSize;
  let slideSizes = [];
  let destroyed = false;
  function readSize(node) {
    return axis.measureSize(nodeRects.measure(node));
  }
  function init(emblaApi) {
    if (!watchResize) return;
    containerSize = readSize(container);
    slideSizes = slides.map(readSize);
    function defaultCallback(entries) {
      for (const entry of entries) {
        const isContainer = entry.target === container;
        const slideIndex = slides.indexOf(entry.target);
        const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
        const newSize = readSize(isContainer ? container : slides[slideIndex]);
        const diffSize = mathAbs(newSize - lastSize);
        if (diffSize >= 0.5) {
          ownerWindow.requestAnimationFrame(() => {
            emblaApi.reInit();
            eventHandler.emit('resize');
          });
          break;
        }
      }
    }
    resizeObserver = new ResizeObserver(entries => {
      if (destroyed) return;
      if (isBoolean$1(watchResize) || watchResize(emblaApi, entries)) {
        defaultCallback(entries);
      }
    });
    const observeNodes = [container].concat(slides);
    observeNodes.forEach(node => resizeObserver.observe(node));
  }
  function destroy() {
    if (resizeObserver) resizeObserver.disconnect();
    destroyed = true;
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function ScrollBody(location, offsetLocation, target, baseDuration, baseFriction) {
  let bodyVelocity = 0;
  let scrollDirection = 0;
  let scrollDuration = baseDuration;
  let scrollFriction = baseFriction;
  let rawLocation = location.get();
  let rawLocationPrevious = 0;
  function seek() {
    const diff = target.get() - location.get();
    const isInstant = !scrollDuration;
    let directionDiff = 0;
    if (isInstant) {
      bodyVelocity = 0;
      location.set(target);
      directionDiff = diff;
    } else {
      bodyVelocity += diff / scrollDuration;
      bodyVelocity *= scrollFriction;
      rawLocation += bodyVelocity;
      location.add(bodyVelocity);
      directionDiff = rawLocation - rawLocationPrevious;
    }
    scrollDirection = mathSign(directionDiff);
    rawLocationPrevious = rawLocation;
    return self;
  }
  function settled() {
    const diff = target.get() - offsetLocation.get();
    return mathAbs(diff) < 0.001;
  }
  function duration() {
    return scrollDuration;
  }
  function direction() {
    return scrollDirection;
  }
  function velocity() {
    return bodyVelocity;
  }
  function useBaseDuration() {
    return useDuration(baseDuration);
  }
  function useBaseFriction() {
    return useFriction(baseFriction);
  }
  function useDuration(n) {
    scrollDuration = n;
    return self;
  }
  function useFriction(n) {
    scrollFriction = n;
    return self;
  }
  const self = {
    direction,
    duration,
    velocity,
    seek,
    settled,
    useBaseFriction,
    useBaseDuration,
    useFriction,
    useDuration
  };
  return self;
}

function ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView) {
  const pullBackThreshold = percentOfView.measure(10);
  const edgeOffsetTolerance = percentOfView.measure(50);
  const frictionLimit = Limit(0.1, 0.99);
  let disabled = false;
  function shouldConstrain() {
    if (disabled) return false;
    if (!limit.reachedAny(target.get())) return false;
    if (!limit.reachedAny(offsetLocation.get())) return false;
    return true;
  }
  function constrain(pointerDown) {
    if (!shouldConstrain()) return;
    const edge = limit.reachedMin(offsetLocation.get()) ? 'min' : 'max';
    const diffToEdge = mathAbs(limit[edge] - offsetLocation.get());
    const diffToTarget = target.get() - offsetLocation.get();
    const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
    target.subtract(diffToTarget * friction);
    if (!pointerDown && mathAbs(diffToTarget) < pullBackThreshold) {
      target.set(limit.constrain(target.get()));
      scrollBody.useDuration(25).useBaseFriction();
    }
  }
  function toggleActive(active) {
    disabled = !active;
  }
  const self = {
    constrain,
    toggleActive
  };
  return self;
}

function ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
  const scrollBounds = Limit(-contentSize + viewSize, 0);
  const snapsBounded = measureBounded();
  const scrollContainLimit = findScrollContainLimit();
  const snapsContained = measureContained();
  function usePixelTolerance(bound, snap) {
    return deltaAbs(bound, snap) < 1;
  }
  function findScrollContainLimit() {
    const startSnap = snapsBounded[0];
    const endSnap = arrayLast(snapsBounded);
    const min = snapsBounded.lastIndexOf(startSnap);
    const max = snapsBounded.indexOf(endSnap) + 1;
    return Limit(min, max);
  }
  function measureBounded() {
    return snapsAligned.map((snapAligned, index) => {
      const {
        min,
        max
      } = scrollBounds;
      const snap = scrollBounds.constrain(snapAligned);
      const isFirst = !index;
      const isLast = arrayIsLastIndex(snapsAligned, index);
      if (isFirst) return max;
      if (isLast) return min;
      if (usePixelTolerance(min, snap)) return min;
      if (usePixelTolerance(max, snap)) return max;
      return snap;
    }).map(scrollBound => parseFloat(scrollBound.toFixed(3)));
  }
  function measureContained() {
    if (contentSize <= viewSize + pixelTolerance) return [scrollBounds.max];
    if (containScroll === 'keepSnaps') return snapsBounded;
    const {
      min,
      max
    } = scrollContainLimit;
    return snapsBounded.slice(min, max);
  }
  const self = {
    snapsContained,
    scrollContainLimit
  };
  return self;
}

function ScrollLimit(contentSize, scrollSnaps, loop) {
  const max = scrollSnaps[0];
  const min = loop ? max - contentSize : arrayLast(scrollSnaps);
  const limit = Limit(min, max);
  const self = {
    limit
  };
  return self;
}

function ScrollLooper(contentSize, limit, offsetLocation, vectors) {
  const jointSafety = 0.1;
  const min = limit.min + jointSafety;
  const max = limit.max + jointSafety;
  const {
    reachedMin,
    reachedMax
  } = Limit(min, max);
  function shouldLoop(direction) {
    if (direction === 1) return reachedMax(offsetLocation.get());
    if (direction === -1) return reachedMin(offsetLocation.get());
    return false;
  }
  function loop(direction) {
    if (!shouldLoop(direction)) return;
    const loopDistance = contentSize * (direction * -1);
    vectors.forEach(v => v.add(loopDistance));
  }
  const self = {
    loop
  };
  return self;
}

function ScrollProgress(limit) {
  const {
    max,
    length
  } = limit;
  function get(n) {
    const currentLocation = n - max;
    return length ? currentLocation / -length : 0;
  }
  const self = {
    get
  };
  return self;
}

function ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
  const {
    startEdge,
    endEdge
  } = axis;
  const {
    groupSlides
  } = slidesToScroll;
  const alignments = measureSizes().map(alignment.measure);
  const snaps = measureUnaligned();
  const snapsAligned = measureAligned();
  function measureSizes() {
    return groupSlides(slideRects).map(rects => arrayLast(rects)[endEdge] - rects[0][startEdge]).map(mathAbs);
  }
  function measureUnaligned() {
    return slideRects.map(rect => containerRect[startEdge] - rect[startEdge]).map(snap => -mathAbs(snap));
  }
  function measureAligned() {
    return groupSlides(snaps).map(g => g[0]).map((snap, index) => snap + alignments[index]);
  }
  const self = {
    snaps,
    snapsAligned
  };
  return self;
}

function SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
  const {
    groupSlides
  } = slidesToScroll;
  const {
    min,
    max
  } = scrollContainLimit;
  const slideRegistry = createSlideRegistry();
  function createSlideRegistry() {
    const groupedSlideIndexes = groupSlides(slideIndexes);
    const doNotContain = !containSnaps || containScroll === 'keepSnaps';
    if (scrollSnaps.length === 1) return [slideIndexes];
    if (doNotContain) return groupedSlideIndexes;
    return groupedSlideIndexes.slice(min, max).map((group, index, groups) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(groups, index);
      if (isFirst) {
        const range = arrayLast(groups[0]) + 1;
        return arrayFromNumber(range);
      }
      if (isLast) {
        const range = arrayLastIndex(slideIndexes) - arrayLast(groups)[0] + 1;
        return arrayFromNumber(range, arrayLast(groups)[0]);
      }
      return group;
    });
  }
  const self = {
    slideRegistry
  };
  return self;
}

function ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
  const {
    reachedAny,
    removeOffset,
    constrain
  } = limit;
  function minDistance(distances) {
    return distances.concat().sort((a, b) => mathAbs(a) - mathAbs(b))[0];
  }
  function findTargetSnap(target) {
    const distance = loop ? removeOffset(target) : constrain(target);
    const ascDiffsToSnaps = scrollSnaps.map((snap, index) => ({
      diff: shortcut(snap - distance, 0),
      index
    })).sort((d1, d2) => mathAbs(d1.diff) - mathAbs(d2.diff));
    const {
      index
    } = ascDiffsToSnaps[0];
    return {
      index,
      distance
    };
  }
  function shortcut(target, direction) {
    const targets = [target, target + contentSize, target - contentSize];
    if (!loop) return targets[0];
    if (!direction) return minDistance(targets);
    const matchingTargets = targets.filter(t => mathSign(t) === direction);
    if (matchingTargets.length) return minDistance(matchingTargets);
    return arrayLast(targets) - contentSize;
  }
  function byIndex(index, direction) {
    const diffToSnap = scrollSnaps[index] - targetVector.get();
    const distance = shortcut(diffToSnap, direction);
    return {
      index,
      distance
    };
  }
  function byDistance(distance, snap) {
    const target = targetVector.get() + distance;
    const {
      index,
      distance: targetSnapDistance
    } = findTargetSnap(target);
    const reachedBound = !loop && reachedAny(target);
    if (!snap || reachedBound) return {
      index,
      distance
    };
    const diffToSnap = scrollSnaps[index] - targetSnapDistance;
    const snapDistance = distance + shortcut(diffToSnap, 0);
    return {
      index,
      distance: snapDistance
    };
  }
  const self = {
    byDistance,
    byIndex,
    shortcut
  };
  return self;
}

function ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
  function scrollTo(target) {
    const distanceDiff = target.distance;
    const indexDiff = target.index !== indexCurrent.get();
    targetVector.add(distanceDiff);
    if (distanceDiff) {
      if (scrollBody.duration()) {
        animation.start();
      } else {
        animation.update();
        animation.render(1);
        animation.update();
      }
    }
    if (indexDiff) {
      indexPrevious.set(indexCurrent.get());
      indexCurrent.set(target.index);
      eventHandler.emit('select');
    }
  }
  function distance(n, snap) {
    const target = scrollTarget.byDistance(n, snap);
    scrollTo(target);
  }
  function index(n, direction) {
    const targetIndex = indexCurrent.clone().set(n);
    const target = scrollTarget.byIndex(targetIndex.get(), direction);
    scrollTo(target);
  }
  const self = {
    distance,
    index
  };
  return self;
}

function SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore) {
  let lastTabPressTime = 0;
  function init() {
    eventStore.add(document, 'keydown', registerTabPress, false);
    slides.forEach(addSlideFocusEvent);
  }
  function registerTabPress(event) {
    if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
  }
  function addSlideFocusEvent(slide) {
    const focus = () => {
      const nowTime = new Date().getTime();
      const diffTime = nowTime - lastTabPressTime;
      if (diffTime > 10) return;
      root.scrollLeft = 0;
      const index = slides.indexOf(slide);
      const group = slideRegistry.findIndex(group => group.includes(index));
      if (!isNumber(group)) return;
      scrollBody.useDuration(0);
      scrollTo.index(group, 0);
    };
    eventStore.add(slide, 'focus', focus, {
      passive: true,
      capture: true
    });
  }
  const self = {
    init
  };
  return self;
}

function Vector1D(initialValue) {
  let value = initialValue;
  function get() {
    return value;
  }
  function set(n) {
    value = normalizeInput(n);
  }
  function add(n) {
    value += normalizeInput(n);
  }
  function subtract(n) {
    value -= normalizeInput(n);
  }
  function normalizeInput(n) {
    return isNumber(n) ? n : n.get();
  }
  const self = {
    get,
    set,
    add,
    subtract
  };
  return self;
}

function Translate(axis, container) {
  const translate = axis.scroll === 'x' ? x : y;
  const containerStyle = container.style;
  let disabled = false;
  function x(n) {
    return `translate3d(${n}px,0px,0px)`;
  }
  function y(n) {
    return `translate3d(0px,${n}px,0px)`;
  }
  function to(target) {
    if (disabled) return;
    containerStyle.transform = translate(axis.direction(target));
  }
  function toggleActive(active) {
    disabled = !active;
  }
  function clear() {
    if (disabled) return;
    containerStyle.transform = '';
    if (!container.getAttribute('style')) container.removeAttribute('style');
  }
  const self = {
    clear,
    to,
    toggleActive
  };
  return self;
}

function SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides) {
  const roundingSafety = 0.5;
  const ascItems = arrayKeys(slideSizesWithGaps);
  const descItems = arrayKeys(slideSizesWithGaps).reverse();
  const loopPoints = startPoints().concat(endPoints());
  function removeSlideSizes(indexes, from) {
    return indexes.reduce((a, i) => {
      return a - slideSizesWithGaps[i];
    }, from);
  }
  function slidesInGap(indexes, gap) {
    return indexes.reduce((a, i) => {
      const remainingGap = removeSlideSizes(a, gap);
      return remainingGap > 0 ? a.concat([i]) : a;
    }, []);
  }
  function findSlideBounds(offset) {
    return snaps.map((snap, index) => ({
      start: snap - slideSizes[index] + roundingSafety + offset,
      end: snap + viewSize - roundingSafety + offset
    }));
  }
  function findLoopPoints(indexes, offset, isEndEdge) {
    const slideBounds = findSlideBounds(offset);
    return indexes.map(index => {
      const initial = isEndEdge ? 0 : -contentSize;
      const altered = isEndEdge ? contentSize : 0;
      const boundEdge = isEndEdge ? 'end' : 'start';
      const loopPoint = slideBounds[index][boundEdge];
      return {
        index,
        loopPoint,
        slideLocation: Vector1D(-1),
        translate: Translate(axis, slides[index]),
        target: () => offsetLocation.get() > loopPoint ? initial : altered
      };
    });
  }
  function startPoints() {
    const gap = scrollSnaps[0];
    const indexes = slidesInGap(descItems, gap);
    return findLoopPoints(indexes, contentSize, false);
  }
  function endPoints() {
    const gap = viewSize - scrollSnaps[0] - 1;
    const indexes = slidesInGap(ascItems, gap);
    return findLoopPoints(indexes, -contentSize, true);
  }
  function canLoop() {
    return loopPoints.every(({
      index
    }) => {
      const otherIndexes = ascItems.filter(i => i !== index);
      return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
    });
  }
  function loop() {
    loopPoints.forEach(loopPoint => {
      const {
        target,
        translate,
        slideLocation
      } = loopPoint;
      const shiftLocation = target();
      if (shiftLocation === slideLocation.get()) return;
      translate.to(shiftLocation);
      slideLocation.set(shiftLocation);
    });
  }
  function clear() {
    loopPoints.forEach(loopPoint => loopPoint.translate.clear());
  }
  const self = {
    canLoop,
    clear,
    loop,
    loopPoints
  };
  return self;
}

function SlidesHandler(container, eventHandler, watchSlides) {
  let mutationObserver;
  let destroyed = false;
  function init(emblaApi) {
    if (!watchSlides) return;
    function defaultCallback(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          emblaApi.reInit();
          eventHandler.emit('slidesChanged');
          break;
        }
      }
    }
    mutationObserver = new MutationObserver(mutations => {
      if (destroyed) return;
      if (isBoolean$1(watchSlides) || watchSlides(emblaApi, mutations)) {
        defaultCallback(mutations);
      }
    });
    mutationObserver.observe(container, {
      childList: true
    });
  }
  function destroy() {
    if (mutationObserver) mutationObserver.disconnect();
    destroyed = true;
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function SlidesInView(container, slides, eventHandler, threshold) {
  const intersectionEntryMap = {};
  let inViewCache = null;
  let notInViewCache = null;
  let intersectionObserver;
  let destroyed = false;
  function init() {
    intersectionObserver = new IntersectionObserver(entries => {
      if (destroyed) return;
      entries.forEach(entry => {
        const index = slides.indexOf(entry.target);
        intersectionEntryMap[index] = entry;
      });
      inViewCache = null;
      notInViewCache = null;
      eventHandler.emit('slidesInView');
    }, {
      root: container.parentElement,
      threshold
    });
    slides.forEach(slide => intersectionObserver.observe(slide));
  }
  function destroy() {
    if (intersectionObserver) intersectionObserver.disconnect();
    destroyed = true;
  }
  function createInViewList(inView) {
    return objectKeys$1(intersectionEntryMap).reduce((list, slideIndex) => {
      const index = parseInt(slideIndex);
      const {
        isIntersecting
      } = intersectionEntryMap[index];
      const inViewMatch = inView && isIntersecting;
      const notInViewMatch = !inView && !isIntersecting;
      if (inViewMatch || notInViewMatch) list.push(index);
      return list;
    }, []);
  }
  function get(inView = true) {
    if (inView && inViewCache) return inViewCache;
    if (!inView && notInViewCache) return notInViewCache;
    const slideIndexes = createInViewList(inView);
    if (inView) inViewCache = slideIndexes;
    if (!inView) notInViewCache = slideIndexes;
    return slideIndexes;
  }
  const self = {
    init,
    destroy,
    get
  };
  return self;
}

function SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
  const {
    measureSize,
    startEdge,
    endEdge
  } = axis;
  const withEdgeGap = slideRects[0] && readEdgeGap;
  const startGap = measureStartGap();
  const endGap = measureEndGap();
  const slideSizes = slideRects.map(measureSize);
  const slideSizesWithGaps = measureWithGaps();
  function measureStartGap() {
    if (!withEdgeGap) return 0;
    const slideRect = slideRects[0];
    return mathAbs(containerRect[startEdge] - slideRect[startEdge]);
  }
  function measureEndGap() {
    if (!withEdgeGap) return 0;
    const style = ownerWindow.getComputedStyle(arrayLast(slides));
    return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
  }
  function measureWithGaps() {
    return slideRects.map((rect, index, rects) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(rects, index);
      if (isFirst) return slideSizes[index] + startGap;
      if (isLast) return slideSizes[index] + endGap;
      return rects[index + 1][startEdge] - rect[startEdge];
    }).map(mathAbs);
  }
  const self = {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  };
  return self;
}

function SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
  const {
    startEdge,
    endEdge,
    direction
  } = axis;
  const groupByNumber = isNumber(slidesToScroll);
  function byNumber(array, groupSize) {
    return arrayKeys(array).filter(i => i % groupSize === 0).map(i => array.slice(i, i + groupSize));
  }
  function bySize(array) {
    if (!array.length) return [];
    return arrayKeys(array).reduce((groups, rectB, index) => {
      const rectA = arrayLast(groups) || 0;
      const isFirst = rectA === 0;
      const isLast = rectB === arrayLastIndex(array);
      const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
      const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
      const gapA = !loop && isFirst ? direction(startGap) : 0;
      const gapB = !loop && isLast ? direction(endGap) : 0;
      const chunkSize = mathAbs(edgeB - gapB - (edgeA + gapA));
      if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
      if (isLast) groups.push(array.length);
      return groups;
    }, []).map((currentSize, index, groups) => {
      const previousSize = Math.max(groups[index - 1] || 0);
      return array.slice(previousSize, currentSize);
    });
  }
  function groupSlides(array) {
    return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
  }
  const self = {
    groupSlides
  };
  return self;
}

function Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
  // Options
  const {
    align,
    axis: scrollAxis,
    direction,
    startIndex,
    loop,
    duration,
    dragFree,
    dragThreshold,
    inViewThreshold,
    slidesToScroll: groupSlides,
    skipSnaps,
    containScroll,
    watchResize,
    watchSlides,
    watchDrag
  } = options;
  // Measurements
  const pixelTolerance = 2;
  const nodeRects = NodeRects();
  const containerRect = nodeRects.measure(container);
  const slideRects = slides.map(nodeRects.measure);
  const axis = Axis(scrollAxis, direction);
  const viewSize = axis.measureSize(containerRect);
  const percentOfView = PercentOfView(viewSize);
  const alignment = Alignment(align, viewSize);
  const containSnaps = !loop && !!containScroll;
  const readEdgeGap = loop || !!containScroll;
  const {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  } = SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
  const slidesToScroll = SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
  const {
    snaps,
    snapsAligned
  } = ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
  const contentSize = -arrayLast(snaps) + arrayLast(slideSizesWithGaps);
  const {
    snapsContained,
    scrollContainLimit
  } = ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
  const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
  const {
    limit
  } = ScrollLimit(contentSize, scrollSnaps, loop);
  // Indexes
  const index = Counter(arrayLastIndex(scrollSnaps), startIndex, loop);
  const indexPrevious = index.clone();
  const slideIndexes = arrayKeys(slides);
  // Animation
  const update = ({
    dragHandler,
    scrollBody,
    scrollBounds,
    options: {
      loop
    }
  }) => {
    if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
    scrollBody.seek();
  };
  const render = ({
    scrollBody,
    translate,
    location,
    offsetLocation,
    scrollLooper,
    slideLooper,
    dragHandler,
    animation,
    eventHandler,
    options: {
      loop
    }
  }, lagOffset) => {
    const velocity = scrollBody.velocity();
    const hasSettled = scrollBody.settled();
    if (hasSettled && !dragHandler.pointerDown()) {
      animation.stop();
      eventHandler.emit('settle');
    }
    if (!hasSettled) eventHandler.emit('scroll');
    offsetLocation.set(location.get() - velocity + velocity * lagOffset);
    if (loop) {
      scrollLooper.loop(scrollBody.direction());
      slideLooper.loop();
    }
    translate.to(offsetLocation.get());
  };
  const animation = Animations(ownerDocument, ownerWindow, () => update(engine), lagOffset => render(engine, lagOffset));
  // Shared
  const friction = 0.68;
  const startLocation = scrollSnaps[index.get()];
  const location = Vector1D(startLocation);
  const offsetLocation = Vector1D(startLocation);
  const target = Vector1D(startLocation);
  const scrollBody = ScrollBody(location, offsetLocation, target, duration, friction);
  const scrollTarget = ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
  const scrollTo = ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
  const scrollProgress = ScrollProgress(limit);
  const eventStore = EventStore();
  const slidesInView = SlidesInView(container, slides, eventHandler, inViewThreshold);
  const {
    slideRegistry
  } = SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
  const slideFocus = SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore);
  // Engine
  const engine = {
    ownerDocument,
    ownerWindow,
    eventHandler,
    containerRect,
    slideRects,
    animation,
    axis,
    dragHandler: DragHandler(axis, root, ownerDocument, ownerWindow, target, DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
    eventStore,
    percentOfView,
    index,
    indexPrevious,
    limit,
    location,
    offsetLocation,
    options,
    resizeHandler: ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
    scrollBody,
    scrollBounds: ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
    scrollLooper: ScrollLooper(contentSize, limit, offsetLocation, [location, offsetLocation, target]),
    scrollProgress,
    scrollSnapList: scrollSnaps.map(scrollProgress.get),
    scrollSnaps,
    scrollTarget,
    scrollTo,
    slideLooper: SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
    slideFocus,
    slidesHandler: SlidesHandler(container, eventHandler, watchSlides),
    slidesInView,
    slideIndexes,
    slideRegistry,
    slidesToScroll,
    target,
    translate: Translate(axis, container)
  };
  return engine;
}

function EventHandler() {
  const listeners = {};
  let api;
  function init(emblaApi) {
    api = emblaApi;
  }
  function getListeners(evt) {
    return listeners[evt] || [];
  }
  function emit(evt) {
    getListeners(evt).forEach(e => e(api, evt));
    return self;
  }
  function on(evt, cb) {
    listeners[evt] = getListeners(evt).concat([cb]);
    return self;
  }
  function off(evt, cb) {
    listeners[evt] = getListeners(evt).filter(e => e !== cb);
    return self;
  }
  const self = {
    init,
    emit,
    off,
    on
  };
  return self;
}

const defaultOptions = {
  align: 'center',
  axis: 'x',
  container: null,
  slides: null,
  containScroll: 'trimSnaps',
  direction: 'ltr',
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: false,
  dragThreshold: 10,
  loop: false,
  skipSnaps: false,
  duration: 25,
  startIndex: 0,
  active: true,
  watchDrag: true,
  watchResize: true,
  watchSlides: true
};

function OptionsHandler(ownerWindow) {
  function mergeOptions(optionsA, optionsB) {
    return objectsMergeDeep(optionsA, optionsB || {});
  }
  function optionsAtMedia(options) {
    const optionsAtMedia = options.breakpoints || {};
    const matchedMediaOptions = objectKeys$1(optionsAtMedia).filter(media => ownerWindow.matchMedia(media).matches).map(media => optionsAtMedia[media]).reduce((a, mediaOption) => mergeOptions(a, mediaOption), {});
    return mergeOptions(options, matchedMediaOptions);
  }
  function optionsMediaQueries(optionsList) {
    return optionsList.map(options => objectKeys$1(options.breakpoints || {})).reduce((acc, mediaQueries) => acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
  }
  const self = {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  };
  return self;
}

function PluginsHandler(optionsHandler) {
  let activePlugins = [];
  function init(emblaApi, plugins) {
    activePlugins = plugins.filter(({
      options
    }) => optionsHandler.optionsAtMedia(options).active !== false);
    activePlugins.forEach(plugin => plugin.init(emblaApi, optionsHandler));
    return plugins.reduce((map, plugin) => Object.assign(map, {
      [plugin.name]: plugin
    }), {});
  }
  function destroy() {
    activePlugins = activePlugins.filter(plugin => plugin.destroy());
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function EmblaCarousel(root, userOptions, userPlugins) {
  const ownerDocument = root.ownerDocument;
  const ownerWindow = ownerDocument.defaultView;
  const optionsHandler = OptionsHandler(ownerWindow);
  const pluginsHandler = PluginsHandler(optionsHandler);
  const mediaHandlers = EventStore();
  const eventHandler = EventHandler();
  const {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  } = optionsHandler;
  const {
    on,
    off,
    emit
  } = eventHandler;
  const reInit = reActivate;
  let destroyed = false;
  let engine;
  let optionsBase = mergeOptions(defaultOptions, EmblaCarousel.globalOptions);
  let options = mergeOptions(optionsBase);
  let pluginList = [];
  let pluginApis;
  let container;
  let slides;
  function storeElements() {
    const {
      container: userContainer,
      slides: userSlides
    } = options;
    const customContainer = isString$1(userContainer) ? root.querySelector(userContainer) : userContainer;
    container = customContainer || root.children[0];
    const customSlides = isString$1(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
    slides = [].slice.call(customSlides || container.children);
  }
  function createEngine(options) {
    const engine = Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
    if (options.loop && !engine.slideLooper.canLoop()) {
      const optionsWithoutLoop = Object.assign({}, options, {
        loop: false
      });
      return createEngine(optionsWithoutLoop);
    }
    return engine;
  }
  function activate(withOptions, withPlugins) {
    if (destroyed) return;
    optionsBase = mergeOptions(optionsBase, withOptions);
    options = optionsAtMedia(optionsBase);
    pluginList = withPlugins || pluginList;
    storeElements();
    engine = createEngine(options);
    optionsMediaQueries([optionsBase, ...pluginList.map(({
      options
    }) => options)]).forEach(query => mediaHandlers.add(query, 'change', reActivate));
    if (!options.active) return;
    engine.translate.to(engine.location.get());
    engine.animation.init();
    engine.slidesInView.init();
    engine.slideFocus.init();
    engine.eventHandler.init(self);
    engine.resizeHandler.init(self);
    engine.slidesHandler.init(self);
    if (engine.options.loop) engine.slideLooper.loop();
    if (container.offsetParent && slides.length) engine.dragHandler.init(self);
    pluginApis = pluginsHandler.init(self, pluginList);
  }
  function reActivate(withOptions, withPlugins) {
    const startIndex = selectedScrollSnap();
    deActivate();
    activate(mergeOptions({
      startIndex
    }, withOptions), withPlugins);
    eventHandler.emit('reInit');
  }
  function deActivate() {
    engine.dragHandler.destroy();
    engine.eventStore.clear();
    engine.translate.clear();
    engine.slideLooper.clear();
    engine.resizeHandler.destroy();
    engine.slidesHandler.destroy();
    engine.slidesInView.destroy();
    engine.animation.destroy();
    pluginsHandler.destroy();
    mediaHandlers.clear();
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    mediaHandlers.clear();
    deActivate();
    eventHandler.emit('destroy');
  }
  function scrollTo(index, jump, direction) {
    if (!options.active || destroyed) return;
    engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
    engine.scrollTo.index(index, direction || 0);
  }
  function scrollNext(jump) {
    const next = engine.index.add(1).get();
    scrollTo(next, jump, -1);
  }
  function scrollPrev(jump) {
    const prev = engine.index.add(-1).get();
    scrollTo(prev, jump, 1);
  }
  function canScrollNext() {
    const next = engine.index.add(1).get();
    return next !== selectedScrollSnap();
  }
  function canScrollPrev() {
    const prev = engine.index.add(-1).get();
    return prev !== selectedScrollSnap();
  }
  function scrollSnapList() {
    return engine.scrollSnapList;
  }
  function scrollProgress() {
    return engine.scrollProgress.get(engine.location.get());
  }
  function selectedScrollSnap() {
    return engine.index.get();
  }
  function previousScrollSnap() {
    return engine.indexPrevious.get();
  }
  function slidesInView() {
    return engine.slidesInView.get();
  }
  function slidesNotInView() {
    return engine.slidesInView.get(false);
  }
  function plugins() {
    return pluginApis;
  }
  function internalEngine() {
    return engine;
  }
  function rootNode() {
    return root;
  }
  function containerNode() {
    return container;
  }
  function slideNodes() {
    return slides;
  }
  const self = {
    canScrollNext,
    canScrollPrev,
    containerNode,
    internalEngine,
    destroy,
    off,
    on,
    emit,
    plugins,
    previousScrollSnap,
    reInit,
    rootNode,
    scrollNext,
    scrollPrev,
    scrollProgress,
    scrollSnapList,
    scrollTo,
    selectedScrollSnap,
    slideNodes,
    slidesInView,
    slidesNotInView
  };
  activate(userOptions, userPlugins);
  setTimeout(() => eventHandler.emit('init'), 0);
  return self;
}
EmblaCarousel.globalOptions = undefined;

var EmblaCarouselService = {
  loadCarousel: function loadCarousel() {
    var _this = this;
    var initCarousel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
      _newArrowCheck(this, _this);
    }.bind(this);
    // options is other carousel related configs
    initCarousel();
  },
  // ex. ref
  // https://www.embla-carousel.com/get-started/cdn/
  initEmblaCarousel: function initEmblaCarousel(elementSelector) {
    var _this2 = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (params) {
      _newArrowCheck(this, _this2);
    }.bind(this);
    var emblaOptions = _objectSpread2({
      // align: 'start',
      loop: false,
      skipSnaps: true
    }, options);
    var emblaNode = document.getElementById(elementSelector);
    var viewportNode = emblaNode.querySelector('.embla__viewport');
    var emblaApi = EmblaCarousel(viewportNode, emblaOptions);
    callback({
      status: "completed",
      emblaApi: emblaApi
    });
  }
};

var _this$5 = this;
var script = {
  props: {
    isDisabled: {
      type: Boolean,
      "default": false,
      description: "Carousel is disable"
    },
    isChoiceSelectionMultiple: {
      type: Boolean,
      "default": false,
      description: "Flag to confirm carousel choice selection is a multiple choice"
    },
    carouselId: {
      type: String,
      required: true,
      description: "The carousel container id, it must be unique."
    },
    dataItems: {
      type: Array,
      "default": function _default() {
        _newArrowCheck(this, _this$5);
        return [];
      }.bind(this),
      description: "Carousel list item"
    },
    onAfterChoiceSelected: {
      type: Function,
      "default": function _default() {
        _newArrowCheck(this, _this$5);
      }.bind(this),
      description: "Trigger after choice selection"
    }
  },
  data: function data() {
    return {
      selectedMultipleItems: []
    };
  },
  computed: {
    getCarouselWrapperClass: function getCarouselWrapperClass() {
      return this.isDisabled ? "embla disabled" : "embla";
    }
  },
  mounted: function mounted() {
    console.log("carouselItems: ", JSON.stringify(this.dataItems));
    this.handleLoadCarousel();
  },
  methods: {
    canShowCarouselItem: function canShowCarouselItem(item) {
      if (!item) return false;
      var content = item.content;
      var _content = _slicedToArray(content, 1),
        itemContent = _content[0];
      return !!itemContent;
    },
    canShowCarouselImage: function canShowCarouselImage(itemContent) {
      var url = itemContent.url;
      return url && isUrlImage(url);
    },
    canShowCarouselCaption: function canShowCarouselCaption(itemContent) {
      var caption = itemContent.caption;
      return caption && isContentNotEmpty(caption);
    },
    isMultipleChoiceItemSelected: function isMultipleChoiceItemSelected(selectedItem) {
      var _this2 = this;
      return !!this.selectedMultipleItems.find(function (item) {
        _newArrowCheck(this, _this2);
        return selectedItem.command === item.command;
      }.bind(this));
    },
    getCarouselItemClass: function getCarouselItemClass(item) {
      return this.isMultipleChoiceItemSelected(item) ? "embla__slide selected" : "embla__slide";
    },
    getRemainingMultipleChoiceItem: function getRemainingMultipleChoiceItem(selectedItem) {
      var _this3 = this;
      return this.selectedMultipleItems.filter(function (item) {
        _newArrowCheck(this, _this3);
        return item.command !== selectedItem.command;
      }.bind(this));
    },
    getCarouselItemUrl: function getCarouselItemUrl(itemContent) {
      if (!itemContent) return "";
      var url = itemContent.url;
      return url || "";
    },
    getCarouselItemCaption: function getCarouselItemCaption(itemContent) {
      if (!itemContent) return "";
      var caption = itemContent.caption;
      return caption || "";
    },
    handleLoadCarousel: function handleLoadCarousel() {
      var _this4 = this;
      EmblaCarouselService.loadCarousel(function () {
        _newArrowCheck(this, _this4);
        this.handleInitCarousel();
      }.bind(this));
    },
    handleInitCarousel: function handleInitCarousel() {
      var _this5 = this;
      EmblaCarouselService.initEmblaCarousel(this.carouselId, {}, function (params) {
        _newArrowCheck(this, _this5);
        console.log("callback params: ", params);
      }.bind(this));
    },
    handleChoiceMultipleSelection: function handleChoiceMultipleSelection(item) {
      if (this.isMultipleChoiceItemSelected(item)) {
        this.selectedMultipleItems = _toConsumableArray(this.getRemainingMultipleChoiceItem(item));
      } else {
        this.selectedMultipleItems = [].concat(_toConsumableArray(this.selectedMultipleItems), [item]);
      }
    },
    onClickCarouselItem: function onClickCarouselItem(item) {
      if (!this.isDisabled) {
        if (this.isChoiceSelectionMultiple) {
          this.handleChoiceMultipleSelection(item);
          this.onAfterChoiceSelected({
            multipleChoiceItems: _toConsumableArray(this.selectedMultipleItems),
            isChoiceSelectionMultiple: this.isChoiceSelectionMultiple
          });
        } else {
          this.onAfterChoiceSelected({
            singleChoiceItem: item,
            isChoiceSelectionMultiple: this.isChoiceSelectionMultiple
          });
        }
      }
    }
  }
};

/* script */
var __vue_script__$5 = script;

/* template */
var __vue_render__$5 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('section', {
    "class": _vm.getCarouselWrapperClass,
    attrs: {
      "id": _vm.carouselId
    }
  }, [_c('div', {
    staticClass: "embla__viewport"
  }, [_c('div', {
    staticClass: "embla__container"
  }, _vm._l(_vm.dataItems, function (item) {
    return _c('div', {
      key: "" + item.command,
      "class": _vm.getCarouselItemClass(item),
      on: {
        "click": function click($event) {
          return _vm.onClickCarouselItem(item);
        }
      }
    }, [_c('div', {
      staticClass: "embla__slide__item"
    }, [_vm.canShowCarouselItem(item) ? _c('div', {
      staticClass: "carousel-bubble-item"
    }, [_vm.canShowCarouselImage(item.content[0]) ? _c('div', {
      staticClass: "carousel-item-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.getCarouselItemUrl(item.content[0])
      }
    })]) : _vm._e(), _vm._v(" "), _vm.canShowCarouselCaption(item.content[0]) ? _c('div', {
      staticClass: "carousel-item-caption",
      domProps: {
        "innerHTML": _vm._s(_vm.getCarouselItemCaption(item.content[0]))
      }
    }) : _vm._e()]) : _vm._e()])]);
  }), 0)])]);
};
var __vue_staticRenderFns__$5 = [];

/* style */
var __vue_inject_styles__$5 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-13ce958b_0", {
    source: ".embla[data-v-13ce958b]{max-width:48rem;margin:auto;--detail-medium-contrast:rgb(234, 234, 234);--slide-height:8rem;--slide-spacing:1rem;--slide-size:70%;margin:1rem 0}.embla__viewport[data-v-13ce958b]{overflow:hidden}.embla__container[data-v-13ce958b]{display:flex;touch-action:pan-y pinch-zoom}.embla__slide[data-v-13ce958b]{transform:translate3d(0,0,0);box-shadow:inset 0 0 0 .1rem var(--detail-medium-contrast);flex:0 0 var(--slide-size);min-width:0;background-color:#fff;border-radius:1rem;user-select:none;margin:0 .5rem;overflow:hidden;cursor:pointer}.embla__slide.selected[data-v-13ce958b]{box-shadow:inset 0 0 0 .1rem #225080;border:2px solid #225080}.disabled[data-v-13ce958b]{opacity:.7}.disabled .embla__slide[data-v-13ce958b]{cursor:auto}.embla__slide__item[data-v-13ce958b]{user-select:none}.embla__slide__item .carousel-bubble-item .carousel-item-image[data-v-13ce958b]{height:100px;overflow:hidden}.embla__slide__item .carousel-bubble-item .carousel-item-image img[data-v-13ce958b]{width:100%;height:100%;object-fit:cover;margin:0!important}.embla__slide__item .carousel-bubble-item .carousel-item-caption[data-v-13ce958b]{margin-top:10px}.embla__slide__item .carousel-bubble-item .carousel-item-caption p[data-v-13ce958b]{width:100%;text-align:center}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$5 = "data-v-13ce958b";
/* module identifier */
var __vue_module_identifier__$5 = undefined;
/* functional template */
var __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

var _dec$5, _dec2$5, _dec3$5, _dec4$4, _dec5$3, _class$5, _class2$5, _descriptor$5, _descriptor2$5, _descriptor3$4, _descriptor4$4;
var BubbleContentChoices = (_dec$5 = Component({
  components: {
    EmblaCarouselChoices: __vue_component__$5
  }
}), _dec2$5 = Prop(), _dec3$5 = Prop(), _dec4$4 = Getter("chat/getCurrentChatMessages"), _dec5$3 = Getter("chat/getBotConfigSettings"), _dec$5(_class$5 = (_class2$5 = /*#__PURE__*/function (_Vue) {
  function BubbleContentChoices() {
    var _this;
    _classCallCheck(this, BubbleContentChoices);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BubbleContentChoices, [].concat(args));
    _defineProperty(_this, "isOptionVisible", true);
    _defineProperty(_this, "isSubmitMultipleChoiceEnabled", false);
    _defineProperty(_this, "selectedMultipleChoices", []);
    _defineProperty(_this, "userInput", "");
    _initializerDefineProperty(_this, "chatBubbleId", _descriptor$5, _this);
    _initializerDefineProperty(_this, "metas", _descriptor2$5, _this);
    _initializerDefineProperty(_this, "getCurrentChatMessages", _descriptor3$4, _this);
    _initializerDefineProperty(_this, "getBotConfigSettings", _descriptor4$4, _this);
    return _this;
  }
  _inherits(BubbleContentChoices, _Vue);
  return _createClass(BubbleContentChoices, [{
    key: "getCarouselId",
    get: function get() {
      return "carousel-id-".concat(this.chatBubbleId);
    }
  }, {
    key: "isOptionEnabled",
    get: function get() {
      var _this2 = this;
      var isLastChoice = this.getCurrentChatMessages.findIndex(function (m, k) {
        _newArrowCheck(this, _this2);
        return m === this.metas;
      }.bind(this)) === this.getCurrentChatMessages.length - 1;
      return isLastChoice;
    }
  }, {
    key: "isSelectionModeInputChoices",
    get: function get() {
      return !this.isSelectionModeInput && this.metas.payload.inputData.choice;
    }
  }, {
    key: "isSelectionModeInput",
    get: function get() {
      return this.metas.payload.layout.selectionMode === "input";
    }
  }, {
    key: "isChoiceSelectionMultiple",
    get: function get() {
      return isChoiceSelectionMultiple(this.metas.payload.layout.selectionMode);
    }
  }, {
    key: "listChoicesData",
    get: function get() {
      return this.metas.payload.inputData.choice.list;
    }
  }, {
    key: "canHandleMultipleChoiceList",
    get: function get() {
      return this.isOptionVisible && this.isOptionEnabled && !this.isSelectionModeInput;
    }
  }, {
    key: "canShowContentText",
    value: function canShowContentText(type) {
      return isChatText(type);
    }
  }, {
    key: "canShowContentImage",
    value: function canShowContentImage(type) {
      return isChatImage(type);
    }
  }, {
    key: "canShowCarouselChoices",
    value: function canShowCarouselChoices(metas) {
      return isSelectionModeCarouselChoices(metas);
    }
  }, {
    key: "canShowSingleListChoices",
    value: function canShowSingleListChoices(metas) {
      // if node is single choice
      var singleChoiceLimitCount = this.getBotConfigSettings.singleChoiceLimitCount;
      return !isChoiceSelectionModeSingleAutocomplete(metas, singleChoiceLimitCount);
    }
  }, {
    key: "canShowMultipleListChoices",
    value: function canShowMultipleListChoices(metas) {
      // if node is multiple choice
      var multipleChoiceLimitCount = this.getBotConfigSettings.multipleChoiceLimitCount;
      return !isChoiceSelectionModeMultipleAutocomplete(metas, multipleChoiceLimitCount);
    }
  }, {
    key: "canShowSingleMultipleListChoices",
    value: function canShowSingleMultipleListChoices(metas) {
      if (isNodeSingleChoiceList(metas)) {
        // if node is single choice
        return this.canShowSingleListChoices(metas);
      } else if (isNodeMultipleChoiceList(metas)) {
        // if node is multiple choice
        return this.canShowMultipleListChoices(metas);
      } else {
        return false;
      }
    }
  }, {
    key: "canShowButtonMultipleChoiceSubmit",
    value: function canShowButtonMultipleChoiceSubmit(metas) {
      return this.canShowMultipleListChoices(metas) && metas.payload.inputData.choice.submit;
    }
  }, {
    key: "handleRemoveOption",
    value: function handleRemoveOption(option) {
      var _this3 = this;
      var remainingChoices = this.selectedMultipleChoices.filter(function (item) {
        _newArrowCheck(this, _this3);
        return item.command !== option.command;
      }.bind(this));
      this.selectedMultipleChoices = _toConsumableArray(remainingChoices);
    }
  }, {
    key: "handleOnAfterChoiceSelected",
    value: function handleOnAfterChoiceSelected() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var isChoiceSelectionMultiple = items.isChoiceSelectionMultiple,
        singleChoiceItem = items.singleChoiceItem,
        multipleChoiceItems = items.multipleChoiceItems;
      if (isChoiceSelectionMultiple) {
        console.log("handleOnAfterChoiceSelected: ", JSON.stringify(multipleChoiceItems));
        this.selectedMultipleChoices = _toConsumableArray(multipleChoiceItems);
        this.handleProcessMultipleChosenOption("carousel", {
          minSelectable: this.metas.payload.inputData.choice.minSelectable,
          maxSelectable: this.metas.payload.inputData.choice.maxSelectable
        });
      } else {
        console.log("handleOnAfterChoiceSelected: ", JSON.stringify(singleChoiceItem));
        this.handleProcessChosenOption(this.metas.payload, singleChoiceItem);
      }
    }
  }, {
    key: "handleProcessChosenOption",
    value: function handleProcessChosenOption() {
      var optionPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var option = arguments.length > 1 ? arguments[1] : undefined;
      var messageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "chat_dynamic";
      var message = getCorrectedSingleChoicePayload(optionPayload, option, messageType);
      // emit event sendMessage
      EventHub.$emit(EventHub.events.sendMessage, message);
    }
  }, {
    key: "handleProcessMultipleChosenOptionText",
    value: function handleProcessMultipleChosenOptionText(option, event) {
      if (event.currentTarget.classList.contains("toggled")) {
        this.handleRemoveOption(option);
        event.currentTarget.classList.remove("toggled");
      } else {
        this.selectedMultipleChoices.push(option);
        event.currentTarget.classList.add("toggled");
      }
    }
  }, {
    key: "handleProcessMultipleChosenOption",
    value: function handleProcessMultipleChosenOption() {
      var choicesType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "text";
      var
      // text|carousel
      minMaxParams = arguments.length > 1 ? arguments[1] : undefined;
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var event = arguments.length > 3 ? arguments[3] : undefined;
      // if multiple choice is text
      if (choicesType === "text") {
        this.handleProcessMultipleChosenOptionText(option, event);
      }
      if (isMultipleMinMaxSelectableNotOk(this.selectedMultipleChoices, minMaxParams)) {
        this.isSubmitMultipleChoiceEnabled = false;
        // just stop code here...
        return false;
      }
      this.isSubmitMultipleChoiceEnabled = true;
    }
  }, {
    key: "onClickChoiceList",
    value: function onClickChoiceList(event, selectedItem) {
      if (this.canHandleMultipleChoiceList) {
        if (this.isChoiceSelectionMultiple) {
          this.handleProcessMultipleChosenOption("text", {
            minSelectable: this.metas.payload.inputData.choice.minSelectable,
            maxSelectable: this.metas.payload.inputData.choice.maxSelectable
          }, selectedItem, event);
        } else {
          this.handleProcessChosenOption(this.metas.payload, selectedItem);
        }
      }
    }
  }, {
    key: "onClickSubmitChoices",
    value: function onClickSubmitChoices() {
      var multipleChoiceMessage = getCorrectedMultipleChoicePayload(this.metas.payload, this.selectedMultipleChoices);
      // disable the send button
      this.isSubmitMultipleChoiceEnabled = false;
      EventHub.$emit(EventHub.events.sendMessage, multipleChoiceMessage);
    }
  }]);
}(Vue$2), _descriptor$5 = _applyDecoratedDescriptor(_class2$5.prototype, "chatBubbleId", [_dec2$5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$5 = _applyDecoratedDescriptor(_class2$5.prototype, "metas", [_dec3$5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$4 = _applyDecoratedDescriptor(_class2$5.prototype, "getCurrentChatMessages", [_dec4$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$4 = _applyDecoratedDescriptor(_class2$5.prototype, "getBotConfigSettings", [_dec5$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$5)) || _class$5);

/* script */
var __vue_script__$6 = BubbleContentChoices;

/* template */
var __vue_render__$6 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_vm.canShowCarouselChoices(_vm.metas) ? _c('EmblaCarouselChoices', {
    attrs: {
      "carousel-id": _vm.getCarouselId,
      "is-disabled": !_vm.isOptionEnabled,
      "is-choice-selection-multiple": _vm.isChoiceSelectionMultiple,
      "data-items": _vm.listChoicesData,
      "on-after-choice-selected": _vm.handleOnAfterChoiceSelected
    }
  }) : _vm._e(), _vm._v(" "), _vm.canShowSingleMultipleListChoices(_vm.metas) ? _vm._l(_vm.listChoicesData, function (choice) {
    return _c('div', {
      staticClass: "option position-relative",
      "class": choice.interaction.type === 'insert_text' ? 'not-bubbled' : '',
      attrs: {
        "disabled": !_vm.isOptionEnabled || !_vm.isOptionVisible
      },
      on: {
        "click": function click($event) {
          return _vm.onClickChoiceList($event, choice);
        }
      }
    }, [_vm._l(choice.content, function (content) {
      return [_vm.canShowContentText(content.type) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(content.text)
        }
      }) : _vm.canShowContentImage(content.type) ? _c('img', {
        attrs: {
          "src": content.url
        }
      }) : _vm._e()];
    })], 2);
  }) : _vm._e(), _vm._v(" "), _vm.canShowButtonMultipleChoiceSubmit(_vm.metas) ? _c('div', {
    staticClass: "submit-wrapper pl-5 pr-5"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "disabled": !_vm.isSubmitMultipleChoiceEnabled
    },
    on: {
      "click": _vm.onClickSubmitChoices
    }
  }, [_c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.metas.payload.inputData.choice.submit[0].text)
    }
  })])], 1) : _vm._e()], 2);
};
var __vue_staticRenderFns__$6 = [];

/* style */
var __vue_inject_styles__$6 = undefined;
/* scoped */
var __vue_scope_id__$6 = "data-v-7896250c";
/* module identifier */
var __vue_module_identifier__$6 = undefined;
/* functional template */
var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

var _dec$6, _dec2$6, _class$6, _class2$6, _descriptor$6;
var ChatInteractionOpenUrl = (_dec$6 = Component({}), _dec2$6 = Prop(), _dec$6(_class$6 = (_class2$6 = /*#__PURE__*/function (_Vue) {
  function ChatInteractionOpenUrl() {
    var _this;
    _classCallCheck(this, ChatInteractionOpenUrl);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatInteractionOpenUrl, [].concat(args));
    _initializerDefineProperty(_this, "content", _descriptor$6, _this);
    return _this;
  }
  _inherits(ChatInteractionOpenUrl, _Vue);
  return _createClass(ChatInteractionOpenUrl);
}(Vue$2), _descriptor$6 = _applyDecoratedDescriptor(_class2$6.prototype, "content", [_dec2$6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$6)) || _class$6);

/* script */
var __vue_script__$7 = ChatInteractionOpenUrl;

/* template */
var __vue_render__$7 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a', {
    attrs: {
      "href": _vm.content.interaction.content[0].url,
      "target": "_blank"
    }
  }, [_c('div', [_c('svg', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 172 172"
    }
  }, [_c('g', {
    staticStyle: {
      "mix-blend-mode": "normal"
    },
    attrs: {
      "fill": "none",
      "fill-rule": "nonzero",
      "stroke": "none",
      "stroke-width": "1",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "stroke-dasharray": "",
      "stroke-dashoffset": "0",
      "font-family": "none",
      "font-weight": "none",
      "font-size": "none",
      "text-anchor": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,172v-172h172v172z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#3498db"
    }
  }, [_c('path', {
    attrs: {
      "d": "M127.28,13.77344c-7.92834,-0.00043 -15.8592,3.0214 -21.8964,9.05688l-17.2,17.2c-8.57248,8.57248 -11.02262,20.95153 -7.4175,31.73937l12.35578,-12.35578c0.516,-3.53288 2.07631,-6.94068 4.79047,-9.65484l17.2,-17.2c3.354,-3.35056 7.76445,-5.03234 12.16765,-5.03234c4.4032,0 8.81038,1.67834 12.16094,5.03234c6.70456,6.708 6.70456,17.61731 0,24.32187l-17.2,17.2c-2.71416,2.71416 -6.11852,4.27103 -9.65484,4.79047l-12.3625,12.3625c3.19232,1.0664 6.51633,1.63266 9.84969,1.63266c7.9292,0 15.8592,-3.01968 21.8964,-9.05688l17.2,-17.2c12.0744,-12.07096 12.07096,-31.70841 0,-43.77937c-6.0372,-6.03376 -13.96135,-9.05644 -21.88969,-9.05688zM106.50563,58.41281c-1.78741,0.05326 -3.48388,0.80028 -4.73,2.08281l-41.28,41.28c-1.79734,1.72562 -2.52135,4.28808 -1.89282,6.69912c0.62853,2.41104 2.5114,4.29391 4.92245,4.92245c2.41104,0.62853 4.9735,-0.09548 6.69912,-1.89282l41.28,-41.28c2.03483,-1.97794 2.64666,-5.00221 1.54067,-7.61556c-1.10599,-2.61334 -3.7029,-4.27965 -6.53941,-4.196zM63.46531,79.20063c-8.43515,-0.42925 -17.00306,2.55361 -23.435,8.98297l-17.2,17.2c-12.07096,12.07096 -12.07096,31.71513 0,43.78609c6.0372,6.03376 13.96393,9.05016 21.88969,9.05016c7.92576,0 15.85249,-3.01968 21.88969,-9.05688l17.2,-17.2c8.57248,-8.57248 11.02934,-20.95153 7.42422,-31.73937l-12.3625,12.3625c-0.516,3.53288 -2.07631,6.94068 -4.79047,9.65484l-17.2,17.2c-6.70456,6.708 -17.61731,6.708 -24.32187,0c-6.70456,-6.708 -6.70456,-17.61731 0,-24.32187l17.2,-17.2c2.71416,-2.71416 6.12196,-4.27775 9.65484,-4.79719l12.35578,-12.35578c-2.69696,-0.90128 -5.49266,-1.42239 -8.30437,-1.56547z"
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.content.interaction.content[0].text))])]);
};
var __vue_staticRenderFns__$7 = [];

/* style */
var __vue_inject_styles__$7 = undefined;
/* scoped */
var __vue_scope_id__$7 = undefined;
/* module identifier */
var __vue_module_identifier__$7 = undefined;
/* functional template */
var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

var _dec$7, _dec2$7, _class$7, _class2$7, _descriptor$7;
var ChatInteractionStartCall = (_dec$7 = Component({}), _dec2$7 = Prop(), _dec$7(_class$7 = (_class2$7 = /*#__PURE__*/function (_Vue) {
  function ChatInteractionStartCall() {
    var _this;
    _classCallCheck(this, ChatInteractionStartCall);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatInteractionStartCall, [].concat(args));
    _initializerDefineProperty(_this, "content", _descriptor$7, _this);
    return _this;
  }
  _inherits(ChatInteractionStartCall, _Vue);
  return _createClass(ChatInteractionStartCall);
}(Vue$2), _descriptor$7 = _applyDecoratedDescriptor(_class2$7.prototype, "content", [_dec2$7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$7)) || _class$7);

/* script */
var __vue_script__$8 = ChatInteractionStartCall;

/* template */
var __vue_render__$8 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a', {
    attrs: {
      "href": 'tel:' + _vm.content.interaction.content[0].text
    }
  }, [_c('div', [_c('svg', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 172 172"
    }
  }, [_c('g', {
    staticStyle: {
      "mix-blend-mode": "normal"
    },
    attrs: {
      "fill": "none",
      "fill-rule": "nonzero",
      "stroke": "none",
      "stroke-width": "1",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "stroke-dasharray": "",
      "stroke-dashoffset": "0",
      "font-family": "none",
      "font-weight": "none",
      "font-size": "none",
      "text-anchor": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,172v-172h172v172z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#3498db"
    }
  }, [_c('path', {
    attrs: {
      "d": "M121.69,102.5636c-2.32773,-1.36453 -5.18867,-1.33587 -7.50493,0.04013l-11.7304,6.98893c-2.62587,1.5652 -5.90533,1.38173 -8.31333,-0.4988c-4.1624,-3.2508 -10.86467,-8.7204 -16.69547,-14.5512c-5.8308,-5.8308 -11.3004,-12.53307 -14.5512,-16.69547c-1.88053,-2.408 -2.064,-5.68747 -0.4988,-8.31333l6.98893,-11.7304c1.38173,-2.31627 1.3932,-5.20013 0.02867,-7.52787l-17.21147,-29.40053c-1.6684,-2.84373 -4.98227,-4.24267 -8.1872,-3.4572c-3.1132,0.7568 -7.1552,2.60293 -11.39213,6.8456c-13.26693,13.26693 -20.3132,35.64413 29.57827,85.5356c49.89147,49.89147 72.26293,42.85093 85.5356,29.57827c4.2484,-4.2484 6.0888,-8.29613 6.85133,-11.41507c0.774,-3.1992 -0.602,-6.49013 -3.44,-8.1528c-7.0864,-4.1452 -22.37147,-13.09493 -29.45787,-17.24587z"
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Chiama " + _vm._s(_vm.content.interaction.content[0].text))])]);
};
var __vue_staticRenderFns__$8 = [];

/* style */
var __vue_inject_styles__$8 = undefined;
/* scoped */
var __vue_scope_id__$8 = undefined;
/* module identifier */
var __vue_module_identifier__$8 = undefined;
/* functional template */
var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

var _dec$8, _dec2$8, _class$8, _class2$8, _descriptor$8;
var ChatInteractionStartChat = (_dec$8 = Component({}), _dec2$8 = Prop(), _dec$8(_class$8 = (_class2$8 = /*#__PURE__*/function (_Vue) {
  function ChatInteractionStartChat() {
    var _this;
    _classCallCheck(this, ChatInteractionStartChat);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatInteractionStartChat, [].concat(args));
    _initializerDefineProperty(_this, "content", _descriptor$8, _this);
    return _this;
  }
  _inherits(ChatInteractionStartChat, _Vue);
  return _createClass(ChatInteractionStartChat);
}(Vue$2), _descriptor$8 = _applyDecoratedDescriptor(_class2$8.prototype, "content", [_dec2$8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$8)) || _class$8);

/* script */
var __vue_script__$9 = ChatInteractionStartChat;

/* template */
var __vue_render__$9 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('div', [_c('svg', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 172 172"
    }
  }, [_c('g', {
    staticStyle: {
      "mix-blend-mode": "normal"
    },
    attrs: {
      "fill": "none",
      "fill-rule": "nonzero",
      "stroke": "none",
      "stroke-width": "1",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "stroke-dasharray": "",
      "stroke-dashoffset": "0",
      "font-family": "none",
      "font-weight": "none",
      "font-size": "none",
      "text-anchor": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,172v-172h172v172z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#3498db"
    }
  }, [_c('path', {
    attrs: {
      "d": "M74.53333,17.2c-34.83,0 -63.06667,25.66813 -63.06667,57.33333c0,16.2632 7.49993,30.88989 19.47318,41.30911c-1.71739,5.62423 -5.29979,11.21796 -11.88099,16.20339c-0.00372,0.00374 -0.00746,0.00748 -0.0112,0.0112c-1.11129,0.42263 -1.84635,1.48737 -1.84766,2.6763c0,1.58322 1.28345,2.86667 2.86667,2.86667c0.19588,-0.00244 0.391,-0.02496 0.58229,-0.06719c11.12306,-0.03241 20.61351,-4.78364 28.16276,-10.7388c3.58246,1.45718 7.32203,2.65852 11.22031,3.49375c-1.74293,-4.93067 -2.6987,-10.18016 -2.6987,-15.62109c0,-8.24453 2.21127,-16.0132 6.04688,-22.93333h-11.78021c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333c0,-3.1648 2.56853,-5.73333 5.73333,-5.73333h20.45859c4.65547,-4.66693 10.21161,-8.57133 16.46094,-11.46667h-36.91953c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333c0,-3.1648 2.56853,-5.73333 5.73333,-5.73333h45.86667c3.1648,0 5.73333,2.56853 5.73333,5.73333c0,0.38413 -0.14396,0.725 -0.21276,1.0862c3.77253,-0.7052 7.67756,-1.0862 11.67942,-1.0862c7.92347,0 15.47677,1.45564 22.35104,4.08724c-3.99041,-28.1736 -30.41211,-49.95391 -62.48438,-49.95391zM114.66667,74.53333c-25.32987,0 -45.86667,17.96827 -45.86667,40.13333c0,22.16507 20.5368,40.13333 45.86667,40.13333c6.05488,0 11.81834,-1.05733 17.11042,-2.92266c7.03112,4.91169 15.54015,8.55476 25.28489,8.5888c0.19861,0.04378 0.40131,0.06631 0.60469,0.06719c1.58322,0 2.86667,-1.28345 2.86667,-2.86667c-0.00188,-1.20157 -0.7529,-2.27446 -1.88125,-2.6875c-5.24708,-3.98365 -8.6101,-8.36855 -10.62683,-12.83281c7.73285,-7.18404 12.50808,-16.83221 12.50808,-27.47969c0,-22.16507 -20.5368,-40.13333 -45.86667,-40.13333zM97.46667,97.46667h34.4c3.1648,0 5.73333,2.56853 5.73333,5.73333c0,3.1648 -2.56853,5.73333 -5.73333,5.73333h-34.4c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333c0,-3.1648 2.56853,-5.73333 5.73333,-5.73333zM97.46667,120.4h34.4c3.1648,0 5.73333,2.56853 5.73333,5.73333c0,3.1648 -2.56853,5.73333 -5.73333,5.73333h-34.4c-3.1648,0 -5.73333,-2.56853 -5.73333,-5.73333c0,-3.1648 2.56853,-5.73333 5.73333,-5.73333z"
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.content.interaction.content[0].text))])]);
};
var __vue_staticRenderFns__$9 = [];

/* style */
var __vue_inject_styles__$9 = undefined;
/* scoped */
var __vue_scope_id__$9 = undefined;
/* module identifier */
var __vue_module_identifier__$9 = undefined;
/* functional template */
var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

var _dec$9, _dec2$9, _dec3$6, _dec4$5, _dec5$4, _class$9, _class2$9, _descriptor$9, _descriptor2$6, _descriptor3$5, _descriptor4$5;
var ChatInputAreaContent = (_dec$9 = Component({
  components: {
    ChatInteractionOpenUrl: __vue_component__$7,
    ChatInteractionStartCall: __vue_component__$8,
    ChatInteractionStartChat: __vue_component__$9
  }
}), _dec2$9 = Prop(), _dec3$6 = Getter("chat/fetchAttachmentsUploaderConfig"), _dec4$5 = Action$1("chat/setAttachmentsUploaderConfig"), _dec5$4 = Action$1("chat/setIsInteractionInsertDate"), _dec$9(_class$9 = (_class2$9 = /*#__PURE__*/function (_Vue) {
  function ChatInputAreaContent() {
    var _this;
    _classCallCheck(this, ChatInputAreaContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatInputAreaContent, [].concat(args));
    _initializerDefineProperty(_this, "content", _descriptor$9, _this);
    _initializerDefineProperty(_this, "attachmentsUploaderConfig", _descriptor2$6, _this);
    _initializerDefineProperty(_this, "setAttachmentsUploaderConfig", _descriptor3$5, _this);
    _initializerDefineProperty(_this, "setIsInteractionInsertDate", _descriptor4$5, _this);
    return _this;
  }
  _inherits(ChatInputAreaContent, _Vue);
  return _createClass(ChatInputAreaContent, [{
    key: "canShowInputContent",
    get: function get() {
      return this.hasInteractionsOptionsAcceptedFormat !== false;
    }
  }, {
    key: "hasInteractionsOptionsAcceptedFormat",
    get: function get() {
      if (this.hasInteractionOptions) {
        var acceptedFormat = this.content.interaction.options.acceptedFormat;
        return !!acceptedFormat;
      } else {
        return false;
      }
    }
  }, {
    key: "hasContent",
    get: function get() {
      return !!this.content;
    }
  }, {
    key: "hasInteraction",
    get: function get() {
      if (this.hasContent) {
        var interaction = this.content.interaction;
        return !!interaction;
      } else {
        return false;
      }
    }
  }, {
    key: "hasInteractionOptions",
    get: function get() {
      if (this.hasInteraction) {
        var options = this.content.interaction.options;
        return !!options;
      } else {
        return false;
      }
    }
  }, {
    key: "hasInteractionType",
    get: function get() {
      if (this.hasInteraction) {
        var type = this.content.interaction.type;
        return !!type;
      } else {
        return false;
      }
    }
  }, {
    key: "getInputContentClass",
    get: function get() {
      var inputContentClass = "mt-3 ml-auto mr-auto";
      if (this.hasInteractionType) {
        var type = this.content.interaction.type;
        if (type.indexOf("take_") !== -1) {
          inputContentClass = "option position-relative";
        }
      }
      return inputContentClass;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;
      EventHub.$on(EventHub.events.attachmentUploadedResponse, function (attachment) {
        _newArrowCheck(this, _this2);
        EventHub.$emit(EventHub.events.sendMessage, attachment);
        this.setIsInteractionInsertDate(false);
      }.bind(this));
      if (this.content.interaction) {
        var showGloabalAttachment = false;
        if (this.content.interaction.type.indexOf("take_") !== -1) {
          showGloabalAttachment = this.content;
        }
        this.setAttachmentsUploaderConfig(_objectSpread2(_objectSpread2({}, this.attachmentsUploaderConfig), {}, {
          use: showGloabalAttachment
        }));
      }
    }
  }, {
    key: "isContentInteractionOpenUrl",
    value: function isContentInteractionOpenUrl(type) {
      return type === "open_url";
    }
  }, {
    key: "isContentInteractionStartCall",
    value: function isContentInteractionStartCall(type) {
      return type === "start_call";
    }
  }, {
    key: "isContentInteractionStartChat",
    value: function isContentInteractionStartChat(type) {
      return type === "start_chat";
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      EventHub.$off(EventHub.events.attachmentUploadedResponse);
    }
  }]);
}(Vue$2), _descriptor$9 = _applyDecoratedDescriptor(_class2$9.prototype, "content", [_dec2$9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$6 = _applyDecoratedDescriptor(_class2$9.prototype, "attachmentsUploaderConfig", [_dec3$6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$5 = _applyDecoratedDescriptor(_class2$9.prototype, "setAttachmentsUploaderConfig", [_dec4$5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$5 = _applyDecoratedDescriptor(_class2$9.prototype, "setIsInteractionInsertDate", [_dec5$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$9)) || _class$9);

/* script */
var __vue_script__$a = ChatInputAreaContent;

/* template */
var __vue_render__$a = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.canShowInputContent ? _c('div', {
    "class": _vm.getInputContentClass
  }, [_vm.isContentInteractionOpenUrl(_vm.content.interaction.type) ? _c('ChatInteractionOpenUrl', {
    attrs: {
      "content": _vm.content
    }
  }) : _vm.isContentInteractionStartCall(_vm.content.interaction.type) ? _c('ChatInteractionStartCall', {
    attrs: {
      "content": _vm.content
    }
  }) : _vm.isContentInteractionStartChat(_vm.content.interaction.type) ? _c('ChatInteractionStartChat', {
    attrs: {
      "content": _vm.content
    }
  }) : _vm._e()], 1) : _vm._e();
};
var __vue_staticRenderFns__$a = [];

/* style */
var __vue_inject_styles__$a = undefined;
/* scoped */
var __vue_scope_id__$a = undefined;
/* module identifier */
var __vue_module_identifier__$a = undefined;
/* functional template */
var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

var img$3 = "data:image/gif;base64,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";

var _dec$a, _dec2$a, _dec3$7, _dec4$6, _dec5$5, _dec6$3, _dec7$3, _dec8$2, _dec9$2, _dec0$2, _dec1$1, _class$a, _class2$a, _descriptor$a, _descriptor2$7, _descriptor3$6, _descriptor4$6, _descriptor5$3, _descriptor6$3, _descriptor7$2, _descriptor8$2, _descriptor9$2, _descriptor0$2;
// import Interaction from '@monksoftware/momofolo/build/messages/chat_dynamic/interactions/base';
var ChatBubble = (_dec$a = Component({
  components: {
    ChatBubbleContent: __vue_component__$4,
    BubbleContentChoices: __vue_component__$6,
    ChatInputAreaContent: __vue_component__$a
  }
}), _dec2$a = Prop(), _dec3$7 = Prop(), _dec4$6 = Prop({
  description: "The typing bubble shown from bot, while waiting for reply from server"
}), _dec5$5 = Prop({
  description: "The typing bubble from user, typically shown while waiting stt response from server."
}), _dec6$3 = Prop(), _dec7$3 = PropSync("botAvatar", {
  type: String
}), _dec8$2 = Action$1("chat/addMessage"), _dec9$2 = Getter("chat/getCurrentChat"), _dec0$2 = Getter("chat/getCurrentChatMessages"), _dec1$1 = Getter("chat/stampsMap"), _dec$a(_class$a = (_class2$a = /*#__PURE__*/function (_Vue) {
  function ChatBubble() {
    var _this;
    _classCallCheck(this, ChatBubble);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatBubble, [].concat(args));
    _defineProperty(_this, "userInput", "");
    _defineProperty(_this, "datesInterval", []);
    _defineProperty(_this, "loaderTrigger", "");
    _initializerDefineProperty(_this, "chatBubbleId", _descriptor$a, _this);
    _initializerDefineProperty(_this, "metas", _descriptor2$7, _this);
    _initializerDefineProperty(_this, "isTyping", _descriptor3$6, _this);
    _initializerDefineProperty(_this, "isTypingUser", _descriptor4$6, _this);
    _initializerDefineProperty(_this, "userAvatar", _descriptor5$3, _this);
    _initializerDefineProperty(_this, "chatInAvatar", _descriptor6$3, _this);
    _initializerDefineProperty(_this, "addMessage", _descriptor7$2, _this);
    _initializerDefineProperty(_this, "currentChat", _descriptor8$2, _this);
    _initializerDefineProperty(_this, "getCurrentChatMessages", _descriptor9$2, _this);
    _initializerDefineProperty(_this, "daySeparatorMap", _descriptor0$2, _this);
    return _this;
  }
  _inherits(ChatBubble, _Vue);
  return _createClass(ChatBubble, [{
    key: "loaderGifIcon",
    get: function get() {
      return img$3;
    }
  }, {
    key: "botAvatarIcon",
    get: function get() {
      return img$2;
    }
  }, {
    key: "operatorAvatarIcon",
    get: function get() {
      return operatorAvatarIcon;
    }
  }, {
    key: "userAvatarIcon",
    get: function get() {
      return userAvatarIcon;
    }
  }, {
    key: "canShowBubbleStanzaIn",
    get: function get() {
      return hasMetaStanza(this.metas) && isStanzaDirectionIn(this.metas);
    }
  }, {
    key: "canShowSelectionModeInputChoices",
    get: function get() {
      return isSelectionModeInputChoices(this.metas);
    }
  }, {
    key: "canShowBubbleStanzaOutAndModeInput",
    get: function get() {
      return isBubbleStanzaOutAndModeInput(this.metas);
    }
  }, {
    key: "canShowBubbleStanzaInAndModeInput",
    get: function get() {
      return isBubbleStanzaInAndModeInput(this.metas);
    }
  }, {
    key: "canShowBubbleStanzaInAndModeInputLocation",
    get: function get() {
      return hasMetaPayloadInputData(this.metas) && isBubbleStanzaInAndModeInputLocation(this.metas);
    }
  }, {
    key: "canShowMetaStanza",
    get: function get() {
      return hasMetaStanza(this.metas);
    }
  }, {
    key: "canShowMetaContent",
    get: function get() {
      return hasMetaContent(this.metas);
    }
  }, {
    key: "canShowMetaPayload",
    get: function get() {
      return hasMetaPayload(this.metas);
    }
  }, {
    key: "canShowMetaPayloadLayout",
    get: function get() {
      return hasMetaPayloadLayout(this.metas);
    }
  }, {
    key: "canShowMetaPayloadInputData",
    get: function get() {
      return hasMetaPayloadInputData(this.metas);
    }
  }, {
    key: "canShowMetaPayloadContent",
    get: function get() {
      return hasMetaPayloadContent(this.metas);
    }
  }, {
    key: "canShowBubbleStanza",
    get: function get() {
      return hasMetaStanza(this.metas) && this.metas.stanza.hasOwnProperty("id") && this.retrieveMamMessageTimestamp(this.metas);
    }
  }, {
    key: "canShowBubbleStanzaSeparator",
    get: function get() {
      var currentChatTitle = this.currentChat.title;
      if (currentChatTitle) {
        var newCurrentChatTitle = currentChatTitle;
        // TODO: workaround, understand why, doesnt work with angie
        if (currentChatTitle.toLowerCase() === "angie") {
          newCurrentChatTitle = getBase64EncodeFromKey(currentChatTitle);
        }
        var title = getBase64DecodeFromKey(newCurrentChatTitle);
        var id = this.retrieveMamMessageTimestamp(this.metas) ? this.retrieveMamMessageTimestamp(this.metas).split("T")[0] : -1;
        return title && id !== -1 ? this.daySeparatorMap[title] && this.daySeparatorMap[title][id] === this.metas.stanza.id : false;
      }
      return false;
    }
  }, {
    key: "getBubbleWrapperClass",
    get: function get() {
      return hasMetaPayload(this.metas) && this.metas.payload.hasOwnProperty("code") ? "is-notice" : "";
    }
  }, {
    key: "getInputDataClass",
    get: function get() {
      return this.metas.payload.inputData && this.metas.payload.inputData.choice && this.metas.payload.inputData.choice.list ? "bubble bubble-action-container" : "";
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.metas.hasOwnProperty("payload") && this.metas.payload.hasOwnProperty("inputData")) {
        if (this.metas.payload.inputData.hasOwnProperty("interaction")) {
          this.metas.payload.inputData.interaction.type === "insert_text";
        } else if (this.metas.payload.inputData.hasOwnProperty("choice")) ;
      }
      /**
       * TODO: check if this feature has to be re-enabled
       */
      // this.toggleUserInputStatus(isInputText)
    }
  }, {
    key: "isMamMessage",
    value: function isMamMessage(message) {
      var isMam = false;
      if (message.hasOwnProperty("stanza")) {
        if (message.stanza.hasOwnProperty("rawStanza")) {
          isMam = message.stanza.rawStanza.indexOf('queryid="mamquery-') !== -1;
          // there's another way to check if message is from mam, but for now this is ok 👍🏻
        }
      }
      return isMam;
    }
  }, {
    key: "getTimestamp",
    value: function getTimestamp(message) {
      var mamMessageTimestamp = this.retrieveMamMessageTimestamp(message);
      if (mamMessageTimestamp) {
        return mamMessageTimestamp;
      } else {
        var stanza = message.stanza;
        return stanza && stanza.timestamp ? stanza.timestamp : new Date().toISOString();
      }
    }
  }, {
    key: "retrieveMamMessageTimestamp",
    value: function retrieveMamMessageTimestamp(message) {
      var stanza = message.stanza;
      if (!stanza) return "";
      var rawStanza = stanza.rawStanza;
      if (!rawStanza) return "";
      var ts = "";
      var xmlMsg = new DOMParser().parseFromString(rawStanza, "text/xml");
      try {
        var timestampElem = xmlMsg.getElementsByTagName('delay')[0];
        ts = timestampElem && timestampElem.getAttribute("stamp");
      } catch (ex) {
        console.log(ex);
      }
      return ts;
    }
  }]);
}(Vue$2), _descriptor$a = _applyDecoratedDescriptor(_class2$a.prototype, "chatBubbleId", [_dec2$a], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$7 = _applyDecoratedDescriptor(_class2$a.prototype, "metas", [_dec3$7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$6 = _applyDecoratedDescriptor(_class2$a.prototype, "isTyping", [_dec4$6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$6 = _applyDecoratedDescriptor(_class2$a.prototype, "isTypingUser", [_dec5$5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5$3 = _applyDecoratedDescriptor(_class2$a.prototype, "userAvatar", [_dec6$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6$3 = _applyDecoratedDescriptor(_class2$a.prototype, "chatInAvatar", [_dec7$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7$2 = _applyDecoratedDescriptor(_class2$a.prototype, "addMessage", [_dec8$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8$2 = _applyDecoratedDescriptor(_class2$a.prototype, "currentChat", [_dec9$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9$2 = _applyDecoratedDescriptor(_class2$a.prototype, "getCurrentChatMessages", [_dec0$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0$2 = _applyDecoratedDescriptor(_class2$a.prototype, "daySeparatorMap", [_dec1$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$a)) || _class$a);

/* script */
var __vue_script__$b = ChatBubble;

/* template */
var __vue_render__$b = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('el-row', {
    staticClass: "m-0"
  }, [_vm.canShowBubbleStanza ? [_vm.canShowBubbleStanzaSeparator ? _c('p', {
    staticClass: "date-separator"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.retrieveMamMessageTimestamp(_vm.metas) | _vm.getDateSeparator)
    }
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "bubble-wrapper",
    "class": _vm.getBubbleWrapperClass,
    attrs: {
      "gutter": 5
    }
  }, [_vm.canShowBubbleStanzaIn ? _c('div', {
    staticClass: "avatar in"
  }, [_c('img', {
    attrs: {
      "src": _vm.chatInAvatar || _vm.botAvatarIcon,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bubble-content"
  }, [_vm.isTyping ? [_c('div', {
    staticClass: "bubble in is-typing",
    staticStyle: {
      "margin-left": "15%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.loaderGifIcon,
      "width": "35"
    }
  })])] : _vm.isTypingUser ? [_c('div', {
    staticClass: "bubble out bubble-inline is-typing",
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.loaderGifIcon,
      "width": "35"
    }
  })])] : [_vm.canShowMetaStanza ? [_vm.canShowMetaPayloadContent ? _vm._l(_vm.metas.payload.content, function (message) {
    return _c('ChatBubbleContent', {
      key: message.id,
      attrs: {
        "content": message,
        "direction": _vm.metas.stanza.direction,
        "mam": _vm.isMamMessage(_vm.metas),
        "timestamp": _vm.getTimestamp(_vm.metas)
      }
    });
  }) : _vm.canShowMetaContent ? _vm._l(_vm.metas.content, function (message) {
    return _c('ChatBubbleContent', {
      key: message.id,
      attrs: {
        "content": message,
        "direction": _vm.metas.stanza.direction,
        "mam": _vm.isMamMessage(_vm.metas),
        "timestamp": _vm.getTimestamp(_vm.metas)
      }
    });
  }) : [_c('ChatBubbleContent', {
    attrs: {
      "content": _vm.metas.payload,
      "direction": _vm.metas.stanza.direction,
      "mam": _vm.isMamMessage(_vm.metas),
      "timestamp": _vm.getTimestamp(_vm.metas)
    }
  })]] : [_vm.canShowMetaPayloadContent ? _vm._l(_vm.metas.payload.content, function (message) {
    return _c('ChatBubbleContent', {
      key: message.id,
      attrs: {
        "content": message,
        "timestamp": _vm.metas.timestamp || false,
        "mam": _vm.isMamMessage(message),
        "direction": "out"
      }
    });
  }) : [_c('ChatBubbleContent', {
    attrs: {
      "content": _vm.metas.payload,
      "timestamp": _vm.metas.timestamp || false,
      "mam": _vm.isMamMessage(_vm.metas),
      "direction": "out"
    }
  })]], _vm._v(" "), _vm.canShowMetaPayload ? [_vm.canShowMetaPayloadLayout ? [_vm.canShowBubbleStanzaOutAndModeInput ? [_c('ChatInputAreaContent', {
    attrs: {
      "content": _vm.metas.payload.inputData
    }
  })] : _vm.canShowMetaPayloadInputData ? _c('div', {
    "class": _vm.getInputDataClass
  }, [_c('div', {
    staticClass: "options-wrapper"
  }, [_vm.canShowSelectionModeInputChoices ? _c('BubbleContentChoices', {
    attrs: {
      "chat-bubble-id": _vm.chatBubbleId,
      "metas": _vm.metas
    }
  }) : _vm.canShowBubbleStanzaInAndModeInput ? [_c('ChatInputAreaContent', {
    attrs: {
      "content": _vm.metas.payload.inputData
    }
  })] : _vm._e()], 2)]) : _vm._e()] : _vm.canShowBubbleStanzaInAndModeInputLocation ? [_c('ChatInputAreaContent', {
    attrs: {
      "content": _vm.metas.payload.inputData
    }
  })] : _vm._e()] : _vm._e()], _vm._v(" "), _vm.userAvatar && !_vm.metas.stanza || _vm.metas.stanza && _vm.metas.stanza.direction !== 'in' ? _c('div', {
    staticClass: "avatar out"
  }, [_vm.userAvatar ? _c('img', {
    attrs: {
      "src": _vm.userAvatar
    }
  }) : _vm._e()]) : _vm._e()], 2)])], 2);
};
var __vue_staticRenderFns__$b = [];

/* style */
var __vue_inject_styles__$b = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-5c9169ec_0", {
    source: ".w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}.date-separator{text-align:center;font-weight:600;margin:.3em auto .5em;font-size:.85em}.bubble-wrapper{display:block;margin-bottom:.1em;float:left;width:100%}.bubble-wrapper.is-notice .avatar{display:none}.bubble-wrapper.is-notice .bubble-content{width:100%}.bubble-wrapper.is-notice .bubble-content .bubble.is-notice{margin:.75em 0;font-size:.8em;font-weight:600}.bubble-wrapper.is-notice .bubble-content .bubble.is-notice:after{content:\" \";position:absolute;top:50%;left:2.5%;width:95%;z-index:-1;height:1px;background:#bababa}.bubble-wrapper.is-notice .bubble-content .bubble.is-notice p{background:#fff;color:#adadad}.bubble-wrapper.is-notice .bubble-content .bubble.is-notice.naked{font-weight:400}.bubble-wrapper.is-notice .bubble-content .bubble.is-notice.naked p{color:#1d1d1d}.bubble-wrapper.is-notice .bubble-content .bubble.is-notice.naked:after{background:0 0}.bubble-wrapper.history .option{text-align:center}.bubble-wrapper.history .option img{max-width:200px!important}.bubble-wrapper.history .option:hover{cursor:unset!important;color:inherit!important;border:1px solid rgba(16,16,16,.5)!important}.bubble-wrapper .avatar{position:absolute;width:14%;height:100%}.bubble-wrapper .avatar.out{margin-left:1%;right:0}.bubble-wrapper .avatar.out+.bubble-content{float:left}.bubble-wrapper .avatar.in{text-align:right;margin-right:1%;left:0;float:left;clear:both;position:relative}.bubble-wrapper .avatar.in+.bubble-content{float:right}.bubble-wrapper .avatar img{border-radius:0!important;width:85%;max-width:40px;max-height:40px;box-shadow:none!important;background:0 0!important;padding:2px}.bubble-wrapper .bubble-content{width:85%}.bubble-wrapper .bubble-content .is-typing{min-width:auto!important;max-width:35px!important}.bubble-wrapper .bubble-content .bubble:not(.is-notice){text-align:left;border-radius:1.3em;padding:9px 17px;transition:width 2s;word-break:break-word;line-height:20px;background-color:#f8f8f8;box-shadow:0 1px 2px rgba(16,16,16,.2);max-width:90%;min-width:100px;clear:both}.bubble-wrapper .bubble-content .bubble:not(.is-notice).bubble-full{display:block;width:fit-content;margin-bottom:.6em;clear:both}.bubble-wrapper .bubble-content .bubble:not(.is-notice).bubble-full.naked{background:0 0!important;border:none!important;float:none!important}.bubble-wrapper .bubble-content .bubble:not(.is-notice).bubble-full.naked:before{border:none!important}.bubble-wrapper .bubble-content .bubble:not(.is-notice).bubble-full.naked p{margin:0!important;text-align:center!important;max-width:100%!important}.bubble-wrapper .bubble-content .bubble:not(.is-notice).bubble-full.in{float:none}.bubble-wrapper .bubble-content .bubble:not(.is-notice).bubble-inline{margin-bottom:7px;float:left;clear:both;position:relative}.bubble-wrapper .bubble-content .bubble:not(.is-notice).bubble-inline:first-child{clear:right!important;margin-left:0!important}.bubble-wrapper .bubble-content .bubble:not(.is-notice).in:not(.is-notice){display:block;width:fit-content}.bubble-wrapper .bubble-content .bubble:not(.is-notice).out{margin-right:0;float:right;background-color:#4386ff;color:#fff}.bubble-wrapper .bubble-content .bubble:not(.is-notice) p{text-align:left;margin-top:0;margin-bottom:.9em;line-height:1.3;font-size:.9em;display:inline;width:85%;min-width:50px;float:left}.bubble-wrapper .bubble-content .bubble:not(.is-notice) p:not(:first-child){margin-top:10px}.bubble-wrapper .bubble-content .bubble:not(.is-notice) p.time{font-size:11px;color:#bababa}.bubble-wrapper .bubble-content .bubble:not(.is-notice) img{max-width:300px;display:flex;margin:.4em 0}.bubble-wrapper .bubble-content .bubble-action-container{float:left!important}.bubble-wrapper .timestamp{position:absolute;width:fit-content;bottom:.5em;right:1.75em;text-align:right!important;font-size:11px!important;display:block}.options-wrapper.is-loading{opacity:.5}.options-wrapper .option:not(.not-bubbled){display:inline-block;background:#fff;border:1px solid rgba(16,16,16,.2);border-radius:2.3em;position:relative;padding:10px 15px;margin:5px;cursor:pointer}.options-wrapper .option.small{padding:5px 15px;margin:4px 4px 4px 0;font-size:14px}.options-wrapper .option.not-bubbled{background:0 0;border-color:transparent;padding:0;margin-left:0}.options-wrapper .option.toggled{color:#fff;border-color:#4386ff;background-color:#4386ff}.options-wrapper .option[disabled]{cursor:default;opacity:.4}.options-wrapper .option[disabled]:hover{border-color:rgba(16,16,16,.2)}.options-wrapper .option[disabled]:hover:before{background-color:#f8f8f8}.options-wrapper .option:hover{border-color:#4386ff;color:#4386ff}.options-wrapper .option:hover:before{background-color:#4386ff}.options-wrapper .option:hover .btn:not(.btn-action){color:#4386ff!important}.options-wrapper .option:first-child{margin-left:0!important}.options-wrapper .option .loader{position:absolute;right:8px;bottom:1px}.options-wrapper .option .loader img{max-width:70px!important;margin:0}.options-wrapper .option img{display:flex;max-width:300px}.options-wrapper .option .attachment-actions .spinner-border{width:20px;height:20px;margin-top:.5em;color:#4386ff!important}.options-wrapper .option .attachment-actions .btn-link:hover.text-success{border-color:#28a745}.options-wrapper .option .attachment-actions .btn-link:hover.text-danger{border-color:#dc3545}.options-wrapper .input-group .el-input__inner,.options-wrapper .input-group input{border-radius:25px 0 0 25px!important}.options-wrapper .input-group .input-group-append button{border-radius:0 25px 25px 0}@media screen and (min-width:800px){.bubble-content .bubble{max-width:70%!important;min-width:150px!important}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$b = undefined;
/* module identifier */
var __vue_module_identifier__$b = undefined;
/* functional template */
var __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);

var _dec$b, _dec2$b, _dec3$8, _dec4$7, _dec5$6, _class$b, _class2$b, _descriptor$b, _descriptor2$8, _descriptor3$7, _descriptor4$7;
var ChatActionsMenu = (_dec$b = Component({}), _dec2$b = Getter("chat/fetchAttachmentsUploaderConfig"), _dec3$8 = Action$1("chat/setAttachmentsUploaderConfig"), _dec4$7 = Action$1("chat/setIsInteractionInsertDate"), _dec5$6 = Action$1("chat/setCurrentDatePickerInfo"), _dec$b(_class$b = (_class2$b = /*#__PURE__*/function (_Vue) {
  function ChatActionsMenu() {
    var _this;
    _classCallCheck(this, ChatActionsMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatActionsMenu, [].concat(args));
    _initializerDefineProperty(_this, "attachmentsUploaderConfig", _descriptor$b, _this);
    _initializerDefineProperty(_this, "setAttachmentsUploaderConfig", _descriptor2$8, _this);
    _initializerDefineProperty(_this, "setIsInteractionInsertDate", _descriptor3$7, _this);
    _initializerDefineProperty(_this, "setCurrentDatePickerInfo", _descriptor4$7, _this);
    return _this;
  }
  _inherits(ChatActionsMenu, _Vue);
  return _createClass(ChatActionsMenu, [{
    key: "chatFlowCommand",
    value: function chatFlowCommand(command) {
      var showText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var textes = {
        cmd_restart: "Voglio ricominciare la chat",
        cmd_back: "Mi ripeti quello che hai appena detto, per favore?"
      };
      var msg = {
        type: "chat_text",
        action: command,
        payload: {
          text: showText ? textes[command] : ""
        }
      };
      this.setAttachmentsUploaderConfig(_objectSpread2(_objectSpread2({}, this.attachmentsUploaderConfig), {}, {
        use: false
      }));
      EventHub.$emit(EventHub.events.sendMessage, msg);
      this.setIsInteractionInsertDate(false);
      this.setCurrentDatePickerInfo({});
    }
  }]);
}(Vue$2), _descriptor$b = _applyDecoratedDescriptor(_class2$b.prototype, "attachmentsUploaderConfig", [_dec2$b], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$8 = _applyDecoratedDescriptor(_class2$b.prototype, "setAttachmentsUploaderConfig", [_dec3$8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$7 = _applyDecoratedDescriptor(_class2$b.prototype, "setIsInteractionInsertDate", [_dec4$7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$7 = _applyDecoratedDescriptor(_class2$b.prototype, "setCurrentDatePickerInfo", [_dec5$6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$b)) || _class$b);

/* script */
var __vue_script__$c = ChatActionsMenu;

/* template */
var __vue_render__$c = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('el-row', {
    attrs: {
      "id": "chat-actions-menu"
    }
  }, [_c('el-col', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('el-button', {
    staticClass: "text-primary el-dropdown-link",
    staticStyle: {
      "padding": "0.5em 0"
    },
    attrs: {
      "type": "text"
    }
  }, [_c('svg', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 172 172"
    }
  }, [_c('g', {
    staticStyle: {
      "mix-blend-mode": "normal"
    },
    attrs: {
      "fill": "none",
      "fill-rule": "nonzero",
      "stroke": "none",
      "stroke-width": "1",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "stroke-dasharray": "",
      "stroke-dashoffset": "0",
      "font-family": "none",
      "font-weight": "none",
      "font-size": "none",
      "text-anchor": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,172v-172h172v172z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#3498db"
    }
  }, [_c('path', {
    attrs: {
      "d": "M86,22.93333c-9.4993,0 -17.2,7.7007 -17.2,17.2c0,9.4993 7.7007,17.2 17.2,17.2c9.4993,0 17.2,-7.7007 17.2,-17.2c0,-9.4993 -7.7007,-17.2 -17.2,-17.2zM86,68.8c-9.4993,0 -17.2,7.7007 -17.2,17.2c0,9.4993 7.7007,17.2 17.2,17.2c9.4993,0 17.2,-7.7007 17.2,-17.2c0,-9.4993 -7.7007,-17.2 -17.2,-17.2zM86,114.66667c-9.4993,0 -17.2,7.7007 -17.2,17.2c0,9.4993 7.7007,17.2 17.2,17.2c9.4993,0 17.2,-7.7007 17.2,-17.2c0,-9.4993 -7.7007,-17.2 -17.2,-17.2z"
    }
  })])])])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    staticClass: "text-primary"
  }, [_c('p', {
    on: {
      "click": function click($event) {
        return _vm.chatFlowCommand('cmd_back');
      }
    }
  }, [_vm._v("Ripeti")])]), _vm._v(" "), _c('el-dropdown-item', {
    staticClass: "text-primary",
    attrs: {
      "divided": ""
    }
  }, [_c('p', {
    on: {
      "click": function click($event) {
        return _vm.chatFlowCommand('cmd_restart');
      }
    }
  }, [_vm._v("Ricomincia")])])], 1)], 1)], 1)], 1);
};
var __vue_staticRenderFns__$c = [];

/* style */
var __vue_inject_styles__$c = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-40d48f7c_0", {
    source: ".el-dropdown-menu__item p[data-v-40d48f7c]{margin:0;font-family:Avenir,sans-serif}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$c = "data-v-40d48f7c";
/* module identifier */
var __vue_module_identifier__$c = undefined;
/* functional template */
var __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);

var FUNCTION_NAME_EXISTS = functionName.EXISTS;



var FunctionPrototype$3 = Function.prototype;
var functionToString$1 = functionUncurryThis(FunctionPrototype$3.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = functionUncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (descriptors && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype$3, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString$1(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var $values = objectToArray.values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
_export({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

var _dec$c, _dec2$c, _dec3$9, _dec4$8, _dec5$7, _dec6$4, _dec7$4, _class$c, _class2$c, _descriptor$c, _descriptor2$9, _descriptor3$8, _descriptor4$8, _descriptor5$4, _descriptor6$4;
var AttachmentsUploader = (_dec$c = Component({}), _dec2$c = Prop({
  "default": false
}), _dec3$9 = Prop({
  "default": "inline"
}), _dec4$8 = Prop(), _dec5$7 = Prop(), _dec6$4 = Getter("chat/fetchAttachmentsUploaderConfig"), _dec7$4 = Action$1("chat/setAttachmentsUploaderConfig"), _dec$c(_class$c = (_class2$c = /*#__PURE__*/function (_Vue) {
  function AttachmentsUploader() {
    var _this;
    _classCallCheck(this, AttachmentsUploader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AttachmentsUploader, [].concat(args));
    _defineProperty(_this, "actionPath", "");
    _defineProperty(_this, "fileList", []);
    _defineProperty(_this, "payloadInfo", {});
    _defineProperty(_this, "attachmentPayload", new FormData());
    _defineProperty(_this, "attachmentUploadErrorCB", void 0);
    _defineProperty(_this, "attachmentUploadInProgress", false);
    _initializerDefineProperty(_this, "disabled", _descriptor$c, _this);
    _initializerDefineProperty(_this, "variant", _descriptor2$9, _this);
    _initializerDefineProperty(_this, "content", _descriptor3$8, _this);
    _initializerDefineProperty(_this, "attachmentsUploadErrorCallback", _descriptor4$8, _this);
    _initializerDefineProperty(_this, "attachmentsUploaderConfig", _descriptor5$4, _this);
    _initializerDefineProperty(_this, "setAttachmentsUploaderConfig", _descriptor6$4, _this);
    return _this;
  }
  _inherits(AttachmentsUploader, _Vue);
  return _createClass(AttachmentsUploader, [{
    key: "isVariantNotBubble",
    get: function get() {
      return this.variant !== "bubble";
    }
  }, {
    key: "beforeMount",
    value: function beforeMount() {
      EventHub.$on(EventHub.events.sendAttachmentMessage, this.sendAttachment);
      if (this.attachmentsUploadErrorCallback) {
        this.attachmentUploadErrorCB = this.attachmentsUploadErrorCallback;
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      EventHub.$off(EventHub.events.sendAttachmentMessage);
    }
  }, {
    key: "getMediaMessageObjByType",
    value: function getMediaMessageObjByType(info, type) {
      switch (type) {
        case "take_audio":
          return {
            type: "chat_audio",
            action: "chat_audio",
            payload: {
              filename: info.filename,
              url: info.url
            }
          };
        case "take_image":
          return {
            type: "chat_image",
            action: "chat_image",
            payload: {
              filename: info.filename,
              url: info.url,
              thumbUrl: info.thumb || info.filename
            }
          };
        case "take_video":
          return {
            type: "chat_video",
            action: "chat_video",
            payload: {
              filename: info.filename,
              url: info.url,
              thumbUrl: info.thumb || info.filename
            }
          };
        default:
          return {
            type: "chat_file",
            action: "chat_file",
            payload: {
              filename: info.filename,
              url: info.url
            }
          };
      }
    }
  }, {
    key: "messageType",
    value: function messageType(fileMimeType) {
      if (!fileMimeType || fileMimeType.indexOf("image") !== -1) {
        return {
          actionKey: "chat_image",
          type: "take_image"
        };
      } else if (fileMimeType.indexOf("audio") !== -1) {
        return {
          actionKey: "chat_audio",
          type: "take_audio"
        };
      } else if (fileMimeType.indexOf("video") !== -1) {
        return {
          actionKey: "chat_video",
          type: "take_video"
        };
      } else {
        return {
          actionKey: "chat_file",
          type: "take_document"
        };
      }
    }
  }, {
    key: "setFileType",
    value: function () {
      var _setFileType = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
        var confirmAction, fileType;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.$confirm("Confermi la scelta del file '".concat(file.name, "' ?"), "", {
                type: "info",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showClose: false,
                confirmButtonText: "Conferma scelta",
                confirmButtonClass: "btn-gradient-orange"
              });
            case 1:
              confirmAction = _context.v;
              if (confirmAction === "confirm") {
                fileType = file.raw ? file.raw.type : file.type;
                this.payloadInfo = Object.assign({}, this.payloadInfo, {
                  actionKey: this.messageType(fileType).actionKey,
                  type: this.messageType(fileType).type
                });
                if (this.attachmentsUploaderConfig.isEIMeAttachment) {
                  this.handlePayloadInfoType(this.payloadInfo.type);
                }
                if (this.actionPath) {
                  this.setAttachmentsUploaderConfig(_objectSpread2(_objectSpread2({}, this.attachmentsUploaderConfig), {}, {
                    actionPath: this.actionPath
                  }));
                }
                this.sendAttachment((file === null || file === void 0 ? void 0 : file.raw) || file);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function setFileType(_x) {
        return _setFileType.apply(this, arguments);
      }
      return setFileType;
    }()
  }, {
    key: "handlePayloadInfoType",
    value: function handlePayloadInfoType(type) {
      var _this$attachmentsUplo, _this$attachmentsUplo2, _this$attachmentsUplo3, _this$attachmentsUplo4;
      switch (type) {
        case "take_audio":
          if (((_this$attachmentsUplo = this.attachmentsUploaderConfig.actionPath) === null || _this$attachmentsUplo === void 0 ? void 0 : _this$attachmentsUplo.indexOf("/audios")) === -1) {
            this.actionPath = "".concat(this.attachmentsUploaderConfig.actionPath, "/audios");
          }
          break;
        case "take_image":
          if (((_this$attachmentsUplo2 = this.attachmentsUploaderConfig.actionPath) === null || _this$attachmentsUplo2 === void 0 ? void 0 : _this$attachmentsUplo2.indexOf("/pictures")) === -1) {
            this.actionPath = "".concat(this.attachmentsUploaderConfig.actionPath, "/pictures");
          }
          break;
        case "take_video":
          if (((_this$attachmentsUplo3 = this.attachmentsUploaderConfig.actionPath) === null || _this$attachmentsUplo3 === void 0 ? void 0 : _this$attachmentsUplo3.indexOf("/videos")) === -1) {
            this.actionPath = "".concat(this.attachmentsUploaderConfig.actionPath, "/videos");
          }
          break;
        default:
          if (((_this$attachmentsUplo4 = this.attachmentsUploaderConfig.actionPath) === null || _this$attachmentsUplo4 === void 0 ? void 0 : _this$attachmentsUplo4.indexOf("/documents")) === -1) {
            this.actionPath = "".concat(this.attachmentsUploaderConfig.actionPath, "/documents");
          }
          break;
      }
    }
  }, {
    key: "handleExceed",
    value: function handleExceed(files, fileList) {
      delete this.fileList[0];
      this.fileList[0] = files[0];
      this.setFileType(files[0]);
    }
  }, {
    key: "prepareAttachmentPayload",
    value: function prepareAttachmentPayload() {
      var currentConfig = this.attachmentsUploaderConfig;
      if (currentConfig.hasOwnProperty("requestData")) {
        var rd = currentConfig.requestData;
        for (var i = 0; i < Object.keys(rd).length; i++) {
          var key = Object.keys(rd)[i];
          if (Object.values(rd)[i]) {
            if (!this.attachmentPayload.has(key)) {
              this.attachmentPayload.append(key, Object.values(rd)[i]);
            } else {
              this.attachmentPayload.set(key, Object.values(rd)[i]);
            }
          }
        }
      }
    }
  }, {
    key: "sendAttachment",
    value: function sendAttachment(file) {
      var _this2 = this;
      this.prepareAttachmentPayload();
      this.attachmentPayload.set("attachment", file);
      if (this.attachmentsUploaderConfig.actionPath) {
        this.attachmentUploadInProgress = true;
        axios.post(this.attachmentsUploaderConfig.actionPath, this.attachmentPayload, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }).then(function (res) {
          _newArrowCheck(this, _this2);
          if (res.status === 200 || res.status === 201) {
            this.handleUploadSuccess(res);
          }
        }.bind(this))["catch"](function (err) {
          _newArrowCheck(this, _this2);
          var errorMessage = "Si è verificato un errore nell' invio del file";
          if (this.attachmentUploadErrorCB) {
            var error = err.response.hasOwnProperty("data") ? err.response.data : err.response;
            errorMessage = this.attachmentUploadErrorCB(error);
          }
          this.$alert(errorMessage, "Errore", {
            confirmButtonText: "Chiudi",
            confirmButtonClass: "btn-gradient-orange",
            type: "error"
          });
        }.bind(this))["finally"](function () {
          _newArrowCheck(this, _this2);
          return this.attachmentUploadInProgress = false;
        }.bind(this));
      }
    }
  }, {
    key: "hideAttachmentUploader",
    value: function hideAttachmentUploader() {
      this.setAttachmentsUploaderConfig(_objectSpread2(_objectSpread2({}, this.attachmentsUploaderConfig), {}, {
        use: false
      }));
    }
  }, {
    key: "handleUploadSuccess",
    value: function handleUploadSuccess(res) {
      var fileInfo = this.attachmentPayload.get("attachment");
      var info = res.data.hasOwnProperty("body") ? res.data.body : res.data;
      var mediaMessage = this.getMediaMessageObjByType(_objectSpread2(_objectSpread2({}, info), {}, {
        filename: fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.name
      }), this.payloadInfo.type);
      EventHub.$emit(EventHub.events.sendMessage, mediaMessage);
    }
  }]);
}(Vue$2), _descriptor$c = _applyDecoratedDescriptor(_class2$c.prototype, "disabled", [_dec2$c], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$9 = _applyDecoratedDescriptor(_class2$c.prototype, "variant", [_dec3$9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$8 = _applyDecoratedDescriptor(_class2$c.prototype, "content", [_dec4$8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$8 = _applyDecoratedDescriptor(_class2$c.prototype, "attachmentsUploadErrorCallback", [_dec5$7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5$4 = _applyDecoratedDescriptor(_class2$c.prototype, "attachmentsUploaderConfig", [_dec6$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6$4 = _applyDecoratedDescriptor(_class2$c.prototype, "setAttachmentsUploaderConfig", [_dec7$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$c)) || _class$c);

/* script */
var __vue_script__$d = AttachmentsUploader;

/* template */
var __vue_render__$d = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_vm.isVariantNotBubble ? [_c('div', {
    staticClass: "file-uploader-controls",
    "class": _vm.variant || 'inline'
  }, [_c('el-upload', {
    ref: "uploader",
    staticClass: "custom-file-uploader",
    attrs: {
      "file-list": _vm.fileList,
      "limit": 1,
      "show-file-list": false,
      "auto-upload": false,
      "accept": "accepted",
      "action": _vm.actionPath,
      "on-change": _vm.setFileType,
      "on-exceed": _vm.handleExceed,
      "disabled": _vm.attachmentUploadInProgress || _vm.disabled
    }
  }, [_c('el-button', {
    staticClass: "uploader-trigger.text-primary",
    attrs: {
      "slot": "trigger",
      "type": "text",
      "disabled": _vm.attachmentUploadInProgress || _vm.disabled
    },
    slot: "trigger"
  }, [!_vm.attachmentUploadInProgress ? [_c('svg', {
    staticStyle: {
      "fill": "#000000"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "x": "0px",
      "y": "0px",
      "width": "30",
      "height": "30",
      "viewBox": "0 0 172 172"
    }
  }, [_c('g', {
    staticStyle: {
      "mix-blend-mode": "normal"
    },
    attrs: {
      "fill": "none",
      "fill-rule": "nonzero",
      "stroke": "none",
      "stroke-width": "1",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "stroke-dasharray": "",
      "stroke-dashoffset": "0",
      "font-family": "none",
      "font-weight": "none",
      "font-size": "none",
      "text-anchor": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,172v-172h172v172z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#3498db"
    }
  }, [_c('path', {
    attrs: {
      "d": "M116.37995,17.30078c-8.44701,0 -16.88573,3.3465 -23.21328,10.02214l-45.91146,48.43099c-17.16635,18.11531 -17.16635,47.23573 0,65.35104c0.52921,0.55767 1.16517,1.00322 1.87005,1.31016c0.01119,0.00377 0.02238,0.0075 0.03359,0.0112c17.2954,16.3895 44.27357,16.20633 60.88307,-1.32136l32.29479,-34.07526c1.48863,-1.47161 2.05704,-3.63749 1.48289,-5.65045c-0.57415,-2.01296 -2.1996,-3.5531 -4.24057,-4.01798c-2.04097,-0.46488 -4.17308,0.21936 -5.56237,1.7851l-32.29479,34.07526c-12.91019,13.62387 -33.22523,13.62387 -46.13542,0c-12.91072,-13.62442 -12.91072,-35.95995 0,-49.58437l45.90026,-48.43099c8.3977,-8.85966 21.39996,-8.85966 29.79766,0c8.39685,8.85878 8.39685,23.4808 0,32.33958l-41.77943,44.0862c-3.89237,4.10367 -9.57412,4.10063 -13.45989,0c-3.88584,-4.10069 -3.88584,-11.0053 0,-15.10599l33.60495,-35.4638c1.48862,-1.47162 2.05702,-3.63749 1.48287,-5.65044c-0.57415,-2.01296 -2.1996,-3.55309 -4.24056,-4.01797c-2.04096,-0.46489 -4.17307,0.21935 -5.56237,1.78508l-33.61614,35.46381c-8.14269,8.59291 -8.14269,22.27974 0,30.87265c0.54349,0.57197 1.19918,1.02561 1.92604,1.33255c8.25968,6.90012 20.59826,6.66621 28.18516,-1.33255l41.77942,-44.0862c12.13377,-12.80126 12.30831,-32.83503 1.17579,-46.2474c-0.2683,-0.68969 -0.66757,-1.32092 -1.17579,-1.85885c-6.32755,-6.67564 -14.77746,-10.02214 -23.22448,-10.02214z"
    }
  })])])])] : [_c('svg', {
    staticStyle: {
      "margin": "auto",
      "background": "#fff",
      "display": "block"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "33px",
      "height": "33px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "8.43317",
      "fill": "none",
      "stroke": "#225080",
      "stroke-width": "4"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "r",
      "repeatCount": "indefinite",
      "dur": "1s",
      "values": "0;40",
      "keyTimes": "0;1",
      "keySplines": "0 0.2 0.8 1",
      "calcMode": "spline",
      "begin": "-0.5s"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "opacity",
      "repeatCount": "indefinite",
      "dur": "1s",
      "values": "1;0",
      "keyTimes": "0;1",
      "keySplines": "0.2 0 0.8 1",
      "calcMode": "spline",
      "begin": "-0.5s"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "29.819",
      "fill": "none",
      "stroke": "#ff3800",
      "stroke-width": "4"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "r",
      "repeatCount": "indefinite",
      "dur": "1s",
      "values": "0;40",
      "keyTimes": "0;1",
      "keySplines": "0 0.2 0.8 1",
      "calcMode": "spline"
    }
  }), _vm._v(" "), _c('animate', {
    attrs: {
      "attributeName": "opacity",
      "repeatCount": "indefinite",
      "dur": "1s",
      "values": "1;0",
      "keyTimes": "0;1",
      "keySplines": "0.2 0 0.8 1",
      "calcMode": "spline"
    }
  })])])]], 2)], 1)], 1)] : _vm._e()], 2);
};
var __vue_staticRenderFns__$d = [];

/* style */
var __vue_inject_styles__$d = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-3b2d5bd1_0", {
    source: ".uploader-trigger[data-v-3b2d5bd1]{padding:.35em 0}.uploading-controls-host[data-v-3b2d5bd1]{padding-right:100px}.file-uploader-controls.inline[data-v-3b2d5bd1]{padding:.15em}.file-uploader-controls .attachment-actions[data-v-3b2d5bd1]{position:absolute;bottom:-5px;left:3em}.file-uploader-controls .spinner-border[data-v-3b2d5bd1]{width:21px;height:21px;margin:8px 5px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$d = "data-v-3b2d5bd1";
/* module identifier */
var __vue_module_identifier__$d = undefined;
/* functional template */
var __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

var _dec$d, _dec2$d, _dec3$a, _dec4$9, _dec5$8, _dec6$5, _dec7$5, _dec8$3, _dec9$3, _dec0$3, _dec1$2, _dec10$1, _dec11$1, _dec12$1, _dec13$1, _dec14$1, _dec15$1, _dec16$1, _dec17$1, _dec18$1, _dec19$1, _dec20$1, _dec21$1, _dec22$1, _dec23$1, _dec24$1, _dec25$1, _dec26$1, _dec27$1, _dec28$1, _dec29$1, _dec30$1, _dec31$1, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _class$d, _class2$d, _descriptor$d, _descriptor2$a, _descriptor3$9, _descriptor4$9, _descriptor5$5, _descriptor6$5, _descriptor7$3, _descriptor8$3, _descriptor9$3, _descriptor0$3, _descriptor1$1, _descriptor10$1, _descriptor11$1, _descriptor12$1, _descriptor13$1, _descriptor14$1, _descriptor15$1, _descriptor16$1, _descriptor17$1, _descriptor18$1, _descriptor19$1, _descriptor20$1, _descriptor21$1, _descriptor22$1, _descriptor23$1, _descriptor24$1, _descriptor25$1, _descriptor26$1, _descriptor27$1, _descriptor28;
var UserInputArea = (_dec$d = Component({
  components: {
    ChatActionsMenu: __vue_component__$c,
    AttachmentsUploader: __vue_component__$d
  }
}), _dec2$d = Getter("xmpp/instance"), _dec3$a = Getter("chat/fetchAttachmentsUploaderConfig"), _dec4$9 = Getter("chat/isInteractionInsertLocation"), _dec5$8 = Action$1("chat/setIsInteractionInsertLocation"), _dec6$5 = Action$1("chat/setIsLocationModalEnable"), _dec7$5 = Getter("chat/isInteractionSingleAutocomplete"), _dec8$3 = Action$1("chat/setIsInteractionSingleAutocomplete"), _dec9$3 = Getter("chat/isInteractionMultipleAutocomplete"), _dec0$3 = Action$1("chat/setIsInteractionMultipleAutocomplete"), _dec1$2 = Getter("chat/currentAutocompleteInfo"), _dec10$1 = Action$1("chat/setCurrentAutocompleteInfo"), _dec11$1 = Getter("chat/currentAutocompleteList"), _dec12$1 = Action$1("chat/setCurrentAutocompleteList"), _dec13$1 = Action$1("chat/setIsInteractionInsertDate"), _dec14$1 = Action$1("chat/setCurrentDatePickerInfo"), _dec15$1 = Getter("chat/isInteractionInsertDate"), _dec16$1 = Getter("chat/currentDatePickerInfo"), _dec17$1 = Getter("chat/modeBeforeSubmit"), _dec18$1 = Getter("chat/visibilityAfterSubmit"), _dec19$1 = Getter("chat/getBotConfigSettings"), _dec20$1 = Action$1("voiceInterface/setIsVoiceAudioEnabled"), _dec21$1 = Action$1("voiceInterface/setIsMicListening"), _dec22$1 = Getter("voiceInterface/isVoiceInterfaceEnabled"), _dec23$1 = Getter("voiceInterface/isVoiceAudioEnabled"), _dec24$1 = Getter("voiceInterface/isMicListening"), _dec25$1 = Getter("voiceInterface/isMicHasErrors"), _dec26$1 = Prop(Boolean), _dec27$1 = Prop(Function), _dec28$1 = Prop(Object), _dec29$1 = Prop(Function), _dec30$1 = Watch("isInteractionInsertLocation"), _dec31$1 = Watch("isInteractionInsertDate"), _dec32 = Watch("isInteractionSingleAutocomplete"), _dec33 = Watch("isInteractionMultipleAutocomplete"), _dec34 = Watch("currentAutocompleteList"), _dec35 = Watch("currentAutocompleteInfo"), _dec36 = Watch("inputLocation"), _dec37 = Watch("modeBeforeSubmit"), _dec38 = Watch("visibilityAfterSubmit"), _dec$d(_class$d = (_class2$d = /*#__PURE__*/function (_Vue) {
  function UserInputArea() {
    var _this;
    _classCallCheck(this, UserInputArea);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserInputArea, [].concat(args));
    _defineProperty(_this, "datePickerOptions", {});
    _defineProperty(_this, "datePickerType", "date");
    _defineProperty(_this, "showInputDate", false);
    _defineProperty(_this, "userInput", "");
    _defineProperty(_this, "userInputDate", "");
    _defineProperty(_this, "userInputLocation", "");
    _defineProperty(_this, "userInputSingleAutocomplete", "");
    _defineProperty(_this, "userInputMultipleAutocomplete", []);
    _defineProperty(_this, "userInputSingleAutocompleteSelected", {});
    _defineProperty(_this, "userInputMultipleAutocompleteSelected", []);
    _defineProperty(_this, "userInputMultipleAutocompleteOptions", []);
    _defineProperty(_this, "content", void 0);
    _defineProperty(_this, "inputEnabled", true);
    _initializerDefineProperty(_this, "instance", _descriptor$d, _this);
    _initializerDefineProperty(_this, "customAttachmentUploaderProps", _descriptor2$a, _this);
    // location node
    _initializerDefineProperty(_this, "isInteractionInsertLocation", _descriptor3$9, _this);
    _initializerDefineProperty(_this, "setIsInteractionInsertLocation", _descriptor4$9, _this);
    _initializerDefineProperty(_this, "setIsLocationModalEnable", _descriptor5$5, _this);
    // autocomplete node
    _initializerDefineProperty(_this, "isInteractionSingleAutocomplete", _descriptor6$5, _this);
    _initializerDefineProperty(_this, "setIsInteractionSingleAutocomplete", _descriptor7$3, _this);
    _initializerDefineProperty(_this, "isInteractionMultipleAutocomplete", _descriptor8$3, _this);
    _initializerDefineProperty(_this, "setIsInteractionMultipleAutocomplete", _descriptor9$3, _this);
    _initializerDefineProperty(_this, "currentAutocompleteInfo", _descriptor0$3, _this);
    _initializerDefineProperty(_this, "setCurrentAutocompleteInfo", _descriptor1$1, _this);
    _initializerDefineProperty(_this, "currentAutocompleteList", _descriptor10$1, _this);
    _initializerDefineProperty(_this, "setCurrentAutocompleteList", _descriptor11$1, _this);
    // date node
    _initializerDefineProperty(_this, "setIsInteractionInsertDate", _descriptor12$1, _this);
    _initializerDefineProperty(_this, "setCurrentDatePickerInfo", _descriptor13$1, _this);
    _initializerDefineProperty(_this, "isInteractionInsertDate", _descriptor14$1, _this);
    _initializerDefineProperty(_this, "currentDatePickerInfo", _descriptor15$1, _this);
    _initializerDefineProperty(_this, "modeBeforeSubmit", _descriptor16$1, _this);
    _initializerDefineProperty(_this, "visibilityAfterSubmit", _descriptor17$1, _this);
    _initializerDefineProperty(_this, "getBotConfigSettings", _descriptor18$1, _this);
    _initializerDefineProperty(_this, "setIsVoiceAudioEnabled", _descriptor19$1, _this);
    _initializerDefineProperty(_this, "setIsMicListening", _descriptor20$1, _this);
    _initializerDefineProperty(_this, "isVoiceInterfaceEnabled", _descriptor21$1, _this);
    _initializerDefineProperty(_this, "isVoiceAudioEnabled", _descriptor22$1, _this);
    _initializerDefineProperty(_this, "isMicListening", _descriptor23$1, _this);
    _initializerDefineProperty(_this, "isMicHasErrors", _descriptor24$1, _this);
    _initializerDefineProperty(_this, "hideMenu", _descriptor25$1, _this);
    _initializerDefineProperty(_this, "attachmentsUploadErrorCallback", _descriptor26$1, _this);
    _initializerDefineProperty(_this, "inputLocation", _descriptor27$1, _this);
    _initializerDefineProperty(_this, "onConfirmSendLocationCallback", _descriptor28, _this);
    return _this;
  }
  _inherits(UserInputArea, _Vue);
  return _createClass(UserInputArea, [{
    key: "isButtonEnabled",
    get: function get() {
      return isXmppConnectionActive(this.instance);
    }
  }, {
    key: "isInputText",
    get: function get() {
      return !this.showInputDate && !this.isInteractionInsertLocation && !this.isInteractionSingleAutocomplete && !this.isInteractionMultipleAutocomplete;
    }
  }, {
    key: "isInputDate",
    get: function get() {
      return this.showInputDate;
    }
  }, {
    key: "isInputLocation",
    get: function get() {
      return this.isInteractionInsertLocation;
    }
  }, {
    key: "isInputSingleAutocomplete",
    get: function get() {
      return this.isInteractionSingleAutocomplete;
    }
  }, {
    key: "isInputMultipleAutocomplete",
    get: function get() {
      return this.isInteractionMultipleAutocomplete;
    }
  }, {
    key: "isInputTextEmpty",
    get: function get() {
      return this.userInput.trim().length <= 0;
    }
  }, {
    key: "isInputDateEmpty",
    get: function get() {
      return this.userInputDate.length <= 0;
    }
  }, {
    key: "isInputLocationEmpty",
    get: function get() {
      return this.userInputLocation.length <= 0;
    }
  }, {
    key: "isInputSingleAutocompleteEmpty",
    get: function get() {
      return Object.entries(this.userInputSingleAutocompleteSelected).length <= 0;
    }
  }, {
    key: "isInputMultipleAutocompleteEmpty",
    get: function get() {
      return this.userInputMultipleAutocompleteSelected.length <= 0;
    }
  }, {
    key: "isMicEnabled",
    get: function get() {
      return this.isMicListening && !this.isMicHasErrors;
    }
  }, {
    key: "isVoiceInterfaceButtonDisabled",
    get: function get() {
      return !isXmppConnectionActive(this.instance) || this.isInputDisabled;
    }
  }, {
    key: "isSendButtonDisabled",
    get: function get() {
      return !isXmppConnectionActive(this.instance) || this.isInputDisabled;
    }
  }, {
    key: "isInputDisabled",
    get: function get() {
      return this.isModeBeforeSubmitInputBlocked && !this.isInputMultipleAutocomplete || !this.inputEnabled || this.isInputMultipleAutocomplete && !this.isInputMultipleAutocompleteEnabled;
    }
  }, {
    key: "isInputMultipleAutocompleteEnabled",
    get: function get() {
      if (this.isInputMultipleAutocomplete && Object.entries(this.currentAutocompleteInfo).length > 0) {
        var _this$currentAutocomp = this.currentAutocompleteInfo.payload.inputData.choice,
          minSelectable = _this$currentAutocomp.minSelectable,
          maxSelectable = _this$currentAutocomp.maxSelectable;
        return !this.isInputMultipleAutocompleteEmpty && !isMultipleMinMaxSelectableNotOk(this.userInputMultipleAutocompleteSelected, {
          minSelectable: minSelectable,
          maxSelectable: maxSelectable
        });
      }
      return false;
    }
  }, {
    key: "isModeBeforeSubmitInputBlocked",
    get: function get() {
      return this.modeBeforeSubmit === "inputBlock";
    }
  }, {
    key: "isModeBeforeSubmitInputHide",
    get: function get() {
      return this.modeBeforeSubmit === "inputHide";
    }
  }, {
    key: "isModeBeforeSubmitInputNone",
    get: function get() {
      return this.modeBeforeSubmit === "none";
    }
  }, {
    key: "canShowAttachmentUploader",
    get: function get() {
      return this.customAttachmentUploaderProps && this.customAttachmentUploaderProps.use;
    }
  }, {
    key: "canShowVoiceInterface",
    get: function get() {
      return this.isVoiceInterfaceEnabled === true;
    }
  }, {
    key: "getInputAreaInlineStyles",
    get: function get() {
      var styles = {};
      if (this.isModeBeforeSubmitInputNone) {
        styles = {
          display: "none"
        };
      }
      return styles;
    }
  }, {
    key: "getMenuSpanCount",
    get: function get() {
      return this.canShowAttachmentUploader ? 12 : 16;
    }
  }, {
    key: "getNoMenuSpanCount",
    get: function get() {
      return this.canShowAttachmentUploader ? 16 : 20;
    }
  }, {
    key: "getSpanCount",
    get: function get() {
      return !this.hideMenu ? this.getMenuSpanCount : this.getNoMenuSpanCount;
    }
  }, {
    key: "getPayloadInputText",
    get: function get() {
      return {
        type: "chat_text",
        action: "chat_text",
        payload: {
          text: this.userInput
        }
      };
    }
  }, {
    key: "getPayloadInputDate",
    get: function get() {
      return {
        type: "chat_date",
        action: "chat_date",
        payload: {
          dateType: typeof this.userInputDate === "string" ? "date" : "date_range",
          value: typeof this.userInputDate === "string" ? this.userInputDate : this.userInputDate.join("/")
        }
      };
    }
  }, {
    key: "getPayloadInputLocation",
    get: function get() {
      return {
        type: "chat_location",
        action: "chat_location",
        payload: _objectSpread2({}, this.inputLocation)
      };
    }
  }, {
    key: "getPayloadInputSingleAutocomplete",
    get: function get() {
      var selectedOption = this.userInputSingleAutocompleteSelected.item;
      return _objectSpread2({}, getCorrectedSingleChoicePayload(this.currentAutocompleteInfo.payload, selectedOption));
    }
  }, {
    key: "getPayloadInputMultipleAutocomplete",
    get: function get() {
      var _this2 = this;
      var selectedMultipleOptions = this.currentAutocompleteList.reduce(function (acc, option) {
        _newArrowCheck(this, _this2);
        if (this.userInputMultipleAutocompleteSelected.includes(option.value)) {
          acc.push(_objectSpread2({}, option.item));
        }
        return acc;
      }.bind(this), []);
      return _objectSpread2({}, getCorrectedMultipleChoicePayload(this.currentAutocompleteInfo.payload, selectedMultipleOptions));
    }
  }, {
    key: "getLabelMicrophone",
    get: function get() {
      return this.isMicEnabled ? this.getLabel.placeholder_mic_disable : this.getLabel.placeholder_mic_enable;
    }
  }, {
    key: "getLabel",
    get: function get() {
      var labels = this.getBotConfigSettings.labels;
      return {
        input_text: labels === null || labels === void 0 ? void 0 : labels.label_input_text_placeholder,
        input_blocked: labels === null || labels === void 0 ? void 0 : labels.label_select_button_first,
        placeholder_date: labels === null || labels === void 0 ? void 0 : labels.label_input_date_placeholder,
        placeholder_location: labels === null || labels === void 0 ? void 0 : labels.label_input_location_placeholder,
        placeholder_autocomplete: labels === null || labels === void 0 ? void 0 : labels.label_input_autocomplete_placeholder,
        placeholder_mic_enable: "Enable Mic",
        placeholder_mic_disable: "Disable Mic",
        placeholder_dictate: "Dictate"
      };
    }
  }, {
    key: "created",
    value: function created() {
      var _this3 = this;
      // catch sent messages
      EventHub.$on(EventHub.events.sendMessage, this.sendMessageAction);
      // enable/disable input
      EventHub.$on(EventHub.events.enableMainInput, function (isText) {
        _newArrowCheck(this, _this3);
        this.inputEnabled = isText;
        if (!isText) {
          this.userInput = "";
        }
      }.bind(this));
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      EventHub.$off(EventHub.events.sendMessage);
      EventHub.$off(EventHub.events.sessionExpired);
      EventHub.$off(EventHub.events.enableMainInput);
    }
  }, {
    key: "sendMessageAction",
    value: function sendMessageAction(msg) {
      EventHub.$emit(EventHub.events.sendMessageAction, msg);
    }
  }, {
    key: "validateMessageInput",
    value: function validateMessageInput() {
      if (this.isInputDate) {
        return !this.isInputDateEmpty;
      } else if (this.isInputLocation) {
        return !this.isInputLocationEmpty;
      } else if (this.isInputSingleAutocomplete) {
        return !this.isInputSingleAutocompleteEmpty;
      } else if (this.isInputMultipleAutocomplete) {
        return !this.isInputMultipleAutocompleteEmpty;
      } else {
        return !this.isInputTextEmpty;
      }
    }
  }, {
    key: "resetModelInputs",
    value: function resetModelInputs() {
      this.userInputLocation = "";
      this.userInputSingleAutocomplete = "";
      this.userInputMultipleAutocomplete = [];
      this.userInputSingleAutocompleteSelected = {};
      this.userInputMultipleAutocompleteSelected = [];
      this.userInputMultipleAutocompleteOptions = [];
      this.userInputDate = "";
      this.userInput = "";
    }
  }, {
    key: "inputMessageSendAction",
    value: function inputMessageSendAction() {
      if (isXmppConnectionActive(this.instance)) {
        // handle input validation
        if (this.validateMessageInput()) {
          var message = {};
          if (this.isInputDate) {
            message = this.getPayloadInputDate;
          } else if (this.isInputLocation) {
            message = this.getPayloadInputLocation;
          } else if (this.isInputSingleAutocomplete) {
            message = this.getPayloadInputSingleAutocomplete;
          } else if (this.isInputMultipleAutocomplete) {
            message = this.getPayloadInputMultipleAutocomplete;
          } else {
            message = this.getPayloadInputText;
          }
          EventHub.$emit(EventHub.events.sendMessage, message);
          // reset inputs
          this.resetModelInputs();
          // reset input date
          this.setIsInteractionInsertDate(false);
          this.setCurrentDatePickerInfo({});
          // reset autocomplete
          this.setIsInteractionSingleAutocomplete(false);
          this.setIsInteractionMultipleAutocomplete(false);
          this.setCurrentAutocompleteInfo({});
          this.setCurrentAutocompleteList([]);

          // reset input location
          if (this.isInputLocation) {
            this.setIsInteractionInsertLocation(false);
            this.onConfirmSendLocationCallback({});
          }
        }
      } else {
        this.emitNoXMPPConnectionNotification();
      }
    }
  }, {
    key: "emitNoXMPPConnectionNotification",
    value: function emitNoXMPPConnectionNotification() {
      EventHub.$emit(EventHub.events.sessionExpired, true);
    }
  }, {
    key: "inputAttachmentSendAction",
    value: function inputAttachmentSendAction() {
      EventHub.$emit(EventHub.events.sendAttachmentMessage, true);
    }
  }, {
    key: "getFilteredChoicesList",
    value: function getFilteredChoicesList() {
      var _this4 = this;
      var choicesList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var searchString = arguments.length > 1 ? arguments[1] : undefined;
      return choicesList.filter(function (choice) {
        _newArrowCheck(this, _this4);
        return choice.text.toLowerCase().includes(searchString.toLowerCase());
      }.bind(this));
    }
  }, {
    key: "geFilteredMultipleChoicesList",
    value: function geFilteredMultipleChoicesList() {
      var _this5 = this;
      var optionsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var searchString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      // 1st, filter only available choices
      var remainingChoices = _toConsumableArray(optionsData).filter(function (item) {
        _newArrowCheck(this, _this5);
        return !this.userInputMultipleAutocomplete.includes(item.value);
      }.bind(this));
      var filteredResults = this.getFilteredChoicesList(remainingChoices, searchString);
      // only return first 5 items
      return filteredResults.slice(0, 5);
    }
  }, {
    key: "onClickEnableVoiceMic",
    value: function onClickEnableVoiceMic() {
      this.setIsMicListening(!this.isMicListening);
      this.setIsVoiceAudioEnabled(!this.isVoiceAudioEnabled);
    }
  }, {
    key: "onClickInputLocation",
    value: function onClickInputLocation(evt) {
      this.setIsLocationModalEnable(true);
    }
  }, {
    key: "onFetchSingleAutocompleteSuggestions",
    value: function onFetchSingleAutocompleteSuggestions(searchString, callback) {
      // TODO: commented for now, might uncomment back later
      // if (searchString && searchString.length >= 3) {
      if (searchString) {
        var filteredResults = this.getFilteredChoicesList(this.currentAutocompleteList, searchString);
        // only return first 5 items
        var trimmedResults = filteredResults.slice(0, 5);
        // callback function to return suggestions
        callback(_toConsumableArray(trimmedResults));
      } else {
        return [];
      }
    }
  }, {
    key: "onFetchMultipleAutocompleteSuggestions",
    value: function onFetchMultipleAutocompleteSuggestions(searchString) {
      if (searchString) {
        var trimmedResults = this.geFilteredMultipleChoicesList(this.currentAutocompleteList, searchString);
        this.userInputMultipleAutocompleteOptions = _toConsumableArray(trimmedResults);
      } else {
        this.userInputMultipleAutocompleteOptions = [];
      }
    }
  }, {
    key: "onSelectSingleAutocomplete",
    value: function onSelectSingleAutocomplete(item) {
      this.userInputSingleAutocompleteSelected = _objectSpread2({}, item);
      // fire sendMessageAction
      this.inputMessageSendAction();
    }
  }, {
    key: "onChangeMultipleAutocomplete",
    value: function onChangeMultipleAutocomplete() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.userInputMultipleAutocompleteSelected = _toConsumableArray(items);
      var trimmedResults = this.geFilteredMultipleChoicesList(this.currentAutocompleteList, "");
      this.userInputMultipleAutocompleteOptions = _toConsumableArray(trimmedResults);
    }
  }, {
    key: "handleToggleInputDate",
    value: function handleToggleInputDate(dateInfo) {
      if (dateInfo) {
        var status = dateInfo.status;
        this.showInputDate = status === "input_date";
      } else {
        this.showInputDate = false;
      }
    }
  }, {
    key: "handleDatePickerType",
    value: function handleDatePickerType() {
      var dateInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var dateType = dateInfo.type;
      this.datePickerType = dateType ? dateType.replace("_", "") : "date";
    }
  }, {
    key: "handleShowInputdate",
    value: function handleShowInputdate(dateInfo) {
      if (this.showInputDate) {
        this.handleDatePickerType(dateInfo);
        var options = dateInfo.options;
        if (options) {
          this.datePickerOptions = {
            disabledDate: function disabledDate(date) {
              var minStartDate = options.minStartDate,
                maxStartDate = options.maxStartDate;
              if (minStartDate && maxStartDate) {
                // we need to get the previous day of the minStartDate
                var prevDayStartDateMin = minStartDate === "today" ? getPreviousDateByDays(1, new Date()) : getPreviousDateByDays(1, minStartDate);
                var startDateMin = new Date(prevDayStartDateMin).getTime();
                var startDateMax = maxStartDate === "today" ? Date.now() : new Date(maxStartDate).getTime();

                // disable dates outside minimum and maximum dates specified
                return date.getTime() < startDateMin || date.getTime() > startDateMax;
              } else if (minStartDate) {
                // we need to get the previous day of the minStartDate
                var _prevDayStartDateMin = minStartDate === "today" ? getPreviousDateByDays(1, new Date()) : getPreviousDateByDays(1, minStartDate);

                // only disable previous dates from min date specified
                return date.getTime() < new Date(_prevDayStartDateMin).getTime();
              } else if (maxStartDate) {
                // only disable future dates from max date specified
                var _startDateMax = maxStartDate === "today" ? Date.now() : new Date(maxStartDate).getTime();
                return date.getTime() > _startDateMax;
              } else {
                // otherwise, enable all dates
                return false;
              }
            }
          };
        }
      }
    }
  }, {
    key: "handleIsInteractionInputLocation",
    value: function handleIsInteractionInputLocation(toggle) {
      var _this6 = this;
      if (toggle) {
        var inputElem = document.getElementById('main-input');
        var inputLocationElem = document.getElementById('main-input-location');
        // remove the input auto focus for location message
        // because we want to actually let the user do it
        // to show the modal for location
        inputElem === null || inputElem === void 0 ? void 0 : inputElem.blur();
        inputLocationElem === null || inputLocationElem === void 0 ? void 0 : inputLocationElem.blur();
        this.resetModelInputs();
      } else {
        setTimeout(function () {
          _newArrowCheck(this, _this6);
          var inputElem = document.getElementById('main-input');
          inputElem === null || inputElem === void 0 ? void 0 : inputElem.focus();
        }.bind(this), 100);
      }
    }
  }, {
    key: "handleIsInteractionInsertDate",
    value: function handleIsInteractionInsertDate(toggle) {
      this.handleToggleInputDate(this.currentDatePickerInfo);
      if (toggle) {
        this.handleShowInputdate(this.currentDatePickerInfo);
      }
    }
  }, {
    key: "handleIsInteractionSingleAutocomplete",
    value: function handleIsInteractionSingleAutocomplete(toggle) {
      // console.log("watcher isInteractionSingleAutocomplete: ", toggle);
      if (!toggle) {
        // reset inputs
        this.resetModelInputs();
      }
    }
  }, {
    key: "handleIsInteractionMultipleAutocomplete",
    value: function handleIsInteractionMultipleAutocomplete(toggle) {
      // console.log("watcher isInteractionMultipleAutocomplete: ", toggle)
      if (!toggle) {
        // reset inputs
        this.resetModelInputs();
      }
    }
  }, {
    key: "handleCurrentAutocompleteList",
    value: function handleCurrentAutocompleteList() {
    } // console.log("watcher currentAutocompleteList: ", JSON.stringify(options));
  }, {
    key: "handleCurrentAutocompleteInfo",
    value: function handleCurrentAutocompleteInfo() {
    } // console.log("watcher currentAutocompleteInfo: ", JSON.stringify(info));
  }, {
    key: "populateInputLocation",
    value: function populateInputLocation(params) {
      var text = params.text;
      if (text) {
        this.userInputLocation = text;
        this.inputMessageSendAction();
      } else {
        this.resetModelInputs();
      }
    }
  }, {
    key: "handleModeBeforeSubmit",
    value: function handleModeBeforeSubmit(newValue) {
      // console.log("watcher modeBeforeSubmit: ", newValue);
    }
  }, {
    key: "handleVisibilityAfterSubmit",
    value: function handleVisibilityAfterSubmit(newValue) {
      // console.log("watcher visibilityAfterSubmit: ", newValue);
    }
  }]);
}(Vue$2), _descriptor$d = _applyDecoratedDescriptor(_class2$d.prototype, "instance", [_dec2$d], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$a = _applyDecoratedDescriptor(_class2$d.prototype, "customAttachmentUploaderProps", [_dec3$a], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$9 = _applyDecoratedDescriptor(_class2$d.prototype, "isInteractionInsertLocation", [_dec4$9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$9 = _applyDecoratedDescriptor(_class2$d.prototype, "setIsInteractionInsertLocation", [_dec5$8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5$5 = _applyDecoratedDescriptor(_class2$d.prototype, "setIsLocationModalEnable", [_dec6$5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6$5 = _applyDecoratedDescriptor(_class2$d.prototype, "isInteractionSingleAutocomplete", [_dec7$5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7$3 = _applyDecoratedDescriptor(_class2$d.prototype, "setIsInteractionSingleAutocomplete", [_dec8$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8$3 = _applyDecoratedDescriptor(_class2$d.prototype, "isInteractionMultipleAutocomplete", [_dec9$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9$3 = _applyDecoratedDescriptor(_class2$d.prototype, "setIsInteractionMultipleAutocomplete", [_dec0$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0$3 = _applyDecoratedDescriptor(_class2$d.prototype, "currentAutocompleteInfo", [_dec1$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1$1 = _applyDecoratedDescriptor(_class2$d.prototype, "setCurrentAutocompleteInfo", [_dec10$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10$1 = _applyDecoratedDescriptor(_class2$d.prototype, "currentAutocompleteList", [_dec11$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11$1 = _applyDecoratedDescriptor(_class2$d.prototype, "setCurrentAutocompleteList", [_dec12$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12$1 = _applyDecoratedDescriptor(_class2$d.prototype, "setIsInteractionInsertDate", [_dec13$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13$1 = _applyDecoratedDescriptor(_class2$d.prototype, "setCurrentDatePickerInfo", [_dec14$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14$1 = _applyDecoratedDescriptor(_class2$d.prototype, "isInteractionInsertDate", [_dec15$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15$1 = _applyDecoratedDescriptor(_class2$d.prototype, "currentDatePickerInfo", [_dec16$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16$1 = _applyDecoratedDescriptor(_class2$d.prototype, "modeBeforeSubmit", [_dec17$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17$1 = _applyDecoratedDescriptor(_class2$d.prototype, "visibilityAfterSubmit", [_dec18$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18$1 = _applyDecoratedDescriptor(_class2$d.prototype, "getBotConfigSettings", [_dec19$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19$1 = _applyDecoratedDescriptor(_class2$d.prototype, "setIsVoiceAudioEnabled", [_dec20$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20$1 = _applyDecoratedDescriptor(_class2$d.prototype, "setIsMicListening", [_dec21$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21$1 = _applyDecoratedDescriptor(_class2$d.prototype, "isVoiceInterfaceEnabled", [_dec22$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22$1 = _applyDecoratedDescriptor(_class2$d.prototype, "isVoiceAudioEnabled", [_dec23$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23$1 = _applyDecoratedDescriptor(_class2$d.prototype, "isMicListening", [_dec24$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24$1 = _applyDecoratedDescriptor(_class2$d.prototype, "isMicHasErrors", [_dec25$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25$1 = _applyDecoratedDescriptor(_class2$d.prototype, "hideMenu", [_dec26$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26$1 = _applyDecoratedDescriptor(_class2$d.prototype, "attachmentsUploadErrorCallback", [_dec27$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27$1 = _applyDecoratedDescriptor(_class2$d.prototype, "inputLocation", [_dec28$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class2$d.prototype, "onConfirmSendLocationCallback", [_dec29$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2$d.prototype, "handleIsInteractionInputLocation", [_dec30$1], Object.getOwnPropertyDescriptor(_class2$d.prototype, "handleIsInteractionInputLocation"), _class2$d.prototype), _applyDecoratedDescriptor(_class2$d.prototype, "handleIsInteractionInsertDate", [_dec31$1], Object.getOwnPropertyDescriptor(_class2$d.prototype, "handleIsInteractionInsertDate"), _class2$d.prototype), _applyDecoratedDescriptor(_class2$d.prototype, "handleIsInteractionSingleAutocomplete", [_dec32], Object.getOwnPropertyDescriptor(_class2$d.prototype, "handleIsInteractionSingleAutocomplete"), _class2$d.prototype), _applyDecoratedDescriptor(_class2$d.prototype, "handleIsInteractionMultipleAutocomplete", [_dec33], Object.getOwnPropertyDescriptor(_class2$d.prototype, "handleIsInteractionMultipleAutocomplete"), _class2$d.prototype), _applyDecoratedDescriptor(_class2$d.prototype, "handleCurrentAutocompleteList", [_dec34], Object.getOwnPropertyDescriptor(_class2$d.prototype, "handleCurrentAutocompleteList"), _class2$d.prototype), _applyDecoratedDescriptor(_class2$d.prototype, "handleCurrentAutocompleteInfo", [_dec35], Object.getOwnPropertyDescriptor(_class2$d.prototype, "handleCurrentAutocompleteInfo"), _class2$d.prototype), _applyDecoratedDescriptor(_class2$d.prototype, "populateInputLocation", [_dec36], Object.getOwnPropertyDescriptor(_class2$d.prototype, "populateInputLocation"), _class2$d.prototype), _applyDecoratedDescriptor(_class2$d.prototype, "handleModeBeforeSubmit", [_dec37], Object.getOwnPropertyDescriptor(_class2$d.prototype, "handleModeBeforeSubmit"), _class2$d.prototype), _applyDecoratedDescriptor(_class2$d.prototype, "handleVisibilityAfterSubmit", [_dec38], Object.getOwnPropertyDescriptor(_class2$d.prototype, "handleVisibilityAfterSubmit"), _class2$d.prototype), _class2$d)) || _class$d);

/* script */
var __vue_script__$e = UserInputArea;

/* template */
var __vue_render__$e = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('el-container', {
    staticClass: "input-wrapper",
    style: _vm.getInputAreaInlineStyles
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "middle"
    }
  }, [!_vm.hideMenu ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('ChatActionsMenu')], 1) : _vm._e(), _vm._v(" "), _vm.canShowAttachmentUploader ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('AttachmentsUploader', {
    attrs: {
      "disabled": !_vm.inputEnabled,
      "content": _vm.content,
      "attachments-upload-error-callback": _vm.attachmentsUploadErrorCallback
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "main-input-wrapper",
    attrs: {
      "span": _vm.getSpanCount
    }
  }, [_vm.isInputText ? [_c('el-input', {
    attrs: {
      "id": "main-input",
      "placeholder": _vm.isModeBeforeSubmitInputBlocked ? _vm.getLabel.input_blocked : _vm.getLabel.input_text,
      "disabled": _vm.isInputDisabled
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.inputMessageSendAction($event);
      }
    },
    model: {
      value: _vm.userInput,
      callback: function callback($$v) {
        _vm.userInput = $$v;
      },
      expression: "userInput"
    }
  })] : _vm.isInputDate ? [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-format": "yyyy-MM-dd",
      "format": "dd/MM/yyyy",
      "placeholder": _vm.getLabel.placeholder_date,
      "type": _vm.datePickerType,
      "picker-options": _vm.datePickerOptions
    },
    model: {
      value: _vm.userInputDate,
      callback: function callback($$v) {
        _vm.userInputDate = $$v;
      },
      expression: "userInputDate"
    }
  })] : _vm.isInputLocation ? [_c('el-input', {
    attrs: {
      "id": "main-input-location",
      "placeholder": _vm.getLabel.placeholder_location
    },
    on: {
      "focus": _vm.onClickInputLocation
    },
    model: {
      value: _vm.userInputLocation,
      callback: function callback($$v) {
        _vm.userInputLocation = $$v;
      },
      expression: "userInputLocation"
    }
  })] : _vm.isInputSingleAutocomplete ? [_c('el-autocomplete', {
    attrs: {
      "id": "main-input-single-autocomplete",
      "value-key": "text",
      "placeholder": _vm.getLabel.placeholder_autocomplete,
      "trigger-on-focus": false,
      "hide-loading": true,
      "fetch-suggestions": _vm.onFetchSingleAutocompleteSuggestions
    },
    on: {
      "select": _vm.onSelectSingleAutocomplete
    },
    model: {
      value: _vm.userInputSingleAutocomplete,
      callback: function callback($$v) {
        _vm.userInputSingleAutocomplete = $$v;
      },
      expression: "userInputSingleAutocomplete"
    }
  })] : _vm.isInputMultipleAutocomplete ? [_c('div', {
    staticClass: "multiple-autocomplete-wrapper"
  }, [_c('el-select', {
    attrs: {
      "id": "main-input-multiple-autocomplete",
      "multiple": "",
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "Search multiple choices",
      "no-data-text": "No choices available",
      "remote-method": _vm.onFetchMultipleAutocompleteSuggestions
    },
    on: {
      "change": _vm.onChangeMultipleAutocomplete
    },
    model: {
      value: _vm.userInputMultipleAutocomplete,
      callback: function callback($$v) {
        _vm.userInputMultipleAutocomplete = $$v;
      },
      expression: "userInputMultipleAutocomplete"
    }
  }, _vm._l(_vm.userInputMultipleAutocompleteOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    });
  }), 1)], 1)] : _vm._e()], 2), _vm._v(" "), _vm.canShowVoiceInterface ? _c('el-col', {
    staticClass: "h-100",
    attrs: {
      "span": 4
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.getLabelMicrophone,
      "open-delay": 300,
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "id": "btn-voice",
      "type": "text",
      "disabled": _vm.isVoiceInterfaceButtonDisabled
    },
    on: {
      "click": _vm.onClickEnableVoiceMic
    }
  }, [_vm.isMicEnabled ? _c('span', {
    staticClass: "el-icon-microphone"
  }) : _c('span', {
    staticClass: "el-icon-turn-off-microphone"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "h-100",
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "id": "btn-send",
      "type": "text",
      "disabled": _vm.isSendButtonDisabled
    },
    on: {
      "click": _vm.inputMessageSendAction
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "32",
      "height": "32",
      "viewBox": "0 0 32 32"
    }
  }, [_c('title', [_vm._v("send")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 29.714l32-13.714-32-13.714v10.667l22.857 3.048-22.857 3.048v10.667z"
    }
  })])])], 1)], 1)], 1);
};
var __vue_staticRenderFns__$e = [];

/* style */
var __vue_inject_styles__$e = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-8712d7ac_0", {
    source: ".w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}#btn-send:disabled{opacity:.6}#btn-send span{background:0 0!important}#btn-send span svg{fill:#4386ff;width:23px}#btn-voice:disabled{opacity:.6}#btn-voice span{background:0 0!important}#btn-voice span svg{fill:#4386ff;width:23px}#chat-area-wrapper{padding-bottom:5em}#chat-area-wrapper.closed-chat{padding-bottom:1em!important}#chat-area-wrapper.more-padding-bottom{padding-bottom:7em!important}#chat-area-wrapper .main-controls-area{float:left;width:100%;margin-bottom:15px}#chat-area-wrapper .main-controls-area .rounded-pill:hover{color:#6c757d;background:#efefef}#chat-area-wrapper .input-wrapper{position:fixed;z-index:49;bottom:0;left:0;right:0;padding:1em;background:#f8f8f8;box-shadow:0 0 10px rgba(16,16,16,.2)}#chat-area-wrapper .input-wrapper input{font-family:inherit}#chat-area-wrapper .input-wrapper input:not(.el-range-input){border-radius:25px!important;height:45px;transition:all .5s}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$e = undefined;
/* module identifier */
var __vue_module_identifier__$e = undefined;
/* functional template */
var __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}

var onDemand = /*#__PURE__*/function () {
  function onDemand(src) {
    var waitForPageLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    _classCallCheck(this, onDemand);
    this.isLoaded = false;
    this.isLoading = false;
    this.callbacks = [];
    this.src = src;
    this.waitForPageLoad = waitForPageLoad;
  }
  return _createClass(onDemand, [{
    key: "load",
    value: function load() {
      var _this = this;
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        _newArrowCheck(this, _this);
      }.bind(this);
      if (this.isLoaded) return callback();
      this.callbacks.push(callback);
      if (!this.isLoading) {
        this.isLoading = true;
        if (!this.waitForPageLoad || document.readyState === 'complete') {
          this.loadAllScript();
        } else {
          window.addEventListener('load', function () {
            _newArrowCheck(this, _this);
            return this.loadAllScript();
          }.bind(this));
        }
      }
    }
  }, {
    key: "loadAllScript",
    value: function loadAllScript() {
      var _this2 = this;
      var script = document.createElement('script');
      script.src = this.src;
      script.onload = function () {
        _newArrowCheck(this, _this2);
        return this.invokeAllCallbacks();
      }.bind(this);
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }, {
    key: "invokeAllCallbacks",
    value: function invokeAllCallbacks() {
      var _this3 = this;
      this.isLoaded = true;
      this.callbacks.forEach(function (callback) {
        _newArrowCheck(this, _this3);
        return callback();
      }.bind(this));
    }
  }]);
}();

var apiKey = "AIzaSyC-PrS41paapeqnCdnIbg_H6BU23OBdEZk"; // wfp
var googleUrl = "https://maps.googleapis.com/maps/api/js";
var queryParams = ["key=".concat(apiKey), "libraries=places", "v=weekly"];
var GoogleMapService = {
  loadMap: function loadMap() {
    var _this = this;
    var initMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
      _newArrowCheck(this, _this);
    }.bind(this);
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // language support ref: https://developers.google.com/maps/faq#languagesupport
    var languageApi = options.languageApi;
    if (languageApi) {
      queryParams.push("language=".concat(languageApi));
    }
    var loader = new onDemand("".concat(googleUrl, "?").concat(queryParams.join("&")));
    loader.load(function () {
      _newArrowCheck(this, _this);
      initMap();
    }.bind(this));
  },
  // ex. ref
  // https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform#maps_places_autocomplete_addressform-typescript
  initGoogleMapsAutoComplete: function initGoogleMapsAutoComplete(elementSelector) {
    var _this2 = this;
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (params) {
      _newArrowCheck(this, _this2);
    }.bind(this);
    // @ts-ignore
    var autocomplete;
    var input = document.getElementById(elementSelector);
    // Create the autocomplete object
    // ref https://developers.google.com/maps/documentation/javascript/reference/places-service#PlaceResult
    // @ts-ignore
    autocomplete = new google.maps.places.Autocomplete(input, {
      fields: [
      // ref: https://developers.google.com/maps/documentation/javascript/place-id
      "place_id", "address_components", "geometry", "formatted_address", "name"],
      // forced language into English even if the device language or the writing language is different
      language: "en"
    });
    autocomplete.addListener("place_changed", function () {
      _newArrowCheck(this, _this2);
      var place = autocomplete.getPlace();
      // TODO: enable when debugging
      // console.log('getPlace: ', JSON.stringify(place));
      // Get the place details from the autocomplete object.
      var addressObj = this.getAddressObject(place);
      callback(_objectSpread2({}, addressObj));
    }.bind(this));
  },
  getAddressObject: function getAddressObject() {
    var place = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // Get each component of the address from the place details,
    // and then fill-in the corresponding field
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    var addressObj = {};
    var _iterator = _createForOfIteratorHelper(place.address_components),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var component = _step.value;
        // @ts-ignore remove once typings fixed
        var componentType = component.types[0];
        switch (componentType) {
          case "street_number":
            addressObj.streetNumber = component.long_name || "";
            break;
          case "postal_code":
            addressObj.postalCode = component.long_name || "";
            break;
          case "postal_code_suffix":
            addressObj.postalCodeSuffix = component.long_name || "";
            break;
          case "locality":
            addressObj.city = component.long_name || "";
            break;
          case "administrative_area_level_1":
            addressObj.state = component.short_name || "";
            break;
          case "administrative_area_level_2":
            // case "administrative_area_level_3":
            // TODO: confirm about the cityCode
            addressObj.cityCode = component.short_name || "";
            break;
          case "country":
            addressObj.country = component.long_name || "";
            addressObj.isoCode = component.short_name || "";
            break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    addressObj = _objectSpread2(_objectSpread2({}, addressObj), {}, {
      text: this.getFormattedTextAddress(place.name, addressObj),
      address: this.getFormattedTextAddress(place.name, addressObj),
      latitude: place.geometry.location.lat(),
      longitude: place.geometry.location.lng()
    });
    return _objectSpread2({}, addressObj);
  },
  getFormattedTextAddress: function getFormattedTextAddress(rawName) {
    var addressObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var city = addressObj.city,
      country = addressObj.country;
    var formattedText = [];
    if (rawName) formattedText.push(rawName);
    if (city) formattedText.push(city);
    if (country) formattedText.push(country);
    if (rawName && city) {
      if (rawName.toLowerCase() === city.toLowerCase()) {
        formattedText = [city, country];
      }
    }
    return formattedText.join(", ");
  }
};

var _this$6 = this;
var script$1 = {
  props: {
    isView: {
      type: Boolean,
      "default": false,
      description: "Maps isView"
    },
    mapId: {
      type: String,
      required: true,
      description: "The map element id, it must be unique."
    },
    placeholder: {
      type: String,
      "default": "write a position",
      description: "Default location input placeholder"
    },
    languageApi: {
      type: String,
      "default": "en",
      description: "Is the indicated language use for google maps api. Default is en."
    },
    handleOnSelectAddress: {
      type: Function,
      "default": function _default() {
        _newArrowCheck(this, _this$6);
      }.bind(this),
      description: "Trigger after location change"
    }
  },
  data: function data() {
    return {
      locationAddress: "",
      model: {
        text: "",
        latitude: "",
        longitude: "",
        address: "",
        city: "",
        cityCode: "",
        zipCode: "",
        country: "",
        isoCode: ""
      }
    };
  },
  mounted: function mounted() {
    this.handleLoadGoogleMap();
  },
  methods: {
    handleLoadGoogleMap: function handleLoadGoogleMap() {
      var _this2 = this;
      GoogleMapService.loadMap(function () {
        _newArrowCheck(this, _this2);
        this.handleInitAutoComplete();
      }.bind(this), {
        languageApi: this.languageApi
      });
    },
    handleInitAutoComplete: function handleInitAutoComplete() {
      var _this3 = this;
      GoogleMapService.initGoogleMapsAutoComplete(this.mapId, function (params) {
        _newArrowCheck(this, _this3);
        // TODO: enable when debugging
        // console.log('gmaps autocomplete params: ', JSON.stringify(params));

        var text = params.text,
          latitude = params.latitude,
          longitude = params.longitude,
          address = params.address,
          city = params.city,
          cityCode = params.cityCode,
          postalCode = params.postalCode,
          country = params.country,
          isoCode = params.isoCode;

        // populate model
        this.model = {
          text: text,
          latitude: latitude,
          longitude: longitude,
          address: address,
          city: city,
          cityCode: cityCode,
          zipCode: postalCode,
          country: country,
          isoCode: isoCode
        };

        // handle callback
        this.handleOnSelectAddress(_objectSpread2({}, this.model));
      }.bind(this));
    },
    resetMapDetails: function resetMapDetails() {
      this.model = {
        text: "",
        latitude: "",
        longitude: "",
        address: "",
        city: "",
        cityCode: "",
        zipCode: "",
        country: "",
        isoCode: ""
      };
      // handle callback
      this.handleOnSelectAddress(_objectSpread2({}, this.model));
    },
    handleInputChange: function handleInputChange(elem) {
      var inputValue = elem.target.value;
      if (!inputValue.trim()) {
        this.resetMapDetails();
      }
    }
  }
};

/* script */
var __vue_script__$f = script$1;

/* template */
var __vue_render__$f = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.locationAddress,
      expression: "locationAddress"
    }],
    staticClass: "input-location",
    attrs: {
      "id": _vm.mapId,
      "type": "text",
      "placeholder": _vm.placeholder,
      "disabled": _vm.isView
    },
    domProps: {
      "value": _vm.locationAddress
    },
    on: {
      "change": _vm.handleInputChange,
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.locationAddress = $event.target.value;
      }
    }
  })]);
};
var __vue_staticRenderFns__$f = [];

/* style */
var __vue_inject_styles__$f = undefined;
/* scoped */
var __vue_scope_id__$f = "data-v-6227f6c2";
/* module identifier */
var __vue_module_identifier__$f = undefined;
/* functional template */
var __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

var _dec$e,
  _dec2$e,
  _dec3$b,
  _dec4$a,
  _dec5$9,
  _dec6$6,
  _dec7$6,
  _dec8$4,
  _dec9$4,
  _dec0$4,
  _dec1$3,
  _dec10$2,
  _dec11$2,
  _dec12$2,
  _dec13$2,
  _dec14$2,
  _dec15$2,
  _dec16$2,
  _dec17$2,
  _dec18$2,
  _dec19$2,
  _dec20$2,
  _dec21$2,
  _dec22$2,
  _dec23$2,
  _dec24$2,
  _dec25$2,
  _dec26$2,
  _this$7 = this,
  _class$e,
  _class2$e,
  _descriptor$e,
  _descriptor2$b,
  _descriptor3$a,
  _descriptor4$a,
  _descriptor5$6,
  _descriptor6$6,
  _descriptor7$4,
  _descriptor8$4,
  _descriptor9$4,
  _descriptor0$4,
  _descriptor1$2,
  _descriptor10$2,
  _descriptor11$2,
  _descriptor12$2,
  _descriptor13$2,
  _descriptor14$2,
  _descriptor15$2,
  _descriptor16$2,
  _descriptor17$2,
  _descriptor18$2,
  _descriptor19$2,
  _descriptor20$2,
  _descriptor21$2,
  _descriptor22$2,
  _descriptor23$2,
  _descriptor24$2;
var ChatConversationArea = (_dec$e = Component({
  components: {
    ChatHeader: __vue_component__$2,
    ChatBubble: __vue_component__$b,
    UserInputArea: __vue_component__$e,
    GMapSuggestions: __vue_component__$f
  }
}), _dec2$e = Prop(Boolean), _dec3$b = Prop({
  "default": true
}), _dec4$a = Prop({
  "default": false
}), _dec5$9 = Prop(String), _dec6$6 = Prop({
  "default": false
}), _dec7$6 = Prop({
  "default": false
}), _dec8$4 = Prop({
  "default": false
}), _dec9$4 = Prop({
  "default": false
}), _dec0$4 = Prop(Function), _dec1$3 = Prop(Function), _dec10$2 = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$7);
  }.bind(this)
}), _dec11$2 = Prop(String), _dec12$2 = Getter("chat/getChatHeaderTitle"), _dec13$2 = Getter("chat/getChatHeaderIcon"), _dec14$2 = Getter("chat/showUserInputArea"), _dec15$2 = Getter("chat/getCurrentChatMessages"), _dec16$2 = Getter("chat/getChatAvatarIcon"), _dec17$2 = Getter("chat/getIsConversationHeaderRawHtml"), _dec18$2 = Getter("chat/getCurrentChat"), _dec19$2 = Getter("chat/isLocationModalEnable"), _dec20$2 = Action$1("chat/setIsLocationModalEnable"), _dec21$2 = Getter("chat/getBotConfigSettings"), _dec22$2 = Getter("proactivity/isChatbotProactive"), _dec23$2 = Getter("proactivity/getProactivityChatTitle"), _dec24$2 = Getter("proactivity/getProactivityMessageContent"), _dec25$2 = Getter("proactivity/getProactivitySettingsDefault"), _dec26$2 = Watch("isLocationModalEnable"), _dec$e(_class$e = (_class2$e = /*#__PURE__*/function (_Vue) {
  function ChatConversationArea() {
    var _this2;
    _classCallCheck(this, ChatConversationArea);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ChatConversationArea, [].concat(args));
    /*
     * Chat header
     */
    _initializerDefineProperty(_this2, "showHeader", _descriptor$e, _this2);
    _initializerDefineProperty(_this2, "showChatBackButton", _descriptor2$b, _this2);
    _initializerDefineProperty(_this2, "enableMultipleConversations", _descriptor3$a, _this2);
    /*
     * Chat Bubble
     */
    _initializerDefineProperty(_this2, "userAvatarIcon", _descriptor4$a, _this2);
    _initializerDefineProperty(_this2, "showIsTypingBubble", _descriptor5$6, _this2);
    _initializerDefineProperty(_this2, "showIsTypingBubbleUser", _descriptor6$6, _this2);
    _initializerDefineProperty(_this2, "showChatStartupButton", _descriptor7$4, _this2);
    _initializerDefineProperty(_this2, "hideActionMenu", _descriptor8$4, _this2);
    _initializerDefineProperty(_this2, "attachmentsUploadErrorCallback", _descriptor9$4, _this2);
    _initializerDefineProperty(_this2, "handleStartChat", _descriptor0$4, _this2);
    _initializerDefineProperty(_this2, "handleOnRestartChat", _descriptor1$2, _this2);
    _initializerDefineProperty(_this2, "btnStartConversationLabel", _descriptor10$2, _this2);
    _initializerDefineProperty(_this2, "getChatHeaderTitle", _descriptor11$2, _this2);
    _initializerDefineProperty(_this2, "getChatHeaderIcon", _descriptor12$2, _this2);
    _initializerDefineProperty(_this2, "showUserInputArea", _descriptor13$2, _this2);
    _initializerDefineProperty(_this2, "getCurrentChatMessages", _descriptor14$2, _this2);
    _initializerDefineProperty(_this2, "getChatAvatarIcon", _descriptor15$2, _this2);
    _initializerDefineProperty(_this2, "getIsConversationHeaderRawHtml", _descriptor16$2, _this2);
    _initializerDefineProperty(_this2, "currentChat", _descriptor17$2, _this2);
    _initializerDefineProperty(_this2, "isLocationModalEnable", _descriptor18$2, _this2);
    _initializerDefineProperty(_this2, "setIsLocationModalEnable", _descriptor19$2, _this2);
    _initializerDefineProperty(_this2, "getBotConfigSettings", _descriptor20$2, _this2);
    _initializerDefineProperty(_this2, "isChatbotProactive", _descriptor21$2, _this2);
    _initializerDefineProperty(_this2, "getProactivityChatTitle", _descriptor22$2, _this2);
    _initializerDefineProperty(_this2, "getProactivityMessageContent", _descriptor23$2, _this2);
    _initializerDefineProperty(_this2, "getProactivitySettingsDefault", _descriptor24$2, _this2);
    // state to enable/disable location modal dialog
    _defineProperty(_this2, "showLocationModal", false);
    // staging state for the input location data
    _defineProperty(_this2, "stagingInputLocation", {});
    // final state the holds current input location data
    _defineProperty(_this2, "currentInputLocation", {});
    return _this2;
  }
  _inherits(ChatConversationArea, _Vue);
  return _createClass(ChatConversationArea, [{
    key: "getConversationAreaClass",
    get: function get() {
      return (this.currentChat.is_archived ? "archived " : "") + this.currentChat["class"];
    }
  }, {
    key: "getRawHtmlClass",
    get: function get() {
      return this.getIsConversationHeaderRawHtml ? "has-raw-html" : "";
    }
  }, {
    key: "getClosedChatClass",
    get: function get() {
      return !this.showUserInputArea ? "closed-chat " : "";
    }
  }, {
    key: "getChatAreaWrapperClass",
    get: function get() {
      return this.getClosedChatClass + this.getRawHtmlClass;
    }
  }, {
    key: "getChatAreaClass",
    get: function get() {
      return this.showChatStartupButton ? "startup-chat-btn-wrapper" : "";
    }
  }, {
    key: "getMsgBubbleContent",
    get: function get() {
      return this.isChatbotProactive() ? this.getProactivityMessageContent() : this.getProactivitySettingsDefault.proactiveBubbleMessage;
    }
  }, {
    key: "getGoogleMapsApiLanguage",
    get: function get() {
      var googleMapsApiLangKey = this.getBotConfigSettings.googleMapsApiLangKey;
      // forced language into English 
      // even if the device language
      // or the writing language is different
      return lsGet(googleMapsApiLangKey) || "en";
    }
  }, {
    key: "getLabel",
    get: function get() {
      var labels = this.getBotConfigSettings.labels;
      return {
        label_popup_location_placeholder: labels === null || labels === void 0 ? void 0 : labels.label_popup_location_placeholder,
        label_popup_button_cancel: labels === null || labels === void 0 ? void 0 : labels.label_popup_button_cancel,
        label_popup_button_confirm: labels === null || labels === void 0 ? void 0 : labels.label_popup_button_confirm
      };
    }
  }, {
    key: "getBubbleItemId",
    value: function getBubbleItemId() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return getStanzaItemId(item);
    }
  }, {
    key: "onCancelLocationModal",
    value: function onCancelLocationModal() {
      this.handleCloseLocationModal();
    }
  }, {
    key: "onConfirmLocationModal",
    value: function onConfirmLocationModal() {
      var text = this.stagingInputLocation.text;
      if (text) {
        this.currentInputLocation = _objectSpread2({}, this.stagingInputLocation);
        this.handleCloseLocationModal();
      } else {
        var inputLocationElem = document.getElementById("gmap-input-location");
        inputLocationElem.focus();
      }
    }
  }, {
    key: "onConfirmSendLocationCallback",
    value: function onConfirmSendLocationCallback(params) {
      if (params) {
        this.resetInputLocationModel();
      }
    }
  }, {
    key: "onCloseLocationModal",
    value: function onCloseLocationModal() {
      var _this3 = this;
      var done = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        _newArrowCheck(this, _this3);
      }.bind(this);
      console.log("before close location modal...");
      this.resetInputLocationModel();
      this.handleCloseLocationModal();
      done();
    }
  }, {
    key: "handleCloseLocationModal",
    value: function handleCloseLocationModal() {
      this.showLocationModal = false;
      this.setIsLocationModalEnable(false);
    }
  }, {
    key: "handleOnSelectAddress",
    value: function handleOnSelectAddress(params) {
      if (params) {
        this.stagingInputLocation = _objectSpread2({}, params);
        console.log("handleOnSelectAddress staging: ", JSON.stringify(params));
      }
    }
  }, {
    key: "resetInputLocationModel",
    value: function resetInputLocationModel() {
      // empty model
      this.stagingInputLocation = {};
      this.currentInputLocation = {};
      var inputLocationElem = document.getElementById("gmap-input-location");
      inputLocationElem.value = "";
    }
  }, {
    key: "onClickStartChat",
    value: function onClickStartChat() {
      this.handleStartChat();
    }
  }, {
    key: "toggleLocationModal",
    value: function toggleLocationModal(toggle) {
      var _this4 = this;
      this.showLocationModal = toggle;
      if (toggle) {
        // focus
        setTimeout(function () {
          _newArrowCheck(this, _this4);
          var inputLocationElem = document.getElementById("gmap-input-location");
          inputLocationElem.focus();
        }.bind(this), 800);
      }
    }
  }]);
}(Vue$2), _descriptor$e = _applyDecoratedDescriptor(_class2$e.prototype, "showHeader", [_dec2$e], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$b = _applyDecoratedDescriptor(_class2$e.prototype, "showChatBackButton", [_dec3$b], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$a = _applyDecoratedDescriptor(_class2$e.prototype, "enableMultipleConversations", [_dec4$a], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$a = _applyDecoratedDescriptor(_class2$e.prototype, "userAvatarIcon", [_dec5$9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5$6 = _applyDecoratedDescriptor(_class2$e.prototype, "showIsTypingBubble", [_dec6$6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6$6 = _applyDecoratedDescriptor(_class2$e.prototype, "showIsTypingBubbleUser", [_dec7$6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7$4 = _applyDecoratedDescriptor(_class2$e.prototype, "showChatStartupButton", [_dec8$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8$4 = _applyDecoratedDescriptor(_class2$e.prototype, "hideActionMenu", [_dec9$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9$4 = _applyDecoratedDescriptor(_class2$e.prototype, "attachmentsUploadErrorCallback", [_dec0$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0$4 = _applyDecoratedDescriptor(_class2$e.prototype, "handleStartChat", [_dec1$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1$2 = _applyDecoratedDescriptor(_class2$e.prototype, "handleOnRestartChat", [_dec10$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10$2 = _applyDecoratedDescriptor(_class2$e.prototype, "btnStartConversationLabel", [_dec11$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11$2 = _applyDecoratedDescriptor(_class2$e.prototype, "getChatHeaderTitle", [_dec12$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12$2 = _applyDecoratedDescriptor(_class2$e.prototype, "getChatHeaderIcon", [_dec13$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13$2 = _applyDecoratedDescriptor(_class2$e.prototype, "showUserInputArea", [_dec14$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14$2 = _applyDecoratedDescriptor(_class2$e.prototype, "getCurrentChatMessages", [_dec15$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15$2 = _applyDecoratedDescriptor(_class2$e.prototype, "getChatAvatarIcon", [_dec16$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16$2 = _applyDecoratedDescriptor(_class2$e.prototype, "getIsConversationHeaderRawHtml", [_dec17$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17$2 = _applyDecoratedDescriptor(_class2$e.prototype, "currentChat", [_dec18$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18$2 = _applyDecoratedDescriptor(_class2$e.prototype, "isLocationModalEnable", [_dec19$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19$2 = _applyDecoratedDescriptor(_class2$e.prototype, "setIsLocationModalEnable", [_dec20$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20$2 = _applyDecoratedDescriptor(_class2$e.prototype, "getBotConfigSettings", [_dec21$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21$2 = _applyDecoratedDescriptor(_class2$e.prototype, "isChatbotProactive", [_dec22$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22$2 = _applyDecoratedDescriptor(_class2$e.prototype, "getProactivityChatTitle", [_dec23$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23$2 = _applyDecoratedDescriptor(_class2$e.prototype, "getProactivityMessageContent", [_dec24$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24$2 = _applyDecoratedDescriptor(_class2$e.prototype, "getProactivitySettingsDefault", [_dec25$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2$e.prototype, "toggleLocationModal", [_dec26$2], Object.getOwnPropertyDescriptor(_class2$e.prototype, "toggleLocationModal"), _class2$e.prototype), _class2$e)) || _class$e);

/* script */
var __vue_script__$g = ChatConversationArea;

/* template */
var __vue_render__$g = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    "class": _vm.getConversationAreaClass,
    attrs: {
      "id": "conversation-area"
    }
  }, [_vm.showHeader ? _c('ChatHeader', {
    attrs: {
      "message": _vm.getChatHeaderTitle,
      "icon": _vm.getChatHeaderIcon,
      "show-back-button": _vm.showChatBackButton && _vm.enableMultipleConversations,
      "handle-on-restart-chat": _vm.handleOnRestartChat
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    "class": _vm.getChatAreaWrapperClass,
    attrs: {
      "id": "chat-area-wrapper"
    }
  }, [_c('el-row', {
    staticClass: "m-0",
    "class": _vm.getChatAreaClass,
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    staticClass: "chat-wrapper",
    attrs: {
      "span": 24
    }
  }, [_vm._l(_vm.getCurrentChatMessages, function (message) {
    return message ? _c('ChatBubble', {
      key: message.id,
      attrs: {
        "id": _vm.getBubbleItemId(message),
        "chat-bubble-id": _vm.getBubbleItemId(message),
        "metas": message,
        "bot-avatar": _vm.getChatHeaderIcon,
        "user-avatar": _vm.userAvatarIcon
      }
    }) : _vm._e();
  }), _vm._v(" "), _vm.showIsTypingBubble ? _c('ChatBubble', {
    attrs: {
      "metas": {},
      "isTyping": true
    }
  }) : _vm._e(), _vm._v(" "), _vm.showIsTypingBubbleUser ? _c('ChatBubble', {
    attrs: {
      "metas": {},
      "isTypingUser": true
    }
  }) : _vm._e()], 2), _vm._v(" "), !_vm.showChatStartupButton ? [_vm.showUserInputArea ? _c('UserInputArea', {
    attrs: {
      "hide-menu": _vm.hideActionMenu,
      "attachments-upload-error-callback": _vm.attachmentsUploadErrorCallback,
      "input-location": _vm.currentInputLocation,
      "on-confirm-send-location-callback": _vm.onConfirmSendLocationCallback
    }
  }) : _vm._e()] : [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onClickStartChat
    }
  }, [_vm._v(_vm._s(_vm.btnStartConversationLabel))])]], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "id": "dialog-input-location",
      "title": "Insert location",
      "width": "90%",
      "append-to-body": true,
      "close-on-click-modal": false,
      "visible": _vm.showLocationModal,
      "before-close": _vm.onCloseLocationModal
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showLocationModal = $event;
      }
    }
  }, [_c('GMapSuggestions', {
    attrs: {
      "map-id": "gmap-input-location",
      "placeholder": _vm.getLabel.label_popup_location_placeholder,
      "language-api": _vm.getGoogleMapsApiLanguage,
      "handle-on-select-address": _vm.handleOnSelectAddress
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.onCancelLocationModal
    }
  }, [_vm._v(_vm._s(_vm.getLabel.label_popup_button_cancel))]), _vm._v(" "), _c('el-button', {
    staticClass: "ml-2",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onConfirmLocationModal
    }
  }, [_vm._v(_vm._s(_vm.getLabel.label_popup_button_confirm))])], 1)], 1)], 1);
};
var __vue_staticRenderFns__$g = [];

/* style */
var __vue_inject_styles__$g = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-305a9608_0", {
    source: ".w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}#conversation-area #chat-area-wrapper .startup-chat-btn-wrapper{position:absolute;bottom:1em;left:0;right:0}#conversation-area #chat-area-wrapper.has-raw-html .chat-wrapper{margin-top:2.7rem}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$g = undefined;
/* module identifier */
var __vue_module_identifier__$g = undefined;
/* functional template */
var __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);

var _dec$f,
  _dec2$f,
  _this$8 = this,
  _class$f,
  _class2$f,
  _descriptor$f,
  _descriptor2$c;
var ChatToggleButton = (_dec$f = Prop(String), _dec2$f = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$8);
  }.bind(this)
}), Component(_class$f = (_class2$f = /*#__PURE__*/function (_Vue) {
  function ChatToggleButton() {
    var _this2;
    _classCallCheck(this, ChatToggleButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ChatToggleButton, [].concat(args));
    _initializerDefineProperty(_this2, "avatarUrl", _descriptor$f, _this2);
    _initializerDefineProperty(_this2, "handleShowChatArea", _descriptor2$c, _this2);
    return _this2;
  }
  _inherits(ChatToggleButton, _Vue);
  return _createClass(ChatToggleButton, [{
    key: "botAvatarIcon",
    get: function get() {
      return img;
    }
  }, {
    key: "onClickToggleChat",
    value: function onClickToggleChat() {
      var _this3 = this;
      this.handleShowChatArea(true);
      setTimeout(function () {
        _newArrowCheck(this, _this3);
        return EventHub.$emit(EventHub.events.chatToggleStatus, true);
      }.bind(this), 700);
      setTimeout(function () {
        _newArrowCheck(this, _this3);
        return EventHub.$emit(EventHub.events.proactiveBubbleShown, false);
      }.bind(this), 700);
    }
  }]);
}(Vue$2), _descriptor$f = _applyDecoratedDescriptor(_class2$f.prototype, "avatarUrl", [_dec$f], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$c = _applyDecoratedDescriptor(_class2$f.prototype, "handleShowChatArea", [_dec2$f], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$f)) || _class$f);

/* script */
var __vue_script__$h = ChatToggleButton;

/* template */
var __vue_render__$h = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "id": "chat-toggler-button"
    }
  }, [_c('el-button', {
    staticClass: "wrapper-event-handler",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.onClickToggleChat
    }
  }, [_c('el-avatar', {
    attrs: {
      "id": "avatar",
      "src": _vm.avatarUrl || _vm.botAvatarIcon
    }
  })], 1)], 1);
};
var __vue_staticRenderFns__$h = [];

/* style */
var __vue_inject_styles__$h = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-acb279d0_0", {
    source: "@-webkit-keyframes slide-in{100%{transform:translateX(5px)}}@-moz-keyframes slide-in{100%{transform:translateX(5px)}}@-ms-keyframes slide-in{100%{transform:translateX(5px)}}@keyframes slide-in{100%{transform:translateX(5px)}}@-webkit-keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@-moz-keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@-ms-keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@-webkit-keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@-moz-keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@-ms-keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@-webkit-keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@-moz-keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@-ms-keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@-webkit-keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@-moz-keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@-ms-keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@-webkit-keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@-moz-keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@-ms-keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@-webkit-keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@-moz-keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@-ms-keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@-webkit-keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@-moz-keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@-ms-keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@-webkit-keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}@-moz-keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}@-ms-keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}@keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}.slide-in{animation:slide-in .5s forwards;-webkit-animation:slide-in .5s forwards}.slide-in-menu{animation:slide-in-menu .5s forwards;-webkit-animation:slide-in-menu .5s forwards}.slide-out{animation:slide-out .5s forwards;-webkit-animation:slide-out .5s forwards}.slide-out-33{animation:slide-out-33 .5s forwards;-webkit-animation:slide-out-33 .5s forwards}.slide-out-66{animation:slide-out-66 .5s forwards;-webkit-animation:slide-out-66 .5s forwards}.slide-out-menu{animation:slide-out-menu .5s forwards;-webkit-animation:slide-out-menu .5s forwards}.w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}#chat-toggler-button{position:absolute;top:50%;left:50%;width:100%;height:100%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2}#chat-toggler-button .wrapper-event-handler{width:85px!important;height:85px!important;position:absolute;top:50%;left:50%;margin-left:-42.5px;margin-top:-42.5px;padding:0;font-size:inherit;outline:0;z-index:5}#chat-toggler-button .wrapper-event-handler>span{position:relative;display:flex;place-content:start;place-items:center}#chat-toggler-button .wrapper-event-handler>span small.date{position:absolute;inset:1rem 1rem auto auto}#chat-toggler-button .wrapper-event-handler #avatar{content:\"\";position:relative;left:0;top:0;width:100%;height:100%;margin:0;display:block;background:#fff!important;border:solid 1px #ccc;border-radius:50%;-webkit-box-shadow:0 0 8px rgba(0,0,0,.3);box-shadow:0 0 8px rgba(0,0,0,.3);-webkit-animation:pulse-heart 3s cubic-bezier(.455,.03,.515,.955) -.9s;animation:pulse-heart 3s cubic-bezier(.455,.03,.515,.955) -.9s;animation-iteration-count:infinite;animation-direction:normal;animation-fill-mode:none;animation-play-state:running}#chat-toggler-button .wrapper-event-handler #avatar>img{margin:0 auto!important;box-shadow:none;border:none}#chat-toggler-button::before{content:\"\";position:relative;display:block;width:100%;height:100%;box-sizing:border-box;margin-left:0;margin-top:0;border-radius:50%;background-color:#363636;-webkit-animation:pulse-ring 3s cubic-bezier(.215,.61,.355,1);animation:pulse-ring 3s cubic-bezier(.215,.61,.355,1);animation-iteration-count:infinite;animation-direction:normal;animation-fill-mode:none;animation-play-state:running}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$h = undefined;
/* module identifier */
var __vue_module_identifier__$h = undefined;
/* functional template */
var __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);

var path = globalThis_1;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue = functionUncurryThis(1.0.valueOf);

var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var defineProperty$3 = objectDefineProperty.f;

var trim = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = globalThis_1[NUMBER];
path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError$2 = globalThis_1.TypeError;
var stringSlice$7 = functionUncurryThis(''.slice);
var charCodeAt$1 = functionUncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive$1(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive$1(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw new TypeError$2('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt$1(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt$1(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt$1(it, 1)) {
        // fast equal of /^0b[01]+$/i
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        // fast equal of /^0o[0-7]+$/i
        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        default:
          return +it;
      }
      digits = stringSlice$7(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt$1(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED$4 = isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return objectIsPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED$4 && !isPure) NumberPrototype.constructor = NumberWrapper;

_export({ global: true, constructor: true, wrap: true, forced: FORCED$4 }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties$1 = function (target, source) {
  for (var keys = descriptors ? getOwnPropertyNames$1(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwnProperty_1(source, key = keys[j]) && !hasOwnProperty_1(target, key)) {
      defineProperty$3(target, key, getOwnPropertyDescriptor$3(source, key));
    }
  }
};
if (FORCED$4 || isPure) copyConstructorProperties$1(path[NUMBER], NativeNumber);

var _dec$g, _dec2$g, _dec3$c, _class$g, _class2$g, _descriptor$g, _descriptor2$d;
var ChatToggleMessage = (_dec$g = Component({}), _dec2$g = Prop(String), _dec3$c = Prop(Number), _dec$g(_class$g = (_class2$g = /*#__PURE__*/function (_Vue) {
  function ChatToggleMessage() {
    var _this;
    _classCallCheck(this, ChatToggleMessage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatToggleMessage, [].concat(args));
    _defineProperty(_this, "canShowMessageBubble", false);
    _initializerDefineProperty(_this, "msgBubbleContent", _descriptor$g, _this);
    _initializerDefineProperty(_this, "showMsgBubbleTimeout", _descriptor2$d, _this);
    return _this;
  }
  _inherits(ChatToggleMessage, _Vue);
  return _createClass(ChatToggleMessage, [{
    key: "getMessageDefault",
    get: function get() {
      return this.msgBubbleContent || "Hai bisogno d'aiuto?";
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.handleMessageBubbleTimeout();
    }
  }, {
    key: "handleMessageBubbleTimeout",
    value: function handleMessageBubbleTimeout() {
      var _this2 = this;
      if (this.showMsgBubbleTimeout > 0) {
        setTimeout(function () {
          _newArrowCheck(this, _this2);
          this.canShowMessageBubble = true;
          EventHub.$emit(EventHub.events.proactiveBubbleShown, true);
        }.bind(this), this.showMsgBubbleTimeout);
      }
    }
  }, {
    key: "onClickCloseBubble",
    value: function onClickCloseBubble() {
      var _this3 = this;
      this.canShowMessageBubble = false;
      setTimeout(function () {
        _newArrowCheck(this, _this3);
        return EventHub.$emit(EventHub.events.proactiveBubbleShown, false);
      }.bind(this), 200);
    }
  }]);
}(Vue$2), _descriptor$g = _applyDecoratedDescriptor(_class2$g.prototype, "msgBubbleContent", [_dec2$g], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$d = _applyDecoratedDescriptor(_class2$g.prototype, "showMsgBubbleTimeout", [_dec3$c], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$g)) || _class$g);

/* script */
var __vue_script__$i = ChatToggleMessage;

/* template */
var __vue_render__$i = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.canShowMessageBubble ? _c('div', {
    attrs: {
      "id": "chat-toggler-message"
    }
  }, [_c('span', {
    staticClass: "close-icon",
    on: {
      "click": _vm.onClickCloseBubble
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getMessageDefault))])]) : _vm._e()]);
};
var __vue_staticRenderFns__$i = [];

/* style */
var __vue_inject_styles__$i = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-f165ec5c_0", {
    source: ".w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}#chat-toggler-message{display:inline-block;border:1px solid #000;min-width:170px;min-height:50px;position:absolute;z-index:9999;bottom:75%;left:87.5%;background:#fff;border:none;box-shadow:0 1px 30px rgba(0,0,0,.3);border-radius:1em;border-bottom-left-radius:0}#chat-toggler-message .close-icon{color:#363636!important;position:absolute;right:5px;top:-5px;cursor:pointer;font-size:28px}#chat-toggler-message p{color:#363636;font-weight:600;text-align:left;margin:.5em .75em;margin-right:1.3em;font-size:.9em;line-height:1.2}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$i = undefined;
/* module identifier */
var __vue_module_identifier__$i = undefined;
/* functional template */
var __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);

var _dec$h,
  _dec2$h,
  _dec3$d,
  _dec4$b,
  _dec5$a,
  _dec6$7,
  _this$9 = this,
  _class$h,
  _class2$h,
  _descriptor$h,
  _descriptor2$e,
  _descriptor3$b,
  _descriptor4$b,
  _descriptor5$7;
var ChatToggle = (_dec$h = Component({
  components: {
    ChatToggleButton: __vue_component__$h,
    ChatToggleMessage: __vue_component__$i
  }
}), _dec2$h = Prop({
  type: Function,
  "default": function _default() {
    _newArrowCheck(this, _this$9);
  }.bind(this)
}), _dec3$d = Getter("chat/getToggleMetas"), _dec4$b = Getter("proactivity/isChatbotProactive"), _dec5$a = Getter("proactivity/getProactivityMessageContent"), _dec6$7 = Getter("proactivity/getProactivityMessageTimeout"), _dec$h(_class$h = (_class2$h = /*#__PURE__*/function (_Vue) {
  function ChatToggle() {
    var _this2;
    _classCallCheck(this, ChatToggle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ChatToggle, [].concat(args));
    _initializerDefineProperty(_this2, "handleShowChatArea", _descriptor$h, _this2);
    _initializerDefineProperty(_this2, "chatToggleMeta", _descriptor2$e, _this2);
    _initializerDefineProperty(_this2, "isChatbotProactive", _descriptor3$b, _this2);
    _initializerDefineProperty(_this2, "getProactivityMessageContent", _descriptor4$b, _this2);
    _initializerDefineProperty(_this2, "getProactivityMessageTimeout", _descriptor5$7, _this2);
    return _this2;
  }
  _inherits(ChatToggle, _Vue);
  return _createClass(ChatToggle, [{
    key: "avatarUrlSrc",
    get: function get() {
      return this.isChatbotProactive && this.chatToggleMeta.hasOwnProperty("avatarUrlSrc") ? this.chatToggleMeta.avatarUrlSrc : "";
    }
  }, {
    key: "showMsgBubble",
    get: function get() {
      var _this$chatToggleMeta;
      return (_this$chatToggleMeta = this.chatToggleMeta) !== null && _this$chatToggleMeta !== void 0 && _this$chatToggleMeta.proactiveBubbleMessage ? true : false;
    }
  }, {
    key: "msgBubbleContent",
    get: function get() {
      var _this$chatToggleMeta2;
      return ((_this$chatToggleMeta2 = this.chatToggleMeta) === null || _this$chatToggleMeta2 === void 0 ? void 0 : _this$chatToggleMeta2.proactiveBubbleMessage) || "";
    }
  }, {
    key: "showMsgBubbleTimeout",
    get: function get() {
      var _this$chatToggleMeta3;
      return this.isChatbotProactive && (_this$chatToggleMeta3 = this.chatToggleMeta) !== null && _this$chatToggleMeta3 !== void 0 && _this$chatToggleMeta3.proactivePromptTimeout ? this.chatToggleMeta.proactivePromptTimeout : 0;
    }
  }]);
}(Vue$2), _descriptor$h = _applyDecoratedDescriptor(_class2$h.prototype, "handleShowChatArea", [_dec2$h], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$e = _applyDecoratedDescriptor(_class2$h.prototype, "chatToggleMeta", [_dec3$d], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$b = _applyDecoratedDescriptor(_class2$h.prototype, "isChatbotProactive", [_dec4$b], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$b = _applyDecoratedDescriptor(_class2$h.prototype, "getProactivityMessageContent", [_dec5$a], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5$7 = _applyDecoratedDescriptor(_class2$h.prototype, "getProactivityMessageTimeout", [_dec6$7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$h)) || _class$h);

/* script */
var __vue_script__$j = ChatToggle;

/* template */
var __vue_render__$j = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "id": "chat-toggler-area"
    }
  }, [_c('ChatToggleButton', {
    attrs: {
      "handle-show-chat-area": _vm.handleShowChatArea,
      "avatar-url": _vm.avatarUrlSrc
    }
  }), _vm._v(" "), _vm.showMsgBubble ? _c('ChatToggleMessage', {
    attrs: {
      "msg-bubble-content": _vm.msgBubbleContent,
      "show-msg-bubble-timeout": _vm.showMsgBubbleTimeout
    }
  }) : _vm._e()], 1);
};
var __vue_staticRenderFns__$j = [];

/* style */
var __vue_inject_styles__$j = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-4851d3d6_0", {
    source: "@-webkit-keyframes slide-in{100%{transform:translateX(5px)}}@-moz-keyframes slide-in{100%{transform:translateX(5px)}}@-ms-keyframes slide-in{100%{transform:translateX(5px)}}@keyframes slide-in{100%{transform:translateX(5px)}}@-webkit-keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@-moz-keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@-ms-keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-10.4rem)}}@-webkit-keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@-moz-keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@-ms-keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@keyframes slide-out-33{0%{transform:translateX(0)}100%{transform:translateX(-3rem)}}@-webkit-keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@-moz-keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@-ms-keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@keyframes slide-out-66{0%{transform:translateX(0)}100%{transform:translateX(-6.7rem)}}@-webkit-keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@-moz-keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@-ms-keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@keyframes slide-out-menu{0%{-webkit-transform:translateX(0)}100%{-webkit-transform:translateX(101%)}}@-webkit-keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@-moz-keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@-ms-keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@keyframes pulse-ring{0%{transform:scale(.23)}100%,80%{opacity:0}}@-webkit-keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@-moz-keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@-ms-keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@keyframes pulse-heart{0%{transform:scale(1)}50%{transform:scale(1.1)}100%{transform:scale(1)}}@-webkit-keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@-moz-keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@-ms-keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes pulse-shrink{0%{transform:scale(1)}100%{transform:scale(0)}}@-webkit-keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}@-moz-keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}@-ms-keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}@keyframes pulse-ring-explosion{0%,20%{transform:scale(.5);opacity:.5}30%,50%{opacity:.3}80%{opacity:1}100%{transform:scale(25);opacity:0}}.slide-in{animation:slide-in .5s forwards;-webkit-animation:slide-in .5s forwards}.slide-in-menu{animation:slide-in-menu .5s forwards;-webkit-animation:slide-in-menu .5s forwards}.slide-out{animation:slide-out .5s forwards;-webkit-animation:slide-out .5s forwards}.slide-out-33{animation:slide-out-33 .5s forwards;-webkit-animation:slide-out-33 .5s forwards}.slide-out-66{animation:slide-out-66 .5s forwards;-webkit-animation:slide-out-66 .5s forwards}.slide-out-menu{animation:slide-out-menu .5s forwards;-webkit-animation:slide-out-menu .5s forwards}#chat-toggler-area{width:130px;height:130px;position:fixed;z-index:9999;bottom:0;transform:scale(1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$j = undefined;
/* module identifier */
var __vue_module_identifier__$j = undefined;
/* functional template */
var __vue_is_functional_template__$j = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, createInjector, undefined, undefined);

var _dec$i,
  _this$a = this,
  _class$i,
  _class2$i,
  _descriptor$i;
var ChatToggleClose = (_dec$i = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$a);
  }.bind(this)
}), Component(_class$i = (_class2$i = /*#__PURE__*/function (_Vue) {
  function ChatToggleClose() {
    var _this2;
    _classCallCheck(this, ChatToggleClose);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ChatToggleClose, [].concat(args));
    _initializerDefineProperty(_this2, "handleShowChatArea", _descriptor$i, _this2);
    return _this2;
  }
  _inherits(ChatToggleClose, _Vue);
  return _createClass(ChatToggleClose, [{
    key: "onClickToggleClose",
    value: function onClickToggleClose() {
      this.handleShowChatArea(false);
    }
  }]);
}(Vue$2), _descriptor$i = _applyDecoratedDescriptor(_class2$i.prototype, "handleShowChatArea", [_dec$i], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2$i)) || _class$i);

/* script */
var __vue_script__$k = ChatToggleClose;

/* template */
var __vue_render__$k = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "id": "chat-toggler-close"
    }
  }, [_c('el-button', {
    staticClass: "wrapper-close-toggle",
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": _vm.onClickToggleClose
    }
  })], 1);
};
var __vue_staticRenderFns__$k = [];

/* style */
var __vue_inject_styles__$k = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-5b9cc899_0", {
    source: ".w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}#chat-toggler-close{display:inline-block;position:fixed;width:35px;z-index:9999;top:10px;right:10px;opacity:0}#chat-toggler-close .wrapper-close-toggle{margin:0;padding:0;font-size:inherit;outline:0;border:none;font-size:2em;color:#225080;background:#fff;-webkit-box-shadow:0 1px 10px #818181;box-shadow:0 1px 10px #818181}#chat-toggler-close .wrapper-close-toggle:hover{color:#225080}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$k = undefined;
/* module identifier */
var __vue_module_identifier__$k = undefined;
/* functional template */
var __vue_is_functional_template__$k = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, createInjector, undefined, undefined);

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var iterators = {};

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR] === it);
};

var ITERATOR$1 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$1)
    || getMethod(it, '@@iterator')
    || iterators[classof(it)];
};

var $TypeError$d = TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw new $TypeError$d(tryToString(argument) + ' is not iterable');
};

var $Array$2 = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array$2 && isArrayIteratorMethod(iteratorMethod))) {
    result = IS_CONSTRUCTOR ? new this() : [];
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    for (;!(step = functionCall(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$2(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var ITERATOR$2 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
_export({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: arrayFrom
});

// eslint-disable-next-line es/no-typed-arrays -- safe
var arrayBufferBasicDetection = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

var defineBuiltIns = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

var $TypeError$e = TypeError;

var anInstance = function (it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw new $TypeError$e('Incorrect invocation');
};

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
var toIndex = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw new $RangeError('Wrong length or index');
  return length;
};

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
var mathSign$1 = Math.sign || function sign(x) {
  var n = +x;
  // eslint-disable-next-line no-self-compare -- NaN check
  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};

var abs = Math.abs;

var EPSILON = 2.220446049250313e-16; // Number.EPSILON
var INVERSE_EPSILON = 1 / EPSILON;

var roundTiesToEven = function (n) {
  return n + INVERSE_EPSILON - INVERSE_EPSILON;
};

var mathFloatRound = function (x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
  var n = +x;
  var absolute = abs(n);
  var s = mathSign$1(n);
  if (absolute < FLOAT_MIN_VALUE) return s * roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
  var a = (1 + FLOAT_EPSILON / EPSILON) * absolute;
  var result = a - (a - absolute);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
  return s * result;
};

var FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;

// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
var mathFround = Math.fround || function fround(x) {
  return mathFloatRound(x, FLOAT32_EPSILON, FLOAT32_MAX_VALUE, FLOAT32_MIN_VALUE);
};

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array$3 = Array;
var abs$1 = Math.abs;
var pow = Math.pow;
var floor$3 = Math.floor;
var log$1 = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array$3(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs$1(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number !== number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number !== number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$3(log$1(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent += eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[index - 1] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa += pow(2, mantissaLength);
    exponent -= eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

var ieee754 = {
  pack: pack,
  unpack: unpack
};

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var defineProperty$4 = objectDefineProperty.f;



var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwnProperty_1(target, TO_STRING_TAG$2)) {
    defineProperty$4(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var PROPER_FUNCTION_NAME$2 = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE$1 = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = internalState.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = internalState.getterFor(DATA_VIEW);
var setInternalState = internalState.set;
var NativeArrayBuffer = globalThis_1[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE$1];
var $DataView = globalThis_1[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE$1];
var ObjectPrototype$1 = Object.prototype;
var Array$1 = globalThis_1.Array;
var RangeError$1 = globalThis_1.RangeError;
var fill = functionUncurryThis(arrayFill);
var reverse = functionUncurryThis([].reverse);

var packIEEE754 = ieee754.pack;
var unpackIEEE754 = ieee754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(mathFround(number), 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor(Constructor[PROTOTYPE$1], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get$1 = function (view, count, index, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError$1(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice(bytes, start, start + count);
  return boolIsLittleEndian ? pack : reverse(pack);
};

var set$1 = function (view, count, index, conversion, value, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex(index);
  var pack = conversion(+value);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError$1(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  for (var i = 0; i < count; i++) bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};

if (!arrayBufferBasicDetection) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array$1(byteLength), 0),
      byteLength: byteLength
    });
    if (!descriptors) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE$1];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw new RangeError$1('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw new RangeError$1(WRONG_LENGTH);
    setInternalState(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!descriptors) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE$1];

  if (descriptors) {
    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter($DataView, 'buffer', getInternalDataViewState);
    addGetter($DataView, 'byteLength', getInternalDataViewState);
    addGetter($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get$1(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get$1(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get$1(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get$1(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get$1(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get$1(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get$1(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get$1(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set$1(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set$1(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set$1(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set$1(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set$1(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set$1(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set$1(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set$1(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME$2 && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new, sonar/inconsistent-function-call -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new, sonar/inconsistent-function-call -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return inheritIfRequired(new NativeArrayBuffer(toIndex(length)), this, $ArrayBuffer);
    };

    $ArrayBuffer[PROTOTYPE$1] = ArrayBufferPrototype;

    ArrayBufferPrototype.constructor = $ArrayBuffer;

    copyConstructorProperties($ArrayBuffer, NativeArrayBuffer);
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (objectSetPrototypeOf && objectGetPrototypeOf(DataViewPrototype) !== ObjectPrototype$1) {
    objectSetPrototypeOf(DataViewPrototype, ObjectPrototype$1);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = functionUncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};

var ARRAY_BUFFER$1 = 'ArrayBuffer';
var ArrayBuffer$1 = arrayBuffer[ARRAY_BUFFER$1];
var NativeArrayBuffer$1 = globalThis_1[ARRAY_BUFFER$1];

// `ArrayBuffer` constructor
// https://tc39.es/ecma262/#sec-arraybuffer-constructor
_export({ global: true, constructor: true, forced: NativeArrayBuffer$1 !== ArrayBuffer$1 }, {
  ArrayBuffer: ArrayBuffer$1
});

setSpecies(ARRAY_BUFFER$1);

var ITERATOR$3 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$1(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR$3].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR$3])) {
  defineBuiltIn(IteratorPrototype, ITERATOR$3, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

var PROPER_FUNCTION_NAME$3 = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$4, returnThis$1);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$3 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return functionCall(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  iterators[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return { value: value, done: done };
};

var charAt$5 = stringMultibyte.charAt;





var STRING_ITERATOR = 'String Iterator';
var setInternalState$1 = internalState.set;
var getInternalState$1 = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
iteratorDefine(String, 'String', function (iterated) {
  setInternalState$1(this, {
    type: STRING_ITERATOR,
    string: toString_1(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt$5(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});

var $RangeError$1 = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString_1(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n === Infinity) throw new $RangeError$1('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

// https://github.com/tc39/proposal-string-pad-start-end






var repeat$2 = functionUncurryThis(stringRepeat);
var stringSlice$8 = functionUncurryThis(''.slice);
var ceil$1 = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod$5 = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString_1(requireObjectCoercible($this));
    var intMaxLength = toLength(maxLength);
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString_1(fillString);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr === '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat$2(fillStr, ceil$1(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringSlice$8(stringFiller, 0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

var stringPad = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod$5(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod$5(true)
};

// https://github.com/zloirock/core-js/issues/280


var stringPadWebkitBug = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(environmentUserAgent);

var $padStart = stringPad.start;


// `String.prototype.padStart` method
// https://tc39.es/ecma262/#sec-string.prototype.padstart
_export({ target: 'String', proto: true, forced: stringPadWebkitBug }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;







var stringSlice$9 = functionUncurryThisClause(''.slice);
var min$6 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor$4(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
_export({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString_1(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min$6(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString_1(searchString);
    return stringSlice$9(that, index, index + search.length) === search;
  }
});

var enforceInternalState$1 = internalState.enforce;
var getInternalState$2 = internalState.get;
var Int8Array$1 = globalThis_1.Int8Array;
var Int8ArrayPrototype = Int8Array$1 && Int8Array$1.prototype;
var Uint8ClampedArray$1 = globalThis_1.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray$1 && Uint8ClampedArray$1.prototype;
var TypedArray = Int8Array$1 && objectGetPrototypeOf(Int8Array$1);
var TypedArrayPrototype = Int8ArrayPrototype && objectGetPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype$2 = Object.prototype;
var TypeError$3 = globalThis_1.TypeError;

var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferBasicDetection && !!objectSetPrototypeOf && classof(globalThis_1.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME$1, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject$1(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwnProperty_1(TypedArrayConstructorsList, klass)
    || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = objectGetPrototypeOf(it);
  if (!isObject$1(proto)) return;
  var state = getInternalState$2(proto);
  return (state && hasOwnProperty_1(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject$1(it)) return false;
  var klass = classof(it);
  return hasOwnProperty_1(TypedArrayConstructorsList, klass)
    || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw new TypeError$3('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!objectSetPrototypeOf || objectIsPrototypeOf(TypedArray, C))) return C;
  throw new TypeError$3(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!descriptors) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = globalThis_1[ARRAY];
    if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!descriptors) return;
  if (objectSetPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = globalThis_1[ARRAY];
      if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = globalThis_1[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME$1 in TypedArrayConstructorsList) {
  Constructor = globalThis_1[NAME$1];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState$1(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME$1 in BigIntArrayConstructorsList) {
  Constructor = globalThis_1[NAME$1];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState$1(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw new TypeError$3('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME$1 in TypedArrayConstructorsList) {
    if (globalThis_1[NAME$1]) objectSetPrototypeOf(globalThis_1[NAME$1], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype$2) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME$1 in TypedArrayConstructorsList) {
    if (globalThis_1[NAME$1]) objectSetPrototypeOf(globalThis_1[NAME$1].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && objectGetPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  objectSetPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (descriptors && !hasOwnProperty_1(TypedArrayPrototype, TO_STRING_TAG$3)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG$3, {
    configurable: true,
    get: function () {
      return isObject$1(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME$1 in TypedArrayConstructorsList) if (globalThis_1[NAME$1]) {
    createNonEnumerableProperty(globalThis_1[NAME$1], TYPED_ARRAY_TAG, NAME$1);
  }
}

var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};

/* eslint-disable no-new, sonar/inconsistent-function-call -- required for testing */



var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer$2 = globalThis_1.ArrayBuffer;
var Int8Array$2 = globalThis_1.Int8Array;

var typedArrayConstructorsRequireWrappers = !NATIVE_ARRAY_BUFFER_VIEWS$1 || !fails(function () {
  Int8Array$2(1);
}) || !fails(function () {
  new Int8Array$2(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array$2();
  new Int8Array$2(null);
  new Int8Array$2(1.5);
  new Int8Array$2(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array$2(new ArrayBuffer$2(2), 1, undefined).length !== 1;
});

var floor$4 = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
var isIntegralNumber = Number.isInteger || function isInteger(it) {
  return !isObject$1(it) && isFinite(it) && floor$4(it) === it;
};

var $RangeError$2 = RangeError;

var toPositiveInteger = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw new $RangeError$2("The argument can't be less than 0");
  return result;
};

var $RangeError$3 = RangeError;

var toOffset = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw new $RangeError$3('Wrong offset');
  return offset;
};

var round$1 = Math.round;

var toUint8Clamped = function (it) {
  var value = round$1(it);
  return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};

var isBigIntArray = function (it) {
  var klass = classof(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};

var $TypeError$f = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
var toBigInt = function (argument) {
  var prim = toPrimitive$1(argument, 'number');
  if (typeof prim == 'number') throw new $TypeError$f("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};

var aTypedArrayConstructor$1 = arrayBufferViewCore.aTypedArrayConstructor;


var typedArrayFrom = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = functionCall(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = functionBindContext(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor$1(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};

var arrayFromConstructorAndList = function (Constructor, list, $length) {
  var index = 0;
  var length = arguments.length > 2 ? $length : lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var typedArrayConstructor = createCommonjsModule(function (module) {























var getOwnPropertyNames = objectGetOwnPropertyNames.f;

var forEach = arrayIteration.forEach;








var getInternalState = internalState.get;
var setInternalState = internalState.set;
var enforceInternalState = internalState.enforce;
var nativeDefineProperty = objectDefineProperty.f;
var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var RangeError = globalThis_1.RangeError;
var ArrayBuffer = arrayBuffer.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = arrayBuffer.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = arrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = arrayBufferViewCore.TypedArray;
var TypedArrayPrototype = arrayBufferViewCore.TypedArrayPrototype;
var isTypedArray = arrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return objectIsPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey$1(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey$1(key);
  if (isTypedArrayIndex(target, key)
    && isObject$1(descriptor)
    && hasOwnProperty_1(descriptor, 'value')
    && !hasOwnProperty_1(descriptor, 'get')
    && !hasOwnProperty_1(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwnProperty_1(descriptor, 'writable') || descriptor.writable)
    && (!hasOwnProperty_1(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (descriptors) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    objectGetOwnPropertyDescriptor.f = wrappedGetOwnPropertyDescriptor;
    objectDefineProperty.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  _export({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = globalThis_1[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject$1(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw new RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw new RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw new RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return arrayFromConstructorAndList(TypedArrayConstructor, data);
        } else {
          return functionCall(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (objectSetPrototypeOf) objectSetPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = objectCreate(TypedArrayPrototype);
    } else if (typedArrayConstructorsRequireWrappers) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject$1(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return arrayFromConstructorAndList(TypedArrayConstructor, data);
          return functionCall(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (objectSetPrototypeOf) objectSetPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    _export({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };
});

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
typedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var min$7 = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
var arrayCopyWithin = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min$7((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  } return O;
};

var u$ArrayCopyWithin = functionUncurryThis(arrayCopyWithin);
var aTypedArray$1 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$1 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod$1('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray$1(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});

var $every = arrayIteration.every;

var aTypedArray$2 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$2 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod$2('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray$2(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var aTypedArray$3 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$3 = arrayBufferViewCore.exportTypedArrayMethod;
var slice = functionUncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod$3('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray$3(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return functionCall(arrayFill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);

var aTypedArrayConstructor$2 = arrayBufferViewCore.aTypedArrayConstructor;
var getTypedArrayConstructor$1 = arrayBufferViewCore.getTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
var typedArraySpeciesConstructor = function (originalArray) {
  return aTypedArrayConstructor$2(speciesConstructor(originalArray, getTypedArrayConstructor$1(originalArray)));
};

var typedArrayFromSpeciesAndList = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};

var $filter$1 = arrayIteration.filter;


var aTypedArray$4 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$4 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod$4('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter$1(aTypedArray$4(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return typedArrayFromSpeciesAndList(this, list);
});

var $find$1 = arrayIteration.find;

var aTypedArray$5 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$5 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod$5('find', function find(predicate /* , thisArg */) {
  return $find$1(aTypedArray$5(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

var $findIndex$1 = arrayIteration.findIndex;

var aTypedArray$6 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$6 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod$6('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex$1(aTypedArray$6(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

var $forEach$1 = arrayIteration.forEach;

var aTypedArray$7 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$7 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod$7('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach$1(aTypedArray$7(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var $includes$1 = arrayIncludes.includes;

var aTypedArray$8 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$8 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod$8('includes', function includes(searchElement /* , fromIndex */) {
  return $includes$1(aTypedArray$8(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

var $indexOf = arrayIncludes.indexOf;

var aTypedArray$9 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$9 = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod$9('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray$9(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});

var defineProperty$5 = objectDefineProperty.f;





var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$2 = internalState.set;
var getInternalState$3 = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = iteratorDefine(Array, 'Array', function (iterated, kind) {
  setInternalState$2(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$3(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = iterators.Arguments = iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (descriptors && values.name !== 'values') try {
  defineProperty$5(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var ITERATOR$5 = wellKnownSymbol('iterator');
var Uint8Array$1 = globalThis_1.Uint8Array;
var arrayValues = functionUncurryThis(es_array_iterator.values);
var arrayKeys$1 = functionUncurryThis(es_array_iterator.keys);
var arrayEntries = functionUncurryThis(es_array_iterator.entries);
var aTypedArray$a = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$a = arrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype$1 = Uint8Array$1 && Uint8Array$1.prototype;

var GENERIC = !fails(function () {
  TypedArrayPrototype$1[ITERATOR$5].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype$1
  && TypedArrayPrototype$1.values
  && TypedArrayPrototype$1[ITERATOR$5] === TypedArrayPrototype$1.values
  && TypedArrayPrototype$1.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray$a(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod$a('entries', function entries() {
  return arrayEntries(aTypedArray$a(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod$a('keys', function keys() {
  return arrayKeys$1(aTypedArray$a(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod$a('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod$a(ITERATOR$5, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });

var aTypedArray$b = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$b = arrayBufferViewCore.exportTypedArrayMethod;
var $join = functionUncurryThis([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod$b('join', function join(separator) {
  return $join(aTypedArray$b(this), separator);
});

/* eslint-disable es/no-array-prototype-lastindexof -- safe */






var min$8 = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD$2 = arrayMethodIsStrict('lastIndexOf');
var FORCED$5 = NEGATIVE_ZERO || !STRICT_METHOD$2;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
var arrayLastIndexOf = FORCED$5 ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return functionApply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  if (length === 0) return -1;
  var index = length - 1;
  if (arguments.length > 1) index = min$8(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;

var aTypedArray$c = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$c = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod$c('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return functionApply(arrayLastIndexOf, aTypedArray$c(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});

var $map$1 = arrayIteration.map;


var aTypedArray$d = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$d = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod$d('map', function map(mapfn /* , thisArg */) {
  return $map$1(aTypedArray$d(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});

var $TypeError$g = TypeError;

var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$6 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject(that);
    var self = indexedObject(O);
    var length = lengthOfArrayLike(O);
    aCallable(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError$g(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError$g(REDUCE_EMPTY);
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$6(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$6(true)
};

var $reduce = arrayReduce.left;

var aTypedArray$e = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$e = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod$e('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce(aTypedArray$e(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

var $reduceRight = arrayReduce.right;

var aTypedArray$f = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$f = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod$f('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray$f(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});

var aTypedArray$g = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$g = arrayBufferViewCore.exportTypedArrayMethod;
var floor$5 = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod$g('reverse', function reverse() {
  var that = this;
  var length = aTypedArray$g(that).length;
  var middle = floor$5(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});

var RangeError$2 = globalThis_1.RangeError;
var Int8Array$3 = globalThis_1.Int8Array;
var Int8ArrayPrototype$1 = Int8Array$3 && Int8Array$3.prototype;
var $set = Int8ArrayPrototype$1 && Int8ArrayPrototype$1.set;
var aTypedArray$h = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$h = arrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  functionCall($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array$3(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod$h('set', function set(arrayLike /* , offset */) {
  aTypedArray$h(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return functionCall($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw new RangeError$2('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

var aTypedArray$i = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$i = arrayBufferViewCore.exportTypedArrayMethod;

var FORCED$6 = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod$i('slice', function slice(start, end) {
  var list = arraySlice(aTypedArray$i(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED$6);

var $some = arrayIteration.some;

var aTypedArray$j = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$j = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod$j('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray$j(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});

var aTypedArray$k = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$k = arrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array$1 = globalThis_1.Uint16Array;
var nativeSort$1 = Uint16Array$1 && functionUncurryThisClause(Uint16Array$1.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort$1 && !(fails(function () {
  nativeSort$1(new Uint16Array$1(2), null);
}) && fails(function () {
  nativeSort$1(new Uint16Array$1(2), {});
}));

var STABLE_SORT$1 = !!nativeSort$1 && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (environmentV8Version) return environmentV8Version < 74;
  if (environmentFfVersion) return environmentFfVersion < 67;
  if (environmentIsIeOrEdge) return true;
  if (environmentWebkitVersion) return environmentWebkitVersion < 602;

  var array = new Uint16Array$1(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort$1(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare$1 = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod$k('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT$1) return nativeSort$1(this, comparefn);

  return arraySort(aTypedArray$k(this), getSortCompare$1(comparefn));
}, !STABLE_SORT$1 || ACCEPT_INCORRECT_ARGUMENTS);

var aTypedArray$l = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$l = arrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod$l('subarray', function subarray(begin, end) {
  var O = aTypedArray$l(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});

var Int8Array$4 = globalThis_1.Int8Array;
var aTypedArray$m = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$m = arrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array$4 && fails(function () {
  $toLocaleString.call(new Int8Array$4(1));
});

var FORCED$7 = fails(function () {
  return [1, 2].toLocaleString() !== new Int8Array$4([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array$4.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod$m('toLocaleString', function toLocaleString() {
  return functionApply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray$m(this)) : aTypedArray$m(this),
    arraySlice(arguments)
  );
}, FORCED$7);

var exportTypedArrayMethod$n = arrayBufferViewCore.exportTypedArrayMethod;




var Uint8Array$2 = globalThis_1.Uint8Array;
var Uint8ArrayPrototype = Uint8Array$2 && Uint8Array$2.prototype || {};
var arrayToString = [].toString;
var join = functionUncurryThis([].join);

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod$n('toString', arrayToString, IS_NOT_ARRAY_METHOD);

var $RangeError$4 = RangeError;
var $String$5 = String;
var floor$6 = Math.floor;
var repeat$3 = functionUncurryThis(stringRepeat);
var stringSlice$a = functionUncurryThis(''.slice);
var nativeToFixed = functionUncurryThis(1.0.toFixed);

var pow$1 = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow$1(x, n - 1, acc * x) : pow$1(x * x, n / 2, acc);
};

var log$2 = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$6(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$6(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String$5(data[index]);
      s = s === '' ? t : s + repeat$3('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED$8 = fails(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
_export({ target: 'Number', proto: true, forced: FORCED$8 }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError$4('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String$5(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log$2(number * pow$1(2, 69, 1)) - 69;
      z = e < 0 ? number * pow$1(2, -e, 1) : number / pow$1(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow$1(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat$3('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat$3('0', fractDigits - k) + result
        : stringSlice$a(result, 0, k - fractDigits) + '.' + stringSlice$a(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

// AudioService: Microphone + VAD + Recorder
var AudioService = /*#__PURE__*/function () {
  function AudioService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$cfg = _ref.cfg,
      cfg = _ref$cfg === void 0 ? {} : _ref$cfg,
      _ref$onSegment = _ref.onSegment,
      onSegment = _ref$onSegment === void 0 ? null : _ref$onSegment,
      _ref$onState = _ref.onState,
      onState = _ref$onState === void 0 ? null : _ref$onState,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? null : _ref$onError;
    _classCallCheck(this, AudioService);
    // call static polyfill helper
    AudioService.ensureMediaDevices();

    // instance-level flag mirrors static one
    this.hasMicSupport = AudioService.isMicSupported;
    this.cfg = _objectSpread2({}, cfg);
    this.onSegment = onSegment;
    this.onState = onState;
    this.onError = onError;
    this.setDefaultState();

    // bind vadLoop so RAF can reference a stable function instance
    this.boundVadLoop = this.vadLoop.bind(this);

    // guards and locks
    this.resetLock = false;
    // used to await mediaRecorder stop events
    this.stopWaiters = [];
    // ensure RAF-running flag defined immediately (defensive)
    this.rafRunning = false;
  }
  return _createClass(AudioService, [{
    key: "setDefaultState",
    value: function setDefaultState() {
      this.stream = null;
      this.mediaRecorder = null;
      this.audioCtx = null;
      this.analyser = null;
      this.dataArray = null;
      this.freqArray = null;
      this.chunks = [];
      this.isListening = false;
      this.inSpeech = false;
      this.speechStartTime = null; // to manage delayed VAD activation
      this.ttsInterruptStartTime = null; // for TTS interruption
      this.lastResetTime = 0;
      this.lastVoiceTs = 0;
      this.rafId = null;
      this.isTtsPlaying = false;
      this.segmentCount = 0; // total processed (including skipped)
      this.successCount = 0; // segments successfully passed on
      this.resetCount = 0; // how many preventive resets occurred
      // track whether the RAF loop is currently scheduled/running
      this.rafRunning = false;
    }
  }, {
    key: "pickSupportedMime",
    value: function pickSupportedMime(preferred) {
      var list = [preferred, "audio/webm;codecs=opus", "audio/webm", "audio/ogg;codecs=opus", "audio/ogg"].filter(Boolean);
      var _iterator = _createForOfIteratorHelper(list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mt = _step.value;
          try {
            if (mt && window.MediaRecorder && MediaRecorder.isTypeSupported(mt)) {
              return mt;
            }
          } catch (e) {}
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return "";
    }

    // small helper to safely stop mediaRecorder and wait for onstop
  }, {
    key: "safeStopMediaRecorder",
    value: function safeStopMediaRecorder() {
      var _this = this;
      return new Promise(function (resolve) {
        var _this2 = this;
        _newArrowCheck(this, _this);
        if (!this.mediaRecorder) {
          return resolve();
        }
        try {
          if (this.mediaRecorder.state === "inactive") return resolve();
          var timeout = setTimeout(function () {
            _newArrowCheck(this, _this2);
            // Force resolve if onstop never fires
            try {
              this.mediaRecorder.ondataavailable = null;
            } catch (e) {}
            resolve();
          }.bind(this), 1200);
          var originalOnStop = this.mediaRecorder.onstop;
          var once = function once(ev) {
            _newArrowCheck(this, _this2);
            clearTimeout(timeout);
            try {
              if (originalOnStop) {
                originalOnStop.call(this.mediaRecorder, ev);
              }
            } catch (e) {}
            resolve();
          }.bind(this);
          this.mediaRecorder.onstop = once;
          try {
            this.mediaRecorder.stop();
          } catch (e) {
            // If stop throws (rare), resolve anyway
            clearTimeout(timeout);
            resolve();
          }
        } catch (e) {
          resolve();
        }
      }.bind(this));
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this3 = this;
        var errorMsg, requested, audioSrc, highpassFilter, chosen, opts, timeslice, _t2, _t3, _t4, _t5, _t6, _t7, _t8;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.hasMicSupport) {
                _context.n = 1;
                break;
              }
              errorMsg = "[AudioService] Microphone not supported in this environment.";
              console.warn(errorMsg);
              if (this.onError) {
                this.onError(new Error(errorMsg));
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              requested = {
                audio: {
                  echoCancellation: true,
                  noiseSuppression: true,
                  autoGainControl: true,
                  sampleRate: 16000,
                  channelCount: 1,
                  googEchoCancellation: true,
                  // advanced parameters for better echo cancellation
                  googAutoGainControl: true,
                  googNoiseSuppression: true,
                  googHighpassFilter: true,
                  googAudioMirroring: false
                }
              };
              _context.n = 2;
              return navigator.mediaDevices.getUserMedia(requested);
            case 2:
              this.stream = _context.v;
              if (!(!this.audioCtx || this.audioCtx && this.audioCtx.state === "closed")) {
                _context.n = 3;
                break;
              }
              this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
              _context.n = 7;
              break;
            case 3:
              if (!(this.audioCtx && this.audioCtx.state === "suspended")) {
                _context.n = 7;
                break;
              }
              _context.p = 4;
              _context.n = 5;
              return this.audioCtx.resume();
            case 5:
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _context.v;
            case 7:
              audioSrc = this.audioCtx.createMediaStreamSource(this.stream);
              highpassFilter = this.audioCtx.createBiquadFilter();
              highpassFilter.type = "highpass";
              highpassFilter.frequency.value = 85; // remove frequencies below 85Hz

              this.analyser = this.audioCtx.createAnalyser();
              this.analyser.fftSize = 2048; // increased for more precision
              this.analyser.smoothingTimeConstant = 0.3; // smoothing to reduce false positives
              this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);
              this.freqArray = new Uint8Array(this.analyser.frequencyBinCount); // separate array for frequencies

              // connection: source -> highpass filter -> analyzer
              _context.p = 8;
              audioSrc.connect(highpassFilter);
              highpassFilter.connect(this.analyser);
              _context.n = 12;
              break;
            case 9:
              _context.p = 9;
              _t2 = _context.v;
              // defensive fallback if connect fails
              console.warn("[AudioService] Node connect failed, attempting alternative routing", _t2);
              _context.p = 10;
              audioSrc.connect(this.analyser);
              _context.n = 12;
              break;
            case 11:
              _context.p = 11;
              _t3 = _context.v;
              console.error("[AudioService] Failed to connect audio nodes", _t3);
              throw _t3;
            case 12:
              // mediaRecorder with more robust management
              chosen = this.pickSupportedMime(this.cfg.mimeType);
              opts = {
                audioBitsPerSecond: 128000
              };
              if (chosen) {
                opts.mimeType = chosen;
              }
              console.log("[MediaRecorder] Initializing with options: ", opts);
              _context.p = 13;
              if (!(!this.mediaRecorder || this.mediaRecorder.state === "inactive")) {
                _context.n = 14;
                break;
              }
              this.mediaRecorder = new MediaRecorder(this.stream, opts);
              _context.n = 16;
              break;
            case 14:
              _context.n = 15;
              return this.safeStopMediaRecorder();
            case 15:
              this.mediaRecorder = new MediaRecorder(this.stream, opts);
            case 16:
              _context.n = 20;
              break;
            case 17:
              _context.p = 17;
              _t4 = _context.v;
              console.warn("[MediaRecorder] Init failed with opts, retry with basic config", _t4);
              _context.p = 18;
              this.mediaRecorder = new MediaRecorder(this.stream, {});
              _context.n = 20;
              break;
            case 19:
              _context.p = 19;
              _t5 = _context.v;
              console.error("[MediaRecorder] Complete init failure", _t5);
              throw _t5;
            case 20:
              console.log("[MediaRecorder] Final mimeType: ", this.mediaRecorder.mimeType);

              // reset chunks in a way that avoids race with ondataavailable
              this.chunks = [];

              // event handlers with defensive guards and minimal work
              this.mediaRecorder.ondataavailable = function (e) {
                _newArrowCheck(this, _this3);
                try {
                  if (e.data && e.data.size > 0) {
                    // push a copy reference immediately, avoid async races
                    this.chunks.push(e.data);
                    console.log("[MediaRecorder] Chunk received: ", e.data.size, "bytes, TTS playing:", this.isTtsPlaying);
                  }
                } catch (err) {
                  console.error("[MediaRecorder] ondataavailable handler error", err);
                }
              }.bind(this);
              this.mediaRecorder.onerror = function (e) {
                _newArrowCheck(this, _this3);
                console.error("[MediaRecorder] Error: ", e);
                this.onError && this.onError(e);
              }.bind(this);

              // ensure onstop doesn't clobber other logic
              this.mediaRecorder.onstop = function (ev) {
                var _this4 = this;
                _newArrowCheck(this, _this3);
                try {
                  console.log("[MediaRecorder] Stopped, final chunks: ", this.chunks.length);
                  // resolve any waiters awaiting stop
                  if (this.stopWaiters && this.stopWaiters.length) {
                    this.stopWaiters.forEach(function (fn) {
                      _newArrowCheck(this, _this4);
                      return fn();
                    }.bind(this));
                    this.stopWaiters = [];
                  }
                } catch (e) {
                  console.error(e);
                }
              }.bind(this);

              // Start with appropriate timeslice (configurable)
              timeslice = Number(this.cfg.timeslice) || 400;
              _context.p = 21;
              // start only if recorder inactive (avoid DOMException)
              if (this.mediaRecorder.state === "inactive") {
                this.mediaRecorder.start(timeslice); // 400ms default
                console.log("[MediaRecorder] Started with timeslice:", timeslice);
              } else {
                console.warn("[MediaRecorder] Start requested but recorder state:", this.mediaRecorder.state);
              }
              _context.n = 25;
              break;
            case 22:
              _context.p = 22;
              _t6 = _context.v;
              console.warn("[MediaRecorder] start() threw, attempting without timeslice", _t6);
              _context.p = 23;
              if (this.mediaRecorder.state === "inactive") {
                this.mediaRecorder.start();
              }
              _context.n = 25;
              break;
            case 24:
              _context.p = 24;
              _t7 = _context.v;
              console.error("[MediaRecorder] Failed to start", _t7);
              throw _t7;
            case 25:
              this.isListening = true;
              this.lastVoiceTs = performance.now();
              this.speechStartTime = null;
              this.ttsInterruptStartTime = null;

              // ensure only one RAF is running at a time
              if (!this.rafRunning) {
                this.rafRunning = true;
                this.rafId = requestAnimationFrame(this.boundVadLoop);
              }
              this.onState && this.onState({
                isListening: true,
                inSpeech: this.inSpeech
              });
              _context.n = 27;
              break;
            case 26:
              _context.p = 26;
              _t8 = _context.v;
              console.error("[Microphone] Error: ", _t8);
              this.onError && this.onError(_t8);
            case 27:
              return _context.a(2);
          }
        }, _callee, this, [[23, 24], [21, 22], [18, 19], [13, 17], [10, 11], [8, 9], [4, 6], [1, 26]]);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "stop",
    value: function stop() {
      var _this5 = this;
      try {
        this.isListening = false;

        // stop mediaRecorder safely and wait a short time for onstop
        var waitStop = this.safeStopMediaRecorder();
        // Stop media stream tracks
        if (this.stream) {
          try {
            this.stream.getTracks().forEach(function (t) {
              _newArrowCheck(this, _this5);
              return t.stop();
            }.bind(this));
          } catch (e) {}
        }

        // Close WebAudio context
        if (this.audioCtx) {
          try {
            this.audioCtx.close();
          } catch (e) {}
        }

        // Cancel animation frame
        if (this.rafId) {
          cancelAnimationFrame(this.rafId);
          this.rafId = null;
        }
        this.rafRunning = false;

        // Wait a small amount to ensure onstop handlers run
        waitStop.then(function () {
          _newArrowCheck(this, _this5);
          // after stopping, reset state but keep ability to inspect chunks if needed
          // NOTE: do not call setDefaultState here synchronously because caller may expect to read last chunk
          // now, reset the state
          this.setDefaultState();
          this.onState && this.onState({
            isListening: false,
            inSpeech: false
          });
        }.bind(this));
      } catch (e) {
        console.error("[AudioService] stop() error", e);
        this.setDefaultState();
        this.onState && this.onState({
          isListening: false,
          inSpeech: false
        });
      }
    }
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this6 = this;
        var now, _t9, _t1;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              console.log("[AudioService] Resetting recorder...");

              // prevent concurrent resets
              if (!this.resetLock) {
                _context2.n = 1;
                break;
              }
              console.log("[RESET] Already resetting - ignoring concurrent call");
              return _context2.a(2);
            case 1:
              this.resetLock = true;
              now = performance.now(); // Prevent too frequent resets (min 5 seconds apart)
              if (!(now - this.lastResetTime < 5000)) {
                _context2.n = 2;
                break;
              }
              console.log("[RESET] Skipping - too recent");
              this.resetLock = false;
              return _context2.a(2);
            case 2:
              this.resetCount++;
              this.lastResetTime = now;

              // Stop everything cleanly
              this.isListening = false;
              this.inSpeech = false;
              this.speechStartTime = null;

              // Stop MediaRecorder safely and wait
              _context2.p = 3;
              _context2.n = 4;
              return this.safeStopMediaRecorder();
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t9 = _context2.v;
              console.warn("[RESET] Error while stopping mediaRecorder", _t9);
            case 6:
              // Clear chunks buffer defensively (but keep a copy for debugging if needed)
              try {
                this.chunks = [];
              } catch (e) {}

              // Close WebAudio context
              _context2.p = 7;
              if (!this.audioCtx) {
                _context2.n = 8;
                break;
              }
              _context2.n = 8;
              return this.audioCtx.close();
            case 8:
              _context2.n = 10;
              break;
            case 9:
              _context2.p = 9;
              _context2.v;
            case 10:
              // Stop media stream tracks
              try {
                if (this.stream) this.stream.getTracks().forEach(function (track) {
                  _newArrowCheck(this, _this6);
                  return track.stop();
                }.bind(this));
              } catch (e) {}

              // Cancel animation frame
              if (this.rafId) {
                cancelAnimationFrame(this.rafId);
                this.rafId = null;
                this.rafRunning = false;
              }

              // Wait for cleanup
              _context2.n = 11;
              return new Promise(function (resolve) {
                _newArrowCheck(this, _this6);
                return setTimeout(resolve, 700);
              }.bind(this));
            case 11:
              // slightly shorter wait but stable

              // Reset all variables
              this.setDefaultState();

              // Restart recording (defensive, wrapped in try/catch)
              _context2.p = 12;
              _context2.n = 13;
              return this.start();
            case 13:
              _context2.n = 15;
              break;
            case 14:
              _context2.p = 14;
              _t1 = _context2.v;
              console.error("[AudioService] Failed to restart after reset", _t1);
              this.onError && this.onError(_t1);
            case 15:
              _context2.p = 15;
              this.resetLock = false;
              return _context2.f(15);
            case 16:
              return _context2.a(2);
          }
        }, _callee2, this, [[12, 14, 15, 16], [7, 9], [3, 5]]);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "vadLoop",
    value: function vadLoop() {
      var _this7 = this;
      // NOTE: this method is bound to this.boundVadLoop for RAF
      if (!this.analyser || !this.dataArray) {
        // schedule another check only if still listening and audioCtx exists
        if (this.isListening && this.rafRunning) {
          this.rafId = requestAnimationFrame(this.boundVadLoop);
        } else {
          this.rafRunning = false;
        }
        return;
      }
      try {
        this.analyser.getByteTimeDomainData(this.dataArray);
      } catch (e) {
        console.warn("[VAD] getByteTimeDomainData failed", e);
        // attempt to recover next frame
        if (this.isListening && this.rafRunning) {
          this.rafId = requestAnimationFrame(this.boundVadLoop);
        }
        return;
      }
      var sum = 0;
      for (var i = 0; i < this.dataArray.length; i++) {
        var v = (this.dataArray[i] - 128) / 128;
        sum += v * v;
      }
      var rms = Math.sqrt(sum / this.dataArray.length);
      var now = performance.now();

      // During TTS: use normal threshold but also analyze frequencies
      var threshold = this.cfg.vadThreshold || 0.025;
      var isLikelySpeech = true;
      if (this.isTtsPlaying) {
        try {
          // Analyzes the frequency spectrum to distinguish human speech from TTS
          this.analyser.getByteFrequencyData(this.freqArray);

          // Calculate energy in the typical voice frequency bands (300-3000 Hz)
          var nyquist = this.audioCtx.sampleRate / 2;
          var binSize = nyquist / this.analyser.frequencyBinCount;
          var voiceStart = Math.floor(300 / binSize); // 300 Hz
          var voiceEnd = Math.floor(3000 / binSize); // 3000 Hz

          var voiceEnergy = 0;
          var totalEnergy = 0;
          for (var _i2 = 0; _i2 < this.freqArray.length; _i2++) {
            var e = this.freqArray[_i2];
            totalEnergy += e;
            if (_i2 >= voiceStart && _i2 <= voiceEnd) {
              voiceEnergy += e;
            }
          }
          var voiceRatio = totalEnergy > 0 ? voiceEnergy / totalEnergy : 0;

          // If there is little energy in the voice band during TTS, it is probably just echo
          if (voiceRatio < 0.3) {
            isLikelySpeech = false;
          }

          // Occasional debugging
          if (rms > this.cfg.vadThreshold && Math.random() < 0.1) {
            console.log("[VAD] During TTS - RMS: ", rms.toFixed(4), "VoiceRatio: ", voiceRatio.toFixed(3), "LikelySpeech: ", isLikelySpeech);
          }
        } catch (e) {
          isLikelySpeech = true;
        }
      }

      // Main VAD - use normal threshold but consider filter during TTS
      var effectiveThreshold = this.isTtsPlaying && !isLikelySpeech ? threshold * 2 : threshold;
      if (rms > effectiveThreshold) {
        if (!this.inSpeech) {
          if (!this.speechStartTime) {
            this.speechStartTime = now;
          } else if (now - this.speechStartTime > 120) {
            // Slightly longer for stability
            this.inSpeech = true;
            this.lastVoiceTs = now;
            console.log("[VAD] Speech started, RMS: ", rms.toFixed(4), "During TTS: ", this.isTtsPlaying, "LikelySpeech: ", isLikelySpeech);
            this.onState && this.onState({
              inSpeech: true
            });
          }
        } else {
          this.lastVoiceTs = now;
        }
      } else {
        this.speechStartTime = null;
        if (this.inSpeech && now - this.lastVoiceTs > (this.cfg.silenceMs || 500)) {
          console.log("[VAD] Speech ended.");
          this.inSpeech = false;
          this.onState && this.onState({
            inSpeech: false
          });
          var audioBlob = this.flushBlob();
          if (audioBlob) {
            this.segmentCount++;

            // Reset MediaRecorder every 8 segments to prevent corruption
            if (this.segmentCount % 8 === 0 && this.segmentCount > 0) {
              console.log("[VAD] Preventive reset after ", this.segmentCount, " segments");

              // call reset asynchronously but stop current RAF before reset
              if (this.rafId) {
                cancelAnimationFrame(this.rafId);
                this.rafId = null;
                this.rafRunning = false;
              }

              // call reset but avoid awaiting here to let reset handle restart and states
              this.reset()["catch"](function (e) {
                _newArrowCheck(this, _this7);
                return console.error("[VAD] reset() error", e);
              }.bind(this));
              // log tracker
              this.logStats();
              return; // skip sending this corrupted segment
            }
            this.successCount++;
            if (this.onSegment) {
              // Normal handling
              try {
                this.onSegment(audioBlob);
              } catch (e) {
                console.error("[AudioService] onSegment handler threw", e);
              }
            }

            // log tracker
            this.logStats();
          }
        }
      }

      // schedule next iteration only if still listening
      if (this.isListening) {
        this.rafId = requestAnimationFrame(this.boundVadLoop);
        this.rafRunning = true;
      } else {
        this.rafRunning = false;
      }
    }
  }, {
    key: "flushBlob",
    value: function flushBlob() {
      if (!this.chunks.length) {
        return null;
      }

      // Simplified: get all chunks, reset immediately
      // clone array reference then clear to avoid races with ondataavailable
      var chunksToUse = this.chunks.slice();
      this.chunks.length = 0;
      var effectiveType = this.mediaRecorder && this.mediaRecorder.mimeType || this.cfg.mimeType || "audio/webm";
      var blob = new Blob(chunksToUse, {
        type: effectiveType
      });
      console.log("[VAD] Processing audio segment: ", blob.size, "bytes from ", chunksToUse.length, " chunks");
      return blob;
    }
  }, {
    key: "logStats",
    value: function logStats() {
      var successRate = this.segmentCount > 0 ? (this.successCount / this.segmentCount * 100).toFixed(1) : "0.0";
      console.log("[Tracker] Segments: ".concat(this.segmentCount, ", Success: ").concat(this.successCount, ", Resets: ").concat(this.resetCount, ", Success Rate: ").concat(successRate, "%"));
    }
  }, {
    key: "setTtsPlaying",
    value: function setTtsPlaying(val) {
      this.isTtsPlaying = !!val;
    }
  }], [{
    key: "ensureMediaDevices",
    value:
    // static helper for defensive polyfill
    // we make it static, might reuse this helper elsewhere (e.g. before instantiating AudioService)
    // ensure navigator.mediaDevices.getUserMedia exists
    function ensureMediaDevices() {
      if (typeof navigator === "undefined") {
        console.warn("[AudioService] navigator is undefined — audio APIs unavailable (possible SSR or headless mode).");
        // If microphone access can’t be established
        AudioService.isMicSupported = false;
        return;
      }

      // If the property exists and is an object, patch inside it
      if (_typeof(navigator.mediaDevices) === "object" && navigator.mediaDevices !== null) {
        if (typeof navigator.mediaDevices.getUserMedia !== "function") {
          var legacyGetUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
          if (legacyGetUserMedia) {
            console.warn("[AudioService] Patching legacy getUserMedia implementation.");
            navigator.mediaDevices.getUserMedia = function (constraints) {
              var _this8 = this;
              return new Promise(function (resolve, reject) {
                _newArrowCheck(this, _this8);
                return legacyGetUserMedia.call(navigator, constraints, resolve, reject);
              }.bind(this));
            };
          }
        }
      }
      // If the property doesn’t exist (very old browsers / headless)
      else if (navigator.mediaDevices === undefined) {
        var _legacyGetUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        if (_legacyGetUserMedia) {
          console.warn("[AudioService] Adding mediaDevices shim for legacy browsers.");
          navigator.mediaDevices = {
            getUserMedia: function getUserMedia(constraints) {
              var _this9 = this;
              return new Promise(function (resolve, reject) {
                _newArrowCheck(this, _this9);
                return _legacyGetUserMedia.call(navigator, constraints, resolve, reject);
              }.bind(this));
            }
          };
        }
      }

      // Final sanity check
      if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== "function") {
        console.warn("[AudioService] Warning: navigator.mediaDevices.getUserMedia() is still unavailable. " + "Audio capture will not work in this environment.");
        // If microphone access can’t be established
        AudioService.isMicSupported = false;
      }
    }
  }]);
}();
// static global flag for microphone fallback when getUserMedia is unavailable
// assume ok until proven otherwise
_defineProperty(AudioService, "isMicSupported", true);

var ITERATOR$6 = wellKnownSymbol('iterator');
var ArrayValues = es_array_iterator.values;

var handlePrototype$1 = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$6] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$6, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$6] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME$1 in domIterables) {
  handlePrototype$1(globalThis_1[COLLECTION_NAME$1] && globalThis_1[COLLECTION_NAME$1].prototype, COLLECTION_NAME$1);
}

handlePrototype$1(domTokenListPrototype, 'DOMTokenList');

var ITERATOR$7 = wellKnownSymbol('iterator');

var urlConstructorDetection = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'https://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (isPure && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (isPure || !descriptors))
    || !params.sort
    || url.href !== 'https://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR$7]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('https://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('https://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('https://x', undefined).host !== 'x';
});

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$6 = Object.defineProperty;
var concat$4 = functionUncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({ b: 1 }, $assign(defineProperty$6({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$6(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$4(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || functionCall(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js


var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base$1 = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base$1 - tMin;

var $RangeError$5 = RangeError;
var exec$2 = functionUncurryThis(regexSeparators.exec);
var floor$7 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt$2 = functionUncurryThis(''.charCodeAt);
var join$1 = functionUncurryThis([].join);
var push$6 = functionUncurryThis([].push);
var replace$4 = functionUncurryThis(''.replace);
var split$1 = functionUncurryThis(''.split);
var toLowerCase = functionUncurryThis(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt$2(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt$2(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push$6(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$6(output, value);
        counter--;
      }
    } else {
      push$6(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$7(delta / damp) : delta >> 1;
  delta += floor$7(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$7(delta / baseMinusTMin);
    k += base$1;
  }
  return floor$7(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$6(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$6(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$7((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError$5(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError$5(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base$1;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base$1 - t;
          push$6(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$7(qMinusT / baseMinusT);
          k += base$1;
        }

        push$6(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join$1(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$1(replace$4(toLowerCase(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$6(encoded, exec$2(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join$1(encoded, '.');
};

var $TypeError$h = TypeError;

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw new $TypeError$h('Not enough arguments');
  return passed;
};

var $RangeError$6 = RangeError;
var fromCharCode$1 = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join$2 = functionUncurryThis([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
_export({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError$6(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode$1(code)
        : fromCharCode$1(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join$2(elements, '');
  }
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!descriptors) return globalThis_1[name];
  var descriptor = getOwnPropertyDescriptor$5(globalThis_1, name);
  return descriptor && descriptor.value;
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

































var ITERATOR$8 = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$3 = internalState.set;
var getInternalParamsState = internalState.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = internalState.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var TypeError$4 = globalThis_1.TypeError;
var encodeURIComponent$1 = globalThis_1.encodeURIComponent;
var fromCharCode$2 = String.fromCharCode;
var fromCodePoint = getBuiltIn('String', 'fromCodePoint');
var $parseInt = parseInt;
var charAt$6 = functionUncurryThis(''.charAt);
var join$3 = functionUncurryThis([].join);
var push$7 = functionUncurryThis([].push);
var replace$5 = functionUncurryThis(''.replace);
var shift = functionUncurryThis([].shift);
var splice = functionUncurryThis([].splice);
var split$2 = functionUncurryThis(''.split);
var stringSlice$b = functionUncurryThis(''.slice);
var exec$3 = functionUncurryThis(/./.exec);

var plus = /\+/g;
var FALLBACK_REPLACER = '\uFFFD';
var VALID_HEX = /^[0-9a-f]+$/i;

var parseHexOctet = function (string, start) {
  var substr = stringSlice$b(string, start, start + 2);
  if (!exec$3(VALID_HEX, substr)) return NaN;

  return $parseInt(substr, 16);
};

var getLeadingOnes = function (octet) {
  var count = 0;
  for (var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1) {
    count++;
  }
  return count;
};

var utf8Decode = function (octets) {
  var codePoint = null;

  switch (octets.length) {
    case 1:
      codePoint = octets[0];
      break;
    case 2:
      codePoint = (octets[0] & 0x1F) << 6 | (octets[1] & 0x3F);
      break;
    case 3:
      codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | (octets[2] & 0x3F);
      break;
    case 4:
      codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | (octets[3] & 0x3F);
      break;
  }

  return codePoint > 0x10FFFF ? null : codePoint;
};

var decode = function (input) {
  input = replace$5(input, plus, ' ');
  var length = input.length;
  var result = '';
  var i = 0;

  while (i < length) {
    var decodedChar = charAt$6(input, i);

    if (decodedChar === '%') {
      if (charAt$6(input, i + 1) === '%' || i + 3 > length) {
        result += '%';
        i++;
        continue;
      }

      var octet = parseHexOctet(input, i + 1);

      // eslint-disable-next-line no-self-compare -- NaN check
      if (octet !== octet) {
        result += decodedChar;
        i++;
        continue;
      }

      i += 2;
      var byteSequenceLength = getLeadingOnes(octet);

      if (byteSequenceLength === 0) {
        decodedChar = fromCharCode$2(octet);
      } else {
        if (byteSequenceLength === 1 || byteSequenceLength > 4) {
          result += FALLBACK_REPLACER;
          i++;
          continue;
        }

        var octets = [octet];
        var sequenceIndex = 1;

        while (sequenceIndex < byteSequenceLength) {
          i++;
          if (i + 3 > length || charAt$6(input, i) !== '%') break;

          var nextByte = parseHexOctet(input, i + 1);

          // eslint-disable-next-line no-self-compare -- NaN check
          if (nextByte !== nextByte) {
            i += 3;
            break;
          }
          if (nextByte > 191 || nextByte < 128) break;

          push$7(octets, nextByte);
          i += 2;
          sequenceIndex++;
        }

        if (octets.length !== byteSequenceLength) {
          result += FALLBACK_REPLACER;
          continue;
        }

        var codePoint = utf8Decode(octets);
        if (codePoint === null) {
          result += FALLBACK_REPLACER;
        } else {
          decodedChar = fromCodePoint(codePoint);
        }
      }
    }

    result += decodedChar;
    i++;
  }

  return result;
};

var find$2 = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$5(encodeURIComponent$1(it), find$2, replacer);
};

var URLSearchParamsIterator = iteratorCreateConstructor(function Iterator(params, kind) {
  setInternalState$3(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$1(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$6(init, 0) === '?' ? stringSlice$b(init, 1) : init : toString_1(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = functionCall(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = functionCall(entryNext, entryIterator)).done ||
          (second = functionCall(entryNext, entryIterator)).done ||
          !functionCall(entryNext, entryIterator).done
        ) throw new TypeError$4('Expected sequence with length 2');
        push$7(entries, { key: toString_1(first.value), value: toString_1(second.value) });
      }
    } else for (var key in object) if (hasOwnProperty_1(object, key)) {
      push$7(entries, { key: key, value: toString_1(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split$2(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split$2(attribute, '=');
          push$7(entries, {
            key: decode(shift(entry)),
            value: decode(join$3(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$7(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join$3(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState$3(this, new URLSearchParamsState(init));
  if (!descriptors) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push$7(state.entries, { key: toString_1(name), value: toString_1(value) });
    if (!descriptors) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = toString_1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : toString_1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!descriptors) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = toString_1(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = toString_1(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$7(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = toString_1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : toString_1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = toString_1(name);
    var val = toString_1(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$7(entries, { key: key, value: val });
    if (!descriptors) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = functionBindContext(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR$8, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (descriptors) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

_export({ global: true, constructor: true, forced: !urlConstructorDetection }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!urlConstructorDetection && isCallable(Headers)) {
  var headersHas = functionUncurryThis(HeadersPrototype.has);
  var headersSet = functionUncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject$1(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return objectCreate(init, {
          body: createPropertyDescriptor(0, toString_1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    _export({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    _export({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`














var codeAt = stringMultibyte.codeAt;







var setInternalState$4 = internalState.set;
var getInternalURLState = internalState.getterFor('URL');
var URLSearchParams$1 = web_urlSearchParams_constructor.URLSearchParams;
var getInternalSearchParamsState = web_urlSearchParams_constructor.getState;

var NativeURL = globalThis_1.URL;
var TypeError$5 = globalThis_1.TypeError;
var parseInt$1 = globalThis_1.parseInt;
var floor$8 = Math.floor;
var pow$2 = Math.pow;
var charAt$7 = functionUncurryThis(''.charAt);
var exec$4 = functionUncurryThis(/./.exec);
var join$4 = functionUncurryThis([].join);
var numberToString = functionUncurryThis(1.0.toString);
var pop = functionUncurryThis([].pop);
var push$8 = functionUncurryThis([].push);
var replace$6 = functionUncurryThis(''.replace);
var shift$1 = functionUncurryThis([].shift);
var split$3 = functionUncurryThis(''.split);
var stringSlice$c = functionUncurryThis(''.slice);
var toLowerCase$1 = functionUncurryThis(''.toLowerCase);
var unshift = functionUncurryThis([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split$3(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return input;
    radix = 10;
    if (part.length > 1 && charAt$7(part, 0) === '0') {
      radix = exec$4(HEX_START, part) ? 16 : 8;
      part = stringSlice$c(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec$4(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
      number = parseInt$1(part, radix);
    }
    push$8(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow$2(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow$2(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt$7(input, pointer);
  };

  if (chr() === ':') {
    if (charAt$7(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec$4(HEX, chr())) {
      value = value * 16 + parseInt$1(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec$4(DIGIT, chr())) return;
        while (exec$4(DIGIT, chr())) {
          number = parseInt$1(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  return currLength > maxLength ? currStart : maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;

  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor$8(host / 256);
    }
    return join$4(result, '.');
  }

  // ipv6
  if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  }

  return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = objectAssign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = objectAssign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = objectAssign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwnProperty_1(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec$4(ALPHA, charAt$7(string, 0))
    && ((second = charAt$7(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$c(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt$7(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase$1(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase$1(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = toString_1(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw new TypeError$5(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw new TypeError$5(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = toString_1(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$6(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace$6(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace$6(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec$4(ALPHA, chr)) {
            buffer += toLowerCase$1(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec$4(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
            buffer += toLowerCase$1(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwnProperty_1(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$8(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || charAt$7(buffer, pointer + 1) !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride === HOSTNAME) return;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec$4(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt$1(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join$4(arraySlice(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join$4(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push$8(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$8(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$8(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$7(buffer, 0) + ':'; // normalize windows drive letter
              }
              push$8(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift$1(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial()) url.query += '%27';
            else if (chr === '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt$7(input, 0) === '[') {
      if (charAt$7(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice$c(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec$4(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = stringPunycodeToAscii(input);
      if (exec$4(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwnProperty_1(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join$4(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw new TypeError$5(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse(toString_1(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom(toString_1(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom(toString_1(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : toString_1(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = toString_1(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join$4(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = toString_1(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt$7(search, 0) === '?') search = stringSlice$c(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = toString_1(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt$7(hash, 0) === '#') hash = stringSlice$c(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState$4(that, new URLState(url, false, base));
  if (!descriptors) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (descriptors) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', functionBindContext(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', functionBindContext(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

_export({ global: true, constructor: true, forced: !urlConstructorDetection, sham: !descriptors }, {
  URL: URLConstructor
});

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
_export({ target: 'URL', proto: true, enumerable: true }, {
  toJSON: function toJSON() {
    return functionCall(URL.prototype.toString, this);
  }
});

// TTSService: builds payload and plays TTS via provided audio element
var TTSService = /*#__PURE__*/function () {
  function TTSService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === void 0 ? "" : _ref$baseUrl,
      _ref$audioEl = _ref.audioEl,
      audioEl = _ref$audioEl === void 0 ? null : _ref$audioEl;
    _classCallCheck(this, TTSService);
    this.baseUrl = (baseUrl || "").replace(/\/$/, "");
    this.audioEl = audioEl;
    this.isPlaying = false;
    this.currentBlobUrl = null;
  }
  return _createClass(TTSService, [{
    key: "buildPayload",
    value: function buildPayload(_ref2) {
      var voicePresetName = _ref2.voicePresetName,
        _ref2$voiceTuning = _ref2.voiceTuning,
        voiceTuning = _ref2$voiceTuning === void 0 ? {
          rate: 1.00,
          pitch: 0.0
        } : _ref2$voiceTuning,
        _ref2$ssml = _ref2.ssml,
        ssml = _ref2$ssml === void 0 ? false : _ref2$ssml,
        _ref2$text = _ref2.text,
        text = _ref2$text === void 0 ? "" : _ref2$text;
      return _objectSpread2({
        voice_preset: voicePresetName,
        audio_config: {
          speaking_rate: voiceTuning.rate,
          pitch: voiceTuning.pitch,
          audio_encoding: 'MP3'
        }
      }, ssml ? {
        ssml: text
      } : {
        text: text
      });
    }
  }, {
    key: "playText",
    value: function () {
      var _playText = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref3) {
        var _this = this;
        var text, voicePresetName, voiceTuning, _ref3$ssml, ssml, _ref3$onBeforePlayTex, onBeforePlayText, payload, ttsUrl, response, txt, blob, url, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              text = _ref3.text, voicePresetName = _ref3.voicePresetName, voiceTuning = _ref3.voiceTuning, _ref3$ssml = _ref3.ssml, ssml = _ref3$ssml === void 0 ? false : _ref3$ssml, _ref3$onBeforePlayTex = _ref3.onBeforePlayText, onBeforePlayText = _ref3$onBeforePlayTex === void 0 ? function () {
                _newArrowCheck(this, _this);
              }.bind(this) : _ref3$onBeforePlayTex;
              if (this.audioEl) {
                _context.n = 1;
                break;
              }
              throw new Error("No audio element provided to TTSService");
            case 1:
              payload = this.buildPayload({
                voicePresetName: voicePresetName,
                voiceTuning: voiceTuning,
                ssml: ssml,
                text: text
              });
              ttsUrl = this.baseUrl + "/tts";
              _context.n = 2;
              return fetch(ttsUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
              });
            case 2:
              response = _context.v;
              if (response.ok) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return response.text()["catch"](function () {
                _newArrowCheck(this, _this);
                return "";
              }.bind(this));
            case 3:
              txt = _context.v;
              throw new Error("TTS failed: " + response.status + " " + txt.slice(0, 200));
            case 4:
              _context.n = 5;
              return response.blob();
            case 5:
              blob = _context.v;
              if (this.currentBlobUrl) {
                try {
                  URL.revokeObjectURL(this.currentBlobUrl);
                } catch (e) {}
              }
              url = URL.createObjectURL(blob);
              this.currentBlobUrl = url;
              this.audioEl.src = url;

              // fire callback
              onBeforePlayText();
              _context.p = 6;
              _context.n = 7;
              return this.audioEl.play();
            case 7:
              this.isPlaying = true;
              _context.n = 9;
              break;
            case 8:
              _context.p = 8;
              _t = _context.v;
              this.isPlaying = false;
              throw _t;
            case 9:
              return _context.a(2, new Promise(function (resolve) {
                var _this2 = this;
                _newArrowCheck(this, _this);
                this.audioEl.onended = function () {
                  _newArrowCheck(this, _this2);
                  this.isPlaying = false;
                  try {
                    URL.revokeObjectURL(url);
                  } catch (e) {}
                  this.currentBlobUrl = null;
                  resolve();
                }.bind(this);
                this.audioEl.onerror = function () {
                  _newArrowCheck(this, _this2);
                  this.isPlaying = false;
                  try {
                    URL.revokeObjectURL(url);
                  } catch (e) {}
                  this.currentBlobUrl = null;
                  resolve();
                }.bind(this);
              }.bind(this)));
          }
        }, _callee, this, [[6, 8]]);
      }));
      function playText(_x) {
        return _playText.apply(this, arguments);
      }
      return playText;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.audioEl && !this.audioEl.paused) {
                try {
                  this.audioEl.pause();
                  this.audioEl.currentTime = 0;
                } catch (e) {}
              }
              if (this.currentBlobUrl) {
                try {
                  URL.revokeObjectURL(this.currentBlobUrl);
                } catch (e) {}
                this.currentBlobUrl = null;
              }
              this.isPlaying = false;
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }]);
}();

// STTService: wrapper for /stt endpoint
var STTService = /*#__PURE__*/function () {
  function STTService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$baseUrl = _ref.baseUrl,
      baseUrl = _ref$baseUrl === void 0 ? "" : _ref$baseUrl;
    _classCallCheck(this, STTService);
    this.baseUrl = (baseUrl || "").replace(/\/$/, "");
  }
  return _createClass(STTService, [{
    key: "transcribe",
    value: function () {
      var _transcribe = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(blob) {
        var _this = this;
        var _ref2,
          language,
          formData,
          ext,
          sttUrl,
          response,
          txt,
          json,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _ref2 = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, language = _ref2.language;
              formData = new FormData();
              ext = /ogg/i.test(blob.type) ? "ogg" : "webm";
              formData.append("audio", blob, "utterance.".concat(ext));
              if (language) {
                formData.append("language", language);
              }
              sttUrl = this.baseUrl + "/stt";
              _context.n = 1;
              return fetch(sttUrl, {
                method: "POST",
                body: formData
              });
            case 1:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return response.text()["catch"](function () {
                _newArrowCheck(this, _this);
                return "(no body)";
              }.bind(this));
            case 2:
              txt = _context.v;
              throw new Error("STT failed ".concat(response.status, ": ").concat(txt.slice(0, 200)));
            case 3:
              _context.n = 4;
              return response.json()["catch"](function () {
                _newArrowCheck(this, _this);
                return null;
              }.bind(this));
            case 4:
              json = _context.v;
              return _context.a(2, json);
          }
        }, _callee, this);
      }));
      function transcribe(_x) {
        return _transcribe.apply(this, arguments);
      }
      return transcribe;
    }()
  }]);
}();

var _this$b = this;
// import { voicePresets } from './services/voicePresets';

var script$2 = {
  name: "VoiceBridge",
  props: {
    canShowVoiceInterface: {
      type: Boolean,
      "default": false,
      description: "Toggle to enable/disable voice interface"
    },
    incomingMessage: {
      type: String,
      description: "Incoming messages from current conversation"
    },
    isViewNotConversationList: {
      type: Boolean,
      "default": false,
      description: "Toggle to confirm the view is not conversation list view"
    },
    baseUrl: {
      type: String,
      description: "Base url endpoint for tts/stt"
    },
    sttLanguage: {
      type: String,
      description: "The language use for speech transcription for google stt service"
    },
    handleOnAfterTranscribingSpeech: {
      type: Function,
      "default": function _default(params) {
        _newArrowCheck(this, _this$b);
      }.bind(this),
      description: "Trigger after speech transcription from stt"
    },
    handleOnAfterPlayVoice: {
      type: Function,
      "default": function _default(params) {
        _newArrowCheck(this, _this$b);
      }.bind(this),
      description: "Trigger after playing tts"
    },
    handleOnErrorCallback: {
      type: Function,
      "default": function _default(params) {
        _newArrowCheck(this, _this$b);
      }.bind(this),
      description: "Callback function that triggers on error"
    }
  },
  data: function data() {
    return {
      audioConfig: {
        baseUrl: "",
        // https://chatbot-svil.tim.monksoftware.it,
        mimeType: "audio/webm;codecs=opus",
        silenceMs: 500,
        // reduce from 700 to 500ms for more responsiveness
        vadThreshold: 0.025,
        // slightly more sensitive
        minBlobSize: 800,
        // reduce to capture even short messages
        sttLang: "en-US",
        // it-IT,
        interruptTTS: true // pause TTS when speaking
      },
      status: "idle",
      ssmlMode: false,
      voicePresetName: "en_neural_female",
      voiceTuning: {
        rate: 1.00,
        pitch: 0.0
      },
      audioService: null,
      sttService: null,
      ttsService: null,
      audioState: {
        isListening: false,
        inSpeech: false
      },
      ttsState: {
        isPlaying: false
      },
      isMicError: false,
      errorMessage: ""
    };
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, mapGetters$1("xmpp", ["instance"])), mapGetters$1("voiceInterface", ["isVoiceAudioEnabled"])), {}, {
    canShowMicErrorMsg: function canShowMicErrorMsg() {
      return isXmppConnectionActive(this.instance) && this.isViewNotConversationList && this.errorMessage !== "";
    },
    getLabel: function getLabel() {
      return {
        error_response_stt_1: "Sorry, I couldn’t understand that. Please try speaking again.",
        error_response_stt_2: "Sorry, I couldn’t hear that clearly. Let’s try again!",
        error_response_stt_3: "Hmm, I missed that one. Could you repeat it for me?",
        error_response_stt_4: "Hmm, I didn’t catch that. Can you say it one more time?",
        error_response_stt_5: "Sorry! I didn’t quite catch that. Mind saying it again?",
        error_response_stt_6: "Didn’t get that—can you say it one more time?"
      };
    }
  }),
  watch: {
    incomingMessage: {
      handler: function handler(newMessage) {
        var _this2 = this;
        if (newMessage && this.canShowVoiceInterface) {
          console.log("incomingMessage for tts: ", newMessage);
          // console.log("this.canShowVoiceInterface: ", this.canShowVoiceInterface);

          this.playTTS(newMessage, function () {
            _newArrowCheck(this, _this2);
            // disable stt processing
            this.setIsSTTProcessing(false);
          }.bind(this));
        }
      },
      immediate: false
    },
    isVoiceAudioEnabled: {
      handler: function handler(newToggle) {
        var _this3 = this;
        return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                /* console.log(
                  "watcher isVoiceAudioEnabled, canShowVoiceInterface: ",
                  newToggle,
                  this.canShowVoiceInterface,
                ); */
                _this3.handleToggleAudio(newToggle, _this3.canShowVoiceInterface);
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }))();
      },
      immediate: false
    },
    isMicError: function isMicError(newValue) {
      if (!newValue) {
        this.errorMessage = "";
      }

      // on error callback
      this.handleOnErrorCallback({
        isMicError: newValue
      });
    },
    status: function status(newStatus) {
      console.log("Status voice: ", newStatus);
    },
    canShowVoiceInterface: function canShowVoiceInterface(newToggle) {
      console.log("watcher canShowVoiceInterface, isVoiceAudioEnabled: ", newToggle, this.isVoiceAudioEnabled);
      this.handleToggleAudio(this.isVoiceAudioEnabled, newToggle);
    }
  },
  created: function created() {
    // setup configs
    this.setupOtherConfigs();
  },
  mounted: function mounted() {
    // init services
    this.setupServices();
    this.initAudioService();
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions$1("voiceInterface", ["setIsSTTProcessing"])), {}, {
    setupOtherConfigs: function setupOtherConfigs() {
      // setup baseUrl
      if (this.baseUrl) {
        var audioConfiguration = this.audioConfig;
        this.audioConfig = _objectSpread2(_objectSpread2({}, audioConfiguration), {}, {
          baseUrl: this.baseUrl
        });
      }

      // setup sttLang 
      if (this.sttLanguage) {
        var _audioConfiguration = this.audioConfig;
        this.audioConfig = _objectSpread2(_objectSpread2({}, _audioConfiguration), {}, {
          sttLang: this.sttLanguage
        });
      }
    },
    setupServices: function setupServices() {
      var baseUrl = this.audioConfig.baseUrl;

      // setup services
      this.sttService = new STTService({
        baseUrl: baseUrl
      });
      this.ttsService = new TTSService({
        baseUrl: baseUrl,
        audioEl: this.$refs.ttsAudio
      });
    },
    initAudioService: function initAudioService() {
      var _this4 = this;
      if (this.audioService) {
        try {
          this.audioService.stop();
          this.audioService = null;
        } catch (e) {}
      }
      this.audioService = new AudioService({
        cfg: this.audioConfig,
        onSegment: this.handleTranscription,
        onState: function onState(st) {
          _newArrowCheck(this, _this4);
          this.audioState.isListening = st.isListening || false;
          this.audioState.inSpeech = st.inSpeech || false;
          this.status = this.audioState.isListening ? this.ttsState.isPlaying ? "playing TTS..." : "audio ready..." : "stopped";

          // reset mic errors
          this.isMicError = false;
          this.errorMessage = "";
        }.bind(this),
        onError: function onError(err) {
          var _this5 = this;
          _newArrowCheck(this, _this4);
          console.error(err);
          this.status = "mic error: " + (err.message || err);

          // error handling mic
          setTimeout(function () {
            _newArrowCheck(this, _this5);
            this.errorMessage = "The voice feature needs your browsers microphone to work. Please allow your microphone to be use for this app and refresh the chat.";
            this.isMicError = true;
          }.bind(this), 1000);
        }.bind(this)
      });
    },
    handleTranscription: function handleTranscription(blob) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this7 = this;
        var arrayBuffer, magicBytes, sttJson, text, _t, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (blob) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              // enable stt processing
              _this6.setIsSTTProcessing(true);
              if (!(blob.size < (_this6.audioConfig.minBlobSize || 800))) {
                _context2.n = 2;
                break;
              }
              console.log("[VAD] Audio too small, ignoring");
              _this6.status = "audio too small";
              // disable stt processing
              _this6.setIsSTTProcessing(false);
              return _context2.a(2);
            case 2:
              if (!(_this6.ttsState.isPlaying && _this6.audioConfig.interruptTTS)) {
                _context2.n = 3;
                break;
              }
              _context2.n = 3;
              return _this6.stopTtsFromPlaying();
            case 3:
              _context2.p = 3;
              _context2.n = 4;
              return blob.slice(0, 4).arrayBuffer();
            case 4:
              arrayBuffer = _context2.v;
              magicBytes = Array.from(new Uint8Array(arrayBuffer)).map(function (b) {
                _newArrowCheck(this, _this7);
                return b.toString(16).padStart(2, '0');
              }.bind(this)).join('');
              if (!magicBytes.startsWith('43c3')) {
                _context2.n = 5;
                break;
              }
              console.log("[VAD] Corrupted magic bytes detected: ", magicBytes);

              // add audio feedback when error capturing audio
              // this.playTTS(this.getLabel.error_response_stt_1);

              // disable stt processing
              _this6.setIsSTTProcessing(false);
              // Immediate reset
              _this6.resetRecorder();
              return _context2.a(2);
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t = _context2.v;
              console.warn("[VAD] Could not check magic bytes: ", _t);
              // add audio feedback when error capturing audio
              // this.playTTS(this.getLabel.error_response_stt_6);

              // disable stt processing
              _this6.setIsSTTProcessing(false);
            case 7:
              _context2.p = 7;
              _this6.status = "transcribing...";
              _context2.n = 8;
              return _this6.sttService.transcribe(blob, {
                language: _this6.audioConfig.sttLang
              });
            case 8:
              sttJson = _context2.v;
              if (sttJson) {
                _context2.n = 9;
                break;
              }
              _this6.status = "parse error";
              // add audio feedback when error capturing audio
              _this6.playTTS(_this6.getLabel.error_response_stt_1, function () {
                _newArrowCheck(this, _this7);
                // disable stt processing
                _this6.setIsSTTProcessing(false);
              }.bind(this));
              return _context2.a(2);
            case 9:
              if (!(sttJson.error && sttJson.error.includes("Audio validation failed"))) {
                _context2.n = 10;
                break;
              }
              _this6.status = "audio corruption detected, resetting...";
              // add audio feedback when error capturing audio
              _this6.playTTS(_this6.getLabel.error_response_stt_4, function () {
                _newArrowCheck(this, _this7);
                // disable stt processing
                _this6.setIsSTTProcessing(false);
              }.bind(this));
              // reset recorder
              setTimeout(function () {
                _newArrowCheck(this, _this7);
                _this6.resetRecorder();
              }.bind(this), 500);
              return _context2.a(2);
            case 10:
              text = (sttJson.text || "").trim();
              if (!(!text || text.length < 2)) {
                _context2.n = 11;
                break;
              }
              _this6.status = "no speech detected";
              // add audio feedback when error capturing audio
              _this6.playTTS(_this6.getLabel.error_response_stt_3, function () {
                _newArrowCheck(this, _this7);
                // disable stt processing
                _this6.setIsSTTProcessing(false);
              }.bind(this));
              return _context2.a(2);
            case 11:
              if (!(sttJson.is_sandbox === true)) {
                _context2.n = 12;
                break;
              }
              _this6.status = "sandbox mode";
              // add audio feedback when error capturing audio
              _this6.playTTS(_this6.getLabel.error_response_stt_5, function () {
                _newArrowCheck(this, _this7);
                // disable stt processing
                _this6.setIsSTTProcessing(false);
              }.bind(this));
              return _context2.a(2);
            case 12:
              // disable stt processing
              _this6.setIsSTTProcessing(false);
              // fire callback
              _this6.handleOnAfterTranscribingSpeech({
                text: text
              });
              _this6.status = "ready...";
              _context2.n = 14;
              break;
            case 13:
              _context2.p = 13;
              _t2 = _context2.v;
              console.error(_t2);
              // add audio feedback when error capturing audio
              // this.playTTS(this.getLabel.error_response_stt_2);

              // disable stt processing
              _this6.setIsSTTProcessing(false);
              _this6.status = "error: " + (_t2.message || _t2);
            case 14:
              return _context2.a(2);
          }
        }, _callee2, this, [[7, 13], [3, 6]]);
      }))();
    },
    handleToggleAudio: function handleToggleAudio(isVoiceAudioEnabled, canShowVoiceInterface) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(isVoiceAudioEnabled && canShowVoiceInterface)) {
                _context3.n = 2;
                break;
              }
              _context3.n = 1;
              return _this8.enableAudio();
            case 1:
              _context3.n = 3;
              break;
            case 2:
              _context3.n = 3;
              return _this8.disableAudio();
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    resetRecorder: function resetRecorder() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _this9.status = "resetting recorder...";
              _context4.p = 1;
              if (!_this9.audioService) {
                _this9.initAudioService();
              }
              _context4.n = 2;
              return _this9.audioService.reset();
            case 2:
              _this9.status = "ready";
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              _this9.status = "reset failed: " + (_t3.message || _t3);
              console.error(_t3);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 3]]);
      }))();
    },
    enableAudio: function enableAudio() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              console.log("enabling audio...");
              if (!_this0.audioService) {
                _this0.initAudioService();
              }
              _context5.p = 1;
              _this0.status = "requesting mic...";
              _context5.n = 2;
              return _this0.audioService.start();
            case 2:
              _this0.audioState.isListening = true;
              console.log("enabling mic...");
              _this0.status = "mic ready, listening...";
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              _this0.status = "mic error: " + (_t4.message || _t4);
              console.error(_t4);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, null, [[1, 3]]);
      }))();
    },
    disableAudio: function disableAudio() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!(_this1.ttsState.isPlaying && _this1.audioConfig.interruptTTS)) {
                _context6.n = 1;
                break;
              }
              _context6.n = 1;
              return _this1.stopTtsFromPlaying();
            case 1:
              if (_this1.audioService) {
                _this1.audioService.stop();
              }

              // full stop mic
              _this1.audioState.isListening = false;
              _this1.status = "stopped";
              // reset audioService
              _this1.audioService = null;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    stopTtsFromPlaying: function stopTtsFromPlaying() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (!(_this10.ttsState.isPlaying && _this10.ttsService)) {
                _context7.n = 5;
                break;
              }
              _context7.p = 1;
              _context7.n = 2;
              return _this10.ttsService.stop();
            case 2:
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _context7.v;
            case 4:
              _this10.ttsState.isPlaying = false;
              if (_this10.audioService) {
                _this10.audioService.setTtsPlaying(false);
              }
              _this10.status = "TTS interrupted...";
            case 5:
              return _context7.a(2);
          }
        }, _callee7, null, [[1, 3]]);
      }))();
    },
    playTTS: function playTTS(text) {
      var _arguments = arguments,
        _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this12 = this;
        var _onBeforePlayText;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _onBeforePlayText = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : function () {
                _newArrowCheck(this, _this12);
              }.bind(this);
              if (!text) {
                _context8.n = 2;
                break;
              }
              // play TTS
              _this11.ttsState.isPlaying = true;
              if (_this11.audioService) {
                _this11.audioService.setTtsPlaying(true);
              }
              _this11.status = "playing tts...";
              _context8.n = 1;
              return _this11.ttsService.playText({
                text: text,
                voicePresetName: _this11.voicePresetName,
                voiceTuning: _this11.voiceTuning,
                ssml: _this11.ssmlMode,
                onBeforePlayText: function onBeforePlayText() {
                  _newArrowCheck(this, _this12);
                  // fire function callback
                  _onBeforePlayText();
                }.bind(this)
              });
            case 1:
              _this11.ttsState.isPlaying = false;
              if (_this11.audioService) {
                _this11.audioService.setTtsPlaying(false);
              }
              _this11.status = "ready...";
              // fire component callback
              _this11.handleOnAfterPlayVoice(_objectSpread2({
                status: _this11.status
              }, _this11.ttsState));
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }))();
    }
  })
};

/* script */
var __vue_script__$l = script$2;

/* template */
var __vue_render__$l = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "voice-bridge"
  }, [_vm.canShowMicErrorMsg ? [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "error-wrapper"
  }, [_c('el-alert', {
    staticClass: "sticky",
    attrs: {
      "type": "warning",
      "show-icon": "",
      "effect": "dark",
      "closable": true
    }
  }, [_c('div', {
    staticClass: "error-mic",
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  })])], 1)])] : _vm._e(), _vm._v(" "), _c('audio', {
    ref: "ttsAudio",
    attrs: {
      "preload": "auto",
      "hidden": ""
    }
  })], 2);
};
var __vue_staticRenderFns__$l = [];

/* style */
var __vue_inject_styles__$l = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-78bb2d60_0", {
    source: ".error-mic[data-v-78bb2d60]{margin-right:10px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$l = "data-v-78bb2d60";
/* module identifier */
var __vue_module_identifier__$l = undefined;
/* functional template */
var __vue_is_functional_template__$l = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, createInjector, undefined, undefined);

var _dec$j,
  _dec2$i,
  _dec3$e,
  _dec4$c,
  _dec5$b,
  _dec6$8,
  _dec7$7,
  _dec8$5,
  _dec9$5,
  _dec0$5,
  _dec1$4,
  _dec10$3,
  _dec11$3,
  _dec12$3,
  _dec13$3,
  _dec14$3,
  _dec15$3,
  _dec16$3,
  _dec17$3,
  _dec18$3,
  _dec19$3,
  _dec20$3,
  _dec21$3,
  _dec22$3,
  _dec23$3,
  _dec24$3,
  _dec25$3,
  _dec26$3,
  _dec27$2,
  _dec28$2,
  _dec29$2,
  _dec30$2,
  _dec31$2,
  _dec32$1,
  _dec33$1,
  _dec34$1,
  _dec35$1,
  _dec36$1,
  _dec37$1,
  _dec38$1,
  _dec39,
  _dec40,
  _dec41,
  _dec42,
  _dec43,
  _dec44,
  _dec45,
  _dec46,
  _dec47,
  _dec48,
  _dec49,
  _dec50,
  _dec51,
  _dec52,
  _dec53,
  _dec54,
  _dec55,
  _dec56,
  _dec57,
  _dec58,
  _dec59,
  _dec60,
  _dec61,
  _dec62,
  _dec63,
  _dec64,
  _dec65,
  _dec66,
  _dec67,
  _dec68,
  _dec69,
  _dec70,
  _dec71,
  _dec72,
  _dec73,
  _dec74,
  _dec75,
  _dec76,
  _dec77,
  _dec78,
  _dec79,
  _dec80,
  _dec81,
  _dec82,
  _dec83,
  _dec84,
  _dec85,
  _dec86,
  _dec87,
  _dec88,
  _dec89,
  _dec90,
  _dec91,
  _dec92,
  _dec93,
  _dec94,
  _dec95,
  _dec96,
  _dec97,
  _dec98,
  _dec99,
  _dec100,
  _dec101,
  _dec102,
  _dec103,
  _dec104,
  _dec105,
  _dec106,
  _dec107,
  _dec108,
  _dec109,
  _dec110,
  _dec111,
  _dec112,
  _dec113,
  _dec114,
  _dec115,
  _dec116,
  _dec117,
  _dec118,
  _dec119,
  _dec120,
  _dec121,
  _dec122,
  _dec123,
  _dec124,
  _dec125,
  _dec126,
  _dec127,
  _dec128,
  _dec129,
  _dec130,
  _dec131,
  _dec132,
  _dec133,
  _dec134,
  _dec135,
  _this$c = this,
  _class$j,
  _class2$j,
  _descriptor$j,
  _descriptor2$f,
  _descriptor3$c,
  _descriptor4$c,
  _descriptor5$8,
  _descriptor6$7,
  _descriptor7$5,
  _descriptor8$5,
  _descriptor9$5,
  _descriptor0$5,
  _descriptor1$3,
  _descriptor10$3,
  _descriptor11$3,
  _descriptor12$3,
  _descriptor13$3,
  _descriptor14$3,
  _descriptor15$3,
  _descriptor16$3,
  _descriptor17$3,
  _descriptor18$3,
  _descriptor19$3,
  _descriptor20$3,
  _descriptor21$3,
  _descriptor22$3,
  _descriptor23$3,
  _descriptor24$3,
  _descriptor25$2,
  _descriptor26$2,
  _descriptor27$2,
  _descriptor28$1,
  _descriptor29,
  _descriptor30,
  _descriptor31,
  _descriptor32,
  _descriptor33,
  _descriptor34,
  _descriptor35,
  _descriptor36,
  _descriptor37,
  _descriptor38,
  _descriptor39,
  _descriptor40,
  _descriptor41,
  _descriptor42,
  _descriptor43,
  _descriptor44,
  _descriptor45,
  _descriptor46,
  _descriptor47,
  _descriptor48,
  _descriptor49,
  _descriptor50,
  _descriptor51,
  _descriptor52,
  _descriptor53,
  _descriptor54,
  _descriptor55,
  _descriptor56,
  _descriptor57,
  _descriptor58,
  _descriptor59,
  _descriptor60,
  _descriptor61,
  _descriptor62,
  _descriptor63,
  _descriptor64,
  _descriptor65,
  _descriptor66,
  _descriptor67,
  _descriptor68,
  _descriptor69,
  _descriptor70,
  _descriptor71,
  _descriptor72,
  _descriptor73,
  _descriptor74,
  _descriptor75,
  _descriptor76,
  _descriptor77,
  _descriptor78,
  _descriptor79,
  _descriptor80,
  _descriptor81,
  _descriptor82,
  _descriptor83,
  _descriptor84,
  _descriptor85,
  _descriptor86,
  _descriptor87,
  _descriptor88,
  _descriptor89,
  _descriptor90,
  _descriptor91,
  _descriptor92,
  _descriptor93,
  _descriptor94,
  _descriptor95,
  _descriptor96,
  _descriptor97,
  _descriptor98,
  _descriptor99,
  _descriptor100,
  _descriptor101,
  _descriptor102,
  _descriptor103,
  _descriptor104,
  _descriptor105,
  _descriptor106,
  _descriptor107,
  _descriptor108,
  _descriptor109,
  _descriptor110,
  _descriptor111,
  _descriptor112,
  _descriptor113,
  _descriptor114,
  _descriptor115,
  _descriptor116,
  _descriptor117,
  _descriptor118,
  _descriptor119,
  _descriptor120,
  _descriptor121,
  _descriptor122,
  _descriptor123,
  _descriptor124;
var ConversationArea = (_dec$j = Component({
  components: {
    LoginProxy: __vue_component__,
    ConversationsList: __vue_component__$1,
    ChatConversationArea: __vue_component__$g,
    ChatToggle: __vue_component__$j,
    ChatToggleClose: __vue_component__$k,
    VoiceBridge: __vue_component__$l
  }
}), _dec2$i = Prop(String), _dec3$e = Prop(String), _dec4$c = Prop({
  "default": false
}), _dec5$b = Prop({
  "default": false
}), _dec6$8 = Prop({
  "default": false
}), _dec7$7 = Prop({
  "default": false
}), _dec8$5 = Prop(String), _dec9$5 = Prop(String), _dec0$5 = Prop(String), _dec1$4 = Prop({
  "default": 2
}), _dec10$3 = Prop({
  "default": true
}), _dec11$3 = Prop({
  "default": true
}), _dec12$3 = Prop(String), _dec13$3 = Prop({
  "default": 50
}), _dec14$3 = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$c);
  }.bind(this)
}), _dec15$3 = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$c);
  }.bind(this)
}), _dec16$3 = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$c);
  }.bind(this)
}), _dec17$3 = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$c);
  }.bind(this)
}), _dec18$3 = Prop(String), _dec19$3 = Prop(String), _dec20$3 = Prop({
  "default": false
}), _dec21$3 = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$c);
  }.bind(this)
}), _dec22$3 = Prop({
  "default": function _default() {
    _newArrowCheck(this, _this$c);
  }.bind(this)
}), _dec23$3 = Prop(), _dec24$3 = Prop(), _dec25$3 = Prop({
  "default": true
}), _dec26$3 = Prop({
  "default": true
}), _dec27$2 = Prop({
  "default": 0
}), _dec28$2 = Prop({
  "default": false
}), _dec29$2 = Prop({
  "default": true
}), _dec30$2 = Prop({
  "default": false
}), _dec31$2 = Prop({
  "default": false
}), _dec32$1 = Prop(Boolean), _dec33$1 = Prop(String), _dec34$1 = Prop(String), _dec35$1 = Prop(String), _dec36$1 = Prop(String), _dec37$1 = Getter("chat/messages"), _dec38$1 = Getter("chat/resource"), _dec39 = Action$1("chat/setResource"), _dec40 = Getter("chat/isLoggedIn"), _dec41 = Getter("chat/showProxyView"), _dec42 = Getter("xmpp/messages"), _dec43 = Getter("xmpp/instance"), _dec44 = Getter("xmpp/vcard"), _dec45 = Action$1("xmpp/setupXmppConnection"), _dec46 = Action$1("xmpp/updateVCard"), _dec47 = Action$1("xmpp/setIsXmppQueryArchivePagination"), _dec48 = Getter("xmpp/isXmppQueryArchivePagination"), _dec49 = Action$1("xmpp/setShouldForceQueryArchivePagination"), _dec50 = Getter("xmpp/shouldForceQueryArchivePagination"), _dec51 = Action$1("xmpp/setIsXmppQueryArchive"), _dec52 = Getter("xmpp/isXmppQueryArchive"), _dec53 = Action$1("xmpp/setIsXmppQueryArchiveAfter"), _dec54 = Getter("xmpp/isXmppQueryArchiveAfter"), _dec55 = Action$1("xmpp/setXmppMamPagination"), _dec56 = Getter("xmpp/xmppMamPagination"), _dec57 = Action$1("chat/addMessage"), _dec58 = Action$1("chat/addMessageToHistory"), _dec59 = Action$1("chat/setConversationsArray"), _dec60 = Action$1("chat/setCurrentConversationMessages"), _dec61 = Action$1("chat/setCurrentConversationMessagesPagination"), _dec62 = Action$1("chat/setCurrentConversationSupportMessagesPagination"), _dec63 = Action$1("chat/setCurrentConversationPreviousMessages"), _dec64 = Action$1("chat/setCurrentConversationNextMessages"), _dec65 = Action$1("chat/setCurrentConversationPaginationMode"), _dec66 = Action$1("chat/updateConversationClass"), _dec67 = Action$1("chat/updateConversation"), _dec68 = Action$1("chat/pushMessageInCurrentConversation"), _dec69 = Action$1("chat/pushMessageInCurrentConversationPagination"), _dec70 = Action$1("chat/pushMessageInCurrentConversationSupportPagination"), _dec71 = Action$1("chat/prependMessageInCurrentConversation"), _dec72 = Getter("chat/showUserInputArea"), _dec73 = Action$1("chat/toggleUserInputArea"), _dec74 = Action$1("chat/toggleLoginProxyView"), _dec75 = Getter("chat/getCurrentChatMessages"), _dec76 = Getter("chat/getCurrentChatMessagesPagination"), _dec77 = Getter("chat/getCurrentChatSupportMessagesPagination"), _dec78 = Getter("chat/getCurrentConversationPaginationMode"), _dec79 = Action$1("chat/setLoggedInStatus"), _dec80 = Getter("chat/fetchAttachmentsUploaderConfig"), _dec81 = Action$1("chat/setAttachmentsUploaderConfig"), _dec82 = Action$1("chat/pushConversation"), _dec83 = Action$1("chat/setCurrentChat"), _dec84 = Action$1("chat/setModeBeforeSubmit"), _dec85 = Action$1("chat/setVisibilityAfterSubmit"), _dec86 = Getter("chat/getCurrentChat"), _dec87 = Getter("chat/getConversations"), _dec88 = Getter("xmpp/genesysErrorsMap"), _dec89 = Getter("chat/getChatHeaderTitle"), _dec90 = Action$1("chat/setChatHeaderTitle"), _dec91 = Getter("chat/getChatHeaderIcon"), _dec92 = Action$1("chat/setChatHeaderIcon"), _dec93 = Getter("chat/getChatAvatarIcon"), _dec94 = Action$1("chat/setChatAvatarIcon"), _dec95 = Getter("chat/getConversationsCounter"), _dec96 = Action$1("chat/setConversationsCounter"), _dec97 = Action$1("chat/setIsConversationHeaderRawHtml"), _dec98 = Action$1("chat/setTimestampMap"), _dec99 = Action$1("chat/setIsInteractionInsertLocation"), _dec100 = Action$1("chat/setIsLocationModalEnable"), _dec101 = Action$1("chat/setIsInteractionInsertDate"), _dec102 = Action$1("chat/setCurrentDatePickerInfo"), _dec103 = Action$1("chat/setIsInteractionSingleAutocomplete"), _dec104 = Action$1("chat/setIsInteractionMultipleAutocomplete"), _dec105 = Action$1("chat/setCurrentAutocompleteInfo"), _dec106 = Action$1("chat/setCurrentAutocompleteList"), _dec107 = Action$1("chat/setShowRestartChatButton"), _dec108 = Getter("chat/getBotConfigSettings"), _dec109 = Action$1("chat/setBotConfigSettings"), _dec110 = Action$1("voiceInterface/setBaseUrl"), _dec111 = Action$1("voiceInterface/setSttLang"), _dec112 = Action$1("voiceInterface/setIsVoiceInterfaceEnabled"), _dec113 = Action$1("voiceInterface/setIsVoiceAudioEnabled"), _dec114 = Action$1("voiceInterface/setIsMicHasErrors"), _dec115 = Action$1("voiceInterface/setIsSTTProcessing"), _dec116 = Getter("voiceInterface/isVoiceInterfaceEnabled"), _dec117 = Getter("voiceInterface/isSTTProcessing"), _dec118 = Getter("chat/getToggleMetas"), _dec119 = Action$1("chat/setToggleMetas"), _dec120 = Getter("proactivity/isProactivityEnabled"), _dec121 = Getter("proactivity/getProactivitySettingsByPage"), _dec122 = Getter("proactivity/getProactivitySettings"), _dec123 = Getter("proactivity/getProactivitySettingsDefault"), _dec124 = Action$1("proactivity/setProactivitySettingsData"), _dec125 = Action$1("proactivity/setProactivityExpiry"), _dec126 = Watch("xmppInstance"), _dec127 = Watch("messages"), _dec128 = Watch("getCurrentChatMessages", {
  immediate: true
}), _dec129 = Watch("vCard"), _dec130 = Watch("isXmppQueryArchivePagination"), _dec131 = Watch("isXmppQueryArchive"), _dec132 = Watch("isSTTProcessing"), _dec133 = Watch("xmppMessages"), _dec134 = Watch("currentChat"), _dec135 = Watch("alreadyLoggedIn"), _dec$j(_class$j = (_class2$j = /*#__PURE__*/function (_Vue) {
  function ConversationArea() {
    var _this2;
    _classCallCheck(this, ConversationArea);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, ConversationArea, [].concat(args));
    _defineProperty(_this2, "canShowConversationsView", true);
    _defineProperty(_this2, "THREAD_MULTI_CHANNEL_SEPARATOR", "|$|");
    _defineProperty(_this2, "showIsTypingBubble", false);
    _defineProperty(_this2, "ANONYMOUS_LOGIN_KEY", "_al");
    _defineProperty(_this2, "creds", {});
    _defineProperty(_this2, "askBotVCardFlag", void 0);
    _defineProperty(_this2, "autoLoginFlag", void 0);
    _defineProperty(_this2, "xmppReceiver", void 0);
    _defineProperty(_this2, "showLeaveDialog", false);
    _defineProperty(_this2, "sessionInterval", void 0);
    _defineProperty(_this2, "sessionIntervalCycle", 0);
    _defineProperty(_this2, "sessionIntervalCyclesLimit", 1800);
    // 30 minutes
    _defineProperty(_this2, "foregroundNoticeCommand1", "FOREGROUND_CONVERSATION#0001");
    _defineProperty(_this2, "foregroundNoticeCommand2", "FOREGROUND_CONVERSATION#0002");
    _defineProperty(_this2, "btnStartupConversationLabel", "Inizia");
    _defineProperty(_this2, "isChatAreaVisible", false);
    _defineProperty(_this2, "canShowMessageBanner", true);
    _defineProperty(_this2, "messageLoadingBannerContent", "Please hold on. The chat is loading and will be ready for you shortly.");
    // 'Ci sono alcuni problemi di connessione';
    _defineProperty(_this2, "messageXmppConnectionError", "Sorry, we cant establish the chat connection. User is probably unauthorized. Please try again.");
    _defineProperty(_this2, "enhancedChatToggleMeta", {
      showMsgBubble: false
    });
    _defineProperty(_this2, "uniqueVisitorId", "");
    _defineProperty(_this2, "incomingMessage", "");
    /**
     * XMPP props
     */
    _initializerDefineProperty(_this2, "domain", _descriptor$j, _this2);
    _initializerDefineProperty(_this2, "receiver", _descriptor2$f, _this2);
    _initializerDefineProperty(_this2, "enableMultipleConversations", _descriptor3$c, _this2);
    _initializerDefineProperty(_this2, "hideActionMenu", _descriptor4$c, _this2);
    _initializerDefineProperty(_this2, "askBotVcard", _descriptor5$8, _this2);
    _initializerDefineProperty(_this2, "enableXmppAnonymousLogin", _descriptor6$7, _this2);
    _initializerDefineProperty(_this2, "xmppUsername", _descriptor7$5, _this2);
    _initializerDefineProperty(_this2, "xmppPassword", _descriptor8$5, _this2);
    _initializerDefineProperty(_this2, "xmppEndpoint", _descriptor9$5, _this2);
    _initializerDefineProperty(_this2, "eimeVersion", _descriptor0$5, _this2);
    _initializerDefineProperty(_this2, "enableMessagesHistory", _descriptor1$3, _this2);
    _initializerDefineProperty(_this2, "autologin", _descriptor10$3, _this2);
    _initializerDefineProperty(_this2, "contextCode", _descriptor11$3, _this2);
    _initializerDefineProperty(_this2, "lastMessageToDisplayTotal", _descriptor12$3, _this2);
    _initializerDefineProperty(_this2, "attachmentsUploadErrorCallback", _descriptor13$3, _this2);
    _initializerDefineProperty(_this2, "onAfterXmppQueryArchive", _descriptor14$3, _this2);
    _initializerDefineProperty(_this2, "onAfterXmppQueryArchivePagination", _descriptor15$3, _this2);
    _initializerDefineProperty(_this2, "botConfigSettings", _descriptor16$3, _this2);
    /**
     * Voice Interface props
     */
    _initializerDefineProperty(_this2, "voiceInterfaceEndpoint", _descriptor17$3, _this2);
    _initializerDefineProperty(_this2, "sttLanguage", _descriptor18$3, _this2);
    _initializerDefineProperty(_this2, "shouldEnableVoiceInterface", _descriptor19$3, _this2);
    _initializerDefineProperty(_this2, "onAfterTranscribingSpeech", _descriptor20$3, _this2);
    _initializerDefineProperty(_this2, "onFireVoiceInterface", _descriptor21$3, _this2);
    /**
     * Conversations props
     */
    _initializerDefineProperty(_this2, "conversationsTitle", _descriptor22$3, _this2);
    _initializerDefineProperty(_this2, "conversationsBackButton", _descriptor23$3, _this2);
    _initializerDefineProperty(_this2, "allowConversationsFilter", _descriptor24$3, _this2);
    _initializerDefineProperty(_this2, "showChatBackButton", _descriptor25$2, _this2);
    _initializerDefineProperty(_this2, "botResponseDelay", _descriptor26$2, _this2);
    _initializerDefineProperty(_this2, "showChatStartupButton", _descriptor27$2, _this2);
    _initializerDefineProperty(_this2, "showConnectionStatusBanner", _descriptor28$1, _this2);
    _initializerDefineProperty(_this2, "enableUnreadMessagesBadge", _descriptor29, _this2);
    _initializerDefineProperty(_this2, "showChatToggle", _descriptor30, _this2);
    /**
     * UI props
     */
    _initializerDefineProperty(_this2, "showHeader", _descriptor31, _this2);
    _initializerDefineProperty(_this2, "headerTitle", _descriptor32, _this2);
    _initializerDefineProperty(_this2, "headerIcon", _descriptor33, _this2);
    _initializerDefineProperty(_this2, "botAvatarIcon", _descriptor34, _this2);
    _initializerDefineProperty(_this2, "userAvatarIcon", _descriptor35, _this2);
    _initializerDefineProperty(_this2, "messages", _descriptor36, _this2);
    _initializerDefineProperty(_this2, "resource", _descriptor37, _this2);
    _initializerDefineProperty(_this2, "setResource", _descriptor38, _this2);
    _initializerDefineProperty(_this2, "alreadyLoggedIn", _descriptor39, _this2);
    _initializerDefineProperty(_this2, "canShowLoginProxyView", _descriptor40, _this2);
    _initializerDefineProperty(_this2, "xmppMessages", _descriptor41, _this2);
    _initializerDefineProperty(_this2, "xmppInstance", _descriptor42, _this2);
    _initializerDefineProperty(_this2, "vCard", _descriptor43, _this2);
    _initializerDefineProperty(_this2, "setupXmppConnection", _descriptor44, _this2);
    _initializerDefineProperty(_this2, "updateVCard", _descriptor45, _this2);
    _initializerDefineProperty(_this2, "setIsXmppQueryArchivePagination", _descriptor46, _this2);
    _initializerDefineProperty(_this2, "isXmppQueryArchivePagination", _descriptor47, _this2);
    _initializerDefineProperty(_this2, "setShouldForceQueryArchivePagination", _descriptor48, _this2);
    _initializerDefineProperty(_this2, "shouldForceQueryArchivePagination", _descriptor49, _this2);
    _initializerDefineProperty(_this2, "setIsXmppQueryArchive", _descriptor50, _this2);
    _initializerDefineProperty(_this2, "isXmppQueryArchive", _descriptor51, _this2);
    _initializerDefineProperty(_this2, "setIsXmppQueryArchiveAfter", _descriptor52, _this2);
    _initializerDefineProperty(_this2, "isXmppQueryArchiveAfter", _descriptor53, _this2);
    _initializerDefineProperty(_this2, "setXmppMamPagination", _descriptor54, _this2);
    _initializerDefineProperty(_this2, "xmppMamPagination", _descriptor55, _this2);
    _initializerDefineProperty(_this2, "addMessage", _descriptor56, _this2);
    _initializerDefineProperty(_this2, "addMessageToHistory", _descriptor57, _this2);
    _initializerDefineProperty(_this2, "setConversationsArray", _descriptor58, _this2);
    _initializerDefineProperty(_this2, "setCurrentConversationMessages", _descriptor59, _this2);
    _initializerDefineProperty(_this2, "setCurrentConversationMessagesPagination", _descriptor60, _this2);
    _initializerDefineProperty(_this2, "setCurrentConversationSupportMessagesPagination", _descriptor61, _this2);
    _initializerDefineProperty(_this2, "setCurrentConversationPreviousMessages", _descriptor62, _this2);
    _initializerDefineProperty(_this2, "setCurrentConversationNextMessages", _descriptor63, _this2);
    _initializerDefineProperty(_this2, "setCurrentConversationPaginationMode", _descriptor64, _this2);
    _initializerDefineProperty(_this2, "updateConversationClass", _descriptor65, _this2);
    _initializerDefineProperty(_this2, "updateConversation", _descriptor66, _this2);
    _initializerDefineProperty(_this2, "pushMessageInCurrentConversation", _descriptor67, _this2);
    _initializerDefineProperty(_this2, "pushMessageInCurrentConversationPagination", _descriptor68, _this2);
    _initializerDefineProperty(_this2, "pushMessageInCurrentConversationSupportPagination", _descriptor69, _this2);
    _initializerDefineProperty(_this2, "prependMessageInCurrentConversation", _descriptor70, _this2);
    _initializerDefineProperty(_this2, "showUserInputArea", _descriptor71, _this2);
    _initializerDefineProperty(_this2, "toggleUserInputArea", _descriptor72, _this2);
    _initializerDefineProperty(_this2, "toggleLoginProxyView", _descriptor73, _this2);
    _initializerDefineProperty(_this2, "getCurrentChatMessages", _descriptor74, _this2);
    _initializerDefineProperty(_this2, "getCurrentChatMessagesPagination", _descriptor75, _this2);
    _initializerDefineProperty(_this2, "getCurrentChatSupportMessagesPagination", _descriptor76, _this2);
    _initializerDefineProperty(_this2, "getCurrentConversationPaginationMode", _descriptor77, _this2);
    _initializerDefineProperty(_this2, "setLoggedInStatus", _descriptor78, _this2);
    _initializerDefineProperty(_this2, "attachmentsUploaderConfig", _descriptor79, _this2);
    _initializerDefineProperty(_this2, "setAttachmentsUploaderConfig", _descriptor80, _this2);
    _initializerDefineProperty(_this2, "pushConversation", _descriptor81, _this2);
    _initializerDefineProperty(_this2, "setCurrentChat", _descriptor82, _this2);
    _initializerDefineProperty(_this2, "setModeBeforeSubmit", _descriptor83, _this2);
    _initializerDefineProperty(_this2, "setVisibilityAfterSubmit", _descriptor84, _this2);
    _initializerDefineProperty(_this2, "currentChat", _descriptor85, _this2);
    _initializerDefineProperty(_this2, "getConversations", _descriptor86, _this2);
    _initializerDefineProperty(_this2, "genesysNoticeMap", _descriptor87, _this2);
    _initializerDefineProperty(_this2, "getChatHeaderTitle", _descriptor88, _this2);
    _initializerDefineProperty(_this2, "setChatHeaderTitle", _descriptor89, _this2);
    _initializerDefineProperty(_this2, "getChatHeaderIcon", _descriptor90, _this2);
    _initializerDefineProperty(_this2, "setChatHeaderIcon", _descriptor91, _this2);
    _initializerDefineProperty(_this2, "getChatAvatarIcon", _descriptor92, _this2);
    _initializerDefineProperty(_this2, "setChatAvatarIcon", _descriptor93, _this2);
    _initializerDefineProperty(_this2, "getConversationsCounter", _descriptor94, _this2);
    _initializerDefineProperty(_this2, "setConversationsCounter", _descriptor95, _this2);
    _initializerDefineProperty(_this2, "setIsConversationHeaderRawHtml", _descriptor96, _this2);
    _initializerDefineProperty(_this2, "setTimestampMap", _descriptor97, _this2);
    _initializerDefineProperty(_this2, "setIsInteractionInsertLocation", _descriptor98, _this2);
    _initializerDefineProperty(_this2, "setIsLocationModalEnable", _descriptor99, _this2);
    _initializerDefineProperty(_this2, "setIsInteractionInsertDate", _descriptor100, _this2);
    _initializerDefineProperty(_this2, "setCurrentDatePickerInfo", _descriptor101, _this2);
    _initializerDefineProperty(_this2, "setIsInteractionSingleAutocomplete", _descriptor102, _this2);
    _initializerDefineProperty(_this2, "setIsInteractionMultipleAutocomplete", _descriptor103, _this2);
    _initializerDefineProperty(_this2, "setCurrentAutocompleteInfo", _descriptor104, _this2);
    _initializerDefineProperty(_this2, "setCurrentAutocompleteList", _descriptor105, _this2);
    _initializerDefineProperty(_this2, "setShowRestartChatButton", _descriptor106, _this2);
    _initializerDefineProperty(_this2, "getBotConfigSettings", _descriptor107, _this2);
    _initializerDefineProperty(_this2, "setBotConfigSettings", _descriptor108, _this2);
    /** 
     * voiceInterface
     */
    _initializerDefineProperty(_this2, "setVoiceInterfaceBaseUrl", _descriptor109, _this2);
    _initializerDefineProperty(_this2, "setSttLang", _descriptor110, _this2);
    _initializerDefineProperty(_this2, "setIsVoiceInterfaceEnabled", _descriptor111, _this2);
    _initializerDefineProperty(_this2, "setIsVoiceAudioEnabled", _descriptor112, _this2);
    _initializerDefineProperty(_this2, "setIsMicHasErrors", _descriptor113, _this2);
    _initializerDefineProperty(_this2, "setIsSTTProcessing", _descriptor114, _this2);
    _initializerDefineProperty(_this2, "isVoiceInterfaceEnabled", _descriptor115, _this2);
    _initializerDefineProperty(_this2, "isSTTProcessing", _descriptor116, _this2);
    /**
     * proactivity
     */
    _initializerDefineProperty(_this2, "chatToggleMeta", _descriptor117, _this2);
    _initializerDefineProperty(_this2, "setToggleMetas", _descriptor118, _this2);
    _initializerDefineProperty(_this2, "isProactivityEnabled", _descriptor119, _this2);
    _initializerDefineProperty(_this2, "getChatbotProactive", _descriptor120, _this2);
    _initializerDefineProperty(_this2, "getProactivitySettings", _descriptor121, _this2);
    _initializerDefineProperty(_this2, "defaultProactivitySettings", _descriptor122, _this2);
    _initializerDefineProperty(_this2, "setProactivitySettingsData", _descriptor123, _this2);
    _initializerDefineProperty(_this2, "setProactivityExpiry", _descriptor124, _this2);
    return _this2;
  }
  _inherits(ConversationArea, _Vue);
  return _createClass(ConversationArea, [{
    key: "isCurrentConversationPaginationModeForward",
    get: function get() {
      return this.getCurrentConversationPaginationMode === "forward";
    }
  }, {
    key: "isCurrentConversationPaginationModeBackward",
    get: function get() {
      return this.getCurrentConversationPaginationMode === "backward";
    }
  }, {
    key: "canShowConversationArea",
    get: function get() {
      return !this.canShowLoginProxyView && (!this.canShowConversationsView || !this.enableMultipleConversations) && !this.canShowChatToggle;
    }
  }, {
    key: "canShowConversationList",
    get: function get() {
      return !this.canShowLoginProxyView && this.canShowConversationsView && this.enableMultipleConversations && !this.canShowChatToggle;
    }
  }, {
    key: "canShowLogin",
    get: function get() {
      return this.canShowLoginProxyView && !this.alreadyLoggedIn && !this.canShowChatToggle;
    }
  }, {
    key: "canShowChatToggle",
    get: function get() {
      return this.showChatToggle && !this.isChatAreaVisible;
    }
  }, {
    key: "canShowChatToggleClose",
    get: function get() {
      return this.showChatToggle && this.isChatAreaVisible;
    }
  }, {
    key: "conversationAreaClass",
    get: function get() {
      return (this.currentChat.is_archived ? "archived " : "") + this.currentChat["class"];
    }
  }, {
    key: "cannotShowLogin",
    get: function get() {
      return this.autoLoginFlag && !(this.creds.user && this.creds.password && this.creds.host) || !this.autoLoginFlag && !this.autoLoginFlag;
    }
  }, {
    key: "canShowIsTypingBubble",
    get: function get() {
      var currentClass = this.currentChat["class"];
      return this.showIsTypingBubble && currentClass === ConversationType.Wfp;
    }
  }, {
    key: "canShowIsTypingBubbleUser",
    get: function get() {
      var currentClass = this.currentChat["class"];
      return this.isSTTProcessing && currentClass === ConversationType.Wfp;
    }
  }, {
    key: "canShowXmppMessageBanner",
    get: function get() {
      return this.canShowMessageBanner && !isXmppConnectionActive(this.xmppInstance) && this.isChatAreaVisible;
    }
  }, {
    key: "canShowLoginProxy",
    get: function get() {
      return this.enableXmppAnonymousLogin !== true && !this.cannotShowLogin;
    }
  }, {
    key: "canShowVoiceInterface",
    get: function get() {
      return isXmppConnectionActive(this.xmppInstance) && !this.canShowLogin && this.canShowConversationArea && this.shouldEnableVoiceInterface;
    }
  }, {
    key: "getReceiver",
    get: function get() {
      return "".concat(this.xmppReceiver, "@").concat(this.domain);
    }
  }, {
    key: "getLocalUniqueId",
    get: function get() {
      return "_unique_id";
    }
  }, {
    key: "getLocalThread",
    get: function get() {
      return "_t";
    }
  }, {
    key: "getLocalMessageTree",
    get: function get() {
      return "_lmt_".concat(this.resource);
    }
  }, {
    key: "getLocalConversationTree",
    get: function get() {
      return "_lct_".concat(this.resource);
    }
  }, {
    key: "getLocalConversationsCounter",
    get: function get() {
      return "_lcc_".concat(this.resource);
    }
  }, {
    key: "getLocalProactivity",
    get: function get() {
      return "proactivity_".concat(this.resource);
    }
  }, {
    key: "getLocalProactivityExpiry",
    get: function get() {
      return "proactivity_".concat(this.resource, "_expiry");
    }
  }, {
    key: "getLocalLastMessageTimestamp",
    get: function get() {
      return "_last_msg_ts_".concat(this.resource);
    }
  }, {
    key: "getLocalLastMessageMamId",
    get: function get() {
      return "_last_mam_id_".concat(this.resource);
    }
  }, {
    key: "getConversationKey",
    get: function get() {
      return atob(this.headerTitle);
    }
  }, {
    key: "getLastMessageTimeStamp",
    get: function get() {
      return localStorage.getItem(this.getLocalLastMessageTimestamp);
    }
  }, {
    key: "getXmppConnectionLoadingMessage",
    get: function get() {
      var labels = this.getBotConfigSettings.labels;
      if (labels) {
        var label_xmpp_connection_message = labels.label_xmpp_connection_message;
        return label_xmpp_connection_message || this.messageLoadingBannerContent;
      }
      return this.messageLoadingBannerContent;
    }
  }, {
    key: "getXmppConnectionErrorMessage",
    get: function get() {
      var labels = this.getBotConfigSettings.labels;
      if (labels) {
        var label_xmpp_connection_error_message = labels.label_xmpp_connection_error_message;
        return label_xmpp_connection_error_message || this.messageXmppConnectionError;
      }
      return this.messageXmppConnectionError;
    }
  }, {
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this3 = this;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.handleUniqueVisitorId();
            case 1:
              // handle voice interface configurations
              this.handleVoiceInterfaceConfigs();
              // handle client bot configurations
              this.handleBotConfigSettings(this.botConfigSettings);
              // handle credentials
              this.handleCreds();
              // check and set receiver
              this.handleXmppReceiver();
              // check autologin flag
              this.handleAutoLoginFlag();
              // check autologin flag
              this.handleConnectionStatusBannerFlag();
              // check askVCard flag
              this.handleAskVCard();
              EventHub.$on(EventHub.events.sendMessageAction, function (msg) {
                _newArrowCheck(this, _this3);
                return this.sendMessageAction(msg);
              }.bind(this));
              EventHub.$on(EventHub.events.goBackFromConversationsList, function () {
                _newArrowCheck(this, _this3);
                console.log("Catched \"goBackFromConversationsList\" event");
              }.bind(this));
              EventHub.$on(EventHub.events.sessionExpired, function () {
                _newArrowCheck(this, _this3);
                return this.handleXmppConnectionError();
              }.bind(this));
              EventHub.$on(EventHub.events.proactiveBubbleShown, function (status) {
                _newArrowCheck(this, _this3);
                return this.onProactiveBubbleShown(status);
              }.bind(this));
              EventHub.$on(EventHub.events.chatToggleStatus, function (status) {
                _newArrowCheck(this, _this3);
                return this.onChatToggleClicked(status);
              }.bind(this));
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "mounted",
    value: function mounted() {
      console.log("webchatcorewfp v".concat("0.2.42"));

      // handle scroll up handler
      this.handleScrollUpConversation();
    }
  }, {
    key: "beforeMount",
    value: function beforeMount() {
      this.handleLoginProxy();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      EventHub.$off(EventHub.events.sendMessageAction);
      EventHub.$off(EventHub.events.goBackFromConversationsList);
      EventHub.$off(EventHub.events.sessionExpired);
      EventHub.$off(EventHub.events.proactiveBubbleShown);
      EventHub.$off(EventHub.events.chatToggleStatus);
      this.XMPPLogout();
    }
  }, {
    key: "onProactiveBubbleShown",
    value: function onProactiveBubbleShown(status) {
      if (!status) this.chatToggleMeta.proactiveBubbleMessage = "";
      this.setToggleMetas(_objectSpread2(_objectSpread2({}, this.enhancedChatToggleMeta), this.chatToggleMeta));
    }
  }, {
    key: "onChatToggleClicked",
    value: function onChatToggleClicked(status) {
      // hook me
    }
  }, {
    key: "XMPPLogout",
    value: function XMPPLogout() {
      var _this$xmppInstance$co;
      clearInterval(this.sessionInterval);
      this.sessionInterval = null;
      (_this$xmppInstance$co = this.xmppInstance.connection) === null || _this$xmppInstance$co === void 0 ? void 0 : _this$xmppInstance$co.disconnect("logout");
    }
  }, {
    key: "XMPPLogin",
    value: function () {
      var _XMPPLogin = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(credentials) {
        var host, xmppCreds, randomId;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              host = credentials.host;
              xmppCreds = _objectSpread2({}, credentials);
              if (!host) {
                xmppCreds.host = this.xmppEndpoint || process.env.VUE_APP_XMPP_ENDPOINT;
              }
              if (this.uniqueVisitorId) {
                xmppCreds.uniqueVisitorId = this.uniqueVisitorId;
              } else {
                // this is a fallback, a bit redundant,
                // but we need to ensure we get unique id for a visitor
                randomId = Date.now().toString(36);
                xmppCreds.uniqueVisitorId = randomId;
              }
              this.setupXmppConnection(_objectSpread2(_objectSpread2({}, xmppCreds), {}, {
                domain: this.domain
              }));
              // check chat activity
              this.setupConnectionSessionInspector();
              // setup proactivity
              _context2.n = 1;
              return this.setupProactivitySettings();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function XMPPLogin(_x) {
        return _XMPPLogin.apply(this, arguments);
      }
      return XMPPLogin;
    }()
  }, {
    key: "setupProactivitySettings",
    value: function () {
      var _setupProactivitySettings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this4 = this;
        var proactivityData, payload;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              proactivityData = JSON.parse(lsGet(this.getLocalProactivity) || "{}");
              if (!proactivityData) {
                _context3.n = 2;
                break;
              }
              payload = [];
              Object.keys(proactivityData).forEach(function (cc) {
                _newArrowCheck(this, _this4);
                return payload.push(proactivityData[cc]);
              }.bind(this));
              _context3.n = 1;
              return this.setProactivitySettingsData(payload);
            case 1:
              _context3.n = 3;
              break;
            case 2:
              /*
               * remove all proactivity data from localStorage
               * try to revisit logic next time
               */
              this.removeProactivityData();
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function setupProactivitySettings() {
        return _setupProactivitySettings.apply(this, arguments);
      }
      return setupProactivitySettings;
    }()
  }, {
    key: "setupProactivityExpiryLocalStorage",
    value: function () {
      var _setupProactivityExpiryLocalStorage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(proactivitySettings) {
        var proactivityExpiryJSON, proactivityExpiryData;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(localStorage.getItem(this.getLocalProactivityExpiry) === null)) {
                _context4.n = 2;
                break;
              }
              proactivityExpiryJSON = this.getProactivityExpiryData(proactivitySettings);
              _context4.n = 1;
              return this.setProactivityExpiry(proactivityExpiryJSON);
            case 1:
              localStorage.setItem(this.getLocalProactivityExpiry, JSON.stringify(proactivityExpiryJSON));
              _context4.n = 3;
              break;
            case 2:
              proactivityExpiryData = localStorage.getItem(this.getLocalProactivityExpiry);
              this.setProactivityExpiry(JSON.parse(proactivityExpiryData));
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function setupProactivityExpiryLocalStorage(_x2) {
        return _setupProactivityExpiryLocalStorage.apply(this, arguments);
      }
      return setupProactivityExpiryLocalStorage;
    }()
  }, {
    key: "isChoiceSelectionSingleAutoComplete",
    value: function isChoiceSelectionSingleAutoComplete(metas) {
      var limitCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
      return isChoiceSelectionModeSingleAutocomplete(metas, limitCount);
    }
  }, {
    key: "isChoiceSelectionMultipleAutoComplete",
    value: function isChoiceSelectionMultipleAutoComplete(metas) {
      var limitCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
      return isChoiceSelectionModeMultipleAutocomplete(metas, limitCount);
    }
  }, {
    key: "isMamMessagePayloadTextMatched",
    value: function isMamMessagePayloadTextMatched() {
      var currentMsg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var itemMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // currentMsg realtime reply always has a structure of
      // { stanza, payload, ..., key}
      // we only care about stanza and payload
      var currentStanza = currentMsg.stanza,
        currentPayload = currentMsg.payload;
      // while with the item, we only care about the payload
      var payload = itemMsg.payload;
      if (currentStanza && currentPayload && payload) {
        var currentDirection = currentStanza.direction;
        var currentText = currentPayload.text;
        var text = payload.text;
        var isCurrentDirectionOut = currentDirection === "out";

        // we check if direction is out
        // and the current text match the item text
        return isCurrentDirectionOut && currentText && text && currentText.trim() === text.trim();
      } else {
        // otherwise, I dont know
        // in theory, logic should never go here
        // so if goes here, I dont know, what kind message is this
        return false;
      }
    }
  }, {
    key: "isMamMessageExistsOnConversation",
    value: function isMamMessageExistsOnConversation() {
      var _this5 = this;
      var conversation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var currentMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var currentMamId = arguments.length > 2 ? arguments[2] : undefined;
      // check for duplicates
      // confirm if this is enough
      var isMessageExist = conversation.find(function (itemMsg) {
        _newArrowCheck(this, _this5);
        var stanza = itemMsg.stanza;
        if (stanza) {
          // first check, if item has a stanza
          // then we can check the mam id
          var itemMamId = this.getMamIdFromStanza(stanza);
          // sometimes, we can't get a mam id, resulting to empty string
          // some of these messages saved are forwarded messages
          if (itemMamId) {
            return itemMamId === currentMamId;
          } else {
            // so then, resort to comparing the payload text
            return this.isMamMessagePayloadTextMatched(currentMsg, itemMsg);
          }
        } else {
          // 2nd check, if item has no stanza
          // normally, this kind of messages are outgoing replies from webchat user
          // these messages were saved on the fly, so no mam id, no unique identifier
          // so, the only way to check is literally to match the text
          // I dont know about any other way,
          return this.isMamMessagePayloadTextMatched(currentMsg, itemMsg);
        }
      }.bind(this));
      return isMessageExist;
    }
  }, {
    key: "getMamIdFromStanza",
    value: function getMamIdFromStanza(stanza) {
      var mamId = "";
      if (stanza) {
        var rawStanza = stanza.rawStanza;
        mamId = getMamIdFromXML(rawStanza);
      }
      return mamId;
    }
  }, {
    key: "getMamIdFromCurrentMessages",
    value: function getMamIdFromCurrentMessages() {
      var currentChatMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var mamId = "";

      // we need to loop and check if item
      // has actual id, because some messages from realtime conversation
      // were added on the fly and dont have actual mam id yet
      // i.e. (outgoing outgoing messages, welcome messages, etc)
      for (var i = 0; i < currentChatMessages.length; i++) {
        var stanza = currentChatMessages[i].stanza;

        // console.log(`item[${i}]: `, JSON.stringify(currentChatMessages[i]));
        if (stanza) {
          var rawStanza = stanza.rawStanza;
          if (rawStanza) {
            mamId = getMamIdFromXML(rawStanza);
          }

          // only get first item with the mamId
          if (mamId) {
            break;
          }
        }
      }
      return mamId;
    }
  }, {
    key: "getXmppMamPaginationFirstId",
    value: function getXmppMamPaginationFirstId() {
      var currentChatMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var shouldGetIdFromCurrentChatMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var firstIdXmpp = this.xmppMamPagination.firstId;
      var firstId = firstIdXmpp;

      // if from query archive with after tag
      if (shouldGetIdFromCurrentChatMessages) {
        // we need to get the first mam id of the message
        firstId = this.getMamIdFromCurrentMessages(currentChatMessages);

        // reset isXmppQueryArchiveAfter
        this.setIsXmppQueryArchiveAfter(false);
      }
      return firstId;
    }
  }, {
    key: "getXmppMamPaginationLastId",
    value: function getXmppMamPaginationLastId() {
      var currentChatMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var shouldGetIdFromCurrentChatMessages = arguments.length > 1 ? arguments[1] : undefined;
      var lastIdXmpp = this.xmppMamPagination.lastId;
      var lastId = lastIdXmpp;

      // if from query archive with after tag
      if (shouldGetIdFromCurrentChatMessages) {
        // we need to reverse, because we want to start with the last item
        // to get the lastMamId
        var currentChatMessagesReverse = _toConsumableArray(currentChatMessages).reverse();
        lastId = this.getMamIdFromCurrentMessages(currentChatMessagesReverse);
      }
      return lastId;
    }
  }, {
    key: "getProactivityExpiryData",
    value: function getProactivityExpiryData(proactivitySettings) {
      var _this6 = this;
      return proactivitySettings.map(function (item) {
        _newArrowCheck(this, _this6);
        return {
          contextCode: item.contextCode,
          expiryTime: getTimeExpiryByHour(item.proactivityStandbyHours)
        };
      }.bind(this));
    }
  }, {
    key: "getCorrectedConversationMessages",
    value: function getCorrectedConversationMessages() {
      var _this7 = this;
      var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return messages.filter(function (msg) {
        _newArrowCheck(this, _this7);
        return !isMessageAdamService(msg);
      }.bind(this));
    }
  }, {
    key: "removeProactivityData",
    value: function removeProactivityData() {
      localStorage.removeItem(this.getLocalProactivity);
      localStorage.removeItem(this.getLocalProactivityExpiry);
    }
  }, {
    key: "setupConnectionSessionInspector",
    value: function setupConnectionSessionInspector() {
      var _this8 = this;
      var waitFor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
      this.sessionIntervalCycle = 0;
      clearInterval(this.sessionInterval);
      this.sessionInterval = setInterval(function () {
        _newArrowCheck(this, _this8);
        if (this.sessionIntervalCycle < this.sessionIntervalCyclesLimit) {
          this.sessionIntervalCycle++;
        } else {
          this.XMPPLogout();
          console.log("Reached maximum allowed time for this session. I'm logging out...");
        }
      }.bind(this), waitFor);
    }
  }, {
    key: "startupChatCmd",
    value: function startupChatCmd() {
      var msg = {
        type: "chat_text",
        action: "cmd_restart",
        payload: {
          text: this.btnStartupConversationLabel
        }
      };
      this.sendMessageAction(msg);
      this.showChatStartupButton = false;
    }
  }, {
    key: "sendXMPPMessage",
    value: function sendXMPPMessage(content) {
      var message = {
        to: this.getReceiver,
        body: " "
      };
      try {
        // @ts-ignore
        this.xmppInstance.sendMonkMessage(message, content, {
          askReceipt: true
        });
        // this.setupConnectionSessionInspector();
      } catch (err) {
        console.log("Error sending XMPP message: ", err);
      }
    }
  }, {
    key: "sendMessageAction",
    value: function sendMessageAction(msg) {
      if (!msg.hasOwnProperty("stanza")) {
        Object.assign(msg, {
          timestamp: moment().format()
        });
      }
      this.sendXMPPMessage(msg);
      this.storeMessage(msg);
    }
  }, {
    key: "storeMessage",
    value: function storeMessage(msg) {
      var conversationsTree = lsGet(this.getLocalMessageTree) || {};
      var key = getBase64EncodeFromKey(this.getChatHeaderTitle);
      if (!conversationsTree.hasOwnProperty(key)) {
        conversationsTree[key] = [];
      }
      this.pushMessageInCurrentConversation(msg);
      if (msg.hasOwnProperty("stanza") && msg.hasOwnProperty("payload")) {
        delete msg.payload.stanza;
      }
      console.log("storeMessage called...", msg);
      conversationsTree[key].push(msg);
      lsSet(this.getLocalMessageTree, conversationsTree);
    }
  }, {
    key: "closeConversationAction",
    value: function closeConversationAction() {
      this.updateConversationClass({
        thread: this.currentChat.thread,
        newClass: ConversationType.LocalClosed
      });
      EventHub.$emit(EventHub.events.closeConversationEvent, this.currentChat);
      this.showLeaveDialog = false;
    }
  }, {
    key: "archiveConversationAction",
    value: function archiveConversationAction() {
      EventHub.$emit(EventHub.events.archiveConversationEvent, this.currentChat);
      this.showLeaveDialog = false;
    }
  }, {
    key: "toggleUserInputStatus",
    value: function toggleUserInputStatus(status) {
      EventHub.$emit(EventHub.events.enableMainInput, status);
    }
  }, {
    key: "retrieveOlderMessages",
    value: function retrieveOlderMessages() {
      var _this9 = this;
      var mamMessagesCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
      var bot = this.getReceiver;
      var localMessagesTree = lsGet(this.getLocalMessageTree) || {};
      var conversationKey = this.getConversationKey;
      var lastMsgTimestamp = this.getLastMessageTimeStamp;
      if (localMessagesTree && localMessagesTree[conversationKey].length > 0) {
        localMessagesTree.forEach(function (el) {
          _newArrowCheck(this, _this9);
          el = Object.assign({}, el, {
            locallyStored: true
          });
          this.addMessage(el);
        }.bind(this));
      } else {
        this.sendRawMamIqRequest({
          receiver: bot,
          startMsgTimestamp: lastMsgTimestamp,
          max: mamMessagesCount
        });
      }
    }
  }, {
    key: "checkIfChatIsMultiLevel",
    value: function checkIfChatIsMultiLevel(thread) {
      var conversations = [];
      if (!thread) return conversations;
      if (thread.indexOf(this.THREAD_MULTI_CHANNEL_SEPARATOR) !== -1) {
        return thread.split(this.THREAD_MULTI_CHANNEL_SEPARATOR);
      } else {
        return conversations;
      }
    }
  }, {
    key: "filterConversationsMessages",
    value: function filterConversationsMessages(thread, conversationClass, conversationKey, messagesTree) {
      var _this0 = this;
      var localMessageTree = lsGet(this.getLocalMessageTree) || {};
      var localMessages = messagesTree || localMessageTree;
      var enrichedKey = conversationKey || thread;
      var spocKey = getBase64EncodeFromKey();
      var filteredMessages = [];
      if (conversationClass === ConversationType.Wfp && localMessages.hasOwnProperty(spocKey)) {
        console.log("opening conversation spoc");
        filteredMessages = localMessages[spocKey];
      }
      if (enrichedKey !== spocKey && localMessages.hasOwnProperty(enrichedKey)) {
        console.log("opening conversation ".concat(enrichedKey));
        filteredMessages = localMessages[enrichedKey];
      }
      var correctedMessages = _toConsumableArray(this.getCorrectedConversationMessages(filteredMessages));
      // resets
      this.setCurrentConversationMessages(_toConsumableArray(correctedMessages));

      // handle auto scroll down
      setTimeout(function () {
        _newArrowCheck(this, _this0);
        this.onScrollDownConversation();
      }.bind(this), 600);
    }
    /**
     * strophejs ref https://strophe.im/strophejs/doc/1.3.0/files/strophe-js.html#Strophe.xmlHtmlNode
     * @param param {}
     */
  }, {
    key: "sendRawMamIqRequest",
    value: function sendRawMamIqRequest(_ref) {
      var _ref$receiver = _ref.receiver,
        receiver = _ref$receiver === void 0 ? "" : _ref$receiver,
        _ref$beforeMsgId = _ref.beforeMsgId,
        beforeMsgId = _ref$beforeMsgId === void 0 ? "" : _ref$beforeMsgId,
        _ref$afterMsgId = _ref.afterMsgId,
        afterMsgId = _ref$afterMsgId === void 0 ? "" : _ref$afterMsgId,
        _ref$startMsgTimestam = _ref.startMsgTimestamp,
        startMsgTimestamp = _ref$startMsgTimestam === void 0 ? "" : _ref$startMsgTimestam,
        _ref$endMsgTimestamp = _ref.endMsgTimestamp,
        endMsgTimestamp = _ref$endMsgTimestamp === void 0 ? "" : _ref$endMsgTimestamp,
        _ref$max = _ref.max,
        max = _ref$max === void 0 ? 0 : _ref$max,
        _ref$isQueryArchive = _ref.isQueryArchive,
        isQueryArchive = _ref$isQueryArchive === void 0 ? false : _ref$isQueryArchive,
        _ref$isFlipResults = _ref.isFlipResults,
        isFlipResults = _ref$isFlipResults === void 0 ? false : _ref$isFlipResults;
      try {
        // only sendIQ if connection is active
        if (isXmppConnectionActive(this.xmppInstance)) {
          var filtersArr = [];
          var limitsArr = [];
          var otherOptionsArr = [];

          /**
           * MAM ref: https://xmpp.org/extensions/xep-0313.html
           * Filtering by JID
           */
          if (receiver) {
            filtersArr.push("<field var=\"with\">\n              <value>".concat(receiver, "</value>\n            </field>"));
          }

          /**
           * Filtering by time received
           * start
           */
          if (startMsgTimestamp) {
            filtersArr.push("<field var=\"start\">\n              <value>".concat(startMsgTimestamp, "</value>\n            </field>"));
          }
          // end
          if (endMsgTimestamp) {
            filtersArr.push("<field var=\"end\">\n              <value>".concat(endMsgTimestamp, "</value>\n            </field>"));
          }

          /**
           * Pagination
           * before
           */
          if (beforeMsgId) {
            // previous page
            limitsArr.push("<before>".concat(beforeMsgId, "</before>"));
          } else if (beforeMsgId === "") {
            // this is important
            // the empty (<before/>) request the page at the end of the archive (i.e. the most recent messages)
            limitsArr.push("<before/>");
          }
          // after
          if (afterMsgId) {
            limitsArr.push("<after>".concat(afterMsgId, "</after>"));
          }

          // max
          if (max) {
            limitsArr.push("<max>".concat(max, "</max>"));
          }

          // flip page
          if (isFlipResults) {
            otherOptionsArr.push("<flip-page/>");
          }
          var iqMamId = Date.now();
          var iqMamMessage = "<iq\n          xmlns=\"jabber:client\"\n          type=\"set\"\n          id=\"".concat(iqMamId, "\"\n          to=\"").concat(this.xmppInstance.bareJid, "\" \n        >\n          <query queryid=\"query-id-").concat(iqMamId, "\" xmlns=\"urn:xmpp:mam:2\">\n            <x xmlns=\"jabber:x:data\" type=\"submit\">\n              <field var=\"FORM_TYPE\" type=\"hidden\">\n                <value>urn:xmpp:mam:2</value>\n              </field>\n              ").concat(filtersArr.join(""), "\n            </x>\n            <set xmlns=\"http://jabber.org/protocol/rsm\">\n              ").concat(limitsArr.join(""), "\n            </set>\n            ").concat(otherOptionsArr.join(""), "\n          </query>\n        </iq>");
          var iqMamMessageXml = Strophe.xmlHtmlNode(iqMamMessage);
          var iqMamMessageElem = iqMamMessageXml.getElementById(iqMamId.toString());
          // console.log("iqMamMessage: ", iqMamMessageElem);

          if (isQueryArchive) {
            this.setIsXmppQueryArchive(true);
          }
          this.setXmppMamPagination({
            limit: this.lastMessageToDisplayTotal
          });

          // send IQ query to xmpp stream
          this.xmppInstance.connection.sendIQ(iqMamMessageElem);
        } else {
          // handle error connection loss
          // TODO: understand if this is necessary
          // this.handleXmppConnectionError();
        }
      } catch (e) {
        console.error("sendRawMamIqRequest error: ", e);
      }
    }
  }, {
    key: "slsGet",
    value: function slsGet(key) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "object";
      return lsGet(key) || (!type || type === "object" ? {} : []);
    }
  }, {
    key: "sssGet",
    value: function sssGet(key) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "object";
      return ssGet(key) || (!type || type === "object" ? {} : []);
    }
  }, {
    key: "slsSet",
    value: function slsSet(key, value) {
      return lsSet(key, value);
    }
  }, {
    key: "sssSet",
    value: function sssSet(key, value) {
      return ssSet(key, value);
    }
  }, {
    key: "handleUniqueVisitorId",
    value: function () {
      var _handleUniqueVisitorId = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var uniqueVisitorId, visitorId;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              uniqueVisitorId = localStorage.getItem(this.getLocalUniqueId); // if unique identifier available is not available yet
              if (uniqueVisitorId) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return getUniqueVisitorId();
            case 1:
              visitorId = _context5.v;
              this.uniqueVisitorId = visitorId;
              _context5.n = 3;
              break;
            case 2:
              this.uniqueVisitorId = uniqueVisitorId;
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function handleUniqueVisitorId() {
        return _handleUniqueVisitorId.apply(this, arguments);
      }
      return handleUniqueVisitorId;
    }()
  }, {
    key: "handleVoiceInterfaceConfigs",
    value: function handleVoiceInterfaceConfigs() {
      // setup voice interface endpoint
      if (this.voiceInterfaceEndpoint) {
        this.setVoiceInterfaceBaseUrl(this.voiceInterfaceEndpoint);
      }
      // setup sttLanguage
      if (this.sttLanguage) {
        this.setSttLang(this.sttLanguage);
      }
      // setup isVoiceInterfaceEnabled
      if (this.shouldEnableVoiceInterface) {
        this.setIsVoiceInterfaceEnabled(true);
      }
    }
  }, {
    key: "handleBotConfigSettings",
    value: function handleBotConfigSettings() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // config is stringified object
      // so you have to parse it first
      if (config) {
        // console.log("botConfigSettings: ", config);
        this.setBotConfigSettings(_objectSpread2({}, config));
      }
    }
  }, {
    key: "handleCreds",
    value: function handleCreds() {
      lsSet(this.ANONYMOUS_LOGIN_KEY, "");
      var rawStoredCreds = lsGet("_wcue");
      if (rawStoredCreds) {
        var storedCreds = JSON.parse(atob(lsGet("_wcue")));
        this.creds = Object.assign({}, this.creds, {
          user: storedCreds.user,
          password: storedCreds.password
        });
      } else if (this.enableXmppAnonymousLogin !== undefined && this.enableXmppAnonymousLogin !== false) {
        lsSet(this.ANONYMOUS_LOGIN_KEY, true);
      }
    }
  }, {
    key: "handleXmppReceiver",
    value: function handleXmppReceiver() {
      this.xmppReceiver = this.receiver || process.env.VUE_APP_XMPP_RECEIVER;
    }
  }, {
    key: "handleXmppConnectionError",
    value: function handleXmppConnectionError() {
      // do other stuff related to error connection here
      console.error(this.getXmppConnectionErrorMessage);
    }
  }, {
    key: "handleAutoLoginFlag",
    value: function handleAutoLoginFlag() {
      if (this.autologin !== undefined && this.autologin !== false) {
        this.autoLoginFlag = this.autologin;
        if (this.xmppUsername && this.xmppPassword) {
          this.creds = Object.assign({}, this.creds, {
            user: this.xmppUsername,
            password: this.xmppPassword
          });
          this.toggleLoginProxyView(false);
        }
      }
    }
  }, {
    key: "handleConnectionStatusBannerFlag",
    value: function handleConnectionStatusBannerFlag() {
      this.canShowMessageBanner = !!this.showConnectionStatusBanner;
    }
  }, {
    key: "handleAskVCard",
    value: function handleAskVCard() {
      if (this.askBotVcard !== undefined) {
        this.askBotVCardFlag = this.askBotVcard;
      } else if (process.env.VUE_APP_ASK_BOT_VCARD === "yes") {
        this.askBotVCardFlag = true;
      }
    }
  }, {
    key: "handleLoginProxy",
    value: function handleLoginProxy() {
      this.toggleLoginProxyView(this.canShowLoginProxy);
      this.isChatAreaVisible = !this.canShowLoginProxy && !this.showChatToggle;
      if (!this.canShowLoginProxyView && this.autoLoginFlag) {
        this.XMPPLogin(this.creds);
      } else {
        this.setLoggedInStatus(!!lsGet("_wcue"));
        this.toggleUserInputArea(!!lsGet("_wcue"));
      }
    }
  }, {
    key: "handleShowChatArea",
    value: function handleShowChatArea() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isChatAreaVisible = show;
      this.setToggleMetas(_objectSpread2(_objectSpread2({}, this.chatToggleMeta), {}, {
        proactiveBubbleMessage: ""
      }));
    }
  }, {
    key: "handleNotice",
    value: function handleNotice(incomingMessage) {
      var _this1 = this;
      // @ts-ignore
      var type = incomingMessage.type,
        payload = incomingMessage.payload,
        stanza = incomingMessage.stanza;
      if (payload) {
        // @ts-ignore
        var code = payload.code;
        var isNotice = type === "chat_notice" && code;
        var isMamMessage = stanza.rawStanza.indexOf('<result id="') !== -1;
        if (isNotice && !isMamMessage) {
          // @ts-ignore
          switch (code) {
            case this.foregroundNoticeCommand1:
            case this.foregroundNoticeCommand2:
              // @ts-ignore
              var rawThread = stanza.thread.split(this.THREAD_MULTI_CHANNEL_SEPARATOR);
              // avoid wrong thread issue
              var thread = "".concat(rawThread[0]).concat(this.THREAD_MULTI_CHANNEL_SEPARATOR).concat(rawThread[1]);
              var localConversationsTree = lsGet(this.getLocalConversationTree) || [];
              var title = payload.data.chatTitle;
              // @ts-ignore
              if (code === this.foregroundNoticeCommand1) {
                var id = "".concat(thread, "__").concat(Date.now());
                this.setCurrentChat({
                  title: title,
                  thread: thread,
                  "class": "active",
                  id: id
                });

                // initialize
                var localMessagesTree = lsGet(this.getLocalMessageTree);
                if (localMessagesTree) {
                  // initialized to empty array
                  localMessagesTree[thread] = [];
                  var localMessageConversation = localMessagesTree[thread];

                  // update localStorage
                  lsSet(this.getLocalMessageTree, localMessagesTree);

                  // reset local stores
                  this.setCurrentConversationMessages(_toConsumableArray(localMessageConversation));
                }
              } else {
                // @ts-ignore
                var match = localConversationsTree.find(function (lc) {
                  _newArrowCheck(this, _this1);
                  return lc.thread === thread || lc.thread === stanza.thread && lc["class"] === ConversationType.Active;
                }.bind(this));
                if (!match) {
                  // @ts-ignore
                  match = this.getConversations.find(function (lc) {
                    _newArrowCheck(this, _this1);
                    return lc.thread === thread || lc.thread === stanza.thread && lc["class"] === ConversationType.Active;
                  }.bind(this));
                }
                if (match) {
                  this.setCurrentChat(match);
                  var localMessages = lsGet(this.getLocalMessageTree);
                  this.filterConversationsMessages("", "active", match.id, localMessages);
                }
              }
              break;
          }
        }
      }
    }
  }, {
    key: "handleUnreadMessages",
    value: function handleUnreadMessages(thread) {
      if (thread) {
        var conversationsCounter = _objectSpread2({}, this.getConversationsCounter);
        if (!conversationsCounter.hasOwnProperty(thread)) {
          // if no thread yet, create it
          conversationsCounter[thread] = {
            unread_msg_count: 0
          };
        }
        var unread_msg_count = conversationsCounter[thread].unread_msg_count;
        // update unread count
        conversationsCounter[thread].unread_msg_count = unread_msg_count + 1;
        // realign store
        this.setConversationsCounter(conversationsCounter);
        // realign localStorage
        lsSet(this.getLocalConversationsCounter, conversationsCounter);
      }
    }
  }, {
    key: "handleAutoScrollIntoView",
    value: function handleAutoScrollIntoView() {
      var previousMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      // handle auto scroll
      var _previousMessages$sli = previousMessages.slice(-1),
        _previousMessages$sli2 = _slicedToArray(_previousMessages$sli, 1),
        lastMessage = _previousMessages$sli2[0];
      if (lastMessage) {
        var elementId = getStanzaItemId(lastMessage);
        this.handleScrollIntoView(elementId);
      }
    }
  }, {
    key: "handleDisplayPreviousSupportMessages",
    value: function handleDisplayPreviousSupportMessages() {
      var localMessageTree = lsGet(this.getLocalMessageTree) || {};
      for (var _i = 0, _Object$entries = Object.entries(this.getCurrentChatSupportMessagesPagination); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          thread = _Object$entries$_i[0],
          messages = _Object$entries$_i[1];
        // create if thread do not exist
        if (!localMessageTree.hasOwnProperty(thread)) {
          localMessageTree[thread] = [];
        }
        var currentMessages = _toConsumableArray(localMessageTree[thread]);
        // prepend the pagination results
        localMessageTree[thread] = [].concat(_toConsumableArray(messages), _toConsumableArray(currentMessages));
      }
      // update local storage localMessageTree
      lsSet(this.getLocalMessageTree, localMessageTree);
    }
  }, {
    key: "handleDisplayPreviousSpocMessages",
    value: function handleDisplayPreviousSpocMessages() {
      var _this10 = this;
      // check if not empty
      if (this.getCurrentChatMessagesPagination.length > 0) {
        var localMessageTree = lsGet(this.getLocalMessageTree) || {};
        var currentThread = lsGet(this.getLocalThread) || "";
        if (currentThread && localMessageTree.hasOwnProperty(currentThread)) {
          var previousMessages = _toConsumableArray(this.getCurrentChatMessagesPagination);

          // sort conversation messages by timestamp
          var sortedMessages = previousMessages.sort(function (firstItem, secondItem) {
            _newArrowCheck(this, _this10);
            return new Date(firstItem.stanza.timestamp).getTime() - new Date(secondItem.stanza.timestamp).getTime();
          }.bind(this));

          // console.log("sortedMessagesPagination: ", JSON.stringify(sortedMessages));

          if (sortedMessages.length > 0) {
            var currentMessages = localMessageTree[currentThread];

            // realign localStorage
            localMessageTree[currentThread] = [].concat(_toConsumableArray(sortedMessages), _toConsumableArray(currentMessages));

            // prepend previous conversation to currentConversationMessages
            this.setCurrentConversationPreviousMessages(sortedMessages);
            // update local storage localMessageTree
            lsSet(this.getLocalMessageTree, localMessageTree);
          }
        }
      } else {
        console.log("no more results...");
      }
    }
  }, {
    key: "handleDisplayPreviousMessages",
    value: function handleDisplayPreviousMessages() {
      // display spoc messages
      this.handleDisplayPreviousSpocMessages();
      // display support messages
      this.handleDisplayPreviousSupportMessages();
    }
  }, {
    key: "handleDisplayNextMessages",
    value: function handleDisplayNextMessages() {
      var _this11 = this;
      // check if not empty
      if (this.getCurrentChatMessagesPagination.length > 0) {
        var localMessageTree = lsGet(this.getLocalMessageTree) || {};
        var currentThread = lsGet(this.getLocalThread) || "";
        if (currentThread && localMessageTree.hasOwnProperty(currentThread)) {
          var nextMessages = _toConsumableArray(this.getCurrentChatMessagesPagination);

          // sort conversation messages by timestamp
          var sortedMessages = nextMessages.sort(function (firstItem, secondItem) {
            _newArrowCheck(this, _this11);
            return new Date(secondItem.stanza.timestamp).getTime() - new Date(firstItem.stanza.timestamp).getTime();
          }.bind(this));

          // console.log("sortedMessagesPagination: ", JSON.stringify(sortedMessages));

          if (sortedMessages.length > 0) {
            // if results is more than 10
            if (sortedMessages.length >= this.lastMessageToDisplayTotal) {
              console.log("conversation message has been aligned with only pagination result...");
              // realign localStorage
              localMessageTree[currentThread] = _toConsumableArray(sortedMessages);
              // set next conversation to currentConversationMessages
              this.setCurrentConversationMessages(_toConsumableArray(sortedMessages));
            } else {
              console.log("conversation message has been aligned with part of previous and pagination result...");
              var previousStagedMessages = _toConsumableArray(localMessageTree[currentThread]);
              // first, only get the difference between
              // lastMessageToDisplayTotal and pagination messages length
              var sliceCount = this.lastMessageToDisplayTotal - sortedMessages.length;
              // then, lets start from the end of the array
              // and only extract items based on -sliceCount
              var previousMessages = previousStagedMessages.slice(-sliceCount);

              // realign localStorage
              localMessageTree[currentThread] = [].concat(_toConsumableArray(previousMessages), _toConsumableArray(sortedMessages));

              // set next conversation to currentConversationMessages
              this.setCurrentConversationMessages(_toConsumableArray(localMessageTree[currentThread]));
            }

            // update local storage localMessageTree
            lsSet(this.getLocalMessageTree, localMessageTree);
            // after appending the next messages pagination
            // handle auto scroll down
            setTimeout(function () {
              _newArrowCheck(this, _this11);
              this.onScrollDownConversation();
            }.bind(this), 600);
          }
        }
      } else {
        console.log("no more next results...");
      }
    }
  }, {
    key: "handleFetchPreviousMessages",
    value: function handleFetchPreviousMessages() {
      // only trigger pagination query 
      // if the previous operation query is completed
      // and isCurrentConversationPaginationModeForward
      if (!this.isXmppQueryArchivePagination && this.isCurrentConversationPaginationModeForward) {
        var limit = this.xmppMamPagination.limit;
        var firstId = this.getXmppMamPaginationFirstId(this.getCurrentChatMessages, this.isXmppQueryArchiveAfter);
        if (firstId) {
          console.log("fetching previous bot conversation...");

          // specifically set the pagination mode to backward
          this.setCurrentConversationPaginationMode("backward");
          this.setIsXmppQueryArchivePagination(true);
          // handle fetching from mam query pagination
          this.sendRawMamIqRequest({
            receiver: this.getReceiver,
            beforeMsgId: firstId,
            max: limit,
            isFlipResults: false
          });
        } else {
          // resets
          this.setShouldForceQueryArchivePagination(false);
          this.setIsXmppQueryArchivePagination(false);
          console.log("no more messages...");
        }
      }
    }
  }, {
    key: "handleFetchNextMessages",
    value: function handleFetchNextMessages() {
      var lastMamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      // only trigger pagination query 
      // if the previous operation query is completed
      // and shouldForceQueryArchivePagination
      if (this.shouldForceQueryArchivePagination) {
        var lastId = lastMamId || lsGet(this.getLocalLastMessageMamId);
        if (lastId) {
          console.log("fetching next bot conversation...");

          // specifically set the pagination mode to forward
          this.setCurrentConversationPaginationMode("forward");
          // set flag isXmppQueryArchiveAfter to true
          this.setIsXmppQueryArchiveAfter(true);
          this.setIsXmppQueryArchivePagination(true);
          // handle fetching from mam query pagination
          this.sendRawMamIqRequest({
            receiver: this.getReceiver,
            beforeMsgId: false,
            afterMsgId: lastId,
            // max: this.lastMessageToDisplayTotal,
            isFlipResults: false
          });
        } else {
          // resets
          this.setIsXmppQueryArchiveAfter(false);
          this.setIsXmppQueryArchivePagination(false);
          this.setShouldForceQueryArchivePagination(false);
          console.log("no more next messages...");
        }
      }
    }
  }, {
    key: "handleOnRestartChat",
    value: function handleOnRestartChat() {
      // this function is a placeholder and is overiden
      // by actual call from inside client wrapper
      // DO NOT delete
      // i.e. wfp-client
      console.log("core handleOnRestartChat...");
    }
  }, {
    key: "resetUnreadMessagesCount",
    value: function resetUnreadMessagesCount(thread) {
      EventHub.$emit(EventHub.events.resetUnreadMessagesCount, thread);
    }
    /**
     * Watchers methods
     */
  }, {
    key: "onAskVCardAction",
    value: (function () {
      var _onAskVCardAction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this12 = this;
        var defaultVCardErrorMessage, bot, infos, currentBuddy;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              defaultVCardErrorMessage = {
                info: {
                  defaultMessage: "Spiacente, ma al momento non posso rispondere"
                }
              };
              bot = this.getReceiver; // @ts-ignore
              _context6.n = 1;
              return this.xmppInstance.getBuddyInfo(bot);
            case 1:
              infos = _context6.v;
              if (infos) {
                currentBuddy = infos.items.find(function (buddy) {
                  _newArrowCheck(this, _this12);
                  return buddy.address === process.env.XMPP_THREAD;
                }.bind(this));
                this.updateVCard(currentBuddy || defaultVCardErrorMessage);
              } else {
                console.warn("There was an error getting VCard info...");
                this.updateVCard(defaultVCardErrorMessage);
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function onAskVCardAction() {
        return _onAskVCardAction.apply(this, arguments);
      }
      return onAskVCardAction;
    }())
  }, {
    key: "onShowWelcomeMessage",
    value: function onShowWelcomeMessage(vCard) {
      var localMessagesTree = lsGet(this.getLocalMessageTree) || {};
      var conversationKey = this.getConversationKey;
      if (vCard.info && vCard.info.defaultMessage && localMessagesTree[conversationKey].length <= 0) {
        var message = {
          stanza: {
            direction: "in"
          },
          content: [{
            type: "chat_text",
            text: vCard.info.defaultMessage
          }]
        };
        console.log("onShowWelcomeMessage...", message);
        // this.messages.push(message);
        this.addMessage(message);
      }
    }
  }, {
    key: "onFillOutMessagesList",
    value: function onFillOutMessagesList(incomingMessage) {
      this.handleNotice(incomingMessage);
      this.storeMessage(incomingMessage);
    }
  }, {
    key: "handleOnAfterTranscribingSpeech",
    value: function handleOnAfterTranscribingSpeech(params) {
      if (params) {
        this.onAfterTranscribingSpeech(params);
      }
    }
  }, {
    key: "handleOnErrorCallback",
    value: function handleOnErrorCallback(params) {
      if (params) {
        var isMicError = params.isMicError;
        console.log("onErrorCallback isMicError: ", !!isMicError);
        this.setIsMicHasErrors(!!isMicError);
      }
    }
  }, {
    key: "handleOnAfterPlayVoice",
    value: function handleOnAfterPlayVoice(params) {
      if (params) {
        console.log("handleOnAfterPlayVoice...", params);
      }
    }
  }, {
    key: "handleAudioTextToSpeech",
    value: function handleAudioTextToSpeech(text) {
      if (text) {
        this.incomingMessage = text;
      }
    }
  }, {
    key: "handleScrollUpConversation",
    value: function handleScrollUpConversation() {
      var _this13 = this;
      var chatAreaElem = document.querySelector("#chat-area-wrapper");
      if (chatAreaElem) {
        chatAreaElem.addEventListener("scroll", function () {
          var _this14 = this;
          _newArrowCheck(this, _this13);
          if (chatAreaElem.scrollTop === 0) {
            var currentClass = this.currentChat["class"];

            // paginate spoc conversation
            if (currentClass === ConversationType.Wfp) {
              setTimeout(function () {
                _newArrowCheck(this, _this14);
                // handle fetch
                this.handleFetchPreviousMessages();
              }.bind(this), 300);
            }
          }
        }.bind(this));
      }
    }
  }, {
    key: "handleScrollVerticalConversation",
    value: function handleScrollVerticalConversation(elementWrapper) {
      var _this15 = this;
      var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 150;
      if (elementWrapper) {
        setTimeout(function () {
          _newArrowCheck(this, _this15);
          elementWrapper.scroll({
            top: top,
            left: 0,
            behavior: "smooth"
          });
        }.bind(this), delay);
      }
    }
  }, {
    key: "handleScrollIntoView",
    value: function handleScrollIntoView() {
      var _this16 = this;
      var elementId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      if (elementId) {
        setTimeout(function () {
          _newArrowCheck(this, _this16);
          var element = document.getElementById(elementId);
          console.log("scrollIntoView: ", elementId);
          element.scrollIntoView({
            block: "center",
            behavior: "smooth"
          });
        }.bind(this), 300);
      }
    }
  }, {
    key: "onScrollDownConversation",
    value: function onScrollDownConversation() {
      var scrollToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (!this.canShowConversationsView) {
        var chatAreaElem = document.getElementById("chat-area-wrapper");
        var scrollHeight = scrollToTop || chatAreaElem.firstChild.offsetHeight;
        this.handleScrollVerticalConversation(chatAreaElem, scrollHeight);
      }
    }
  }, {
    key: "askVCardAction",
    value: function () {
      var _askVCardAction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(newXmppInstance) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!this.resource) {
                this.setResource(ssGet("resource"));
              }
              this.setLoggedInStatus(true);
              if (!this.askBotVCardFlag) {
                _context7.n = 1;
                break;
              }
              _context7.n = 1;
              return this.onAskVCardAction();
            case 1:
              if (this.enableMessagesHistory && !this.showChatStartupButton) {
                this.retrieveOlderMessages();
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function askVCardAction(_x3) {
        return _askVCardAction.apply(this, arguments);
      }
      return askVCardAction;
    }()
  }, {
    key: "showChatMessages",
    value: function showChatMessages(message) {
      // console.log("watcher message: ", JSON.stringify(message));
    }
  }, {
    key: "updateCurrentConversation",
    value: function updateCurrentConversation(messagesArray) {
      var _this17 = this;
      if (messagesArray && messagesArray.length && messagesArray[0]) {
        var _messagesArray$, _messagesArray$2, _messagesArray$3, _messagesArray$3$payl;
        if (((_messagesArray$ = messagesArray[0]) === null || _messagesArray$ === void 0 ? void 0 : _messagesArray$.type) === "chat_notice" && (_messagesArray$2 = messagesArray[0]) !== null && _messagesArray$2 !== void 0 && _messagesArray$2.payload && ((_messagesArray$3 = messagesArray[0]) === null || _messagesArray$3 === void 0 ? void 0 : (_messagesArray$3$payl = _messagesArray$3.payload) === null || _messagesArray$3$payl === void 0 ? void 0 : _messagesArray$3$payl.code.indexOf("GENESYS#")) !== -1) {
          delete messagesArray[0];
          messagesArray = messagesArray.filter(function (obj) {
            _newArrowCheck(this, _this17);
            return !!obj;
          }.bind(this));
        }
      }
      // console.log("watcher getCurrentChatMessages...", JSON.stringify(messagesArray));
    }
  }, {
    key: "showWelcomeMessage",
    value: function showWelcomeMessage(vCard) {
      this.onShowWelcomeMessage(vCard);
    }
  }, {
    key: "handleIsXmppQueryArchivePagination",
    value: function handleIsXmppQueryArchivePagination(toggle) {
      if (!toggle) {
        console.log("mam query pagination completed: ", toggle);
        // console.log("xmppMamPagination: ", JSON.stringify(this.xmppMamPagination));

        if (this.isCurrentConversationPaginationModeForward) {
          // pagination is forward
          // display next pagination results
          this.handleDisplayNextMessages();

          // reset staging currentConversationMessagesPagination
          this.setCurrentConversationMessagesPagination([]);
          // reset staging currentConversationSupportMessagesPagination
          this.setCurrentConversationSupportMessagesPagination({});
          // reset pagination mode to forward by default
          this.setCurrentConversationPaginationMode("forward");
          // handle callback
          this.onAfterXmppQueryArchivePagination();
          // special callback to handle voice interface
          if (this.onFireVoiceInterface) {
            this.onFireVoiceInterface();
          }
        } else if (this.isCurrentConversationPaginationModeBackward) {
          // pagination is backward
          // display previous pagination results
          this.handleDisplayPreviousMessages();

          // reset staging currentConversationMessagesPagination
          this.setCurrentConversationMessagesPagination([]);
          // reset staging currentConversationSupportMessagesPagination
          this.setCurrentConversationSupportMessagesPagination({});
          // reset pagination mode to forward by default
          this.setCurrentConversationPaginationMode("forward");
          // handle callback
          this.onAfterXmppQueryArchivePagination();
        }
      }
    }
  }, {
    key: "handleIsXmppQueryArchive",
    value: function handleIsXmppQueryArchive(toggle) {
      if (!toggle) {
        console.log("mam query completed...");
        // console.log("xmppMamPagination: ", JSON.stringify(this.xmppMamPagination));

        // callback
        this.onAfterXmppQueryArchive();
        // special callback to handle voice interface
        if (this.onFireVoiceInterface) {
          this.onFireVoiceInterface();
        }
        // scroll down
        this.onScrollDownConversation();
      }
    }
  }, {
    key: "handleIsSTTProcessing",
    value: function handleIsSTTProcessing(toggle) {
      if (toggle) {
        // scroll down
        this.onScrollDownConversation();
      }
    }
  }, {
    key: "fillOutMessagesList",
    value: function fillOutMessagesList(msg) {
      var _this18 = this;
      var botResponseDelayMs = 0;
      if (msg.hasOwnProperty("payload") && msg.payload.hasOwnProperty("content")) {
        // @ts-ignore
        var lastMsg = msg.payload.content[msg.payload.content.length - 1];
        var lastMsgContentKey = Object.keys(lastMsg).find(function (k) {
          _newArrowCheck(this, _this18);
          return k !== "type";
        }.bind(this));
        var lastMsgContent = lastMsg[lastMsgContentKey] || "";
        /**
         * @description: If botResponseDelay === 'adaptive' then assign a more-real response time, based on answer's length
         *               Obviously you need to have a good internet connection as well!
         */
        if (this.botResponseDelay !== undefined && this.botResponseDelay === "adaptive") {
          botResponseDelayMs = lastMsgContent.length * 100;
        }
      }
      /**
       * @description: If botResponseDelay is a number then use this value as the response time.
       *               Obviously you need to have a good internet connection as well!
       */
      if (this.botResponseDelay !== undefined && typeof this.botResponseDelay === "number") {
        botResponseDelayMs = this.botResponseDelay;
      }
      if (typeof botResponseDelayMs === "number" && botResponseDelayMs > 0) {
        this.showIsTypingBubble = true;
      }
      setTimeout(function () {
        _newArrowCheck(this, _this18);
        this.showIsTypingBubble = false;
        this.onFillOutMessagesList(msg);
      }.bind(this), botResponseDelayMs);
    }
  }, {
    key: "renderCurrentConversation",
    value: function renderCurrentConversation(conversation) {
      try {
        this.canShowConversationsView = this.enableMultipleConversations && conversation && Object.entries(conversation).length === 0;
      } catch (err) {
        this.canShowConversationsView = false;
      }
    }
  }, {
    key: "toggleLoggedInStatus",
    value: function toggleLoggedInStatus(status) {
      this.toggleUserInputArea(status);
    }
  }]);
}(Vue$2), _descriptor$j = _applyDecoratedDescriptor(_class2$j.prototype, "domain", [_dec2$i], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2$f = _applyDecoratedDescriptor(_class2$j.prototype, "receiver", [_dec3$e], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3$c = _applyDecoratedDescriptor(_class2$j.prototype, "enableMultipleConversations", [_dec4$c], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4$c = _applyDecoratedDescriptor(_class2$j.prototype, "hideActionMenu", [_dec5$b], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5$8 = _applyDecoratedDescriptor(_class2$j.prototype, "askBotVcard", [_dec6$8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6$7 = _applyDecoratedDescriptor(_class2$j.prototype, "enableXmppAnonymousLogin", [_dec7$7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7$5 = _applyDecoratedDescriptor(_class2$j.prototype, "xmppUsername", [_dec8$5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8$5 = _applyDecoratedDescriptor(_class2$j.prototype, "xmppPassword", [_dec9$5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9$5 = _applyDecoratedDescriptor(_class2$j.prototype, "xmppEndpoint", [_dec0$5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0$5 = _applyDecoratedDescriptor(_class2$j.prototype, "eimeVersion", [_dec1$4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1$3 = _applyDecoratedDescriptor(_class2$j.prototype, "enableMessagesHistory", [_dec10$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10$3 = _applyDecoratedDescriptor(_class2$j.prototype, "autologin", [_dec11$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11$3 = _applyDecoratedDescriptor(_class2$j.prototype, "contextCode", [_dec12$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12$3 = _applyDecoratedDescriptor(_class2$j.prototype, "lastMessageToDisplayTotal", [_dec13$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13$3 = _applyDecoratedDescriptor(_class2$j.prototype, "attachmentsUploadErrorCallback", [_dec14$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14$3 = _applyDecoratedDescriptor(_class2$j.prototype, "onAfterXmppQueryArchive", [_dec15$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15$3 = _applyDecoratedDescriptor(_class2$j.prototype, "onAfterXmppQueryArchivePagination", [_dec16$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16$3 = _applyDecoratedDescriptor(_class2$j.prototype, "botConfigSettings", [_dec17$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17$3 = _applyDecoratedDescriptor(_class2$j.prototype, "voiceInterfaceEndpoint", [_dec18$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18$3 = _applyDecoratedDescriptor(_class2$j.prototype, "sttLanguage", [_dec19$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19$3 = _applyDecoratedDescriptor(_class2$j.prototype, "shouldEnableVoiceInterface", [_dec20$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20$3 = _applyDecoratedDescriptor(_class2$j.prototype, "onAfterTranscribingSpeech", [_dec21$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21$3 = _applyDecoratedDescriptor(_class2$j.prototype, "onFireVoiceInterface", [_dec22$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22$3 = _applyDecoratedDescriptor(_class2$j.prototype, "conversationsTitle", [_dec23$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23$3 = _applyDecoratedDescriptor(_class2$j.prototype, "conversationsBackButton", [_dec24$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24$3 = _applyDecoratedDescriptor(_class2$j.prototype, "allowConversationsFilter", [_dec25$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25$2 = _applyDecoratedDescriptor(_class2$j.prototype, "showChatBackButton", [_dec26$3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26$2 = _applyDecoratedDescriptor(_class2$j.prototype, "botResponseDelay", [_dec27$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27$2 = _applyDecoratedDescriptor(_class2$j.prototype, "showChatStartupButton", [_dec28$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28$1 = _applyDecoratedDescriptor(_class2$j.prototype, "showConnectionStatusBanner", [_dec29$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class2$j.prototype, "enableUnreadMessagesBadge", [_dec30$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class2$j.prototype, "showChatToggle", [_dec31$2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class2$j.prototype, "showHeader", [_dec32$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class2$j.prototype, "headerTitle", [_dec33$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class2$j.prototype, "headerIcon", [_dec34$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class2$j.prototype, "botAvatarIcon", [_dec35$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class2$j.prototype, "userAvatarIcon", [_dec36$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class2$j.prototype, "messages", [_dec37$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class2$j.prototype, "resource", [_dec38$1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class2$j.prototype, "setResource", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class2$j.prototype, "alreadyLoggedIn", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class2$j.prototype, "canShowLoginProxyView", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class2$j.prototype, "xmppMessages", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class2$j.prototype, "xmppInstance", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class2$j.prototype, "vCard", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class2$j.prototype, "setupXmppConnection", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class2$j.prototype, "updateVCard", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsXmppQueryArchivePagination", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class2$j.prototype, "isXmppQueryArchivePagination", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class2$j.prototype, "setShouldForceQueryArchivePagination", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class2$j.prototype, "shouldForceQueryArchivePagination", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsXmppQueryArchive", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class2$j.prototype, "isXmppQueryArchive", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsXmppQueryArchiveAfter", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class2$j.prototype, "isXmppQueryArchiveAfter", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class2$j.prototype, "setXmppMamPagination", [_dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class2$j.prototype, "xmppMamPagination", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class2$j.prototype, "addMessage", [_dec57], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class2$j.prototype, "addMessageToHistory", [_dec58], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class2$j.prototype, "setConversationsArray", [_dec59], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentConversationMessages", [_dec60], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentConversationMessagesPagination", [_dec61], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentConversationSupportMessagesPagination", [_dec62], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentConversationPreviousMessages", [_dec63], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentConversationNextMessages", [_dec64], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentConversationPaginationMode", [_dec65], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class2$j.prototype, "updateConversationClass", [_dec66], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class2$j.prototype, "updateConversation", [_dec67], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class2$j.prototype, "pushMessageInCurrentConversation", [_dec68], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class2$j.prototype, "pushMessageInCurrentConversationPagination", [_dec69], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class2$j.prototype, "pushMessageInCurrentConversationSupportPagination", [_dec70], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class2$j.prototype, "prependMessageInCurrentConversation", [_dec71], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class2$j.prototype, "showUserInputArea", [_dec72], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class2$j.prototype, "toggleUserInputArea", [_dec73], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class2$j.prototype, "toggleLoginProxyView", [_dec74], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class2$j.prototype, "getCurrentChatMessages", [_dec75], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class2$j.prototype, "getCurrentChatMessagesPagination", [_dec76], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class2$j.prototype, "getCurrentChatSupportMessagesPagination", [_dec77], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class2$j.prototype, "getCurrentConversationPaginationMode", [_dec78], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class2$j.prototype, "setLoggedInStatus", [_dec79], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class2$j.prototype, "attachmentsUploaderConfig", [_dec80], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class2$j.prototype, "setAttachmentsUploaderConfig", [_dec81], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class2$j.prototype, "pushConversation", [_dec82], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor82 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentChat", [_dec83], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class2$j.prototype, "setModeBeforeSubmit", [_dec84], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class2$j.prototype, "setVisibilityAfterSubmit", [_dec85], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor85 = _applyDecoratedDescriptor(_class2$j.prototype, "currentChat", [_dec86], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor86 = _applyDecoratedDescriptor(_class2$j.prototype, "getConversations", [_dec87], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor87 = _applyDecoratedDescriptor(_class2$j.prototype, "genesysNoticeMap", [_dec88], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor88 = _applyDecoratedDescriptor(_class2$j.prototype, "getChatHeaderTitle", [_dec89], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor89 = _applyDecoratedDescriptor(_class2$j.prototype, "setChatHeaderTitle", [_dec90], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor90 = _applyDecoratedDescriptor(_class2$j.prototype, "getChatHeaderIcon", [_dec91], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor91 = _applyDecoratedDescriptor(_class2$j.prototype, "setChatHeaderIcon", [_dec92], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor92 = _applyDecoratedDescriptor(_class2$j.prototype, "getChatAvatarIcon", [_dec93], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor93 = _applyDecoratedDescriptor(_class2$j.prototype, "setChatAvatarIcon", [_dec94], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor94 = _applyDecoratedDescriptor(_class2$j.prototype, "getConversationsCounter", [_dec95], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor95 = _applyDecoratedDescriptor(_class2$j.prototype, "setConversationsCounter", [_dec96], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor96 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsConversationHeaderRawHtml", [_dec97], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor97 = _applyDecoratedDescriptor(_class2$j.prototype, "setTimestampMap", [_dec98], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor98 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsInteractionInsertLocation", [_dec99], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor99 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsLocationModalEnable", [_dec100], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor100 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsInteractionInsertDate", [_dec101], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor101 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentDatePickerInfo", [_dec102], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor102 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsInteractionSingleAutocomplete", [_dec103], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor103 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsInteractionMultipleAutocomplete", [_dec104], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor104 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentAutocompleteInfo", [_dec105], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor105 = _applyDecoratedDescriptor(_class2$j.prototype, "setCurrentAutocompleteList", [_dec106], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor106 = _applyDecoratedDescriptor(_class2$j.prototype, "setShowRestartChatButton", [_dec107], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor107 = _applyDecoratedDescriptor(_class2$j.prototype, "getBotConfigSettings", [_dec108], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor108 = _applyDecoratedDescriptor(_class2$j.prototype, "setBotConfigSettings", [_dec109], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor109 = _applyDecoratedDescriptor(_class2$j.prototype, "setVoiceInterfaceBaseUrl", [_dec110], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor110 = _applyDecoratedDescriptor(_class2$j.prototype, "setSttLang", [_dec111], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor111 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsVoiceInterfaceEnabled", [_dec112], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor112 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsVoiceAudioEnabled", [_dec113], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor113 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsMicHasErrors", [_dec114], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor114 = _applyDecoratedDescriptor(_class2$j.prototype, "setIsSTTProcessing", [_dec115], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor115 = _applyDecoratedDescriptor(_class2$j.prototype, "isVoiceInterfaceEnabled", [_dec116], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor116 = _applyDecoratedDescriptor(_class2$j.prototype, "isSTTProcessing", [_dec117], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor117 = _applyDecoratedDescriptor(_class2$j.prototype, "chatToggleMeta", [_dec118], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor118 = _applyDecoratedDescriptor(_class2$j.prototype, "setToggleMetas", [_dec119], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor119 = _applyDecoratedDescriptor(_class2$j.prototype, "isProactivityEnabled", [_dec120], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor120 = _applyDecoratedDescriptor(_class2$j.prototype, "getChatbotProactive", [_dec121], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor121 = _applyDecoratedDescriptor(_class2$j.prototype, "getProactivitySettings", [_dec122], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor122 = _applyDecoratedDescriptor(_class2$j.prototype, "defaultProactivitySettings", [_dec123], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor123 = _applyDecoratedDescriptor(_class2$j.prototype, "setProactivitySettingsData", [_dec124], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor124 = _applyDecoratedDescriptor(_class2$j.prototype, "setProactivityExpiry", [_dec125], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2$j.prototype, "askVCardAction", [_dec126], Object.getOwnPropertyDescriptor(_class2$j.prototype, "askVCardAction"), _class2$j.prototype), _applyDecoratedDescriptor(_class2$j.prototype, "showChatMessages", [_dec127], Object.getOwnPropertyDescriptor(_class2$j.prototype, "showChatMessages"), _class2$j.prototype), _applyDecoratedDescriptor(_class2$j.prototype, "updateCurrentConversation", [_dec128], Object.getOwnPropertyDescriptor(_class2$j.prototype, "updateCurrentConversation"), _class2$j.prototype), _applyDecoratedDescriptor(_class2$j.prototype, "showWelcomeMessage", [_dec129], Object.getOwnPropertyDescriptor(_class2$j.prototype, "showWelcomeMessage"), _class2$j.prototype), _applyDecoratedDescriptor(_class2$j.prototype, "handleIsXmppQueryArchivePagination", [_dec130], Object.getOwnPropertyDescriptor(_class2$j.prototype, "handleIsXmppQueryArchivePagination"), _class2$j.prototype), _applyDecoratedDescriptor(_class2$j.prototype, "handleIsXmppQueryArchive", [_dec131], Object.getOwnPropertyDescriptor(_class2$j.prototype, "handleIsXmppQueryArchive"), _class2$j.prototype), _applyDecoratedDescriptor(_class2$j.prototype, "handleIsSTTProcessing", [_dec132], Object.getOwnPropertyDescriptor(_class2$j.prototype, "handleIsSTTProcessing"), _class2$j.prototype), _applyDecoratedDescriptor(_class2$j.prototype, "fillOutMessagesList", [_dec133], Object.getOwnPropertyDescriptor(_class2$j.prototype, "fillOutMessagesList"), _class2$j.prototype), _applyDecoratedDescriptor(_class2$j.prototype, "renderCurrentConversation", [_dec134], Object.getOwnPropertyDescriptor(_class2$j.prototype, "renderCurrentConversation"), _class2$j.prototype), _applyDecoratedDescriptor(_class2$j.prototype, "toggleLoggedInStatus", [_dec135], Object.getOwnPropertyDescriptor(_class2$j.prototype, "toggleLoggedInStatus"), _class2$j.prototype), _class2$j)) || _class$j);

/* script */
var __vue_script__$m = ConversationArea;

/* template */
var __vue_render__$m = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "id": "webchat-core-wfp-wrapper"
    }
  }, [_vm.canShowLogin ? _c('LoginProxy', {
    attrs: {
      "xmpp-endpoint": _vm.xmppEndpoint,
      "eimeVersion": _vm.eimeVersion
    }
  }) : _vm._e(), _vm._v(" "), _vm.showChatToggle ? _c('ChatToggle', {
    ref: "chatToggle",
    attrs: {
      "handle-show-chat-area": _vm.handleShowChatArea
    }
  }) : _vm._e(), _vm._v(" "), _vm.showChatToggle ? _c('ChatToggleClose', {
    ref: "chatToggleClose",
    attrs: {
      "handle-show-chat-area": _vm.handleShowChatArea
    }
  }) : _vm._e(), _vm._v(" "), _vm.canShowXmppMessageBanner ? [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "error-wrapper"
  }, [_c('el-alert', {
    "class": _vm.canShowConversationArea ? 'sticky' : '',
    attrs: {
      "type": "warning",
      "show-icon": "",
      "effect": "dark",
      "closable": false
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getXmppConnectionLoadingMessage)
    }
  })])], 1)])] : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.canShowConversationList,
      expression: "canShowConversationList"
    }]
  }, [_c('ConversationsList', {
    ref: "conversationList",
    attrs: {
      "main-title": _vm.conversationsTitle,
      "allow-search-filter": _vm.allowConversationsFilter,
      "back-button-label": _vm.conversationsBackButton,
      "enable-unread-messages-badge": _vm.enableUnreadMessagesBadge,
      "last-message-to-display-total": _vm.lastMessageToDisplayTotal
    }
  })], 1), _vm._v(" "), _c('ChatConversationArea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.canShowConversationArea,
      expression: "canShowConversationArea"
    }],
    ref: "chatConversationArea",
    attrs: {
      "show-header": _vm.showHeader,
      "show-chat-back-button": _vm.showChatBackButton,
      "show-is-typing-bubble": _vm.canShowIsTypingBubble,
      "show-is-typing-bubble-user": _vm.canShowIsTypingBubbleUser,
      "enable-multiple-conversations": _vm.enableMultipleConversations,
      "hide-action-menu": _vm.hideActionMenu,
      "user-avatar-icon": _vm.userAvatarIcon,
      "attachments-upload-error-callback": _vm.attachmentsUploadErrorCallback,
      "handle-start-chat": _vm.startupChatCmd,
      "btn-start-conversation-label": _vm.btnStartupConversationLabel,
      "handle-on-restart-chat": _vm.handleOnRestartChat
    }
  }), _vm._v(" "), _c('VoiceBridge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.canShowVoiceInterface,
      expression: "canShowVoiceInterface"
    }],
    attrs: {
      "can-show-voice-interface": _vm.canShowVoiceInterface,
      "incoming-message": _vm.incomingMessage,
      "is-view-not-conversation-list": !_vm.canShowConversationList,
      "base-url": _vm.voiceInterfaceEndpoint,
      "stt-language": _vm.sttLanguage,
      "handle-on-after-transcribing-speech": _vm.handleOnAfterTranscribingSpeech,
      "handle-on-after-play-voice": _vm.handleOnAfterPlayVoice,
      "handle-on-error-callback": _vm.handleOnErrorCallback
    }
  })], 2);
};
var __vue_staticRenderFns__$m = [];

/* style */
var __vue_inject_styles__$m = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-393878b3_0", {
    source: ".w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}.error-wrapper{position:fixed;top:0;left:0;right:0;z-index:9998}.error-wrapper .el-alert{color:#efefef;border-radius:0;padding:15px 10px;background-color:#0a6eb4!important;margin-top:0!important;text-align:left;line-height:1}.error-wrapper .el-alert *{color:#efefef}.error-wrapper .el-alert .is-big{font-size:16px!important;width:16px!important}.error-wrapper .el-alert .el-alert__content p{margin:0!important;font-size:small!important;line-height:normal!important}.error-wrapper .el-alert.sticky{top:114px;padding:10px!important}.slide-enter-active{transition:all .3s ease}.slide-leave-active{transition:all .1s cubic-bezier(1,.5,.8,1)}.slide-enter,.slide-leave-to{transform:translateY(25px);opacity:0}.startup-chat-btn-wrapper{position:absolute;bottom:1em;left:0;right:0}#conversation-explode-wrapper{width:130px;height:130px;position:fixed;top:50%;left:50%;margin-top:-65px;margin-left:-65px;opacity:1;border-radius:100%;transform:scale(0);box-shadow:0 3px 25px rgba(0,0,0,.5);background:rgba(0,0,0,.5);border:.2em solid #363636}#ring-explode-wrapper{width:130px;height:130px;position:fixed;bottom:-4px;left:-4px;opacity:1;border-radius:100%;transform:scale(.1);border:.2em solid #363636}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$m = undefined;
/* module identifier */
var __vue_module_identifier__$m = undefined;
/* functional template */
var __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

var _dec$k, _class$k;
var Core = (_dec$k = Component({
  store: store$2
}), _dec$k(_class$k = /*#__PURE__*/function (_mixins) {
  function Core() {
    _classCallCheck(this, Core);
    return _callSuper(this, Core, arguments);
  }
  _inherits(Core, _mixins);
  return _createClass(Core);
}(mixins(__vue_component__$m))) || _class$k);

/* script */
var __vue_script__$n = Core;

/* template */

/* style */
var __vue_inject_styles__$n = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-5131405e_0", {
    source: ".w-50{width:50%!important}.w-100{width:100%}.h-100{height:100%}.el-row{margin-bottom:1em}.el-row:last-child{margin-bottom:0}.el-button:disabled{opacity:.6}.el-message-box{width:90%;max-width:420px;font-family:Avenir,sans-serif}.el-message{font-family:Avenir,sans-serif}.el-notification p{text-align:left}.m-1{margin:.5em!important}.m-top-2{margin-top:1em!important}.m-right-3{margin-right:1.5em!important}.m-bottom-4{margin-bottom:2em!important}.m-left-5{margin-left:2.5em!important}html #app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;overflow-x:hidden}html #app.widget{overflow-y:scroll}html #app .btn-link{color:#2c3e50}html #app .btn-link:hover{text-decoration:none;color:#4386ff}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
var __vue_scope_id__$n = undefined;
/* module identifier */
var __vue_module_identifier__$n = undefined;
/* functional template */
var __vue_is_functional_template__$n = undefined;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$n = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

// import css
// install function executed by Vue.use()
var install$3 = function installMonkChatCore(Vue) {
  if (install$3.installed) {
    return;
  }
  install$3.installed = true;
  Vue.component("MonkChatCore", __vue_component__$n);
};
// Create module definition for Vue.use()
var plugin = {
  install: install$3
};
// To auto-install when vue is found
// eslint-disable-next-line no-redeclare
/* global window, global */
var GlobalVue = null;
if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
  // @ts-ignore
} else if (typeof global !== "undefined") {
  // @ts-ignore
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}
// Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()
__vue_component__$n.install = install$3;

export default __vue_component__$n;
